var Cd = Object.defineProperty;
var Sd = (e, t, n) => t in e ? Cd(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var gl = (e, t, n) => Sd(e, typeof t != "symbol" ? t + "" : t, n);
import * as Ed from "react/jsx-runtime";
import { jsxs as B, jsx as _, Fragment as Ke } from "react/jsx-runtime";
import xr, { useRef as re, useState as Ee, useCallback as pe, useId as at, useLayoutEffect as no, useEffect as ve, forwardRef as Ad, useMemo as $e, createContext as Cr, useContext as Oi, Fragment as io, useReducer as Id } from "react";
import { createPortal as di } from "react-dom";
var Ld = /* @__PURE__ */ ((e) => (e.Text = "text", e.Email = "email", e.Number = "number", e.Choice = "choice", e.MultiChoice = "multiChoice", e.Date = "date", e.Time = "time", e.Entity = "entity", e))(Ld || {}), it = /* @__PURE__ */ ((e) => (e.TextInput = "textInput", e.EmailInput = "emailInput", e.NumberInput = "numberInput", e.PasswordInput = "passwordInput", e.Select = "select", e.ComboBox = "comboBox", e.MultiSelect = "multiSelect", e.DatePicker = "datePicker", e.TimePicker = "timePicker", e.EntityPicker = "entityPicker", e.Separator = "separator", e.CheckboxGroup = "checkboxGroup", e.Custom = "custom", e.RadioGroup = "radioGroup", e.TextArea = "textArea", e))(it || {}), kt = /* @__PURE__ */ ((e) => (e.Large = "large", e.Medium = "medium", e.Small = "small", e))(kt || {}), Ne = /* @__PURE__ */ ((e) => (e.Default = "default", e.Error = "error", e.Warning = "warning", e.Success = "success", e))(Ne || {}), Pd = /* @__PURE__ */ ((e) => (e.info = "info", e.warning = "warning", e.success = "success", e.error = "error", e))(Pd || {}), Td = /* @__PURE__ */ ((e) => (e.text = "text", e.number = "number", e.date = "date", e.time = "time", e.datetime = "datetime", e))(Td || {}), Nd = /* @__PURE__ */ ((e) => (e.text = "text", e.currency = "currency", e.datetime = "datetime", e.select = "select", e.multiselect = "multiselect", e))(Nd || {}), ct = /* @__PURE__ */ ((e) => (e.Text = "text", e.Email = "email", e.Number = "number", e.Password = "password", e.Search = "search", e.Tel = "tel", e.Url = "url", e))(ct || {});
function Sr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Vs = { exports: {} };
var _l;
function Dd() {
  return _l || (_l = 1, (function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var a = "", o = 0; o < arguments.length; o++) {
          var l = arguments[o];
          l && (a = r(a, i(l)));
        }
        return a;
      }
      function i(a) {
        if (typeof a == "string" || typeof a == "number")
          return a;
        if (typeof a != "object")
          return "";
        if (Array.isArray(a))
          return n.apply(null, a);
        if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
          return a.toString();
        var o = "";
        for (var l in a)
          t.call(a, l) && a[l] && (o = r(o, l));
        return o;
      }
      function r(a, o) {
        return o ? a ? a + " " + o : a + o : a;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  })(Vs)), Vs.exports;
}
var Vd = Dd();
const Q = /* @__PURE__ */ Sr(Vd);
var Re = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Secondary = "secondary", e.Info = "info", e.Success = "success", e.Warning = "warning", e.Error = "error", e))(Re || {}), Mt = /* @__PURE__ */ ((e) => (e.Large = "large", e.Medium = "medium", e.Small = "small", e))(Mt || {}), we = /* @__PURE__ */ ((e) => (e.Auto = "auto", e.Full = "full", e.Small = "sm", e.Medium = "md", e.Large = "lg", e))(we || {}), Mn = /* @__PURE__ */ ((e) => (e.Blank = "_blank", e.Self = "_self", e))(Mn || {});
function Bi(...e) {
  return (t) => {
    for (const n of e)
      typeof n == "function" ? n(t) : n != null && (n.current = t);
  };
}
function Fn(e, t, n) {
  const i = e !== void 0, r = re(i);
  r.current = i;
  const [a, o] = Ee(
    i ? e : t
  ), l = i ? e : a, u = pe(
    (c) => {
      const h = typeof c == "function" ? c(l) : c;
      r.current || o(h), n?.(h);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [l, n]
  );
  return [l, u];
}
const xl = {
  "ds-input": "_ds-input_fzm43_1",
  "ds-input--width-full": "_ds-input--width-full_fzm43_1",
  "ds-input--width-sm": "_ds-input--width-sm_fzm43_4",
  "ds-input--width-md": "_ds-input--width-md_fzm43_7",
  "ds-input--width-lg": "_ds-input--width-lg_fzm43_10"
}, Md = "ds-tooltip-layer", Fd = 8, Rd = 8, Od = 6, Bd = 200, zd = 100, jd = {
  top: ["bottom", "right", "left"],
  bottom: ["top", "right", "left"],
  left: ["right", "top", "bottom"],
  right: ["left", "top", "bottom"]
};
function fi(e) {
  const t = document.getElementById(e);
  if (t)
    return t;
  const n = document.createElement("div");
  return n.id = e, n.setAttribute("data-ds-layer", ""), document.body.appendChild(n), n;
}
function Fi(e, t, n, i, r) {
  const a = document.documentElement.clientWidth, o = document.documentElement.clientHeight;
  return e >= r && t >= r && e + n <= a - r && t + i <= o - r;
}
function ro(e, t, n, i, r) {
  const a = document.documentElement.clientWidth, o = document.documentElement.clientHeight;
  return {
    x: Math.min(Math.max(e, r), a - n - r),
    y: Math.min(Math.max(t, r), o - i - r)
  };
}
function yl(e, t, n, i, r, a) {
  const o = i + (a ? r : 0), l = e.left + e.width / 2, u = e.top + e.height / 2;
  switch (n) {
    case "top":
      return {
        x: l - t.width / 2,
        y: e.top - t.height - o
      };
    case "bottom":
      return {
        x: l - t.width / 2,
        y: e.bottom + o
      };
    case "left":
      return {
        x: e.left - t.width - o,
        y: u - t.height / 2
      };
    case "right":
      return {
        x: e.right + o,
        y: u - t.height / 2
      };
  }
}
function Hd(e, t, n, i, r, a, o) {
  const l = e.left + e.width / 2, u = e.top + e.height / 2, c = o;
  switch (a) {
    case "top":
    case "bottom": {
      const h = l - t, p = i - o;
      return { offset: Math.min(Math.max(h, c), p), edge: a === "top" ? "bottom" : "top" };
    }
    case "left":
    case "right": {
      const h = u - n, p = r - o;
      return { offset: Math.min(Math.max(h, c), p), edge: a === "left" ? "right" : "left" };
    }
  }
}
function $d(e, t, n, i, r, a, o) {
  const { viewportPaddingPx: l, flip: u } = r;
  let c = n, h = yl(e, t, n, i, o, a);
  if (u && !Fi(h.x, h.y, t.width, t.height, l)) {
    const g = jd[n];
    for (const b of g) {
      const v = yl(e, t, b, i, o, a);
      if (Fi(v.x, v.y, t.width, t.height, l)) {
        c = b, h = v;
        break;
      }
    }
  }
  const p = ro(h.x, h.y, t.width, t.height, l), m = a ? Hd(
    e,
    p.x,
    p.y,
    t.width,
    t.height,
    c,
    o
  ) : null;
  return {
    tooltip: { x: p.x, y: p.y, resolvedPlacement: c },
    arrow: m
  };
}
const vi = {
  "ds-tooltip": "_ds-tooltip_y2xmt_1",
  "ds-tooltip--top": "_ds-tooltip--top_y2xmt_31",
  "ds-tooltip--closed": "_ds-tooltip--closed_y2xmt_34",
  "ds-tooltip--bottom": "_ds-tooltip--bottom_y2xmt_37",
  "ds-tooltip--left": "_ds-tooltip--left_y2xmt_43",
  "ds-tooltip--right": "_ds-tooltip--right_y2xmt_49",
  "ds-tooltip--open": "_ds-tooltip--open_y2xmt_55",
  "ds-tooltip__content": "_ds-tooltip__content_y2xmt_61",
  "ds-tooltip__arrow": "_ds-tooltip__arrow_y2xmt_78"
}, cn = ({
  id: e,
  content: t,
  anchorRef: n,
  placement: i = "top",
  offsetPx: r = Fd,
  collision: a,
  disabled: o = !1,
  layerId: l = Md,
  showArrow: u = !0,
  arrowSizePx: c = Od
}) => {
  const h = at(), p = e || h, [m, g] = Ee(!1), b = re(null), v = re(null), w = re(null), y = re(null), I = re(null), E = re({ x: 0, y: 0, resolvedPlacement: i }), P = re(null), S = {
    viewportPaddingPx: a?.viewportPaddingPx ?? Rd,
    flip: a?.flip ?? !0
  }, f = pe(() => {
    w.current !== null && (clearTimeout(w.current), w.current = null), y.current !== null && (clearTimeout(y.current), y.current = null);
  }, []), C = pe(() => {
    I.current !== null && (cancelAnimationFrame(I.current), I.current = null);
  }, []), L = pe(() => {
    const O = n.current, X = b.current;
    if (!O || !X)
      return;
    const K = O.getBoundingClientRect(), se = X.getBoundingClientRect(), { tooltip: Y, arrow: N } = $d(
      K,
      se,
      i,
      r,
      S,
      u,
      c
    );
    if (E.current = Y, P.current = N, X.style.transform = `translate(${Y.x}px, ${Y.y}px)`, X.dataset.placement = Y.resolvedPlacement, N && v.current) {
      const ue = v.current;
      ue.dataset.edge = N.edge, N.edge === "top" || N.edge === "bottom" ? (ue.style.left = `${N.offset}px`, ue.style.top = "") : (ue.style.top = `${N.offset}px`, ue.style.left = "");
    }
  }, [n, i, r, S.viewportPaddingPx, S.flip, u, c]), F = pe(() => {
    C(), I.current = requestAnimationFrame(() => {
      L();
    });
  }, [C, L]), M = pe(() => {
    f(), w.current = setTimeout(() => {
      g(!0);
    }, Bd);
  }, [f]), z = pe(() => {
    f(), y.current = setTimeout(() => {
      g(!1);
    }, zd);
  }, [f]), R = pe(() => {
    f(), g(!1);
  }, [f]);
  no(() => {
    m && L();
  }, [m, L]), ve(() => {
    const O = n?.current;
    if (!(!O || o))
      return O.setAttribute("aria-describedby", p), () => {
        O.removeAttribute("aria-describedby");
      };
  }, [n, p, o]), ve(() => {
    const O = n?.current;
    if (!O || o)
      return;
    const X = () => {
      M();
    }, K = () => {
      z();
    }, se = () => {
      M();
    }, Y = () => {
      z();
    }, N = (ue) => {
      ue.key === "Escape" && R();
    };
    return O.addEventListener("pointerenter", X), O.addEventListener("pointerleave", K), O.addEventListener("focusin", se), O.addEventListener("focusout", Y), O.addEventListener("keydown", N), () => {
      O.removeEventListener("pointerenter", X), O.removeEventListener("pointerleave", K), O.removeEventListener("focusin", se), O.removeEventListener("focusout", Y), O.removeEventListener("keydown", N);
    };
  }, [n, o, M, z, R]), ve(() => {
    if (!m || o) {
      C();
      return;
    }
    const O = () => {
      F();
    }, X = () => {
      F();
    };
    return window.addEventListener("scroll", O, { capture: !0, passive: !0 }), window.addEventListener("resize", X, { passive: !0 }), () => {
      window.removeEventListener("scroll", O, { capture: !0 }), window.removeEventListener("resize", X), C();
    };
  }, [m, o, F, C]), ve(() => {
    const O = n?.current;
    if (!O || !m || o)
      return;
    const X = new ResizeObserver(() => {
      F();
    });
    return X.observe(O), b?.current && X.observe(b.current), () => {
      X.disconnect();
    };
  }, [n, m, o, F]), ve(() => () => {
    f(), C();
  }, [f, C]);
  const j = fi(l), H = m && !o ? "open" : "closed";
  return di(
    /* @__PURE__ */ B(
      "div",
      {
        ref: b,
        id: p,
        role: "tooltip",
        "aria-hidden": H === "closed",
        "data-state": H,
        "data-placement": E?.current.resolvedPlacement,
        className: Q({
          [vi["ds-tooltip"]]: !0,
          [vi[`ds-tooltip--${E?.current.resolvedPlacement}`]]: !0,
          [vi["ds-tooltip--open"]]: m && !o,
          [vi["ds-tooltip--closed"]]: !m || o
        }),
        children: [
          /* @__PURE__ */ _("span", { className: vi["ds-tooltip__content"], children: t }),
          u && /* @__PURE__ */ _(
            "div",
            {
              ref: v,
              className: vi["ds-tooltip__arrow"],
              "data-edge": P?.current?.edge ?? E?.current.resolvedPlacement,
              "aria-hidden": "true"
            }
          )
        ]
      }
    ),
    j
  );
};
var he = /* @__PURE__ */ ((e) => (e.Circle = "circle", e.Ellipse = "ellipse", e.Image = "image", e.Line = "line", e.Path = "path", e.Polygon = "polygon", e.Polyline = "polyline", e.Rect = "rect", e.Text = "text", e.Tspan = "tspan", e.Use = "use", e))(he || {}), J = /* @__PURE__ */ ((e) => (e.Apartment = "apartment", e.Done = "done", e.Launch = "launch", e.Close = "close", e.MoreVert = "more_vert", e.Sort = "content_sort", e.Help = "help", e.Support = "support", e.Chat = "chat", e.Feedback = "feedback", e.Menu = "menu", e.Dashboard = "dashboard", e.FolderOpen = "folder-open", e.Add = "add", e.ChevronLeft = "chevron-left", e.ChevronRight = "chevron-right", e.ManageAccounts = "manage-accounts", e.TextSnippet = "text-snippet", e.NetworkNode = "network-node", e.Group = "group", e.FolderShared = "folder-shared", e.StatusActive = "status-active", e.StatusOpen = "status-open", e.StatusClosed = "status-closed", e.StatusDenied = "status-denied", e.StatusPending = "status-pending", e.SwapHoriz = "swap-horiz", e.CheckCircle = "check-circle", e.CheckCircleOutline = "check-circle-outline", e.Delete = "_delete", e.RemoveCircleOutline = "remove-circle-outline", e.HighlightOff = "hightlight-off", e.Dangerous = "dangerous", e.Send = "send", e.HomeFilled = "home-filled", e.Developer = "developer", e.FilterList = "filter-list", e.KeyboardArrowLeft = "keyboard-arrow-left", e.KeyboardArrowRight = "keyboard-arrow-right", e.CalendarToday = "calendar-today", e.KeyboardArrowDown = "keyboard-arrow-down", e.KeyboardArrowUp = "keyboard-arrow-up", e.Edit = "edit", e.Search = "search", e.Cancel = "cancel", e.Replay = "replay", e.Lock = "lock", e.Link = "link", e.Power = "power", e.ErrorOutline = "error_outline", e.Archive = "archive", e.Notifications = "notifications", e.FileUpload = "file_upload", e.FileDownload = "file_download", e.CloudUpload = "cloud_upload", e.AttachFile = "attach_file", e.AccountCircle = "account-circle", e.FindInPage = "find-in-page", e.PrivacyTip = "privacy-tip", e.Logout = "logout", e.ARIES = "aries", e.AlertCircle = "alert-circle", e.Warning = "warning", e.WarningOutline = "warning-outline", e.Info = "info", e.InfoOutline = "info-outline", e.Visibility = "visibility", e.VisibilityOff = "visibility-off", e.ThumbUp = "thumb-up", e.ThumbDown = "thumb-down", e.NumericalSpinner = "numerical-spinner", e))(J || {});
const qd = {
  [J.Apartment]: {
    id: "apartment",
    category: "places",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M17 11V3H7V7H3V21H11V17H13V21H21V11H17ZM7 19H5V17H7V19ZM7 15H5V13H7V15ZM7 11H5V9H7V11ZM11 15H9V13H11V15ZM11 11H9V9H11V11ZM11 7H9V5H11V7ZM15 15H13V13H15V15ZM15 11H13V9H15V11ZM15 7H13V5H15V7ZM19 19H17V17H19V19ZM19 15H17V13H19V15Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Add]: {
    id: "add",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Done]: {
    id: "done",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M9 16.2L4.8 12L3.4 13.4L9 19L21 7.00001L19.6 5.60001L9 16.2Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Launch]: {
    id: "launch",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Close]: {
    id: "close",
    category: "navigation",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.MoreVert]: {
    id: "more_vert",
    category: "navigation",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Sort]: {
    id: "content-sort",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M7 13.1L12 18.1L17 13.1H7Z",
          fill: "#323232"
        }
      },
      {
        type: he.Path,
        props: {
          d: "M7 10.9L12 5.90002L17 10.9H7Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Help]: {
    id: "help",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.78 10.05 14 9.55 14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9H8C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9C16 9.88 15.64 10.68 15.07 11.25Z",
          fill: "CurrentColor"
        }
      }
    ]
  },
  [J.Support]: {
    id: "support",
    category: "communication",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22 22 17.52 22 12 17.52 2 12 2ZM18.92 8H15.89C15.63 7.66 15.34 7.37 15 7.11V4.08C16.72 4.73 18.27 6.28 18.92 8ZM12 16C9.79 16 8 14.21 8 12S9.79 8 12 8 16 9.79 16 12 14.21 16 12 16ZM9 4.08V7.11C8.66 7.37 8.37 7.66 8.11 8H5.08C5.73 6.28 7.28 4.73 9 4.08ZM5.08 16H8.11C8.37 16.34 8.66 16.63 9 16.89V19.92C7.28 19.27 5.73 17.72 5.08 16ZM15 19.92V16.89C15.34 16.63 15.63 16.34 15.89 16H18.92C18.27 17.72 16.72 19.27 15 19.92Z",
          fill: "currentColor"
        }
      }
    ]
  },
  [J.Chat]: {
    id: "chat",
    category: "communication",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M4 4H20V16H7L4 19V4Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinejoin: "round",
          strokeWidth: 2
        }
      },
      {
        type: he.Path,
        props: {
          d: "M7 8H17M7 12H14",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: 2
        }
      }
    ]
  },
  [J.Feedback]: {
    id: "feedback",
    category: "communication",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M4 4H20V16H7L4 19V4Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinejoin: "round",
          strokeWidth: 2
        }
      },
      {
        type: he.Path,
        props: {
          d: "M12 7V11",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: 2
        }
      },
      {
        type: he.Circle,
        props: {
          cx: 12,
          cy: 14,
          fill: "currentColor",
          r: 1
        }
      }
    ]
  },
  [J.Menu]: {
    id: "menu",
    category: "navigation",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Dashboard]: {
    id: "dashboard",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.FolderOpen]: {
    id: "folder_open",
    category: "file",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H10L12 6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8H4V18L6.4 10H23.5L20.925 18.575C20.7917 19.0083 20.5458 19.3542 20.1875 19.6125C19.8292 19.8708 19.4333 20 19 20H4Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.ChevronLeft]: {
    id: "chevron_left",
    category: "navigation",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.ChevronRight]: {
    id: "chevron_right",
    category: "navigation",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M9.99984 6L8.58984 7.41L13.1698 12L8.58984 16.59L9.99984 18L15.9998 12L9.99984 6Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.ManageAccounts]: {
    id: "manage-accounts",
    category: "social",
    width: 24,
    height: 24,
    viewBox: "0 0 20 17",
    data: [
      {
        type: he.Path,
        props: {
          d: "M14 17L13.7 15.5C13.5 15.4167 13.3125 15.3292 13.1375 15.2375C12.9625 15.1458 12.7833 15.0333 12.6 14.9L11.15 15.35L10.15 13.65L11.3 12.65C11.2667 12.4167 11.25 12.2 11.25 12C11.25 11.8 11.2667 11.5833 11.3 11.35L10.15 10.35L11.15 8.65L12.6 9.1C12.7833 8.96667 12.9625 8.85417 13.1375 8.7625C13.3125 8.67083 13.5 8.58333 13.7 8.5L14 7H16L16.3 8.5C16.5 8.58333 16.6875 8.675 16.8625 8.775C17.0375 8.875 17.2167 9 17.4 9.15L18.85 8.65L19.85 10.4L18.7 11.4C18.7333 11.6 18.75 11.8083 18.75 12.025C18.75 12.2417 18.7333 12.45 18.7 12.65L19.85 13.65L18.85 15.35L17.4 14.9C17.2167 15.0333 17.0375 15.1458 16.8625 15.2375C16.6875 15.3292 16.5 15.4167 16.3 15.5L16 17H14ZM0 16V13.2C0 12.65 0.141667 12.1333 0.425 11.65C0.708333 11.1667 1.1 10.8 1.6 10.55C2.45 10.1167 3.40833 9.75 4.475 9.45C5.54167 9.15 6.71667 9 8 9H8.35C8.45 9 8.55 9.01667 8.65 9.05C8.16667 10.25 7.96667 11.4417 8.05 12.625C8.13333 13.8083 8.53333 14.9333 9.25 16H0ZM15 14C15.55 14 16.0208 13.8042 16.4125 13.4125C16.8042 13.0208 17 12.55 17 12C17 11.45 16.8042 10.9792 16.4125 10.5875C16.0208 10.1958 15.55 10 15 10C14.45 10 13.9792 10.1958 13.5875 10.5875C13.1958 10.9792 13 11.45 13 12C13 12.55 13.1958 13.0208 13.5875 13.4125C13.9792 13.8042 14.45 14 15 14ZM8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.TextSnippet]: {
    id: "text_snippet",
    category: "file",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M20.41 8.41L15.58 3.58C15.21 3.21 14.7 3 14.17 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V9.83C21 9.3 20.79 8.79 20.41 8.41ZM7 7H14V9H7V7ZM17 17H7V15H17V17ZM17 13H7V11H17V13Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.NetworkNode]: {
    id: "network-node",
    category: "hardware",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M5.5 22C4.53333 22 3.70833 21.6583 3.025 20.975C2.34167 20.2917 2 19.4667 2 18.5C2 17.5333 2.34167 16.7083 3.025 16.025C3.70833 15.3417 4.53333 15 5.5 15C5.8 15 6.09167 15.0375 6.375 15.1125C6.65833 15.1875 6.925 15.2917 7.175 15.425L11 11.6V8.85C10.2667 8.63333 9.66667 8.22083 9.2 7.6125C8.73333 7.00417 8.5 6.3 8.5 5.5C8.5 4.53333 8.84167 3.70833 9.525 3.025C10.2083 2.34167 11.0333 2 12 2C12.9667 2 13.7917 2.34167 14.475 3.025C15.1583 3.70833 15.5 4.53333 15.5 5.5C15.5 6.3 15.2667 7.00417 14.8 7.6125C14.3333 8.22083 13.7333 8.63333 13 8.85V11.6L16.85 15.425C17.1 15.2917 17.3625 15.1875 17.6375 15.1125C17.9125 15.0375 18.2 15 18.5 15C19.4667 15 20.2917 15.3417 20.975 16.025C21.6583 16.7083 22 17.5333 22 18.5C22 19.4667 21.6583 20.2917 20.975 20.975C20.2917 21.6583 19.4667 22 18.5 22C17.5333 22 16.7083 21.6583 16.025 20.975C15.3417 20.2917 15 19.4667 15 18.5C15 18.2 15.0375 17.9083 15.1125 17.625C15.1875 17.3417 15.2917 17.075 15.425 16.825L12 13.4L8.575 16.825C8.70833 17.075 8.8125 17.3417 8.8875 17.625C8.9625 17.9083 9 18.2 9 18.5C9 19.4667 8.65833 20.2917 7.975 20.975C7.29167 21.6583 6.46667 22 5.5 22ZM18.5 20C18.9167 20 19.2708 19.8542 19.5625 19.5625C19.8542 19.2708 20 18.9167 20 18.5C20 18.0833 19.8542 17.7292 19.5625 17.4375C19.2708 17.1458 18.9167 17 18.5 17C18.0833 17 17.7292 17.1458 17.4375 17.4375C17.1458 17.7292 17 18.0833 17 18.5C17 18.9167 17.1458 19.2708 17.4375 19.5625C17.7292 19.8542 18.0833 20 18.5 20ZM12 7C12.4167 7 12.7708 6.85417 13.0625 6.5625C13.3542 6.27083 13.5 5.91667 13.5 5.5C13.5 5.08333 13.3542 4.72917 13.0625 4.4375C12.7708 4.14583 12.4167 4 12 4C11.5833 4 11.2292 4.14583 10.9375 4.4375C10.6458 4.72917 10.5 5.08333 10.5 5.5C10.5 5.91667 10.6458 6.27083 10.9375 6.5625C11.2292 6.85417 11.5833 7 12 7ZM5.5 20C5.91667 20 6.27083 19.8542 6.5625 19.5625C6.85417 19.2708 7 18.9167 7 18.5C7 18.0833 6.85417 17.7292 6.5625 17.4375C6.27083 17.1458 5.91667 17 5.5 17C5.08333 17 4.72917 17.1458 4.4375 17.4375C4.14583 17.7292 4 18.0833 4 18.5C4 18.9167 4.14583 19.2708 4.4375 19.5625C4.72917 19.8542 5.08333 20 5.5 20Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Group]: {
    id: "group",
    category: "social",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.FolderShared]: {
    id: "folder_shared",
    category: "file",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM15 9C16.1 9 17 9.9 17 11C17 12.1 16.1 13 15 13C13.9 13 13 12.1 13 11C13 9.9 13.9 9 15 9ZM19 17H11V16C11 14.67 13.67 14 15 14C16.33 14 19 14.67 19 16V17Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.StatusActive]: {
    id: "status-active",
    category: "status",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Circle,
        props: {
          cx: "12",
          cy: "12",
          r: "12",
          fill: "#00774E"
        }
      }
    ]
  },
  [J.StatusOpen]: {
    id: "status-open",
    category: "status",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Circle,
        props: {
          cx: "12",
          cy: "12",
          r: "12",
          // --Background-orange (LOA-1700)
          fill: "#ED5B3E"
        }
      }
    ]
  },
  [J.StatusClosed]: {
    id: "status-closed",
    category: "status",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Circle,
        props: {
          cx: "12",
          cy: "12",
          r: "12",
          // --Background-blue (LOA-1700)
          fill: "#0067D2"
        }
      }
    ]
  },
  [J.StatusDenied]: {
    id: "status-denied",
    category: "status",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Circle,
        props: {
          cx: "12",
          cy: "12",
          r: "12",
          fill: "#CD2026"
        }
      }
    ]
  },
  [J.StatusPending]: {
    id: "status-pending",
    category: "status",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Circle,
        props: {
          cx: "12",
          cy: "12",
          r: "12",
          // --Background-primary_bold (LOA-1700)
          fill: "#ABBDCF"
        }
      }
    ]
  },
  [J.SwapHoriz]: {
    id: "swap_horiz",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M6.99 11L3 15L6.99 19V16H14V14H6.99V11ZM21 9L17.01 5V8H10V10H17.01V13L21 9Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.CheckCircle]: {
    id: "check_circle",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.CheckCircleOutline]: {
    id: "check_circle_outline",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M16.59 7.58L10 14.17L6.41 10.59L5 12L10 17L18 9L16.59 7.58ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Delete]: {
    id: "_delete",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.RemoveCircleOutline]: {
    id: "remove_circle_outline",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M7 11V13H17V11H7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.HighlightOff]: {
    id: "highlight_off",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8ZM12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Dangerous]: {
    id: "dangerous",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3ZM17 15.74L15.74 17L12 13.26L8.26 17L7 15.74L10.74 12L7 8.26L8.26 7L12 10.74L15.74 7L17 8.26L13.26 12L17 15.74Z",
          fill: "#323232"
        }
      }
    ]
  },
  // Form / input controls
  [J.Visibility]: {
    id: "visibility",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Cancel]: {
    id: "cancel",
    category: "navigation",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59L15.59 7L17 8.41L13.41 12L17 15.59Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Replay]: {
    id: "replay",
    category: "media",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M12 5V1L7 6L12 11V7C15.31 7 18 9.69 18 13C18 16.31 15.31 19 12 19C8.69 19 6 16.31 6 13H4C4 17.42 7.58 21 12 21C16.42 21 20 17.42 20 13C20 8.58 16.42 5 12 5Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.VisibilityOff]: {
    id: "visibility-off",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Send]: {
    id: "send",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Developer]: {
    id: "developer",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M7.77001 6.75998L6.23001 5.47998L0.820007 12L6.23001 18.52L7.77001 17.24L3.42001 12L7.77001 6.75998ZM7.00001 13H9.00001V11H7.00001V13ZM17 11H15V13H17V11ZM11 13H13V11H11V13ZM17.77 5.47998L16.23 6.75998L20.58 12L16.23 17.24L17.77 18.52L23.18 12L17.77 5.47998Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.FilterList]: {
    id: "filter_list",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Search]: {
    id: "search",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z",
          fill: "#323232"
        }
      }
    ]
  },
  // ARIES
  [J.ARIES]: {
    id: "aries",
    category: "aries",
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    data: [
      {
        type: he.Path,
        props: {
          d: "M13.4697 9.47508L14.0811 11.174C14.761 13.0596 16.2457 14.5442 18.1312 15.2241L19.8301 15.8355C19.9835 15.8907 19.9835 16.1079 19.8301 16.1631L18.1312 16.7745C16.2456 17.4544 14.761 18.9391 14.0811 20.8246L13.4697 22.5235C13.4145 22.6769 13.1973 22.6769 13.1421 22.5235L12.5307 20.8246C11.8508 18.939 10.3661 17.4544 8.48061 16.7745L6.78168 16.1631C6.62836 16.1079 6.62836 15.8907 6.78168 15.8355L8.48061 15.2241C10.3662 14.5442 11.8508 13.0595 12.5307 11.174L13.1421 9.47508C13.1973 9.32081 13.4145 9.32081 13.4697 9.47508Z",
          fill: "currentColor"
        }
      },
      {
        type: he.Path,
        props: {
          d: "M21.1177 5.39261L21.4281 6.25254C21.7729 7.20676 22.5242 7.95907 23.4794 8.30382L24.3393 8.61426C24.4174 8.64283 24.4174 8.75235 24.3393 8.77997L23.4794 9.09041C22.5252 9.43516 21.7729 10.1865 21.4281 11.1417L21.1177 12.0016C21.0891 12.0797 20.9796 12.0797 20.952 12.0016L20.6415 11.1417C20.2968 10.1875 19.5454 9.43516 18.5902 9.09041L17.7303 8.77997C17.6522 8.7514 17.6522 8.64188 17.7303 8.61426L18.5902 8.30382C19.5445 7.95907 20.2968 7.20771 20.6415 6.25254L20.952 5.39261C20.9796 5.31357 21.0901 5.31357 21.1177 5.39261Z",
          fill: "currentColor"
        }
      },
      {
        type: he.Path,
        props: {
          d: "M21.1177 19.9991L21.4281 20.859C21.7729 21.8132 22.5242 22.5656 23.4794 22.9103L24.3393 23.2207C24.4174 23.2493 24.4174 23.3588 24.3393 23.3864L23.4794 23.6969C22.5252 24.0416 21.7729 24.793 21.4281 25.7482L21.1177 26.6081C21.0891 26.6862 20.9796 26.6862 20.952 26.6081L20.6415 25.7482C20.2968 24.794 19.5454 24.0416 18.5902 23.6969L17.7303 23.3864C17.6522 23.3579 17.6522 23.2484 17.7303 23.2207L18.5902 22.9103C19.5445 22.5656 20.2968 21.8142 20.6415 20.859L20.952 19.9991C20.9796 19.921 21.0901 19.921 21.1177 19.9991Z",
          fill: "currentColor"
        }
      }
    ]
  },
  [J.HomeFilled]: {
    id: "home_filled",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M12 3L4 9V21H9V14H15V21H20V9L12 3Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.KeyboardArrowLeft]: {
    id: "keyboard_arrow_left",
    category: "hardware",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.KeyboardArrowRight]: {
    id: "keyboard_arrow_right",
    category: "hardware",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M8.59009 16.59L13.1701 12L8.59009 7.41L10.0001 6L16.0001 12L10.0001 18L8.59009 16.59Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.CalendarToday]: {
    id: "calendar_today",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M20 3H19V1H17V3H7V1H5V3H4C2.9 3 2 3.9 2 5V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V5C22 3.9 21.1 3 20 3ZM20 21H4V8H20V21Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.KeyboardArrowDown]: {
    id: "keyboard_arrow_down",
    category: "hardware",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M7.41 8.59003L12 13.17L16.59 8.59003L18 10L12 16L6 10L7.41 8.59003Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.KeyboardArrowUp]: {
    id: "keyboard_arrow_up",
    category: "hardware",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M7.41 15.41L12 10.83L16.59 15.41L18 14L12 8L6 14L7.41 15.41Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Edit]: {
    id: "edit",
    category: "image",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.ThumbUp]: {
    id: "thumb-up",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.ThumbDown]: {
    id: "thumb-down",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L10.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.NumericalSpinner]: {
    id: "numerical-spinner",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M7 11L12 6L17 11H7Z",
          fill: "#323232"
        }
      },
      {
        type: he.Path,
        props: {
          d: "M7 13L12 18L17 13H7Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.AlertCircle]: {
    id: "alert-circle",
    category: "alert",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Warning]: {
    id: "warning",
    category: "alert",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.WarningOutline]: {
    id: "warning-outline",
    category: "alert",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      // Hollow triangle: the inner subpath winds against the outer one, so the
      // default nonzero fill rule leaves the middle empty.
      {
        type: he.Path,
        props: {
          d: "M12 5.99 19.53 19H4.47L12 5.99M12 2 1 21h22L12 2z",
          fill: "#323232"
        }
      },
      // Solid "!" stem and dot.
      {
        type: he.Path,
        props: {
          d: "M11 10h2v4h-2zm0 6h2v2h-2z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Info]: {
    id: "info",
    category: "alert",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.InfoOutline]: {
    id: "info-outline",
    category: "alert",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      // Hollow ring (stroke only, no fill) — the "hollow circle".
      {
        type: he.Circle,
        props: {
          cx: 12,
          cy: 12,
          r: 9,
          fill: "none",
          stroke: "#323232",
          strokeWidth: 1.5
        }
      },
      // Solid "i" stem.
      {
        type: he.Path,
        props: {
          d: "M11 10.5h2v6.5h-2z",
          fill: "#323232"
        }
      },
      // Solid "i" dot.
      {
        type: he.Circle,
        props: {
          cx: 12,
          cy: 7.6,
          r: 1.15,
          fill: "#323232"
        }
      }
    ]
  },
  [J.AccountCircle]: {
    id: "account-circle",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960",
    data: [
      {
        type: he.Path,
        props: {
          d: "M234-276q51-39 114-61.5T480-360q69 0 132 22.5T726-276q35-41 54.5-93T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 54 19.5 111T234-276Zm246-164q-59 0-99.5-40.5T340-580q0-59 40.5-99.5T480-720q59 0 99.5 40.5T620-580q0 59-40.5 99.5T480-440Zm0 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q54 0 104-17.5t92-50.5q-42-33-92-50.5T480-286q-54 0-104 17.5T284-198q42 33 92 50.5T480-160Zm0-360q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.FindInPage]: {
    id: "find-in-page",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960",
    data: [
      {
        type: he.Path,
        props: {
          d: "m590-160 80 80H240q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h360l200 240v480q0 20-8.5 36.5T768-96L560-302q-17 11-37 16.5t-43 5.5q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 23-5.5 43T618-360l102 104v-356L562-800H240v640h350ZM480-360q33 0 56.5-23.5T560-440q0-33-23.5-56.5T480-520q-33 0-56.5 23.5T400-440q0 33 23.5 56.5T480-360Zm0-80Zm0 0Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.PrivacyTip]: {
    id: "privacy-tip",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960",
    data: [
      {
        type: he.Path,
        props: {
          d: "M480-80q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 152-90.5 276.5T480-80Zm0-84q104-33 172-132t68-220v-189l-240-90-240 90v189q0 121 68 220t172 132Zm0-396q17 0 28.5-11.5T520-600q0-17-11.5-28.5T480-640q-17 0-28.5 11.5T440-600q0 17 11.5 28.5T480-560Zm-40 40v240h80v-240h-80Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Logout]: {
    id: "logout",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960",
    data: [
      {
        type: he.Path,
        props: {
          d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Lock]: {
    id: "lock",
    category: "action",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M12 17C13.1 17 14 16.1 14 15C14 13.9 13.1 13 12 13C10.9 13 10 13.9 10 15C10 16.1 10.9 17 12 17ZM18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM8.9 6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8H8.9V6ZM18 20H6V10H18V20Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Link]: {
    id: "link",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M3.9 12C3.9 10.29 5.29 8.9 7 8.9H11V7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15.1H7C5.29 15.1 3.9 13.71 3.9 12ZM8 13H16V11H8V13ZM17 7H13V8.9H17C18.71 8.9 20.1 10.29 20.1 12C20.1 13.71 18.71 15.1 17 15.1H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.ErrorOutline]: {
    id: "error_outline",
    category: "alert",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M11 15H13V17H11V15ZM11 7H13V13H11V7ZM11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Power]: {
    id: "power",
    category: "notification",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M16.01 7L16 3H14V7H10V3H8V7H7.99C7 6.99 6 7.99 6 8.99V14.48L9.5 18V21H14.5V18L18 14.49V8.99C18 7.99 17 6.99 16.01 7Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.FileUpload]: {
    id: "file_upload",
    category: "file",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M9 16H15V10H19L12 3L5 10H9V16ZM5 18H19V20H5V18Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.FileDownload]: {
    id: "file_download",
    category: "file",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M19 9H15V3H9V9H5L12 16L19 9ZM5 18V20H19V18H5Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.CloudUpload]: {
    id: "cloud_upload",
    category: "file",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM14 13V17H10V13H7L12 8L17 13H14Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.AttachFile]: {
    id: "attach_file",
    category: "file",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M16.5 6V17.5C16.5 19.71 14.71 21.5 12.5 21.5C10.29 21.5 8.5 19.71 8.5 17.5V5C8.5 3.62 9.62 2.5 11 2.5C12.38 2.5 13.5 3.62 13.5 5V15.5C13.5 16.05 13.05 16.5 12.5 16.5C11.95 16.5 11.5 16.05 11.5 15.5V6H10V15.5C10 16.88 11.12 18 12.5 18C13.88 18 15 16.88 15 15.5V5C15 2.79 13.21 1 11 1C8.79 1 7 2.79 7 5V17.5C7 20.54 9.46 23 12.5 23C15.54 23 18 20.54 18 17.5V6H16.5Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Archive]: {
    id: "archive",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: he.Path,
        props: {
          d: "M20.54 5.23L19.15 3.55C18.88 3.21 18.47 3 18 3H6C5.53 3 5.12 3.21 4.84 3.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V6.5C21 6.02 20.83 5.57 20.54 5.23ZM12 17.5L6.5 12H10V10H14V12H17.5L12 17.5ZM5.12 5L5.93 4H17.93L18.87 5H5.12Z",
          fill: "#323232"
        }
      }
    ]
  },
  [J.Notifications]: {
    id: "notifications",
    category: "social",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960",
    data: [
      {
        type: he.Path,
        props: {
          d: "M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160Zm320-300Zm0 420q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM320-280h320v-280q0-66-47-113t-113-47q-66 0-113 47t-47 113v280Z",
          fill: "#323232"
        }
      }
    ]
  }
};
function ke({ ref: e, name: t, size: n, color: i, className: r, tooltip: a, tooltipPlacement: o, onClick: l }) {
  const { width: u, height: c, viewBox: h, data: p } = qd[t], m = re(null), g = at();
  return (
    // `className` is applied to BOTH the wrapper and the <svg>. The wrapper is
    // the component root and carries the merged ref for Tooltip /
    // ContextualMenu anchoring, so layout utilities (margin, alignment) must
    // land there; but a consumer writing `<Icon className="text-red-500" />`
    // is styling the glyph, and colour utilities do not reliably inherit into
    // an SVG. Duplicating the class is redundant DOM in exchange for both
    // working. See LOA-1156 bug 17.
    /* @__PURE__ */ B("div", { ref: Bi(m, e), className: r, children: [
      /* @__PURE__ */ _(
        "svg",
        {
          className: r,
          width: n ?? u,
          height: n ?? c,
          viewBox: h,
          fill: "none",
          onClick: () => {
            l && l();
          },
          children: p.map((b) => {
            const v = { ...b.props };
            switch (i && (v.fill = i, v.stroke && (v.stroke = i)), b.type) {
              case "circle":
                return /* @__PURE__ */ _("circle", { ...v }, crypto.randomUUID());
              default:
                return /* @__PURE__ */ _("path", { ...v }, crypto.randomUUID());
            }
          })
        }
      ),
      a && /* @__PURE__ */ _(cn, { id: `tooltip-${t}-${g}`, content: a, anchorRef: m, placement: o })
    ] })
  );
}
const xn = {
  "ds-input-chrome": "_ds-input-chrome_sjquo_1",
  "ds-input-chrome__body": "_ds-input-chrome__body_sjquo_22",
  "ds-input-chrome__adornment": "_ds-input-chrome__adornment_sjquo_28",
  "ds-input-chrome__adornment--prefix": "_ds-input-chrome__adornment--prefix_sjquo_41",
  "ds-input-chrome__adornment--suffix": "_ds-input-chrome__adornment--suffix_sjquo_44",
  "ds-input-chrome__adornment--interactive": "_ds-input-chrome__adornment--interactive_sjquo_47",
  "ds-input-chrome--size-large": "_ds-input-chrome--size-large_sjquo_59",
  "ds-input-chrome--size-medium": "_ds-input-chrome--size-medium_sjquo_67",
  "ds-input-chrome--size-small": "_ds-input-chrome--size-small_sjquo_75",
  "ds-input-chrome--focused": "_ds-input-chrome--focused_sjquo_83",
  "ds-input-chrome--state-error": "_ds-input-chrome--state-error_sjquo_88",
  "ds-input-chrome--state-warning": "_ds-input-chrome--state-warning_sjquo_95",
  "ds-input-chrome--state-success": "_ds-input-chrome--state-success_sjquo_102",
  "ds-input-chrome--disabled": "_ds-input-chrome--disabled_sjquo_109",
  "ds-input-chrome--readonly": "_ds-input-chrome--readonly_sjquo_115"
};
function bl({ icon: e, position: t, onClick: n, ariaLabel: i }) {
  const r = n ? (o) => {
    o.stopPropagation(), n();
  } : void 0, a = n ? (o) => {
    (o.key === "Enter" || o.key === " ") && (o.preventDefault(), n());
  } : void 0;
  return /* @__PURE__ */ _(
    "span",
    {
      className: Q(
        xn["ds-input-chrome__adornment"],
        xn[`ds-input-chrome__adornment--${t}`],
        n && xn["ds-input-chrome__adornment--interactive"]
      ),
      "data-input-adornment": t,
      "aria-hidden": n ? void 0 : !0,
      "aria-label": n ? i : void 0,
      role: n ? "button" : void 0,
      tabIndex: n ? 0 : void 0,
      onClick: r,
      onKeyDown: a,
      children: /* @__PURE__ */ _(ke, { name: e, "aria-hidden": "true" })
    }
  );
}
const Bn = ({
  isFocused: e = !1,
  disabled: t = !1,
  readOnly: n = !1,
  state: i = Ne.Default,
  size: r = kt.Medium,
  prefix: a,
  onPrefixClick: o,
  prefixAriaLabel: l,
  suffix: u,
  onSuffixClick: c,
  suffixAriaLabel: h,
  inputRef: p,
  onClick: m,
  children: g,
  className: b
}) => {
  const v = (w) => {
    w.target.closest("[data-input-adornment]") === null && (p?.current?.focus(), m?.(w));
  };
  return /* @__PURE__ */ B(
    "div",
    {
      className: Q(
        xn["ds-input-chrome"],
        xn[`ds-input-chrome--size-${r}`],
        i !== Ne.Default && xn[`ds-input-chrome--state-${i}`],
        e && xn["ds-input-chrome--focused"],
        t && xn["ds-input-chrome--disabled"],
        n && xn["ds-input-chrome--readonly"],
        b
      ),
      onClick: v,
      children: [
        a && /* @__PURE__ */ _(bl, { icon: a, position: "prefix", onClick: o, ariaLabel: l }),
        /* @__PURE__ */ _("div", { className: xn["ds-input-chrome__body"], children: g }),
        u && /* @__PURE__ */ _(bl, { icon: u, position: "suffix", onClick: c, ariaLabel: h })
      ]
    }
  );
}, Ud = {
  "ds-text-entry": "_ds-text-entry_542kk_1"
}, zn = ({
  id: e,
  name: t,
  ref: n,
  value: i,
  placeholder: r,
  type: a = ct.Text,
  disabled: o = !1,
  readOnly: l = !1,
  maxLength: u,
  minLength: c,
  min: h,
  max: p,
  required: m = !1,
  ariaLabel: g,
  ariaLabelledBy: b,
  ariaDescribedBy: v,
  ariaExpanded: w,
  ariaControls: y,
  ariaActivedescendant: I,
  role: E,
  ariaInvalid: P = !1,
  onChange: S,
  onFocus: f,
  onBlur: C,
  onKeyDown: L,
  autoComplete: F = "off",
  className: M
}) => {
  const z = re(null), R = (j) => {
    a === ct.Number && j.key.length === 1 && !/^[0-9]$/.test(j.key) && !j.ctrlKey && !j.metaKey && j.preventDefault(), L?.(j);
  };
  return /* @__PURE__ */ _(
    "input",
    {
      ref: Bi(z, n),
      id: e,
      name: t,
      type: a,
      value: i,
      placeholder: r,
      disabled: o,
      readOnly: l,
      maxLength: u,
      minLength: c,
      min: h,
      max: p,
      required: m,
      autoComplete: F,
      role: E,
      "aria-label": g,
      "aria-labelledby": b,
      "aria-describedby": v,
      "aria-expanded": w,
      "aria-controls": y,
      "aria-activedescendant": I,
      "aria-invalid": P || void 0,
      "aria-required": m || void 0,
      className: `${Ud["ds-text-entry"]}${M ? ` ${M}` : ""}`,
      onChange: (j) => S(j.target.value),
      onFocus: f,
      onBlur: C,
      onKeyDown: R
    }
  );
}, Jd = Ad(function({
  id: t,
  name: n,
  placeholder: i,
  disabled: r = !1,
  readOnly: a = !1,
  required: o = !1,
  size: l = kt.Medium,
  state: u = Ne.Default,
  width: c = we.Auto,
  prefix: h,
  onPrefixClick: p,
  suffix: m,
  onSuffixClick: g,
  inputType: b = ct.Text,
  maxLength: v,
  minLength: w,
  min: y,
  max: I,
  className: E,
  value: P,
  defaultValue: S = "",
  onChange: f,
  onBlur: C,
  onFocus: L,
  ariaLabel: F
}, M) {
  const z = at(), R = t ?? z, j = re(null), [H, O] = Ee(!1), [X, K] = Fn(P, S, f), se = () => {
    O(!0), L?.();
  }, Y = () => {
    O(!1), C?.(X);
  };
  return /* @__PURE__ */ _(
    Bn,
    {
      isFocused: H,
      disabled: r,
      readOnly: a,
      state: u,
      size: l,
      prefix: h,
      onPrefixClick: p,
      suffix: m,
      onSuffixClick: g,
      inputRef: j,
      className: Q(
        xl["ds-input"],
        c !== we.Auto && xl[`ds-input--width-${c}`],
        E
      ),
      children: /* @__PURE__ */ _(
        zn,
        {
          ref: Bi(j, M),
          id: R,
          name: n,
          value: X,
          placeholder: i,
          type: b,
          disabled: r,
          readOnly: a,
          maxLength: v,
          minLength: w,
          min: y,
          max: I,
          required: o,
          ariaLabel: F,
          ariaInvalid: u === Ne.Error,
          onChange: K,
          onFocus: se,
          onBlur: Y
        }
      )
    }
  );
}), bt = {
  "ds-field-base": "_ds-field-base_1t7a2_1",
  "ds-field-base__label-row": "_ds-field-base__label-row_1t7a2_8",
  "ds-field-base__label": "_ds-field-base__label_1t7a2_8",
  "ds-field-base__required": "_ds-field-base__required_1t7a2_22",
  "ds-field-base__help-trigger": "_ds-field-base__help-trigger_1t7a2_25",
  "ds-field-base__description": "_ds-field-base__description_1t7a2_42",
  "ds-field-base__control": "_ds-field-base__control_1t7a2_48",
  "ds-field-base__control-row": "_ds-field-base__control-row_1t7a2_52",
  "ds-field-base__control-input": "_ds-field-base__control-input_1t7a2_57",
  "ds-field-base__suffix-copy": "_ds-field-base__suffix-copy_1t7a2_61",
  "ds-field-base__footer": "_ds-field-base__footer_1t7a2_69",
  "ds-field-base__hint": "_ds-field-base__hint_1t7a2_76",
  "ds-field-base__hint--error": "_ds-field-base__hint--error_1t7a2_83",
  "ds-field-base__hint--warning": "_ds-field-base__hint--warning_1t7a2_86",
  "ds-field-base__hint--success": "_ds-field-base__hint--success_1t7a2_89",
  "ds-field-base__counter": "_ds-field-base__counter_1t7a2_92",
  "ds-field-base__counter--exceeded": "_ds-field-base__counter--exceeded_1t7a2_99",
  "ds-field-base--disabled": "_ds-field-base--disabled_1t7a2_103",
  "ds-field-base--width-full": "_ds-field-base--width-full_1t7a2_111",
  "ds-field-base--width-sm": "_ds-field-base--width-sm_1t7a2_114",
  "ds-field-base--width-md": "_ds-field-base--width-md_1t7a2_117",
  "ds-field-base--width-lg": "_ds-field-base--width-lg_1t7a2_120"
}, Qn = ({
  id: e,
  label: t,
  description: n,
  hint: i,
  state: r = Ne.Default,
  required: a = !1,
  disabled: o = !1,
  width: l = we.Auto,
  tooltip: u,
  tooltipPlacement: c,
  maxLength: h,
  currentLength: p,
  suffixCopy: m,
  className: g,
  children: b
}) => {
  const v = re(null), w = at(), y = h !== void 0 && p !== void 0 && p > h;
  return /* @__PURE__ */ B(
    "div",
    {
      className: Q(
        bt["ds-field-base"],
        r !== Ne.Default && bt[`ds-field-base--${r}`],
        o && bt["ds-field-base--disabled"],
        l !== we.Auto && bt[`ds-field-base--width-${l}`],
        g
      ),
      children: [
        t && /* @__PURE__ */ B("div", { className: bt["ds-field-base__label-row"], children: [
          /* @__PURE__ */ B("label", { htmlFor: e, className: bt["ds-field-base__label"], children: [
            t,
            a && /* @__PURE__ */ _("span", { className: bt["ds-field-base__required"], "aria-hidden": "true", children: " *" })
          ] }),
          u && /* @__PURE__ */ B(Ke, { children: [
            /* @__PURE__ */ _(
              "span",
              {
                ref: v,
                className: bt["ds-field-base__help-trigger"],
                role: "img",
                "aria-label": `More information about ${t}`,
                children: /* @__PURE__ */ _(ke, { name: J.Help, "aria-hidden": "true" })
              }
            ),
            /* @__PURE__ */ _(cn, { id: w, content: u, anchorRef: v, placement: c })
          ] })
        ] }),
        n && /* @__PURE__ */ _("p", { id: `${e}-description`, className: bt["ds-field-base__description"], children: n }),
        /* @__PURE__ */ _("div", { className: bt["ds-field-base__control"], children: m ? /* @__PURE__ */ B("div", { className: bt["ds-field-base__control-row"], children: [
          /* @__PURE__ */ _("div", { className: bt["ds-field-base__control-input"], children: b }),
          /* @__PURE__ */ _("span", { className: bt["ds-field-base__suffix-copy"], children: m })
        ] }) : b }),
        (i || h !== void 0 && p !== void 0) && /* @__PURE__ */ B("div", { className: bt["ds-field-base__footer"], children: [
          i && /* @__PURE__ */ _(
            "p",
            {
              id: `${e}-hint`,
              className: Q(
                bt["ds-field-base__hint"],
                r !== Ne.Default && bt[`ds-field-base__hint--${r}`]
              ),
              role: r === Ne.Error ? "alert" : void 0,
              "aria-live": r === Ne.Error ? "polite" : void 0,
              children: i
            }
          ),
          h !== void 0 && p !== void 0 && /* @__PURE__ */ B(
            "span",
            {
              className: Q(bt["ds-field-base__counter"], y && bt["ds-field-base__counter--exceeded"]),
              "aria-label": `${p} of ${h} characters used`,
              "aria-live": "polite",
              children: [
                p,
                "/",
                h
              ]
            }
          )
        ] })
      ]
    }
  );
}, Wd = {}, Ni = ({
  id: e,
  name: t,
  ref: n,
  label: i,
  description: r,
  hint: a,
  state: o = Ne.Default,
  placeholder: l,
  disabled: u = !1,
  readOnly: c = !1,
  size: h = kt.Medium,
  required: p = !1,
  min: m,
  max: g,
  minLength: b,
  maxLength: v,
  prefix: w,
  onPrefixClick: y,
  prefixAriaLabel: I,
  suffix: E,
  onSuffixClick: P,
  suffixAriaLabel: S,
  suffixCopy: f,
  tooltip: C,
  tooltipPlacement: L,
  width: F,
  className: M,
  value: z,
  defaultValue: R = "",
  onChange: j,
  onBlur: H,
  onFocus: O,
  onKeyDown: X,
  inputType: K = ct.Text,
  showCounter: se = !1,
  revealable: Y = !1,
  revealAriaLabel: N = "Show value",
  hideAriaLabel: ue = "Hide value"
}) => {
  const ie = re(null), [V, de] = Ee(!1), [Se, W] = Ee(!1), [q, ne] = Fn(z, R, j);
  let ee = K, ge = E, te = P, _e = S;
  Y && (ee = Se ? ct.Text : ct.Password, ge = Se ? J.VisibilityOff : J.Visibility, te = () => W((Ze) => !Ze), _e = Se ? ue : N);
  const Te = () => {
    de(!0), O?.();
  }, Ye = () => {
    de(!1), H?.(q);
  }, ot = [r ? `${e}-description` : null, a ? `${e}-hint` : null].filter(Boolean).join(" ") || void 0;
  return /* @__PURE__ */ _(
    Qn,
    {
      id: e,
      label: i,
      description: r,
      hint: a,
      state: o,
      required: p,
      disabled: u,
      tooltip: C,
      tooltipPlacement: L,
      suffixCopy: f,
      width: F,
      maxLength: se && v !== void 0 ? v : void 0,
      currentLength: se && v !== void 0 ? q.length : void 0,
      className: M,
      children: /* @__PURE__ */ _(
        Bn,
        {
          isFocused: V,
          disabled: u,
          readOnly: c,
          state: o,
          size: h,
          prefix: w,
          onPrefixClick: y,
          prefixAriaLabel: I,
          suffix: ge,
          onSuffixClick: te,
          suffixAriaLabel: _e,
          inputRef: ie,
          className: Wd["ds-text-field__chrome"],
          children: /* @__PURE__ */ _(
            zn,
            {
              ref: (Ze) => {
                ie.current = Ze, typeof n == "function" ? n(Ze) : n && (n.current = Ze);
              },
              id: e,
              name: t,
              value: q,
              placeholder: l,
              type: ee,
              disabled: u,
              readOnly: c,
              maxLength: v,
              minLength: b,
              min: m,
              max: g,
              required: p,
              ariaDescribedBy: ot,
              ariaInvalid: o === Ne.Error,
              onChange: ne,
              onFocus: Te,
              onBlur: Ye,
              onKeyDown: X
            }
          )
        }
      )
    }
  );
};
function Xd(e, t) {
  if (e.length === 0)
    return null;
  if (t === null)
    return e[0]?.id ?? null;
  const n = e.findIndex((i) => i.id === t);
  return e[(n + 1) % e.length]?.id ?? null;
}
function Zd(e, t) {
  if (e.length === 0)
    return null;
  if (t === null)
    return e[e.length - 1]?.id ?? null;
  const n = e.findIndex((r) => r.id === t), i = n <= 0 ? e.length - 1 : n - 1;
  return e[i]?.id ?? null;
}
function Gd(e, t) {
  t && e.get(t)?.scrollIntoView({ block: "nearest" });
}
function Er({
  options: e,
  isOpen: t,
  onSelect: n,
  onClose: i,
  onOpen: r
}) {
  const [a, o] = Ee(null), l = re(/* @__PURE__ */ new Map()), u = pe((m, g) => {
    l.current.set(m, g);
  }, []), c = e.filter((m) => !m.disabled), h = pe(
    (m) => {
      const g = (b) => {
        o(b), Gd(l.current, b);
      };
      switch (m.key) {
        case "ArrowDown": {
          m.preventDefault(), t || r(), g(Xd(c, t ? a : null));
          break;
        }
        case "ArrowUp": {
          m.preventDefault(), t || r(), g(Zd(c, t ? a : null));
          break;
        }
        case "Home": {
          if (!t)
            break;
          m.preventDefault(), g(c[0]?.id ?? null);
          break;
        }
        case "End": {
          if (!t)
            break;
          m.preventDefault(), g(c[c.length - 1]?.id ?? null);
          break;
        }
        case "Enter": {
          if (!t || a === null)
            break;
          m.preventDefault();
          const b = e.find((v) => v.id === a);
          b && !b.disabled && n(b);
          break;
        }
        case "Escape": {
          if (!t)
            break;
          m.preventDefault(), i(), o(null);
          break;
        }
        case "Tab": {
          if (!t)
            break;
          i(), o(null);
          break;
        }
      }
    },
    [t, a, e, c, r, n, i]
  ), p = pe(() => o(null), []);
  return {
    activeId: a,
    clearActiveId: p,
    handleInputKeyDown: h,
    onOptionRef: u
  };
}
function zi({
  anchorRef: e,
  overlayRef: t,
  placement: n = "bottom-start",
  disabled: i = !1,
  onOpen: r,
  onClose: a
}) {
  const [o, l] = Ee(!1), u = re(!1);
  ve(() => {
    u.current = o;
  }, [o]);
  const c = re({
    x: 0,
    y: 0,
    resolvedPlacement: n
  }), h = re(!1), p = pe(() => {
    i || l(!0);
  }, [i]), m = pe(() => {
    l(!1);
  }, []), g = pe(() => {
    u.current ? m() : p();
  }, [p, m]);
  return ve(() => {
    if (!h.current) {
      h.current = !0;
      return;
    }
    o ? r?.() : a?.();
  }, [o, r, a]), ve(() => {
    if (!o)
      return;
    const b = (v) => {
      const w = e.current, y = t.current;
      w?.contains(v.target) || y?.contains(v.target) || m();
    };
    return document.addEventListener("pointerdown", b, {
      capture: !0
    }), document.addEventListener("click", b, {
      capture: !0
    }), () => {
      document.removeEventListener("pointerdown", b, { capture: !0 }), document.removeEventListener("click", b, { capture: !0 });
    };
  }, [o, e, t, m]), ve(() => {
    if (!o)
      return;
    const b = (v) => {
      v.key === "Escape" && (v.stopPropagation(), m(), e.current?.focus());
    };
    return document.addEventListener("keydown", b, { capture: !0 }), () => {
      document.removeEventListener("keydown", b, {
        capture: !0
      });
    };
  }, [o, m, e]), {
    isOpen: o,
    open: p,
    close: m,
    toggle: g,
    position: c.current
  };
}
function so(e) {
  const { mode: t, options: n } = e, i = t === "single" ? e : void 0, [r, a] = Fn(
    t === "single" ? i.value : void 0,
    t === "single" ? i.defaultValue ?? null : null,
    t === "single" ? i.onChange : void 0
  ), o = t === "multi" ? e : void 0, [l, u] = Fn(
    t === "multi" ? o.value : void 0,
    t === "multi" ? o.defaultValue ?? [] : [],
    t === "multi" ? o.onChange : void 0
  ), c = $e(() => {
    if (t === "single") {
      if (r == null)
        return [];
      const y = n.find((I) => I.value === r);
      return y ? [y.id] : [];
    }
    return n.filter((y) => l.includes(y.value)).map((y) => y.id);
  }, [t, r, l, n]), h = $e(() => n.filter((y) => c.includes(y.id)), [n, c]), p = pe((y) => c.includes(y), [c]), m = pe(
    (y) => {
      t === "single" ? a(y.value) : u((I) => I.includes(y.value) ? I : [...I, y.value]);
    },
    [t, a, u]
  ), g = pe(
    (y) => {
      if (t === "single")
        n.find((E) => E.id === y)?.value === r && a(null);
      else {
        const I = n.find((E) => E.id === y);
        I && u((E) => E.filter((P) => P !== I.value));
      }
    },
    [t, n, r, a, u]
  ), b = pe(
    (y) => {
      p(y.id) ? g(y.id) : m(y);
    },
    [p, g, m]
  ), v = pe(() => {
    t === "single" ? a(null) : u([]);
  }, [t, a, u]), w = $e(() => h.map((y) => y.label).join(", "), [h]);
  return {
    selectedIds: c,
    selectedOptions: h,
    isSelected: p,
    select: m,
    deselect: g,
    toggle: b,
    clear: v,
    displayValue: w
  };
}
const Dt = {
  "ds-option-list": "_ds-option-list_cyotw_1",
  "ds-option-list__item": "_ds-option-list__item_cyotw_7",
  "ds-option-list__item--disabled": "_ds-option-list__item--disabled_cyotw_17",
  "ds-option-list__item--active": "_ds-option-list__item--active_cyotw_20",
  "ds-option-list__item--selected": "_ds-option-list__item--selected_cyotw_25",
  "ds-option-list__label": "_ds-option-list__label_cyotw_28",
  "ds-option-list__checkbox": "_ds-option-list__checkbox_cyotw_42",
  "ds-option-list__checkbox--checked": "_ds-option-list__checkbox--checked_cyotw_51",
  "ds-option-list__icon": "_ds-option-list__icon_cyotw_58",
  "ds-option-list__content": "_ds-option-list__content_cyotw_68",
  "ds-option-list__label--wrap": "_ds-option-list__label--wrap_cyotw_84",
  "ds-option-list__description": "_ds-option-list__description_cyotw_89",
  "ds-option-list__description--sr-only": "_ds-option-list__description--sr-only_cyotw_97",
  "ds-option-list__selected-mark": "_ds-option-list__selected-mark_cyotw_108",
  "ds-option-list__empty": "_ds-option-list__empty_cyotw_115"
};
function Kd({
  option: e,
  isSelected: t,
  isActive: n,
  mode: i,
  onActivate: r,
  onRef: a,
  selectedMarkPosition: o = "trailing"
}) {
  const l = (g) => {
    g.preventDefault(), e.disabled || r(e);
  }, u = (g) => {
    (g.key === "Enter" || g.key === " ") && (g.preventDefault(), e.disabled || r(e));
  }, c = !!(e.icon && e.description && e.descriptionAsTooltip), h = e.description ? `${e.id}-description` : void 0, p = e.icon && /* @__PURE__ */ _("span", { className: Dt["ds-option-list__icon"], "aria-hidden": c ? void 0 : "true", children: /* @__PURE__ */ _(ke, { name: e.icon, tooltip: c ? e.description : void 0 }) }), m = i === "single" && t && /* @__PURE__ */ _("span", { className: Dt["ds-option-list__selected-mark"], "aria-hidden": "true", children: "✓" });
  return /* @__PURE__ */ B(
    "li",
    {
      ref: (g) => a(e.id, g),
      id: e.id,
      role: "option",
      "aria-selected": t,
      "aria-disabled": e.disabled ? !0 : void 0,
      "aria-describedby": h,
      className: Q(
        Dt["ds-option-list__item"],
        n && Dt["ds-option-list__item--active"],
        t && Dt["ds-option-list__item--selected"],
        e.disabled && Dt["ds-option-list__item--disabled"]
      ),
      onClick: l,
      onKeyDown: u,
      children: [
        i === "multi" && /* @__PURE__ */ _(
          "span",
          {
            className: Q(Dt["ds-option-list__checkbox"], t && Dt["ds-option-list__checkbox--checked"]),
            "aria-hidden": "true"
          }
        ),
        o === "leading" && m,
        e.iconPosition !== "trailing" && p,
        /* @__PURE__ */ B("span", { className: Dt["ds-option-list__content"], children: [
          /* @__PURE__ */ _(
            "span",
            {
              className: Q(
                Dt["ds-option-list__label"],
                e.description && !c && Dt["ds-option-list__label--wrap"]
              ),
              children: e.label
            }
          ),
          e.description && !c && /* @__PURE__ */ _("span", { id: h, className: Dt["ds-option-list__description"], "aria-hidden": "true", children: e.description }),
          e.description && c && /* @__PURE__ */ _("span", { id: h, className: Dt["ds-option-list__description--sr-only"], "aria-hidden": "true", children: e.description })
        ] }),
        e.iconPosition === "trailing" && p,
        o === "trailing" && m
      ]
    }
  );
}
function Ar({
  id: e,
  options: t,
  selectedIds: n,
  activeId: i,
  mode: r = "single",
  ariaLabel: a,
  emptyText: o = "No options available",
  onActivate: l,
  onOptionRef: u,
  className: c,
  selectedMarkPosition: h
}) {
  return /* @__PURE__ */ _(
    "ul",
    {
      id: e,
      role: "listbox",
      "aria-label": a,
      "aria-multiselectable": r === "multi" ? !0 : void 0,
      className: Q(Dt["ds-option-list"], c),
      onMouseDown: (p) => p.preventDefault(),
      children: t.length === 0 ? /* @__PURE__ */ _("li", { role: "presentation", className: Dt["ds-option-list__empty"], "aria-live": "polite", children: o }) : t.map((p) => /* @__PURE__ */ _(
        Kd,
        {
          option: p,
          isSelected: n.includes(p.id),
          isActive: i === p.id,
          mode: r,
          onActivate: l,
          onRef: u,
          selectedMarkPosition: h
        },
        p.id
      ))
    }
  );
}
const Yd = "ds-input-overlay-layer", Qd = 4, ef = 8, tf = {
  "bottom-start": ["top-start", "bottom-end", "top-end"],
  "bottom-end": ["top-end", "bottom-start", "top-start"],
  "top-start": ["bottom-start", "top-end", "bottom-end"],
  "top-end": ["bottom-end", "top-start", "bottom-start"]
};
function vl(e, t, n, i) {
  switch (n) {
    case "bottom-start":
      return {
        x: e.left,
        y: e.bottom + i
      };
    case "bottom-end":
      return {
        x: e.right - t.width,
        y: e.bottom + i
      };
    case "top-start":
      return {
        x: e.left,
        y: e.top - t.height - i
      };
    case "top-end":
      return {
        x: e.right - t.width,
        y: e.top - t.height - i
      };
  }
}
function nf(e, t, n, i, r) {
  const { viewportPaddingPx: a, flip: o } = r;
  let l = n, u = vl(e, t, n, i);
  if (o && !Fi(u.x, u.y, t.width, t.height, a))
    for (const h of tf[n]) {
      const p = vl(e, t, h, i);
      if (Fi(p.x, p.y, t.width, t.height, a)) {
        l = h, u = p;
        break;
      }
    }
  const c = ro(u.x, u.y, t.width, t.height, a);
  return { x: c.x, y: c.y, resolvedPlacement: l };
}
const Ms = {
  "ds-overlay-surface": "_ds-overlay-surface_4ir7y_1",
  "ds-overlay-surface--bottom-start": "_ds-overlay-surface--bottom-start_4ir7y_28",
  "ds-overlay-surface--bottom-end": "_ds-overlay-surface--bottom-end_4ir7y_28",
  "ds-overlay-surface--closed": "_ds-overlay-surface--closed_4ir7y_31",
  "ds-overlay-surface--open": "_ds-overlay-surface--open_4ir7y_34",
  "ds-overlay-surface--top-start": "_ds-overlay-surface--top-start_4ir7y_37",
  "ds-overlay-surface--top-end": "_ds-overlay-surface--top-end_4ir7y_37"
}, ji = ({
  id: e,
  anchorRef: t,
  isOpen: n,
  placement: i = "bottom-start",
  offsetPx: r = Qd,
  collision: a,
  layerId: o = Yd,
  minWidth: l,
  className: u,
  children: c,
  ref: h
}) => {
  const p = re(null), m = re(null), g = re({
    x: 0,
    y: 0,
    resolvedPlacement: i
  }), b = {
    viewportPaddingPx: a?.viewportPaddingPx ?? ef,
    flip: a?.flip ?? !0
  }, v = pe(() => {
    m.current !== null && (cancelAnimationFrame(m.current), m.current = null);
  }, []), w = pe(() => {
    const P = t.current, S = p.current;
    if (!P || !S)
      return;
    const f = P.getBoundingClientRect(), C = S.getBoundingClientRect();
    l === "anchor" && (S.style.minWidth = `${f.width}px`);
    const L = nf(f, C, i, r, b);
    g.current = L, S.style.setProperty("--_x", `${L.x}px`), S.style.setProperty("--_y", `${L.y}px`), S.dataset.placement = L.resolvedPlacement;
  }, [t, i, r, l, b.viewportPaddingPx, b.flip]), y = pe(() => {
    v(), m.current = requestAnimationFrame(() => {
      w();
    });
  }, [v, w]);
  no(() => {
    n && w();
  }, [n, w]), ve(() => {
    if (!n) {
      v();
      return;
    }
    const P = () => y(), S = () => y();
    return window.addEventListener("scroll", P, { capture: !0, passive: !0 }), window.addEventListener("resize", S, { passive: !0 }), () => {
      window.removeEventListener("scroll", P, {
        capture: !0
      }), window.removeEventListener("resize", S), v();
    };
  }, [n, y, v]), ve(() => {
    const P = t.current;
    if (!P || !n)
      return;
    const S = new ResizeObserver(() => y());
    return S.observe(P), p.current && S.observe(p.current), () => S.disconnect();
  }, [t, n, y]), ve(() => () => v(), [v]);
  const I = n ? "open" : "closed", E = fi(o);
  return di(
    /* @__PURE__ */ _(
      "div",
      {
        ref: Bi(p, h),
        id: e,
        className: Q(
          Ms["ds-overlay-surface"],
          Ms[`ds-overlay-surface--${g.current.resolvedPlacement}`],
          Ms[`ds-overlay-surface--${I}`],
          u
        ),
        "data-state": I,
        "data-placement": g.current.resolvedPlacement,
        children: c
      }
    ),
    E
  );
}, er = {
  "ds-select-field": "_ds-select-field_r82g1_1",
  "ds-select-field--width-full": "_ds-select-field--width-full_r82g1_6",
  "ds-select-field--width-sm": "_ds-select-field--width-sm_r82g1_9",
  "ds-select-field--width-md": "_ds-select-field--width-md_r82g1_12",
  "ds-select-field--width-lg": "_ds-select-field--width-lg_r82g1_15",
  "ds-select-field__trigger-wrap": "_ds-select-field__trigger-wrap_r82g1_18",
  "ds-select-field__chrome": "_ds-select-field__chrome_r82g1_22",
  "ds-select-field__input": "_ds-select-field__input_r82g1_25"
};
function ao({
  id: e,
  name: t,
  label: n,
  description: i,
  hint: r,
  state: a = Ne.Default,
  placeholder: o = "Select an option",
  disabled: l = !1,
  readOnly: u = !1,
  size: c = kt.Medium,
  required: h = !1,
  prefix: p,
  suffix: m,
  suffixCopy: g,
  tooltip: b,
  tooltipPlacement: v,
  width: w = we.Auto,
  className: y,
  options: I,
  value: E,
  defaultValue: P = null,
  onChange: S,
  emptyText: f = "No options available",
  popupPlacement: C = "bottom-start",
  selectedMarkPosition: L
}) {
  const F = re(null), M = re(null), z = re(null), [R, j] = Ee(!1), H = at(), { isOpen: O, open: X, close: K } = zi({
    anchorRef: F,
    overlayRef: M,
    placement: C,
    disabled: l || u
  }), { selectedIds: se, displayValue: Y, select: N } = so({
    mode: "single",
    options: I,
    value: E,
    defaultValue: P,
    onChange: S
  }), { activeId: ue, clearActiveId: ie, handleInputKeyDown: V, onOptionRef: de } = Er({
    options: I,
    isOpen: O,
    onOpen: X,
    onClose: K,
    onSelect: (te) => {
      N(te), K(), ie(), z.current?.focus();
    }
  }), Se = () => {
    l || u || (O ? K() : X(), z.current?.focus());
  }, W = (te) => {
    N(te), K(), ie(), z.current?.focus();
  }, q = () => j(!0), ne = () => {
    j(!1);
  }, ee = [i ? `${e}-description` : null, r ? `${e}-hint` : null].filter(Boolean).join(" ") || void 0, ge = m ?? J.KeyboardArrowDown;
  return /* @__PURE__ */ B(
    "div",
    {
      className: Q(
        er["ds-select-field"],
        w !== we.Auto && er[`ds-select-field--width-${w}`],
        y
      ),
      children: [
        /* @__PURE__ */ _(
          Qn,
          {
            id: e,
            label: n,
            description: i,
            hint: r,
            state: a,
            required: h,
            disabled: l,
            tooltip: b,
            tooltipPlacement: v,
            suffixCopy: g,
            children: /* @__PURE__ */ _("div", { ref: F, className: er["ds-select-field__trigger-wrap"], children: /* @__PURE__ */ _(
              Bn,
              {
                isFocused: R || O,
                disabled: l,
                readOnly: u,
                state: a,
                size: c,
                prefix: p,
                suffix: ge,
                inputRef: z,
                onClick: Se,
                className: er["ds-select-field__chrome"],
                children: /* @__PURE__ */ _(
                  zn,
                  {
                    ref: z,
                    id: e,
                    name: t,
                    value: Y,
                    placeholder: o,
                    type: ct.Text,
                    disabled: l,
                    readOnly: !0,
                    required: h,
                    role: "combobox",
                    ariaExpanded: O,
                    ariaControls: H,
                    ariaActivedescendant: ue ?? void 0,
                    ariaDescribedBy: ee,
                    ariaInvalid: a === Ne.Error,
                    onChange: () => {
                    },
                    onFocus: q,
                    onBlur: ne,
                    onKeyDown: V,
                    className: er["ds-select-field__input"]
                  }
                )
              }
            ) })
          }
        ),
        /* @__PURE__ */ _(
          ji,
          {
            id: H,
            ref: M,
            anchorRef: F,
            isOpen: O && !l && !u,
            placement: C,
            minWidth: "anchor",
            children: /* @__PURE__ */ _(
              Ar,
              {
                id: `${H}-list`,
                options: I,
                selectedIds: se,
                activeId: ue,
                mode: "single",
                ariaLabel: n,
                emptyText: f,
                onActivate: W,
                onOptionRef: de,
                selectedMarkPosition: L
              }
            )
          }
        )
      ]
    }
  );
}
function Fs(e) {
  return e.toLowerCase().trim();
}
function oo(e, t, n = !0) {
  return $e(() => {
    if (!n || t.trim() === "")
      return e;
    const i = Fs(t);
    return e.filter((r) => !!(Fs(r.label).includes(i) || r.description && Fs(r.description).includes(i)));
  }, [e, t, n]);
}
const Br = {
  "ds-combo-box-field": "_ds-combo-box-field_18p8z_1",
  "ds-combo-box-field--width-full": "_ds-combo-box-field--width-full_18p8z_6",
  "ds-combo-box-field--width-sm": "_ds-combo-box-field--width-sm_18p8z_9",
  "ds-combo-box-field--width-md": "_ds-combo-box-field--width-md_18p8z_12",
  "ds-combo-box-field--width-lg": "_ds-combo-box-field--width-lg_18p8z_15",
  "ds-combo-box-field__trigger-wrap": "_ds-combo-box-field__trigger-wrap_18p8z_18"
};
function bc({
  id: e,
  name: t,
  label: n,
  description: i,
  hint: r,
  state: a = Ne.Default,
  placeholder: o = "Search or select...",
  disabled: l = !1,
  readOnly: u = !1,
  size: c = kt.Medium,
  required: h = !1,
  minLength: p,
  maxLength: m,
  prefix: g,
  suffix: b = J.KeyboardArrowDown,
  suffixCopy: v,
  tooltip: w,
  tooltipPlacement: y,
  width: I = we.Auto,
  className: E,
  options: P,
  value: S,
  defaultValue: f = null,
  onChange: C,
  noOptionsText: L = "No matching options",
  popupPlacement: F = "bottom-start",
  allowFreeInput: M = !1,
  onFreeInput: z
}) {
  const R = re(null), j = re(null), H = re(null), O = re(!1), [X, K] = Ee(!1), [se, Y] = Ee(""), N = at(), { isOpen: ue, open: ie, close: V } = zi({
    anchorRef: R,
    overlayRef: j,
    placement: F,
    disabled: l || u
  }), { selectedIds: de, displayValue: Se, select: W, clear: q } = so({
    mode: "single",
    options: P,
    value: S,
    defaultValue: f,
    onChange: C
  }), ne = M && typeof S == "string" && S.trim() !== "" ? S : "", ee = Se || ne, ge = oo(P, se, !0), { activeId: te, clearActiveId: _e, handleInputKeyDown: Te, onOptionRef: Ye } = Er({
    options: ge,
    isOpen: ue,
    onOpen: ie,
    onClose: () => {
      V(), Y(ee);
    },
    onSelect: (De) => {
      W(De), Y(De.label), V(), _e(), O.current = !0, H.current?.focus();
    }
  }), ot = (De) => {
    Y(De), !ue && De.length > 0 && ie(), De === "" && q();
  }, Ze = (De) => {
    W(De), Y(De.label), V(), _e(), O.current = !0, H.current?.focus();
  }, ht = () => {
    if (K(!0), O.current) {
      O.current = !1;
      return;
    }
    P.length > 0 && (Y(""), ie());
  }, Oe = () => {
    K(!1), ee ? Y(ee) : M && se.trim() !== "" ? z?.(se.trim()) : M || (Y(""), q());
  }, ft = () => {
    l || u || !ue && P.length > 0 && (Y(""), ie());
  }, Ct = () => {
    l || u || (ue ? (V(), Y(ee)) : P.length > 0 && (Y(""), ie(), H.current?.focus()));
  }, St = [i ? `${e}-description` : null, r ? `${e}-hint` : null].filter(Boolean).join(" ") || void 0, Ve = X ? se : ee, qe = b ?? J.KeyboardArrowDown;
  return /* @__PURE__ */ B(
    "div",
    {
      className: Q(
        Br["ds-combo-box-field"],
        I !== we.Auto && Br[`ds-combo-box-field--width-${I}`],
        E
      ),
      children: [
        /* @__PURE__ */ _(
          Qn,
          {
            id: e,
            label: n,
            description: i,
            hint: r,
            state: a,
            required: h,
            disabled: l,
            tooltip: w,
            tooltipPlacement: y,
            suffixCopy: v,
            children: /* @__PURE__ */ _("div", { ref: R, className: Br["ds-combo-box-field__trigger-wrap"], children: /* @__PURE__ */ _(
              Bn,
              {
                isFocused: X || ue,
                disabled: l,
                readOnly: u,
                state: a,
                size: c,
                prefix: g,
                suffix: qe,
                inputRef: H,
                className: Br["ds-combo-box-field__chrome"],
                onClick: ft,
                onSuffixClick: Ct,
                suffixAriaLabel: ue ? "Close options" : "Open options",
                children: /* @__PURE__ */ _(
                  zn,
                  {
                    ref: H,
                    id: e,
                    name: t,
                    value: Ve,
                    placeholder: o,
                    type: ct.Text,
                    disabled: l,
                    readOnly: u,
                    required: h,
                    minLength: p,
                    maxLength: m,
                    role: "combobox",
                    ariaExpanded: ue,
                    ariaControls: N,
                    ariaActivedescendant: te ?? void 0,
                    ariaDescribedBy: St,
                    ariaInvalid: a === Ne.Error,
                    autoComplete: "off",
                    onChange: ot,
                    onFocus: ht,
                    onBlur: Oe,
                    onKeyDown: Te
                  }
                )
              }
            ) })
          }
        ),
        /* @__PURE__ */ _(
          ji,
          {
            id: N,
            ref: j,
            anchorRef: R,
            isOpen: ue && !l && !u,
            placement: F,
            minWidth: "anchor",
            children: /* @__PURE__ */ _(
              Ar,
              {
                id: `${N}-list`,
                options: ge,
                selectedIds: de,
                activeId: te,
                mode: "single",
                ariaLabel: n,
                emptyText: L,
                onActivate: Ze,
                onOptionRef: Ye
              }
            )
          }
        )
      ]
    }
  );
}
const yn = {
  "ds-multi-select-field": "_ds-multi-select-field_yvwwl_1",
  "ds-multi-select-field--width-full": "_ds-multi-select-field--width-full_yvwwl_6",
  "ds-multi-select-field--width-sm": "_ds-multi-select-field--width-sm_yvwwl_9",
  "ds-multi-select-field--width-md": "_ds-multi-select-field--width-md_yvwwl_12",
  "ds-multi-select-field--width-lg": "_ds-multi-select-field--width-lg_yvwwl_15",
  "ds-multi-select-field__trigger-wrap": "_ds-multi-select-field__trigger-wrap_yvwwl_18",
  "ds-multi-select-field__chrome": "_ds-multi-select-field__chrome_yvwwl_22",
  "ds-multi-select__body": "_ds-multi-select__body_yvwwl_29",
  "ds-multi-select__text-entry": "_ds-multi-select__text-entry_yvwwl_39",
  "ds-multi-select__chip": "_ds-multi-select__chip_yvwwl_44",
  "ds-multi-select__chip--disabled": "_ds-multi-select__chip--disabled_yvwwl_59",
  "ds-multi-select__chip-label": "_ds-multi-select__chip-label_yvwwl_62",
  "ds-multi-select__chip-remove": "_ds-multi-select__chip-remove_yvwwl_66"
};
function rf({
  option: e,
  onRemove: t,
  disabled: n
}) {
  const i = (a) => {
    a.stopPropagation(), n || t(e.id);
  }, r = (a) => {
    (a.key === "Enter" || a.key === " " || a.key === "Backspace") && !n && (a.preventDefault(), a.stopPropagation(), t(e.id));
  };
  return /* @__PURE__ */ B(
    "span",
    {
      className: Q(yn["ds-multi-select__chip"], n && yn["ds-multi-select__chip--disabled"]),
      role: "group",
      "aria-label": e.label,
      children: [
        /* @__PURE__ */ _("span", { className: yn["ds-multi-select__chip-label"], children: e.label }),
        !n && /* @__PURE__ */ _(
          "button",
          {
            type: "button",
            className: yn["ds-multi-select__chip-remove"],
            "aria-label": `Remove ${e.label}`,
            onClick: i,
            onKeyDown: r,
            tabIndex: 0,
            children: "×"
          }
        )
      ]
    }
  );
}
function vc({
  id: e,
  name: t,
  label: n,
  description: i,
  hint: r,
  state: a = Ne.Default,
  placeholder: o = "Select options...",
  disabled: l = !1,
  readOnly: u = !1,
  size: c = kt.Medium,
  required: h = !1,
  prefix: p,
  suffix: m,
  suffixCopy: g,
  tooltip: b,
  tooltipPlacement: v,
  width: w = we.Auto,
  className: y,
  options: I,
  value: E,
  defaultValue: P = [],
  onChange: S,
  noOptionsText: f = "No matching options",
  popupPlacement: C = "bottom-start",
  maxSelections: L
}) {
  const F = re(null), M = re(null), z = re(null), [R, j] = Ee(!1), [H, O] = Ee(""), X = at(), { isOpen: K, open: se, close: Y } = zi({
    anchorRef: F,
    overlayRef: M,
    placement: C,
    disabled: l || u
  }), { selectedIds: N, selectedOptions: ue, toggle: ie, deselect: V } = so({
    mode: "multi",
    options: I,
    value: E,
    defaultValue: P,
    onChange: S
  }), de = oo(I, H, !0), Se = L ? de.map(
    (Oe) => !N.includes(Oe.id) && N.length >= L ? { ...Oe, disabled: !0 } : Oe
  ) : de, { activeId: W, clearActiveId: q, handleInputKeyDown: ne, onOptionRef: ee } = Er({
    options: Se,
    isOpen: K,
    onOpen: se,
    onClose: Y,
    onSelect: (Oe) => {
      ie(Oe), O(""), z.current?.focus();
    }
  }), ge = (Oe) => {
    if (Oe.key === "Backspace" && H === "" && ue.length > 0 && !l && !u) {
      const ft = ue[ue.length - 1];
      ft && V(ft.id);
      return;
    }
    ne(Oe);
  }, te = (Oe) => {
    O(Oe), !K && Oe.length > 0 && se();
  }, _e = () => {
    l || u || (se(), z.current?.focus());
  }, Te = () => {
    j(!0), K || se();
  }, Ye = () => {
    j(!1), O("");
  }, ot = (Oe) => {
    V(Oe), z.current?.focus();
  }, Ze = [i ? `${e}-description` : null, r ? `${e}-hint` : null].filter(Boolean).join(" ") || void 0, ht = m ?? J.KeyboardArrowDown;
  return /* @__PURE__ */ B(
    "div",
    {
      className: Q(
        yn["ds-multi-select-field"],
        w !== we.Auto && yn[`ds-multi-select-field--width-${w}`],
        y
      ),
      children: [
        /* @__PURE__ */ _(
          Qn,
          {
            id: e,
            label: n,
            description: i,
            hint: r,
            state: a,
            required: h,
            disabled: l,
            tooltip: b,
            tooltipPlacement: v,
            suffixCopy: g,
            children: /* @__PURE__ */ _("div", { ref: F, className: yn["ds-multi-select-field__trigger-wrap"], children: /* @__PURE__ */ _(
              Bn,
              {
                isFocused: R || K,
                disabled: l,
                readOnly: u,
                state: a,
                size: c,
                prefix: p,
                suffix: ht,
                inputRef: z,
                onClick: _e,
                className: yn["ds-multi-select-field__chrome"],
                children: /* @__PURE__ */ B(
                  "div",
                  {
                    className: yn["ds-multi-select__body"],
                    "aria-label": `Selected items: ${ue.map((Oe) => Oe.label).join(", ") || "none"}`,
                    children: [
                      ue.map((Oe) => /* @__PURE__ */ _(rf, { option: Oe, onRemove: ot, disabled: l || u }, Oe.id)),
                      /* @__PURE__ */ _(
                        zn,
                        {
                          ref: z,
                          id: e,
                          name: t,
                          value: H,
                          placeholder: ue.length === 0 ? o : "",
                          type: ct.Text,
                          disabled: l,
                          readOnly: u,
                          required: h,
                          role: "combobox",
                          ariaExpanded: K,
                          ariaControls: X,
                          ariaActivedescendant: W ?? void 0,
                          ariaDescribedBy: Ze,
                          ariaInvalid: a === Ne.Error,
                          autoComplete: "off",
                          onChange: te,
                          onFocus: Te,
                          onBlur: Ye,
                          onKeyDown: ge,
                          className: yn["ds-multi-select__text-entry"]
                        }
                      )
                    ]
                  }
                )
              }
            ) })
          }
        ),
        /* @__PURE__ */ _(
          ji,
          {
            id: X,
            ref: M,
            anchorRef: F,
            isOpen: K && !l && !u,
            placement: C,
            minWidth: "anchor",
            children: /* @__PURE__ */ _(
              Ar,
              {
                id: `${X}-list`,
                options: Se,
                selectedIds: N,
                activeId: W,
                mode: "multi",
                ariaLabel: n,
                emptyText: f,
                onActivate: (Oe) => {
                  ie(Oe), O(""), q(), z.current?.focus();
                },
                onOptionRef: ee
              }
            )
          }
        )
      ]
    }
  );
}
const rs = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  '[tabindex]:not([tabindex="-1"])'
].join(","), lo = Cr(null), cr = [];
function sf(e, t) {
  for (let n = e.parent; n !== null; n = n.parent)
    if (n === t)
      return !0;
  return !1;
}
function wc(e) {
  return cr.some((t) => t !== e && sf(t, e));
}
function af() {
  return [...cr].reverse().find((e) => !wc(e));
}
function uo({
  isOpen: e,
  onClose: t,
  onAction: n,
  closeOnBackdropClick: i = !0,
  closeOnEscape: r = !0,
  lockBodyScroll: a = !1
}) {
  const o = re(null), l = Oi(lo), u = $e(() => ({ ref: o, parent: l }), [l]), c = re(t);
  c.current = t;
  const h = re(r);
  return h.current = r, ve(() => {
    if (e)
      return cr.push(u), () => {
        const g = cr.indexOf(u);
        g !== -1 && cr.splice(g, 1);
      };
  }, [e, u]), ve(() => {
    if (!e)
      return;
    const g = document.activeElement;
    return wc(u) || (o.current?.querySelector(rs) ?? o.current)?.focus(), () => {
      g?.isConnected && g.focus();
    };
  }, [e, u]), ve(() => {
    if (!e)
      return;
    const g = (b) => {
      if (af() === u) {
        if (b.key === "Escape") {
          h.current && c.current();
          return;
        }
        if (b.key === "Tab") {
          const v = Array.from(
            o.current?.querySelectorAll(rs) ?? []
          );
          if (!v.length) {
            b.preventDefault();
            return;
          }
          const w = v[0], y = v[v.length - 1];
          b.shiftKey ? document.activeElement === w && (b.preventDefault(), y.focus()) : document.activeElement === y && (b.preventDefault(), w.focus());
        }
      }
    };
    return document.addEventListener("keydown", g), () => document.removeEventListener("keydown", g);
  }, [e, u]), ve(() => {
    if (!a || !e)
      return;
    const g = document.body.style.overflow;
    return document.body.style.overflow = "hidden", () => {
      document.body.style.overflow = g;
    };
  }, [e, a]), { panelRef: o, panel: u, handleBackdropClick: () => {
    i && t();
  }, handleActionClick: (g) => {
    n?.(g);
  } };
}
const kc = "data-ns-autofocus";
function of(e) {
  const t = e.querySelector(`[${kc}]`);
  if (t)
    return t;
  const n = e.querySelector(rs);
  return n || (e.matches(rs) ? e : null);
}
function Cc(e, { enabled: t = !0, preventScroll: n = !0 } = {}) {
  const i = re(null), r = re(null);
  return ve(() => {
    if (!t || e !== null && e === r.current)
      return;
    const a = i.current;
    if (!a)
      return;
    const o = requestAnimationFrame(() => {
      if (a.contains(document.activeElement))
        return;
      const l = of(a);
      l && (l.focus({ preventScroll: n }), r.current = e);
    });
    return () => cancelAnimationFrame(o);
  }, [e, t, n]), i;
}
const lf = "_buttons_33e4f_62", Ge = {
  "ds-date-picker-field": "_ds-date-picker-field_33e4f_1",
  "ds-date-picker-field--width-full": "_ds-date-picker-field--width-full_33e4f_6",
  "ds-date-picker-field--width-sm": "_ds-date-picker-field--width-sm_33e4f_9",
  "ds-date-picker-field--width-md": "_ds-date-picker-field--width-md_33e4f_12",
  "ds-date-picker-field--width-lg": "_ds-date-picker-field--width-lg_33e4f_15",
  "ds-date-picker-field__trigger-wrap": "_ds-date-picker-field__trigger-wrap_33e4f_18",
  "ds-date-picker-field__calendar-trigger": "_ds-date-picker-field__calendar-trigger_33e4f_22",
  "ds-date-picker__calendar": "_ds-date-picker__calendar_33e4f_45",
  "ds-date-picker__calendar-disabled": "_ds-date-picker__calendar-disabled_33e4f_53",
  "ds-date-picker__cal-header": "_ds-date-picker__cal-header_33e4f_56",
  buttons: lf,
  "ds-date-picker__nav-btn": "_ds-date-picker__nav-btn_33e4f_72",
  "ds-date-picker__month-label": "_ds-date-picker__month-label_33e4f_93",
  "ds-date-picker__year-btn": "_ds-date-picker__year-btn_33e4f_100",
  "ds-date-picker__year-grid": "_ds-date-picker__year-grid_33e4f_120",
  "ds-date-picker__year-cell": "_ds-date-picker__year-cell_33e4f_126",
  "ds-date-picker__year-cell--selected": "_ds-date-picker__year-cell--selected_33e4f_147",
  "ds-date-picker__year-cell--current": "_ds-date-picker__year-cell--current_33e4f_154",
  "ds-date-picker__day-names": "_ds-date-picker__day-names_33e4f_157",
  "ds-date-picker__day-name": "_ds-date-picker__day-name_33e4f_157",
  "ds-date-picker__grid": "_ds-date-picker__grid_33e4f_171",
  "ds-date-picker__day-cell": "_ds-date-picker__day-cell_33e4f_176",
  "ds-date-picker__day-cell--disabled": "_ds-date-picker__day-cell--disabled_33e4f_190",
  "ds-date-picker__day-cell--today": "_ds-date-picker__day-cell--today_33e4f_197",
  "ds-date-picker__day-cell--selected": "_ds-date-picker__day-cell--selected_33e4f_201",
  "ds-date-picker__day-cell--selected-disabled": "_ds-date-picker__day-cell--selected-disabled_33e4f_213",
  "ds-date-picker__day-cell--today-disabled": "_ds-date-picker__day-cell--today-disabled_33e4f_221"
};
function ci(e, t, n) {
  return `${e}-${String(t + 1).padStart(2, "0")}-${String(n).padStart(2, "0")}`;
}
function hr(e, t, n, i) {
  return !!(t && e < t || n && e > n || i?.(e));
}
function uf(e, t) {
  return new Date(e, t + 1, 0).getDate();
}
function cf(e, t) {
  return new Date(e, t, 1).getDay();
}
const wl = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], hf = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], fn = 12, zr = 7, kl = 3, Cl = 'button:not([disabled]), [tabindex="0"]';
function pf(e, t, n, i, r, a, o) {
  let l = 1;
  if (i) {
    const [u, c, h] = i.split("-").map(Number);
    u === e && c - 1 === t && (l = h);
  }
  if (!hr(ci(e, t, l), r, a, o))
    return l;
  for (let u = l + 1; u <= n; u += 1)
    if (!hr(ci(e, t, u), r, a, o))
      return u;
  for (let u = l - 1; u >= 1; u -= 1)
    if (!hr(ci(e, t, u), r, a, o))
      return u;
  return l;
}
function Sc({
  id: e,
  selectedIso: t,
  calState: n,
  disabled: i = !1,
  focusGrid: r = !1,
  minDate: a,
  maxDate: o,
  isDateDisabled: l,
  onSelectDay: u,
  onPrevMonth: c,
  onNextMonth: h,
  onSelectYear: p,
  onEscape: m
}) {
  const { year: g, month: b } = n, [v, w] = Ee(!1), [y, I] = Ee(0), E = re(/* @__PURE__ */ new Map()), [P, S] = Ee(1), f = re(!1), C = re(/* @__PURE__ */ new Map()), [L, F] = Ee(g), M = re(null), z = Q({
    [Ge["ds-date-picker__calendar"]]: !0,
    [Ge["ds-date-picker__calendar-disabled"]]: i
  });
  ve(() => {
    const q = M.current, ne = (ee) => {
      if (ee.key === "Escape") {
        m && (ee.preventDefault(), ee.stopPropagation(), m());
        return;
      }
      if (ee.key !== "Tab")
        return;
      const ge = Array.from(q?.querySelectorAll(Cl) ?? []);
      if (ge.length === 0)
        return;
      const te = ge.indexOf(document.activeElement), _e = te === -1 ? ge[ee.shiftKey ? ge.length - 1 : 0] : ge[(te + (ee.shiftKey ? -1 : 1) + ge.length) % ge.length];
      ee.preventDefault(), _e?.focus();
    };
    return q?.addEventListener("keydown", ne), () => q?.removeEventListener("keydown", ne);
  }, [m]), ve(() => {
    v && C.current.get(L)?.focus();
  }, [v, L]);
  const R = () => {
    i || (I(Math.floor(g / fn) * fn), F(g), w(!0));
  }, j = (q) => {
    i || (p?.(q), w(!1), f.current = !1);
  }, H = (q, ne) => {
    switch (ne) {
      case "ArrowLeft":
        return q - 1;
      case "ArrowRight":
        return q + 1;
      case "ArrowUp":
        return q - kl;
      case "ArrowDown":
        return q + kl;
      case "Home":
        return y;
      case "End":
        return y + fn - 1;
      default:
        return null;
    }
  }, O = (q, ne) => {
    if (i)
      return;
    if (ne.key === "Enter" || ne.key === " ") {
      ne.preventDefault(), j(q);
      return;
    }
    const ee = H(q, ne.key);
    ee !== null && (ne.preventDefault(), (ee < y || ee > y + fn - 1) && I((ge) => ge + (ee < y ? -fn : fn)), F(ee), C.current.get(ee)?.focus());
  }, X = uf(g, b), K = cf(g, b);
  ve(() => {
    const q = pf(
      g,
      b,
      X,
      t,
      a,
      o,
      l
    ), ne = !hr(
      ci(g, b, q),
      a,
      o,
      l
    );
    let ee = 0;
    return S(q), !r || i ? f.current = !1 : !v && !f.current && (f.current = !0, ee = requestAnimationFrame(() => {
      ne ? E.current.get(q)?.focus() : M.current?.querySelector(Cl)?.focus();
    })), () => cancelAnimationFrame(ee);
  }, [
    g,
    b,
    X,
    t,
    a,
    o,
    l,
    r,
    i,
    v
  ]);
  const se = (q) => i || hr(ci(g, b, q), a, o, l), Y = (q, ne) => {
    for (let ee = q; ee >= 1 && ee <= X; ee += ne)
      if (!se(ee))
        return ee;
    return null;
  }, N = (q, ne) => {
    switch (ne) {
      case "ArrowLeft":
        return Y(q - 1, -1);
      case "ArrowRight":
        return Y(q + 1, 1);
      case "ArrowUp":
        return Y(q - zr, -zr);
      case "ArrowDown":
        return Y(q + zr, zr);
      case "Home":
        return Y(1, 1);
      case "End":
        return Y(X, -1);
      default:
        return null;
    }
  }, ue = (q, ne) => {
    if (i)
      return;
    if (ne.key === "PageUp" || ne.key === "PageDown") {
      ne.preventDefault(), f.current = !1;
      const ge = ne.key === "PageUp";
      ne.shiftKey && p ? p(ge ? g - 1 : g + 1) : ge ? c() : h();
      return;
    }
    const ee = N(q, ne.key);
    ee === null || ee === q || (ne.preventDefault(), S(ee), E.current.get(ee)?.focus());
  }, ie = (q) => ci(g, b, q) === t, V = (q) => {
    const ne = /* @__PURE__ */ new Date();
    return ne.getFullYear() === g && ne.getMonth() === b && ne.getDate() === q;
  }, de = (q) => {
    se(q) || u(ci(g, b, q));
  }, Se = (q, ne) => {
    (ne.key === "Enter" || ne.key === " ") && (ne.preventDefault(), de(q));
  }, W = (/* @__PURE__ */ new Date()).getFullYear();
  return /* @__PURE__ */ B("div", { ref: M, id: e, role: "dialog", "aria-label": "Date picker", "aria-modal": "true", className: z, children: [
    /* @__PURE__ */ B("div", { className: Ge["ds-date-picker__cal-header"], children: [
      v ? /* @__PURE__ */ B("span", { className: Ge["ds-date-picker__month-label"], children: [
        y,
        "-",
        y + fn - 1
      ] }) : /* @__PURE__ */ B("span", { className: Ge["ds-date-picker__month-label"], "aria-live": "polite", "aria-atomic": "true", children: [
        wl[b],
        " ",
        p ? /* @__PURE__ */ _(
          "button",
          {
            type: "button",
            className: Ge["ds-date-picker__year-btn"],
            disabled: i,
            "aria-label": `Select year, currently ${g}`,
            onClick: R,
            children: g
          }
        ) : g
      ] }),
      /* @__PURE__ */ B("div", { className: Ge.buttons, children: [
        /* @__PURE__ */ _(
          "button",
          {
            type: "button",
            className: Ge["ds-date-picker__nav-btn"],
            disabled: i,
            "aria-label": v ? "Previous years" : "Previous month",
            onClick: v ? () => I((q) => q - fn) : c,
            children: /* @__PURE__ */ _(ke, { name: J.KeyboardArrowLeft })
          }
        ),
        /* @__PURE__ */ _(
          "button",
          {
            type: "button",
            className: Ge["ds-date-picker__nav-btn"],
            disabled: i,
            "aria-label": v ? "Next years" : "Next month",
            onClick: v ? () => I((q) => q + fn) : h,
            children: /* @__PURE__ */ _(ke, { name: J.KeyboardArrowRight })
          }
        )
      ] })
    ] }),
    v ? (
      /* Year picker grid */
      /* @__PURE__ */ _("div", { role: "grid", "aria-label": "Year selection", className: Ge["ds-date-picker__year-grid"], children: Array.from({ length: fn }, (q, ne) => y + ne).map((q) => /* @__PURE__ */ _(
        "div",
        {
          ref: (ne) => {
            C.current.set(q, ne);
          },
          role: "gridcell",
          tabIndex: !i && q === L ? 0 : -1,
          "aria-selected": q === g,
          "aria-disabled": i ? !0 : void 0,
          className: Q(
            Ge["ds-date-picker__year-cell"],
            q === g && Ge["ds-date-picker__year-cell--selected"],
            q === W && q !== g && Ge["ds-date-picker__year-cell--current"]
          ),
          onClick: () => j(q),
          onKeyDown: (ne) => O(q, ne),
          children: q
        },
        q
      )) })
    ) : /* @__PURE__ */ B(Ke, { children: [
      /* @__PURE__ */ _("div", { className: Ge["ds-date-picker__day-names"], "aria-hidden": "true", children: hf.map((q) => /* @__PURE__ */ _("span", { className: Ge["ds-date-picker__day-name"], children: q }, q)) }),
      /* @__PURE__ */ B("div", { role: "grid", "aria-label": `${wl[b]} ${g}`, className: Ge["ds-date-picker__grid"], children: [
        Array.from({ length: K }).map((q, ne) => /* @__PURE__ */ _("div", { role: "gridcell", "aria-disabled": "true", className: Ge["ds-date-picker__day-cell"] }, `empty-${ne}`)),
        Array.from({ length: X }, (q, ne) => ne + 1).map((q) => /* @__PURE__ */ _(
          "div",
          {
            ref: (ne) => {
              E.current.set(q, ne);
            },
            role: "gridcell",
            tabIndex: se(q) ? -1 : q === P ? 0 : -1,
            ...!se(q) && q === P ? { [kc]: "" } : {},
            "aria-selected": ie(q),
            "aria-disabled": se(q) ? !0 : void 0,
            className: Q(
              Ge["ds-date-picker__day-cell"],
              V(q) && !se(q) && Ge["ds-date-picker__day-cell--today"],
              ie(q) && !se(q) && Ge["ds-date-picker__day-cell--selected"],
              se(q) && !ie(q) && !V(q) && Ge["ds-date-picker__day-cell--disabled"],
              ie(q) && se(q) && Ge["ds-date-picker__day-cell--selected-disabled"],
              V(q) && se(q) && Ge["ds-date-picker__day-cell--today-disabled"]
            ),
            onClick: () => de(q),
            onKeyDown: (ne) => {
              Se(q, ne), ue(q, ne);
            },
            children: q
          },
          q
        ))
      ] })
    ] })
  ] });
}
function Rs(e) {
  if (!e)
    return "";
  const t = e.split("-");
  if (t.length !== 3)
    return e;
  const [n, i, r] = t;
  return `${i}/${r}/${n}`;
}
function df(e) {
  const t = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(e.trim());
  if (!t)
    return null;
  const [, n, i, r] = t;
  return `${r}-${n}-${i}`;
}
function ff(e) {
  if (!e)
    return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(e))
    return e;
  const t = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(e.trim());
  return t ? `${t[3]}-${t[1].padStart(2, "0")}-${t[2].padStart(2, "0")}` : null;
}
const co = ({
  id: e,
  name: t,
  label: n,
  description: i,
  hint: r,
  state: a = Ne.Default,
  placeholder: o = "MM/DD/YYYY",
  disabled: l = !1,
  readOnly: u = !1,
  size: c = kt.Medium,
  required: h = !1,
  prefix: p,
  suffix: m,
  suffixCopy: g,
  tooltip: b,
  tooltipPlacement: v,
  width: w = we.Auto,
  className: y,
  value: I,
  defaultValue: E = null,
  onChange: P,
  minDate: S,
  maxDate: f,
  isDateDisabled: C,
  popupPlacement: L = "bottom-start"
}) => {
  const F = re(null), M = re(null), z = re(null), R = re(null), [j, H] = Ee(!1), [O, X] = Ee(""), K = at(), se = /* @__PURE__ */ new Date(), [Y, N] = Ee({
    year: se.getFullYear(),
    month: se.getMonth()
  }), [ue, ie] = Fn(I, E, P), V = ff(ue), { isOpen: de, open: Se, close: W } = zi({
    anchorRef: F,
    overlayRef: M,
    placement: L,
    disabled: l || u
  }), q = () => {
    H(!0), X(Rs(V));
  }, ne = () => {
    H(!1);
    const Ve = df(O);
    if (Ve) {
      ie(Ve);
      const [qe, De] = Ve.split("-").map(Number);
      N({ year: qe, month: De - 1 });
    } else
      ie(null);
  }, ee = (Ve) => {
    X(Ve);
  }, ge = re(null), te = () => {
    W(), (ge.current ?? R.current)?.focus();
  }, _e = re(!1);
  ve(() => {
    const Ve = document.activeElement, qe = Ve === document.body || M.current?.contains(Ve) === !0;
    _e.current && !de && qe && (ge.current ?? R.current)?.focus(), _e.current = de;
  }, [de]);
  const Te = (Ve) => {
    if (ge.current = Ve, V) {
      const [qe, De] = V.split("-").map(Number);
      N({ year: qe, month: De - 1 });
    }
    Se();
  }, Ye = () => {
    l || u || (de ? W() : Te(R.current));
  }, ot = (Ve) => {
    ie(Ve), te(), X(Rs(Ve));
  }, Ze = (Ve) => {
    l || u || Ve.key === "ArrowDown" && !de && (Ve.preventDefault(), Te(z.current));
  }, ht = () => {
    N((Ve) => {
      const qe = new Date(Ve.year, Ve.month - 1);
      return { year: qe.getFullYear(), month: qe.getMonth() };
    });
  }, Oe = () => {
    N((Ve) => {
      const qe = new Date(Ve.year, Ve.month + 1);
      return { year: qe.getFullYear(), month: qe.getMonth() };
    });
  }, ft = (Ve) => {
    N((qe) => ({ ...qe, year: Ve }));
  }, Ct = j ? O : Rs(V), St = [i ? `${e}-description` : null, r ? `${e}-hint` : null].filter(Boolean).join(" ") || void 0;
  return /* @__PURE__ */ B(
    "div",
    {
      className: Q(
        Ge["ds-date-picker-field"],
        w !== we.Auto && Ge[`ds-date-picker-field--width-${w}`],
        y
      ),
      children: [
        /* @__PURE__ */ _(
          Qn,
          {
            id: e,
            label: n,
            description: i,
            hint: r,
            state: a,
            required: h,
            disabled: l,
            tooltip: b,
            tooltipPlacement: v,
            suffixCopy: g,
            children: /* @__PURE__ */ _("div", { ref: F, className: Ge["ds-date-picker-field__trigger-wrap"], children: /* @__PURE__ */ B(
              Bn,
              {
                isFocused: j || de,
                disabled: l,
                readOnly: u,
                state: a,
                size: c,
                prefix: p,
                suffix: m,
                inputRef: z,
                className: Ge["ds-date-picker-field__chrome"],
                children: [
                  /* @__PURE__ */ _(
                    "span",
                    {
                      ref: R,
                      className: Ge["ds-date-picker-field__calendar-trigger"],
                      role: "button",
                      tabIndex: l || u ? -1 : 0,
                      "aria-label": "Open calendar",
                      "aria-expanded": de,
                      "aria-controls": de ? K : void 0,
                      onClick: Ye,
                      onKeyDown: (Ve) => {
                        (Ve.key === "Enter" || Ve.key === " ") && (Ve.preventDefault(), Ye());
                      },
                      children: /* @__PURE__ */ _(ke, { name: J.CalendarToday, "aria-hidden": "true" })
                    }
                  ),
                  /* @__PURE__ */ _(
                    zn,
                    {
                      ref: z,
                      id: e,
                      name: t,
                      value: Ct,
                      placeholder: o,
                      type: ct.Text,
                      disabled: l,
                      readOnly: u,
                      required: h,
                      ariaDescribedBy: St,
                      ariaInvalid: a === Ne.Error,
                      autoComplete: "off",
                      onChange: ee,
                      onFocus: q,
                      onBlur: ne,
                      onKeyDown: Ze
                    }
                  )
                ]
              }
            ) })
          }
        ),
        /* @__PURE__ */ _(
          ji,
          {
            id: K,
            ref: M,
            anchorRef: F,
            isOpen: de && !l && !u,
            placement: L,
            children: /* @__PURE__ */ _(
              Sc,
              {
                id: `${K}-panel`,
                selectedIso: V,
                calState: Y,
                minDate: S,
                maxDate: f,
                isDateDisabled: C,
                focusGrid: de && !l && !u,
                onSelectDay: ot,
                onPrevMonth: ht,
                onNextMonth: Oe,
                onSelectYear: ft,
                onEscape: te
              }
            )
          }
        )
      ]
    }
  );
}, Xn = {
  "ds-time-picker-field": "_ds-time-picker-field_1b8bw_1",
  "ds-time-picker-field--width-full": "_ds-time-picker-field--width-full_1b8bw_6",
  "ds-time-picker-field--width-sm": "_ds-time-picker-field--width-sm_1b8bw_9",
  "ds-time-picker-field--width-md": "_ds-time-picker-field--width-md_1b8bw_12",
  "ds-time-picker-field--width-lg": "_ds-time-picker-field--width-lg_1b8bw_15",
  "ds-time-picker-field__trigger-wrap": "_ds-time-picker-field__trigger-wrap_1b8bw_18",
  "ds-time-picker__list": "_ds-time-picker__list_1b8bw_22",
  "ds-time-picker__slot": "_ds-time-picker__slot_1b8bw_30",
  "ds-time-picker__slot--disabled": "_ds-time-picker__slot--disabled_1b8bw_39",
  "ds-time-picker__slot--selected": "_ds-time-picker__slot--selected_1b8bw_46"
};
function pr(e) {
  const t = /^(\d{1,2}):(\d{2})$/.exec(e.trim());
  if (!t)
    return -1;
  const n = parseInt(t[1], 10), i = parseInt(t[2], 10);
  return n < 0 || n > 23 || i < 0 || i > 59 ? -1 : n * 60 + i;
}
function Sl(e) {
  const t = Math.floor(e / 60), n = e % 60;
  return `${String(t).padStart(2, "0")}:${String(n).padStart(2, "0")}`;
}
function Ec(e) {
  const t = pr(e);
  if (t === -1)
    return e;
  const n = Math.floor(t / 60), i = t % 60, r = n >= 12 ? "PM" : "AM", a = n % 12 === 0 ? 12 : n % 12;
  return `${String(a).padStart(2, "0")}:${String(i).padStart(2, "0")} ${r}`;
}
function mf({
  id: e,
  slots: t,
  selectedValue: n,
  minTime: i,
  maxTime: r,
  onSelect: a
}) {
  const o = i ? pr(i) : -1, l = r ? pr(r) : 1 / 0;
  return /* @__PURE__ */ _("ul", { id: e, role: "listbox", "aria-label": "Select a time", className: Xn["ds-time-picker__list"], children: t.map((u) => {
    const c = pr(u), h = o !== -1 && c < o || c > l, p = u === n;
    return /* @__PURE__ */ _(
      "li",
      {
        id: `${e}-${u}`,
        role: "option",
        "aria-selected": p,
        "aria-disabled": h ? !0 : void 0,
        className: Q(
          Xn["ds-time-picker__slot"],
          p && Xn["ds-time-picker__slot--selected"],
          h && Xn["ds-time-picker__slot--disabled"]
        ),
        onClick: h ? void 0 : () => a(u),
        onKeyDown: h ? void 0 : (m) => {
          (m.key === "Enter" || m.key === " ") && (m.preventDefault(), a(u));
        },
        tabIndex: h ? -1 : 0,
        children: Ec(u)
      },
      u
    );
  }) });
}
const ho = ({
  id: e,
  name: t,
  label: n,
  description: i,
  hint: r,
  state: a = Ne.Default,
  placeholder: o = "HH:mm",
  disabled: l = !1,
  readOnly: u = !1,
  size: c = kt.Medium,
  required: h = !1,
  prefix: p,
  suffixCopy: m,
  tooltip: g,
  tooltipPlacement: b,
  width: v = we.Auto,
  className: w,
  value: y,
  defaultValue: I = null,
  onChange: E,
  minuteStep: P = 15,
  minTime: S,
  maxTime: f,
  popupPlacement: C = "bottom-start"
}) => {
  const L = re(null), F = re(null), M = re(null), [z, R] = Ee(!1), [j, H] = Ee(""), O = at(), [X, K] = Fn(y, I, E), se = $e(() => {
    const ee = Math.max(1, Math.min(60, P)), ge = [];
    for (let te = 0; te < 1440; te += ee)
      ge.push(Sl(te));
    return ge;
  }, [P]), { isOpen: Y, open: N, close: ue } = zi({
    anchorRef: L,
    overlayRef: F,
    placement: C,
    disabled: l || u
  }), ie = () => {
    R(!0), H(X ?? "");
  }, V = () => {
    R(!1);
    const ee = pr(j);
    K(ee !== -1 ? Sl(ee) : null), H(X ?? "");
  }, de = (ee) => {
    H(ee);
  }, Se = () => {
    l || u || (Y ? ue() : N());
  }, W = (ee) => {
    K(ee), H(ee), ue();
  }, q = z ? j : Ec(X ?? ""), ne = [i ? `${e}-description` : null, r ? `${e}-hint` : null].filter(Boolean).join(" ") || void 0;
  return /* @__PURE__ */ B(
    "div",
    {
      className: Q(
        Xn["ds-time-picker-field"],
        v !== we.Auto && Xn[`ds-time-picker-field--width-${v}`],
        w
      ),
      children: [
        /* @__PURE__ */ _(
          Qn,
          {
            id: e,
            label: n,
            description: i,
            hint: r,
            state: a,
            required: h,
            disabled: l,
            tooltip: g,
            tooltipPlacement: b,
            suffixCopy: m,
            children: /* @__PURE__ */ _("div", { ref: L, className: Xn["ds-time-picker-field__trigger-wrap"], children: /* @__PURE__ */ _(
              Bn,
              {
                isFocused: z || Y,
                disabled: l,
                readOnly: u,
                state: a,
                size: c,
                prefix: p,
                suffix: J.SwapHoriz,
                onSuffixClick: Se,
                inputRef: M,
                className: Xn["ds-time-picker-field__chrome"],
                children: /* @__PURE__ */ _(
                  zn,
                  {
                    ref: M,
                    id: e,
                    name: t,
                    value: q,
                    placeholder: o,
                    type: ct.Text,
                    disabled: l,
                    readOnly: u,
                    required: h,
                    ariaDescribedBy: ne,
                    ariaInvalid: a === Ne.Error,
                    ariaExpanded: Y,
                    ariaControls: Y ? O : void 0,
                    autoComplete: "off",
                    onChange: de,
                    onFocus: ie,
                    onBlur: V
                  }
                )
              }
            ) })
          }
        ),
        /* @__PURE__ */ _(
          ji,
          {
            id: O,
            ref: F,
            anchorRef: L,
            isOpen: Y && !l && !u,
            placement: C,
            children: /* @__PURE__ */ _(
              mf,
              {
                id: `${O}-list`,
                slots: se,
                selectedValue: X,
                minTime: S,
                maxTime: f,
                onSelect: W
              }
            )
          }
        )
      ]
    }
  );
}, tr = {
  "ds-entity-picker-field": "_ds-entity-picker-field_1pcr2_1",
  "ds-entity-picker-field--width-full": "_ds-entity-picker-field--width-full_1pcr2_6",
  "ds-entity-picker-field--width-sm": "_ds-entity-picker-field--width-sm_1pcr2_9",
  "ds-entity-picker-field--width-md": "_ds-entity-picker-field--width-md_1pcr2_12",
  "ds-entity-picker-field--width-lg": "_ds-entity-picker-field--width-lg_1pcr2_15",
  "ds-entity-picker-field__trigger-wrap": "_ds-entity-picker-field__trigger-wrap_1pcr2_18",
  "ds-entity-picker__loading": "_ds-entity-picker__loading_1pcr2_22",
  "ds-entity-picker-pulse": "_ds-entity-picker-pulse_1pcr2_1"
};
function gf(e, t) {
  const n = re(null);
  return pe(
    (...i) => {
      n.current !== null && clearTimeout(n.current), n.current = setTimeout(() => e(...i), t);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e, t]
  );
}
function po({
  id: e,
  name: t,
  label: n,
  description: i,
  hint: r,
  state: a = Ne.Default,
  placeholder: o = "Search...",
  disabled: l = !1,
  readOnly: u = !1,
  size: c = kt.Medium,
  required: h = !1,
  prefix: p,
  suffix: m = J.KeyboardArrowDown,
  suffixCopy: g,
  tooltip: b,
  tooltipPlacement: v,
  width: w = we.Auto,
  className: y,
  value: I,
  defaultValue: E = null,
  onChange: P,
  onSearch: S,
  initialOptions: f,
  getOptionLabel: C,
  loadingText: L = "Searching...",
  noResultsText: F = "No results found",
  minSearchLength: M = 1,
  debounceMs: z = 300,
  popupPlacement: R = "bottom-start"
}) {
  const j = re(null), H = re(null), O = re(null), X = re(!1), [K, se] = Ee(!1), [Y, N] = Ee(""), [ue, ie] = Ee([]), [V, de] = Ee(!1), [Se, W] = Ee(null), q = re(0), ne = at(), [ee, ge] = Fn(I, E, P), { isOpen: te, open: _e, close: Te } = zi({
    anchorRef: j,
    overlayRef: H,
    placement: R,
    disabled: l || u
  }), Ye = ee != null && Y === C(ee), ot = Y.trim() === "" || Ye, Ze = Y.trim() === "" ? f ?? ue : ue, ht = (() => {
    if (Se !== null)
      return [Se];
    if (ee == null)
      return [];
    const le = C(ee), yt = Ze.find(
      (qt) => C(qt.value) === le
    );
    return yt ? [yt.id] : [];
  })(), Oe = re(!1);
  ve(() => {
    Oe.current || l || u || (f?.length ?? 0) > 0 && ee == null && (Oe.current = !0, _e());
  }, []);
  const ft = pe(
    async (le, { force: yt = !1 } = {}) => {
      if (!yt && le.trim().length < M) {
        ie([]);
        return;
      }
      const qt = ++q.current;
      de(!0);
      try {
        const In = await S(le);
        qt === q.current && ie(In);
      } catch {
        qt === q.current && ie([]);
      } finally {
        qt === q.current && de(!1);
      }
    },
    [S, M]
  ), Ct = gf(ft, z);
  ve(() => {
    !te || !ot || V || (f?.length ?? 0) > 0 || ue.length > 0 || ft("", { force: !0 });
  }, [te, ot]);
  const { activeId: St, clearActiveId: Ve, handleInputKeyDown: qe, onOptionRef: De } = Er({
    options: Ze,
    isOpen: te,
    onOpen: _e,
    onClose: Te,
    onSelect: (le) => {
      ge(le.value), N(C(le.value)), W(le.id), Te(), Ve(), X.current = !0, O.current?.focus();
    }
  }), An = (le) => {
    if (N(le), le.trim() === "") {
      ge(null), W(null), ie([]), q.current += 1, de(!1);
      return;
    }
    te || _e(), Ct(le);
  }, Z = (le) => {
    ge(le.value), N(C(le.value)), W(le.id), Te(), Ve(), X.current = !0, O.current?.focus();
  }, G = () => {
    if (se(!0), X.current) {
      X.current = !1;
      return;
    }
    ee != null && N(C(ee));
  }, T = () => {
    se(!1), ee != null ? N(C(ee)) : N("");
  }, Ce = () => {
    te ? Te() : (_e(), O.current?.focus());
  }, Je = [i ? `${e}-description` : null, r ? `${e}-hint` : null].filter(Boolean).join(" ") || void 0, ut = K ? Y : ee != null ? C(ee) : "";
  return /* @__PURE__ */ B(
    "div",
    {
      className: Q(
        tr["ds-entity-picker-field"],
        w !== we.Auto && tr[`ds-entity-picker-field--width-${w}`],
        y
      ),
      children: [
        /* @__PURE__ */ _(
          Qn,
          {
            id: e,
            label: n,
            description: i,
            hint: r,
            state: a,
            required: h,
            disabled: l,
            tooltip: b,
            tooltipPlacement: v,
            suffixCopy: g,
            children: /* @__PURE__ */ _("div", { ref: j, className: tr["ds-entity-picker-field__trigger-wrap"], children: /* @__PURE__ */ _(
              Bn,
              {
                isFocused: K || te,
                disabled: l,
                readOnly: u,
                state: a,
                size: c,
                prefix: p,
                suffix: m,
                onSuffixClick: l || u ? void 0 : Ce,
                suffixAriaLabel: te ? "Close options" : "Open options",
                inputRef: O,
                className: tr["ds-entity-picker-field__chrome"],
                children: /* @__PURE__ */ _(
                  zn,
                  {
                    ref: O,
                    id: e,
                    name: t,
                    value: ut,
                    placeholder: o,
                    type: ct.Text,
                    disabled: l,
                    readOnly: u,
                    required: h,
                    role: "combobox",
                    ariaExpanded: te,
                    ariaControls: ne,
                    ariaActivedescendant: St ?? void 0,
                    ariaDescribedBy: Je,
                    ariaInvalid: a === Ne.Error,
                    autoComplete: "off",
                    onChange: An,
                    onFocus: G,
                    onBlur: T,
                    onKeyDown: qe
                  }
                )
              }
            ) })
          }
        ),
        /* @__PURE__ */ _(
          ji,
          {
            id: ne,
            ref: H,
            anchorRef: j,
            isOpen: te && !l && !u,
            placement: R,
            minWidth: "anchor",
            children: V ? /* @__PURE__ */ _("div", { className: tr["ds-entity-picker__loading"], role: "status", "aria-live": "polite", "aria-busy": "true", children: L }) : /* @__PURE__ */ _(
              Ar,
              {
                id: `${ne}-list`,
                options: Ze,
                selectedIds: ht,
                activeId: St,
                mode: "single",
                ariaLabel: n,
                emptyText: Y.trim().length < M ? `Type at least ${M} character${M === 1 ? "" : "s"} to search` : F,
                onActivate: Z,
                onOptionRef: De
              }
            )
          }
        )
      ]
    }
  );
}
const gt = {
  "ds-textarea-field": "_ds-textarea-field_nzkva_1",
  "ds-textarea-field__label-row": "_ds-textarea-field__label-row_nzkva_17",
  "ds-textarea-field__label": "_ds-textarea-field__label_nzkva_17",
  "ds-textarea-field__required": "_ds-textarea-field__required_nzkva_32",
  "ds-textarea-field__help-trigger": "_ds-textarea-field__help-trigger_nzkva_35",
  "ds-textarea-field__counter": "_ds-textarea-field__counter_nzkva_52",
  "ds-textarea-field__counter--exceeded": "_ds-textarea-field__counter--exceeded_nzkva_59",
  "ds-textarea-field__description": "_ds-textarea-field__description_nzkva_63",
  "ds-textarea-field__chrome": "_ds-textarea-field__chrome_nzkva_69",
  "ds-textarea-field__chrome--focused": "_ds-textarea-field__chrome--focused_nzkva_77",
  "ds-textarea-field__chrome--state-error": "_ds-textarea-field__chrome--state-error_nzkva_81",
  "ds-textarea-field__chrome--state-warning": "_ds-textarea-field__chrome--state-warning_nzkva_88",
  "ds-textarea-field__chrome--state-success": "_ds-textarea-field__chrome--state-success_nzkva_95",
  "ds-textarea-field__chrome--disabled": "_ds-textarea-field__chrome--disabled_nzkva_102",
  "ds-textarea-field__chrome--readonly": "_ds-textarea-field__chrome--readonly_nzkva_107",
  "ds-textarea-field__textarea": "_ds-textarea-field__textarea_nzkva_110",
  "ds-textarea-field__textarea--size-large": "_ds-textarea-field__textarea--size-large_nzkva_129",
  "ds-textarea-field__textarea--size-medium": "_ds-textarea-field__textarea--size-medium_nzkva_134",
  "ds-textarea-field__textarea--size-small": "_ds-textarea-field__textarea--size-small_nzkva_139",
  "ds-textarea-field__hint": "_ds-textarea-field__hint_nzkva_144",
  "ds-textarea-field__hint--error": "_ds-textarea-field__hint--error_nzkva_150",
  "ds-textarea-field__hint--warning": "_ds-textarea-field__hint--warning_nzkva_153",
  "ds-textarea-field__hint--success": "_ds-textarea-field__hint--success_nzkva_156",
  "ds-textarea-field--disabled": "_ds-textarea-field--disabled_nzkva_159",
  "ds-textarea-field--width-full": "_ds-textarea-field--width-full_nzkva_167",
  "ds-textarea-field--width-sm": "_ds-textarea-field--width-sm_nzkva_170",
  "ds-textarea-field--width-md": "_ds-textarea-field--width-md_nzkva_173",
  "ds-textarea-field--width-lg": "_ds-textarea-field--width-lg_nzkva_176"
}, _f = ({
  id: e,
  name: t,
  ref: n,
  label: i,
  description: r,
  hint: a,
  state: o = Ne.Default,
  placeholder: l,
  disabled: u = !1,
  readOnly: c = !1,
  size: h = kt.Medium,
  required: p = !1,
  tooltip: m,
  tooltipPlacement: g,
  width: b = we.Auto,
  className: v,
  value: w,
  defaultValue: y = "",
  onChange: I,
  onBlur: E,
  onFocus: P,
  rows: S = 4,
  maxLength: f,
  minLength: C,
  showCounter: L = !1
}) => {
  const F = re(null), [M, z] = Ee(!1), R = re(null), j = at(), [H, O] = Fn(w, y, I), X = f !== void 0 && H.length > f, K = [r ? `${e}-description` : null, a ? `${e}-hint` : null].filter(Boolean).join(" ") || void 0, se = () => {
    z(!0), P?.();
  }, Y = (N) => {
    z(!1), E?.(N.target.value);
  };
  return /* @__PURE__ */ B(
    "div",
    {
      className: Q(
        gt["ds-textarea-field"],
        u && gt["ds-textarea-field--disabled"],
        b !== we.Auto && gt[`ds-textarea-field--width-${b}`],
        v
      ),
      children: [
        i && /* @__PURE__ */ B("div", { className: gt["ds-textarea-field__label-row"], children: [
          /* @__PURE__ */ B("label", { htmlFor: e, className: gt["ds-textarea-field__label"], children: [
            i,
            p && /* @__PURE__ */ _("span", { className: gt["ds-textarea-field__required"], "aria-hidden": "true", children: " *" })
          ] }),
          m && /* @__PURE__ */ B(Ke, { children: [
            /* @__PURE__ */ _(
              "span",
              {
                ref: R,
                className: gt["ds-textarea-field__help-trigger"],
                role: "img",
                "aria-label": `More information about ${i}`,
                children: /* @__PURE__ */ _(ke, { name: J.Help, "aria-hidden": "true" })
              }
            ),
            /* @__PURE__ */ _(
              cn,
              {
                id: j,
                content: m,
                anchorRef: R,
                placement: g
              }
            )
          ] }),
          L && f !== void 0 && /* @__PURE__ */ B(
            "span",
            {
              className: Q(
                gt["ds-textarea-field__counter"],
                X && gt["ds-textarea-field__counter--exceeded"]
              ),
              "aria-label": `${H.length} of ${f} characters used`,
              "aria-live": "polite",
              children: [
                H.length,
                "/",
                f
              ]
            }
          )
        ] }),
        r && /* @__PURE__ */ _("p", { id: `${e}-description`, className: gt["ds-textarea-field__description"], children: r }),
        /* @__PURE__ */ _(
          "div",
          {
            className: Q(
              gt["ds-textarea-field__chrome"],
              o !== Ne.Default && gt[`ds-textarea-field__chrome--state-${o}`],
              M && gt["ds-textarea-field__chrome--focused"],
              u && gt["ds-textarea-field__chrome--disabled"],
              c && gt["ds-textarea-field__chrome--readonly"]
            ),
            onClick: () => {
              !u && !c && F.current?.focus();
            },
            children: /* @__PURE__ */ _(
              "textarea",
              {
                ref: (N) => {
                  F.current = N, typeof n == "function" ? n(N) : n && (n.current = N);
                },
                id: e,
                name: t,
                value: H,
                placeholder: l,
                disabled: u,
                readOnly: c,
                rows: S,
                maxLength: f,
                minLength: C,
                required: p,
                "aria-describedby": K,
                "aria-invalid": o === Ne.Error || void 0,
                "aria-required": p || void 0,
                className: Q(
                  gt["ds-textarea-field__textarea"],
                  gt[`ds-textarea-field__textarea--size-${h}`]
                ),
                onChange: (N) => O(N.target.value),
                onFocus: se,
                onBlur: Y
              }
            )
          }
        ),
        a && /* @__PURE__ */ _(
          "p",
          {
            id: `${e}-hint`,
            className: Q(
              gt["ds-textarea-field__hint"],
              o !== Ne.Default && gt[`ds-textarea-field__hint--${o}`]
            ),
            role: o === Ne.Error ? "alert" : void 0,
            "aria-live": o === Ne.Error ? "polite" : void 0,
            children: a
          }
        )
      ]
    }
  );
}, Os = {
  "ns-avatar": "_ns-avatar_p5k4g_1",
  "ns-avatar--agent": "_ns-avatar--agent_p5k4g_15",
  "ns-avatar__initials": "_ns-avatar__initials_p5k4g_26"
};
function xf({ imageUrl: e, iconName: t, name: n, size: i = 28, isAries: r }) {
  const a = Q({
    [Os["ns-avatar"]]: !0,
    [Os["ns-avatar--agent"]]: r
  }), o = n ? n.trim().slice(0, 1).toUpperCase() : "";
  return /* @__PURE__ */ _("div", { className: a, style: { width: i, height: i, minWidth: i }, "aria-hidden": "true", children: e ? /* @__PURE__ */ _("img", { src: e, alt: "" }) : t ? /* @__PURE__ */ _(ke, { name: t, size: Math.round(i * 0.65) }) : /* @__PURE__ */ _("span", { className: Os["ns-avatar__initials"], children: o }) });
}
const yf = "data:image/svg+xml,%3csvg%20width='187'%20height='34'%20viewBox='0%200%20187%2034'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Group'%3e%3cpath%20id='Vector'%20d='M181.447%2034H4.81359C2.16515%2034%200%2031.8691%200%2029.2625V4.73755C0%202.13095%202.16515%200%204.81359%200H181.447C184.096%200%20186.261%202.13095%20186.261%204.73755V29.2625C186.261%2031.8691%20184.115%2034%20181.447%2034ZM4.81359%200.894236C2.66777%200.894236%200.90859%202.62563%200.90859%204.73755V29.2625C0.90859%2031.3744%202.66777%2033.1058%204.81359%2033.1058H181.447C183.593%2033.1058%20185.352%2031.3744%20185.352%2029.2625V4.73755C185.352%202.62563%20183.593%200.894236%20181.447%200.894236H4.81359Z'%20fill='%230067D2'/%3e%3cg%20id='Group_2'%3e%3cpath%20id='Vector_2'%20d='M53.8193%2019.2927H50.4555L49.8369%2020.967H48.7737L51.5574%2013.4517H52.7173L55.4818%2020.967H54.4185L53.8193%2019.2927ZM53.5293%2018.4746L52.1374%2014.6503L50.7455%2018.4746H53.5293Z'%20fill='%230067D2'/%3e%3c/g%3e%3cg%20id='Group_3'%3e%3cpath%20id='Vector_3'%20d='M131.494%2017.1996C131.049%2017.6181%20130.392%2017.8274%20129.503%2017.8274H128.033V20.9858H127.009V13.4133H129.483C130.353%2013.4133%20131.01%2013.6226%20131.455%2014.0412C131.9%2014.4598%20132.132%2014.9925%20132.132%2015.6394C132.151%2016.2482%20131.919%2016.781%20131.494%2017.1996ZM130.72%2016.6478C130.991%2016.4005%20131.126%2016.077%20131.126%2015.6204C131.126%2014.6881%20130.585%2014.2315%20129.503%2014.2315H128.033V17.0093H129.503C130.044%2017.0093%20130.45%2016.8761%20130.72%2016.6478Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_4'%20d='M135.148%2015.2018C135.476%2015.0115%20135.863%2014.9164%20136.346%2014.9164V15.9438H136.076C134.955%2015.9438%20134.394%2016.5526%20134.394%2017.7513V20.9858H133.389V15.0305H134.394V16.0009C134.568%2015.6584%20134.819%2015.392%20135.148%2015.2018Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_5'%20d='M138.589%2020.6814C138.125%2020.434%20137.777%2020.0725%20137.506%2019.5969C137.255%2019.1212%20137.12%2018.5885%20137.12%2017.9796C137.12%2017.3708%20137.255%2016.838%20137.526%2016.3624C137.796%2015.8867%20138.164%2015.5442%20138.627%2015.2969C139.091%2015.0496%20139.613%2014.9164%20140.174%2014.9164C140.735%2014.9164%20141.257%2015.0496%20141.721%2015.2969C142.185%2015.5442%20142.552%2015.9057%20142.822%2016.3624C143.093%2016.819%20143.228%2017.3708%20143.228%2017.9796C143.228%2018.5885%20143.093%2019.1402%20142.822%2019.5969C142.552%2020.0725%20142.165%2020.415%20141.701%2020.6814C141.237%2020.9287%20140.715%2021.0619%20140.135%2021.0619C139.555%2021.0619%20139.053%2020.9477%20138.589%2020.6814ZM141.141%2019.9584C141.45%2019.7871%20141.721%2019.5398%20141.914%2019.2163C142.107%2018.8929%20142.204%2018.4743%20142.204%2017.9986C142.204%2017.523%20142.107%2017.1234%20141.914%2016.781C141.721%2016.4575%20141.469%2016.2102%20141.16%2016.0389C140.851%2015.8677%20140.522%2015.7916%20140.155%2015.7916C139.787%2015.7916%20139.459%2015.8677%20139.149%2016.0389C138.84%2016.2102%20138.608%2016.4575%20138.415%2016.781C138.241%2017.1234%20138.144%2017.523%20138.144%2017.9986C138.144%2018.4743%20138.241%2018.8929%20138.415%2019.2163C138.589%2019.5398%20138.84%2019.7871%20139.13%2019.9584C139.439%2020.1296%20139.768%2020.2057%20140.116%2020.2057C140.483%2020.2057%20140.831%2020.1106%20141.141%2019.9584Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_6'%20d='M144.544%2016.3815C144.795%2015.9249%20145.143%2015.5634%20145.569%2015.316C146.013%2015.0687%20146.497%2014.9355%20147.038%2014.9355C147.502%2014.9355%20147.946%2015.0497%20148.352%2015.259C148.758%2015.4683%20149.068%2015.7537%20149.28%2016.0961V12.9568H150.286V20.9859H149.28V19.8633C149.087%2020.2248%20148.797%2020.5102%20148.391%2020.7385C148.004%2020.9669%20147.54%2021.081%20147.019%2021.081C146.477%2021.081%20145.994%2020.9478%20145.569%2020.7005C145.124%2020.4341%20144.795%2020.0726%20144.544%2019.597C144.293%2019.1213%20144.177%2018.5886%20144.177%2017.9988C144.177%2017.3709%20144.293%2016.8382%20144.544%2016.3815ZM149.01%2016.8191C148.836%2016.4957%20148.584%2016.2293%20148.275%2016.0581C147.966%2015.8868%20147.618%2015.7917%20147.251%2015.7917C146.883%2015.7917%20146.535%2015.8868%20146.226%2016.0581C145.917%2016.2293%20145.665%2016.4767%20145.491%2016.8191C145.317%2017.1426%20145.221%2017.5421%20145.221%2017.9988C145.221%2018.4554%20145.317%2018.8549%20145.491%2019.1784C145.685%2019.5209%20145.917%2019.7682%20146.226%2019.9394C146.535%2020.1107%20146.883%2020.2058%20147.251%2020.2058C147.618%2020.2058%20147.966%2020.1107%20148.275%2019.9394C148.584%2019.7682%20148.836%2019.5018%20149.01%2019.1784C149.203%2018.8359%20149.28%2018.4554%20149.28%2017.9988C149.28%2017.5421%20149.184%2017.1426%20149.01%2016.8191Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_7'%20d='M157.339%2015.0308V20.967H156.334V20.0918C156.14%2020.3962%20155.87%2020.6245%20155.541%2020.7957C155.193%2020.967%20154.826%2021.0431%20154.42%2021.0431C153.956%2021.0431%20153.531%2020.9479%20153.144%2020.7577C152.777%2020.5674%20152.467%2020.282%20152.255%2019.9015C152.042%2019.521%20151.926%2019.0453%20151.926%2018.4935V15.0308H152.912V18.3794C152.912%2018.9692%20153.067%2019.4068%20153.357%2019.7303C153.666%2020.0537%20154.072%2020.2059%20154.594%2020.2059C155.135%2020.2059%20155.56%2020.0347%20155.87%2019.7112C156.179%2019.3878%20156.334%2018.9121%20156.334%2018.2843V15.0308H157.339Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_8'%20d='M159.042%2016.3814C159.294%2015.9248%20159.642%2015.5633%20160.086%2015.316C160.531%2015.0686%20161.034%2014.9354%20161.613%2014.9354C162.348%2014.9354%20162.967%2015.1067%20163.45%2015.4682C163.933%2015.8297%20164.243%2016.3053%20164.397%2016.9332H163.315C163.218%2016.5717%20163.005%2016.2863%20162.715%2016.077C162.425%2015.8677%20162.058%2015.7536%20161.613%2015.7536C161.034%2015.7536%20160.57%2015.9438%20160.222%2016.3243C159.874%2016.7049%20159.7%2017.2566%20159.7%2017.9606C159.7%2018.6836%20159.874%2019.2354%20160.222%2019.6159C160.57%2019.9964%20161.034%2020.2057%20161.613%2020.2057C162.058%2020.2057%20162.425%2020.1106%20162.715%2019.9013C163.005%2019.692%20163.218%2019.4066%20163.315%2019.0261H164.397C164.243%2019.6349%20163.914%2020.1106%20163.431%2020.4911C162.947%2020.8526%20162.348%2021.0429%20161.613%2021.0429C161.034%2021.0429%20160.531%2020.9097%20160.086%2020.6623C159.642%2020.415%20159.294%2020.0535%20159.042%2019.5969C158.791%2019.1402%20158.675%2018.5885%20158.675%2017.9796C158.656%2017.3708%20158.791%2016.8381%20159.042%2016.3814Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_9'%20d='M166.947%2015.8489V19.3498C166.947%2019.6352%20167.005%2019.8444%20167.14%2019.9586C167.256%2020.0728%20167.488%2020.1298%20167.797%2020.1298H168.532V20.967H167.623C167.063%2020.967%20166.637%2020.8338%20166.367%2020.5865C166.096%2020.3391%20165.941%2019.9205%20165.941%2019.3307V15.8489H165.168V15.0308H165.941V13.5277H166.947V15.0308H168.512V15.8489H166.947Z'%20fill='%230067D2'/%3e%3c/g%3e%3cg%20id='Group_4'%3e%3cpath%20id='Vector_10'%20opacity='0.5'%20d='M93.4102%2020.967L90.2784%2013.6609L89.6405%2015.164L92.1343%2020.967H93.4102Z'%20fill='%230067D2'/%3e%3cg%20id='Group_5'%3e%3cg%20id='Group_6'%3e%3cpath%20id='Vector_11'%20d='M59.5029%2013.718H60.8368L63.002%2017.1428L65.1671%2013.718H66.501V20.967H65.2444V15.7729L62.9826%2019.1976H62.944L60.7402%2015.7919V20.967H59.5029V13.718Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_12'%20d='M68.8391%2013.7179H70.0957V20.9669H68.8391V13.7179Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_13'%20d='M74.0597%2014.8975H71.7979V13.7179H77.5974V14.8975H75.3356V20.9669H74.079V14.8975H74.0597Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_14'%20d='M83.4736%2018.2271C84.4595%2017.9418%2085.1748%2017.2188%2085.1748%2016.0391V16.0201C85.1748%2015.3922%2084.9621%2014.8405%2084.5755%2014.4599C84.1115%2014.0033%2083.4156%2013.7369%2082.507%2013.7369H79.3173V20.986H80.5738V18.4364H82.1397L83.8795%2020.9479L84.4402%2019.6351L83.4736%2018.2271ZM80.5738%2017.3139V14.8785H82.391C83.3189%2014.8785%2083.8795%2015.2971%2083.8795%2016.0772V16.0962C83.8795%2016.8382%2083.2996%2017.3139%2082.4103%2017.3139H80.5738Z'%20fill='%230067D2'/%3e%3c/g%3e%3cg%20id='Group_7'%3e%3cpath%20id='Vector_15'%20d='M95.7491%2014.8976H93.4873V13.718H99.2868V14.8976H97.025V20.967H95.7684V14.8976H95.7491Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_16'%20d='M101.007%2013.718H106.304V14.8596H102.263V16.7432H105.84V17.8848H102.263V19.8255H106.362V20.967H101.007V13.718Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_17'%20d='M107.831%2017.352V17.333C107.831%2015.2782%20109.359%2013.5848%20111.524%2013.5848C112.838%2013.5848%20113.631%2014.0415%20114.327%2014.7074L113.515%2015.6587C112.935%2015.126%20112.336%2014.7645%20111.524%2014.7645C110.171%2014.7645%20109.165%2015.906%20109.165%2017.314V17.333C109.165%2018.76%20110.151%2019.9016%20111.524%2019.9016C112.394%2019.9016%20112.954%2019.5401%20113.573%2018.9693L114.385%2019.8064C113.631%2020.5865%20112.819%2021.0812%20111.485%2021.0812C109.378%2021.0812%20107.831%2019.4449%20107.831%2017.352Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_18'%20d='M116.183%2013.718H117.44V16.7242H120.842V13.718H122.098V20.967H120.842V17.9038H117.44V20.967H116.183V13.718Z'%20fill='%230067D2'/%3e%3c/g%3e%3cpath%20id='Vector_19'%20d='M90.279%2013.6609H89.0031L85.8521%2020.967H87.1473L90.279%2013.6609Z'%20fill='%230067D2'/%3e%3c/g%3e%3c/g%3e%3cg%20id='Group_8'%3e%3cpath%20id='Vector_20'%20d='M33.3655%200.551514H5.00589C2.45411%200.551514%200.38562%202.58733%200.38562%205.0988V28.9007C0.38562%2031.4122%202.45411%2033.448%205.00589%2033.448H33.3655V0.551514ZM22.965%2025.9326L16.6629%2011.2443L10.3414%2025.9326H7.09372L15.039%207.47709H18.2868L26.2321%2025.9326H22.965Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_21'%20opacity='0.5'%20d='M16.6439%2011.2442L18.8864%206.06909L27.7403%2026.6746H16.6439V11.2442Z'%20fill='%230067D2'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", bf = {
  "loa-badge": "_loa-badge_dop88_1"
};
function vf({ label: e = "A MITRATECH Product", badge: t = yf, onClick: n }) {
  const i = Q({
    [bf["loa-badge"]]: !0
  });
  return /* @__PURE__ */ _("button", { "aria-label": e, title: e, id: "logo-badge", className: i, onClick: () => n?.(), children: /* @__PURE__ */ _("img", { "aria-label": e, src: t }) });
}
var lt = /* @__PURE__ */ ((e) => (e.Contained = "contained", e.Outlined = "outlined", e.Text = "text", e))(lt || {}), wf = /* @__PURE__ */ ((e) => (e.Text = "text", e.Link = "link", e.Icon = "icon", e.Bool = "bool", e.List = "list", e))(wf || {});
const Tt = {
  "ds-badge": "_ds-badge_1b8mi_1",
  "ds-badge__contained": "_ds-badge__contained_1b8mi_16",
  "ds-badge__contained-primary": "_ds-badge__contained-primary_1b8mi_20",
  "ds-badge__contained-secondary": "_ds-badge__contained-secondary_1b8mi_24",
  "ds-badge__contained-info": "_ds-badge__contained-info_1b8mi_28",
  "ds-badge__contained-success": "_ds-badge__contained-success_1b8mi_32",
  "ds-badge__contained-warning": "_ds-badge__contained-warning_1b8mi_36",
  "ds-badge__contained-error": "_ds-badge__contained-error_1b8mi_40",
  "ds-badge__outlined": "_ds-badge__outlined_1b8mi_44",
  "ds-badge__outlined-primary": "_ds-badge__outlined-primary_1b8mi_48",
  "ds-badge__outlined-secondary": "_ds-badge__outlined-secondary_1b8mi_53",
  "ds-badge__outlined-info": "_ds-badge__outlined-info_1b8mi_58",
  "ds-badge__outlined-success": "_ds-badge__outlined-success_1b8mi_63",
  "ds-badge__outlined-warning": "_ds-badge__outlined-warning_1b8mi_68",
  "ds-badge__outlined-error": "_ds-badge__outlined-error_1b8mi_73"
};
var Ea = /* @__PURE__ */ ((e) => (e.Contained = "contained", e.Outlined = "outlined", e))(Ea || {});
function kf({
  text: e,
  variant: t = Ea.Contained,
  color: n = Re.Primary
}) {
  const i = t === Ea.Contained, r = n === Re.Primary, a = n === Re.Secondary, o = n === Re.Error, l = n === Re.Info, u = n === Re.Success, c = n === Re.Warning, h = Q({
    // root class
    [Tt["ds-badge"]]: !0,
    // contained variants
    [Tt["ds-badge__contained"]]: i,
    [Tt["ds-badge__contained-primary"]]: i && r,
    [Tt["ds-badge__contained-secondary"]]: i && a,
    [Tt["ds-badge__contained-info"]]: i && l,
    [Tt["ds-badge__contained-success"]]: i && u,
    [Tt["ds-badge__contained-warning"]]: i && c,
    [Tt["ds-badge__contained-error"]]: i && o,
    // outlined variants
    [Tt["ds-badge__outlined"]]: !i,
    [Tt["ds-badge__outlined-primary"]]: !i && r,
    [Tt["ds-badge__outlined-secondary"]]: !i && a,
    [Tt["ds-badge__outlined-info"]]: !i && l,
    [Tt["ds-badge__outlined-success"]]: !i && u,
    [Tt["ds-badge__outlined-warning"]]: !i && c,
    [Tt["ds-badge__outlined-error"]]: !i && o
  });
  return /* @__PURE__ */ _("span", { className: h, children: e });
}
const Cf = "ds-contextual-menu-layer", Sf = 4, Ef = 8, Af = {
  "bottom-start": ["top-start", "bottom-end", "top-end"],
  "bottom-end": ["top-end", "bottom-start", "top-start"],
  "top-start": ["bottom-start", "top-end", "bottom-end"],
  "top-end": ["bottom-end", "top-start", "bottom-start"]
}, wt = {
  "ds-contextual-menu": "_ds-contextual-menu_18wig_1",
  "ds-contextual-menu--closed": "_ds-contextual-menu--closed_18wig_29",
  "ds-contextual-menu--open": "_ds-contextual-menu--open_18wig_32",
  "ds-contextual-menu__list": "_ds-contextual-menu__list_18wig_53",
  "ds-contextual-menu__item": "_ds-contextual-menu__item_18wig_62",
  "ds-contextual-menu__button--disabled": "_ds-contextual-menu__button--disabled_18wig_77",
  "ds-contextual-menu__button": "_ds-contextual-menu__button_18wig_77",
  "ds-contextual-menu__label": "_ds-contextual-menu__label_18wig_107",
  "ds-contextual-menu__prefix": "_ds-contextual-menu__prefix_18wig_110",
  "ds-contextual-menu__suffix": "_ds-contextual-menu__suffix_18wig_110",
  "ds-contextual-menu__content": "_ds-contextual-menu__content_18wig_113",
  "ds-contextual-menu__header": "_ds-contextual-menu__header_18wig_152",
  "ds-contextual-menu__divider": "_ds-contextual-menu__divider_18wig_163"
}, wi = {
  "ds-checkbox": "_ds-checkbox_1dx76_1",
  "ds-checkbox--disabled": "_ds-checkbox--disabled_1dx76_7",
  "ds-checkbox--width-full": "_ds-checkbox--width-full_1dx76_12",
  "ds-checkbox--width-sm": "_ds-checkbox--width-sm_1dx76_15",
  "ds-checkbox--width-md": "_ds-checkbox--width-md_1dx76_18",
  "ds-checkbox--width-lg": "_ds-checkbox--width-lg_1dx76_21",
  "ds-checkbox__input": "_ds-checkbox__input_1dx76_24",
  "ds-checkbox--size-small": "_ds-checkbox--size-small_1dx76_78",
  "ds-checkbox--size-medium": "_ds-checkbox--size-medium_1dx76_88",
  "ds-checkbox__label": "_ds-checkbox__label_1dx76_92"
};
var Hi = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(Hi || {});
const $i = ({
  id: e,
  label: t,
  checked: n,
  indeterminate: i = !1,
  disabled: r = !1,
  size: a = Hi.Medium,
  width: o = we.Auto,
  onChange: l,
  className: u
}) => {
  const c = re(null);
  ve(() => {
    c.current && (c.current.indeterminate = i);
  }, [i]);
  const h = Q(
    wi["ds-checkbox"],
    wi[`ds-checkbox--size-${a}`],
    r && wi["ds-checkbox--disabled"],
    o !== we.Auto && wi[`ds-checkbox--width-${o}`],
    u
  );
  return /* @__PURE__ */ B("span", { className: h, children: [
    /* @__PURE__ */ _(
      "input",
      {
        ref: c,
        id: e,
        type: "checkbox",
        className: wi["ds-checkbox__input"],
        checked: n,
        disabled: r,
        "aria-checked": i ? "mixed" : n,
        onChange: (p) => l(p.target.checked)
      }
    ),
    t && /* @__PURE__ */ _("label", { htmlFor: e, className: wi["ds-checkbox__label"], children: t })
  ] });
};
function If({ item: e, onActivate: t, onRef: n }) {
  const i = re(null), r = (m) => {
    i.current = m, n(e.id, m);
  }, a = e.type === "checkbox", o = (m) => {
    if (e.disabled) {
      m.preventDefault();
      return;
    }
    if (e.type === "checkbox") {
      e.onChange(!e.checked), t(e.id);
      return;
    }
    e.onClick?.(), t(e.id);
  }, l = (m) => {
    e.type === "anchor" && m.key === " " && (m.preventDefault(), m.currentTarget.click());
  }, u = Q(wt["ds-contextual-menu__button"], e.disabled && wt["ds-contextual-menu__button--disabled"]), c = {
    "data-item-id": e.id,
    role: a ? "menuitemcheckbox" : "menuitem",
    tabIndex: -1,
    "aria-disabled": e.disabled ? !0 : void 0,
    "aria-checked": a ? e.checked : void 0,
    className: u,
    onClick: o,
    onKeyDown: l
  }, h = /* @__PURE__ */ B("span", { className: wt["ds-contextual-menu__content"], children: [
    e.prefix && /* @__PURE__ */ _(ke, { className: wt["ds-contextual-menu__prefix"], name: e.prefix, "aria-hidden": "true" }),
    /* @__PURE__ */ _("span", { className: wt["ds-contextual-menu__label"], children: e.label }),
    a ? (
      // aria-hidden: the <button> already carries role=menuitemcheckbox +
      // aria-checked, so the visual Checkbox is purely decorative here.
      /* @__PURE__ */ _("span", { className: wt["ds-contextual-menu__suffix"], "aria-hidden": "true", children: /* @__PURE__ */ _(
        $i,
        {
          id: `ds-cm-checkbox-${e.id}`,
          label: "",
          checked: e.checked,
          size: Hi.Medium,
          onChange: () => {
          }
        }
      ) })
    ) : "suffix" in e && e.suffix && /* @__PURE__ */ _(ke, { className: wt["ds-contextual-menu__suffix"], name: e.suffix, "aria-hidden": "true" })
  ] }), p = e.type === "anchor" ? /* @__PURE__ */ _(
    "a",
    {
      ref: r,
      href: e.disabled ? void 0 : e.href,
      target: e.target,
      rel: e.target === Mn.Blank ? "noopener noreferrer" : void 0,
      ...c,
      children: h
    }
  ) : /* @__PURE__ */ _("button", { ref: r, type: "button", ...c, children: h });
  return /* @__PURE__ */ B("li", { role: "presentation", className: wt["ds-contextual-menu__item"], children: [
    p,
    e.tooltip && /* @__PURE__ */ _(
      cn,
      {
        id: `ds-cm-item-tooltip-${e.id}`,
        content: e.tooltip,
        anchorRef: i,
        placement: e.tooltipPlacement ?? "right"
      }
    )
  ] });
}
function El(e, t, n, i) {
  switch (n) {
    case "bottom-start":
      return {
        x: e.left,
        y: e.bottom + i
      };
    case "bottom-end":
      return {
        x: e.right + i,
        y: e.top
      };
    case "top-start":
      return {
        x: e.left,
        y: e.top - t.height - i
      };
    case "top-end":
      return {
        x: e.right + i,
        y: e.bottom - t.height
      };
  }
}
function Lf(e, t, n, i, r) {
  const { viewportPaddingPx: a, flip: o } = r;
  let l = n, u = El(e, t, n, i);
  if (o && !Fi(u.x, u.y, t.width, t.height, a))
    for (const h of Af[n]) {
      const p = El(e, t, h, i);
      if (Fi(p.x, p.y, t.width, t.height, a)) {
        l = h, u = p;
        break;
      }
    }
  const c = ro(u.x, u.y, t.width, t.height, a);
  return { x: c.x, y: c.y, resolvedPlacement: l };
}
const Kn = ({
  id: e,
  items: t = [],
  content: n,
  anchorRef: i,
  label: r = "Menu",
  placement: a = "bottom-start",
  offsetPx: o = Sf,
  collision: l,
  disabled: u = !1,
  layerId: c = Cf,
  className: h,
  onItemClick: p,
  onShow: m,
  onHide: g
}) => {
  const b = n !== void 0, v = at(), w = e ?? v, [y, I] = Ee(!1), E = re(null), P = re(null), S = re({
    x: 0,
    y: 0,
    resolvedPlacement: a
  }), f = re(!1);
  ve(() => {
    f.current = y;
  }, [y]);
  const C = re(null), L = {
    viewportPaddingPx: l?.viewportPaddingPx ?? Ef,
    flip: l?.flip ?? !0
  }, F = $e(
    () => t.filter(
      (W) => W.type !== "divider" && W.type !== "header"
    ),
    [t]
  ), M = re(/* @__PURE__ */ new Map()), z = pe((W, q) => {
    M.current.set(W, q);
  }, []), R = pe(() => {
    const W = F[0];
    W && M.current.get(W.id)?.focus();
  }, [F]), j = pe(() => {
    const W = F[F.length - 1];
    W && M.current.get(W.id)?.focus();
  }, [F]), H = pe(
    (W) => {
      const q = F.findIndex((ge) => ge.id === W), ne = q === -1 ? 0 : (q + 1) % F.length, ee = F[ne];
      ee && M.current.get(ee.id)?.focus();
    },
    [F]
  ), O = pe(
    (W) => {
      const q = F.findIndex((ge) => ge.id === W), ne = q <= 0 ? F.length - 1 : q - 1, ee = F[ne];
      ee && M.current.get(ee.id)?.focus();
    },
    [F]
  ), X = pe(() => {
    P.current !== null && (cancelAnimationFrame(P.current), P.current = null);
  }, []), K = pe(() => {
    const W = i.current, q = E.current;
    if (!W || !q)
      return;
    const ne = W.getBoundingClientRect(), ee = q.getBoundingClientRect(), ge = Lf(ne, ee, a, o, L);
    S.current = ge, q.style.setProperty("--_x", `${ge.x}px`), q.style.setProperty("--_y", `${ge.y}px`), q.dataset.placement = ge.resolvedPlacement;
  }, [i, a, o, L.viewportPaddingPx, L.flip]), se = pe(() => {
    X(), P.current = requestAnimationFrame(() => {
      K();
    });
  }, [X, K]), Y = pe(() => {
    I(!1);
  }, []), N = pe((W = "first") => {
    C.current = W, I(!0);
  }, []);
  ve(() => {
    u && Y();
  }, [u, Y]);
  const ue = re(!1);
  ve(() => {
    if (!ue.current) {
      ue.current = !0;
      return;
    }
    y ? m?.() : g?.();
  }, [y, m, g]);
  const ie = pe(
    (W) => {
      p?.(W), t.find((ne) => ne.type !== "divider" && ne.id === W)?.type !== "checkbox" && (Y(), i.current?.focus());
    },
    [p, t, Y, i]
  );
  no(() => {
    if (!y)
      return;
    K();
    const W = C.current;
    W !== null && (C.current = null, W === "first" ? R() : j());
  }, [y, K, R, j]), ve(() => {
    const W = i.current;
    if (!(!W || u))
      return W.setAttribute("aria-haspopup", b ? "dialog" : "menu"), W.setAttribute("aria-controls", w), W.setAttribute("aria-expanded", "false"), () => {
        W.removeAttribute("aria-haspopup"), W.removeAttribute("aria-controls"), W.removeAttribute("aria-expanded");
      };
  }, [i, w, u, b]), ve(() => {
    const W = i.current;
    !W || u || W.setAttribute("aria-expanded", y ? "true" : "false");
  }, [i, y, u]), ve(() => {
    const W = i.current;
    if (!W || u)
      return;
    const q = () => {
      f.current ? Y() : N("first");
    }, ne = (ee) => {
      f.current || (ee.key === "Enter" || ee.key === " " || ee.key === "ArrowDown" ? (ee.preventDefault(), N("first")) : ee.key === "ArrowUp" && (ee.preventDefault(), N("last")));
    };
    return W.addEventListener("click", q), W.addEventListener("keydown", ne), () => {
      W.removeEventListener("click", q), W.removeEventListener("keydown", ne);
    };
  }, [i, u, N, Y]);
  const V = pe(
    (W) => {
      const q = document.activeElement?.dataset.itemId;
      switch (W.key) {
        case "ArrowDown":
          W.preventDefault(), q ? H(q) : R();
          break;
        case "ArrowUp":
          W.preventDefault(), q ? O(q) : j();
          break;
        case "Home":
          W.preventDefault(), R();
          break;
        case "End":
          W.preventDefault(), j();
          break;
        case "Escape":
          W.preventDefault(), Y(), i.current?.focus();
          break;
        case "Tab":
          Y();
          break;
      }
    },
    [H, O, R, j, Y, i]
  );
  ve(() => {
    if (!y)
      return;
    const W = (q) => {
      const ne = i.current, ee = E.current;
      ne?.contains(q.target) || ee?.contains(q.target) || Y();
    };
    return document.addEventListener("pointerdown", W, { capture: !0 }), () => {
      document.removeEventListener("pointerdown", W, { capture: !0 });
    };
  }, [y, i, Y]), ve(() => {
    if (!y || u) {
      X();
      return;
    }
    const W = () => se(), q = () => se();
    return window.addEventListener("scroll", W, { capture: !0, passive: !0 }), window.addEventListener("resize", q, { passive: !0 }), () => {
      window.removeEventListener("scroll", W, { capture: !0 }), window.removeEventListener("resize", q), X();
    };
  }, [y, u, se, X]), ve(() => {
    const W = i.current;
    if (!W || !y || u)
      return;
    const q = new ResizeObserver(() => {
      se();
    });
    return q.observe(W), E.current && q.observe(E.current), () => q.disconnect();
  }, [i, y, u, se]), ve(() => () => {
    X();
  }, [X]);
  const de = y && !u ? "open" : "closed", Se = fi(c);
  return di(
    /* @__PURE__ */ _(
      "div",
      {
        ref: E,
        className: Q(
          wt["ds-contextual-menu"],
          wt[`ds-contextual-menu--${de}`],
          h
        ),
        "data-state": de,
        children: b ? /* @__PURE__ */ _(
          "div",
          {
            id: w,
            role: "dialog",
            "aria-label": r,
            "aria-hidden": de === "closed",
            className: wt["ds-contextual-menu__list"],
            onKeyDown: (W) => {
              W.key === "Escape" && (W.preventDefault(), Y(), i.current?.focus());
            },
            children: n
          }
        ) : /* @__PURE__ */ _(
          "ul",
          {
            id: w,
            role: "menu",
            "aria-label": r,
            "aria-hidden": de === "closed",
            className: wt["ds-contextual-menu__list"],
            onKeyDown: V,
            children: t.map((W) => W.type === "divider" ? /* @__PURE__ */ _(
              "li",
              {
                role: "separator",
                "aria-orientation": "horizontal",
                className: wt["ds-contextual-menu__divider"]
              },
              W.id
            ) : W.type === "header" ? /* @__PURE__ */ _("li", { role: "presentation", className: wt["ds-contextual-menu__header"], children: /* @__PURE__ */ B("span", { className: wt["ds-contextual-menu__content"], children: [
              W.prefix && /* @__PURE__ */ _(ke, { className: wt["ds-contextual-menu__prefix"], name: W.prefix, "aria-hidden": "true" }),
              /* @__PURE__ */ _("span", { className: wt["ds-contextual-menu__label"], children: W.label })
            ] }) }, W.id) : /* @__PURE__ */ _(If, { item: W, onActivate: ie, onRef: z }, W.id))
          }
        )
      }
    ),
    Se
  );
}, ki = {
  "user-badge": "_user-badge_1jsb6_1",
  "user-badge__text": "_user-badge__text_1jsb6_6",
  "user-badge__title": "_user-badge__title_1jsb6_13",
  "user-badge__subtitle": "_user-badge__subtitle_1jsb6_24",
  "user-badge__email": "_user-badge__email_1jsb6_35",
  "user-badge__trigger": "_user-badge__trigger_1jsb6_46"
}, dr = (e, t) => e.find((n) => n.role === t), es = (e, t) => {
  if (t) {
    if (t.render)
      return t.render(e);
    if (t.key !== void 0)
      return e[t.key];
  }
}, Al = (e, t) => {
  const n = es(e, t);
  return typeof n == "string" ? n : "";
}, Pf = (e, t) => {
  const n = Al(e, dr(t, "title")).trim();
  if (n) {
    const r = n.split(/\s+/).filter(Boolean);
    if (r.length >= 2)
      return `${r[0][0]}${r[r.length - 1][0]}`.toUpperCase();
    if (r.length === 1 && r[0].length > 0)
      return r[0][0].toUpperCase();
  }
  const i = Al(e, dr(t, "email")).trim();
  return i ? (i.split("@")[0] ?? "").split(/[._-]/).filter(Boolean).slice(0, 2).map((o) => o[0].toUpperCase()).join("") : "";
};
function e5({
  "aria-label": e,
  id: t,
  entity: n,
  columns: i = [],
  getInitials: r,
  menuHeaderLabel: a,
  menuHeaderIcon: o,
  links: l = [],
  actions: u = [],
  onAction: c
}) {
  const h = re(null), p = at(), m = t ?? p, g = (r?.(n) ?? Pf(n, i)).trim(), b = es(n, dr(i, "title")), v = es(n, dr(i, "subtitle")), w = es(n, dr(i, "email")), y = b !== void 0 || v !== void 0 || w !== void 0, I = typeof b == "string" ? b.trim() : "", E = e ?? (I ? `Open menu for ${I}` : "Open user menu"), P = $e(() => {
    const f = [], C = a?.trim();
    C && f.push({
      type: "header",
      id: `${m}-header`,
      label: C,
      prefix: o
    });
    const L = l.map((z) => ({
      type: "anchor",
      id: `${m}-link-${z.id}`,
      label: z.label,
      href: z.href,
      target: z.target,
      prefix: z.prefix
    })), F = u.map((z) => ({
      type: "button",
      id: `${m}-action-${z.name}`,
      label: z.text ?? z.title ?? z.name,
      prefix: z.prefix ?? z.icon,
      tooltip: z.tooltip,
      tooltipPlacement: z.tooltipPlacement,
      disabled: z.disabled,
      onClick: () => c?.(z)
    }));
    return L.length > 0 || F.length > 0 ? (f.length > 0 && f.push({ type: "divider", id: `${m}-divider` }), [...f, ...L, ...F]) : [];
  }, [a, o, l, u, c, m]), S = P.length > 0;
  return /* @__PURE__ */ B("div", { className: ki["user-badge"], children: [
    y && /* @__PURE__ */ B("div", { className: ki["user-badge__text"], children: [
      b && /* @__PURE__ */ _("span", { className: ki["user-badge__title"], children: b }),
      v && /* @__PURE__ */ _("span", { className: ki["user-badge__subtitle"], children: v }),
      w && /* @__PURE__ */ _("span", { className: ki["user-badge__email"], children: w })
    ] }),
    /* @__PURE__ */ _(
      "button",
      {
        ref: h,
        type: "button",
        id: `${m}-trigger`,
        "aria-label": E,
        className: ki["user-badge__trigger"],
        disabled: !S,
        children: g
      }
    ),
    S && /* @__PURE__ */ _(
      Kn,
      {
        id: `${m}-menu`,
        label: typeof b == "string" ? b : "User menu",
        anchorRef: h,
        items: P,
        placement: "top-end"
      }
    )
  ] });
}
const Rt = {
  "ds-button": "_ds-button_10q1q_11",
  "ds-button__content": "_ds-button__content_10q1q_27",
  "ds-button__prefix": "_ds-button__prefix_10q1q_40",
  "ds-button__suffix": "_ds-button__suffix_10q1q_40",
  "ds-button__prefix--animated": "_ds-button__prefix--animated_10q1q_47",
  "ds-button-aries-pulse": "_ds-button-aries-pulse_10q1q_1",
  "ds-button__label": "_ds-button__label_10q1q_62",
  "ds-button__icon": "_ds-button__icon_10q1q_68",
  "ds-button--variant-contained": "_ds-button--variant-contained_10q1q_73",
  "ds-button--disabled": "_ds-button--disabled_10q1q_79",
  "ds-button--variant-outlined": "_ds-button--variant-outlined_10q1q_91",
  "ds-button--variant-text": "_ds-button--variant-text_10q1q_114",
  "ds-button--color-primary": "_ds-button--color-primary_10q1q_134",
  "ds-button--color-secondary": "_ds-button--color-secondary_10q1q_157",
  "ds-button--color-info": "_ds-button--color-info_10q1q_180",
  "ds-button--color-success": "_ds-button--color-success_10q1q_203",
  "ds-button--color-warning": "_ds-button--color-warning_10q1q_226",
  "ds-button--color-error": "_ds-button--color-error_10q1q_249",
  "ds-button--size-large": "_ds-button--size-large_10q1q_272",
  "ds-button--size-medium": "_ds-button--size-medium_10q1q_281",
  "ds-button--size-small": "_ds-button--size-small_10q1q_290",
  "ds-button--icon-only": "_ds-button--icon-only_10q1q_299",
  "ds-button--icon-only--size-large": "_ds-button--icon-only--size-large_10q1q_306",
  "ds-button--icon-only--size-medium": "_ds-button--icon-only--size-medium_10q1q_309",
  "ds-button--icon-only--size-small": "_ds-button--icon-only--size-small_10q1q_312"
}, Il = (...e) => e.filter(Boolean).join(" "), Tf = {
  [Mt.Large]: 24,
  [Mt.Medium]: 20,
  [Mt.Small]: 18
}, st = (e) => {
  const {
    id: t,
    name: n,
    ref: i,
    text: r,
    label: a,
    tooltip: o,
    tooltipPlacement: l,
    color: u = Re.Primary,
    variant: c = lt.Contained,
    size: h = Mt.Medium,
    icon: p,
    prefix: m,
    animatedPrefix: g = !1,
    suffix: b,
    disabled: v = !1,
    isIconOnly: w = !1,
    type: y = "button",
    onClick: I,
    className: E,
    ...P
  } = e, S = re(null), f = P["aria-busy"], L = v || (f === !0 || f === "true"), M = P["aria-label"] ?? (r && r.trim().length > 0 ? void 0 : a), z = p !== void 0, R = (K) => {
    if (L) {
      K.preventDefault(), K.stopPropagation();
      return;
    }
    I?.(K);
  }, j = Tf[h], H = !!m, O = !!b, X = !!(r && r.trim().length > 0);
  return /* @__PURE__ */ B(
    "button",
    {
      id: t,
      ref: Bi(S, i),
      name: n,
      type: y,
      className: Il(
        Rt["ds-button"],
        Rt[`ds-button--variant-${c}`],
        Rt[`ds-button--color-${u}`],
        Rt[`ds-button--size-${h}`],
        w && Rt["ds-button--icon-only"],
        w && Rt[`ds-button--icon-only--size-${h}`],
        L && Rt["ds-button--disabled"],
        E
      ),
      "aria-label": M,
      "aria-disabled": L || void 0,
      disabled: L,
      ...P,
      onClick: R,
      children: [
        /* @__PURE__ */ B("span", { className: Rt["ds-button__content"], children: [
          H && /* @__PURE__ */ _(
            "span",
            {
              className: Il(Rt["ds-button__prefix"], g && Rt["ds-button__prefix--animated"]),
              children: /* @__PURE__ */ _(ke, { className: Rt["ds-button__icon"], "aria-hidden": "true", name: m, size: j, color: "currentColor" })
            }
          ),
          X && /* @__PURE__ */ _("span", { className: Rt["ds-button__label"], children: r }),
          z && /* @__PURE__ */ _(ke, { "aria-hidden": "true", name: p, size: j, color: "currentColor" }),
          O && /* @__PURE__ */ _("span", { className: Rt["ds-button__suffix"], children: /* @__PURE__ */ _(ke, { className: Rt["ds-button__icon"], "aria-hidden": "true", name: b, size: j, color: "currentColor" }) })
        ] }),
        o && /* @__PURE__ */ _(
          cn,
          {
            id: `tooltip-${a}`,
            content: o,
            anchorRef: S,
            placement: l,
            disabled: v
          }
        )
      ]
    }
  );
}, zt = {
  "ds-radio": "_ds-radio_vxb0h_1",
  "ds-radio--label-start": "_ds-radio--label-start_vxb0h_7",
  "ds-radio--disabled": "_ds-radio--disabled_vxb0h_10",
  "ds-radio--width-full": "_ds-radio--width-full_vxb0h_15",
  "ds-radio--width-sm": "_ds-radio--width-sm_vxb0h_18",
  "ds-radio--width-md": "_ds-radio--width-md_vxb0h_21",
  "ds-radio--width-lg": "_ds-radio--width-lg_vxb0h_24",
  "ds-radio__input": "_ds-radio__input_vxb0h_27",
  "ds-radio--size-small": "_ds-radio--size-small_vxb0h_64",
  "ds-radio--size-medium": "_ds-radio--size-medium_vxb0h_68",
  "ds-radio__label": "_ds-radio__label_vxb0h_72",
  "ds-radio-group": "_ds-radio-group_vxb0h_83",
  "ds-radio-group__label": "_ds-radio-group__label_vxb0h_89",
  "ds-radio-group__options": "_ds-radio-group__options_vxb0h_100",
  "ds-radio-group__options--horizontal": "_ds-radio-group__options--horizontal_vxb0h_105",
  "ds-radio-group__helper": "_ds-radio-group__helper_vxb0h_110",
  "ds-radio-group--error": "_ds-radio-group--error_vxb0h_115",
  "ds-radio-group--disabled": "_ds-radio-group--disabled_vxb0h_121"
};
var fo = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(fo || {});
const Nf = ({
  id: e,
  name: t,
  value: n,
  label: i,
  checked: r,
  onChange: a,
  disabled: o = !1,
  size: l = fo.Medium,
  labelPlacement: u = "end",
  width: c = we.Auto,
  className: h
}) => {
  const p = Q(
    zt["ds-radio"],
    zt[`ds-radio--size-${l}`],
    o && zt["ds-radio--disabled"],
    u === "start" && zt["ds-radio--label-start"],
    c !== we.Auto && zt[`ds-radio--width-${c}`],
    h
  );
  return /* @__PURE__ */ B("span", { className: p, children: [
    /* @__PURE__ */ _(
      "input",
      {
        id: e,
        type: "radio",
        name: t,
        value: n,
        className: zt["ds-radio__input"],
        checked: r,
        disabled: o,
        onChange: (m) => {
          m.target.checked && a(n);
        }
      }
    ),
    i && /* @__PURE__ */ _("label", { htmlFor: e, className: zt["ds-radio__label"], children: i })
  ] });
};
function Df({
  name: e,
  options: t,
  value: n,
  onChange: i,
  label: r,
  helperText: a,
  error: o = !1,
  disabled: l = !1,
  orientation: u = "vertical",
  size: c = fo.Medium,
  id: h,
  className: p
}) {
  const m = at(), g = h ?? e ?? m, b = `${g}-label`, v = `${g}-helper`, w = Q(
    zt["ds-radio-group"],
    o && zt["ds-radio-group--error"],
    l && zt["ds-radio-group--disabled"],
    p
  ), y = Q(zt["ds-radio-group__options"], {
    [zt["ds-radio-group__options--horizontal"]]: u === "horizontal"
  });
  return /* @__PURE__ */ B(
    "div",
    {
      role: "radiogroup",
      "aria-labelledby": r ? b : void 0,
      "aria-describedby": a ? v : void 0,
      "aria-invalid": o || void 0,
      className: w,
      children: [
        r && /* @__PURE__ */ _("span", { id: b, className: zt["ds-radio-group__label"], children: r }),
        /* @__PURE__ */ _("div", { className: y, children: t.map((I) => /* @__PURE__ */ _(
          Nf,
          {
            id: `${g}-${I.value}`,
            name: e,
            value: I.value,
            label: I.label,
            checked: n === I.value,
            disabled: l || I.disabled,
            size: c,
            onChange: (E) => i(E)
          },
          I.value
        )) }),
        a && /* @__PURE__ */ _("span", { id: v, className: zt["ds-radio-group__helper"], children: a })
      ]
    }
  );
}
const qn = {
  "ds-segmented-control": "_ds-segmented-control_ks8gt_1",
  "ds-segmented-control--disabled": "_ds-segmented-control--disabled_ks8gt_7",
  "ds-segmented-control__label": "_ds-segmented-control__label_ks8gt_10",
  "ds-segmented-control__options": "_ds-segmented-control__options_ks8gt_18",
  "ds-segmented-control__option": "_ds-segmented-control__option_ks8gt_18",
  "ds-segmented-control__input": "_ds-segmented-control__input_ks8gt_29",
  "ds-segmented-control__segment": "_ds-segmented-control__segment_ks8gt_39",
  "ds-segmented-control__options--size-small": "_ds-segmented-control__options--size-small_ks8gt_61",
  "ds-segmented-control__options--size-medium": "_ds-segmented-control__options--size-medium_ks8gt_69"
};
var Ac = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(Ac || {});
function t5({
  name: e,
  options: t,
  value: n,
  onChange: i,
  label: r,
  "aria-label": a,
  disabled: o = !1,
  size: l = Ac.Medium,
  id: u,
  className: c
}) {
  const h = at(), p = u ?? e ?? h, m = `${p}-label`, g = Q(
    qn["ds-segmented-control"],
    o && qn["ds-segmented-control--disabled"],
    c
  ), b = Q(qn["ds-segmented-control__options"], qn[`ds-segmented-control__options--size-${l}`]);
  return /* @__PURE__ */ B("div", { className: g, children: [
    r && /* @__PURE__ */ _("span", { id: m, className: qn["ds-segmented-control__label"], children: r }),
    /* @__PURE__ */ _(
      "div",
      {
        role: "radiogroup",
        "aria-labelledby": r ? m : void 0,
        "aria-label": r ? void 0 : a ?? e,
        className: b,
        children: t.map((v) => {
          const w = `${p}-${v.value}`;
          return /* @__PURE__ */ B("span", { className: qn["ds-segmented-control__option"], children: [
            /* @__PURE__ */ _(
              "input",
              {
                id: w,
                type: "radio",
                name: e,
                value: v.value,
                checked: n === v.value,
                disabled: o || v.disabled,
                className: qn["ds-segmented-control__input"],
                onChange: (y) => {
                  y.target.checked && i(v.value);
                }
              }
            ),
            /* @__PURE__ */ _("label", { htmlFor: w, className: qn["ds-segmented-control__segment"], children: v.label })
          ] }, v.value);
        })
      }
    )
  ] });
}
const Vf = {
  "ns-link": "_ns-link_148zc_1"
};
function Ir({ url: e, target: t, title: n, ariaLabel: i, id: r, className: a, text: o, icon: l, children: u }) {
  const c = t === Mn.Blank, h = u !== void 0 ? void 0 : l ?? (c ? J.Launch : void 0);
  return /* @__PURE__ */ _(
    "a",
    {
      id: r,
      href: e,
      target: t,
      rel: c ? "noopener noreferrer" : void 0,
      title: n,
      "aria-label": i ?? n,
      className: Q(Vf["ns-link"], a),
      children: u ?? /* @__PURE__ */ B(Ke, { children: [
        o,
        h !== void 0 && /* @__PURE__ */ _(ke, { name: h })
      ] })
    }
  );
}
const Ll = {
  "ns-visually-hidden": "_ns-visually-hidden_ppm9o_1"
};
function Ic({ as: e = "span", className: t, children: n, ...i }) {
  const r = t ? `${Ll["ns-visually-hidden"]} ${t}` : Ll["ns-visually-hidden"];
  return /* @__PURE__ */ _(e, { className: r, ...i, children: n });
}
const vt = {
  "ds-chip": "_ds-chip_dobiv_1",
  "ds-chip__icon": "_ds-chip__icon_dobiv_13",
  "ds-chip__dismiss": "_ds-chip__dismiss_dobiv_18",
  "ds-chip__contained": "_ds-chip__contained_dobiv_51",
  "ds-chip__contained-primary": "_ds-chip__contained-primary_dobiv_55",
  "ds-chip__contained-secondary": "_ds-chip__contained-secondary_dobiv_66",
  "ds-chip__contained-info": "_ds-chip__contained-info_dobiv_78",
  "ds-chip__contained-success": "_ds-chip__contained-success_dobiv_89",
  "ds-chip__contained-warning": "_ds-chip__contained-warning_dobiv_100",
  "ds-chip__contained-error": "_ds-chip__contained-error_dobiv_111",
  "ds-chip__outlined": "_ds-chip__outlined_dobiv_122",
  "ds-chip__outlined-primary": "_ds-chip__outlined-primary_dobiv_126",
  "ds-chip__outlined-secondary": "_ds-chip__outlined-secondary_dobiv_138",
  "ds-chip__outlined-info": "_ds-chip__outlined-info_dobiv_150",
  "ds-chip__outlined-success": "_ds-chip__outlined-success_dobiv_162",
  "ds-chip__outlined-warning": "_ds-chip__outlined-warning_dobiv_174",
  "ds-chip__outlined-error": "_ds-chip__outlined-error_dobiv_186"
};
var yr = /* @__PURE__ */ ((e) => (e.Contained = "contained", e.Outlined = "outlined", e))(yr || {});
const hi = ({
  id: e,
  label: t,
  text: n,
  variant: i = yr.Contained,
  color: r = Re.Primary,
  className: a,
  prefix: o,
  suffix: l,
  interactive: u = !1,
  ref: c,
  onDismiss: h,
  onClick: p
}) => {
  const m = u || p !== void 0, g = i === yr.Contained, b = r === Re.Primary, v = r === Re.Secondary, w = r === Re.Error, y = r === Re.Info, I = r === Re.Success, E = r === Re.Warning, P = Q({
    // root class
    [vt["ds-chip"]]: !0,
    // contained variants
    [vt["ds-chip__contained"]]: g,
    [vt["ds-chip__contained-primary"]]: g && b,
    [vt["ds-chip__contained-secondary"]]: g && v,
    [vt["ds-chip__contained-info"]]: g && y,
    [vt["ds-chip__contained-success"]]: g && I,
    [vt["ds-chip__contained-warning"]]: g && E,
    [vt["ds-chip__contained-error"]]: g && w,
    // outlined variants
    [vt["ds-chip__outlined"]]: !g,
    [vt["ds-chip__outlined-primary"]]: !g && b,
    [vt["ds-chip__outlined-secondary"]]: !g && v,
    [vt["ds-chip__outlined-info"]]: !g && y,
    [vt["ds-chip__outlined-success"]]: !g && I,
    [vt["ds-chip__outlined-warning"]]: !g && E,
    [vt["ds-chip__outlined-error"]]: !g && w
  }, a);
  return /* @__PURE__ */ B(
    "span",
    {
      ref: c,
      "aria-label": m ? t : void 0,
      title: m ? void 0 : t,
      className: P,
      role: m ? "button" : void 0,
      tabIndex: m ? 0 : void 0,
      onClick: p ? () => p(e) : void 0,
      onKeyDown: p ? (S) => {
        (S.key === "Enter" || S.key === " ") && p(e);
      } : void 0,
      children: [
        o && /* @__PURE__ */ _("span", { "aria-hidden": "true", className: vt["ds-chip__icon"], children: /* @__PURE__ */ _(ke, { name: o, size: 12 }) }),
        n,
        l && /* @__PURE__ */ _("span", { "aria-hidden": "true", className: vt["ds-chip__icon"], children: /* @__PURE__ */ _(ke, { name: l, size: 12 }) }),
        h && /* @__PURE__ */ _(
          "button",
          {
            type: "button",
            "aria-label": `Remove ${t}`,
            className: vt["ds-chip__dismiss"],
            onClick: (S) => {
              S.stopPropagation(), h(e);
            },
            children: /* @__PURE__ */ _(ke, { name: J.Cancel, "aria-hidden": "true", size: 12 })
          }
        )
      ]
    },
    e
  );
}, At = {
  "ns-projection-calendar": "_ns-projection-calendar_1k5ac_1",
  "ns-projection-calendar__header": "_ns-projection-calendar__header_1k5ac_11",
  "ns-projection-calendar__label-cell": "_ns-projection-calendar__label-cell_1k5ac_19",
  "ns-projection-calendar__label-stack": "_ns-projection-calendar__label-stack_1k5ac_37",
  "ns-projection-calendar__label-sub": "_ns-projection-calendar__label-sub_1k5ac_43",
  "ns-projection-calendar__week-strip": "_ns-projection-calendar__week-strip_1k5ac_49",
  "ns-projection-calendar__week-cell": "_ns-projection-calendar__week-cell_1k5ac_55",
  "ns-projection-calendar__week-dates": "_ns-projection-calendar__week-dates_1k5ac_74",
  "ns-projection-calendar__lane": "_ns-projection-calendar__lane_1k5ac_80",
  "ns-projection-calendar__timeline": "_ns-projection-calendar__timeline_1k5ac_88",
  "ns-projection-calendar__bars-container": "_ns-projection-calendar__bars-container_1k5ac_93",
  "ns-projection-calendar__bar": "_ns-projection-calendar__bar_1k5ac_93",
  "ns-projection-calendar__bar--open-ended": "_ns-projection-calendar__bar--open-ended_1k5ac_112",
  "ns-projection-calendar__bar-label": "_ns-projection-calendar__bar-label_1k5ac_116",
  "ns-projection-calendar__legend": "_ns-projection-calendar__legend_1k5ac_131"
}, mo = 19, Lc = 10, Pc = 8, nr = 240, Mf = 112, Ff = 112, Rf = 25, Of = 16, Bf = 96, zf = 7, jf = {
  primary: Re.Info,
  secondary: Re.Warning,
  tertiary: Re.Success,
  quaternary: Re.Primary,
  neutral: Re.Secondary
};
function Aa(e) {
  const [t, n, i] = e.split("-").map(Number);
  return Date.UTC(t, n - 1, i) / 864e5;
}
function pi(e, t) {
  return Aa(t) - Aa(e);
}
function ts(e) {
  const [t, n, i] = e.split("-").map(Number);
  return `${n}/${i}/${t}`;
}
function ss(e, t) {
  const n = Aa(e) + t, i = new Date(n * 864e5);
  return `${i.getUTCFullYear()}-${i.getUTCMonth() + 1}-${i.getUTCDate()}`;
}
function Bs(e) {
  const [, t, n] = e.split("-").map(Number);
  return `${t}/${n}`;
}
function Ia(e) {
  return e < zf ? "days" : "weeks";
}
function Hf(e, t) {
  return e === t ? Bs(e) : `${Bs(e)} – ${Bs(t)}`;
}
function $f(e) {
  if (e.openEnded)
    return `${ts(e.startDate)} – End Date TBD`;
  const t = pi(e.startDate, e.endDate) > 1 ? ss(e.endDate, -1) : e.startDate;
  return `${ts(e.startDate)} – ${ts(t)}`;
}
function qf(e, t) {
  const n = pi(e, t), i = Math.ceil(n / 7);
  return Array.from({ length: i }, (r, a) => {
    const o = a === i - 1 ? n - a * 7 : 7;
    return {
      label: `Week ${a + 1}`,
      detail: Hf(
        ss(e, a * 7),
        ss(e, a * 7 + o - 1)
      ),
      days: o
    };
  });
}
function Uf(e, t) {
  const n = pi(e, t);
  return Array.from({ length: n }, (i, r) => ({
    label: ts(ss(e, r)),
    days: 1
  }));
}
function Jf(e, t) {
  const n = pi(e, t);
  return Ia(n) === "days" ? Uf(e, t) : qf(e, t);
}
function Wf(e) {
  const t = Math.max(e, 1);
  return t * mo + (t - 1) * Lc + Pc * 2;
}
function Xf(e) {
  return Pc + e * (mo + Lc);
}
function Zf({ bar: e, index: t, calStart: n, totalDays: i }) {
  const r = re(null), a = pi(n, e.startDate) / i * 100, o = pi(e.startDate, e.endDate) / i * 100, l = $f(e), u = e.tooltip ?? `${e.label} · ${l}`;
  return /* @__PURE__ */ B(Ke, { children: [
    /* @__PURE__ */ _(
      "div",
      {
        ref: r,
        role: "gridcell",
        tabIndex: 0,
        "aria-label": `${e.label}: ${l}`,
        className: [
          At["ns-projection-calendar__bar"],
          e.openEnded && At["ns-projection-calendar__bar--open-ended"]
        ].filter(Boolean).join(" "),
        style: {
          position: "absolute",
          left: `${a}%`,
          width: `${o}%`,
          top: Xf(t),
          height: mo,
          backgroundColor: e.color
        },
        children: /* @__PURE__ */ _("span", { className: At["ns-projection-calendar__bar-label"], children: e.openEnded ? `${e.label} · End Date TBD` : e.label })
      }
    ),
    /* @__PURE__ */ _(cn, { id: `tip-${e.id}`, anchorRef: r, content: u, placement: "top" })
  ] });
}
function n5({
  "aria-label": e = "Projection calendar",
  laneHeaderLabel: t = "Timeline",
  startDate: n,
  endDate: i,
  lanes: r,
  legend: a
}) {
  const o = pi(n, i), l = Jf(n, i), u = Ia(o) === "days" ? Ff : Mf, c = l[l.length - 1], h = Ia(o) === "weeks" && c && c.days < 7 ? Bf : 0, p = nr + Rf + Of + l.length * u + h;
  return /* @__PURE__ */ B("div", { className: At["ns-projection-calendar"], children: [
    /* @__PURE__ */ B(
      "div",
      {
        role: "grid",
        "aria-label": e,
        "aria-rowcount": r.length + 1,
        style: {
          minWidth: p,
          "--ns-projection-calendar-overhang": `${h}px`
        },
        children: [
          /* @__PURE__ */ B("div", { className: At["ns-projection-calendar__header"], role: "row", children: [
            /* @__PURE__ */ _(
              "div",
              {
                className: At["ns-projection-calendar__label-cell"],
                role: "columnheader",
                style: {
                  width: nr,
                  minWidth: nr,
                  backgroundColor: "var(--ns-color-secondary-100)"
                },
                children: t
              }
            ),
            /* @__PURE__ */ _("div", { className: At["ns-projection-calendar__week-strip"], children: l.map((m, g) => /* @__PURE__ */ B(
              "div",
              {
                role: "columnheader",
                className: At["ns-projection-calendar__week-cell"],
                style: { flex: m.days },
                "aria-label": m.detail ? `${m.label} (${m.detail})` : void 0,
                title: m.detail ? `${m.label} (${m.detail})` : void 0,
                children: [
                  /* @__PURE__ */ _("span", { children: m.label }),
                  m.detail && /* @__PURE__ */ _("span", { className: At["ns-projection-calendar__week-dates"], children: m.detail })
                ]
              },
              `${m.label}-${g}`
            )) })
          ] }),
          r.map((m, g) => {
            const b = Wf(m.bars.length), v = g % 2 === 0 ? "var(--ns-color-background-primary)" : "var(--ns-color-background-secondary)";
            return /* @__PURE__ */ B(
              "div",
              {
                className: At["ns-projection-calendar__lane"],
                style: { backgroundColor: v },
                role: "row",
                children: [
                  /* @__PURE__ */ _(
                    "div",
                    {
                      className: At["ns-projection-calendar__label-cell"],
                      role: "rowheader",
                      style: {
                        width: nr,
                        minWidth: nr,
                        backgroundColor: v
                      },
                      children: m.subLabel ? /* @__PURE__ */ B("span", { className: At["ns-projection-calendar__label-stack"], children: [
                        /* @__PURE__ */ _("span", { children: m.label }),
                        /* @__PURE__ */ _("span", { className: At["ns-projection-calendar__label-sub"], children: m.subLabel })
                      ] }) : m.label
                    }
                  ),
                  /* @__PURE__ */ _(
                    "div",
                    {
                      className: At["ns-projection-calendar__timeline"],
                      style: { minHeight: b },
                      children: /* @__PURE__ */ _("div", { className: At["ns-projection-calendar__bars-container"], children: m.bars.map((w, y) => /* @__PURE__ */ _(
                        Zf,
                        {
                          bar: w,
                          index: y,
                          calStart: n,
                          totalDays: o
                        },
                        w.id
                      )) })
                    }
                  )
                ]
              },
              m.id
            );
          })
        ]
      }
    ),
    a && a.length > 0 && // Shares the grid's minWidth so its border-top and background span
    // the full (possibly wider-than-viewport) table width instead of
    // just the visible, scrolled-into portion. border-box keeps the
    // legend's own padding from pushing its rendered width past the
    // grid's (content-box) minWidth.
    /* @__PURE__ */ _(
      "div",
      {
        className: At["ns-projection-calendar__legend"],
        role: "list",
        style: { minWidth: p, boxSizing: "border-box" },
        children: a.map((m) => /* @__PURE__ */ _("div", { role: "listitem", children: /* @__PURE__ */ _(
          hi,
          {
            id: `legend-${m.variant}`,
            label: m.label,
            text: m.label,
            variant: yr.Outlined,
            color: jf[m.variant]
          }
        ) }, m.variant))
      }
    )
  ] });
}
const Tc = Cr({
  open: [],
  toggle: () => {
  }
}), mn = {
  "ns-accordion": "_ns-accordion_xno7b_1",
  "ns-accordion__item": "_ns-accordion__item_xno7b_8",
  "ns-accordion__heading": "_ns-accordion__heading_xno7b_11",
  "ns-accordion__trigger": "_ns-accordion__trigger_xno7b_14",
  "ns-accordion__trigger-label": "_ns-accordion__trigger-label_xno7b_38",
  "ns-accordion__trigger-icon": "_ns-accordion__trigger-icon_xno7b_41",
  "ns-accordion__content-wrapper": "_ns-accordion__content-wrapper_xno7b_50",
  "ns-accordion__content-wrapper--open": "_ns-accordion__content-wrapper--open_xno7b_56",
  "ns-accordion__content": "_ns-accordion__content_xno7b_50",
  "ns-accordion__item--open": "_ns-accordion__item--open_xno7b_75"
};
function Gf({ children: e, initialOpen: t = [], isMultiExpand: n }) {
  const [i, r] = Ee(() => t), a = (l) => {
    const u = i.includes(l);
    r(u ? i.filter((c) => c !== l) : n ? [...i, l] : [l]);
  }, o = Q({
    [mn["ns-accordion"]]: !0
  });
  return /* @__PURE__ */ _("div", { className: o, children: /* @__PURE__ */ _(Tc.Provider, { value: { open: i, toggle: a }, children: e }) });
}
function Kf({ children: e, id: t, title: n, label: i }) {
  const { open: r, toggle: a } = Oi(Tc), o = r.includes(t), l = `ns-accordion-trigger-${t}`, u = `ns-accordion-content-${t}`, c = Q({
    [mn["ns-accordion__item"]]: !0,
    [mn["ns-accordion__item--open"]]: o
  }), h = Q({
    [mn["ns-accordion__content-wrapper"]]: !0,
    [mn["ns-accordion__content-wrapper--open"]]: o
  });
  return /* @__PURE__ */ B("div", { className: c, children: [
    /* @__PURE__ */ _("h3", { className: mn["ns-accordion__heading"], children: /* @__PURE__ */ B(
      "button",
      {
        id: l,
        type: "button",
        className: mn["ns-accordion__trigger"],
        "aria-expanded": o,
        "aria-controls": u,
        "aria-label": i !== n ? i : void 0,
        onClick: () => a(t),
        children: [
          /* @__PURE__ */ _("span", { className: mn["ns-accordion__trigger-label"], children: n }),
          /* @__PURE__ */ _("span", { "aria-hidden": "true", className: mn["ns-accordion__trigger-icon"], children: /* @__PURE__ */ _(ke, { name: o ? J.KeyboardArrowUp : J.KeyboardArrowDown }) })
        ]
      }
    ) }),
    /* @__PURE__ */ _(
      "div",
      {
        id: u,
        role: "region",
        "aria-labelledby": l,
        className: h,
        children: /* @__PURE__ */ _("div", { className: mn["ns-accordion__content"], children: e })
      }
    )
  ] });
}
const La = {}, Nc = xr.createContext(La);
function Yf(e) {
  const t = xr.useContext(Nc);
  return xr.useMemo(
    function() {
      return typeof e == "function" ? e(t) : { ...t, ...e };
    },
    [t, e]
  );
}
function Qf(e) {
  let t;
  return e.disableParentContext ? t = typeof e.components == "function" ? e.components(La) : e.components || La : t = Yf(e.components), xr.createElement(
    Nc.Provider,
    { value: t },
    e.children
  );
}
const e0 = "data:image/svg+xml,%3csvg%20width='168'%20height='24'%20viewBox='0%200%20168%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Logo%20Type=Default,%20Size=Small'%3e%3cg%20id='Icon%20Left'%3e%3cg%20id='Group'%3e%3cpath%20id='Vector'%20d='M10.1023%207.10631L10.5608%208.38051C11.0708%209.7947%2012.1843%2010.9081%2013.5984%2011.4181L14.8726%2011.8766C14.9876%2011.9181%2014.9876%2012.0809%2014.8726%2012.1223L13.5984%2012.5809C12.1842%2013.0908%2011.0708%2014.2043%2010.5608%2015.6184L10.1023%2016.8926C10.0608%2017.0076%209.89799%2017.0076%209.85656%2016.8926L9.39803%2015.6184C8.88806%2014.2043%207.77458%2013.0908%206.36044%2012.5809L5.08624%2012.1223C4.97125%2012.0809%204.97125%2011.9181%205.08624%2011.8766L6.36044%2011.4181C7.77463%2010.9081%208.88807%209.79464%209.39803%208.38051L9.85656%207.10631C9.89799%206.9906%2010.0608%206.9906%2010.1023%207.10631Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_2'%20d='M15.8382%204.04446L16.0711%204.68941C16.3296%205.40507%2016.8931%205.96931%2017.6095%206.22787L18.2545%206.4607C18.313%206.48213%2018.313%206.56427%2018.2545%206.58498L17.6095%206.81781C16.8939%207.07637%2016.3296%207.6399%2016.0711%208.35628L15.8382%209.00122C15.8168%209.05979%2015.7347%209.05979%2015.714%209.00122L15.4811%208.35628C15.2226%207.64061%2014.659%207.07637%2013.9427%206.81781L13.2977%206.58498C13.2391%206.56355%2013.2391%206.48142%2013.2977%206.4607L13.9427%206.22787C14.6583%205.96931%2015.2226%205.40579%2015.4811%204.68941L15.714%204.04446C15.7347%203.98518%2015.8175%203.98518%2015.8382%204.04446Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_3'%20d='M15.8382%2014.9993L16.0711%2015.6443C16.3296%2016.3599%2016.8931%2016.9242%2017.6095%2017.1827L18.2545%2017.4156C18.313%2017.437%2018.313%2017.5191%2018.2545%2017.5398L17.6095%2017.7727C16.8939%2018.0312%2016.3296%2018.5948%2016.0711%2019.3111L15.8382%2019.9561C15.8168%2020.0147%2015.7347%2020.0147%2015.714%2019.9561L15.4811%2019.3111C15.2226%2018.5955%2014.659%2018.0312%2013.9427%2017.7727L13.2977%2017.5398C13.2391%2017.5184%2013.2391%2017.4363%2013.2977%2017.4156L13.9427%2017.1827C14.6583%2016.9242%2015.2226%2016.3606%2015.4811%2015.6443L15.714%2014.9993C15.7347%2014.9408%2015.8175%2014.9408%2015.8382%2014.9993Z'%20fill='%230067D2'/%3e%3c/g%3e%3c/g%3e%3cpath%20id='powered%20by'%20d='M30.352%2010.742C30.604%2010.3033%2030.9773%209.93933%2031.472%209.65C31.976%209.35133%2032.5593%209.202%2033.222%209.202C33.9033%209.202%2034.5193%209.36533%2035.07%209.692C35.63%2010.0187%2036.0687%2010.4807%2036.386%2011.078C36.7033%2011.666%2036.862%2012.352%2036.862%2013.136C36.862%2013.9107%2036.7033%2014.6013%2036.386%2015.208C36.0687%2015.8147%2035.63%2016.286%2035.07%2016.622C34.5193%2016.958%2033.9033%2017.126%2033.222%2017.126C32.5687%2017.126%2031.99%2016.9813%2031.486%2016.692C30.9913%2016.3933%2030.6133%2016.0247%2030.352%2015.586V20.64H29.078V9.328H30.352V10.742ZM35.56%2013.136C35.56%2012.5573%2035.4433%2012.0533%2035.21%2011.624C34.9767%2011.1947%2034.6593%2010.868%2034.258%2010.644C33.866%2010.42%2033.432%2010.308%2032.956%2010.308C32.4893%2010.308%2032.0553%2010.4247%2031.654%2010.658C31.262%2010.882%2030.9447%2011.2133%2030.702%2011.652C30.4687%2012.0813%2030.352%2012.5807%2030.352%2013.15C30.352%2013.7287%2030.4687%2014.2373%2030.702%2014.676C30.9447%2015.1053%2031.262%2015.4367%2031.654%2015.67C32.0553%2015.894%2032.4893%2016.006%2032.956%2016.006C33.432%2016.006%2033.866%2015.894%2034.258%2015.67C34.6593%2015.4367%2034.9767%2015.1053%2035.21%2014.676C35.4433%2014.2373%2035.56%2013.724%2035.56%2013.136ZM41.9849%2017.126C41.2663%2017.126%2040.6129%2016.9627%2040.0249%2016.636C39.4463%2016.3093%2038.9889%2015.8473%2038.6529%2015.25C38.3263%2014.6433%2038.1629%2013.9433%2038.1629%2013.15C38.1629%2012.366%2038.3309%2011.6753%2038.6669%2011.078C39.0123%2010.4713%2039.4789%2010.0093%2040.0669%209.692C40.6549%209.36533%2041.3129%209.202%2042.0409%209.202C42.7689%209.202%2043.4269%209.36533%2044.0149%209.692C44.6029%2010.0093%2045.0649%2010.4667%2045.4009%2011.064C45.7463%2011.6613%2045.9189%2012.3567%2045.9189%2013.15C45.9189%2013.9433%2045.7416%2014.6433%2045.3869%2015.25C45.0416%2015.8473%2044.5703%2016.3093%2043.9729%2016.636C43.3756%2016.9627%2042.7129%2017.126%2041.9849%2017.126ZM41.9849%2016.006C42.4423%2016.006%2042.8716%2015.8987%2043.2729%2015.684C43.6743%2015.4693%2043.9963%2015.1473%2044.2389%2014.718C44.4909%2014.2887%2044.6169%2013.766%2044.6169%2013.15C44.6169%2012.534%2044.4956%2012.0113%2044.2529%2011.582C44.0103%2011.1527%2043.6929%2010.8353%2043.3009%2010.63C42.9089%2010.4153%2042.4843%2010.308%2042.0269%2010.308C41.5603%2010.308%2041.1309%2010.4153%2040.7389%2010.63C40.3563%2010.8353%2040.0483%2011.1527%2039.8149%2011.582C39.5816%2012.0113%2039.4649%2012.534%2039.4649%2013.15C39.4649%2013.7753%2039.5769%2014.3027%2039.8009%2014.732C40.0343%2015.1613%2040.3423%2015.4833%2040.7249%2015.698C41.1076%2015.9033%2041.5276%2016.006%2041.9849%2016.006ZM57.914%209.328L55.52%2017H54.204L52.356%2010.91L50.508%2017H49.192L46.784%209.328H48.086L49.85%2015.768L51.754%209.328H53.056L54.918%2015.782L56.654%209.328H57.914ZM66.2784%2012.87C66.2784%2013.1127%2066.2644%2013.3693%2066.2364%2013.64H60.1044C60.1511%2014.396%2060.4077%2014.9887%2060.8744%2015.418C61.3504%2015.838%2061.9244%2016.048%2062.5964%2016.048C63.1471%2016.048%2063.6044%2015.922%2063.9684%2015.67C64.3417%2015.4087%2064.6031%2015.0633%2064.7524%2014.634H66.1244C65.9191%2015.3713%2065.5084%2015.9733%2064.8924%2016.44C64.2764%2016.8973%2063.5111%2017.126%2062.5964%2017.126C61.8684%2017.126%2061.2151%2016.9627%2060.6364%2016.636C60.0671%2016.3093%2059.6191%2015.8473%2059.2924%2015.25C58.9657%2014.6433%2058.8024%2013.9433%2058.8024%2013.15C58.8024%2012.3567%2058.9611%2011.6613%2059.2784%2011.064C59.5957%2010.4667%2060.0391%2010.0093%2060.6084%209.692C61.1871%209.36533%2061.8497%209.202%2062.5964%209.202C63.3244%209.202%2063.9684%209.36067%2064.5284%209.678C65.0884%209.99533%2065.5177%2010.434%2065.8164%2010.994C66.1244%2011.5447%2066.2784%2012.17%2066.2784%2012.87ZM64.9624%2012.604C64.9624%2012.1187%2064.8551%2011.7033%2064.6404%2011.358C64.4257%2011.0033%2064.1317%2010.7373%2063.7584%2010.56C63.3944%2010.3733%2062.9884%2010.28%2062.5404%2010.28C61.8964%2010.28%2061.3457%2010.4853%2060.8884%2010.896C60.4404%2011.3067%2060.1837%2011.876%2060.1184%2012.604H64.9624ZM69.334%2010.574C69.558%2010.1353%2069.8754%209.79467%2070.286%209.552C70.706%209.30933%2071.2147%209.188%2071.812%209.188V10.504H71.476C70.048%2010.504%2069.334%2011.2787%2069.334%2012.828V17H68.06V9.328H69.334V10.574ZM80.3827%2012.87C80.3827%2013.1127%2080.3687%2013.3693%2080.3407%2013.64H74.2087C74.2554%2014.396%2074.512%2014.9887%2074.9787%2015.418C75.4547%2015.838%2076.0287%2016.048%2076.7007%2016.048C77.2514%2016.048%2077.7087%2015.922%2078.0727%2015.67C78.446%2015.4087%2078.7074%2015.0633%2078.8567%2014.634H80.2287C80.0234%2015.3713%2079.6127%2015.9733%2078.9967%2016.44C78.3807%2016.8973%2077.6154%2017.126%2076.7007%2017.126C75.9727%2017.126%2075.3194%2016.9627%2074.7407%2016.636C74.1714%2016.3093%2073.7234%2015.8473%2073.3967%2015.25C73.07%2014.6433%2072.9067%2013.9433%2072.9067%2013.15C72.9067%2012.3567%2073.0654%2011.6613%2073.3827%2011.064C73.7%2010.4667%2074.1434%2010.0093%2074.7127%209.692C75.2914%209.36533%2075.954%209.202%2076.7007%209.202C77.4287%209.202%2078.0727%209.36067%2078.6327%209.678C79.1927%209.99533%2079.622%2010.434%2079.9207%2010.994C80.2287%2011.5447%2080.3827%2012.17%2080.3827%2012.87ZM79.0667%2012.604C79.0667%2012.1187%2078.9594%2011.7033%2078.7447%2011.358C78.53%2011.0033%2078.236%2010.7373%2077.8627%2010.56C77.4987%2010.3733%2077.0927%2010.28%2076.6447%2010.28C76.0007%2010.28%2075.45%2010.4853%2074.9927%2010.896C74.5447%2011.3067%2074.288%2011.876%2074.2227%2012.604H79.0667ZM81.6883%2013.136C81.6883%2012.352%2081.847%2011.666%2082.1643%2011.078C82.4817%2010.4807%2082.9157%2010.0187%2083.4663%209.692C84.0263%209.36533%2084.6517%209.202%2085.3423%209.202C85.9397%209.202%2086.495%209.342%2087.0083%209.622C87.5217%209.89267%2087.9137%2010.252%2088.1843%2010.7V6.64H89.4723V17H88.1843V15.558C87.9323%2016.0153%2087.559%2016.3933%2087.0643%2016.692C86.5697%2016.9813%2085.991%2017.126%2085.3283%2017.126C84.647%2017.126%2084.0263%2016.958%2083.4663%2016.622C82.9157%2016.286%2082.4817%2015.8147%2082.1643%2015.208C81.847%2014.6013%2081.6883%2013.9107%2081.6883%2013.136ZM88.1843%2013.15C88.1843%2012.5713%2088.0677%2012.0673%2087.8343%2011.638C87.601%2011.2087%2087.2837%2010.882%2086.8823%2010.658C86.4903%2010.4247%2086.0563%2010.308%2085.5803%2010.308C85.1043%2010.308%2084.6703%2010.42%2084.2783%2010.644C83.8863%2010.868%2083.5737%2011.1947%2083.3403%2011.624C83.107%2012.0533%2082.9903%2012.5573%2082.9903%2013.136C82.9903%2013.724%2083.107%2014.2373%2083.3403%2014.676C83.5737%2015.1053%2083.8863%2015.4367%2084.2783%2015.67C84.6703%2015.894%2085.1043%2016.006%2085.5803%2016.006C86.0563%2016.006%2086.4903%2015.894%2086.8823%2015.67C87.2837%2015.4367%2087.601%2015.1053%2087.8343%2014.676C88.0677%2014.2373%2088.1843%2013.7287%2088.1843%2013.15ZM96.8317%2010.756C97.093%2010.2987%2097.4757%209.92533%2097.9797%209.636C98.4837%209.34667%2099.0577%209.202%2099.7017%209.202C100.392%209.202%20101.013%209.36533%20101.564%209.692C102.114%2010.0187%20102.548%2010.4807%20102.866%2011.078C103.183%2011.666%20103.342%2012.352%20103.342%2013.136C103.342%2013.9107%20103.183%2014.6013%20102.866%2015.208C102.548%2015.8147%20102.11%2016.286%20101.55%2016.622C100.999%2016.958%20100.383%2017.126%2099.7017%2017.126C99.039%2017.126%2098.4557%2016.9813%2097.9517%2016.692C97.457%2016.4027%2097.0837%2016.034%2096.8317%2015.586V17H95.5577V6.64H96.8317V10.756ZM102.04%2013.136C102.04%2012.5573%20101.923%2012.0533%20101.69%2011.624C101.456%2011.1947%20101.139%2010.868%20100.738%2010.644C100.346%2010.42%2099.9117%2010.308%2099.4357%2010.308C98.969%2010.308%2098.535%2010.4247%2098.1337%2010.658C97.7417%2010.882%2097.4244%2011.2133%2097.1817%2011.652C96.9484%2012.0813%2096.8317%2012.5807%2096.8317%2013.15C96.8317%2013.7287%2096.9484%2014.2373%2097.1817%2014.676C97.4244%2015.1053%2097.7417%2015.4367%2098.1337%2015.67C98.535%2015.894%2098.969%2016.006%2099.4357%2016.006C99.9117%2016.006%20100.346%2015.894%20100.738%2015.67C101.139%2015.4367%20101.456%2015.1053%20101.69%2014.676C101.923%2014.2373%20102.04%2013.724%20102.04%2013.136ZM111.727%209.328L107.107%2020.612H105.791L107.303%2016.916L104.209%209.328H105.623L108.031%2015.544L110.411%209.328H111.727Z'%20fill='%23001A35'/%3e%3cg%20id='ARIES-logo'%3e%3cg%20id='Group_2'%3e%3cpath%20id='Vector_4'%20opacity='0.979'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M161.235%205.05044C162.697%204.8775%20164.065%205.14926%20165.339%205.86573C166.39%206.60954%20166.952%207.631%20167.026%208.93008C165.996%208.93008%20164.964%208.93008%20163.934%208.93008C163.821%208.03902%20163.315%207.5236%20162.416%207.38385C161.558%207.19671%20160.874%207.44973%20160.363%208.14291C160.028%208.99224%20160.244%209.6576%20161.01%2010.139C161.197%2010.2327%20161.385%2010.3264%20161.572%2010.4201C162.488%2010.7287%20163.406%2011.0285%20164.327%2011.3197C166.729%2012.1399%20167.6%2013.7799%20166.942%2016.2395C166.321%2017.6661%20165.243%2018.5376%20163.709%2018.8541C161.903%2019.2187%20160.235%2018.9001%20158.705%2017.8982C157.743%2017.1268%20157.274%2016.1241%20157.299%2014.8901C158.293%2014.8901%20159.286%2014.8901%20160.279%2014.8901C160.336%2015.8933%20160.86%2016.4837%20161.853%2016.6612C162.708%2016.8199%20163.429%2016.5857%20164.018%2015.9584C164.456%2015.1552%20164.334%2014.4524%20163.653%2013.8499C163.434%2013.675%20163.19%2013.5438%20162.922%2013.4563C161.984%2013.1565%20161.048%2012.8566%20160.11%2012.5567C157.703%2011.7071%20156.851%2010.0484%20157.552%207.58064C158.099%206.35981%20159.027%205.58201%20160.335%205.24724C160.642%205.17668%20160.942%205.11108%20161.235%205.05044Z'%20fill='%23001A35'/%3e%3c/g%3e%3cg%20id='Group_3'%3e%3cpath%20id='Vector_5'%20opacity='0.987'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M131.21%205.21885C133.103%205.20947%20134.996%205.21885%20136.889%205.24696C138.458%205.29541%20139.704%205.94201%20140.628%207.18678C141.281%208.38984%20141.393%209.64557%20140.965%2010.954C140.43%2012.2108%20139.502%2013.0167%20138.182%2013.3717C139.258%2015.1757%20140.326%2016.9843%20141.387%2018.7976C140.319%2018.8351%20139.25%2018.8351%20138.182%2018.7976C137.196%2017.0593%20136.202%2015.3257%20135.202%2013.5966C134.792%2013.5406%20134.379%2013.5218%20133.965%2013.5404C133.965%2015.3021%20133.965%2017.0639%20133.965%2018.8257C133.047%2018.8257%20132.128%2018.8257%20131.21%2018.8257C131.21%2014.2901%20131.21%209.75448%20131.21%205.21885ZM133.965%207.52414C134.828%207.51477%20135.69%207.52415%20136.551%207.55225C137.733%207.65667%20138.352%208.30327%20138.407%209.49207C138.373%2010.6036%20137.81%2011.2502%20136.72%2011.4319C135.802%2011.46%20134.884%2011.4694%20133.965%2011.46C133.965%2010.1481%20133.965%208.83609%20133.965%207.52414Z'%20fill='%23001A35'/%3e%3c/g%3e%3cg%20id='Group_4'%3e%3cpath%20id='Vector_6'%20opacity='0.968'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M143.128%205.21924C144.065%205.21924%20145.002%205.21924%20145.939%205.21924C145.939%209.75487%20145.939%2014.2905%20145.939%2018.8261C145.002%2018.8261%20144.065%2018.8261%20143.128%2018.8261C143.128%2014.2905%20143.128%209.75487%20143.128%205.21924Z'%20fill='%23001A35'/%3e%3c/g%3e%3cg%20id='Group_5'%3e%3cpath%20id='Vector_7'%20opacity='0.988'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M148.021%205.21924C150.663%205.21924%20153.306%205.21924%20155.948%205.21924C155.948%205.96892%20155.948%206.71862%20155.948%207.4683C154.224%207.4683%20152.5%207.4683%20150.776%207.4683C150.776%208.59284%20150.776%209.71737%20150.776%2010.8419C152.294%2010.8419%20153.812%2010.8419%20155.33%2010.8419C155.33%2011.5728%20155.33%2012.3038%20155.33%2013.0347C153.812%2013.0347%20152.294%2013.0347%20150.776%2013.0347C150.776%2014.2155%20150.776%2015.3963%20150.776%2016.577C152.5%2016.577%20154.224%2016.577%20155.948%2016.577C155.948%2017.3267%20155.948%2018.0764%20155.948%2018.8261C153.306%2018.8261%20150.663%2018.8261%20148.021%2018.8261C148.021%2014.2905%20148.021%209.75487%20148.021%205.21924Z'%20fill='%23001A35'/%3e%3c/g%3e%3cpath%20id='Vector_8'%20d='M125.93%2016.2595H120.677L119.784%2018.85H117L121.727%205.25H124.826L129.554%2018.85H126.77L125.877%2016.2595H125.93ZM125.247%2014.1008L123.356%208.43413L121.465%2014.1008H125.299H125.247Z'%20fill='%23031C37'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", jr = {
  "ns-aries-card": "_ns-aries-card_7uxe1_1",
  "ns-aries-card__header": "_ns-aries-card__header_7uxe1_16",
  "ns-aries-card__body": "_ns-aries-card__body_7uxe1_33",
  "ns-aries-card__footer": "_ns-aries-card__footer_7uxe1_42"
};
function t0({ actions: e, "aria-label": t, children: n, tags: i, onAction: r }) {
  const a = Q({
    [jr["ns-aries-card"]]: !0
  }), o = Q({
    [jr["ns-aries-card__header"]]: !0
  }), l = Q({
    [jr["ns-aries-card__body"]]: !0
  }), u = Q({
    [jr["ns-aries-card__footer"]]: !0
  }), c = (h) => {
    r?.(h);
  };
  return /* @__PURE__ */ B("section", { className: a, "aria-label": t, children: [
    /* @__PURE__ */ B("header", { className: o, children: [
      /* @__PURE__ */ _("img", { src: e0, alt: "ARIES logo", "aria-hidden": "true" }),
      /* @__PURE__ */ _("div", { children: i?.map((h) => /* @__PURE__ */ _(hi, { ...h }, h.id)) })
    ] }),
    /* @__PURE__ */ _("div", { className: l, children: n }),
    e?.length ? /* @__PURE__ */ _("footer", { className: u, children: e.map((h) => /* @__PURE__ */ _(st, { ...h, onClick: () => c(h) }, h.name)) }) : null
  ] });
}
const zs = {
  "ns-aries-infocard": "_ns-aries-infocard_ukfbi_1",
  "ns-aries-infocard__heading": "_ns-aries-infocard__heading_ukfbi_27",
  "ns-aries-infocard__body": "_ns-aries-infocard__body_ukfbi_56"
};
function n0({ "aria-label": e, heading: t, icon: n, instructions: i }) {
  const r = Q({
    [zs["ns-aries-infocard"]]: !0
  }), a = Q({
    [zs["ns-aries-infocard__heading"]]: !0
  }), o = Q({
    [zs["ns-aries-infocard__body"]]: !0
  });
  return /* @__PURE__ */ B("section", { className: r, "aria-label": e, children: [
    /* @__PURE__ */ B("header", { className: a, children: [
      n && /* @__PURE__ */ _(ke, { name: J.ARIES }),
      " ",
      t
    ] }),
    /* @__PURE__ */ _("ol", { className: o, children: i.map((l, u) => /* @__PURE__ */ B("li", { children: [
      /* @__PURE__ */ _("strong", { children: l.text }),
      " ",
      l.subtext
    ] }, l.id ?? `instruction-${u}`)) })
  ] });
}
const _t = {
  "ds-input": "_ds-input_1kuia_1",
  "ds-input__label": "_ds-input__label_1kuia_11",
  "ds-input__label-counter": "_ds-input__label-counter_1kuia_16",
  "ds-input__wrapper": "_ds-input__wrapper_1kuia_19",
  "ds-input__prefix": "_ds-input__prefix_1kuia_39",
  "ds-input__suffix": "_ds-input__suffix_1kuia_39",
  "ds-input__suffix-btn": "_ds-input__suffix-btn_1kuia_52",
  "ds-input__icon": "_ds-input__icon_1kuia_58",
  "ds-input__field": "_ds-input__field_1kuia_63",
  "ds-input__hint": "_ds-input__hint_1kuia_96",
  "ds-input__hint-icon": "_ds-input__hint-icon_1kuia_108",
  "ds-input__hint-text": "_ds-input__hint-text_1kuia_114",
  "ds-input__message": "_ds-input__message_1kuia_117",
  "ds-input--status-error": "_ds-input--status-error_1kuia_128",
  "ds-input--status-success": "_ds-input--status-success_1kuia_135",
  "ds-input--status-warning": "_ds-input--status-warning_1kuia_142",
  "ds-input--disabled": "_ds-input--disabled_1kuia_149",
  "ds-input--readonly": "_ds-input--readonly_1kuia_167"
};
var i0 = /* @__PURE__ */ ((e) => (e.Text = "text", e.Email = "email", e.Password = "password", e.Search = "search", e.URL = "url", e.Tel = "tel", e))(i0 || {}), Pa = /* @__PURE__ */ ((e) => (e.Default = "default", e.Error = "error", e.Success = "success", e.Warning = "warning", e))(Pa || {}), Ta = /* @__PURE__ */ ((e) => (e.Characters = "characters", e.Words = "words", e))(Ta || {});
const r0 = (...e) => e.filter(Boolean).join(" "), s0 = (e) => {
  const {
    ref: t,
    id: n,
    name: i,
    label: r,
    required: a = !1,
    readOnly: o = !1,
    disabled: l = !1,
    status: u = Pa.Default,
    size: c = Mt.Medium,
    prefix: h,
    suffix: p,
    counterMode: m,
    maxCount: g,
    hintIcon: b,
    hint: v,
    message: w,
    value: y,
    defaultValue: I,
    onChange: E,
    onSuffixClick: P,
    suffixAriaLabel: S = "Submit",
    className: f,
    placeholder: C = "Get started...",
    ...L
  } = e, F = at(), M = n ?? F, z = `${M}-hint`, R = `${M}-message`, j = y !== void 0, [H, O] = Ee(I ?? ""), X = j ? y : H, K = re(null), se = Bi(K, t), Y = (te) => {
    j || O(te.target.value), E?.(te);
  }, ue = m ? m === Ta.Words ? X.trim() === "" ? 0 : X.trim().split(/\s+/).length : X.length : 0, ie = p, V = P, de = !!r, Se = !!m, W = !!v, q = !!w, ne = h !== void 0, ee = ie !== void 0, ge = u === Pa.Error;
  return /* @__PURE__ */ B(
    "fieldset",
    {
      className: r0(
        _t["ds-input"],
        _t[`ds-input--size-${c}`],
        _t[`ds-input--status-${u}`],
        l && _t["ds-input--disabled"],
        o && _t["ds-input--readonly"],
        f
      ),
      children: [
        de && /* @__PURE__ */ B("label", { className: _t["ds-input__label"], htmlFor: M, children: [
          /* @__PURE__ */ B("span", { className: _t["ds-input__label-text"], children: [
            r,
            a && /* The asterisk is presentational; aria-required on <input>
            * conveys the requirement to assistive technology. */
            /* @__PURE__ */ _("span", { className: _t["ds-input__label-required"], "aria-hidden": "true", children: " *" })
          ] }),
          Se && /* @__PURE__ */ _(
            "span",
            {
              className: _t["ds-input__label-counter"],
              role: "status",
              "aria-live": "polite",
              "aria-label": `${ue} ${m === Ta.Words ? "words" : "characters"}` + (g ? ` out of ${g}` : ""),
              children: g ? `${ue} / ${g}` : `${ue}`
            }
          )
        ] }),
        /* @__PURE__ */ B("div", { className: _t["ds-input__wrapper"], children: [
          ne && /* @__PURE__ */ _("span", { className: _t["ds-input__prefix"], children: /* @__PURE__ */ _(ke, { className: _t["ds-input__icon"], "aria-hidden": "true", name: h }) }),
          /* @__PURE__ */ _(
            "input",
            {
              ref: se,
              id: M,
              name: i,
              className: _t["ds-input__field"],
              ...j ? { value: y } : { defaultValue: I },
              disabled: l,
              readOnly: o,
              required: a,
              "aria-required": a || void 0,
              "aria-invalid": ge || void 0,
              "aria-describedby": W ? z : void 0,
              placeholder: C,
              onChange: Y,
              ...L
            }
          ),
          ee && V ? (
            // Interactive suffix: wrapped in a native <button> for full keyboard + AT support.
            /* @__PURE__ */ _(
              st,
              {
                type: "submit",
                color: Re.Primary,
                variant: lt.Contained,
                size: Mt.Medium,
                className: _t["ds-input__suffix-btn"],
                onClick: V,
                disabled: l,
                tabIndex: l ? -1 : 0,
                icon: ie,
                isIconOnly: !0,
                label: S
              }
            )
          ) : (
            // Decorative static suffix icon
            /* @__PURE__ */ _(ke, { className: _t["ds-input__icon"], "aria-hidden": "true", name: ie })
          )
        ] }),
        W && /* @__PURE__ */ B(
          "p",
          {
            id: z,
            className: _t["ds-input__hint"],
            role: ge ? "alert" : void 0,
            "aria-live": ge ? void 0 : "polite",
            children: [
              b && /* @__PURE__ */ _(ke, { className: _t["ds-input__hint-icon"], "aria-hidden": "true", name: b }),
              /* @__PURE__ */ _("span", { className: _t["ds-input__hint-text"], children: v })
            ]
          }
        ),
        q && /* @__PURE__ */ _(
          "p",
          {
            id: R,
            className: _t["ds-input__message"],
            role: "alert",
            "aria-live": "polite",
            children: w
          }
        )
      ]
    }
  );
}, Ci = {
  "error-boundary": "_error-boundary_e2ts8_1",
  "error-boundary__icon": "_error-boundary__icon_e2ts8_16",
  "error-boundary__content": "_error-boundary__content_e2ts8_30",
  "error-boundary__title": "_error-boundary__title_e2ts8_34",
  "error-boundary__message": "_error-boundary__message_e2ts8_40",
  "error-boundary__action": "_error-boundary__action_e2ts8_45"
};
class a0 extends xr.Component {
  constructor() {
    super(...arguments);
    gl(this, "state", {
      error: null,
      componentStack: void 0,
      timestamp: void 0
    });
  }
  /**
   * Derives state from the thrown error.
   *
   * React calls this method when a descendant throws during render.
   *
   * @param error - The thrown error instance.
   * @returns Partial state update that stores the error.
   *
   * @internal
   */
  static getDerivedStateFromError(n) {
    return {
      error: n,
      timestamp: /* @__PURE__ */ new Date()
    };
  }
  /**
   * Lifecycle hook where side-effects for captured errors can be executed.
   *
   * @param error - The thrown error instance.
   * @param info - React error info with component stack.
   *
   * @internal
   */
  componentDidCatch(n, i) {
    const { onErrorCaptured: r, name: a } = this.props;
    if (this.setState({
      componentStack: i.componentStack
    }), typeof r == "function") {
      const o = {
        ...i,
        boundaryName: a
      };
      try {
        r(n, o);
      } catch {
        process.env.NODE_ENV !== "production" && console.warn("[ErrorBoundary] onErrorCaptured handler threw an error. Swallowing to avoid cascade.");
      }
    }
  }
  /**
   * Resets the boundary back to a "clean" state.
   *
   * @remarks
   * Use this to allow the user to retry rendering, for example by wiring
   * it to a "Try again" button in the fallback UI.
   *
   * Note: If you use a custom {@link ErrorBoundaryProps.renderFallback},
   * you are responsible for calling this method via a ref.
   */
  reset() {
    this.setState({
      error: null,
      componentStack: void 0,
      timestamp: void 0
    });
  }
  /**
   * Handles reset-on-key-change logic.
   *
   * @param prevProps - Previous props before the update.
   *
   * @internal
   */
  componentDidUpdate(n) {
    const { enableResetOnKeyChange: i, resetKey: r } = this.props;
    i && n.resetKey !== r && this.state.error && this.reset();
  }
  /**
   * Renders either the children (no error) or the fallback UI.
   */
  render() {
    const { children: n, renderFallback: i } = this.props, { error: r, componentStack: a, timestamp: o } = this.state;
    if (!r)
      return n;
    const l = {
      error: r,
      componentStack: a,
      timestamp: o ?? /* @__PURE__ */ new Date()
    };
    return typeof i == "function" ? i(l) : /* @__PURE__ */ B("div", { className: Ci["error-boundary"], role: "alert", "aria-live": "assertive", children: [
      /* @__PURE__ */ _("div", { className: Ci["error-boundary__icon"], "aria-hidden": "true", children: "!" }),
      /* @__PURE__ */ B("div", { className: Ci["error-boundary__content"], children: [
        /* @__PURE__ */ _("h1", { className: Ci["error-boundary__title"], children: "Something went wrong" }),
        /* @__PURE__ */ _("p", { className: Ci["error-boundary__message"], children: "An unexpected error occurred while rendering this section of the application." }),
        /* @__PURE__ */ _("button", { type: "button", className: Ci["error-boundary__action"], onClick: () => this.reset(), children: "Try again" })
      ] })
    ] });
  }
}
const pt = {
  "ns-card": "_ns-card_1k7gv_11",
  "ns-card--variant-secondary": "_ns-card--variant-secondary_1k7gv_22",
  "ns-card__body": "_ns-card__body_1k7gv_27",
  "ns-card__heading": "_ns-card__heading_1k7gv_31",
  "ns-card__icon": "_ns-card__icon_1k7gv_42",
  "ns-card__heading-text": "_ns-card__heading-text_1k7gv_50",
  "ns-card__subheading": "_ns-card__subheading_1k7gv_56",
  "ns-card__toggle": "_ns-card__toggle_1k7gv_75",
  "ns-card-content-in": "_ns-card-content-in_1k7gv_1",
  "ns-card__header-actions": "_ns-card__header-actions_1k7gv_105",
  "ns-card__tags": "_ns-card__tags_1k7gv_117",
  "ns-card__tags--position-left": "_ns-card__tags--position-left_1k7gv_125",
  "ns-card__tags--position-right": "_ns-card__tags--position-right_1k7gv_128",
  "ns-card__tags--position-center": "_ns-card__tags--position-center_1k7gv_131",
  "ns-card__body--hidden": "_ns-card__body--hidden_1k7gv_143",
  "ns-card__footer": "_ns-card__footer_1k7gv_147",
  "ns-card__footer--stretch": "_ns-card__footer--stretch_1k7gv_151",
  "ns-card__footer--hidden": "_ns-card__footer--hidden_1k7gv_154"
};
var Na = /* @__PURE__ */ ((e) => (e.Default = "default", e.Secondary = "secondary", e))(Na || {});
function o0({
  "aria-label": e,
  variant: t = Na.Default,
  heading: n,
  subheading: i,
  headingContent: r,
  icon: a,
  actions: o,
  headerActions: l,
  headerControl: u,
  onAction: c,
  children: h,
  stretch: p = !1,
  tags: m,
  tagsContent: g,
  tagPosition: b = "left",
  open: v,
  defaultOpen: w = !0,
  onOpenChange: y,
  fullCardDisclosure: I = !1
}) {
  const [E, P] = Fn(v, w, y), S = v !== void 0, f = !r || !I || E, C = Q({
    [pt["ns-card"]]: !0,
    [pt[`ns-card--variant-${t}`]]: t !== Na.Default
  }), L = Q({
    [pt["ns-card__heading"]]: !0
  }), F = Q({
    [pt["ns-card__body"]]: !0,
    [pt["ns-card__body--hidden"]]: !f
  }), M = Q({
    [pt["ns-card__footer"]]: !0,
    [pt["ns-card__footer--stretch"]]: p,
    [pt["ns-card__footer--hidden"]]: !f
  }), z = Q({
    [pt["ns-card__tags"]]: !0,
    [pt[`ns-card__tags--position-${b}`]]: !0
  }), R = (H) => {
    c?.(H);
  }, j = () => l?.length || u != null ? /* @__PURE__ */ B(
    "div",
    {
      className: pt["ns-card__header-actions"],
      role: "presentation",
      onClick: (H) => {
        H.stopPropagation();
      },
      onKeyDown: (H) => {
        H.stopPropagation();
      },
      children: [
        l?.map((H) => /* @__PURE__ */ _(
          st,
          {
            ...H,
            onClick: (O) => {
              O.preventDefault(), O.stopPropagation(), R(H);
            }
          },
          H.name
        )),
        u
      ]
    }
  ) : null;
  return /* @__PURE__ */ B("section", { className: C, "aria-label": e, children: [
    /* @__PURE__ */ B("header", { className: L, children: [
      !r && /* @__PURE__ */ B(Ke, { children: [
        a && /* @__PURE__ */ _(ke, { name: a, className: pt["ns-card__icon"] }),
        /* @__PURE__ */ B("div", { className: pt["ns-card__heading-text"], children: [
          /* @__PURE__ */ _("span", { className: pt["ns-card__title"], children: n }),
          i && /* @__PURE__ */ _("span", { className: pt["ns-card__subheading"], children: i })
        ] }),
        /* @__PURE__ */ B("div", { className: z, children: [
          m?.map((H) => /* @__PURE__ */ _(hi, { ...H }, H.id)),
          g
        ] }),
        j()
      ] }),
      r && /* @__PURE__ */ B(
        "details",
        {
          open: E,
          onToggle: (H) => {
            const O = H.currentTarget, X = O.open;
            S && (O.open = v), P(X);
          },
          children: [
            /* @__PURE__ */ B("summary", { children: [
              a && /* @__PURE__ */ _(ke, { name: a, className: pt["ns-card__icon"] }),
              /* @__PURE__ */ B("div", { className: pt["ns-card__heading-text"], children: [
                /* @__PURE__ */ _("span", { className: pt["ns-card__title"], children: n }),
                i && /* @__PURE__ */ _("span", { className: pt["ns-card__subheading"], children: i })
              ] }),
              /* @__PURE__ */ B("div", { className: z, children: [
                m?.map((H) => /* @__PURE__ */ _(hi, { ...H }, H.id)),
                g
              ] }),
              j(),
              /* @__PURE__ */ _("span", { className: pt["ns-card__toggle"], children: /* @__PURE__ */ _(ke, { name: J.KeyboardArrowDown, size: 24 }) })
            ] }),
            /* @__PURE__ */ _("div", { children: r })
          ]
        }
      )
    ] }),
    h != null && /* @__PURE__ */ _("div", { className: F, children: h }),
    o?.length ? /* @__PURE__ */ _("footer", { className: M, children: o.map((H) => /* @__PURE__ */ _(st, { ...H, onClick: () => R(H) }, H.name)) }) : null
  ] });
}
const Pn = {
  "ns-drawer-overlay": "_ns-drawer-overlay_y0hou_1",
  "ns-drawer-overlay--open": "_ns-drawer-overlay--open_y0hou_10",
  "ns-drawer": "_ns-drawer_y0hou_1",
  "ns-drawer--open": "_ns-drawer--open_y0hou_40",
  "ns-drawer__header": "_ns-drawer__header_y0hou_63",
  "ns-drawer__title": "_ns-drawer__title_y0hou_72",
  "ns-drawer__close": "_ns-drawer__close_y0hou_80",
  "ns-drawer__body": "_ns-drawer__body_y0hou_106",
  "ns-drawer__footer": "_ns-drawer__footer_y0hou_114"
}, l0 = "ds-drawer-layer", u0 = ({
  id: e,
  isOpen: t,
  onClose: n,
  title: i,
  children: r,
  actions: a,
  onAction: o,
  closeOnBackdropClick: l = !0,
  closeOnEscape: u = !0,
  lockBodyScroll: c = !1,
  transitionDuration: h = "250ms",
  transitionEasing: p = "ease-in-out",
  "aria-label": m
}) => {
  const { panelRef: g, panel: b, handleBackdropClick: v, handleActionClick: w } = uo({
    isOpen: t,
    onClose: n,
    onAction: o,
    closeOnBackdropClick: l,
    closeOnEscape: u,
    lockBodyScroll: c
  }), y = Q({
    [Pn["ns-drawer-overlay"]]: !0,
    [Pn["ns-drawer-overlay--open"]]: t
  }), I = Q({
    [Pn["ns-drawer"]]: !0,
    [Pn["ns-drawer--open"]]: t
  });
  return di(
    /* @__PURE__ */ B("div", { style: {
      "--ns-drawer-transition-duration": h,
      "--ns-drawer-transition-easing": p
    }, children: [
      /* @__PURE__ */ _("div", { className: y, onClick: v, "aria-hidden": "true" }),
      /* @__PURE__ */ B(
        "div",
        {
          ref: g,
          id: e,
          role: "dialog",
          "aria-modal": "true",
          "aria-label": m ?? i,
          "aria-labelledby": `${e}-title`,
          tabIndex: -1,
          className: I,
          children: [
            /* @__PURE__ */ B("header", { className: Pn["ns-drawer__header"], children: [
              /* @__PURE__ */ _("h6", { id: `${e}-title`, className: Pn["ns-drawer__title"], children: i }),
              /* @__PURE__ */ _("button", { type: "button", className: Pn["ns-drawer__close"], "aria-label": "Close drawer", onClick: n, children: /* @__PURE__ */ _(ke, { name: J.Close, "aria-hidden": !0 }) })
            ] }),
            /* @__PURE__ */ _("div", { className: Pn["ns-drawer__body"], children: /* @__PURE__ */ _(lo.Provider, { value: b, children: r }) }),
            a?.length ? /* @__PURE__ */ _("footer", { className: Pn["ns-drawer__footer"], children: a.map((P) => /* @__PURE__ */ _(st, { ...P, onClick: () => w(P) }, P.name)) }) : null
          ]
        }
      )
    ] }),
    fi(l0)
  );
}, ni = {
  "ns-entity-editor": "_ns-entity-editor_13tza_1",
  "ns-entity-editor__form": "_ns-entity-editor__form_13tza_8",
  "ns-entity-editor__columns": "_ns-entity-editor__columns_13tza_26",
  "ns-entity-editor__column": "_ns-entity-editor__column_13tza_26",
  "ns-entity-editor__footer": "_ns-entity-editor__footer_13tza_40",
  "ns-entity-editor__separator": "_ns-entity-editor__separator_13tza_55"
};
function Dc(e, t) {
  return e.length < t ? `Must be at least ${t} character${t === 1 ? "" : "s"}` : null;
}
function Hr(e) {
  const [t, n] = e.split(":").map(Number);
  return (t ?? 0) * 60 + (n ?? 0);
}
function Pl(e) {
  const [t, n, i] = e.split("-");
  return `${n}/${i}/${t}`;
}
const c0 = /^\d{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\d|3[01])$/;
function h0(e, t) {
  return c0.test(t) ? e.minDate && t < e.minDate ? `Date must be on or after ${Pl(e.minDate)}` : e.maxDate && t > e.maxDate ? `Date must be on or before ${Pl(e.maxDate)}` : null : "Please enter a valid date (MM/DD/YYYY)";
}
const p0 = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;
function d0(e, t) {
  return p0.test(t) ? e.minLength !== void 0 ? Dc(t, e.minLength) : null : "Please enter a valid email address";
}
function f0(e, t) {
  const n = typeof t == "string" ? Number(t) : t;
  return Number.isNaN(n) ? "Please enter a valid number" : e.min !== void 0 && n < e.min ? `Value must be at least ${e.min}` : e.max !== void 0 && n > e.max ? `Value must be at most ${e.max}` : null;
}
function Tl(e, t) {
  return e.minLength !== void 0 ? Dc(t, e.minLength) : null;
}
const m0 = /^([01]\d|2[0-3]):[0-5]\d$/;
function g0(e, t) {
  return m0.test(t) ? e.minTime && Hr(t) < Hr(e.minTime) ? `Time must be at or after ${e.minTime}` : e.maxTime && Hr(t) > Hr(e.maxTime) ? `Time must be at or before ${e.maxTime}` : null : "Please enter a valid time";
}
function _0(e, t) {
  if (typeof t != "string")
    return null;
  switch (e.type) {
    case it.TextInput:
      return Tl(e, t);
    case it.EmailInput:
      return d0(e, t);
    case it.NumberInput:
      return f0(e, t);
    case it.PasswordInput:
      return Tl(e, t);
    case it.DatePicker:
      return h0(e, t);
    case it.TimePicker:
      return g0(e, t);
    default:
      return null;
  }
}
function x0(e) {
  if (!e.every((a) => "fields" in a))
    return e.map(
      (a) => "columns" in a && a.columns ? { columns: a.columns } : { isSeparator: !0 }
    );
  const i = [];
  let r = [];
  for (const a of e)
    a.isSeparator ? (r.length > 0 && (i.push({ columns: r }), r = []), i.push({ isSeparator: !0, isVisible: a.isVisible })) : r.push({ fields: a.fields, width: a.width });
  return r.length > 0 && i.push({ columns: r }), i;
}
function y0(e) {
  return e == null || e === "" || Array.isArray(e) && e.length === 0;
}
function ir(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function js(e, t, n = {}, i) {
  const r = /* @__PURE__ */ new Map();
  for (const a of e) {
    const o = t[a.key], l = y0(o);
    if (a.required && l) {
      r.set(a.key, a.errorHint ?? "This field is required");
      continue;
    }
    if (l)
      continue;
    const u = o === n[a.key], c = _0(a, o);
    if (c) {
      u || r.set(a.key, c);
      continue;
    }
    if (i) {
      const h = i(a, o, t);
      h && r.set(a.key, h);
    }
  }
  return r;
}
function b0(e, t) {
  const n = `${t.formId}-${String(e.key)}`, i = t.values[e.key], r = t.fieldErrors.get(e.key), a = r !== void 0, o = a ? Ne.Error : Ne.Default, l = a ? r : e.hint, u = typeof e.disabled == "function" ? e.disabled(t.values) : e.disabled, c = {
    id: n,
    name: String(e.key),
    label: e.label,
    description: e.description,
    hint: l,
    placeholder: e.placeholder,
    disabled: u,
    readOnly: e.readOnly,
    size: e.size,
    required: e.required,
    prefix: e.prefix,
    suffix: e.suffix,
    suffixCopy: e.suffixCopy,
    tooltip: e.tooltip,
    tooltipPlacement: e.tooltipPlacement,
    state: o
  };
  switch (e.type) {
    // -------------------------------------------------------------------------
    // Text-based inputs
    // -------------------------------------------------------------------------
    case it.TextInput: {
      const h = e;
      return /* @__PURE__ */ _(
        Ni,
        {
          ...c,
          inputType: ct.Text,
          value: i ?? "",
          maxLength: h.maxLength,
          showCounter: h.showCounter,
          onChange: (p) => t.onChange(h.key, p)
        }
      );
    }
    case it.EmailInput: {
      const h = e;
      return /* @__PURE__ */ _(
        Ni,
        {
          ...c,
          inputType: ct.Email,
          value: i ?? "",
          maxLength: h.maxLength,
          showCounter: h.showCounter,
          onChange: (p) => t.onChange(h.key, p)
        }
      );
    }
    case it.NumberInput: {
      const h = e;
      return /* @__PURE__ */ _(
        Ni,
        {
          ...c,
          inputType: ct.Number,
          value: i ?? "",
          onChange: (p) => t.onChange(h.key, p)
        }
      );
    }
    case it.PasswordInput: {
      const h = e;
      return /* @__PURE__ */ _(
        Ni,
        {
          ...c,
          revealable: !0,
          revealAriaLabel: h.revealAriaLabel,
          hideAriaLabel: h.hideAriaLabel,
          value: i ?? "",
          maxLength: h.maxLength,
          showCounter: h.showCounter,
          onChange: (p) => t.onChange(h.key, p)
        }
      );
    }
    case it.TextArea: {
      const h = e;
      return /* @__PURE__ */ _(
        _f,
        {
          id: n,
          name: String(h.key),
          label: h.label,
          description: h.description,
          hint: l,
          placeholder: h.placeholder,
          disabled: u,
          readOnly: h.readOnly,
          size: h.size,
          required: h.required,
          tooltip: h.tooltip,
          tooltipPlacement: h.tooltipPlacement,
          state: o,
          value: i ?? "",
          maxLength: h.maxLength,
          minLength: h.minLength,
          showCounter: h.showCounter,
          rows: h.rows,
          onChange: (p) => t.onChange(h.key, p)
        }
      );
    }
    // -------------------------------------------------------------------------
    // Selection inputs
    // -------------------------------------------------------------------------
    case it.Select: {
      const h = e;
      return /* @__PURE__ */ _(
        ao,
        {
          ...c,
          options: ir(h.options, t.values),
          value: i ?? null,
          emptyText: h.emptyText,
          popupPlacement: h.popupPlacement,
          onChange: (p) => t.onChange(h.key, p)
        }
      );
    }
    case it.MultiSelect: {
      const h = e;
      return /* @__PURE__ */ _(
        vc,
        {
          ...c,
          options: ir(h.options, t.values),
          value: i ?? [],
          noOptionsText: h.noOptionsText,
          maxSelections: h.maxSelections,
          popupPlacement: h.popupPlacement,
          onChange: (p) => t.onChange(h.key, p)
        }
      );
    }
    case it.ComboBox: {
      const h = e;
      return /* @__PURE__ */ _(
        bc,
        {
          ...c,
          options: ir(h.options, t.values),
          value: i ?? null,
          allowFreeInput: h.allowFreeInput,
          onFreeInput: (p) => {
            h.onFreeInput?.(p), t.onChange(h.key, p);
          },
          noOptionsText: h.noOptionsText,
          popupPlacement: h.popupPlacement,
          onChange: (p) => t.onChange(h.key, p)
        }
      );
    }
    // -------------------------------------------------------------------------
    // Date / time inputs
    // -------------------------------------------------------------------------
    case it.DatePicker: {
      const h = e;
      return /* @__PURE__ */ _(
        co,
        {
          ...c,
          value: i ?? null,
          minDate: h.minDate,
          maxDate: h.maxDate,
          isDateDisabled: h.isDateDisabled,
          popupPlacement: h.popupPlacement,
          onChange: (p) => t.onChange(h.key, p)
        }
      );
    }
    case it.TimePicker: {
      const h = e;
      return /* @__PURE__ */ _(
        ho,
        {
          ...c,
          value: i ?? null,
          minuteStep: h.minuteStep,
          minTime: h.minTime,
          maxTime: h.maxTime,
          popupPlacement: h.popupPlacement,
          onChange: (p) => t.onChange(h.key, p)
        }
      );
    }
    // -------------------------------------------------------------------------
    // Async entity input
    // -------------------------------------------------------------------------
    case it.EntityPicker: {
      const h = e, p = h.kind ?? String(h.key);
      return /* @__PURE__ */ _(
        po,
        {
          ...c,
          value: i ?? null,
          onSearch: (m) => t.onSearch?.(p, m, h.endpoint) ?? Promise.resolve([]),
          getOptionLabel: (m) => h.labelAttribute != null && m != null ? String(m[h.labelAttribute]) : t.getEntityLabel?.(p, m) ?? String(m),
          loadingText: h.loadingText,
          noResultsText: h.noResultsText,
          minSearchLength: h.minSearchLength,
          debounceMs: h.debounceMs,
          popupPlacement: h.popupPlacement,
          onChange: (m) => {
            const g = h.attributeAsValue != null && m != null ? m[h.attributeAsValue] : m;
            t.onChange(h.key, g);
          }
        }
      );
    }
    case it.CheckboxGroup: {
      const h = e, p = Array.isArray(i) ? i : [], m = ir(h.options, t.values);
      return /* @__PURE__ */ _(
        Qn,
        {
          id: n,
          label: h.label,
          description: h.description,
          hint: c.hint,
          required: h.required,
          disabled: c.disabled,
          state: c.state,
          tooltip: h.tooltip,
          tooltipPlacement: h.tooltipPlacement,
          suffixCopy: h.suffixCopy,
          children: /* @__PURE__ */ _("div", { style: {
            display: "flex",
            flexDirection: "column",
            gap: "var(--ns-spacing-space-2)",
            paddingTop: "var(--ns-spacing-space-1)"
          }, children: m.map((g) => /* @__PURE__ */ _(
            $i,
            {
              id: `${n}-${g.id}`,
              label: g.label,
              checked: p.includes(g.value),
              disabled: c.disabled,
              onChange: (b) => {
                const v = b ? [...p, g.value] : p.filter((w) => w !== g.value);
                t.onChange(h.key, v);
              }
            },
            g.id
          )) })
        }
      );
    }
    case it.Custom:
      return e.render({ values: t.values, onChange: t.onChange, disabled: u });
    case it.RadioGroup: {
      const h = e, p = ir(h.options, t.values).map((m) => ({
        value: m.value,
        label: m.label
      }));
      return /* @__PURE__ */ _(
        Df,
        {
          id: n,
          name: String(h.key),
          label: h.label,
          options: p,
          value: i ?? null,
          orientation: h.orientation,
          disabled: u,
          error: a,
          helperText: a ? r : h.hint,
          onChange: (m) => t.onChange(h.key, m)
        }
      );
    }
  }
}
function v0({
  "aria-label": e,
  bgcolor: t,
  entity: n,
  columns: i,
  onSave: r,
  onCancel: a,
  saveLabel: o = "Save",
  cancelLabel: l = "Cancel",
  validate: u,
  onSearch: c,
  getEntityLabel: h,
  instructions: p,
  transform: m,
  externalErrors: g,
  isSaving: b = !1
}) {
  const v = at(), [w, y] = Ee(() => ({ ...n })), [I, E] = Ee(/* @__PURE__ */ new Map()), [P, S] = Ee(/* @__PURE__ */ new Map()), f = x0(i), C = f.flatMap(
    (ie) => ie.isSeparator ? [] : ie.columns.flatMap(
      (V) => V.fields.filter(
        (de) => de.type !== it.Separator && de.type !== it.Custom
      )
    )
  ), L = (ie) => {
    const V = C.find((W) => ie.has(W.key));
    if (!V)
      return;
    const de = document.getElementById(`${v}-${String(V.key)}`), Se = typeof window < "u" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches === !0;
    de?.scrollIntoView?.({ block: "center", behavior: Se ? "auto" : "smooth" }), de?.focus?.({ preventScroll: !0 });
  };
  ve(() => {
    const ie = new Map(
      Object.entries(g ?? {}).filter(([, V]) => V != null)
    );
    S(ie), ie.size > 0 && L(new Set(ie.keys()));
  }, [g]);
  const F = new Map(P);
  I.forEach((ie, V) => F.set(V, ie));
  const M = Array.from(/* @__PURE__ */ new Set([...Object.keys(n), ...Object.keys(w)])).some((ie) => {
    const V = w[ie], de = n[ie];
    return Array.isArray(V) && Array.isArray(de) ? V.length !== de.length || V.some((Se, W) => Se !== de[W]) : V !== de;
  }), z = js(C, w, n, u).size === 0, R = (ie, V) => {
    y((W) => {
      let q = { ...W, [ie]: V };
      if (m) {
        const ne = m(ie, q);
        Object.keys(ne).length > 0 && (q = { ...q, ...ne });
      }
      return q;
    });
    const de = C.find((W) => W.key === ie), Se = de ? js([de], { ...w, [ie]: V }, n, u).get(ie) : void 0;
    E((W) => {
      const q = new Map(W);
      return Se !== void 0 ? q.set(ie, Se) : q.delete(ie), q;
    }), S((W) => {
      if (!W.has(ie))
        return W;
      const q = new Map(W);
      return q.delete(ie), q;
    });
  }, j = (ie) => {
    ie.preventDefault();
    const V = js(C, w, void 0, u);
    if (V.size > 0) {
      E(V), L(new Set(V.keys()));
      return;
    }
    r({ ...n, ...w });
  }, H = () => {
    y({ ...n }), E(/* @__PURE__ */ new Map()), S(/* @__PURE__ */ new Map()), a?.();
  }, O = {
    formId: v,
    values: w,
    fieldErrors: F,
    onChange: R,
    onSearch: c,
    getEntityLabel: h
  }, X = Q({ [ni["ns-entity-editor"]]: !0 }), K = Q({ [ni["ns-entity-editor__form"]]: !0 }), se = Q({ [ni["ns-entity-editor__columns"]]: !0 }), Y = Q({ [ni["ns-entity-editor__column"]]: !0 }), N = Q({ [ni["ns-entity-editor__footer"]]: !0 });
  return /* @__PURE__ */ _("section", { className: X, "aria-label": e, children: /* @__PURE__ */ B(
    "form",
    {
      className: K,
      onSubmit: j,
      noValidate: !0,
      "aria-label": e,
      style: {
        backgroundColor: t ?? "inherit"
      },
      children: [
        p,
        f.map((ie, V) => {
          if (ie.isSeparator)
            return ie.isVisible === !1 ? null : /* @__PURE__ */ _("hr", { className: ni["ns-entity-editor__separator"] }, `row-sep-${V}`);
          const de = ie.columns.map((Se) => Se.width ?? "1fr").join(" ");
          return /* @__PURE__ */ _(
            "div",
            {
              className: se,
              style: {
                "--ns-editor-grid-template": de
              },
              children: ie.columns.map((Se, W) => /* @__PURE__ */ _("div", { className: Y, children: Se.fields.map((q) => {
                if (q.type === it.Separator)
                  return /* @__PURE__ */ _("hr", { className: ni["ns-entity-editor__separator"] }, q.id);
                const ne = q;
                return /* @__PURE__ */ _("div", { children: b0(ne, O) }, String(ne.key));
              }) }, W))
            },
            V
          );
        }),
        /* @__PURE__ */ B("footer", { className: N, children: [
          /* @__PURE__ */ _(
            st,
            {
              text: l,
              variant: lt.Outlined,
              color: Re.Secondary,
              type: "button",
              onClick: H
            }
          ),
          /* @__PURE__ */ _(
            st,
            {
              text: o,
              variant: lt.Contained,
              color: Re.Primary,
              type: "submit",
              disabled: !M || !z || b
            }
          )
        ] })
      ]
    }
  ) });
}
const Si = {
  "ns-header": "_ns-header_1a30a_1",
  "ns-header__cta": "_ns-header__cta_1a30a_27",
  "ns-header__actions": "_ns-header__actions_1a30a_51",
  "ns-header__action": "_ns-header__action_1a30a_51",
  "ns-header__toggle": "_ns-header__toggle_1a30a_60"
};
function w0(e) {
  const { cta: t, ctaControls: n, ctaExpanded: i, ctaRef: r, logo: a, title: o, additionalActions: l } = e, { onCallToActionClick: u, onToggle: c } = e, [h, p] = Ee(!1), m = Q(Si["ns-header__action"]);
  return ve(() => {
    c(h);
  }, [h, c]), /* @__PURE__ */ B("header", { className: Si["ns-header"], children: [
    /* @__PURE__ */ B("h1", { children: [
      a,
      o
    ] }),
    /* @__PURE__ */ B("div", { className: Si["ns-header__actions"], children: [
      l,
      n ? /* @__PURE__ */ B(
        "button",
        {
          ref: r,
          "aria-controls": n,
          "aria-expanded": i ?? !1,
          "aria-haspopup": "dialog",
          "aria-label": t.config.label,
          className: Si["ns-header__cta"],
          onClick: u,
          type: "button",
          children: [
            t.config.icon && /* @__PURE__ */ _(ke, { className: m, name: t.config.icon }),
            t.config.text && /* @__PURE__ */ _("span", { children: t.config.text })
          ]
        }
      ) : /* @__PURE__ */ B(
        "a",
        {
          "aria-label": t.config.label,
          className: Si["ns-header__cta"],
          href: t.config.url,
          target: t.config.target ?? Mn.Self,
          rel: t.config.target === Mn.Blank ? "noopener noreferrer" : void 0,
          onClick: u,
          children: [
            t.config.icon && /* @__PURE__ */ _(ke, { className: m, name: t.config.icon }),
            t.config.text && /* @__PURE__ */ _("span", { children: t.config.text })
          ]
        }
      ),
      /* @__PURE__ */ _(
        "button",
        {
          "aria-expanded": h,
          "aria-label": h ? "Close navigation menu" : "Open navigation menu",
          className: Si["ns-header__toggle"],
          onClick: () => p((g) => !g),
          type: "button",
          children: /* @__PURE__ */ _(
            ke,
            {
              name: h ? J.Close : J.Menu,
              color: "var(--ns-color-neutral-white)"
            }
          )
        }
      )
    ] })
  ] });
}
const k0 = "_middle_152j5_325", et = {
  "ns-sidebar": "_ns-sidebar_152j5_1",
  "ns-sidebar__toggle": "_ns-sidebar__toggle_152j5_22",
  "ns-sidebar--expanded": "_ns-sidebar--expanded_152j5_48",
  "ns-sidebar__nav-strip": "_ns-sidebar__nav-strip_152j5_51",
  "ns-sidebar__nav-strip--active": "_ns-sidebar__nav-strip--active_152j5_115",
  "ns-sidebar__nav-panel": "_ns-sidebar__nav-panel_152j5_119",
  "ns-sidebar__nav-panel--disabled": "_ns-sidebar__nav-panel--disabled_152j5_196",
  "ns-sidebar__entity-panel": "_ns-sidebar__entity-panel_152j5_209",
  "status-filter-heading": "_status-filter-heading_152j5_239",
  "ns-sidebar__entity-panel-list-item": "_ns-sidebar__entity-panel-list-item_152j5_252",
  "ns-sidebar__entity-menu-trigger": "_ns-sidebar__entity-menu-trigger_152j5_317",
  middle: k0,
  "status-icon": "_status-icon_152j5_338",
  "suffix-icon": "_suffix-icon_152j5_348",
  "ns-sidebar__entity-panel-list-item--active": "_ns-sidebar__entity-panel-list-item--active_152j5_376",
  "ns-sidebar__entity-panel-list-item--disabled": "_ns-sidebar__entity-panel-list-item--disabled_152j5_380",
  "ns-sidebar__filter-controls": "_ns-sidebar__filter-controls_152j5_400",
  "ns-sidebar__filter-input": "_ns-sidebar__filter-input_152j5_407",
  "ns-sidebar__filter-chips": "_ns-sidebar__filter-chips_152j5_410",
  "ns-sidebar__nav-panel--active": "_ns-sidebar__nav-panel--active_152j5_417",
  "ns-sidebar__panel-footer": "_ns-sidebar__panel-footer_152j5_423",
  "no-items": "_no-items_152j5_428",
  "ns-sidebar__backdrop--expanded": "_ns-sidebar__backdrop--expanded_152j5_438",
  "ns-sidebar__backdrop": "_ns-sidebar__backdrop_152j5_438"
};
function C0({
  entity: e,
  entityNameSingular: t,
  uIdAttribute: n,
  textAttribute: i,
  subtextAttribute: r,
  displayIdAttribute: a,
  isActive: o,
  isDisabled: l = !1,
  prefixIcon: u,
  suffixIcon: c,
  contextMenu: h,
  contextMenuFor: p,
  onEntityClick: m,
  onEntityContextMenuAction: g
}) {
  const b = re(null), v = e[n], w = a ? e[a] : v, y = i.split(".").reduce((L, F) => {
    if (L !== null && typeof L == "object" && Object.prototype.hasOwnProperty.call(L, F))
      return L[F];
  }, e), I = y !== null && typeof y == "object" && r && Object.prototype.hasOwnProperty.call(y, r) ? y[r] : y, P = typeof I == "string" || typeof I == "number" ? String(I) : "", S = p?.(e) ?? h, f = $e(() => S ? S.items.map((L) => L.type === "divider" ? { type: "divider", id: L.id } : L.type === "anchor" ? {
    type: "anchor",
    id: L.id,
    label: L.label ?? "",
    href: L.href ?? "#",
    target: L.target,
    prefix: L.prefix,
    suffix: L.suffix,
    danger: L.danger,
    disabled: L.disabled,
    tooltip: L.tooltip,
    tooltipPlacement: L.tooltipPlacement,
    onClick: () => g?.(v, L.id)
  } : {
    type: "button",
    id: L.id,
    label: L.label ?? "",
    prefix: L.prefix,
    suffix: L.suffix,
    danger: L.danger,
    disabled: L.disabled,
    tooltip: L.tooltip,
    tooltipPlacement: L.tooltipPlacement,
    onClick: () => g?.(v, L.id)
  }) : [], [S, v, g]), C = Q({
    [et["ns-sidebar__entity-panel-list-item"]]: !0,
    [et["ns-sidebar__entity-panel-list-item--active"]]: o,
    [et["ns-sidebar__entity-panel-list-item--disabled"]]: l
  });
  return /* @__PURE__ */ B("li", { className: C, children: [
    /* @__PURE__ */ B(
      "button",
      {
        type: "button",
        tabIndex: 0,
        className: et["ns-sidebar__entity-row"],
        disabled: l,
        "aria-current": o ? "page" : void 0,
        onClick: () => m(v),
        children: [
          u && /* @__PURE__ */ _(ke, { className: et["status-icon"], name: u, "aria-hidden": "true" }),
          /* @__PURE__ */ B("div", { className: et.middle, children: [
            /* @__PURE__ */ _("span", { children: P }),
            /* @__PURE__ */ B("span", { children: [
              "#",
              w
            ] })
          ] }),
          c && /* @__PURE__ */ B(Ke, { children: [
            /* @__PURE__ */ _(Ic, { children: c.tooltip }),
            /* @__PURE__ */ _(
              ke,
              {
                className: et["suffix-icon"],
                name: c.icon,
                tooltip: c.tooltip
              }
            )
          ] })
        ]
      }
    ),
    S && f.length > 0 && /* @__PURE__ */ B(Ke, { children: [
      /* @__PURE__ */ _(
        "button",
        {
          type: "button",
          className: et["ns-sidebar__entity-menu-trigger"],
          "aria-label": `Actions for ${t} ${w}`,
          disabled: l,
          ref: b,
          children: /* @__PURE__ */ _(ke, { tooltip: `${t} Options`, name: J.MoreVert, "aria-hidden": "true" })
        }
      ),
      /* @__PURE__ */ _(
        Kn,
        {
          id: `context-menu-for-${v}`,
          label: `Actions for ${t} ${w}`,
          items: f,
          placement: S.placement,
          anchorRef: b,
          disabled: l
        }
      )
    ] })
  ] });
}
function Vc(e, t) {
  const n = t.split(".");
  let i = e;
  for (const r of n) {
    if (i == null || typeof i != "object")
      return;
    i = i[r];
  }
  if (typeof i == "string" || typeof i == "number" || typeof i == "boolean")
    return i;
}
function S0({
  items: e,
  filterFields: t,
  query: n
}) {
  const i = n.trim().toLowerCase();
  if (!i)
    return e;
  const r = [];
  for (const a of e)
    for (let o = 0; o < t.length; o++) {
      const l = Vc(a, t[o]);
      if (l != null && String(l).toLowerCase().includes(i)) {
        r.push({ item: a, matchIndex: o });
        break;
      }
    }
  return r.sort((a, o) => a.matchIndex - o.matchIndex), r.map((a) => a.item);
}
function E0({
  items: e,
  filterField: t,
  query: n
}) {
  if (!n.length)
    return e;
  const i = [], r = n.reduce((a, o, l) => (a[o] = l, a), {});
  for (const a of e) {
    const o = Vc(a, t);
    o && n.includes(`${o}`) && i.push({ item: a, matchIndex: r[`${o}`] });
  }
  return i.sort((a, o) => a.matchIndex - o.matchIndex), i.map((a) => a.item);
}
function A0({
  icon: e,
  entities: t,
  filterTerm: n,
  entityNameSingular: i,
  entityNamePlural: r,
  activeEntityId: a,
  isFilterable: o,
  uIdAttribute: l,
  textAttribute: u,
  subtextAttribute: c,
  displayIdAttribute: h,
  filterBy: p,
  valueFilter: m,
  prefixIconField: g,
  selectedFilterValues: b = [],
  contextMenu: v,
  contextMenuFor: w,
  disabledFor: y,
  suffixIconFor: I,
  onEntityClick: E = () => {
  },
  onEntityFilter: P = () => {
  },
  onEntityContextMenuAction: S = () => {
  },
  onFilterChange: f = () => {
  }
}) {
  const C = re(null), L = $e(() => m ? m.options.map((j) => ({
    type: "checkbox",
    id: j.id,
    label: j.label,
    prefix: j.prefix,
    checked: b.includes(j.value),
    onChange: (H) => {
      const O = H ? [...b, j.value] : b.filter((X) => X !== j.value);
      f(O);
    }
  })) : [], [m, b, f]), F = $e(() => !g || !m ? null : Object.fromEntries(m.options.filter((j) => j.prefix).map((j) => [j.value, j.prefix])), [g, m]), M = $e(() => {
    P(n);
    let j = S0({ items: t, filterFields: p, query: n });
    return m && b.length > 0 && (j = E0({
      items: j,
      filterField: m.field,
      query: b
    })), j;
  }, [t, p, n, m, b]), z = Q({
    [et["ns-sidebar__entity-panel"]]: !0
  }), R = () => M.length ? /* @__PURE__ */ _("ul", { children: M.map((j) => /* @__PURE__ */ _(
    C0,
    {
      entity: j,
      entityNameSingular: i,
      uIdAttribute: l,
      textAttribute: u,
      subtextAttribute: c,
      displayIdAttribute: h,
      isActive: a === j.id,
      isDisabled: y?.(j) ?? !1,
      prefixIcon: g ? F?.[j[g]] ?? void 0 : void 0,
      contextMenu: v,
      contextMenuFor: w,
      suffixIcon: I?.(j),
      onEntityClick: E,
      onEntityContextMenuAction: S
    },
    j.id
  )) }) : /* @__PURE__ */ B("p", { className: et["no-items"], children: [
    "No ",
    r,
    " found"
  ] });
  return /* @__PURE__ */ B("section", { className: z, children: [
    o && /* @__PURE__ */ B(Ke, { children: [
      /* @__PURE__ */ B("div", { className: et["ns-sidebar__filter-controls"], children: [
        /* @__PURE__ */ _(
          Jd,
          {
            className: et["ns-sidebar__filter-input"],
            placeholder: `Search ${r}`,
            value: n,
            onChange: P,
            prefix: J.Search
          }
        ),
        m && /* @__PURE__ */ B(Ke, { children: [
          /* @__PURE__ */ _(
            st,
            {
              ref: C,
              label: `Filter ${i}`,
              icon: J.FilterList,
              isIconOnly: !0,
              size: Mt.Large,
              variant: lt.Outlined,
              color: Re.Primary,
              tooltip: m.tooltip ?? `Filter ${r}`,
              tooltipPlacement: "right"
            }
          ),
          /* @__PURE__ */ _(
            Kn,
            {
              id: "context-menu-for-entity-filters",
              label: `Filter ${r}`,
              items: L,
              placement: "bottom-start",
              anchorRef: C
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ _("span", { className: et["status-filter-heading"], children: "Status Filter" }),
      m && b.length > 0 && /* @__PURE__ */ _("div", { className: et["ns-sidebar__filter-chips"], children: b.map((j) => {
        const H = m.options.find((O) => O.value === j);
        return H ? /* @__PURE__ */ _(
          hi,
          {
            id: H.id,
            label: H.label,
            text: H.label,
            variant: yr.Outlined,
            color: H?.color ?? Re.Secondary,
            className: H?.className,
            onDismiss: () => f(b.filter((O) => O !== j))
          },
          H.id
        ) : null;
      }) })
    ] }),
    R()
  ] });
}
function I0({ item: e, classNames: t, onNavitemClick: n = () => {
} }) {
  const i = re(null), r = e.disabled === !0, a = e.target ?? Mn.Self, o = a === Mn.Blank;
  return /* @__PURE__ */ B(
    "a",
    {
      className: t,
      href: e.href,
      ref: i,
      "aria-label": e.label,
      "aria-disabled": r || void 0,
      "data-disabled": r ? "true" : void 0,
      "data-nav-item-id": e.id,
      target: a,
      rel: o ? "noopener noreferrer" : void 0,
      onClick: (l) => {
        if (r) {
          l.preventDefault();
          return;
        }
        a === Mn.Self && l.preventDefault(), n(e.id);
      },
      children: [
        e.icon && /* @__PURE__ */ _(ke, { name: e.icon }),
        e.text,
        e.count !== void 0 ? /* @__PURE__ */ B("span", { style: { marginLeft: "auto" }, children: [
          "(",
          e.count,
          ")"
        ] }) : null,
        e.tooltip ? /* @__PURE__ */ _(cn, { id: `tooltip-${e.id}`, content: e.tooltip, anchorRef: i, placement: "right" }) : null
      ]
    }
  );
}
function L0({ activeNavitemId: e, items: t, onNavitemClick: n = () => {
} }) {
  const i = Q({
    [et["ns-sidebar__nav-panel"]]: !0
  });
  return /* @__PURE__ */ _("ul", { className: i, children: t.filter((r) => r.display).map((r) => {
    const a = Q({
      [et["ns-sidebar__nav-panel--active"]]: e === r.id && !r.disabled,
      [et["ns-sidebar__nav-panel--disabled"]]: r.disabled
    });
    return /* @__PURE__ */ _("li", { children: /* @__PURE__ */ _(I0, { item: r, classNames: a, onNavitemClick: n }) }, r.id);
  }) });
}
var Da = /* @__PURE__ */ ((e) => (e.Navigation = "Navigation", e.Entity = "Entity", e))(Da || {}), Va = /* @__PURE__ */ ((e) => (e.Button = "button", e.Link = "link", e))(Va || {});
function P0({
  filterTerm: e = "",
  activePanelId: t = "",
  activeEntityId: n,
  activeNavitemId: i,
  isExpanded: r,
  panels: a,
  entities: o,
  onPanelClick: l = () => {
  },
  onEntityClick: u = () => {
  },
  onEntityFilter: c = () => {
  },
  onNavClick: h = () => {
  },
  onPanelCtaClick: p = () => {
  },
  onEntityContextMenuAction: m,
  onToggle: g,
  selectedFilterValues: b = [],
  onFilterChange: v = () => {
  },
  userBadge: w,
  panelFooter: y
}) {
  const I = t.length ? t : Object.values(a).shift()?.id, E = a[I], P = re(null), S = Q({
    [et["ns-sidebar"]]: !0,
    [et["ns-sidebar--expanded"]]: r
  }), f = Q({
    [et["ns-sidebar__backdrop"]]: !0,
    [et["ns-sidebar__backdrop--expanded"]]: r
  }), C = (R) => {
    u(R);
  }, L = Q({
    [et["ns-sidebar__nav-strip"]]: !0
  }), F = Q({
    [et["ns-sidebar__nav-panel"]]: !0
  }), M = () => {
    if (!E?.cta || !E.cta.display)
      return null;
    if (E.cta.type === Va.Button)
      return /* @__PURE__ */ _(
        st,
        {
          ...E.cta.config,
          onClick: () => p(E.id),
          isIconOnly: !0,
          tooltip: E.cta.config.tooltip,
          tooltipPlacement: E.cta.config.tooltipPlacement
        }
      );
    if (E.cta.type === Va.Link) {
      const { id: R, label: j, title: H, text: O, url: X, target: K } = E.cta.config;
      return /* @__PURE__ */ _(Ir, { id: R, ariaLabel: j, title: H, text: O, url: X, target: K });
    }
    return null;
  }, z = () => E?.type === Da.Navigation ? /* @__PURE__ */ _(L0, { ...E.config, activeNavitemId: i, onNavitemClick: h }) : E?.type === Da.Entity ? /* @__PURE__ */ _(
    A0,
    {
      ...E.config,
      entities: o[E.id] ?? [],
      contextMenu: E.config.contextMenu,
      activeEntityId: n,
      onEntityClick: C,
      filterTerm: e,
      onEntityFilter: c,
      selectedFilterValues: b,
      onFilterChange: v,
      onEntityContextMenuAction: (R, j) => m?.(E.id, R, j)
    }
  ) : null;
  return /* @__PURE__ */ B(Ke, { children: [
    /* @__PURE__ */ _(
      "div",
      {
        className: f,
        onClick: () => g(),
        onKeyDown: (R) => {
          ["Enter", "Space"].includes(R.code) && g();
        }
      }
    ),
    /* @__PURE__ */ B("aside", { className: S, children: [
      /* @__PURE__ */ B(
        "button",
        {
          ref: P,
          "aria-label": r ? "Shrink" : "Expand",
          tabIndex: 0,
          className: et["ns-sidebar__toggle"],
          onClick: () => g(),
          children: [
            /* @__PURE__ */ _(
              cn,
              {
                id: "tooltip-toggle",
                content: r ? "Collapse" : "Expand",
                anchorRef: P,
                placement: "right"
              }
            ),
            /* @__PURE__ */ _(ke, { "aria-hidden": !0, name: r ? J.ChevronLeft : J.ChevronRight })
          ]
        }
      ),
      /* @__PURE__ */ B("section", { children: [
        /* @__PURE__ */ B("nav", { className: L, children: [
          /* @__PURE__ */ _("header", { children: w !== null ? w : /* @__PURE__ */ _("div", { children: "AM" }) }),
          Object.entries(a).filter(([, R]) => R.showInNavStrip !== !1).map(([R, j]) => /* @__PURE__ */ _(
            "button",
            {
              "aria-label": j.tooltip ?? j.title ?? R,
              className: Q({
                [et["ns-sidebar__nav-strip--active"]]: t === R
              }),
              onClick: () => {
                r || g(), l(R);
              },
              children: /* @__PURE__ */ _(ke, { name: j.icon, tooltip: j.tooltip, tooltipPlacement: "right" })
            },
            R
          ))
        ] }),
        /* @__PURE__ */ B("nav", { className: F, children: [
          /* @__PURE__ */ B("header", { children: [
            /* @__PURE__ */ _("h2", { children: E?.title }),
            M()
          ] }),
          z(),
          y ? /* @__PURE__ */ _("div", { className: et["ns-sidebar__panel-footer"], children: y }) : null,
          /* @__PURE__ */ _(vf, {})
        ] })
      ] })
    ] })
  ] });
}
const T0 = "_subheader_166lu_42", N0 = "_link_166lu_96", bn = {
  "ns-table": "_ns-table_166lu_1",
  "color-success": "_color-success_166lu_9",
  "color-failure": "_color-failure_166lu_12",
  "header-cell": "_header-cell_166lu_30",
  "header-text": "_header-text_166lu_35",
  subheader: T0,
  "header-icon": "_header-icon_166lu_50",
  "drag-button": "_drag-button_166lu_64",
  "cell-subheader": "_cell-subheader_166lu_88",
  link: N0
};
function D0({ kind: e, value: t, label: n }) {
  return /* @__PURE__ */ _("td", { children: t ? /* @__PURE__ */ B("span", { children: [
    /* @__PURE__ */ _(ke, { name: J.Done, className: bn["color-success"] }),
    " ",
    n
  ] }) : /* @__PURE__ */ B("span", { children: [
    /* @__PURE__ */ _(ke, { name: J.Close, className: bn["color-failure"] }),
    " ",
    n
  ] }) });
}
function V0({ kind: e, icon: t }) {
  return /* @__PURE__ */ _("td", { children: t ?? /* @__PURE__ */ _(ke, { name: J.MoreVert, className: "dd-handle" }) });
}
function M0({ kind: e, text: t, label: n, href: i, target: r = "_blank", icon: a }) {
  return /* @__PURE__ */ _("td", { children: /* @__PURE__ */ B(Ir, { url: i, target: r, ariaLabel: n, title: n, children: [
    t,
    " ",
    a ?? /* @__PURE__ */ _(ke, { name: J.Launch, className: bn.link })
  ] }) });
}
function F0({ kind: e, items: t }) {
  return /* @__PURE__ */ _("td", { children: /* @__PURE__ */ _("ul", { className: "list", children: t.map((n, i) => /* @__PURE__ */ _("li", { children: n }, `${n}-${i}`)) }) });
}
function R0({ kind: e, text: t, subtext: n }) {
  return /* @__PURE__ */ B("td", { children: [
    /* @__PURE__ */ _("span", { children: t }),
    /* @__PURE__ */ _("span", { className: bn["cell-subheader"], children: n })
  ] });
}
function O0({ caption: e, columns: t, data: n }) {
  return /* @__PURE__ */ B("table", { className: bn["ns-table"], children: [
    e && /* @__PURE__ */ _("caption", { children: e }),
    /* @__PURE__ */ _("thead", { children: /* @__PURE__ */ B("tr", { children: [
      /* @__PURE__ */ _("td", { children: " " }),
      t.map((i) => /* @__PURE__ */ _("th", { children: /* @__PURE__ */ B("div", { className: bn["header-cell"], children: [
        /* @__PURE__ */ B("div", { className: bn["header-text"], children: [
          /* @__PURE__ */ _("span", { children: i.header ?? i.key }),
          i.subheader && /* @__PURE__ */ _("span", { className: bn.subheader, children: i.subheader })
        ] }),
        /* @__PURE__ */ _("div", { className: bn["header-icon"], children: i.isSortable && /* @__PURE__ */ _(ke, { name: J.Sort }) })
      ] }) }, i.key))
    ] }) }),
    /* @__PURE__ */ _("tbody", { children: n.map((i) => /* @__PURE__ */ B("tr", { children: [
      /* @__PURE__ */ _("td", { className: bn["drag-button"], children: /* @__PURE__ */ _(ke, { name: J.MoreVert }) }),
      t.map((r) => {
        const a = i[r.key];
        switch (r.type) {
          case "text":
            return /* @__PURE__ */ _(R0, { ...a });
          case "binary":
            return /* @__PURE__ */ _(D0, { ...a });
          case "link":
            return /* @__PURE__ */ _(M0, { ...a });
          case "icon":
            return /* @__PURE__ */ _(V0, { ...a });
          case "list":
            return /* @__PURE__ */ _(F0, { ...a });
          default:
            return /* @__PURE__ */ _("td", {}, r.key);
        }
      })
    ] }, crypto.randomUUID())) })
  ] });
}
const gn = {
  "ns-entity-viewer": "_ns-entity-viewer_113m3_1",
  "ns-entity-viewer__columns": "_ns-entity-viewer__columns_113m3_11",
  "ns-entity-viewer__column": "_ns-entity-viewer__column_113m3_11",
  "ns-entity-viewer__term": "_ns-entity-viewer__term_113m3_28",
  "ns-entity-viewer__property-actions": "_ns-entity-viewer__property-actions_113m3_45",
  "ns-entity-viewer__label-tooltip": "_ns-entity-viewer__label-tooltip_113m3_52",
  "ns-entity-viewer__value": "_ns-entity-viewer__value_113m3_59",
  "ns-entity-viewer__email": "_ns-entity-viewer__email_113m3_70",
  "ns-entity-viewer__list": "_ns-entity-viewer__list_113m3_74",
  "ns-entity-viewer__action": "_ns-entity-viewer__action_113m3_80"
};
var ns = /* @__PURE__ */ ((e) => (e.Email = "email", e.List = "list", e.Text = "text", e))(ns || {});
function i5(e) {
  return e;
}
function B0({
  actions: e,
  className: t,
  onAction: n
}) {
  return /* @__PURE__ */ _("div", { className: t, children: e.map((i) => /* @__PURE__ */ _(st, { ...i, onClick: () => n(i) }, i.name)) });
}
function z0({ content: e, className: t }) {
  const n = re(null), i = at();
  return /* @__PURE__ */ B(Ke, { children: [
    /* @__PURE__ */ _(
      "span",
      {
        ref: n,
        role: "img",
        "aria-label": e,
        tabIndex: 0,
        className: t,
        children: /* @__PURE__ */ _(ke, { name: J.InfoOutline, size: 20, "aria-hidden": "true" })
      }
    ),
    /* @__PURE__ */ _(cn, { id: i, content: e, anchorRef: n })
  ] });
}
function Hs(e, t = "") {
  return typeof e == "string" ? e : typeof e == "number" || typeof e == "boolean" || typeof e == "bigint" ? String(e) : t;
}
function j0(e, t) {
  switch (t) {
    case ns.Email: {
      const n = Hs(e);
      return /* @__PURE__ */ _(Ir, { url: `mailto:${n}`, text: n, className: gn["ns-entity-viewer__email"] });
    }
    case ns.List: {
      const n = Array.isArray(e) ? e.map(String) : [Hs(e)];
      return /* @__PURE__ */ _("ul", { className: gn["ns-entity-viewer__list"], children: n.map((i, r) => (
        // Index keys are acceptable here: list items are static display
        // data with no identity beyond their position. // NOSONAR
        /* @__PURE__ */ _("li", { children: i }, r)
      )) });
    }
    case ns.Text:
    default:
      return /* @__PURE__ */ _(Ke, { children: Hs(e) });
  }
}
function H0({
  "aria-label": e,
  entity: t,
  columns: n,
  action: i,
  onAction: r
}) {
  if (!t)
    return null;
  const a = Q({
    [gn["ns-entity-viewer"]]: !0
  }), o = Q({
    [gn["ns-entity-viewer__columns"]]: !0
  }), l = n.map((y) => y.width ?? "1fr").join(" "), u = Math.max(1, ...n.map((y) => y.properties.length)), c = Array.from({ length: u * 2 }, () => "auto").join(" "), h = Q({
    [gn["ns-entity-viewer__column"]]: !0
  }), p = Q({
    [gn["ns-entity-viewer__term"]]: !0
  }), m = Q({
    [gn["ns-entity-viewer__value"]]: !0
  }), g = Q({
    [gn["ns-entity-viewer__action"]]: !0
  }), b = Q({
    [gn["ns-entity-viewer__property-actions"]]: !0
  }), v = Q({
    [gn["ns-entity-viewer__label-tooltip"]]: !0
  }), w = (y) => {
    r?.(y);
  };
  return /* @__PURE__ */ B("section", { className: a, "aria-label": e, children: [
    /* @__PURE__ */ _(
      "div",
      {
        className: o,
        style: {
          "--ns-viewer-grid-template": l,
          "--ns-viewer-grid-rows": c
        },
        children: n.map((y, I) => /* @__PURE__ */ _(
          "dl",
          {
            className: h,
            style: { gridRow: `span ${Math.max(1, y.properties.length * 2)}` },
            children: y.properties.map((E) => /* @__PURE__ */ B(io, { children: [
              /* @__PURE__ */ B("dt", { className: p, children: [
                /* @__PURE__ */ _("span", { children: E.label }),
                E.labelTooltip ? /* @__PURE__ */ _(
                  z0,
                  {
                    content: E.labelTooltip,
                    className: v
                  }
                ) : null,
                E.actions?.length ? /* @__PURE__ */ _(
                  B0,
                  {
                    actions: E.actions,
                    className: b,
                    onAction: w
                  }
                ) : null
              ] }),
              /* @__PURE__ */ _("dd", { className: m, children: E.transform ? E.transform(t[E.key]) : j0(t[E.key], E.format) })
            ] }, String(E.key)))
          },
          I
        ))
      }
    ),
    i ? /* @__PURE__ */ _("div", { className: g, children: /* @__PURE__ */ _(st, { ...i, onClick: () => w(i) }) }) : null
  ] });
}
const Ut = {
  "ns-dialog-overlay": "_ns-dialog-overlay_y8ami_1",
  "ns-dialog-overlay--open": "_ns-dialog-overlay--open_y8ami_10",
  "ns-dialog-positioner": "_ns-dialog-positioner_y8ami_20",
  "ns-dialog--open": "_ns-dialog--open_y8ami_29",
  "ns-dialog": "_ns-dialog_y8ami_1",
  "ns-dialog__header": "_ns-dialog__header_y8ami_71",
  "ns-dialog__header-text": "_ns-dialog__header-text_y8ami_80",
  "ns-dialog__title": "_ns-dialog__title_y8ami_87",
  "ns-dialog__description": "_ns-dialog__description_y8ami_95",
  "ns-dialog__close": "_ns-dialog__close_y8ami_102",
  "ns-dialog__body": "_ns-dialog__body_y8ami_128",
  "ns-dialog__footer": "_ns-dialog__footer_y8ami_133"
}, $0 = "ds-dialog-layer", q0 = ({
  id: e,
  isOpen: t,
  onClose: n,
  title: i,
  description: r,
  children: a,
  size: o = "md",
  actions: l,
  onAction: u,
  closeOnBackdropClick: c = !0,
  closeOnEscape: h = !0,
  lockBodyScroll: p = !0,
  transitionDuration: m = "200ms",
  transitionEasing: g = "ease-out",
  "aria-label": b
}) => {
  const { panelRef: v, panel: w, handleBackdropClick: y, handleActionClick: I } = uo({
    isOpen: t,
    onClose: n,
    onAction: u,
    closeOnBackdropClick: c,
    closeOnEscape: h,
    lockBodyScroll: p
  }), E = Q({
    [Ut["ns-dialog-overlay"]]: !0,
    [Ut["ns-dialog-overlay--open"]]: t
  }), P = Q({
    [Ut["ns-dialog"]]: !0,
    [Ut[`ns-dialog--size-${o}`]]: !0,
    [Ut["ns-dialog--open"]]: t
  });
  return di(
    /* @__PURE__ */ B("div", { style: {
      "--ns-dialog-transition-duration": m,
      "--ns-dialog-transition-easing": g
    }, children: [
      /* @__PURE__ */ _("div", { className: E, onClick: y, "aria-hidden": "true" }),
      /* @__PURE__ */ _("div", { className: Ut["ns-dialog-positioner"], children: /* @__PURE__ */ B(
        "dialog",
        {
          ref: v,
          id: e,
          open: !0,
          "aria-hidden": !t || void 0,
          "aria-modal": t ? "true" : void 0,
          inert: !t || void 0,
          "aria-label": b ?? i,
          "aria-labelledby": i ? `${e}-title` : void 0,
          "aria-describedby": r ? `${e}-description` : void 0,
          tabIndex: -1,
          className: P,
          children: [
            /* @__PURE__ */ B("header", { className: Ut["ns-dialog__header"], children: [
              /* @__PURE__ */ B("div", { className: Ut["ns-dialog__header-text"], children: [
                /* @__PURE__ */ _("h6", { id: `${e}-title`, className: Ut["ns-dialog__title"], children: i }),
                r && /* @__PURE__ */ _("p", { id: `${e}-description`, className: Ut["ns-dialog__description"], children: r })
              ] }),
              /* @__PURE__ */ _("button", { type: "button", className: Ut["ns-dialog__close"], "aria-label": "Close dialog", onClick: n, children: /* @__PURE__ */ _(ke, { name: J.Close, "aria-hidden": !0 }) })
            ] }),
            /* @__PURE__ */ _("div", { className: Ut["ns-dialog__body"], children: /* @__PURE__ */ _(lo.Provider, { value: w, children: a }) }),
            l?.length ? /* @__PURE__ */ _("footer", { className: Ut["ns-dialog__footer"], children: l.map((f) => /* @__PURE__ */ _(st, { ...f, onClick: () => I(f) }, f.name)) }) : null
          ]
        }
      ) })
    ] }),
    fi($0)
  );
}, U0 = "_token_v25we_1", J0 = "_copyButton_v25we_11", W0 = "_swatch_v25we_16", X0 = "_value_v25we_23", Z0 = "_tooltip_v25we_49", G0 = "_copyButtonDone_v25we_62", K0 = "_buttonIcon_v25we_70", Y0 = "_srOnly_v25we_107", Dn = {
  token: U0,
  copyButton: J0,
  swatch: W0,
  value: X0,
  tooltip: Z0,
  copyButtonDone: G0,
  buttonIcon: K0,
  srOnly: Y0
};
function Q0({ color: e }) {
  return /* @__PURE__ */ _(
    "svg",
    {
      className: Dn.swatch,
      width: "10",
      height: "10",
      viewBox: "0 0 10 10",
      "aria-hidden": "true",
      focusable: "false",
      children: /* @__PURE__ */ _("circle", { cx: "5", cy: "5", r: "4", fill: e, stroke: "rgba(0,0,0,0.15)", strokeWidth: "0.5" })
    }
  );
}
function e1() {
  return /* @__PURE__ */ _(
    "svg",
    {
      className: Dn.buttonIcon,
      width: "12",
      height: "12",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      focusable: "false",
      children: /* @__PURE__ */ _("path", { d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" })
    }
  );
}
function t1() {
  return /* @__PURE__ */ _(
    "svg",
    {
      className: Dn.buttonIcon,
      width: "12",
      height: "12",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      focusable: "false",
      children: /* @__PURE__ */ _("path", { d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" })
    }
  );
}
function n1({ value: e, color: t }) {
  const [n, i] = Ee(!1), r = $e(() => {
    if (t)
      return t;
    if (!e.startsWith("--") || typeof document > "u")
      return;
    const l = getComputedStyle(document.documentElement).getPropertyValue(e).trim();
    if (l)
      return /^(#|rgb|hsl|oklch|oklab|lch|lab|color\()/i.test(l) ? l : void 0;
  }, [e, t]), a = async () => {
    try {
      await navigator.clipboard.writeText(e), i(!0), setTimeout(() => i(!1), 1500);
    } catch {
    }
  }, o = n ? "Copied!" : `Copy ${e}`;
  return /* @__PURE__ */ B("span", { className: Dn.token, children: [
    r && /* @__PURE__ */ _(Q0, { color: r }),
    /* @__PURE__ */ _("code", { className: Dn.value, children: e }),
    /* @__PURE__ */ B(
      "button",
      {
        type: "button",
        className: `${Dn.copyButton} ${n ? Dn.copyButtonDone : ""}`,
        "aria-label": o,
        onClick: a,
        children: [
          n ? /* @__PURE__ */ _(t1, {}) : /* @__PURE__ */ _(e1, {}),
          /* @__PURE__ */ _("span", { className: Dn.tooltip, "aria-hidden": "true", children: n ? "Copied!" : "Copy" })
        ]
      }
    ),
    /* @__PURE__ */ _("span", { role: "status", "aria-live": "polite", "aria-atomic": "true", className: Dn.srOnly, children: n ? `Copied ${e} to clipboard` : "" })
  ] });
}
function i1(e) {
  return /* @__PURE__ */ _("pre", { tabIndex: 0, ...e });
}
const Mc = {
  // MDX utilities
  Token: n1,
  pre: i1,
  // Base components
  Badge: kf,
  Button: st,
  Checkbox: $i,
  Chip: hi,
  ContextualMenu: Kn,
  Icon: ke,
  Tooltip: cn,
  // Input system
  ComboBoxField: bc,
  DatePickerField: co,
  EntityPickerField: po,
  MultiSelectField: vc,
  SelectField: ao,
  TextField: Ni,
  TimePickerField: ho,
  // Patterns
  Accordion: Gf,
  AccordionItem: Kf,
  AriesCard: t0,
  AriesInput: s0,
  Card: o0,
  Dialog: q0,
  Drawer: u0,
  EntityEditor: v0,
  EntityViewer: H0,
  ErrorBoundary: a0,
  InfoCard: n0,
  Navbar: w0,
  Sidebar: P0,
  Table: O0
};
function r5({ children: e, components: t = {} }) {
  const n = {
    ...Mc,
    ...t
  };
  return /* @__PURE__ */ _(Qf, { components: n, children: e });
}
function nn(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Nl(e.position) : "start" in e || "end" in e ? Nl(e) : "line" in e || "column" in e ? Ma(e) : "";
}
function Ma(e) {
  return Dl(e && e.line) + ":" + Dl(e && e.column);
}
function Nl(e) {
  return Ma(e && e.start) + "-" + Ma(e && e.end);
}
function Dl(e) {
  return e && typeof e == "number" ? e : 1;
}
class Xe extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, i) {
    super(), typeof n == "string" && (i = n, n = void 0);
    let r = "", a = {}, o = !1;
    if (n && ("line" in n && "column" in n ? a = { place: n } : "start" in n && "end" in n ? a = { place: n } : "type" in n ? a = {
      ancestors: [n],
      place: n.position
    } : a = { ...n }), typeof t == "string" ? r = t : !a.cause && t && (o = !0, r = t.message, a.cause = t), !a.ruleId && !a.source && typeof i == "string") {
      const u = i.indexOf(":");
      u === -1 ? a.ruleId = i : (a.source = i.slice(0, u), a.ruleId = i.slice(u + 1));
    }
    if (!a.place && a.ancestors && a.ancestors) {
      const u = a.ancestors[a.ancestors.length - 1];
      u && (a.place = u.position);
    }
    const l = a.place && "start" in a.place ? a.place.start : a.place;
    this.ancestors = a.ancestors || void 0, this.cause = a.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file = "", this.message = r, this.line = l ? l.line : void 0, this.name = nn(a.place) || "1:1", this.place = a.place || void 0, this.reason = this.message, this.ruleId = a.ruleId || void 0, this.source = a.source || void 0, this.stack = o && a.cause && typeof a.cause.stack == "string" ? a.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = void 0, this.url = void 0;
  }
}
Xe.prototype.file = "";
Xe.prototype.name = "";
Xe.prototype.reason = "";
Xe.prototype.message = "";
Xe.prototype.stack = "";
Xe.prototype.column = void 0;
Xe.prototype.line = void 0;
Xe.prototype.ancestors = void 0;
Xe.prototype.cause = void 0;
Xe.prototype.fatal = void 0;
Xe.prototype.place = void 0;
Xe.prototype.ruleId = void 0;
Xe.prototype.source = void 0;
const _n = { basename: r1, dirname: s1, extname: a1, join: o1, sep: "/" };
function r1(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Lr(e);
  let n = 0, i = -1, r = e.length, a;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; r--; )
      if (e.codePointAt(r) === 47) {
        if (a) {
          n = r + 1;
          break;
        }
      } else i < 0 && (a = !0, i = r + 1);
    return i < 0 ? "" : e.slice(n, i);
  }
  if (t === e)
    return "";
  let o = -1, l = t.length - 1;
  for (; r--; )
    if (e.codePointAt(r) === 47) {
      if (a) {
        n = r + 1;
        break;
      }
    } else
      o < 0 && (a = !0, o = r + 1), l > -1 && (e.codePointAt(r) === t.codePointAt(l--) ? l < 0 && (i = r) : (l = -1, i = o));
  return n === i ? i = o : i < 0 && (i = e.length), e.slice(n, i);
}
function s1(e) {
  if (Lr(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, i;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (i) {
        t = n;
        break;
      }
    } else i || (i = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function a1(e) {
  Lr(e);
  let t = e.length, n = -1, i = 0, r = -1, a = 0, o;
  for (; t--; ) {
    const l = e.codePointAt(t);
    if (l === 47) {
      if (o) {
        i = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (o = !0, n = t + 1), l === 46 ? r < 0 ? r = t : a !== 1 && (a = 1) : r > -1 && (a = -1);
  }
  return r < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  a === 0 || // The (right-most) trimmed path component is exactly `..`.
  a === 1 && r === n - 1 && r === i + 1 ? "" : e.slice(r, n);
}
function o1(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    Lr(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : l1(n);
}
function l1(e) {
  Lr(e);
  const t = e.codePointAt(0) === 47;
  let n = u1(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function u1(e, t) {
  let n = "", i = 0, r = -1, a = 0, o = -1, l, u;
  for (; ++o <= e.length; ) {
    if (o < e.length)
      l = e.codePointAt(o);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(r === o - 1 || a === 1)) if (r !== o - 1 && a === 2) {
        if (n.length < 2 || i !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (u = n.lastIndexOf("/"), u !== n.length - 1) {
              u < 0 ? (n = "", i = 0) : (n = n.slice(0, u), i = n.length - 1 - n.lastIndexOf("/")), r = o, a = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", i = 0, r = o, a = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", i = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(r + 1, o) : n = e.slice(r + 1, o), i = o - r - 1;
      r = o, a = 0;
    } else l === 46 && a > -1 ? a++ : a = -1;
  }
  return n;
}
function Lr(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const c1 = { cwd: h1 };
function h1() {
  return "/";
}
function Fa(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function p1(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Fa(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return d1(e);
}
function d1(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const i = t.codePointAt(n + 2);
      if (i === 70 || i === 102) {
        const r = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw r.code = "ERR_INVALID_FILE_URL_PATH", r;
      }
    }
  return decodeURIComponent(t);
}
const $s = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class Fc {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? Fa(t) ? n = { path: t } : typeof t == "string" || f1(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : c1.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < $s.length; ) {
      const a = $s[i];
      a in n && n[a] !== void 0 && n[a] !== null && (this[a] = a === "history" ? [...n[a]] : n[a]);
    }
    let r;
    for (r in n)
      $s.includes(r) || (this[r] = n[r]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? _n.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    Us(t, "basename"), qs(t, "basename"), this.path = _n.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? _n.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    Vl(this.basename, "dirname"), this.path = _n.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? _n.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (qs(t, "extname"), Vl(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = _n.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    Fa(t) && (t = p1(t)), Us(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? _n.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    Us(t, "stem"), qs(t, "stem"), this.path = _n.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, i) {
    const r = this.message(t, n, i);
    throw r.fatal = !0, r;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, i) {
    const r = this.message(t, n, i);
    return r.fatal = void 0, r;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, i) {
    const r = new Xe(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      i
    );
    return this.path && (r.name = this.path + ":" + r.name, r.file = this.path), r.fatal = !1, this.messages.push(r), r;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function qs(e, t) {
  if (e && e.includes(_n.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + _n.sep + "`"
    );
}
function Us(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function Vl(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function f1(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const m1 = [
  "md",
  "markdown",
  "mdown",
  "mkdn",
  "mkd",
  "mdwn",
  "mkdown",
  "ron"
], g1 = m1.map(function(e) {
  return "." + e;
});
function _1(e, t) {
  const n = x1(e) ? e : new Fc(e), { format: i, ...r } = t || {};
  return {
    file: n,
    options: {
      format: i === "md" || i === "mdx" ? i : n.extname && (r.mdExtensions || g1).includes(n.extname) ? "md" : "mdx",
      ...r
    }
  };
}
function x1(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
const y1 = /[$_\p{ID_Start}]/u, b1 = /[$_\u{200C}\u{200D}\p{ID_Continue}]/u, v1 = /[-$_\u{200C}\u{200D}\p{ID_Continue}]/u, w1 = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, k1 = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, Rc = {};
function sn(e) {
  return e ? y1.test(String.fromCodePoint(e)) : !1;
}
function rr(e, t) {
  const i = (t || Rc).jsx ? v1 : b1;
  return e ? i.test(String.fromCodePoint(e)) : !1;
}
function vn(e, t) {
  return ((t || Rc).jsx ? k1 : w1).test(e);
}
class C1 {
  constructor() {
    this.should_skip = !1, this.should_remove = !1, this.replacement = null, this.context = {
      skip: () => this.should_skip = !0,
      remove: () => this.should_remove = !0,
      replace: (t) => this.replacement = t
    };
  }
  /**
   * @template {Node} Parent
   * @param {Parent | null | undefined} parent
   * @param {keyof Parent | null | undefined} prop
   * @param {number | null | undefined} index
   * @param {Node} node
   */
  replace(t, n, i, r) {
    t && n && (i != null ? t[n][i] = r : t[n] = r);
  }
  /**
   * @template {Node} Parent
   * @param {Parent | null | undefined} parent
   * @param {keyof Parent | null | undefined} prop
   * @param {number | null | undefined} index
   */
  remove(t, n, i) {
    t && n && (i != null ? t[n].splice(i, 1) : delete t[n]);
  }
}
class S1 extends C1 {
  /**
   *
   * @param {SyncHandler} [enter]
   * @param {SyncHandler} [leave]
   */
  constructor(t, n) {
    super(), this.should_skip = !1, this.should_remove = !1, this.replacement = null, this.context = {
      skip: () => this.should_skip = !0,
      remove: () => this.should_remove = !0,
      replace: (i) => this.replacement = i
    }, this.enter = t, this.leave = n;
  }
  /**
   * @template {Node} Parent
   * @param {Node} node
   * @param {Parent | null} parent
   * @param {keyof Parent} [prop]
   * @param {number | null} [index]
   * @returns {Node | null}
   */
  visit(t, n, i, r) {
    if (t) {
      if (this.enter) {
        const o = this.should_skip, l = this.should_remove, u = this.replacement;
        this.should_skip = !1, this.should_remove = !1, this.replacement = null, this.enter.call(this.context, t, n, i, r), this.replacement && (t = this.replacement, this.replace(n, i, r, t)), this.should_remove && this.remove(n, i, r);
        const c = this.should_skip, h = this.should_remove;
        if (this.should_skip = o, this.should_remove = l, this.replacement = u, c) return t;
        if (h) return null;
      }
      let a;
      for (a in t) {
        const o = t[a];
        if (o && typeof o == "object")
          if (Array.isArray(o)) {
            const l = (
              /** @type {Array<unknown>} */
              o
            );
            for (let u = 0; u < l.length; u += 1) {
              const c = l[u];
              Ml(c) && (this.visit(c, t, a, u) || u--);
            }
          } else Ml(o) && this.visit(o, t, a, null);
      }
      if (this.leave) {
        const o = this.replacement, l = this.should_remove;
        this.replacement = null, this.should_remove = !1, this.leave.call(this.context, t, n, i, r), this.replacement && (t = this.replacement, this.replace(n, i, r, t)), this.should_remove && this.remove(n, i, r);
        const u = this.should_remove;
        if (this.replacement = o, this.should_remove = l, u) return null;
      }
    }
    return t;
  }
}
function Ml(e) {
  return e !== null && typeof e == "object" && "type" in e && typeof e.type == "string";
}
function Vi(e, { enter: t, leave: n }) {
  return new S1(t, n).visit(e, null);
}
const Js = /@(jsx|jsxFrag|jsxImportSource|jsxRuntime)\s+(\S+)/g;
function E1(e, t) {
  const n = t || {};
  let i = n.runtime === "automatic";
  const r = {}, a = {};
  Vi(e, {
    enter(o) {
      if (o.type === "Program") {
        const l = o.comments || [];
        let u = -1;
        for (; ++u < l.length; ) {
          Js.lastIndex = 0;
          let c = Js.exec(l[u].value);
          for (; c; )
            r[c[1]] = c[2], c = Js.exec(l[u].value);
        }
        if (r.jsxRuntime)
          if (r.jsxRuntime === "automatic") {
            if (i = !0, r.jsx)
              throw new Error("Unexpected `@jsx` pragma w/ automatic runtime");
            if (r.jsxFrag)
              throw new Error(
                "Unexpected `@jsxFrag` pragma w/ automatic runtime"
              );
          } else if (r.jsxRuntime === "classic") {
            if (i = !1, r.jsxImportSource)
              throw new Error(
                "Unexpected `@jsxImportSource` w/ classic runtime"
              );
          } else
            throw new Error(
              "Unexpected `jsxRuntime` `" + r.jsxRuntime + "`, expected `automatic` or `classic`"
            );
      }
    },
    // eslint-disable-next-line complexity
    leave(o) {
      if (o.type === "Program") {
        const v = [];
        if (a.fragment && v.push({
          type: "ImportSpecifier",
          imported: { type: "Identifier", name: "Fragment" },
          local: { type: "Identifier", name: "_Fragment" }
        }), a.jsx && v.push({
          type: "ImportSpecifier",
          imported: { type: "Identifier", name: "jsx" },
          local: { type: "Identifier", name: "_jsx" }
        }), a.jsxs && v.push({
          type: "ImportSpecifier",
          imported: { type: "Identifier", name: "jsxs" },
          local: { type: "Identifier", name: "_jsxs" }
        }), a.jsxDEV && v.push({
          type: "ImportSpecifier",
          imported: { type: "Identifier", name: "jsxDEV" },
          local: { type: "Identifier", name: "_jsxDEV" }
        }), v.length > 0) {
          let w = 0;
          for (; w < o.body.length; ) {
            const y = o.body[w];
            if ("directive" in y && y.directive)
              w++;
            else
              break;
          }
          o.body.splice(w, 0, {
            type: "ImportDeclaration",
            specifiers: v,
            source: {
              type: "Literal",
              value: (r.jsxImportSource || n.importSource || "react") + (n.development ? "/jsx-dev-runtime" : "/jsx-runtime")
            }
          });
        }
      }
      if (o.type !== "JSXElement" && o.type !== "JSXFragment")
        return;
      const l = [];
      let u = -1;
      for (; ++u < o.children.length; ) {
        const v = o.children[u];
        if (v.type === "JSXExpressionContainer")
          v.expression.type !== "JSXEmptyExpression" && l.push(v.expression);
        else if (v.type === "JSXText") {
          const w = v.value.replace(/\t/g, " ").replace(/ *(\r?\n|\r) */g, `
`).replace(/\n+/g, `
`).replace(/\n+$/, "").replace(/^\n+/, "").replace(/\n/g, " ");
          if (w) {
            const y = { type: "Literal", value: w };
            fr(v, y), l.push(y);
          }
        } else
          v.type !== "JSXElement" && v.type !== "JSXFragment" && v.type, l.push(v);
      }
      let c;
      const h = [];
      let p = [], m;
      if (o.type === "JSXElement") {
        if (c = as(o.openingElement.name), c.type === "Identifier" && /^[a-z]/.test(c.name)) {
          const I = { type: "Literal", value: c.name };
          fr(c, I), c = I;
        }
        let v;
        const w = o.openingElement.attributes;
        let y = -1;
        for (; ++y < w.length; ) {
          const I = w[y];
          if (I.type === "JSXSpreadAttribute")
            I.argument.type === "ObjectExpression" ? h.push(...I.argument.properties) : h.push({ type: "SpreadElement", argument: I.argument }), v = !0;
          else {
            const E = A1(I);
            if (i && E.key.type === "Identifier" && E.key.name === "key") {
              if (v)
                throw new Error(
                  "Expected `key` to come before any spread expressions"
                );
              const P = E.value;
              P.type !== "AssignmentPattern" && P.type !== "ArrayPattern" && P.type !== "ObjectPattern" && P.type, m = P;
            } else
              h.push(E);
          }
        }
      } else i ? (a.fragment = !0, c = { type: "Identifier", name: "_Fragment" }) : c = Fl(
        r.jsxFrag || n.pragmaFrag || "React.Fragment"
      );
      i ? l.length > 0 && h.push({
        type: "Property",
        key: { type: "Identifier", name: "children" },
        value: l.length > 1 ? { type: "ArrayExpression", elements: l } : l[0],
        kind: "init",
        method: !1,
        shorthand: !1,
        computed: !1
      }) : p = l;
      let g;
      if (i) {
        p.push({ type: "ObjectExpression", properties: h }), m ? p.push(m) : n.development && p.push({ type: "Identifier", name: "undefined" });
        const v = l.length > 1;
        if (n.development) {
          a.jsxDEV = !0, g = {
            type: "Identifier",
            name: "_jsxDEV"
          }, p.push({ type: "Literal", value: v });
          const w = {
            type: "ObjectExpression",
            properties: [
              {
                type: "Property",
                method: !1,
                shorthand: !1,
                computed: !1,
                kind: "init",
                key: { type: "Identifier", name: "fileName" },
                value: {
                  type: "Literal",
                  value: n.filePath || "<source.js>"
                }
              }
            ]
          };
          o.loc && w.properties.push(
            {
              type: "Property",
              method: !1,
              shorthand: !1,
              computed: !1,
              kind: "init",
              key: { type: "Identifier", name: "lineNumber" },
              value: { type: "Literal", value: o.loc.start.line }
            },
            {
              type: "Property",
              method: !1,
              shorthand: !1,
              computed: !1,
              kind: "init",
              key: { type: "Identifier", name: "columnNumber" },
              value: { type: "Literal", value: o.loc.start.column + 1 }
            }
          ), p.push(w, { type: "ThisExpression" });
        } else v ? (a.jsxs = !0, g = { type: "Identifier", name: "_jsxs" }) : (a.jsx = !0, g = { type: "Identifier", name: "_jsx" });
      } else
        h.length > 0 ? p.unshift({ type: "ObjectExpression", properties: h }) : p.length > 0 && p.unshift({ type: "Literal", value: null }), g = Fl(
          r.jsx || n.pragma || "React.createElement"
        );
      p.unshift(c);
      const b = {
        type: "CallExpression",
        callee: g,
        arguments: p,
        optional: !1
      };
      fr(o, b), this.replace(b);
    }
  });
}
function A1(e) {
  let t;
  if (e.value)
    if (e.value.type === "JSXExpressionContainer") {
      const i = e.value.expression;
      i.type, t = i;
    } else {
      const i = e.value;
      i.type !== "JSXElement" && i.type, t = i, delete t.raw;
    }
  else
    t = { type: "Literal", value: !0 };
  const n = {
    type: "Property",
    key: as(e.name),
    value: t,
    kind: "init",
    method: !1,
    shorthand: !1,
    computed: !1
  };
  return fr(e, n), n;
}
function as(e) {
  let t;
  if (e.type === "JSXMemberExpression") {
    const n = as(e.property);
    t = {
      type: "MemberExpression",
      object: as(e.object),
      property: n,
      computed: n.type === "Literal",
      optional: !1
    };
  } else e.type === "JSXNamespacedName" ? t = {
    type: "Literal",
    value: e.namespace.name + ":" + e.name.name
  } : t = vn(e.name) ? { type: "Identifier", name: e.name } : { type: "Literal", value: e.name };
  return fr(e, t), t;
}
function Fl(e) {
  const t = e.split(".");
  let n = -1, i;
  for (; ++n < t.length; ) {
    const r = vn(t[n]) ? { type: "Identifier", name: t[n] } : { type: "Literal", value: t[n] };
    i = i ? {
      type: "MemberExpression",
      object: i,
      property: r,
      computed: !!(n && r.type === "Literal"),
      optional: !1
    } : r;
  }
  return i;
}
function fr(e, t) {
  const n = ["start", "end", "loc", "range", "comments"];
  let i = -1;
  for (; ++i < n.length; ) {
    const r = n[i];
    r in e && (t[r] = e[r]);
  }
}
function I1(e) {
  return function(t, n) {
    E1(t, { filePath: n.history[0], ...e });
  };
}
var Ws = { exports: {} }, Xs, Rl;
function L1() {
  return Rl || (Rl = 1, Xs = {
    quot: '"',
    amp: "&",
    apos: "'",
    lt: "<",
    gt: ">",
    nbsp: " ",
    iexcl: "¡",
    cent: "¢",
    pound: "£",
    curren: "¤",
    yen: "¥",
    brvbar: "¦",
    sect: "§",
    uml: "¨",
    copy: "©",
    ordf: "ª",
    laquo: "«",
    not: "¬",
    shy: "­",
    reg: "®",
    macr: "¯",
    deg: "°",
    plusmn: "±",
    sup2: "²",
    sup3: "³",
    acute: "´",
    micro: "µ",
    para: "¶",
    middot: "·",
    cedil: "¸",
    sup1: "¹",
    ordm: "º",
    raquo: "»",
    frac14: "¼",
    frac12: "½",
    frac34: "¾",
    iquest: "¿",
    Agrave: "À",
    Aacute: "Á",
    Acirc: "Â",
    Atilde: "Ã",
    Auml: "Ä",
    Aring: "Å",
    AElig: "Æ",
    Ccedil: "Ç",
    Egrave: "È",
    Eacute: "É",
    Ecirc: "Ê",
    Euml: "Ë",
    Igrave: "Ì",
    Iacute: "Í",
    Icirc: "Î",
    Iuml: "Ï",
    ETH: "Ð",
    Ntilde: "Ñ",
    Ograve: "Ò",
    Oacute: "Ó",
    Ocirc: "Ô",
    Otilde: "Õ",
    Ouml: "Ö",
    times: "×",
    Oslash: "Ø",
    Ugrave: "Ù",
    Uacute: "Ú",
    Ucirc: "Û",
    Uuml: "Ü",
    Yacute: "Ý",
    THORN: "Þ",
    szlig: "ß",
    agrave: "à",
    aacute: "á",
    acirc: "â",
    atilde: "ã",
    auml: "ä",
    aring: "å",
    aelig: "æ",
    ccedil: "ç",
    egrave: "è",
    eacute: "é",
    ecirc: "ê",
    euml: "ë",
    igrave: "ì",
    iacute: "í",
    icirc: "î",
    iuml: "ï",
    eth: "ð",
    ntilde: "ñ",
    ograve: "ò",
    oacute: "ó",
    ocirc: "ô",
    otilde: "õ",
    ouml: "ö",
    divide: "÷",
    oslash: "ø",
    ugrave: "ù",
    uacute: "ú",
    ucirc: "û",
    uuml: "ü",
    yacute: "ý",
    thorn: "þ",
    yuml: "ÿ",
    OElig: "Œ",
    oelig: "œ",
    Scaron: "Š",
    scaron: "š",
    Yuml: "Ÿ",
    fnof: "ƒ",
    circ: "ˆ",
    tilde: "˜",
    Alpha: "Α",
    Beta: "Β",
    Gamma: "Γ",
    Delta: "Δ",
    Epsilon: "Ε",
    Zeta: "Ζ",
    Eta: "Η",
    Theta: "Θ",
    Iota: "Ι",
    Kappa: "Κ",
    Lambda: "Λ",
    Mu: "Μ",
    Nu: "Ν",
    Xi: "Ξ",
    Omicron: "Ο",
    Pi: "Π",
    Rho: "Ρ",
    Sigma: "Σ",
    Tau: "Τ",
    Upsilon: "Υ",
    Phi: "Φ",
    Chi: "Χ",
    Psi: "Ψ",
    Omega: "Ω",
    alpha: "α",
    beta: "β",
    gamma: "γ",
    delta: "δ",
    epsilon: "ε",
    zeta: "ζ",
    eta: "η",
    theta: "θ",
    iota: "ι",
    kappa: "κ",
    lambda: "λ",
    mu: "μ",
    nu: "ν",
    xi: "ξ",
    omicron: "ο",
    pi: "π",
    rho: "ρ",
    sigmaf: "ς",
    sigma: "σ",
    tau: "τ",
    upsilon: "υ",
    phi: "φ",
    chi: "χ",
    psi: "ψ",
    omega: "ω",
    thetasym: "ϑ",
    upsih: "ϒ",
    piv: "ϖ",
    ensp: " ",
    emsp: " ",
    thinsp: " ",
    zwnj: "‌",
    zwj: "‍",
    lrm: "‎",
    rlm: "‏",
    ndash: "–",
    mdash: "—",
    lsquo: "‘",
    rsquo: "’",
    sbquo: "‚",
    ldquo: "“",
    rdquo: "”",
    bdquo: "„",
    dagger: "†",
    Dagger: "‡",
    bull: "•",
    hellip: "…",
    permil: "‰",
    prime: "′",
    Prime: "″",
    lsaquo: "‹",
    rsaquo: "›",
    oline: "‾",
    frasl: "⁄",
    euro: "€",
    image: "ℑ",
    weierp: "℘",
    real: "ℜ",
    trade: "™",
    alefsym: "ℵ",
    larr: "←",
    uarr: "↑",
    rarr: "→",
    darr: "↓",
    harr: "↔",
    crarr: "↵",
    lArr: "⇐",
    uArr: "⇑",
    rArr: "⇒",
    dArr: "⇓",
    hArr: "⇔",
    forall: "∀",
    part: "∂",
    exist: "∃",
    empty: "∅",
    nabla: "∇",
    isin: "∈",
    notin: "∉",
    ni: "∋",
    prod: "∏",
    sum: "∑",
    minus: "−",
    lowast: "∗",
    radic: "√",
    prop: "∝",
    infin: "∞",
    ang: "∠",
    and: "∧",
    or: "∨",
    cap: "∩",
    cup: "∪",
    int: "∫",
    there4: "∴",
    sim: "∼",
    cong: "≅",
    asymp: "≈",
    ne: "≠",
    equiv: "≡",
    le: "≤",
    ge: "≥",
    sub: "⊂",
    sup: "⊃",
    nsub: "⊄",
    sube: "⊆",
    supe: "⊇",
    oplus: "⊕",
    otimes: "⊗",
    perp: "⊥",
    sdot: "⋅",
    lceil: "⌈",
    rceil: "⌉",
    lfloor: "⌊",
    rfloor: "⌋",
    lang: "〈",
    rang: "〉",
    loz: "◊",
    spades: "♠",
    clubs: "♣",
    hearts: "♥",
    diams: "♦"
  }), Xs;
}
var ur = { exports: {} }, P1 = ur.exports, Ol;
function Bl() {
  return Ol || (Ol = 1, (function(e, t) {
    (function(n, i) {
      i(t);
    })(P1, (function(n) {
      var i = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 7, 9, 32, 4, 318, 1, 80, 3, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 68, 8, 2, 0, 3, 0, 2, 3, 2, 4, 2, 0, 15, 1, 83, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 7, 19, 58, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 343, 9, 54, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 10, 5350, 0, 7, 14, 11465, 27, 2343, 9, 87, 9, 39, 4, 60, 6, 26, 9, 535, 9, 470, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4178, 9, 519, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 245, 1, 2, 9, 726, 6, 110, 6, 6, 9, 4759, 9, 787719, 239], r = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 4, 51, 13, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 39, 27, 10, 22, 251, 41, 7, 1, 17, 2, 60, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 31, 9, 2, 0, 3, 0, 2, 37, 2, 0, 26, 0, 2, 0, 45, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 200, 32, 32, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 26, 3994, 6, 582, 6842, 29, 1763, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 433, 44, 212, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 42, 9, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 229, 29, 3, 0, 496, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 16, 621, 2467, 541, 1507, 4938, 6, 4191], a = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛ࢗ-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ೳഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ඁ-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-໎໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠏-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᪿ-ᫎᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿‌‍‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯・꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿･", o = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲊᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꟍꟐꟑꟓꟕ-Ƛꟲ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", l = {
        3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
        5: "class enum extends super const export import",
        6: "enum",
        strict: "implements interface let package private protected public static yield",
        strictBind: "eval arguments"
      }, u = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", c = {
        5: u,
        "5module": u + " export import",
        6: u + " const class extends export import super"
      }, h = /^in(stanceof)?$/, p = new RegExp("[" + o + "]"), m = new RegExp("[" + o + a + "]");
      function g(s, d) {
        for (var x = 65536, k = 0; k < d.length; k += 2) {
          if (x += d[k], x > s)
            return !1;
          if (x += d[k + 1], x >= s)
            return !0;
        }
        return !1;
      }
      function b(s, d) {
        return s < 65 ? s === 36 : s < 91 ? !0 : s < 97 ? s === 95 : s < 123 ? !0 : s <= 65535 ? s >= 170 && p.test(String.fromCharCode(s)) : d === !1 ? !1 : g(s, r);
      }
      function v(s, d) {
        return s < 48 ? s === 36 : s < 58 ? !0 : s < 65 ? !1 : s < 91 ? !0 : s < 97 ? s === 95 : s < 123 ? !0 : s <= 65535 ? s >= 170 && m.test(String.fromCharCode(s)) : d === !1 ? !1 : g(s, r) || g(s, i);
      }
      var w = function(d, x) {
        x === void 0 && (x = {}), this.label = d, this.keyword = x.keyword, this.beforeExpr = !!x.beforeExpr, this.startsExpr = !!x.startsExpr, this.isLoop = !!x.isLoop, this.isAssign = !!x.isAssign, this.prefix = !!x.prefix, this.postfix = !!x.postfix, this.binop = x.binop || null, this.updateContext = null;
      };
      function y(s, d) {
        return new w(s, { beforeExpr: !0, binop: d });
      }
      var I = { beforeExpr: !0 }, E = { startsExpr: !0 }, P = {};
      function S(s, d) {
        return d === void 0 && (d = {}), d.keyword = s, P[s] = new w(s, d);
      }
      var f = {
        num: new w("num", E),
        regexp: new w("regexp", E),
        string: new w("string", E),
        name: new w("name", E),
        privateId: new w("privateId", E),
        eof: new w("eof"),
        // Punctuation token types.
        bracketL: new w("[", { beforeExpr: !0, startsExpr: !0 }),
        bracketR: new w("]"),
        braceL: new w("{", { beforeExpr: !0, startsExpr: !0 }),
        braceR: new w("}"),
        parenL: new w("(", { beforeExpr: !0, startsExpr: !0 }),
        parenR: new w(")"),
        comma: new w(",", I),
        semi: new w(";", I),
        colon: new w(":", I),
        dot: new w("."),
        question: new w("?", I),
        questionDot: new w("?."),
        arrow: new w("=>", I),
        template: new w("template"),
        invalidTemplate: new w("invalidTemplate"),
        ellipsis: new w("...", I),
        backQuote: new w("`", E),
        dollarBraceL: new w("${", { beforeExpr: !0, startsExpr: !0 }),
        // Operators. These carry several kinds of properties to help the
        // parser use them properly (the presence of these properties is
        // what categorizes them as operators).
        //
        // `binop`, when present, specifies that this operator is a binary
        // operator, and will refer to its precedence.
        //
        // `prefix` and `postfix` mark the operator as a prefix or postfix
        // unary operator.
        //
        // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
        // binary operators with a very low precedence, that should result
        // in AssignmentExpression nodes.
        eq: new w("=", { beforeExpr: !0, isAssign: !0 }),
        assign: new w("_=", { beforeExpr: !0, isAssign: !0 }),
        incDec: new w("++/--", { prefix: !0, postfix: !0, startsExpr: !0 }),
        prefix: new w("!/~", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        logicalOR: y("||", 1),
        logicalAND: y("&&", 2),
        bitwiseOR: y("|", 3),
        bitwiseXOR: y("^", 4),
        bitwiseAND: y("&", 5),
        equality: y("==/!=/===/!==", 6),
        relational: y("</>/<=/>=", 7),
        bitShift: y("<</>>/>>>", 8),
        plusMin: new w("+/-", { beforeExpr: !0, binop: 9, prefix: !0, startsExpr: !0 }),
        modulo: y("%", 10),
        star: y("*", 10),
        slash: y("/", 10),
        starstar: new w("**", { beforeExpr: !0 }),
        coalesce: y("??", 1),
        // Keyword token types.
        _break: S("break"),
        _case: S("case", I),
        _catch: S("catch"),
        _continue: S("continue"),
        _debugger: S("debugger"),
        _default: S("default", I),
        _do: S("do", { isLoop: !0, beforeExpr: !0 }),
        _else: S("else", I),
        _finally: S("finally"),
        _for: S("for", { isLoop: !0 }),
        _function: S("function", E),
        _if: S("if"),
        _return: S("return", I),
        _switch: S("switch"),
        _throw: S("throw", I),
        _try: S("try"),
        _var: S("var"),
        _const: S("const"),
        _while: S("while", { isLoop: !0 }),
        _with: S("with"),
        _new: S("new", { beforeExpr: !0, startsExpr: !0 }),
        _this: S("this", E),
        _super: S("super", E),
        _class: S("class", E),
        _extends: S("extends", I),
        _export: S("export"),
        _import: S("import", E),
        _null: S("null", E),
        _true: S("true", E),
        _false: S("false", E),
        _in: S("in", { beforeExpr: !0, binop: 7 }),
        _instanceof: S("instanceof", { beforeExpr: !0, binop: 7 }),
        _typeof: S("typeof", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        _void: S("void", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        _delete: S("delete", { beforeExpr: !0, prefix: !0, startsExpr: !0 })
      }, C = /\r\n?|\n|\u2028|\u2029/, L = new RegExp(C.source, "g");
      function F(s) {
        return s === 10 || s === 13 || s === 8232 || s === 8233;
      }
      function M(s, d, x) {
        x === void 0 && (x = s.length);
        for (var k = d; k < x; k++) {
          var D = s.charCodeAt(k);
          if (F(D))
            return k < x - 1 && D === 13 && s.charCodeAt(k + 1) === 10 ? k + 2 : k + 1;
        }
        return -1;
      }
      var z = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, R = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, j = Object.prototype, H = j.hasOwnProperty, O = j.toString, X = Object.hasOwn || (function(s, d) {
        return H.call(s, d);
      }), K = Array.isArray || (function(s) {
        return O.call(s) === "[object Array]";
      }), se = /* @__PURE__ */ Object.create(null);
      function Y(s) {
        return se[s] || (se[s] = new RegExp("^(?:" + s.replace(/ /g, "|") + ")$"));
      }
      function N(s) {
        return s <= 65535 ? String.fromCharCode(s) : (s -= 65536, String.fromCharCode((s >> 10) + 55296, (s & 1023) + 56320));
      }
      var ue = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, ie = function(d, x) {
        this.line = d, this.column = x;
      };
      ie.prototype.offset = function(d) {
        return new ie(this.line, this.column + d);
      };
      var V = function(d, x, k) {
        this.start = x, this.end = k, d.sourceFile !== null && (this.source = d.sourceFile);
      };
      function de(s, d) {
        for (var x = 1, k = 0; ; ) {
          var D = M(s, k, d);
          if (D < 0)
            return new ie(x, d - k);
          ++x, k = D;
        }
      }
      var Se = {
        // `ecmaVersion` indicates the ECMAScript version to parse. Must be
        // either 3, 5, 6 (or 2015), 7 (2016), 8 (2017), 9 (2018), 10
        // (2019), 11 (2020), 12 (2021), 13 (2022), 14 (2023), or `"latest"`
        // (the latest version the library supports). This influences
        // support for strict mode, the set of reserved words, and support
        // for new syntax features.
        ecmaVersion: null,
        // `sourceType` indicates the mode the code should be parsed in.
        // Can be either `"script"` or `"module"`. This influences global
        // strict mode and parsing of `import` and `export` declarations.
        sourceType: "script",
        // `onInsertedSemicolon` can be a callback that will be called when
        // a semicolon is automatically inserted. It will be passed the
        // position of the inserted semicolon as an offset, and if
        // `locations` is enabled, it is given the location as a `{line,
        // column}` object as second argument.
        onInsertedSemicolon: null,
        // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
        // trailing commas.
        onTrailingComma: null,
        // By default, reserved words are only enforced if ecmaVersion >= 5.
        // Set `allowReserved` to a boolean value to explicitly turn this on
        // an off. When this option has the value "never", reserved words
        // and keywords can also not be used as property names.
        allowReserved: null,
        // When enabled, a return at the top level is not considered an
        // error.
        allowReturnOutsideFunction: !1,
        // When enabled, import/export statements are not constrained to
        // appearing at the top of the program, and an import.meta expression
        // in a script isn't considered an error.
        allowImportExportEverywhere: !1,
        // By default, await identifiers are allowed to appear at the top-level scope only if ecmaVersion >= 2022.
        // When enabled, await identifiers are allowed to appear at the top-level scope,
        // but they are still not allowed in non-async functions.
        allowAwaitOutsideFunction: null,
        // When enabled, super identifiers are not constrained to
        // appearing in methods and do not raise an error when they appear elsewhere.
        allowSuperOutsideMethod: null,
        // When enabled, hashbang directive in the beginning of file is
        // allowed and treated as a line comment. Enabled by default when
        // `ecmaVersion` >= 2023.
        allowHashBang: !1,
        // By default, the parser will verify that private properties are
        // only used in places where they are valid and have been declared.
        // Set this to false to turn such checks off.
        checkPrivateFields: !0,
        // When `locations` is on, `loc` properties holding objects with
        // `start` and `end` properties in `{line, column}` form (with
        // line being 1-based and column 0-based) will be attached to the
        // nodes.
        locations: !1,
        // A function can be passed as `onToken` option, which will
        // cause Acorn to call that function with object in the same
        // format as tokens returned from `tokenizer().getToken()`. Note
        // that you are not allowed to call the parser from the
        // callback—that will corrupt its internal state.
        onToken: null,
        // A function can be passed as `onComment` option, which will
        // cause Acorn to call that function with `(block, text, start,
        // end)` parameters whenever a comment is skipped. `block` is a
        // boolean indicating whether this is a block (`/* */`) comment,
        // `text` is the content of the comment, and `start` and `end` are
        // character offsets that denote the start and end of the comment.
        // When the `locations` option is on, two more parameters are
        // passed, the full `{line, column}` locations of the start and
        // end of the comments. Note that you are not allowed to call the
        // parser from the callback—that will corrupt its internal state.
        // When this option has an array as value, objects representing the
        // comments are pushed to it.
        onComment: null,
        // Nodes have their start and end characters offsets recorded in
        // `start` and `end` properties (directly on the node, rather than
        // the `loc` object, which holds line/column data. To also add a
        // [semi-standardized][range] `range` property holding a `[start,
        // end]` array with the same numbers, set the `ranges` option to
        // `true`.
        //
        // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
        ranges: !1,
        // It is possible to parse multiple files into a single AST by
        // passing the tree produced by parsing the first file as
        // `program` option in subsequent parses. This will add the
        // toplevel forms of the parsed file to the `Program` (top) node
        // of an existing parse tree.
        program: null,
        // When `locations` is on, you can pass this to record the source
        // file in every node's `loc` object.
        sourceFile: null,
        // This value, if given, is stored in every node, whether
        // `locations` is on or off.
        directSourceFile: null,
        // When enabled, parenthesized expressions are represented by
        // (non-standard) ParenthesizedExpression nodes
        preserveParens: !1
      }, W = !1;
      function q(s) {
        var d = {};
        for (var x in Se)
          d[x] = s && X(s, x) ? s[x] : Se[x];
        if (d.ecmaVersion === "latest" ? d.ecmaVersion = 1e8 : d.ecmaVersion == null ? (!W && typeof console == "object" && console.warn && (W = !0, console.warn(`Since Acorn 8.0.0, options.ecmaVersion is required.
Defaulting to 2020, but this will stop working in the future.`)), d.ecmaVersion = 11) : d.ecmaVersion >= 2015 && (d.ecmaVersion -= 2009), d.allowReserved == null && (d.allowReserved = d.ecmaVersion < 5), (!s || s.allowHashBang == null) && (d.allowHashBang = d.ecmaVersion >= 14), K(d.onToken)) {
          var k = d.onToken;
          d.onToken = function(D) {
            return k.push(D);
          };
        }
        return K(d.onComment) && (d.onComment = ne(d, d.onComment)), d;
      }
      function ne(s, d) {
        return function(x, k, D, $, U, ae) {
          var ce = {
            type: x ? "Block" : "Line",
            value: k,
            start: D,
            end: $
          };
          s.locations && (ce.loc = new V(this, U, ae)), s.ranges && (ce.range = [D, $]), d.push(ce);
        };
      }
      var ee = 1, ge = 2, te = 4, _e = 8, Te = 16, Ye = 32, ot = 64, Ze = 128, ht = 256, Oe = 512, ft = ee | ge | ht;
      function Ct(s, d) {
        return ge | (s ? te : 0) | (d ? _e : 0);
      }
      var St = 0, Ve = 1, qe = 2, De = 3, An = 4, Z = 5, G = function(d, x, k) {
        this.options = d = q(d), this.sourceFile = d.sourceFile, this.keywords = Y(c[d.ecmaVersion >= 6 ? 6 : d.sourceType === "module" ? "5module" : 5]);
        var D = "";
        d.allowReserved !== !0 && (D = l[d.ecmaVersion >= 6 ? 6 : d.ecmaVersion === 5 ? 5 : 3], d.sourceType === "module" && (D += " await")), this.reservedWords = Y(D);
        var $ = (D ? D + " " : "") + l.strict;
        this.reservedWordsStrict = Y($), this.reservedWordsStrictBind = Y($ + " " + l.strictBind), this.input = String(x), this.containsEsc = !1, k ? (this.pos = k, this.lineStart = this.input.lastIndexOf(`
`, k - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(C).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = f.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = d.sourceType === "module", this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.potentialArrowInForAwait = !1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = /* @__PURE__ */ Object.create(null), this.pos === 0 && d.allowHashBang && this.input.slice(0, 2) === "#!" && this.skipLineComment(2), this.scopeStack = [], this.enterScope(ee), this.regexpState = null, this.privateNameStack = [];
      }, T = { inFunction: { configurable: !0 }, inGenerator: { configurable: !0 }, inAsync: { configurable: !0 }, canAwait: { configurable: !0 }, allowSuper: { configurable: !0 }, allowDirectSuper: { configurable: !0 }, treatFunctionsAsVar: { configurable: !0 }, allowNewDotTarget: { configurable: !0 }, inClassStaticBlock: { configurable: !0 } };
      G.prototype.parse = function() {
        var d = this.options.program || this.startNode();
        return this.nextToken(), this.parseTopLevel(d);
      }, T.inFunction.get = function() {
        return (this.currentVarScope().flags & ge) > 0;
      }, T.inGenerator.get = function() {
        return (this.currentVarScope().flags & _e) > 0;
      }, T.inAsync.get = function() {
        return (this.currentVarScope().flags & te) > 0;
      }, T.canAwait.get = function() {
        for (var s = this.scopeStack.length - 1; s >= 0; s--) {
          var d = this.scopeStack[s], x = d.flags;
          if (x & (ht | Oe))
            return !1;
          if (x & ge)
            return (x & te) > 0;
        }
        return this.inModule && this.options.ecmaVersion >= 13 || this.options.allowAwaitOutsideFunction;
      }, T.allowSuper.get = function() {
        var s = this.currentThisScope(), d = s.flags;
        return (d & ot) > 0 || this.options.allowSuperOutsideMethod;
      }, T.allowDirectSuper.get = function() {
        return (this.currentThisScope().flags & Ze) > 0;
      }, T.treatFunctionsAsVar.get = function() {
        return this.treatFunctionsAsVarInScope(this.currentScope());
      }, T.allowNewDotTarget.get = function() {
        for (var s = this.scopeStack.length - 1; s >= 0; s--) {
          var d = this.scopeStack[s], x = d.flags;
          if (x & (ht | Oe) || x & ge && !(x & Te))
            return !0;
        }
        return !1;
      }, T.inClassStaticBlock.get = function() {
        return (this.currentVarScope().flags & ht) > 0;
      }, G.extend = function() {
        for (var d = [], x = arguments.length; x--; ) d[x] = arguments[x];
        for (var k = this, D = 0; D < d.length; D++)
          k = d[D](k);
        return k;
      }, G.parse = function(d, x) {
        return new this(x, d).parse();
      }, G.parseExpressionAt = function(d, x, k) {
        var D = new this(k, d, x);
        return D.nextToken(), D.parseExpression();
      }, G.tokenizer = function(d, x) {
        return new this(x, d);
      }, Object.defineProperties(G.prototype, T);
      var Ce = G.prototype, Je = /^(?:'((?:\\[^]|[^'\\])*?)'|"((?:\\[^]|[^"\\])*?)")/;
      Ce.strictDirective = function(s) {
        if (this.options.ecmaVersion < 5)
          return !1;
        for (; ; ) {
          R.lastIndex = s, s += R.exec(this.input)[0].length;
          var d = Je.exec(this.input.slice(s));
          if (!d)
            return !1;
          if ((d[1] || d[2]) === "use strict") {
            R.lastIndex = s + d[0].length;
            var x = R.exec(this.input), k = x.index + x[0].length, D = this.input.charAt(k);
            return D === ";" || D === "}" || C.test(x[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(D) || D === "!" && this.input.charAt(k + 1) === "=");
          }
          s += d[0].length, R.lastIndex = s, s += R.exec(this.input)[0].length, this.input[s] === ";" && s++;
        }
      }, Ce.eat = function(s) {
        return this.type === s ? (this.next(), !0) : !1;
      }, Ce.isContextual = function(s) {
        return this.type === f.name && this.value === s && !this.containsEsc;
      }, Ce.eatContextual = function(s) {
        return this.isContextual(s) ? (this.next(), !0) : !1;
      }, Ce.expectContextual = function(s) {
        this.eatContextual(s) || this.unexpected();
      }, Ce.canInsertSemicolon = function() {
        return this.type === f.eof || this.type === f.braceR || C.test(this.input.slice(this.lastTokEnd, this.start));
      }, Ce.insertSemicolon = function() {
        if (this.canInsertSemicolon())
          return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
      }, Ce.semicolon = function() {
        !this.eat(f.semi) && !this.insertSemicolon() && this.unexpected();
      }, Ce.afterTrailingComma = function(s, d) {
        if (this.type === s)
          return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), d || this.next(), !0;
      }, Ce.expect = function(s) {
        this.eat(s) || this.unexpected();
      }, Ce.unexpected = function(s) {
        this.raise(s ?? this.start, "Unexpected token");
      };
      var ut = function() {
        this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
      };
      Ce.checkPatternErrors = function(s, d) {
        if (s) {
          s.trailingComma > -1 && this.raiseRecoverable(s.trailingComma, "Comma is not permitted after the rest element");
          var x = d ? s.parenthesizedAssign : s.parenthesizedBind;
          x > -1 && this.raiseRecoverable(x, d ? "Assigning to rvalue" : "Parenthesized pattern");
        }
      }, Ce.checkExpressionErrors = function(s, d) {
        if (!s)
          return !1;
        var x = s.shorthandAssign, k = s.doubleProto;
        if (!d)
          return x >= 0 || k >= 0;
        x >= 0 && this.raise(x, "Shorthand property assignments are valid only in destructuring patterns"), k >= 0 && this.raiseRecoverable(k, "Redefinition of __proto__ property");
      }, Ce.checkYieldAwaitInDefaultParams = function() {
        this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
      }, Ce.isSimpleAssignTarget = function(s) {
        return s.type === "ParenthesizedExpression" ? this.isSimpleAssignTarget(s.expression) : s.type === "Identifier" || s.type === "MemberExpression";
      };
      var le = G.prototype;
      le.parseTopLevel = function(s) {
        var d = /* @__PURE__ */ Object.create(null);
        for (s.body || (s.body = []); this.type !== f.eof; ) {
          var x = this.parseStatement(null, !0, d);
          s.body.push(x);
        }
        if (this.inModule)
          for (var k = 0, D = Object.keys(this.undefinedExports); k < D.length; k += 1) {
            var $ = D[k];
            this.raiseRecoverable(this.undefinedExports[$].start, "Export '" + $ + "' is not defined");
          }
        return this.adaptDirectivePrologue(s.body), this.next(), s.sourceType = this.options.sourceType, this.finishNode(s, "Program");
      };
      var yt = { kind: "loop" }, qt = { kind: "switch" };
      le.isLet = function(s) {
        if (this.options.ecmaVersion < 6 || !this.isContextual("let"))
          return !1;
        R.lastIndex = this.pos;
        var d = R.exec(this.input), x = this.pos + d[0].length, k = this.input.charCodeAt(x);
        if (k === 91 || k === 92)
          return !0;
        if (s)
          return !1;
        if (k === 123 || k > 55295 && k < 56320)
          return !0;
        if (b(k, !0)) {
          for (var D = x + 1; v(k = this.input.charCodeAt(D), !0); )
            ++D;
          if (k === 92 || k > 55295 && k < 56320)
            return !0;
          var $ = this.input.slice(x, D);
          if (!h.test($))
            return !0;
        }
        return !1;
      }, le.isAsyncFunction = function() {
        if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
          return !1;
        R.lastIndex = this.pos;
        var s = R.exec(this.input), d = this.pos + s[0].length, x;
        return !C.test(this.input.slice(this.pos, d)) && this.input.slice(d, d + 8) === "function" && (d + 8 === this.input.length || !(v(x = this.input.charCodeAt(d + 8)) || x > 55295 && x < 56320));
      }, le.isUsingKeyword = function(s, d) {
        if (this.options.ecmaVersion < 17 || !this.isContextual(s ? "await" : "using"))
          return !1;
        R.lastIndex = this.pos;
        var x = R.exec(this.input), k = this.pos + x[0].length;
        if (C.test(this.input.slice(this.pos, k)))
          return !1;
        if (s) {
          var D = k + 5, $;
          if (this.input.slice(k, D) !== "using" || D === this.input.length || v($ = this.input.charCodeAt(D)) || $ > 55295 && $ < 56320)
            return !1;
          R.lastIndex = D;
          var U = R.exec(this.input);
          if (U && C.test(this.input.slice(D, D + U[0].length)))
            return !1;
        }
        if (d) {
          var ae = k + 2, ce;
          if (this.input.slice(k, ae) === "of" && (ae === this.input.length || !v(ce = this.input.charCodeAt(ae)) && !(ce > 55295 && ce < 56320)))
            return !1;
        }
        var Ae = this.input.charCodeAt(k);
        return b(Ae, !0) || Ae === 92;
      }, le.isAwaitUsing = function(s) {
        return this.isUsingKeyword(!0, s);
      }, le.isUsing = function(s) {
        return this.isUsingKeyword(!1, s);
      }, le.parseStatement = function(s, d, x) {
        var k = this.type, D = this.startNode(), $;
        switch (this.isLet(s) && (k = f._var, $ = "let"), k) {
          case f._break:
          case f._continue:
            return this.parseBreakContinueStatement(D, k.keyword);
          case f._debugger:
            return this.parseDebuggerStatement(D);
          case f._do:
            return this.parseDoStatement(D);
          case f._for:
            return this.parseForStatement(D);
          case f._function:
            return s && (this.strict || s !== "if" && s !== "label") && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(D, !1, !s);
          case f._class:
            return s && this.unexpected(), this.parseClass(D, !0);
          case f._if:
            return this.parseIfStatement(D);
          case f._return:
            return this.parseReturnStatement(D);
          case f._switch:
            return this.parseSwitchStatement(D);
          case f._throw:
            return this.parseThrowStatement(D);
          case f._try:
            return this.parseTryStatement(D);
          case f._const:
          case f._var:
            return $ = $ || this.value, s && $ !== "var" && this.unexpected(), this.parseVarStatement(D, $);
          case f._while:
            return this.parseWhileStatement(D);
          case f._with:
            return this.parseWithStatement(D);
          case f.braceL:
            return this.parseBlock(!0, D);
          case f.semi:
            return this.parseEmptyStatement(D);
          case f._export:
          case f._import:
            if (this.options.ecmaVersion > 10 && k === f._import) {
              R.lastIndex = this.pos;
              var U = R.exec(this.input), ae = this.pos + U[0].length, ce = this.input.charCodeAt(ae);
              if (ce === 40 || ce === 46)
                return this.parseExpressionStatement(D, this.parseExpression());
            }
            return this.options.allowImportExportEverywhere || (d || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), k === f._import ? this.parseImport(D) : this.parseExport(D, x);
          // If the statement does not start with a statement keyword or a
          // brace, it's an ExpressionStatement or LabeledStatement. We
          // simply start parsing an expression, and afterwards, if the
          // next token is a colon and the expression was a simple
          // Identifier node, we switch to interpreting it as a label.
          default:
            if (this.isAsyncFunction())
              return s && this.unexpected(), this.next(), this.parseFunctionStatement(D, !0, !s);
            var Ae = this.isAwaitUsing(!1) ? "await using" : this.isUsing(!1) ? "using" : null;
            if (Ae)
              return d && this.options.sourceType === "script" && this.raise(this.start, "Using declaration cannot appear in the top level when source type is `script`"), Ae === "await using" && (this.canAwait || this.raise(this.start, "Await using cannot appear outside of async function"), this.next()), this.next(), this.parseVar(D, !1, Ae), this.semicolon(), this.finishNode(D, "VariableDeclaration");
            var Fe = this.value, nt = this.parseExpression();
            return k === f.name && nt.type === "Identifier" && this.eat(f.colon) ? this.parseLabeledStatement(D, Fe, nt, s) : this.parseExpressionStatement(D, nt);
        }
      }, le.parseBreakContinueStatement = function(s, d) {
        var x = d === "break";
        this.next(), this.eat(f.semi) || this.insertSemicolon() ? s.label = null : this.type !== f.name ? this.unexpected() : (s.label = this.parseIdent(), this.semicolon());
        for (var k = 0; k < this.labels.length; ++k) {
          var D = this.labels[k];
          if ((s.label == null || D.name === s.label.name) && (D.kind != null && (x || D.kind === "loop") || s.label && x))
            break;
        }
        return k === this.labels.length && this.raise(s.start, "Unsyntactic " + d), this.finishNode(s, x ? "BreakStatement" : "ContinueStatement");
      }, le.parseDebuggerStatement = function(s) {
        return this.next(), this.semicolon(), this.finishNode(s, "DebuggerStatement");
      }, le.parseDoStatement = function(s) {
        return this.next(), this.labels.push(yt), s.body = this.parseStatement("do"), this.labels.pop(), this.expect(f._while), s.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(f.semi) : this.semicolon(), this.finishNode(s, "DoWhileStatement");
      }, le.parseForStatement = function(s) {
        this.next();
        var d = this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual("await") ? this.lastTokStart : -1;
        if (this.labels.push(yt), this.enterScope(0), this.expect(f.parenL), this.type === f.semi)
          return d > -1 && this.unexpected(d), this.parseFor(s, null);
        var x = this.isLet();
        if (this.type === f._var || this.type === f._const || x) {
          var k = this.startNode(), D = x ? "let" : this.value;
          return this.next(), this.parseVar(k, !0, D), this.finishNode(k, "VariableDeclaration"), this.parseForAfterInit(s, k, d);
        }
        var $ = this.isContextual("let"), U = !1, ae = this.isUsing(!0) ? "using" : this.isAwaitUsing(!0) ? "await using" : null;
        if (ae) {
          var ce = this.startNode();
          return this.next(), ae === "await using" && this.next(), this.parseVar(ce, !0, ae), this.finishNode(ce, "VariableDeclaration"), this.parseForAfterInit(s, ce, d);
        }
        var Ae = this.containsEsc, Fe = new ut(), nt = this.start, Et = d > -1 ? this.parseExprSubscripts(Fe, "await") : this.parseExpression(!0, Fe);
        return this.type === f._in || (U = this.options.ecmaVersion >= 6 && this.isContextual("of")) ? (d > -1 ? (this.type === f._in && this.unexpected(d), s.await = !0) : U && this.options.ecmaVersion >= 8 && (Et.start === nt && !Ae && Et.type === "Identifier" && Et.name === "async" ? this.unexpected() : this.options.ecmaVersion >= 9 && (s.await = !1)), $ && U && this.raise(Et.start, "The left-hand side of a for-of loop may not start with 'let'."), this.toAssignable(Et, !1, Fe), this.checkLValPattern(Et), this.parseForIn(s, Et)) : (this.checkExpressionErrors(Fe, !0), d > -1 && this.unexpected(d), this.parseFor(s, Et));
      }, le.parseForAfterInit = function(s, d, x) {
        return (this.type === f._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && d.declarations.length === 1 ? (this.options.ecmaVersion >= 9 && (this.type === f._in ? x > -1 && this.unexpected(x) : s.await = x > -1), this.parseForIn(s, d)) : (x > -1 && this.unexpected(x), this.parseFor(s, d));
      }, le.parseFunctionStatement = function(s, d, x) {
        return this.next(), this.parseFunction(s, mt | (x ? 0 : pn), !1, d);
      }, le.parseIfStatement = function(s) {
        return this.next(), s.test = this.parseParenExpression(), s.consequent = this.parseStatement("if"), s.alternate = this.eat(f._else) ? this.parseStatement("if") : null, this.finishNode(s, "IfStatement");
      }, le.parseReturnStatement = function(s) {
        return !this.inFunction && !this.options.allowReturnOutsideFunction && this.raise(this.start, "'return' outside of function"), this.next(), this.eat(f.semi) || this.insertSemicolon() ? s.argument = null : (s.argument = this.parseExpression(), this.semicolon()), this.finishNode(s, "ReturnStatement");
      }, le.parseSwitchStatement = function(s) {
        this.next(), s.discriminant = this.parseParenExpression(), s.cases = [], this.expect(f.braceL), this.labels.push(qt), this.enterScope(0);
        for (var d, x = !1; this.type !== f.braceR; )
          if (this.type === f._case || this.type === f._default) {
            var k = this.type === f._case;
            d && this.finishNode(d, "SwitchCase"), s.cases.push(d = this.startNode()), d.consequent = [], this.next(), k ? d.test = this.parseExpression() : (x && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), x = !0, d.test = null), this.expect(f.colon);
          } else
            d || this.unexpected(), d.consequent.push(this.parseStatement(null));
        return this.exitScope(), d && this.finishNode(d, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(s, "SwitchStatement");
      }, le.parseThrowStatement = function(s) {
        return this.next(), C.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), s.argument = this.parseExpression(), this.semicolon(), this.finishNode(s, "ThrowStatement");
      };
      var In = [];
      le.parseCatchClauseParam = function() {
        var s = this.parseBindingAtom(), d = s.type === "Identifier";
        return this.enterScope(d ? Ye : 0), this.checkLValPattern(s, d ? An : qe), this.expect(f.parenR), s;
      }, le.parseTryStatement = function(s) {
        if (this.next(), s.block = this.parseBlock(), s.handler = null, this.type === f._catch) {
          var d = this.startNode();
          this.next(), this.eat(f.parenL) ? d.param = this.parseCatchClauseParam() : (this.options.ecmaVersion < 10 && this.unexpected(), d.param = null, this.enterScope(0)), d.body = this.parseBlock(!1), this.exitScope(), s.handler = this.finishNode(d, "CatchClause");
        }
        return s.finalizer = this.eat(f._finally) ? this.parseBlock() : null, !s.handler && !s.finalizer && this.raise(s.start, "Missing catch or finally clause"), this.finishNode(s, "TryStatement");
      }, le.parseVarStatement = function(s, d, x) {
        return this.next(), this.parseVar(s, !1, d, x), this.semicolon(), this.finishNode(s, "VariableDeclaration");
      }, le.parseWhileStatement = function(s) {
        return this.next(), s.test = this.parseParenExpression(), this.labels.push(yt), s.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(s, "WhileStatement");
      }, le.parseWithStatement = function(s) {
        return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), s.object = this.parseParenExpression(), s.body = this.parseStatement("with"), this.finishNode(s, "WithStatement");
      }, le.parseEmptyStatement = function(s) {
        return this.next(), this.finishNode(s, "EmptyStatement");
      }, le.parseLabeledStatement = function(s, d, x, k) {
        for (var D = 0, $ = this.labels; D < $.length; D += 1) {
          var U = $[D];
          U.name === d && this.raise(x.start, "Label '" + d + "' is already declared");
        }
        for (var ae = this.type.isLoop ? "loop" : this.type === f._switch ? "switch" : null, ce = this.labels.length - 1; ce >= 0; ce--) {
          var Ae = this.labels[ce];
          if (Ae.statementStart === s.start)
            Ae.statementStart = this.start, Ae.kind = ae;
          else
            break;
        }
        return this.labels.push({ name: d, kind: ae, statementStart: this.start }), s.body = this.parseStatement(k ? k.indexOf("label") === -1 ? k + "label" : k : "label"), this.labels.pop(), s.label = x, this.finishNode(s, "LabeledStatement");
      }, le.parseExpressionStatement = function(s, d) {
        return s.expression = d, this.semicolon(), this.finishNode(s, "ExpressionStatement");
      }, le.parseBlock = function(s, d, x) {
        for (s === void 0 && (s = !0), d === void 0 && (d = this.startNode()), d.body = [], this.expect(f.braceL), s && this.enterScope(0); this.type !== f.braceR; ) {
          var k = this.parseStatement(null);
          d.body.push(k);
        }
        return x && (this.strict = !1), this.next(), s && this.exitScope(), this.finishNode(d, "BlockStatement");
      }, le.parseFor = function(s, d) {
        return s.init = d, this.expect(f.semi), s.test = this.type === f.semi ? null : this.parseExpression(), this.expect(f.semi), s.update = this.type === f.parenR ? null : this.parseExpression(), this.expect(f.parenR), s.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(s, "ForStatement");
      }, le.parseForIn = function(s, d) {
        var x = this.type === f._in;
        return this.next(), d.type === "VariableDeclaration" && d.declarations[0].init != null && (!x || this.options.ecmaVersion < 8 || this.strict || d.kind !== "var" || d.declarations[0].id.type !== "Identifier") && this.raise(
          d.start,
          (x ? "for-in" : "for-of") + " loop variable declaration may not have an initializer"
        ), s.left = d, s.right = x ? this.parseExpression() : this.parseMaybeAssign(), this.expect(f.parenR), s.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(s, x ? "ForInStatement" : "ForOfStatement");
      }, le.parseVar = function(s, d, x, k) {
        for (s.declarations = [], s.kind = x; ; ) {
          var D = this.startNode();
          if (this.parseVarId(D, x), this.eat(f.eq) ? D.init = this.parseMaybeAssign(d) : !k && x === "const" && !(this.type === f._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) ? this.unexpected() : !k && (x === "using" || x === "await using") && this.options.ecmaVersion >= 17 && this.type !== f._in && !this.isContextual("of") ? this.raise(this.lastTokEnd, "Missing initializer in " + x + " declaration") : !k && D.id.type !== "Identifier" && !(d && (this.type === f._in || this.isContextual("of"))) ? this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : D.init = null, s.declarations.push(this.finishNode(D, "VariableDeclarator")), !this.eat(f.comma))
            break;
        }
        return s;
      }, le.parseVarId = function(s, d) {
        s.id = d === "using" || d === "await using" ? this.parseIdent() : this.parseBindingAtom(), this.checkLValPattern(s.id, d === "var" ? Ve : qe, !1);
      };
      var mt = 1, pn = 2, Xt = 4;
      le.parseFunction = function(s, d, x, k, D) {
        this.initFunction(s), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !k) && (this.type === f.star && d & pn && this.unexpected(), s.generator = this.eat(f.star)), this.options.ecmaVersion >= 8 && (s.async = !!k), d & mt && (s.id = d & Xt && this.type !== f.name ? null : this.parseIdent(), s.id && !(d & pn) && this.checkLValSimple(s.id, this.strict || s.generator || s.async ? this.treatFunctionsAsVar ? Ve : qe : De));
        var $ = this.yieldPos, U = this.awaitPos, ae = this.awaitIdentPos;
        return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(Ct(s.async, s.generator)), d & mt || (s.id = this.type === f.name ? this.parseIdent() : null), this.parseFunctionParams(s), this.parseFunctionBody(s, x, !1, D), this.yieldPos = $, this.awaitPos = U, this.awaitIdentPos = ae, this.finishNode(s, d & mt ? "FunctionDeclaration" : "FunctionExpression");
      }, le.parseFunctionParams = function(s) {
        this.expect(f.parenL), s.params = this.parseBindingList(f.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
      }, le.parseClass = function(s, d) {
        this.next();
        var x = this.strict;
        this.strict = !0, this.parseClassId(s, d), this.parseClassSuper(s);
        var k = this.enterClassBody(), D = this.startNode(), $ = !1;
        for (D.body = [], this.expect(f.braceL); this.type !== f.braceR; ) {
          var U = this.parseClassElement(s.superClass !== null);
          U && (D.body.push(U), U.type === "MethodDefinition" && U.kind === "constructor" ? ($ && this.raiseRecoverable(U.start, "Duplicate constructor in the same class"), $ = !0) : U.key && U.key.type === "PrivateIdentifier" && Yp(k, U) && this.raiseRecoverable(U.key.start, "Identifier '#" + U.key.name + "' has already been declared"));
        }
        return this.strict = x, this.next(), s.body = this.finishNode(D, "ClassBody"), this.exitClassBody(), this.finishNode(s, d ? "ClassDeclaration" : "ClassExpression");
      }, le.parseClassElement = function(s) {
        if (this.eat(f.semi))
          return null;
        var d = this.options.ecmaVersion, x = this.startNode(), k = "", D = !1, $ = !1, U = "method", ae = !1;
        if (this.eatContextual("static")) {
          if (d >= 13 && this.eat(f.braceL))
            return this.parseClassStaticBlock(x), x;
          this.isClassElementNameStart() || this.type === f.star ? ae = !0 : k = "static";
        }
        if (x.static = ae, !k && d >= 8 && this.eatContextual("async") && ((this.isClassElementNameStart() || this.type === f.star) && !this.canInsertSemicolon() ? $ = !0 : k = "async"), !k && (d >= 9 || !$) && this.eat(f.star) && (D = !0), !k && !$ && !D) {
          var ce = this.value;
          (this.eatContextual("get") || this.eatContextual("set")) && (this.isClassElementNameStart() ? U = ce : k = ce);
        }
        if (k ? (x.computed = !1, x.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc), x.key.name = k, this.finishNode(x.key, "Identifier")) : this.parseClassElementName(x), d < 13 || this.type === f.parenL || U !== "method" || D || $) {
          var Ae = !x.static && Dr(x, "constructor"), Fe = Ae && s;
          Ae && U !== "method" && this.raise(x.key.start, "Constructor can't have get/set modifier"), x.kind = Ae ? "constructor" : U, this.parseClassMethod(x, D, $, Fe);
        } else
          this.parseClassField(x);
        return x;
      }, le.isClassElementNameStart = function() {
        return this.type === f.name || this.type === f.privateId || this.type === f.num || this.type === f.string || this.type === f.bracketL || this.type.keyword;
      }, le.parseClassElementName = function(s) {
        this.type === f.privateId ? (this.value === "constructor" && this.raise(this.start, "Classes can't have an element named '#constructor'"), s.computed = !1, s.key = this.parsePrivateIdent()) : this.parsePropertyName(s);
      }, le.parseClassMethod = function(s, d, x, k) {
        var D = s.key;
        s.kind === "constructor" ? (d && this.raise(D.start, "Constructor can't be a generator"), x && this.raise(D.start, "Constructor can't be an async method")) : s.static && Dr(s, "prototype") && this.raise(D.start, "Classes may not have a static property named prototype");
        var $ = s.value = this.parseMethod(d, x, k);
        return s.kind === "get" && $.params.length !== 0 && this.raiseRecoverable($.start, "getter should have no params"), s.kind === "set" && $.params.length !== 1 && this.raiseRecoverable($.start, "setter should have exactly one param"), s.kind === "set" && $.params[0].type === "RestElement" && this.raiseRecoverable($.params[0].start, "Setter cannot use rest params"), this.finishNode(s, "MethodDefinition");
      }, le.parseClassField = function(s) {
        return Dr(s, "constructor") ? this.raise(s.key.start, "Classes can't have a field named 'constructor'") : s.static && Dr(s, "prototype") && this.raise(s.key.start, "Classes can't have a static field named 'prototype'"), this.eat(f.eq) ? (this.enterScope(Oe | ot), s.value = this.parseMaybeAssign(), this.exitScope()) : s.value = null, this.semicolon(), this.finishNode(s, "PropertyDefinition");
      }, le.parseClassStaticBlock = function(s) {
        s.body = [];
        var d = this.labels;
        for (this.labels = [], this.enterScope(ht | ot); this.type !== f.braceR; ) {
          var x = this.parseStatement(null);
          s.body.push(x);
        }
        return this.next(), this.exitScope(), this.labels = d, this.finishNode(s, "StaticBlock");
      }, le.parseClassId = function(s, d) {
        this.type === f.name ? (s.id = this.parseIdent(), d && this.checkLValSimple(s.id, qe, !1)) : (d === !0 && this.unexpected(), s.id = null);
      }, le.parseClassSuper = function(s) {
        s.superClass = this.eat(f._extends) ? this.parseExprSubscripts(null, !1) : null;
      }, le.enterClassBody = function() {
        var s = { declared: /* @__PURE__ */ Object.create(null), used: [] };
        return this.privateNameStack.push(s), s.declared;
      }, le.exitClassBody = function() {
        var s = this.privateNameStack.pop(), d = s.declared, x = s.used;
        if (this.options.checkPrivateFields)
          for (var k = this.privateNameStack.length, D = k === 0 ? null : this.privateNameStack[k - 1], $ = 0; $ < x.length; ++$) {
            var U = x[$];
            X(d, U.name) || (D ? D.used.push(U) : this.raiseRecoverable(U.start, "Private field '#" + U.name + "' must be declared in an enclosing class"));
          }
      };
      function Yp(s, d) {
        var x = d.key.name, k = s[x], D = "true";
        return d.type === "MethodDefinition" && (d.kind === "get" || d.kind === "set") && (D = (d.static ? "s" : "i") + d.kind), k === "iget" && D === "iset" || k === "iset" && D === "iget" || k === "sget" && D === "sset" || k === "sset" && D === "sget" ? (s[x] = "true", !1) : k ? !0 : (s[x] = D, !1);
      }
      function Dr(s, d) {
        var x = s.computed, k = s.key;
        return !x && (k.type === "Identifier" && k.name === d || k.type === "Literal" && k.value === d);
      }
      le.parseExportAllDeclaration = function(s, d) {
        return this.options.ecmaVersion >= 11 && (this.eatContextual("as") ? (s.exported = this.parseModuleExportName(), this.checkExport(d, s.exported, this.lastTokStart)) : s.exported = null), this.expectContextual("from"), this.type !== f.string && this.unexpected(), s.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (s.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(s, "ExportAllDeclaration");
      }, le.parseExport = function(s, d) {
        if (this.next(), this.eat(f.star))
          return this.parseExportAllDeclaration(s, d);
        if (this.eat(f._default))
          return this.checkExport(d, "default", this.lastTokStart), s.declaration = this.parseExportDefaultDeclaration(), this.finishNode(s, "ExportDefaultDeclaration");
        if (this.shouldParseExportStatement())
          s.declaration = this.parseExportDeclaration(s), s.declaration.type === "VariableDeclaration" ? this.checkVariableExport(d, s.declaration.declarations) : this.checkExport(d, s.declaration.id, s.declaration.id.start), s.specifiers = [], s.source = null, this.options.ecmaVersion >= 16 && (s.attributes = []);
        else {
          if (s.declaration = null, s.specifiers = this.parseExportSpecifiers(d), this.eatContextual("from"))
            this.type !== f.string && this.unexpected(), s.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (s.attributes = this.parseWithClause());
          else {
            for (var x = 0, k = s.specifiers; x < k.length; x += 1) {
              var D = k[x];
              this.checkUnreserved(D.local), this.checkLocalExport(D.local), D.local.type === "Literal" && this.raise(D.local.start, "A string literal cannot be used as an exported binding without `from`.");
            }
            s.source = null, this.options.ecmaVersion >= 16 && (s.attributes = []);
          }
          this.semicolon();
        }
        return this.finishNode(s, "ExportNamedDeclaration");
      }, le.parseExportDeclaration = function(s) {
        return this.parseStatement(null);
      }, le.parseExportDefaultDeclaration = function() {
        var s;
        if (this.type === f._function || (s = this.isAsyncFunction())) {
          var d = this.startNode();
          return this.next(), s && this.next(), this.parseFunction(d, mt | Xt, !1, s);
        } else if (this.type === f._class) {
          var x = this.startNode();
          return this.parseClass(x, "nullableID");
        } else {
          var k = this.parseMaybeAssign();
          return this.semicolon(), k;
        }
      }, le.checkExport = function(s, d, x) {
        s && (typeof d != "string" && (d = d.type === "Identifier" ? d.name : d.value), X(s, d) && this.raiseRecoverable(x, "Duplicate export '" + d + "'"), s[d] = !0);
      }, le.checkPatternExport = function(s, d) {
        var x = d.type;
        if (x === "Identifier")
          this.checkExport(s, d, d.start);
        else if (x === "ObjectPattern")
          for (var k = 0, D = d.properties; k < D.length; k += 1) {
            var $ = D[k];
            this.checkPatternExport(s, $);
          }
        else if (x === "ArrayPattern")
          for (var U = 0, ae = d.elements; U < ae.length; U += 1) {
            var ce = ae[U];
            ce && this.checkPatternExport(s, ce);
          }
        else x === "Property" ? this.checkPatternExport(s, d.value) : x === "AssignmentPattern" ? this.checkPatternExport(s, d.left) : x === "RestElement" && this.checkPatternExport(s, d.argument);
      }, le.checkVariableExport = function(s, d) {
        if (s)
          for (var x = 0, k = d; x < k.length; x += 1) {
            var D = k[x];
            this.checkPatternExport(s, D.id);
          }
      }, le.shouldParseExportStatement = function() {
        return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
      }, le.parseExportSpecifier = function(s) {
        var d = this.startNode();
        return d.local = this.parseModuleExportName(), d.exported = this.eatContextual("as") ? this.parseModuleExportName() : d.local, this.checkExport(
          s,
          d.exported,
          d.exported.start
        ), this.finishNode(d, "ExportSpecifier");
      }, le.parseExportSpecifiers = function(s) {
        var d = [], x = !0;
        for (this.expect(f.braceL); !this.eat(f.braceR); ) {
          if (x)
            x = !1;
          else if (this.expect(f.comma), this.afterTrailingComma(f.braceR))
            break;
          d.push(this.parseExportSpecifier(s));
        }
        return d;
      }, le.parseImport = function(s) {
        return this.next(), this.type === f.string ? (s.specifiers = In, s.source = this.parseExprAtom()) : (s.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), s.source = this.type === f.string ? this.parseExprAtom() : this.unexpected()), this.options.ecmaVersion >= 16 && (s.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(s, "ImportDeclaration");
      }, le.parseImportSpecifier = function() {
        var s = this.startNode();
        return s.imported = this.parseModuleExportName(), this.eatContextual("as") ? s.local = this.parseIdent() : (this.checkUnreserved(s.imported), s.local = s.imported), this.checkLValSimple(s.local, qe), this.finishNode(s, "ImportSpecifier");
      }, le.parseImportDefaultSpecifier = function() {
        var s = this.startNode();
        return s.local = this.parseIdent(), this.checkLValSimple(s.local, qe), this.finishNode(s, "ImportDefaultSpecifier");
      }, le.parseImportNamespaceSpecifier = function() {
        var s = this.startNode();
        return this.next(), this.expectContextual("as"), s.local = this.parseIdent(), this.checkLValSimple(s.local, qe), this.finishNode(s, "ImportNamespaceSpecifier");
      }, le.parseImportSpecifiers = function() {
        var s = [], d = !0;
        if (this.type === f.name && (s.push(this.parseImportDefaultSpecifier()), !this.eat(f.comma)))
          return s;
        if (this.type === f.star)
          return s.push(this.parseImportNamespaceSpecifier()), s;
        for (this.expect(f.braceL); !this.eat(f.braceR); ) {
          if (d)
            d = !1;
          else if (this.expect(f.comma), this.afterTrailingComma(f.braceR))
            break;
          s.push(this.parseImportSpecifier());
        }
        return s;
      }, le.parseWithClause = function() {
        var s = [];
        if (!this.eat(f._with))
          return s;
        this.expect(f.braceL);
        for (var d = {}, x = !0; !this.eat(f.braceR); ) {
          if (x)
            x = !1;
          else if (this.expect(f.comma), this.afterTrailingComma(f.braceR))
            break;
          var k = this.parseImportAttribute(), D = k.key.type === "Identifier" ? k.key.name : k.key.value;
          X(d, D) && this.raiseRecoverable(k.key.start, "Duplicate attribute key '" + D + "'"), d[D] = !0, s.push(k);
        }
        return s;
      }, le.parseImportAttribute = function() {
        var s = this.startNode();
        return s.key = this.type === f.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never"), this.expect(f.colon), this.type !== f.string && this.unexpected(), s.value = this.parseExprAtom(), this.finishNode(s, "ImportAttribute");
      }, le.parseModuleExportName = function() {
        if (this.options.ecmaVersion >= 13 && this.type === f.string) {
          var s = this.parseLiteral(this.value);
          return ue.test(s.value) && this.raise(s.start, "An export name cannot include a lone surrogate."), s;
        }
        return this.parseIdent(!0);
      }, le.adaptDirectivePrologue = function(s) {
        for (var d = 0; d < s.length && this.isDirectiveCandidate(s[d]); ++d)
          s[d].directive = s[d].expression.raw.slice(1, -1);
      }, le.isDirectiveCandidate = function(s) {
        return this.options.ecmaVersion >= 5 && s.type === "ExpressionStatement" && s.expression.type === "Literal" && typeof s.expression.value == "string" && // Reject parenthesized strings.
        (this.input[s.start] === '"' || this.input[s.start] === "'");
      };
      var Zt = G.prototype;
      Zt.toAssignable = function(s, d, x) {
        if (this.options.ecmaVersion >= 6 && s)
          switch (s.type) {
            case "Identifier":
              this.inAsync && s.name === "await" && this.raise(s.start, "Cannot use 'await' as identifier inside an async function");
              break;
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "RestElement":
              break;
            case "ObjectExpression":
              s.type = "ObjectPattern", x && this.checkPatternErrors(x, !0);
              for (var k = 0, D = s.properties; k < D.length; k += 1) {
                var $ = D[k];
                this.toAssignable($, d), $.type === "RestElement" && ($.argument.type === "ArrayPattern" || $.argument.type === "ObjectPattern") && this.raise($.argument.start, "Unexpected token");
              }
              break;
            case "Property":
              s.kind !== "init" && this.raise(s.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(s.value, d);
              break;
            case "ArrayExpression":
              s.type = "ArrayPattern", x && this.checkPatternErrors(x, !0), this.toAssignableList(s.elements, d);
              break;
            case "SpreadElement":
              s.type = "RestElement", this.toAssignable(s.argument, d), s.argument.type === "AssignmentPattern" && this.raise(s.argument.start, "Rest elements cannot have a default value");
              break;
            case "AssignmentExpression":
              s.operator !== "=" && this.raise(s.left.end, "Only '=' operator can be used for specifying default value."), s.type = "AssignmentPattern", delete s.operator, this.toAssignable(s.left, d);
              break;
            case "ParenthesizedExpression":
              this.toAssignable(s.expression, d, x);
              break;
            case "ChainExpression":
              this.raiseRecoverable(s.start, "Optional chaining cannot appear in left-hand side");
              break;
            case "MemberExpression":
              if (!d)
                break;
            default:
              this.raise(s.start, "Assigning to rvalue");
          }
        else x && this.checkPatternErrors(x, !0);
        return s;
      }, Zt.toAssignableList = function(s, d) {
        for (var x = s.length, k = 0; k < x; k++) {
          var D = s[k];
          D && this.toAssignable(D, d);
        }
        if (x) {
          var $ = s[x - 1];
          this.options.ecmaVersion === 6 && d && $ && $.type === "RestElement" && $.argument.type !== "Identifier" && this.unexpected($.argument.start);
        }
        return s;
      }, Zt.parseSpread = function(s) {
        var d = this.startNode();
        return this.next(), d.argument = this.parseMaybeAssign(!1, s), this.finishNode(d, "SpreadElement");
      }, Zt.parseRestBinding = function() {
        var s = this.startNode();
        return this.next(), this.options.ecmaVersion === 6 && this.type !== f.name && this.unexpected(), s.argument = this.parseBindingAtom(), this.finishNode(s, "RestElement");
      }, Zt.parseBindingAtom = function() {
        if (this.options.ecmaVersion >= 6)
          switch (this.type) {
            case f.bracketL:
              var s = this.startNode();
              return this.next(), s.elements = this.parseBindingList(f.bracketR, !0, !0), this.finishNode(s, "ArrayPattern");
            case f.braceL:
              return this.parseObj(!0);
          }
        return this.parseIdent();
      }, Zt.parseBindingList = function(s, d, x, k) {
        for (var D = [], $ = !0; !this.eat(s); )
          if ($ ? $ = !1 : this.expect(f.comma), d && this.type === f.comma)
            D.push(null);
          else {
            if (x && this.afterTrailingComma(s))
              break;
            if (this.type === f.ellipsis) {
              var U = this.parseRestBinding();
              this.parseBindingListItem(U), D.push(U), this.type === f.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.expect(s);
              break;
            } else
              D.push(this.parseAssignableListItem(k));
          }
        return D;
      }, Zt.parseAssignableListItem = function(s) {
        var d = this.parseMaybeDefault(this.start, this.startLoc);
        return this.parseBindingListItem(d), d;
      }, Zt.parseBindingListItem = function(s) {
        return s;
      }, Zt.parseMaybeDefault = function(s, d, x) {
        if (x = x || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(f.eq))
          return x;
        var k = this.startNodeAt(s, d);
        return k.left = x, k.right = this.parseMaybeAssign(), this.finishNode(k, "AssignmentPattern");
      }, Zt.checkLValSimple = function(s, d, x) {
        d === void 0 && (d = St);
        var k = d !== St;
        switch (s.type) {
          case "Identifier":
            this.strict && this.reservedWordsStrictBind.test(s.name) && this.raiseRecoverable(s.start, (k ? "Binding " : "Assigning to ") + s.name + " in strict mode"), k && (d === qe && s.name === "let" && this.raiseRecoverable(s.start, "let is disallowed as a lexically bound name"), x && (X(x, s.name) && this.raiseRecoverable(s.start, "Argument name clash"), x[s.name] = !0), d !== Z && this.declareName(s.name, d, s.start));
            break;
          case "ChainExpression":
            this.raiseRecoverable(s.start, "Optional chaining cannot appear in left-hand side");
            break;
          case "MemberExpression":
            k && this.raiseRecoverable(s.start, "Binding member expression");
            break;
          case "ParenthesizedExpression":
            return k && this.raiseRecoverable(s.start, "Binding parenthesized expression"), this.checkLValSimple(s.expression, d, x);
          default:
            this.raise(s.start, (k ? "Binding" : "Assigning to") + " rvalue");
        }
      }, Zt.checkLValPattern = function(s, d, x) {
        switch (d === void 0 && (d = St), s.type) {
          case "ObjectPattern":
            for (var k = 0, D = s.properties; k < D.length; k += 1) {
              var $ = D[k];
              this.checkLValInnerPattern($, d, x);
            }
            break;
          case "ArrayPattern":
            for (var U = 0, ae = s.elements; U < ae.length; U += 1) {
              var ce = ae[U];
              ce && this.checkLValInnerPattern(ce, d, x);
            }
            break;
          default:
            this.checkLValSimple(s, d, x);
        }
      }, Zt.checkLValInnerPattern = function(s, d, x) {
        switch (d === void 0 && (d = St), s.type) {
          case "Property":
            this.checkLValInnerPattern(s.value, d, x);
            break;
          case "AssignmentPattern":
            this.checkLValPattern(s.left, d, x);
            break;
          case "RestElement":
            this.checkLValPattern(s.argument, d, x);
            break;
          default:
            this.checkLValPattern(s, d, x);
        }
      };
      var Gt = function(d, x, k, D, $) {
        this.token = d, this.isExpr = !!x, this.preserveSpace = !!k, this.override = D, this.generator = !!$;
      }, tt = {
        b_stat: new Gt("{", !1),
        b_expr: new Gt("{", !0),
        b_tmpl: new Gt("${", !1),
        p_stat: new Gt("(", !1),
        p_expr: new Gt("(", !0),
        q_tmpl: new Gt("`", !0, !0, function(s) {
          return s.tryReadTemplateToken();
        }),
        f_stat: new Gt("function", !1),
        f_expr: new Gt("function", !0),
        f_expr_gen: new Gt("function", !0, !1, null, !0),
        f_gen: new Gt("function", !1, !1, null, !0)
      }, _i = G.prototype;
      _i.initialContext = function() {
        return [tt.b_stat];
      }, _i.curContext = function() {
        return this.context[this.context.length - 1];
      }, _i.braceIsBlock = function(s) {
        var d = this.curContext();
        return d === tt.f_expr || d === tt.f_stat ? !0 : s === f.colon && (d === tt.b_stat || d === tt.b_expr) ? !d.isExpr : s === f._return || s === f.name && this.exprAllowed ? C.test(this.input.slice(this.lastTokEnd, this.start)) : s === f._else || s === f.semi || s === f.eof || s === f.parenR || s === f.arrow ? !0 : s === f.braceL ? d === tt.b_stat : s === f._var || s === f._const || s === f.name ? !1 : !this.exprAllowed;
      }, _i.inGeneratorContext = function() {
        for (var s = this.context.length - 1; s >= 1; s--) {
          var d = this.context[s];
          if (d.token === "function")
            return d.generator;
        }
        return !1;
      }, _i.updateContext = function(s) {
        var d, x = this.type;
        x.keyword && s === f.dot ? this.exprAllowed = !1 : (d = x.updateContext) ? d.call(this, s) : this.exprAllowed = x.beforeExpr;
      }, _i.overrideContext = function(s) {
        this.curContext() !== s && (this.context[this.context.length - 1] = s);
      }, f.parenR.updateContext = f.braceR.updateContext = function() {
        if (this.context.length === 1) {
          this.exprAllowed = !0;
          return;
        }
        var s = this.context.pop();
        s === tt.b_stat && this.curContext().token === "function" && (s = this.context.pop()), this.exprAllowed = !s.isExpr;
      }, f.braceL.updateContext = function(s) {
        this.context.push(this.braceIsBlock(s) ? tt.b_stat : tt.b_expr), this.exprAllowed = !0;
      }, f.dollarBraceL.updateContext = function() {
        this.context.push(tt.b_tmpl), this.exprAllowed = !0;
      }, f.parenL.updateContext = function(s) {
        var d = s === f._if || s === f._for || s === f._with || s === f._while;
        this.context.push(d ? tt.p_stat : tt.p_expr), this.exprAllowed = !0;
      }, f.incDec.updateContext = function() {
      }, f._function.updateContext = f._class.updateContext = function(s) {
        s.beforeExpr && s !== f._else && !(s === f.semi && this.curContext() !== tt.p_stat) && !(s === f._return && C.test(this.input.slice(this.lastTokEnd, this.start))) && !((s === f.colon || s === f.braceL) && this.curContext() === tt.b_stat) ? this.context.push(tt.f_expr) : this.context.push(tt.f_stat), this.exprAllowed = !1;
      }, f.colon.updateContext = function() {
        this.curContext().token === "function" && this.context.pop(), this.exprAllowed = !0;
      }, f.backQuote.updateContext = function() {
        this.curContext() === tt.q_tmpl ? this.context.pop() : this.context.push(tt.q_tmpl), this.exprAllowed = !1;
      }, f.star.updateContext = function(s) {
        if (s === f._function) {
          var d = this.context.length - 1;
          this.context[d] === tt.f_expr ? this.context[d] = tt.f_expr_gen : this.context[d] = tt.f_gen;
        }
        this.exprAllowed = !0;
      }, f.name.updateContext = function(s) {
        var d = !1;
        this.options.ecmaVersion >= 6 && s !== f.dot && (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) && (d = !0), this.exprAllowed = d;
      };
      var Ie = G.prototype;
      Ie.checkPropClash = function(s, d, x) {
        if (!(this.options.ecmaVersion >= 9 && s.type === "SpreadElement") && !(this.options.ecmaVersion >= 6 && (s.computed || s.method || s.shorthand))) {
          var k = s.key, D;
          switch (k.type) {
            case "Identifier":
              D = k.name;
              break;
            case "Literal":
              D = String(k.value);
              break;
            default:
              return;
          }
          var $ = s.kind;
          if (this.options.ecmaVersion >= 6) {
            D === "__proto__" && $ === "init" && (d.proto && (x ? x.doubleProto < 0 && (x.doubleProto = k.start) : this.raiseRecoverable(k.start, "Redefinition of __proto__ property")), d.proto = !0);
            return;
          }
          D = "$" + D;
          var U = d[D];
          if (U) {
            var ae;
            $ === "init" ? ae = this.strict && U.init || U.get || U.set : ae = U.init || U[$], ae && this.raiseRecoverable(k.start, "Redefinition of property");
          } else
            U = d[D] = {
              init: !1,
              get: !1,
              set: !1
            };
          U[$] = !0;
        }
      }, Ie.parseExpression = function(s, d) {
        var x = this.start, k = this.startLoc, D = this.parseMaybeAssign(s, d);
        if (this.type === f.comma) {
          var $ = this.startNodeAt(x, k);
          for ($.expressions = [D]; this.eat(f.comma); )
            $.expressions.push(this.parseMaybeAssign(s, d));
          return this.finishNode($, "SequenceExpression");
        }
        return D;
      }, Ie.parseMaybeAssign = function(s, d, x) {
        if (this.isContextual("yield")) {
          if (this.inGenerator)
            return this.parseYield(s);
          this.exprAllowed = !1;
        }
        var k = !1, D = -1, $ = -1, U = -1;
        d ? (D = d.parenthesizedAssign, $ = d.trailingComma, U = d.doubleProto, d.parenthesizedAssign = d.trailingComma = -1) : (d = new ut(), k = !0);
        var ae = this.start, ce = this.startLoc;
        (this.type === f.parenL || this.type === f.name) && (this.potentialArrowAt = this.start, this.potentialArrowInForAwait = s === "await");
        var Ae = this.parseMaybeConditional(s, d);
        if (x && (Ae = x.call(this, Ae, ae, ce)), this.type.isAssign) {
          var Fe = this.startNodeAt(ae, ce);
          return Fe.operator = this.value, this.type === f.eq && (Ae = this.toAssignable(Ae, !1, d)), k || (d.parenthesizedAssign = d.trailingComma = d.doubleProto = -1), d.shorthandAssign >= Ae.start && (d.shorthandAssign = -1), this.type === f.eq ? this.checkLValPattern(Ae) : this.checkLValSimple(Ae), Fe.left = Ae, this.next(), Fe.right = this.parseMaybeAssign(s), U > -1 && (d.doubleProto = U), this.finishNode(Fe, "AssignmentExpression");
        } else
          k && this.checkExpressionErrors(d, !0);
        return D > -1 && (d.parenthesizedAssign = D), $ > -1 && (d.trailingComma = $), Ae;
      }, Ie.parseMaybeConditional = function(s, d) {
        var x = this.start, k = this.startLoc, D = this.parseExprOps(s, d);
        if (this.checkExpressionErrors(d))
          return D;
        if (this.eat(f.question)) {
          var $ = this.startNodeAt(x, k);
          return $.test = D, $.consequent = this.parseMaybeAssign(), this.expect(f.colon), $.alternate = this.parseMaybeAssign(s), this.finishNode($, "ConditionalExpression");
        }
        return D;
      }, Ie.parseExprOps = function(s, d) {
        var x = this.start, k = this.startLoc, D = this.parseMaybeUnary(d, !1, !1, s);
        return this.checkExpressionErrors(d) || D.start === x && D.type === "ArrowFunctionExpression" ? D : this.parseExprOp(D, x, k, -1, s);
      }, Ie.parseExprOp = function(s, d, x, k, D) {
        var $ = this.type.binop;
        if ($ != null && (!D || this.type !== f._in) && $ > k) {
          var U = this.type === f.logicalOR || this.type === f.logicalAND, ae = this.type === f.coalesce;
          ae && ($ = f.logicalAND.binop);
          var ce = this.value;
          this.next();
          var Ae = this.start, Fe = this.startLoc, nt = this.parseExprOp(this.parseMaybeUnary(null, !1, !1, D), Ae, Fe, $, D), Et = this.buildBinary(d, x, s, nt, ce, U || ae);
          return (U && this.type === f.coalesce || ae && (this.type === f.logicalOR || this.type === f.logicalAND)) && this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses"), this.parseExprOp(Et, d, x, k, D);
        }
        return s;
      }, Ie.buildBinary = function(s, d, x, k, D, $) {
        k.type === "PrivateIdentifier" && this.raise(k.start, "Private identifier can only be left side of binary expression");
        var U = this.startNodeAt(s, d);
        return U.left = x, U.operator = D, U.right = k, this.finishNode(U, $ ? "LogicalExpression" : "BinaryExpression");
      }, Ie.parseMaybeUnary = function(s, d, x, k) {
        var D = this.start, $ = this.startLoc, U;
        if (this.isContextual("await") && this.canAwait)
          U = this.parseAwait(k), d = !0;
        else if (this.type.prefix) {
          var ae = this.startNode(), ce = this.type === f.incDec;
          ae.operator = this.value, ae.prefix = !0, this.next(), ae.argument = this.parseMaybeUnary(null, !0, ce, k), this.checkExpressionErrors(s, !0), ce ? this.checkLValSimple(ae.argument) : this.strict && ae.operator === "delete" && Uo(ae.argument) ? this.raiseRecoverable(ae.start, "Deleting local variable in strict mode") : ae.operator === "delete" && Ns(ae.argument) ? this.raiseRecoverable(ae.start, "Private fields can not be deleted") : d = !0, U = this.finishNode(ae, ce ? "UpdateExpression" : "UnaryExpression");
        } else if (!d && this.type === f.privateId)
          (k || this.privateNameStack.length === 0) && this.options.checkPrivateFields && this.unexpected(), U = this.parsePrivateIdent(), this.type !== f._in && this.unexpected();
        else {
          if (U = this.parseExprSubscripts(s, k), this.checkExpressionErrors(s))
            return U;
          for (; this.type.postfix && !this.canInsertSemicolon(); ) {
            var Ae = this.startNodeAt(D, $);
            Ae.operator = this.value, Ae.prefix = !1, Ae.argument = U, this.checkLValSimple(U), this.next(), U = this.finishNode(Ae, "UpdateExpression");
          }
        }
        if (!x && this.eat(f.starstar))
          if (d)
            this.unexpected(this.lastTokStart);
          else
            return this.buildBinary(D, $, U, this.parseMaybeUnary(null, !1, !1, k), "**", !1);
        else
          return U;
      };
      function Uo(s) {
        return s.type === "Identifier" || s.type === "ParenthesizedExpression" && Uo(s.expression);
      }
      function Ns(s) {
        return s.type === "MemberExpression" && s.property.type === "PrivateIdentifier" || s.type === "ChainExpression" && Ns(s.expression) || s.type === "ParenthesizedExpression" && Ns(s.expression);
      }
      Ie.parseExprSubscripts = function(s, d) {
        var x = this.start, k = this.startLoc, D = this.parseExprAtom(s, d);
        if (D.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")")
          return D;
        var $ = this.parseSubscripts(D, x, k, !1, d);
        return s && $.type === "MemberExpression" && (s.parenthesizedAssign >= $.start && (s.parenthesizedAssign = -1), s.parenthesizedBind >= $.start && (s.parenthesizedBind = -1), s.trailingComma >= $.start && (s.trailingComma = -1)), $;
      }, Ie.parseSubscripts = function(s, d, x, k, D) {
        for (var $ = this.options.ecmaVersion >= 8 && s.type === "Identifier" && s.name === "async" && this.lastTokEnd === s.end && !this.canInsertSemicolon() && s.end - s.start === 5 && this.potentialArrowAt === s.start, U = !1; ; ) {
          var ae = this.parseSubscript(s, d, x, k, $, U, D);
          if (ae.optional && (U = !0), ae === s || ae.type === "ArrowFunctionExpression") {
            if (U) {
              var ce = this.startNodeAt(d, x);
              ce.expression = ae, ae = this.finishNode(ce, "ChainExpression");
            }
            return ae;
          }
          s = ae;
        }
      }, Ie.shouldParseAsyncArrow = function() {
        return !this.canInsertSemicolon() && this.eat(f.arrow);
      }, Ie.parseSubscriptAsyncArrow = function(s, d, x, k) {
        return this.parseArrowExpression(this.startNodeAt(s, d), x, !0, k);
      }, Ie.parseSubscript = function(s, d, x, k, D, $, U) {
        var ae = this.options.ecmaVersion >= 11, ce = ae && this.eat(f.questionDot);
        k && ce && this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
        var Ae = this.eat(f.bracketL);
        if (Ae || ce && this.type !== f.parenL && this.type !== f.backQuote || this.eat(f.dot)) {
          var Fe = this.startNodeAt(d, x);
          Fe.object = s, Ae ? (Fe.property = this.parseExpression(), this.expect(f.bracketR)) : this.type === f.privateId && s.type !== "Super" ? Fe.property = this.parsePrivateIdent() : Fe.property = this.parseIdent(this.options.allowReserved !== "never"), Fe.computed = !!Ae, ae && (Fe.optional = ce), s = this.finishNode(Fe, "MemberExpression");
        } else if (!k && this.eat(f.parenL)) {
          var nt = new ut(), Et = this.yieldPos, Qi = this.awaitPos, xi = this.awaitIdentPos;
          this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
          var Or = this.parseExprList(f.parenR, this.options.ecmaVersion >= 8, !1, nt);
          if (D && !ce && this.shouldParseAsyncArrow())
            return this.checkPatternErrors(nt, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = Et, this.awaitPos = Qi, this.awaitIdentPos = xi, this.parseSubscriptAsyncArrow(d, x, Or, U);
          this.checkExpressionErrors(nt, !0), this.yieldPos = Et || this.yieldPos, this.awaitPos = Qi || this.awaitPos, this.awaitIdentPos = xi || this.awaitIdentPos;
          var yi = this.startNodeAt(d, x);
          yi.callee = s, yi.arguments = Or, ae && (yi.optional = ce), s = this.finishNode(yi, "CallExpression");
        } else if (this.type === f.backQuote) {
          (ce || $) && this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
          var bi = this.startNodeAt(d, x);
          bi.tag = s, bi.quasi = this.parseTemplate({ isTagged: !0 }), s = this.finishNode(bi, "TaggedTemplateExpression");
        }
        return s;
      }, Ie.parseExprAtom = function(s, d, x) {
        this.type === f.slash && this.readRegexp();
        var k, D = this.potentialArrowAt === this.start;
        switch (this.type) {
          case f._super:
            return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), k = this.startNode(), this.next(), this.type === f.parenL && !this.allowDirectSuper && this.raise(k.start, "super() call outside constructor of a subclass"), this.type !== f.dot && this.type !== f.bracketL && this.type !== f.parenL && this.unexpected(), this.finishNode(k, "Super");
          case f._this:
            return k = this.startNode(), this.next(), this.finishNode(k, "ThisExpression");
          case f.name:
            var $ = this.start, U = this.startLoc, ae = this.containsEsc, ce = this.parseIdent(!1);
            if (this.options.ecmaVersion >= 8 && !ae && ce.name === "async" && !this.canInsertSemicolon() && this.eat(f._function))
              return this.overrideContext(tt.f_expr), this.parseFunction(this.startNodeAt($, U), 0, !1, !0, d);
            if (D && !this.canInsertSemicolon()) {
              if (this.eat(f.arrow))
                return this.parseArrowExpression(this.startNodeAt($, U), [ce], !1, d);
              if (this.options.ecmaVersion >= 8 && ce.name === "async" && this.type === f.name && !ae && (!this.potentialArrowInForAwait || this.value !== "of" || this.containsEsc))
                return ce = this.parseIdent(!1), (this.canInsertSemicolon() || !this.eat(f.arrow)) && this.unexpected(), this.parseArrowExpression(this.startNodeAt($, U), [ce], !0, d);
            }
            return ce;
          case f.regexp:
            var Ae = this.value;
            return k = this.parseLiteral(Ae.value), k.regex = { pattern: Ae.pattern, flags: Ae.flags }, k;
          case f.num:
          case f.string:
            return this.parseLiteral(this.value);
          case f._null:
          case f._true:
          case f._false:
            return k = this.startNode(), k.value = this.type === f._null ? null : this.type === f._true, k.raw = this.type.keyword, this.next(), this.finishNode(k, "Literal");
          case f.parenL:
            var Fe = this.start, nt = this.parseParenAndDistinguishExpression(D, d);
            return s && (s.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(nt) && (s.parenthesizedAssign = Fe), s.parenthesizedBind < 0 && (s.parenthesizedBind = Fe)), nt;
          case f.bracketL:
            return k = this.startNode(), this.next(), k.elements = this.parseExprList(f.bracketR, !0, !0, s), this.finishNode(k, "ArrayExpression");
          case f.braceL:
            return this.overrideContext(tt.b_expr), this.parseObj(!1, s);
          case f._function:
            return k = this.startNode(), this.next(), this.parseFunction(k, 0);
          case f._class:
            return this.parseClass(this.startNode(), !1);
          case f._new:
            return this.parseNew();
          case f.backQuote:
            return this.parseTemplate();
          case f._import:
            return this.options.ecmaVersion >= 11 ? this.parseExprImport(x) : this.unexpected();
          default:
            return this.parseExprAtomDefault();
        }
      }, Ie.parseExprAtomDefault = function() {
        this.unexpected();
      }, Ie.parseExprImport = function(s) {
        var d = this.startNode();
        if (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword import"), this.next(), this.type === f.parenL && !s)
          return this.parseDynamicImport(d);
        if (this.type === f.dot) {
          var x = this.startNodeAt(d.start, d.loc && d.loc.start);
          return x.name = "import", d.meta = this.finishNode(x, "Identifier"), this.parseImportMeta(d);
        } else
          this.unexpected();
      }, Ie.parseDynamicImport = function(s) {
        if (this.next(), s.source = this.parseMaybeAssign(), this.options.ecmaVersion >= 16)
          this.eat(f.parenR) ? s.options = null : (this.expect(f.comma), this.afterTrailingComma(f.parenR) ? s.options = null : (s.options = this.parseMaybeAssign(), this.eat(f.parenR) || (this.expect(f.comma), this.afterTrailingComma(f.parenR) || this.unexpected())));
        else if (!this.eat(f.parenR)) {
          var d = this.start;
          this.eat(f.comma) && this.eat(f.parenR) ? this.raiseRecoverable(d, "Trailing comma is not allowed in import()") : this.unexpected(d);
        }
        return this.finishNode(s, "ImportExpression");
      }, Ie.parseImportMeta = function(s) {
        this.next();
        var d = this.containsEsc;
        return s.property = this.parseIdent(!0), s.property.name !== "meta" && this.raiseRecoverable(s.property.start, "The only valid meta property for import is 'import.meta'"), d && this.raiseRecoverable(s.start, "'import.meta' must not contain escaped characters"), this.options.sourceType !== "module" && !this.options.allowImportExportEverywhere && this.raiseRecoverable(s.start, "Cannot use 'import.meta' outside a module"), this.finishNode(s, "MetaProperty");
      }, Ie.parseLiteral = function(s) {
        var d = this.startNode();
        return d.value = s, d.raw = this.input.slice(this.start, this.end), d.raw.charCodeAt(d.raw.length - 1) === 110 && (d.bigint = d.value != null ? d.value.toString() : d.raw.slice(0, -1).replace(/_/g, "")), this.next(), this.finishNode(d, "Literal");
      }, Ie.parseParenExpression = function() {
        this.expect(f.parenL);
        var s = this.parseExpression();
        return this.expect(f.parenR), s;
      }, Ie.shouldParseArrow = function(s) {
        return !this.canInsertSemicolon();
      }, Ie.parseParenAndDistinguishExpression = function(s, d) {
        var x = this.start, k = this.startLoc, D, $ = this.options.ecmaVersion >= 8;
        if (this.options.ecmaVersion >= 6) {
          this.next();
          var U = this.start, ae = this.startLoc, ce = [], Ae = !0, Fe = !1, nt = new ut(), Et = this.yieldPos, Qi = this.awaitPos, xi;
          for (this.yieldPos = 0, this.awaitPos = 0; this.type !== f.parenR; )
            if (Ae ? Ae = !1 : this.expect(f.comma), $ && this.afterTrailingComma(f.parenR, !0)) {
              Fe = !0;
              break;
            } else if (this.type === f.ellipsis) {
              xi = this.start, ce.push(this.parseParenItem(this.parseRestBinding())), this.type === f.comma && this.raiseRecoverable(
                this.start,
                "Comma is not permitted after the rest element"
              );
              break;
            } else
              ce.push(this.parseMaybeAssign(!1, nt, this.parseParenItem));
          var Or = this.lastTokEnd, yi = this.lastTokEndLoc;
          if (this.expect(f.parenR), s && this.shouldParseArrow(ce) && this.eat(f.arrow))
            return this.checkPatternErrors(nt, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = Et, this.awaitPos = Qi, this.parseParenArrowList(x, k, ce, d);
          (!ce.length || Fe) && this.unexpected(this.lastTokStart), xi && this.unexpected(xi), this.checkExpressionErrors(nt, !0), this.yieldPos = Et || this.yieldPos, this.awaitPos = Qi || this.awaitPos, ce.length > 1 ? (D = this.startNodeAt(U, ae), D.expressions = ce, this.finishNodeAt(D, "SequenceExpression", Or, yi)) : D = ce[0];
        } else
          D = this.parseParenExpression();
        if (this.options.preserveParens) {
          var bi = this.startNodeAt(x, k);
          return bi.expression = D, this.finishNode(bi, "ParenthesizedExpression");
        } else
          return D;
      }, Ie.parseParenItem = function(s) {
        return s;
      }, Ie.parseParenArrowList = function(s, d, x, k) {
        return this.parseArrowExpression(this.startNodeAt(s, d), x, !1, k);
      };
      var Qp = [];
      Ie.parseNew = function() {
        this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword new");
        var s = this.startNode();
        if (this.next(), this.options.ecmaVersion >= 6 && this.type === f.dot) {
          var d = this.startNodeAt(s.start, s.loc && s.loc.start);
          d.name = "new", s.meta = this.finishNode(d, "Identifier"), this.next();
          var x = this.containsEsc;
          return s.property = this.parseIdent(!0), s.property.name !== "target" && this.raiseRecoverable(s.property.start, "The only valid meta property for new is 'new.target'"), x && this.raiseRecoverable(s.start, "'new.target' must not contain escaped characters"), this.allowNewDotTarget || this.raiseRecoverable(s.start, "'new.target' can only be used in functions and class static block"), this.finishNode(s, "MetaProperty");
        }
        var k = this.start, D = this.startLoc;
        return s.callee = this.parseSubscripts(this.parseExprAtom(null, !1, !0), k, D, !0, !1), this.eat(f.parenL) ? s.arguments = this.parseExprList(f.parenR, this.options.ecmaVersion >= 8, !1) : s.arguments = Qp, this.finishNode(s, "NewExpression");
      }, Ie.parseTemplateElement = function(s) {
        var d = s.isTagged, x = this.startNode();
        return this.type === f.invalidTemplate ? (d || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), x.value = {
          raw: this.value.replace(/\r\n?/g, `
`),
          cooked: null
        }) : x.value = {
          raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, `
`),
          cooked: this.value
        }, this.next(), x.tail = this.type === f.backQuote, this.finishNode(x, "TemplateElement");
      }, Ie.parseTemplate = function(s) {
        s === void 0 && (s = {});
        var d = s.isTagged;
        d === void 0 && (d = !1);
        var x = this.startNode();
        this.next(), x.expressions = [];
        var k = this.parseTemplateElement({ isTagged: d });
        for (x.quasis = [k]; !k.tail; )
          this.type === f.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(f.dollarBraceL), x.expressions.push(this.parseExpression()), this.expect(f.braceR), x.quasis.push(k = this.parseTemplateElement({ isTagged: d }));
        return this.next(), this.finishNode(x, "TemplateLiteral");
      }, Ie.isAsyncProp = function(s) {
        return !s.computed && s.key.type === "Identifier" && s.key.name === "async" && (this.type === f.name || this.type === f.num || this.type === f.string || this.type === f.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === f.star) && !C.test(this.input.slice(this.lastTokEnd, this.start));
      }, Ie.parseObj = function(s, d) {
        var x = this.startNode(), k = !0, D = {};
        for (x.properties = [], this.next(); !this.eat(f.braceR); ) {
          if (k)
            k = !1;
          else if (this.expect(f.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma(f.braceR))
            break;
          var $ = this.parseProperty(s, d);
          s || this.checkPropClash($, D, d), x.properties.push($);
        }
        return this.finishNode(x, s ? "ObjectPattern" : "ObjectExpression");
      }, Ie.parseProperty = function(s, d) {
        var x = this.startNode(), k, D, $, U;
        if (this.options.ecmaVersion >= 9 && this.eat(f.ellipsis))
          return s ? (x.argument = this.parseIdent(!1), this.type === f.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.finishNode(x, "RestElement")) : (x.argument = this.parseMaybeAssign(!1, d), this.type === f.comma && d && d.trailingComma < 0 && (d.trailingComma = this.start), this.finishNode(x, "SpreadElement"));
        this.options.ecmaVersion >= 6 && (x.method = !1, x.shorthand = !1, (s || d) && ($ = this.start, U = this.startLoc), s || (k = this.eat(f.star)));
        var ae = this.containsEsc;
        return this.parsePropertyName(x), !s && !ae && this.options.ecmaVersion >= 8 && !k && this.isAsyncProp(x) ? (D = !0, k = this.options.ecmaVersion >= 9 && this.eat(f.star), this.parsePropertyName(x)) : D = !1, this.parsePropertyValue(x, s, k, D, $, U, d, ae), this.finishNode(x, "Property");
      }, Ie.parseGetterSetter = function(s) {
        var d = s.key.name;
        this.parsePropertyName(s), s.value = this.parseMethod(!1), s.kind = d;
        var x = s.kind === "get" ? 0 : 1;
        if (s.value.params.length !== x) {
          var k = s.value.start;
          s.kind === "get" ? this.raiseRecoverable(k, "getter should have no params") : this.raiseRecoverable(k, "setter should have exactly one param");
        } else
          s.kind === "set" && s.value.params[0].type === "RestElement" && this.raiseRecoverable(s.value.params[0].start, "Setter cannot use rest params");
      }, Ie.parsePropertyValue = function(s, d, x, k, D, $, U, ae) {
        (x || k) && this.type === f.colon && this.unexpected(), this.eat(f.colon) ? (s.value = d ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, U), s.kind = "init") : this.options.ecmaVersion >= 6 && this.type === f.parenL ? (d && this.unexpected(), s.method = !0, s.value = this.parseMethod(x, k), s.kind = "init") : !d && !ae && this.options.ecmaVersion >= 5 && !s.computed && s.key.type === "Identifier" && (s.key.name === "get" || s.key.name === "set") && this.type !== f.comma && this.type !== f.braceR && this.type !== f.eq ? ((x || k) && this.unexpected(), this.parseGetterSetter(s)) : this.options.ecmaVersion >= 6 && !s.computed && s.key.type === "Identifier" ? ((x || k) && this.unexpected(), this.checkUnreserved(s.key), s.key.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = D), d ? s.value = this.parseMaybeDefault(D, $, this.copyNode(s.key)) : this.type === f.eq && U ? (U.shorthandAssign < 0 && (U.shorthandAssign = this.start), s.value = this.parseMaybeDefault(D, $, this.copyNode(s.key))) : s.value = this.copyNode(s.key), s.kind = "init", s.shorthand = !0) : this.unexpected();
      }, Ie.parsePropertyName = function(s) {
        if (this.options.ecmaVersion >= 6) {
          if (this.eat(f.bracketL))
            return s.computed = !0, s.key = this.parseMaybeAssign(), this.expect(f.bracketR), s.key;
          s.computed = !1;
        }
        return s.key = this.type === f.num || this.type === f.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
      }, Ie.initFunction = function(s) {
        s.id = null, this.options.ecmaVersion >= 6 && (s.generator = s.expression = !1), this.options.ecmaVersion >= 8 && (s.async = !1);
      }, Ie.parseMethod = function(s, d, x) {
        var k = this.startNode(), D = this.yieldPos, $ = this.awaitPos, U = this.awaitIdentPos;
        return this.initFunction(k), this.options.ecmaVersion >= 6 && (k.generator = s), this.options.ecmaVersion >= 8 && (k.async = !!d), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(Ct(d, k.generator) | ot | (x ? Ze : 0)), this.expect(f.parenL), k.params = this.parseBindingList(f.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(k, !1, !0, !1), this.yieldPos = D, this.awaitPos = $, this.awaitIdentPos = U, this.finishNode(k, "FunctionExpression");
      }, Ie.parseArrowExpression = function(s, d, x, k) {
        var D = this.yieldPos, $ = this.awaitPos, U = this.awaitIdentPos;
        return this.enterScope(Ct(x, !1) | Te), this.initFunction(s), this.options.ecmaVersion >= 8 && (s.async = !!x), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, s.params = this.toAssignableList(d, !0), this.parseFunctionBody(s, !0, !1, k), this.yieldPos = D, this.awaitPos = $, this.awaitIdentPos = U, this.finishNode(s, "ArrowFunctionExpression");
      }, Ie.parseFunctionBody = function(s, d, x, k) {
        var D = d && this.type !== f.braceL, $ = this.strict, U = !1;
        if (D)
          s.body = this.parseMaybeAssign(k), s.expression = !0, this.checkParams(s, !1);
        else {
          var ae = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(s.params);
          (!$ || ae) && (U = this.strictDirective(this.end), U && ae && this.raiseRecoverable(s.start, "Illegal 'use strict' directive in function with non-simple parameter list"));
          var ce = this.labels;
          this.labels = [], U && (this.strict = !0), this.checkParams(s, !$ && !U && !d && !x && this.isSimpleParamList(s.params)), this.strict && s.id && this.checkLValSimple(s.id, Z), s.body = this.parseBlock(!1, void 0, U && !$), s.expression = !1, this.adaptDirectivePrologue(s.body.body), this.labels = ce;
        }
        this.exitScope();
      }, Ie.isSimpleParamList = function(s) {
        for (var d = 0, x = s; d < x.length; d += 1) {
          var k = x[d];
          if (k.type !== "Identifier")
            return !1;
        }
        return !0;
      }, Ie.checkParams = function(s, d) {
        for (var x = /* @__PURE__ */ Object.create(null), k = 0, D = s.params; k < D.length; k += 1) {
          var $ = D[k];
          this.checkLValInnerPattern($, Ve, d ? null : x);
        }
      }, Ie.parseExprList = function(s, d, x, k) {
        for (var D = [], $ = !0; !this.eat(s); ) {
          if ($)
            $ = !1;
          else if (this.expect(f.comma), d && this.afterTrailingComma(s))
            break;
          var U = void 0;
          x && this.type === f.comma ? U = null : this.type === f.ellipsis ? (U = this.parseSpread(k), k && this.type === f.comma && k.trailingComma < 0 && (k.trailingComma = this.start)) : U = this.parseMaybeAssign(!1, k), D.push(U);
        }
        return D;
      }, Ie.checkUnreserved = function(s) {
        var d = s.start, x = s.end, k = s.name;
        if (this.inGenerator && k === "yield" && this.raiseRecoverable(d, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && k === "await" && this.raiseRecoverable(d, "Cannot use 'await' as identifier inside an async function"), !(this.currentThisScope().flags & ft) && k === "arguments" && this.raiseRecoverable(d, "Cannot use 'arguments' in class field initializer"), this.inClassStaticBlock && (k === "arguments" || k === "await") && this.raise(d, "Cannot use " + k + " in class static initialization block"), this.keywords.test(k) && this.raise(d, "Unexpected keyword '" + k + "'"), !(this.options.ecmaVersion < 6 && this.input.slice(d, x).indexOf("\\") !== -1)) {
          var D = this.strict ? this.reservedWordsStrict : this.reservedWords;
          D.test(k) && (!this.inAsync && k === "await" && this.raiseRecoverable(d, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(d, "The keyword '" + k + "' is reserved"));
        }
      }, Ie.parseIdent = function(s) {
        var d = this.parseIdentNode();
        return this.next(!!s), this.finishNode(d, "Identifier"), s || (this.checkUnreserved(d), d.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = d.start)), d;
      }, Ie.parseIdentNode = function() {
        var s = this.startNode();
        return this.type === f.name ? s.name = this.value : this.type.keyword ? (s.name = this.type.keyword, (s.name === "class" || s.name === "function") && (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46) && this.context.pop(), this.type = f.name) : this.unexpected(), s;
      }, Ie.parsePrivateIdent = function() {
        var s = this.startNode();
        return this.type === f.privateId ? s.name = this.value : this.unexpected(), this.next(), this.finishNode(s, "PrivateIdentifier"), this.options.checkPrivateFields && (this.privateNameStack.length === 0 ? this.raise(s.start, "Private field '#" + s.name + "' must be declared in an enclosing class") : this.privateNameStack[this.privateNameStack.length - 1].used.push(s)), s;
      }, Ie.parseYield = function(s) {
        this.yieldPos || (this.yieldPos = this.start);
        var d = this.startNode();
        return this.next(), this.type === f.semi || this.canInsertSemicolon() || this.type !== f.star && !this.type.startsExpr ? (d.delegate = !1, d.argument = null) : (d.delegate = this.eat(f.star), d.argument = this.parseMaybeAssign(s)), this.finishNode(d, "YieldExpression");
      }, Ie.parseAwait = function(s) {
        this.awaitPos || (this.awaitPos = this.start);
        var d = this.startNode();
        return this.next(), d.argument = this.parseMaybeUnary(null, !0, !1, s), this.finishNode(d, "AwaitExpression");
      };
      var Vr = G.prototype;
      Vr.raise = function(s, d) {
        var x = de(this.input, s);
        d += " (" + x.line + ":" + x.column + ")", this.sourceFile && (d += " in " + this.sourceFile);
        var k = new SyntaxError(d);
        throw k.pos = s, k.loc = x, k.raisedAt = this.pos, k;
      }, Vr.raiseRecoverable = Vr.raise, Vr.curPosition = function() {
        if (this.options.locations)
          return new ie(this.curLine, this.pos - this.lineStart);
      };
      var $n = G.prototype, ed = function(d) {
        this.flags = d, this.var = [], this.lexical = [], this.functions = [];
      };
      $n.enterScope = function(s) {
        this.scopeStack.push(new ed(s));
      }, $n.exitScope = function() {
        this.scopeStack.pop();
      }, $n.treatFunctionsAsVarInScope = function(s) {
        return s.flags & ge || !this.inModule && s.flags & ee;
      }, $n.declareName = function(s, d, x) {
        var k = !1;
        if (d === qe) {
          var D = this.currentScope();
          k = D.lexical.indexOf(s) > -1 || D.functions.indexOf(s) > -1 || D.var.indexOf(s) > -1, D.lexical.push(s), this.inModule && D.flags & ee && delete this.undefinedExports[s];
        } else if (d === An) {
          var $ = this.currentScope();
          $.lexical.push(s);
        } else if (d === De) {
          var U = this.currentScope();
          this.treatFunctionsAsVar ? k = U.lexical.indexOf(s) > -1 : k = U.lexical.indexOf(s) > -1 || U.var.indexOf(s) > -1, U.functions.push(s);
        } else
          for (var ae = this.scopeStack.length - 1; ae >= 0; --ae) {
            var ce = this.scopeStack[ae];
            if (ce.lexical.indexOf(s) > -1 && !(ce.flags & Ye && ce.lexical[0] === s) || !this.treatFunctionsAsVarInScope(ce) && ce.functions.indexOf(s) > -1) {
              k = !0;
              break;
            }
            if (ce.var.push(s), this.inModule && ce.flags & ee && delete this.undefinedExports[s], ce.flags & ft)
              break;
          }
        k && this.raiseRecoverable(x, "Identifier '" + s + "' has already been declared");
      }, $n.checkLocalExport = function(s) {
        this.scopeStack[0].lexical.indexOf(s.name) === -1 && this.scopeStack[0].var.indexOf(s.name) === -1 && (this.undefinedExports[s.name] = s);
      }, $n.currentScope = function() {
        return this.scopeStack[this.scopeStack.length - 1];
      }, $n.currentVarScope = function() {
        for (var s = this.scopeStack.length - 1; ; s--) {
          var d = this.scopeStack[s];
          if (d.flags & (ft | Oe | ht))
            return d;
        }
      }, $n.currentThisScope = function() {
        for (var s = this.scopeStack.length - 1; ; s--) {
          var d = this.scopeStack[s];
          if (d.flags & (ft | Oe | ht) && !(d.flags & Te))
            return d;
        }
      };
      var Ki = function(d, x, k) {
        this.type = "", this.start = x, this.end = 0, d.options.locations && (this.loc = new V(d, k)), d.options.directSourceFile && (this.sourceFile = d.options.directSourceFile), d.options.ranges && (this.range = [x, 0]);
      }, Yi = G.prototype;
      Yi.startNode = function() {
        return new Ki(this, this.start, this.startLoc);
      }, Yi.startNodeAt = function(s, d) {
        return new Ki(this, s, d);
      };
      function Jo(s, d, x, k) {
        return s.type = d, s.end = x, this.options.locations && (s.loc.end = k), this.options.ranges && (s.range[1] = x), s;
      }
      Yi.finishNode = function(s, d) {
        return Jo.call(this, s, d, this.lastTokEnd, this.lastTokEndLoc);
      }, Yi.finishNodeAt = function(s, d, x, k) {
        return Jo.call(this, s, d, x, k);
      }, Yi.copyNode = function(s) {
        var d = new Ki(this, s.start, this.startLoc);
        for (var x in s)
          d[x] = s[x];
        return d;
      };
      var td = "Gara Garay Gukh Gurung_Khema Hrkt Katakana_Or_Hiragana Kawi Kirat_Rai Krai Nag_Mundari Nagm Ol_Onal Onao Sunu Sunuwar Todhri Todr Tulu_Tigalari Tutg Unknown Zzzz", Wo = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", Xo = Wo + " Extended_Pictographic", Zo = Xo, Go = Zo + " EBase EComp EMod EPres ExtPict", Ko = Go, nd = Ko, id = {
        9: Wo,
        10: Xo,
        11: Zo,
        12: Go,
        13: Ko,
        14: nd
      }, rd = "Basic_Emoji Emoji_Keycap_Sequence RGI_Emoji_Modifier_Sequence RGI_Emoji_Flag_Sequence RGI_Emoji_Tag_Sequence RGI_Emoji_ZWJ_Sequence RGI_Emoji", sd = {
        9: "",
        10: "",
        11: "",
        12: "",
        13: "",
        14: rd
      }, Yo = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", Qo = "Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", el = Qo + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", tl = el + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho", nl = tl + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi", il = nl + " Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith", ad = il + " " + td, od = {
        9: Qo,
        10: el,
        11: tl,
        12: nl,
        13: il,
        14: ad
      }, rl = {};
      function ld(s) {
        var d = rl[s] = {
          binary: Y(id[s] + " " + Yo),
          binaryOfStrings: Y(sd[s]),
          nonBinary: {
            General_Category: Y(Yo),
            Script: Y(od[s])
          }
        };
        d.nonBinary.Script_Extensions = d.nonBinary.Script, d.nonBinary.gc = d.nonBinary.General_Category, d.nonBinary.sc = d.nonBinary.Script, d.nonBinary.scx = d.nonBinary.Script_Extensions;
      }
      for (var Ds = 0, sl = [9, 10, 11, 12, 13, 14]; Ds < sl.length; Ds += 1) {
        var ud = sl[Ds];
        ld(ud);
      }
      var xe = G.prototype, Mr = function(d, x) {
        this.parent = d, this.base = x || this;
      };
      Mr.prototype.separatedFrom = function(d) {
        for (var x = this; x; x = x.parent)
          for (var k = d; k; k = k.parent)
            if (x.base === k.base && x !== k)
              return !0;
        return !1;
      }, Mr.prototype.sibling = function() {
        return new Mr(this.parent, this.base);
      };
      var dn = function(d) {
        this.parser = d, this.validFlags = "gim" + (d.options.ecmaVersion >= 6 ? "uy" : "") + (d.options.ecmaVersion >= 9 ? "s" : "") + (d.options.ecmaVersion >= 13 ? "d" : "") + (d.options.ecmaVersion >= 15 ? "v" : ""), this.unicodeProperties = rl[d.options.ecmaVersion >= 14 ? 14 : d.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = !1, this.switchV = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = /* @__PURE__ */ Object.create(null), this.backReferenceNames = [], this.branchID = null;
      };
      dn.prototype.reset = function(d, x, k) {
        var D = k.indexOf("v") !== -1, $ = k.indexOf("u") !== -1;
        this.start = d | 0, this.source = x + "", this.flags = k, D && this.parser.options.ecmaVersion >= 15 ? (this.switchU = !0, this.switchV = !0, this.switchN = !0) : (this.switchU = $ && this.parser.options.ecmaVersion >= 6, this.switchV = !1, this.switchN = $ && this.parser.options.ecmaVersion >= 9);
      }, dn.prototype.raise = function(d) {
        this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + d);
      }, dn.prototype.at = function(d, x) {
        x === void 0 && (x = !1);
        var k = this.source, D = k.length;
        if (d >= D)
          return -1;
        var $ = k.charCodeAt(d);
        if (!(x || this.switchU) || $ <= 55295 || $ >= 57344 || d + 1 >= D)
          return $;
        var U = k.charCodeAt(d + 1);
        return U >= 56320 && U <= 57343 ? ($ << 10) + U - 56613888 : $;
      }, dn.prototype.nextIndex = function(d, x) {
        x === void 0 && (x = !1);
        var k = this.source, D = k.length;
        if (d >= D)
          return D;
        var $ = k.charCodeAt(d), U;
        return !(x || this.switchU) || $ <= 55295 || $ >= 57344 || d + 1 >= D || (U = k.charCodeAt(d + 1)) < 56320 || U > 57343 ? d + 1 : d + 2;
      }, dn.prototype.current = function(d) {
        return d === void 0 && (d = !1), this.at(this.pos, d);
      }, dn.prototype.lookahead = function(d) {
        return d === void 0 && (d = !1), this.at(this.nextIndex(this.pos, d), d);
      }, dn.prototype.advance = function(d) {
        d === void 0 && (d = !1), this.pos = this.nextIndex(this.pos, d);
      }, dn.prototype.eat = function(d, x) {
        return x === void 0 && (x = !1), this.current(x) === d ? (this.advance(x), !0) : !1;
      }, dn.prototype.eatChars = function(d, x) {
        x === void 0 && (x = !1);
        for (var k = this.pos, D = 0, $ = d; D < $.length; D += 1) {
          var U = $[D], ae = this.at(k, x);
          if (ae === -1 || ae !== U)
            return !1;
          k = this.nextIndex(k, x);
        }
        return this.pos = k, !0;
      }, xe.validateRegExpFlags = function(s) {
        for (var d = s.validFlags, x = s.flags, k = !1, D = !1, $ = 0; $ < x.length; $++) {
          var U = x.charAt($);
          d.indexOf(U) === -1 && this.raise(s.start, "Invalid regular expression flag"), x.indexOf(U, $ + 1) > -1 && this.raise(s.start, "Duplicate regular expression flag"), U === "u" && (k = !0), U === "v" && (D = !0);
        }
        this.options.ecmaVersion >= 15 && k && D && this.raise(s.start, "Invalid regular expression flag");
      };
      function cd(s) {
        for (var d in s)
          return !0;
        return !1;
      }
      xe.validateRegExpPattern = function(s) {
        this.regexp_pattern(s), !s.switchN && this.options.ecmaVersion >= 9 && cd(s.groupNames) && (s.switchN = !0, this.regexp_pattern(s));
      }, xe.regexp_pattern = function(s) {
        s.pos = 0, s.lastIntValue = 0, s.lastStringValue = "", s.lastAssertionIsQuantifiable = !1, s.numCapturingParens = 0, s.maxBackReference = 0, s.groupNames = /* @__PURE__ */ Object.create(null), s.backReferenceNames.length = 0, s.branchID = null, this.regexp_disjunction(s), s.pos !== s.source.length && (s.eat(
          41
          /* ) */
        ) && s.raise("Unmatched ')'"), (s.eat(
          93
          /* ] */
        ) || s.eat(
          125
          /* } */
        )) && s.raise("Lone quantifier brackets")), s.maxBackReference > s.numCapturingParens && s.raise("Invalid escape");
        for (var d = 0, x = s.backReferenceNames; d < x.length; d += 1) {
          var k = x[d];
          s.groupNames[k] || s.raise("Invalid named capture referenced");
        }
      }, xe.regexp_disjunction = function(s) {
        var d = this.options.ecmaVersion >= 16;
        for (d && (s.branchID = new Mr(s.branchID, null)), this.regexp_alternative(s); s.eat(
          124
          /* | */
        ); )
          d && (s.branchID = s.branchID.sibling()), this.regexp_alternative(s);
        d && (s.branchID = s.branchID.parent), this.regexp_eatQuantifier(s, !0) && s.raise("Nothing to repeat"), s.eat(
          123
          /* { */
        ) && s.raise("Lone quantifier brackets");
      }, xe.regexp_alternative = function(s) {
        for (; s.pos < s.source.length && this.regexp_eatTerm(s); )
          ;
      }, xe.regexp_eatTerm = function(s) {
        return this.regexp_eatAssertion(s) ? (s.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(s) && s.switchU && s.raise("Invalid quantifier"), !0) : (s.switchU ? this.regexp_eatAtom(s) : this.regexp_eatExtendedAtom(s)) ? (this.regexp_eatQuantifier(s), !0) : !1;
      }, xe.regexp_eatAssertion = function(s) {
        var d = s.pos;
        if (s.lastAssertionIsQuantifiable = !1, s.eat(
          94
          /* ^ */
        ) || s.eat(
          36
          /* $ */
        ))
          return !0;
        if (s.eat(
          92
          /* \ */
        )) {
          if (s.eat(
            66
            /* B */
          ) || s.eat(
            98
            /* b */
          ))
            return !0;
          s.pos = d;
        }
        if (s.eat(
          40
          /* ( */
        ) && s.eat(
          63
          /* ? */
        )) {
          var x = !1;
          if (this.options.ecmaVersion >= 9 && (x = s.eat(
            60
            /* < */
          )), s.eat(
            61
            /* = */
          ) || s.eat(
            33
            /* ! */
          ))
            return this.regexp_disjunction(s), s.eat(
              41
              /* ) */
            ) || s.raise("Unterminated group"), s.lastAssertionIsQuantifiable = !x, !0;
        }
        return s.pos = d, !1;
      }, xe.regexp_eatQuantifier = function(s, d) {
        return d === void 0 && (d = !1), this.regexp_eatQuantifierPrefix(s, d) ? (s.eat(
          63
          /* ? */
        ), !0) : !1;
      }, xe.regexp_eatQuantifierPrefix = function(s, d) {
        return s.eat(
          42
          /* * */
        ) || s.eat(
          43
          /* + */
        ) || s.eat(
          63
          /* ? */
        ) || this.regexp_eatBracedQuantifier(s, d);
      }, xe.regexp_eatBracedQuantifier = function(s, d) {
        var x = s.pos;
        if (s.eat(
          123
          /* { */
        )) {
          var k = 0, D = -1;
          if (this.regexp_eatDecimalDigits(s) && (k = s.lastIntValue, s.eat(
            44
            /* , */
          ) && this.regexp_eatDecimalDigits(s) && (D = s.lastIntValue), s.eat(
            125
            /* } */
          )))
            return D !== -1 && D < k && !d && s.raise("numbers out of order in {} quantifier"), !0;
          s.switchU && !d && s.raise("Incomplete quantifier"), s.pos = x;
        }
        return !1;
      }, xe.regexp_eatAtom = function(s) {
        return this.regexp_eatPatternCharacters(s) || s.eat(
          46
          /* . */
        ) || this.regexp_eatReverseSolidusAtomEscape(s) || this.regexp_eatCharacterClass(s) || this.regexp_eatUncapturingGroup(s) || this.regexp_eatCapturingGroup(s);
      }, xe.regexp_eatReverseSolidusAtomEscape = function(s) {
        var d = s.pos;
        if (s.eat(
          92
          /* \ */
        )) {
          if (this.regexp_eatAtomEscape(s))
            return !0;
          s.pos = d;
        }
        return !1;
      }, xe.regexp_eatUncapturingGroup = function(s) {
        var d = s.pos;
        if (s.eat(
          40
          /* ( */
        )) {
          if (s.eat(
            63
            /* ? */
          )) {
            if (this.options.ecmaVersion >= 16) {
              var x = this.regexp_eatModifiers(s), k = s.eat(
                45
                /* - */
              );
              if (x || k) {
                for (var D = 0; D < x.length; D++) {
                  var $ = x.charAt(D);
                  x.indexOf($, D + 1) > -1 && s.raise("Duplicate regular expression modifiers");
                }
                if (k) {
                  var U = this.regexp_eatModifiers(s);
                  !x && !U && s.current() === 58 && s.raise("Invalid regular expression modifiers");
                  for (var ae = 0; ae < U.length; ae++) {
                    var ce = U.charAt(ae);
                    (U.indexOf(ce, ae + 1) > -1 || x.indexOf(ce) > -1) && s.raise("Duplicate regular expression modifiers");
                  }
                }
              }
            }
            if (s.eat(
              58
              /* : */
            )) {
              if (this.regexp_disjunction(s), s.eat(
                41
                /* ) */
              ))
                return !0;
              s.raise("Unterminated group");
            }
          }
          s.pos = d;
        }
        return !1;
      }, xe.regexp_eatCapturingGroup = function(s) {
        if (s.eat(
          40
          /* ( */
        )) {
          if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(s) : s.current() === 63 && s.raise("Invalid group"), this.regexp_disjunction(s), s.eat(
            41
            /* ) */
          ))
            return s.numCapturingParens += 1, !0;
          s.raise("Unterminated group");
        }
        return !1;
      }, xe.regexp_eatModifiers = function(s) {
        for (var d = "", x = 0; (x = s.current()) !== -1 && hd(x); )
          d += N(x), s.advance();
        return d;
      };
      function hd(s) {
        return s === 105 || s === 109 || s === 115;
      }
      xe.regexp_eatExtendedAtom = function(s) {
        return s.eat(
          46
          /* . */
        ) || this.regexp_eatReverseSolidusAtomEscape(s) || this.regexp_eatCharacterClass(s) || this.regexp_eatUncapturingGroup(s) || this.regexp_eatCapturingGroup(s) || this.regexp_eatInvalidBracedQuantifier(s) || this.regexp_eatExtendedPatternCharacter(s);
      }, xe.regexp_eatInvalidBracedQuantifier = function(s) {
        return this.regexp_eatBracedQuantifier(s, !0) && s.raise("Nothing to repeat"), !1;
      }, xe.regexp_eatSyntaxCharacter = function(s) {
        var d = s.current();
        return al(d) ? (s.lastIntValue = d, s.advance(), !0) : !1;
      };
      function al(s) {
        return s === 36 || s >= 40 && s <= 43 || s === 46 || s === 63 || s >= 91 && s <= 94 || s >= 123 && s <= 125;
      }
      xe.regexp_eatPatternCharacters = function(s) {
        for (var d = s.pos, x = 0; (x = s.current()) !== -1 && !al(x); )
          s.advance();
        return s.pos !== d;
      }, xe.regexp_eatExtendedPatternCharacter = function(s) {
        var d = s.current();
        return d !== -1 && d !== 36 && !(d >= 40 && d <= 43) && d !== 46 && d !== 63 && d !== 91 && d !== 94 && d !== 124 ? (s.advance(), !0) : !1;
      }, xe.regexp_groupSpecifier = function(s) {
        if (s.eat(
          63
          /* ? */
        )) {
          this.regexp_eatGroupName(s) || s.raise("Invalid group");
          var d = this.options.ecmaVersion >= 16, x = s.groupNames[s.lastStringValue];
          if (x)
            if (d)
              for (var k = 0, D = x; k < D.length; k += 1) {
                var $ = D[k];
                $.separatedFrom(s.branchID) || s.raise("Duplicate capture group name");
              }
            else
              s.raise("Duplicate capture group name");
          d ? (x || (s.groupNames[s.lastStringValue] = [])).push(s.branchID) : s.groupNames[s.lastStringValue] = !0;
        }
      }, xe.regexp_eatGroupName = function(s) {
        if (s.lastStringValue = "", s.eat(
          60
          /* < */
        )) {
          if (this.regexp_eatRegExpIdentifierName(s) && s.eat(
            62
            /* > */
          ))
            return !0;
          s.raise("Invalid capture group name");
        }
        return !1;
      }, xe.regexp_eatRegExpIdentifierName = function(s) {
        if (s.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(s)) {
          for (s.lastStringValue += N(s.lastIntValue); this.regexp_eatRegExpIdentifierPart(s); )
            s.lastStringValue += N(s.lastIntValue);
          return !0;
        }
        return !1;
      }, xe.regexp_eatRegExpIdentifierStart = function(s) {
        var d = s.pos, x = this.options.ecmaVersion >= 11, k = s.current(x);
        return s.advance(x), k === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(s, x) && (k = s.lastIntValue), pd(k) ? (s.lastIntValue = k, !0) : (s.pos = d, !1);
      };
      function pd(s) {
        return b(s, !0) || s === 36 || s === 95;
      }
      xe.regexp_eatRegExpIdentifierPart = function(s) {
        var d = s.pos, x = this.options.ecmaVersion >= 11, k = s.current(x);
        return s.advance(x), k === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(s, x) && (k = s.lastIntValue), dd(k) ? (s.lastIntValue = k, !0) : (s.pos = d, !1);
      };
      function dd(s) {
        return v(s, !0) || s === 36 || s === 95 || s === 8204 || s === 8205;
      }
      xe.regexp_eatAtomEscape = function(s) {
        return this.regexp_eatBackReference(s) || this.regexp_eatCharacterClassEscape(s) || this.regexp_eatCharacterEscape(s) || s.switchN && this.regexp_eatKGroupName(s) ? !0 : (s.switchU && (s.current() === 99 && s.raise("Invalid unicode escape"), s.raise("Invalid escape")), !1);
      }, xe.regexp_eatBackReference = function(s) {
        var d = s.pos;
        if (this.regexp_eatDecimalEscape(s)) {
          var x = s.lastIntValue;
          if (s.switchU)
            return x > s.maxBackReference && (s.maxBackReference = x), !0;
          if (x <= s.numCapturingParens)
            return !0;
          s.pos = d;
        }
        return !1;
      }, xe.regexp_eatKGroupName = function(s) {
        if (s.eat(
          107
          /* k */
        )) {
          if (this.regexp_eatGroupName(s))
            return s.backReferenceNames.push(s.lastStringValue), !0;
          s.raise("Invalid named reference");
        }
        return !1;
      }, xe.regexp_eatCharacterEscape = function(s) {
        return this.regexp_eatControlEscape(s) || this.regexp_eatCControlLetter(s) || this.regexp_eatZero(s) || this.regexp_eatHexEscapeSequence(s) || this.regexp_eatRegExpUnicodeEscapeSequence(s, !1) || !s.switchU && this.regexp_eatLegacyOctalEscapeSequence(s) || this.regexp_eatIdentityEscape(s);
      }, xe.regexp_eatCControlLetter = function(s) {
        var d = s.pos;
        if (s.eat(
          99
          /* c */
        )) {
          if (this.regexp_eatControlLetter(s))
            return !0;
          s.pos = d;
        }
        return !1;
      }, xe.regexp_eatZero = function(s) {
        return s.current() === 48 && !Fr(s.lookahead()) ? (s.lastIntValue = 0, s.advance(), !0) : !1;
      }, xe.regexp_eatControlEscape = function(s) {
        var d = s.current();
        return d === 116 ? (s.lastIntValue = 9, s.advance(), !0) : d === 110 ? (s.lastIntValue = 10, s.advance(), !0) : d === 118 ? (s.lastIntValue = 11, s.advance(), !0) : d === 102 ? (s.lastIntValue = 12, s.advance(), !0) : d === 114 ? (s.lastIntValue = 13, s.advance(), !0) : !1;
      }, xe.regexp_eatControlLetter = function(s) {
        var d = s.current();
        return ol(d) ? (s.lastIntValue = d % 32, s.advance(), !0) : !1;
      };
      function ol(s) {
        return s >= 65 && s <= 90 || s >= 97 && s <= 122;
      }
      xe.regexp_eatRegExpUnicodeEscapeSequence = function(s, d) {
        d === void 0 && (d = !1);
        var x = s.pos, k = d || s.switchU;
        if (s.eat(
          117
          /* u */
        )) {
          if (this.regexp_eatFixedHexDigits(s, 4)) {
            var D = s.lastIntValue;
            if (k && D >= 55296 && D <= 56319) {
              var $ = s.pos;
              if (s.eat(
                92
                /* \ */
              ) && s.eat(
                117
                /* u */
              ) && this.regexp_eatFixedHexDigits(s, 4)) {
                var U = s.lastIntValue;
                if (U >= 56320 && U <= 57343)
                  return s.lastIntValue = (D - 55296) * 1024 + (U - 56320) + 65536, !0;
              }
              s.pos = $, s.lastIntValue = D;
            }
            return !0;
          }
          if (k && s.eat(
            123
            /* { */
          ) && this.regexp_eatHexDigits(s) && s.eat(
            125
            /* } */
          ) && fd(s.lastIntValue))
            return !0;
          k && s.raise("Invalid unicode escape"), s.pos = x;
        }
        return !1;
      };
      function fd(s) {
        return s >= 0 && s <= 1114111;
      }
      xe.regexp_eatIdentityEscape = function(s) {
        if (s.switchU)
          return this.regexp_eatSyntaxCharacter(s) ? !0 : s.eat(
            47
            /* / */
          ) ? (s.lastIntValue = 47, !0) : !1;
        var d = s.current();
        return d !== 99 && (!s.switchN || d !== 107) ? (s.lastIntValue = d, s.advance(), !0) : !1;
      }, xe.regexp_eatDecimalEscape = function(s) {
        s.lastIntValue = 0;
        var d = s.current();
        if (d >= 49 && d <= 57) {
          do
            s.lastIntValue = 10 * s.lastIntValue + (d - 48), s.advance();
          while ((d = s.current()) >= 48 && d <= 57);
          return !0;
        }
        return !1;
      };
      var ll = 0, Ln = 1, Kt = 2;
      xe.regexp_eatCharacterClassEscape = function(s) {
        var d = s.current();
        if (md(d))
          return s.lastIntValue = -1, s.advance(), Ln;
        var x = !1;
        if (s.switchU && this.options.ecmaVersion >= 9 && ((x = d === 80) || d === 112)) {
          s.lastIntValue = -1, s.advance();
          var k;
          if (s.eat(
            123
            /* { */
          ) && (k = this.regexp_eatUnicodePropertyValueExpression(s)) && s.eat(
            125
            /* } */
          ))
            return x && k === Kt && s.raise("Invalid property name"), k;
          s.raise("Invalid property name");
        }
        return ll;
      };
      function md(s) {
        return s === 100 || s === 68 || s === 115 || s === 83 || s === 119 || s === 87;
      }
      xe.regexp_eatUnicodePropertyValueExpression = function(s) {
        var d = s.pos;
        if (this.regexp_eatUnicodePropertyName(s) && s.eat(
          61
          /* = */
        )) {
          var x = s.lastStringValue;
          if (this.regexp_eatUnicodePropertyValue(s)) {
            var k = s.lastStringValue;
            return this.regexp_validateUnicodePropertyNameAndValue(s, x, k), Ln;
          }
        }
        if (s.pos = d, this.regexp_eatLoneUnicodePropertyNameOrValue(s)) {
          var D = s.lastStringValue;
          return this.regexp_validateUnicodePropertyNameOrValue(s, D);
        }
        return ll;
      }, xe.regexp_validateUnicodePropertyNameAndValue = function(s, d, x) {
        X(s.unicodeProperties.nonBinary, d) || s.raise("Invalid property name"), s.unicodeProperties.nonBinary[d].test(x) || s.raise("Invalid property value");
      }, xe.regexp_validateUnicodePropertyNameOrValue = function(s, d) {
        if (s.unicodeProperties.binary.test(d))
          return Ln;
        if (s.switchV && s.unicodeProperties.binaryOfStrings.test(d))
          return Kt;
        s.raise("Invalid property name");
      }, xe.regexp_eatUnicodePropertyName = function(s) {
        var d = 0;
        for (s.lastStringValue = ""; ul(d = s.current()); )
          s.lastStringValue += N(d), s.advance();
        return s.lastStringValue !== "";
      };
      function ul(s) {
        return ol(s) || s === 95;
      }
      xe.regexp_eatUnicodePropertyValue = function(s) {
        var d = 0;
        for (s.lastStringValue = ""; gd(d = s.current()); )
          s.lastStringValue += N(d), s.advance();
        return s.lastStringValue !== "";
      };
      function gd(s) {
        return ul(s) || Fr(s);
      }
      xe.regexp_eatLoneUnicodePropertyNameOrValue = function(s) {
        return this.regexp_eatUnicodePropertyValue(s);
      }, xe.regexp_eatCharacterClass = function(s) {
        if (s.eat(
          91
          /* [ */
        )) {
          var d = s.eat(
            94
            /* ^ */
          ), x = this.regexp_classContents(s);
          return s.eat(
            93
            /* ] */
          ) || s.raise("Unterminated character class"), d && x === Kt && s.raise("Negated character class may contain strings"), !0;
        }
        return !1;
      }, xe.regexp_classContents = function(s) {
        return s.current() === 93 ? Ln : s.switchV ? this.regexp_classSetExpression(s) : (this.regexp_nonEmptyClassRanges(s), Ln);
      }, xe.regexp_nonEmptyClassRanges = function(s) {
        for (; this.regexp_eatClassAtom(s); ) {
          var d = s.lastIntValue;
          if (s.eat(
            45
            /* - */
          ) && this.regexp_eatClassAtom(s)) {
            var x = s.lastIntValue;
            s.switchU && (d === -1 || x === -1) && s.raise("Invalid character class"), d !== -1 && x !== -1 && d > x && s.raise("Range out of order in character class");
          }
        }
      }, xe.regexp_eatClassAtom = function(s) {
        var d = s.pos;
        if (s.eat(
          92
          /* \ */
        )) {
          if (this.regexp_eatClassEscape(s))
            return !0;
          if (s.switchU) {
            var x = s.current();
            (x === 99 || pl(x)) && s.raise("Invalid class escape"), s.raise("Invalid escape");
          }
          s.pos = d;
        }
        var k = s.current();
        return k !== 93 ? (s.lastIntValue = k, s.advance(), !0) : !1;
      }, xe.regexp_eatClassEscape = function(s) {
        var d = s.pos;
        if (s.eat(
          98
          /* b */
        ))
          return s.lastIntValue = 8, !0;
        if (s.switchU && s.eat(
          45
          /* - */
        ))
          return s.lastIntValue = 45, !0;
        if (!s.switchU && s.eat(
          99
          /* c */
        )) {
          if (this.regexp_eatClassControlLetter(s))
            return !0;
          s.pos = d;
        }
        return this.regexp_eatCharacterClassEscape(s) || this.regexp_eatCharacterEscape(s);
      }, xe.regexp_classSetExpression = function(s) {
        var d = Ln, x;
        if (!this.regexp_eatClassSetRange(s)) if (x = this.regexp_eatClassSetOperand(s)) {
          x === Kt && (d = Kt);
          for (var k = s.pos; s.eatChars(
            [38, 38]
            /* && */
          ); ) {
            if (s.current() !== 38 && (x = this.regexp_eatClassSetOperand(s))) {
              x !== Kt && (d = Ln);
              continue;
            }
            s.raise("Invalid character in character class");
          }
          if (k !== s.pos)
            return d;
          for (; s.eatChars(
            [45, 45]
            /* -- */
          ); )
            this.regexp_eatClassSetOperand(s) || s.raise("Invalid character in character class");
          if (k !== s.pos)
            return d;
        } else
          s.raise("Invalid character in character class");
        for (; ; )
          if (!this.regexp_eatClassSetRange(s)) {
            if (x = this.regexp_eatClassSetOperand(s), !x)
              return d;
            x === Kt && (d = Kt);
          }
      }, xe.regexp_eatClassSetRange = function(s) {
        var d = s.pos;
        if (this.regexp_eatClassSetCharacter(s)) {
          var x = s.lastIntValue;
          if (s.eat(
            45
            /* - */
          ) && this.regexp_eatClassSetCharacter(s)) {
            var k = s.lastIntValue;
            return x !== -1 && k !== -1 && x > k && s.raise("Range out of order in character class"), !0;
          }
          s.pos = d;
        }
        return !1;
      }, xe.regexp_eatClassSetOperand = function(s) {
        return this.regexp_eatClassSetCharacter(s) ? Ln : this.regexp_eatClassStringDisjunction(s) || this.regexp_eatNestedClass(s);
      }, xe.regexp_eatNestedClass = function(s) {
        var d = s.pos;
        if (s.eat(
          91
          /* [ */
        )) {
          var x = s.eat(
            94
            /* ^ */
          ), k = this.regexp_classContents(s);
          if (s.eat(
            93
            /* ] */
          ))
            return x && k === Kt && s.raise("Negated character class may contain strings"), k;
          s.pos = d;
        }
        if (s.eat(
          92
          /* \ */
        )) {
          var D = this.regexp_eatCharacterClassEscape(s);
          if (D)
            return D;
          s.pos = d;
        }
        return null;
      }, xe.regexp_eatClassStringDisjunction = function(s) {
        var d = s.pos;
        if (s.eatChars(
          [92, 113]
          /* \q */
        )) {
          if (s.eat(
            123
            /* { */
          )) {
            var x = this.regexp_classStringDisjunctionContents(s);
            if (s.eat(
              125
              /* } */
            ))
              return x;
          } else
            s.raise("Invalid escape");
          s.pos = d;
        }
        return null;
      }, xe.regexp_classStringDisjunctionContents = function(s) {
        for (var d = this.regexp_classString(s); s.eat(
          124
          /* | */
        ); )
          this.regexp_classString(s) === Kt && (d = Kt);
        return d;
      }, xe.regexp_classString = function(s) {
        for (var d = 0; this.regexp_eatClassSetCharacter(s); )
          d++;
        return d === 1 ? Ln : Kt;
      }, xe.regexp_eatClassSetCharacter = function(s) {
        var d = s.pos;
        if (s.eat(
          92
          /* \ */
        ))
          return this.regexp_eatCharacterEscape(s) || this.regexp_eatClassSetReservedPunctuator(s) ? !0 : s.eat(
            98
            /* b */
          ) ? (s.lastIntValue = 8, !0) : (s.pos = d, !1);
        var x = s.current();
        return x < 0 || x === s.lookahead() && _d(x) || xd(x) ? !1 : (s.advance(), s.lastIntValue = x, !0);
      };
      function _d(s) {
        return s === 33 || s >= 35 && s <= 38 || s >= 42 && s <= 44 || s === 46 || s >= 58 && s <= 64 || s === 94 || s === 96 || s === 126;
      }
      function xd(s) {
        return s === 40 || s === 41 || s === 45 || s === 47 || s >= 91 && s <= 93 || s >= 123 && s <= 125;
      }
      xe.regexp_eatClassSetReservedPunctuator = function(s) {
        var d = s.current();
        return yd(d) ? (s.lastIntValue = d, s.advance(), !0) : !1;
      };
      function yd(s) {
        return s === 33 || s === 35 || s === 37 || s === 38 || s === 44 || s === 45 || s >= 58 && s <= 62 || s === 64 || s === 96 || s === 126;
      }
      xe.regexp_eatClassControlLetter = function(s) {
        var d = s.current();
        return Fr(d) || d === 95 ? (s.lastIntValue = d % 32, s.advance(), !0) : !1;
      }, xe.regexp_eatHexEscapeSequence = function(s) {
        var d = s.pos;
        if (s.eat(
          120
          /* x */
        )) {
          if (this.regexp_eatFixedHexDigits(s, 2))
            return !0;
          s.switchU && s.raise("Invalid escape"), s.pos = d;
        }
        return !1;
      }, xe.regexp_eatDecimalDigits = function(s) {
        var d = s.pos, x = 0;
        for (s.lastIntValue = 0; Fr(x = s.current()); )
          s.lastIntValue = 10 * s.lastIntValue + (x - 48), s.advance();
        return s.pos !== d;
      };
      function Fr(s) {
        return s >= 48 && s <= 57;
      }
      xe.regexp_eatHexDigits = function(s) {
        var d = s.pos, x = 0;
        for (s.lastIntValue = 0; cl(x = s.current()); )
          s.lastIntValue = 16 * s.lastIntValue + hl(x), s.advance();
        return s.pos !== d;
      };
      function cl(s) {
        return s >= 48 && s <= 57 || s >= 65 && s <= 70 || s >= 97 && s <= 102;
      }
      function hl(s) {
        return s >= 65 && s <= 70 ? 10 + (s - 65) : s >= 97 && s <= 102 ? 10 + (s - 97) : s - 48;
      }
      xe.regexp_eatLegacyOctalEscapeSequence = function(s) {
        if (this.regexp_eatOctalDigit(s)) {
          var d = s.lastIntValue;
          if (this.regexp_eatOctalDigit(s)) {
            var x = s.lastIntValue;
            d <= 3 && this.regexp_eatOctalDigit(s) ? s.lastIntValue = d * 64 + x * 8 + s.lastIntValue : s.lastIntValue = d * 8 + x;
          } else
            s.lastIntValue = d;
          return !0;
        }
        return !1;
      }, xe.regexp_eatOctalDigit = function(s) {
        var d = s.current();
        return pl(d) ? (s.lastIntValue = d - 48, s.advance(), !0) : (s.lastIntValue = 0, !1);
      };
      function pl(s) {
        return s >= 48 && s <= 55;
      }
      xe.regexp_eatFixedHexDigits = function(s, d) {
        var x = s.pos;
        s.lastIntValue = 0;
        for (var k = 0; k < d; ++k) {
          var D = s.current();
          if (!cl(D))
            return s.pos = x, !1;
          s.lastIntValue = 16 * s.lastIntValue + hl(D), s.advance();
        }
        return !0;
      };
      var Rr = function(d) {
        this.type = d.type, this.value = d.value, this.start = d.start, this.end = d.end, d.options.locations && (this.loc = new V(d, d.startLoc, d.endLoc)), d.options.ranges && (this.range = [d.start, d.end]);
      }, ze = G.prototype;
      ze.next = function(s) {
        !s && this.type.keyword && this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword), this.options.onToken && this.options.onToken(new Rr(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
      }, ze.getToken = function() {
        return this.next(), new Rr(this);
      }, typeof Symbol < "u" && (ze[Symbol.iterator] = function() {
        var s = this;
        return {
          next: function() {
            var d = s.getToken();
            return {
              done: d.type === f.eof,
              value: d
            };
          }
        };
      }), ze.nextToken = function() {
        var s = this.curContext();
        if ((!s || !s.preserveSpace) && this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length)
          return this.finishToken(f.eof);
        if (s.override)
          return s.override(this);
        this.readToken(this.fullCharCodeAtPos());
      }, ze.readToken = function(s) {
        return b(s, this.options.ecmaVersion >= 6) || s === 92 ? this.readWord() : this.getTokenFromCode(s);
      }, ze.fullCharCodeAtPos = function() {
        var s = this.input.charCodeAt(this.pos);
        if (s <= 55295 || s >= 56320)
          return s;
        var d = this.input.charCodeAt(this.pos + 1);
        return d <= 56319 || d >= 57344 ? s : (s << 10) + d - 56613888;
      }, ze.skipBlockComment = function() {
        var s = this.options.onComment && this.curPosition(), d = this.pos, x = this.input.indexOf("*/", this.pos += 2);
        if (x === -1 && this.raise(this.pos - 2, "Unterminated comment"), this.pos = x + 2, this.options.locations)
          for (var k = void 0, D = d; (k = M(this.input, D, this.pos)) > -1; )
            ++this.curLine, D = this.lineStart = k;
        this.options.onComment && this.options.onComment(
          !0,
          this.input.slice(d + 2, x),
          d,
          this.pos,
          s,
          this.curPosition()
        );
      }, ze.skipLineComment = function(s) {
        for (var d = this.pos, x = this.options.onComment && this.curPosition(), k = this.input.charCodeAt(this.pos += s); this.pos < this.input.length && !F(k); )
          k = this.input.charCodeAt(++this.pos);
        this.options.onComment && this.options.onComment(
          !1,
          this.input.slice(d + s, this.pos),
          d,
          this.pos,
          x,
          this.curPosition()
        );
      }, ze.skipSpace = function() {
        e: for (; this.pos < this.input.length; ) {
          var s = this.input.charCodeAt(this.pos);
          switch (s) {
            case 32:
            case 160:
              ++this.pos;
              break;
            case 13:
              this.input.charCodeAt(this.pos + 1) === 10 && ++this.pos;
            case 10:
            case 8232:
            case 8233:
              ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
              break;
            case 47:
              switch (this.input.charCodeAt(this.pos + 1)) {
                case 42:
                  this.skipBlockComment();
                  break;
                case 47:
                  this.skipLineComment(2);
                  break;
                default:
                  break e;
              }
              break;
            default:
              if (s > 8 && s < 14 || s >= 5760 && z.test(String.fromCharCode(s)))
                ++this.pos;
              else
                break e;
          }
        }
      }, ze.finishToken = function(s, d) {
        this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
        var x = this.type;
        this.type = s, this.value = d, this.updateContext(x);
      }, ze.readToken_dot = function() {
        var s = this.input.charCodeAt(this.pos + 1);
        if (s >= 48 && s <= 57)
          return this.readNumber(!0);
        var d = this.input.charCodeAt(this.pos + 2);
        return this.options.ecmaVersion >= 6 && s === 46 && d === 46 ? (this.pos += 3, this.finishToken(f.ellipsis)) : (++this.pos, this.finishToken(f.dot));
      }, ze.readToken_slash = function() {
        var s = this.input.charCodeAt(this.pos + 1);
        return this.exprAllowed ? (++this.pos, this.readRegexp()) : s === 61 ? this.finishOp(f.assign, 2) : this.finishOp(f.slash, 1);
      }, ze.readToken_mult_modulo_exp = function(s) {
        var d = this.input.charCodeAt(this.pos + 1), x = 1, k = s === 42 ? f.star : f.modulo;
        return this.options.ecmaVersion >= 7 && s === 42 && d === 42 && (++x, k = f.starstar, d = this.input.charCodeAt(this.pos + 2)), d === 61 ? this.finishOp(f.assign, x + 1) : this.finishOp(k, x);
      }, ze.readToken_pipe_amp = function(s) {
        var d = this.input.charCodeAt(this.pos + 1);
        if (d === s) {
          if (this.options.ecmaVersion >= 12) {
            var x = this.input.charCodeAt(this.pos + 2);
            if (x === 61)
              return this.finishOp(f.assign, 3);
          }
          return this.finishOp(s === 124 ? f.logicalOR : f.logicalAND, 2);
        }
        return d === 61 ? this.finishOp(f.assign, 2) : this.finishOp(s === 124 ? f.bitwiseOR : f.bitwiseAND, 1);
      }, ze.readToken_caret = function() {
        var s = this.input.charCodeAt(this.pos + 1);
        return s === 61 ? this.finishOp(f.assign, 2) : this.finishOp(f.bitwiseXOR, 1);
      }, ze.readToken_plus_min = function(s) {
        var d = this.input.charCodeAt(this.pos + 1);
        return d === s ? d === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 && (this.lastTokEnd === 0 || C.test(this.input.slice(this.lastTokEnd, this.pos))) ? (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : this.finishOp(f.incDec, 2) : d === 61 ? this.finishOp(f.assign, 2) : this.finishOp(f.plusMin, 1);
      }, ze.readToken_lt_gt = function(s) {
        var d = this.input.charCodeAt(this.pos + 1), x = 1;
        return d === s ? (x = s === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2, this.input.charCodeAt(this.pos + x) === 61 ? this.finishOp(f.assign, x + 1) : this.finishOp(f.bitShift, x)) : d === 33 && s === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 && this.input.charCodeAt(this.pos + 3) === 45 ? (this.skipLineComment(4), this.skipSpace(), this.nextToken()) : (d === 61 && (x = 2), this.finishOp(f.relational, x));
      }, ze.readToken_eq_excl = function(s) {
        var d = this.input.charCodeAt(this.pos + 1);
        return d === 61 ? this.finishOp(f.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) : s === 61 && d === 62 && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(f.arrow)) : this.finishOp(s === 61 ? f.eq : f.prefix, 1);
      }, ze.readToken_question = function() {
        var s = this.options.ecmaVersion;
        if (s >= 11) {
          var d = this.input.charCodeAt(this.pos + 1);
          if (d === 46) {
            var x = this.input.charCodeAt(this.pos + 2);
            if (x < 48 || x > 57)
              return this.finishOp(f.questionDot, 2);
          }
          if (d === 63) {
            if (s >= 12) {
              var k = this.input.charCodeAt(this.pos + 2);
              if (k === 61)
                return this.finishOp(f.assign, 3);
            }
            return this.finishOp(f.coalesce, 2);
          }
        }
        return this.finishOp(f.question, 1);
      }, ze.readToken_numberSign = function() {
        var s = this.options.ecmaVersion, d = 35;
        if (s >= 13 && (++this.pos, d = this.fullCharCodeAtPos(), b(d, !0) || d === 92))
          return this.finishToken(f.privateId, this.readWord1());
        this.raise(this.pos, "Unexpected character '" + N(d) + "'");
      }, ze.getTokenFromCode = function(s) {
        switch (s) {
          // The interpretation of a dot depends on whether it is followed
          // by a digit or another two dots.
          case 46:
            return this.readToken_dot();
          // Punctuation tokens.
          case 40:
            return ++this.pos, this.finishToken(f.parenL);
          case 41:
            return ++this.pos, this.finishToken(f.parenR);
          case 59:
            return ++this.pos, this.finishToken(f.semi);
          case 44:
            return ++this.pos, this.finishToken(f.comma);
          case 91:
            return ++this.pos, this.finishToken(f.bracketL);
          case 93:
            return ++this.pos, this.finishToken(f.bracketR);
          case 123:
            return ++this.pos, this.finishToken(f.braceL);
          case 125:
            return ++this.pos, this.finishToken(f.braceR);
          case 58:
            return ++this.pos, this.finishToken(f.colon);
          case 96:
            if (this.options.ecmaVersion < 6)
              break;
            return ++this.pos, this.finishToken(f.backQuote);
          case 48:
            var d = this.input.charCodeAt(this.pos + 1);
            if (d === 120 || d === 88)
              return this.readRadixNumber(16);
            if (this.options.ecmaVersion >= 6) {
              if (d === 111 || d === 79)
                return this.readRadixNumber(8);
              if (d === 98 || d === 66)
                return this.readRadixNumber(2);
            }
          // Anything else beginning with a digit is an integer, octal
          // number, or float.
          case 49:
          case 50:
          case 51:
          case 52:
          case 53:
          case 54:
          case 55:
          case 56:
          case 57:
            return this.readNumber(!1);
          // Quotes produce strings.
          case 34:
          case 39:
            return this.readString(s);
          // Operators are parsed inline in tiny state machines. '=' (61) is
          // often referred to. `finishOp` simply skips the amount of
          // characters it is given as second argument, and returns a token
          // of the type given by its first argument.
          case 47:
            return this.readToken_slash();
          case 37:
          case 42:
            return this.readToken_mult_modulo_exp(s);
          case 124:
          case 38:
            return this.readToken_pipe_amp(s);
          case 94:
            return this.readToken_caret();
          case 43:
          case 45:
            return this.readToken_plus_min(s);
          case 60:
          case 62:
            return this.readToken_lt_gt(s);
          case 61:
          case 33:
            return this.readToken_eq_excl(s);
          case 63:
            return this.readToken_question();
          case 126:
            return this.finishOp(f.prefix, 1);
          case 35:
            return this.readToken_numberSign();
        }
        this.raise(this.pos, "Unexpected character '" + N(s) + "'");
      }, ze.finishOp = function(s, d) {
        var x = this.input.slice(this.pos, this.pos + d);
        return this.pos += d, this.finishToken(s, x);
      }, ze.readRegexp = function() {
        for (var s, d, x = this.pos; ; ) {
          this.pos >= this.input.length && this.raise(x, "Unterminated regular expression");
          var k = this.input.charAt(this.pos);
          if (C.test(k) && this.raise(x, "Unterminated regular expression"), s)
            s = !1;
          else {
            if (k === "[")
              d = !0;
            else if (k === "]" && d)
              d = !1;
            else if (k === "/" && !d)
              break;
            s = k === "\\";
          }
          ++this.pos;
        }
        var D = this.input.slice(x, this.pos);
        ++this.pos;
        var $ = this.pos, U = this.readWord1();
        this.containsEsc && this.unexpected($);
        var ae = this.regexpState || (this.regexpState = new dn(this));
        ae.reset(x, D, U), this.validateRegExpFlags(ae), this.validateRegExpPattern(ae);
        var ce = null;
        try {
          ce = new RegExp(D, U);
        } catch {
        }
        return this.finishToken(f.regexp, { pattern: D, flags: U, value: ce });
      }, ze.readInt = function(s, d, x) {
        for (var k = this.options.ecmaVersion >= 12 && d === void 0, D = x && this.input.charCodeAt(this.pos) === 48, $ = this.pos, U = 0, ae = 0, ce = 0, Ae = d ?? 1 / 0; ce < Ae; ++ce, ++this.pos) {
          var Fe = this.input.charCodeAt(this.pos), nt = void 0;
          if (k && Fe === 95) {
            D && this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals"), ae === 95 && this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore"), ce === 0 && this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits"), ae = Fe;
            continue;
          }
          if (Fe >= 97 ? nt = Fe - 97 + 10 : Fe >= 65 ? nt = Fe - 65 + 10 : Fe >= 48 && Fe <= 57 ? nt = Fe - 48 : nt = 1 / 0, nt >= s)
            break;
          ae = Fe, U = U * s + nt;
        }
        return k && ae === 95 && this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits"), this.pos === $ || d != null && this.pos - $ !== d ? null : U;
      };
      function bd(s, d) {
        return d ? parseInt(s, 8) : parseFloat(s.replace(/_/g, ""));
      }
      function dl(s) {
        return typeof BigInt != "function" ? null : BigInt(s.replace(/_/g, ""));
      }
      ze.readRadixNumber = function(s) {
        var d = this.pos;
        this.pos += 2;
        var x = this.readInt(s);
        return x == null && this.raise(this.start + 2, "Expected number in radix " + s), this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110 ? (x = dl(this.input.slice(d, this.pos)), ++this.pos) : b(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(f.num, x);
      }, ze.readNumber = function(s) {
        var d = this.pos;
        !s && this.readInt(10, void 0, !0) === null && this.raise(d, "Invalid number");
        var x = this.pos - d >= 2 && this.input.charCodeAt(d) === 48;
        x && this.strict && this.raise(d, "Invalid number");
        var k = this.input.charCodeAt(this.pos);
        if (!x && !s && this.options.ecmaVersion >= 11 && k === 110) {
          var D = dl(this.input.slice(d, this.pos));
          return ++this.pos, b(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(f.num, D);
        }
        x && /[89]/.test(this.input.slice(d, this.pos)) && (x = !1), k === 46 && !x && (++this.pos, this.readInt(10), k = this.input.charCodeAt(this.pos)), (k === 69 || k === 101) && !x && (k = this.input.charCodeAt(++this.pos), (k === 43 || k === 45) && ++this.pos, this.readInt(10) === null && this.raise(d, "Invalid number")), b(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
        var $ = bd(this.input.slice(d, this.pos), x);
        return this.finishToken(f.num, $);
      }, ze.readCodePoint = function() {
        var s = this.input.charCodeAt(this.pos), d;
        if (s === 123) {
          this.options.ecmaVersion < 6 && this.unexpected();
          var x = ++this.pos;
          d = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, d > 1114111 && this.invalidStringToken(x, "Code point out of bounds");
        } else
          d = this.readHexChar(4);
        return d;
      }, ze.readString = function(s) {
        for (var d = "", x = ++this.pos; ; ) {
          this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
          var k = this.input.charCodeAt(this.pos);
          if (k === s)
            break;
          k === 92 ? (d += this.input.slice(x, this.pos), d += this.readEscapedChar(!1), x = this.pos) : k === 8232 || k === 8233 ? (this.options.ecmaVersion < 10 && this.raise(this.start, "Unterminated string constant"), ++this.pos, this.options.locations && (this.curLine++, this.lineStart = this.pos)) : (F(k) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
        }
        return d += this.input.slice(x, this.pos++), this.finishToken(f.string, d);
      };
      var fl = {};
      ze.tryReadTemplateToken = function() {
        this.inTemplateElement = !0;
        try {
          this.readTmplToken();
        } catch (s) {
          if (s === fl)
            this.readInvalidTemplateToken();
          else
            throw s;
        }
        this.inTemplateElement = !1;
      }, ze.invalidStringToken = function(s, d) {
        if (this.inTemplateElement && this.options.ecmaVersion >= 9)
          throw fl;
        this.raise(s, d);
      }, ze.readTmplToken = function() {
        for (var s = "", d = this.pos; ; ) {
          this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
          var x = this.input.charCodeAt(this.pos);
          if (x === 96 || x === 36 && this.input.charCodeAt(this.pos + 1) === 123)
            return this.pos === this.start && (this.type === f.template || this.type === f.invalidTemplate) ? x === 36 ? (this.pos += 2, this.finishToken(f.dollarBraceL)) : (++this.pos, this.finishToken(f.backQuote)) : (s += this.input.slice(d, this.pos), this.finishToken(f.template, s));
          if (x === 92)
            s += this.input.slice(d, this.pos), s += this.readEscapedChar(!0), d = this.pos;
          else if (F(x)) {
            switch (s += this.input.slice(d, this.pos), ++this.pos, x) {
              case 13:
                this.input.charCodeAt(this.pos) === 10 && ++this.pos;
              case 10:
                s += `
`;
                break;
              default:
                s += String.fromCharCode(x);
                break;
            }
            this.options.locations && (++this.curLine, this.lineStart = this.pos), d = this.pos;
          } else
            ++this.pos;
        }
      }, ze.readInvalidTemplateToken = function() {
        for (; this.pos < this.input.length; this.pos++)
          switch (this.input[this.pos]) {
            case "\\":
              ++this.pos;
              break;
            case "$":
              if (this.input[this.pos + 1] !== "{")
                break;
            // fall through
            case "`":
              return this.finishToken(f.invalidTemplate, this.input.slice(this.start, this.pos));
            case "\r":
              this.input[this.pos + 1] === `
` && ++this.pos;
            // fall through
            case `
`:
            case "\u2028":
            case "\u2029":
              ++this.curLine, this.lineStart = this.pos + 1;
              break;
          }
        this.raise(this.start, "Unterminated template");
      }, ze.readEscapedChar = function(s) {
        var d = this.input.charCodeAt(++this.pos);
        switch (++this.pos, d) {
          case 110:
            return `
`;
          // 'n' -> '\n'
          case 114:
            return "\r";
          // 'r' -> '\r'
          case 120:
            return String.fromCharCode(this.readHexChar(2));
          // 'x'
          case 117:
            return N(this.readCodePoint());
          // 'u'
          case 116:
            return "	";
          // 't' -> '\t'
          case 98:
            return "\b";
          // 'b' -> '\b'
          case 118:
            return "\v";
          // 'v' -> '\u000b'
          case 102:
            return "\f";
          // 'f' -> '\f'
          case 13:
            this.input.charCodeAt(this.pos) === 10 && ++this.pos;
          // '\r\n'
          case 10:
            return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
          case 56:
          case 57:
            if (this.strict && this.invalidStringToken(
              this.pos - 1,
              "Invalid escape sequence"
            ), s) {
              var x = this.pos - 1;
              this.invalidStringToken(
                x,
                "Invalid escape sequence in template string"
              );
            }
          default:
            if (d >= 48 && d <= 55) {
              var k = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], D = parseInt(k, 8);
              return D > 255 && (k = k.slice(0, -1), D = parseInt(k, 8)), this.pos += k.length - 1, d = this.input.charCodeAt(this.pos), (k !== "0" || d === 56 || d === 57) && (this.strict || s) && this.invalidStringToken(
                this.pos - 1 - k.length,
                s ? "Octal literal in template string" : "Octal literal in strict mode"
              ), String.fromCharCode(D);
            }
            return F(d) ? (this.options.locations && (this.lineStart = this.pos, ++this.curLine), "") : String.fromCharCode(d);
        }
      }, ze.readHexChar = function(s) {
        var d = this.pos, x = this.readInt(16, s);
        return x === null && this.invalidStringToken(d, "Bad character escape sequence"), x;
      }, ze.readWord1 = function() {
        this.containsEsc = !1;
        for (var s = "", d = !0, x = this.pos, k = this.options.ecmaVersion >= 6; this.pos < this.input.length; ) {
          var D = this.fullCharCodeAtPos();
          if (v(D, k))
            this.pos += D <= 65535 ? 1 : 2;
          else if (D === 92) {
            this.containsEsc = !0, s += this.input.slice(x, this.pos);
            var $ = this.pos;
            this.input.charCodeAt(++this.pos) !== 117 && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
            var U = this.readCodePoint();
            (d ? b : v)(U, k) || this.invalidStringToken($, "Invalid Unicode escape"), s += N(U), x = this.pos;
          } else
            break;
          d = !1;
        }
        return s + this.input.slice(x, this.pos);
      }, ze.readWord = function() {
        var s = this.readWord1(), d = f.name;
        return this.keywords.test(s) && (d = P[s]), this.finishToken(d, s);
      };
      var ml = "8.15.0";
      G.acorn = {
        Parser: G,
        version: ml,
        defaultOptions: Se,
        Position: ie,
        SourceLocation: V,
        getLineInfo: de,
        Node: Ki,
        TokenType: w,
        tokTypes: f,
        keywordTypes: P,
        TokContext: Gt,
        tokContexts: tt,
        isIdentifierChar: v,
        isIdentifierStart: b,
        Token: Rr,
        isNewLine: F,
        lineBreak: C,
        lineBreakG: L,
        nonASCIIwhitespace: z
      };
      function vd(s, d) {
        return G.parse(s, d);
      }
      function wd(s, d, x) {
        return G.parseExpressionAt(s, d, x);
      }
      function kd(s, d) {
        return G.tokenizer(s, d);
      }
      n.Node = Ki, n.Parser = G, n.Position = ie, n.SourceLocation = V, n.TokContext = Gt, n.Token = Rr, n.TokenType = w, n.defaultOptions = Se, n.getLineInfo = de, n.isIdentifierChar = v, n.isIdentifierStart = b, n.isNewLine = F, n.keywordTypes = P, n.lineBreak = C, n.lineBreakG = L, n.nonASCIIwhitespace = z, n.parse = vd, n.parseExpressionAt = wd, n.tokContexts = tt, n.tokTypes = f, n.tokenizer = kd, n.version = ml;
    }));
  })(ur, ur.exports)), ur.exports;
}
var zl;
function T1() {
  return zl || (zl = 1, (function(e) {
    const t = L1(), n = /^[\da-fA-F]+$/, i = /^\d+$/, r = /* @__PURE__ */ new WeakMap();
    function a(u) {
      u = u.Parser.acorn || u;
      let c = r.get(u);
      if (!c) {
        const h = u.tokTypes, p = u.TokContext, m = u.TokenType, g = new p("<tag", !1), b = new p("</tag", !1), v = new p("<tag>...</tag>", !0, !0), w = {
          tc_oTag: g,
          tc_cTag: b,
          tc_expr: v
        }, y = {
          jsxName: new m("jsxName"),
          jsxText: new m("jsxText", { beforeExpr: !0 }),
          jsxTagStart: new m("jsxTagStart", { startsExpr: !0 }),
          jsxTagEnd: new m("jsxTagEnd")
        };
        y.jsxTagStart.updateContext = function() {
          this.context.push(v), this.context.push(g), this.exprAllowed = !1;
        }, y.jsxTagEnd.updateContext = function(I) {
          let E = this.context.pop();
          E === g && I === h.slash || E === b ? (this.context.pop(), this.exprAllowed = this.curContext() === v) : this.exprAllowed = !0;
        }, c = { tokContexts: w, tokTypes: y }, r.set(u, c);
      }
      return c;
    }
    function o(u) {
      if (!u)
        return u;
      if (u.type === "JSXIdentifier")
        return u.name;
      if (u.type === "JSXNamespacedName")
        return u.namespace.name + ":" + u.name.name;
      if (u.type === "JSXMemberExpression")
        return o(u.object) + "." + o(u.property);
    }
    e.exports = function(u) {
      return u = u || {}, function(c) {
        return l({
          allowNamespaces: u.allowNamespaces !== !1,
          allowNamespacedObjects: !!u.allowNamespacedObjects
        }, c);
      };
    }, Object.defineProperty(e.exports, "tokTypes", {
      get: function() {
        return a(Bl()).tokTypes;
      },
      configurable: !0,
      enumerable: !0
    });
    function l(u, c) {
      const h = c.acorn || Bl(), p = a(h), m = h.tokTypes, g = p.tokTypes, b = h.tokContexts, v = p.tokContexts.tc_oTag, w = p.tokContexts.tc_cTag, y = p.tokContexts.tc_expr, I = h.isNewLine, E = h.isIdentifierStart, P = h.isIdentifierChar;
      return class extends c {
        // Expose actual `tokTypes` and `tokContexts` to other plugins.
        static get acornJsx() {
          return p;
        }
        // Reads inline JSX contents token.
        jsx_readToken() {
          let S = "", f = this.pos;
          for (; ; ) {
            this.pos >= this.input.length && this.raise(this.start, "Unterminated JSX contents");
            let C = this.input.charCodeAt(this.pos);
            switch (C) {
              case 60:
              // '<'
              case 123:
                return this.pos === this.start ? C === 60 && this.exprAllowed ? (++this.pos, this.finishToken(g.jsxTagStart)) : this.getTokenFromCode(C) : (S += this.input.slice(f, this.pos), this.finishToken(g.jsxText, S));
              case 38:
                S += this.input.slice(f, this.pos), S += this.jsx_readEntity(), f = this.pos;
                break;
              case 62:
              // '>'
              case 125:
                this.raise(
                  this.pos,
                  "Unexpected token `" + this.input[this.pos] + "`. Did you mean `" + (C === 62 ? "&gt;" : "&rbrace;") + '` or `{"' + this.input[this.pos] + '"}`?'
                );
              default:
                I(C) ? (S += this.input.slice(f, this.pos), S += this.jsx_readNewLine(!0), f = this.pos) : ++this.pos;
            }
          }
        }
        jsx_readNewLine(S) {
          let f = this.input.charCodeAt(this.pos), C;
          return ++this.pos, f === 13 && this.input.charCodeAt(this.pos) === 10 ? (++this.pos, C = S ? `
` : `\r
`) : C = String.fromCharCode(f), this.options.locations && (++this.curLine, this.lineStart = this.pos), C;
        }
        jsx_readString(S) {
          let f = "", C = ++this.pos;
          for (; ; ) {
            this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
            let L = this.input.charCodeAt(this.pos);
            if (L === S) break;
            L === 38 ? (f += this.input.slice(C, this.pos), f += this.jsx_readEntity(), C = this.pos) : I(L) ? (f += this.input.slice(C, this.pos), f += this.jsx_readNewLine(!1), C = this.pos) : ++this.pos;
          }
          return f += this.input.slice(C, this.pos++), this.finishToken(m.string, f);
        }
        jsx_readEntity() {
          let S = "", f = 0, C, L = this.input[this.pos];
          L !== "&" && this.raise(this.pos, "Entity must start with an ampersand");
          let F = ++this.pos;
          for (; this.pos < this.input.length && f++ < 10; ) {
            if (L = this.input[this.pos++], L === ";") {
              S[0] === "#" ? S[1] === "x" ? (S = S.substr(2), n.test(S) && (C = String.fromCharCode(parseInt(S, 16)))) : (S = S.substr(1), i.test(S) && (C = String.fromCharCode(parseInt(S, 10)))) : C = t[S];
              break;
            }
            S += L;
          }
          return C || (this.pos = F, "&");
        }
        // Read a JSX identifier (valid tag or attribute name).
        //
        // Optimized version since JSX identifiers can't contain
        // escape characters and so can be read as single slice.
        // Also assumes that first character was already checked
        // by isIdentifierStart in readToken.
        jsx_readWord() {
          let S, f = this.pos;
          do
            S = this.input.charCodeAt(++this.pos);
          while (P(S) || S === 45);
          return this.finishToken(g.jsxName, this.input.slice(f, this.pos));
        }
        // Parse next token as JSX identifier
        jsx_parseIdentifier() {
          let S = this.startNode();
          return this.type === g.jsxName ? S.name = this.value : this.type.keyword ? S.name = this.type.keyword : this.unexpected(), this.next(), this.finishNode(S, "JSXIdentifier");
        }
        // Parse namespaced identifier.
        jsx_parseNamespacedName() {
          let S = this.start, f = this.startLoc, C = this.jsx_parseIdentifier();
          if (!u.allowNamespaces || !this.eat(m.colon)) return C;
          var L = this.startNodeAt(S, f);
          return L.namespace = C, L.name = this.jsx_parseIdentifier(), this.finishNode(L, "JSXNamespacedName");
        }
        // Parses element name in any form - namespaced, member
        // or single identifier.
        jsx_parseElementName() {
          if (this.type === g.jsxTagEnd) return "";
          let S = this.start, f = this.startLoc, C = this.jsx_parseNamespacedName();
          for (this.type === m.dot && C.type === "JSXNamespacedName" && !u.allowNamespacedObjects && this.unexpected(); this.eat(m.dot); ) {
            let L = this.startNodeAt(S, f);
            L.object = C, L.property = this.jsx_parseIdentifier(), C = this.finishNode(L, "JSXMemberExpression");
          }
          return C;
        }
        // Parses any type of JSX attribute value.
        jsx_parseAttributeValue() {
          switch (this.type) {
            case m.braceL:
              let S = this.jsx_parseExpressionContainer();
              return S.expression.type === "JSXEmptyExpression" && this.raise(S.start, "JSX attributes must only be assigned a non-empty expression"), S;
            case g.jsxTagStart:
            case m.string:
              return this.parseExprAtom();
            default:
              this.raise(this.start, "JSX value should be either an expression or a quoted JSX text");
          }
        }
        // JSXEmptyExpression is unique type since it doesn't actually parse anything,
        // and so it should start at the end of last read token (left brace) and finish
        // at the beginning of the next one (right brace).
        jsx_parseEmptyExpression() {
          let S = this.startNodeAt(this.lastTokEnd, this.lastTokEndLoc);
          return this.finishNodeAt(S, "JSXEmptyExpression", this.start, this.startLoc);
        }
        // Parses JSX expression enclosed into curly brackets.
        jsx_parseExpressionContainer() {
          let S = this.startNode();
          return this.next(), S.expression = this.type === m.braceR ? this.jsx_parseEmptyExpression() : this.parseExpression(), this.expect(m.braceR), this.finishNode(S, "JSXExpressionContainer");
        }
        // Parses following JSX attribute name-value pair.
        jsx_parseAttribute() {
          let S = this.startNode();
          return this.eat(m.braceL) ? (this.expect(m.ellipsis), S.argument = this.parseMaybeAssign(), this.expect(m.braceR), this.finishNode(S, "JSXSpreadAttribute")) : (S.name = this.jsx_parseNamespacedName(), S.value = this.eat(m.eq) ? this.jsx_parseAttributeValue() : null, this.finishNode(S, "JSXAttribute"));
        }
        // Parses JSX opening tag starting after '<'.
        jsx_parseOpeningElementAt(S, f) {
          let C = this.startNodeAt(S, f);
          C.attributes = [];
          let L = this.jsx_parseElementName();
          for (L && (C.name = L); this.type !== m.slash && this.type !== g.jsxTagEnd; )
            C.attributes.push(this.jsx_parseAttribute());
          return C.selfClosing = this.eat(m.slash), this.expect(g.jsxTagEnd), this.finishNode(C, L ? "JSXOpeningElement" : "JSXOpeningFragment");
        }
        // Parses JSX closing tag starting after '</'.
        jsx_parseClosingElementAt(S, f) {
          let C = this.startNodeAt(S, f), L = this.jsx_parseElementName();
          return L && (C.name = L), this.expect(g.jsxTagEnd), this.finishNode(C, L ? "JSXClosingElement" : "JSXClosingFragment");
        }
        // Parses entire JSX element, including it's opening tag
        // (starting after '<'), attributes, contents and closing tag.
        jsx_parseElementAt(S, f) {
          let C = this.startNodeAt(S, f), L = [], F = this.jsx_parseOpeningElementAt(S, f), M = null;
          if (!F.selfClosing) {
            e: for (; ; )
              switch (this.type) {
                case g.jsxTagStart:
                  if (S = this.start, f = this.startLoc, this.next(), this.eat(m.slash)) {
                    M = this.jsx_parseClosingElementAt(S, f);
                    break e;
                  }
                  L.push(this.jsx_parseElementAt(S, f));
                  break;
                case g.jsxText:
                  L.push(this.parseExprAtom());
                  break;
                case m.braceL:
                  L.push(this.jsx_parseExpressionContainer());
                  break;
                default:
                  this.unexpected();
              }
            o(M.name) !== o(F.name) && this.raise(
              M.start,
              "Expected corresponding JSX closing tag for <" + o(F.name) + ">"
            );
          }
          let z = F.name ? "Element" : "Fragment";
          return C["opening" + z] = F, C["closing" + z] = M, C.children = L, this.type === m.relational && this.value === "<" && this.raise(this.start, "Adjacent JSX elements must be wrapped in an enclosing tag"), this.finishNode(C, "JSX" + z);
        }
        // Parse JSX text
        jsx_parseText() {
          let S = this.parseLiteral(this.value);
          return S.type = "JSXText", S;
        }
        // Parses entire JSX element from current position.
        jsx_parseElement() {
          let S = this.start, f = this.startLoc;
          return this.next(), this.jsx_parseElementAt(S, f);
        }
        parseExprAtom(S) {
          return this.type === g.jsxText ? this.jsx_parseText() : this.type === g.jsxTagStart ? this.jsx_parseElement() : super.parseExprAtom(S);
        }
        readToken(S) {
          let f = this.curContext();
          if (f === y) return this.jsx_readToken();
          if (f === v || f === w) {
            if (E(S)) return this.jsx_readWord();
            if (S == 62)
              return ++this.pos, this.finishToken(g.jsxTagEnd);
            if ((S === 34 || S === 39) && f == v)
              return this.jsx_readString(S);
          }
          return S === 60 && this.exprAllowed && this.input.charCodeAt(this.pos + 1) !== 33 ? (++this.pos, this.finishToken(g.jsxTagStart)) : super.readToken(S);
        }
        updateContext(S) {
          if (this.type == m.braceL) {
            var f = this.curContext();
            f == v ? this.context.push(b.b_expr) : f == y ? this.context.push(b.b_tmpl) : super.updateContext(S), this.exprAllowed = !0;
          } else if (this.type === m.slash && S === g.jsxTagStart)
            this.context.length -= 2, this.context.push(w), this.exprAllowed = !1;
          else
            return super.updateContext(S);
        }
      };
    }
  })(Ws)), Ws.exports;
}
var N1 = T1();
const Oc = /* @__PURE__ */ Sr(N1), { stringify: D1 } = JSON;
if (!String.prototype.repeat)
  throw new Error(
    "String.prototype.repeat is undefined, see https://github.com/davidbonnet/astring#installation"
  );
if (!String.prototype.endsWith)
  throw new Error(
    "String.prototype.endsWith is undefined, see https://github.com/davidbonnet/astring#installation"
  );
const $r = {
  "||": 2,
  "??": 3,
  "&&": 4,
  "|": 5,
  "^": 6,
  "&": 7,
  "==": 8,
  "!=": 8,
  "===": 8,
  "!==": 8,
  "<": 9,
  ">": 9,
  "<=": 9,
  ">=": 9,
  in: 9,
  instanceof: 9,
  "<<": 10,
  ">>": 10,
  ">>>": 10,
  "+": 11,
  "-": 11,
  "*": 12,
  "%": 12,
  "/": 12,
  "**": 13
}, on = 17, V1 = {
  // Definitions
  ArrayExpression: 20,
  TaggedTemplateExpression: 20,
  ThisExpression: 20,
  Identifier: 20,
  PrivateIdentifier: 20,
  Literal: 18,
  TemplateLiteral: 20,
  Super: 20,
  SequenceExpression: 20,
  // Operations
  MemberExpression: 19,
  ChainExpression: 19,
  CallExpression: 19,
  NewExpression: 19,
  // Other definitions
  ArrowFunctionExpression: on,
  ClassExpression: on,
  FunctionExpression: on,
  ObjectExpression: on,
  // Other operations
  UpdateExpression: 16,
  UnaryExpression: 15,
  AwaitExpression: 15,
  BinaryExpression: 14,
  LogicalExpression: 13,
  ConditionalExpression: 4,
  AssignmentExpression: 3,
  YieldExpression: 2,
  RestElement: 1
};
function Ei(e, t) {
  const { generator: n } = e;
  if (e.write("("), t != null && t.length > 0) {
    n[t[0].type](t[0], e);
    const { length: i } = t;
    for (let r = 1; r < i; r++) {
      const a = t[r];
      e.write(", "), n[a.type](a, e);
    }
  }
  e.write(")");
}
function Bc(e, t, n, i) {
  const r = e.expressionsPrecedence[t.type];
  if (r === on)
    return !0;
  const a = e.expressionsPrecedence[n.type];
  return r !== a ? !i && r === 15 && a === 14 && n.operator === "**" || r < a : r !== 13 && r !== 14 ? !1 : t.operator === "**" && n.operator === "**" ? !i : r === 13 && a === 13 && (t.operator === "??" || n.operator === "??") ? !0 : i ? $r[t.operator] <= $r[n.operator] : $r[t.operator] < $r[n.operator];
}
function qr(e, t, n, i) {
  const { generator: r } = e;
  Bc(e, t, n, i) ? (e.write("("), r[t.type](t, e), e.write(")")) : r[t.type](t, e);
}
function M1(e, t, n, i) {
  const r = t.split(`
`), a = r.length - 1;
  if (e.write(r[0].trim()), a > 0) {
    e.write(i);
    for (let o = 1; o < a; o++)
      e.write(n + r[o].trim() + i);
    e.write(n + r[a].trim());
  }
}
function Nt(e, t, n, i) {
  const { length: r } = t;
  for (let a = 0; a < r; a++) {
    const o = t[a];
    e.write(n), o.type[0] === "L" ? e.write("// " + o.value.trim() + `
`, o) : (e.write("/*"), M1(e, o.value, n, i), e.write("*/" + i));
  }
}
function F1(e) {
  let t = e;
  for (; t != null; ) {
    const { type: n } = t;
    if (n[0] === "C" && n[1] === "a")
      return !0;
    if (n[0] === "M" && n[1] === "e" && n[2] === "m")
      t = t.object;
    else
      return !1;
  }
}
function Zs(e, t) {
  const { generator: n } = e, { declarations: i } = t;
  e.write(t.kind + " ");
  const { length: r } = i;
  if (r > 0) {
    n.VariableDeclarator(i[0], e);
    for (let a = 1; a < r; a++)
      e.write(", "), n.VariableDeclarator(i[a], e);
  }
}
let jl, Hl, $l, ql, Ul, Jl;
const zc = {
  /*
  Default generator.
  */
  Program(e, t) {
    const n = t.indent.repeat(t.indentLevel), { lineEnd: i, writeComments: r } = t;
    r && e.comments != null && Nt(t, e.comments, n, i);
    const a = e.body, { length: o } = a;
    for (let l = 0; l < o; l++) {
      const u = a[l];
      r && u.comments != null && Nt(t, u.comments, n, i), t.write(n), this[u.type](u, t), t.write(i);
    }
    r && e.trailingComments != null && Nt(t, e.trailingComments, n, i);
  },
  BlockStatement: Jl = function(e, t) {
    const n = t.indent.repeat(t.indentLevel++), { lineEnd: i, writeComments: r } = t, a = n + t.indent;
    t.write("{");
    const o = e.body;
    if (o != null && o.length > 0) {
      t.write(i), r && e.comments != null && Nt(t, e.comments, a, i);
      const { length: l } = o;
      for (let u = 0; u < l; u++) {
        const c = o[u];
        r && c.comments != null && Nt(t, c.comments, a, i), t.write(a), this[c.type](c, t), t.write(i);
      }
      t.write(n);
    } else
      r && e.comments != null && (t.write(i), Nt(t, e.comments, a, i), t.write(n));
    r && e.trailingComments != null && Nt(t, e.trailingComments, a, i), t.write("}"), t.indentLevel--;
  },
  ClassBody: Jl,
  StaticBlock(e, t) {
    t.write("static "), this.BlockStatement(e, t);
  },
  EmptyStatement(e, t) {
    t.write(";");
  },
  ExpressionStatement(e, t) {
    const n = t.expressionsPrecedence[e.expression.type];
    n === on || n === 3 && e.expression.left.type[0] === "O" ? (t.write("("), this[e.expression.type](e.expression, t), t.write(")")) : this[e.expression.type](e.expression, t), t.write(";");
  },
  IfStatement(e, t) {
    t.write("if ("), this[e.test.type](e.test, t), t.write(") "), this[e.consequent.type](e.consequent, t), e.alternate != null && (t.write(" else "), this[e.alternate.type](e.alternate, t));
  },
  LabeledStatement(e, t) {
    this[e.label.type](e.label, t), t.write(": "), this[e.body.type](e.body, t);
  },
  BreakStatement(e, t) {
    t.write("break"), e.label != null && (t.write(" "), this[e.label.type](e.label, t)), t.write(";");
  },
  ContinueStatement(e, t) {
    t.write("continue"), e.label != null && (t.write(" "), this[e.label.type](e.label, t)), t.write(";");
  },
  WithStatement(e, t) {
    t.write("with ("), this[e.object.type](e.object, t), t.write(") "), this[e.body.type](e.body, t);
  },
  SwitchStatement(e, t) {
    const n = t.indent.repeat(t.indentLevel++), { lineEnd: i, writeComments: r } = t;
    t.indentLevel++;
    const a = n + t.indent, o = a + t.indent;
    t.write("switch ("), this[e.discriminant.type](e.discriminant, t), t.write(") {" + i);
    const { cases: l } = e, { length: u } = l;
    for (let c = 0; c < u; c++) {
      const h = l[c];
      r && h.comments != null && Nt(t, h.comments, a, i), h.test ? (t.write(a + "case "), this[h.test.type](h.test, t), t.write(":" + i)) : t.write(a + "default:" + i);
      const { consequent: p } = h, { length: m } = p;
      for (let g = 0; g < m; g++) {
        const b = p[g];
        r && b.comments != null && Nt(t, b.comments, o, i), t.write(o), this[b.type](b, t), t.write(i);
      }
    }
    t.indentLevel -= 2, t.write(n + "}");
  },
  ReturnStatement(e, t) {
    t.write("return"), e.argument && (t.write(" "), this[e.argument.type](e.argument, t)), t.write(";");
  },
  ThrowStatement(e, t) {
    t.write("throw "), this[e.argument.type](e.argument, t), t.write(";");
  },
  TryStatement(e, t) {
    if (t.write("try "), this[e.block.type](e.block, t), e.handler) {
      const { handler: n } = e;
      n.param == null ? t.write(" catch ") : (t.write(" catch ("), this[n.param.type](n.param, t), t.write(") ")), this[n.body.type](n.body, t);
    }
    e.finalizer && (t.write(" finally "), this[e.finalizer.type](e.finalizer, t));
  },
  WhileStatement(e, t) {
    t.write("while ("), this[e.test.type](e.test, t), t.write(") "), this[e.body.type](e.body, t);
  },
  DoWhileStatement(e, t) {
    t.write("do "), this[e.body.type](e.body, t), t.write(" while ("), this[e.test.type](e.test, t), t.write(");");
  },
  ForStatement(e, t) {
    if (t.write("for ("), e.init != null) {
      const { init: n } = e;
      n.type[0] === "V" ? Zs(t, n) : this[n.type](n, t);
    }
    t.write("; "), e.test && this[e.test.type](e.test, t), t.write("; "), e.update && this[e.update.type](e.update, t), t.write(") "), this[e.body.type](e.body, t);
  },
  ForInStatement: jl = function(e, t) {
    t.write(`for ${e.await ? "await " : ""}(`);
    const { left: n } = e;
    n.type[0] === "V" ? Zs(t, n) : this[n.type](n, t), t.write(e.type[3] === "I" ? " in " : " of "), this[e.right.type](e.right, t), t.write(") "), this[e.body.type](e.body, t);
  },
  ForOfStatement: jl,
  DebuggerStatement(e, t) {
    t.write("debugger;", e);
  },
  FunctionDeclaration: Hl = function(e, t) {
    t.write(
      (e.async ? "async " : "") + (e.generator ? "function* " : "function ") + (e.id ? e.id.name : ""),
      e
    ), Ei(t, e.params), t.write(" "), this[e.body.type](e.body, t);
  },
  FunctionExpression: Hl,
  VariableDeclaration(e, t) {
    Zs(t, e), t.write(";");
  },
  VariableDeclarator(e, t) {
    this[e.id.type](e.id, t), e.init != null && (t.write(" = "), this[e.init.type](e.init, t));
  },
  ClassDeclaration(e, t) {
    if (t.write("class " + (e.id ? `${e.id.name} ` : ""), e), e.superClass) {
      t.write("extends ");
      const { superClass: n } = e, { type: i } = n, r = t.expressionsPrecedence[i];
      (i[0] !== "C" || i[1] !== "l" || i[5] !== "E") && (r === on || r < t.expressionsPrecedence.ClassExpression) ? (t.write("("), this[e.superClass.type](n, t), t.write(")")) : this[n.type](n, t), t.write(" ");
    }
    this.ClassBody(e.body, t);
  },
  ImportDeclaration(e, t) {
    t.write("import ");
    const { specifiers: n, attributes: i } = e, { length: r } = n;
    let a = 0;
    if (r > 0) {
      for (; a < r; ) {
        a > 0 && t.write(", ");
        const o = n[a], l = o.type[6];
        if (l === "D")
          t.write(o.local.name, o), a++;
        else if (l === "N")
          t.write("* as " + o.local.name, o), a++;
        else
          break;
      }
      if (a < r) {
        for (t.write("{"); ; ) {
          const o = n[a], { name: l } = o.imported;
          if (t.write(l, o), l !== o.local.name && t.write(" as " + o.local.name), ++a < r)
            t.write(", ");
          else
            break;
        }
        t.write("}");
      }
      t.write(" from ");
    }
    if (this.Literal(e.source, t), i && i.length > 0) {
      t.write(" with { ");
      for (let o = 0; o < i.length; o++)
        this.ImportAttribute(i[o], t), o < i.length - 1 && t.write(", ");
      t.write(" }");
    }
    t.write(";");
  },
  ImportAttribute(e, t) {
    this.Identifier(e.key, t), t.write(": "), this.Literal(e.value, t);
  },
  ImportExpression(e, t) {
    t.write("import("), this[e.source.type](e.source, t), t.write(")");
  },
  ExportDefaultDeclaration(e, t) {
    t.write("export default "), this[e.declaration.type](e.declaration, t), t.expressionsPrecedence[e.declaration.type] != null && e.declaration.type[0] !== "F" && t.write(";");
  },
  ExportNamedDeclaration(e, t) {
    if (t.write("export "), e.declaration)
      this[e.declaration.type](e.declaration, t);
    else {
      t.write("{");
      const { specifiers: n } = e, { length: i } = n;
      if (i > 0)
        for (let r = 0; ; ) {
          const a = n[r], { name: o } = a.local;
          if (t.write(o, a), o !== a.exported.name && t.write(" as " + a.exported.name), ++r < i)
            t.write(", ");
          else
            break;
        }
      if (t.write("}"), e.source && (t.write(" from "), this.Literal(e.source, t)), e.attributes && e.attributes.length > 0) {
        t.write(" with { ");
        for (let r = 0; r < e.attributes.length; r++)
          this.ImportAttribute(e.attributes[r], t), r < e.attributes.length - 1 && t.write(", ");
        t.write(" }");
      }
      t.write(";");
    }
  },
  ExportAllDeclaration(e, t) {
    if (e.exported != null ? t.write("export * as " + e.exported.name + " from ") : t.write("export * from "), this.Literal(e.source, t), e.attributes && e.attributes.length > 0) {
      t.write(" with { ");
      for (let n = 0; n < e.attributes.length; n++)
        this.ImportAttribute(e.attributes[n], t), n < e.attributes.length - 1 && t.write(", ");
      t.write(" }");
    }
    t.write(";");
  },
  MethodDefinition(e, t) {
    e.static && t.write("static ");
    const n = e.kind[0];
    (n === "g" || n === "s") && t.write(e.kind + " "), e.value.async && t.write("async "), e.value.generator && t.write("*"), e.computed ? (t.write("["), this[e.key.type](e.key, t), t.write("]")) : this[e.key.type](e.key, t), Ei(t, e.value.params), t.write(" "), this[e.value.body.type](e.value.body, t);
  },
  ClassExpression(e, t) {
    this.ClassDeclaration(e, t);
  },
  ArrowFunctionExpression(e, t) {
    t.write(e.async ? "async " : "", e);
    const { params: n } = e;
    n != null && (n.length === 1 && n[0].type[0] === "I" ? t.write(n[0].name, n[0]) : Ei(t, e.params)), t.write(" => "), e.body.type[0] === "O" ? (t.write("("), this.ObjectExpression(e.body, t), t.write(")")) : this[e.body.type](e.body, t);
  },
  ThisExpression(e, t) {
    t.write("this", e);
  },
  Super(e, t) {
    t.write("super", e);
  },
  RestElement: $l = function(e, t) {
    t.write("..."), this[e.argument.type](e.argument, t);
  },
  SpreadElement: $l,
  YieldExpression(e, t) {
    t.write(e.delegate ? "yield*" : "yield"), e.argument && (t.write(" "), this[e.argument.type](e.argument, t));
  },
  AwaitExpression(e, t) {
    t.write("await ", e), qr(t, e.argument, e);
  },
  TemplateLiteral(e, t) {
    const { quasis: n, expressions: i } = e;
    t.write("`");
    const { length: r } = i;
    for (let o = 0; o < r; o++) {
      const l = i[o], u = n[o];
      t.write(u.value.raw, u), t.write("${"), this[l.type](l, t), t.write("}");
    }
    const a = n[n.length - 1];
    t.write(a.value.raw, a), t.write("`");
  },
  TemplateElement(e, t) {
    t.write(e.value.raw, e);
  },
  TaggedTemplateExpression(e, t) {
    qr(t, e.tag, e), this[e.quasi.type](e.quasi, t);
  },
  ArrayExpression: Ul = function(e, t) {
    if (t.write("["), e.elements.length > 0) {
      const { elements: n } = e, { length: i } = n;
      for (let r = 0; ; ) {
        const a = n[r];
        if (a != null && this[a.type](a, t), ++r < i)
          t.write(", ");
        else {
          a == null && t.write(", ");
          break;
        }
      }
    }
    t.write("]");
  },
  ArrayPattern: Ul,
  ObjectExpression(e, t) {
    const n = t.indent.repeat(t.indentLevel++), { lineEnd: i, writeComments: r } = t, a = n + t.indent;
    if (t.write("{"), e.properties.length > 0) {
      t.write(i), r && e.comments != null && Nt(t, e.comments, a, i);
      const o = "," + i, { properties: l } = e, { length: u } = l;
      for (let c = 0; ; ) {
        const h = l[c];
        if (r && h.comments != null && Nt(t, h.comments, a, i), t.write(a), this[h.type](h, t), ++c < u)
          t.write(o);
        else
          break;
      }
      t.write(i), r && e.trailingComments != null && Nt(t, e.trailingComments, a, i), t.write(n + "}");
    } else r ? e.comments != null ? (t.write(i), Nt(t, e.comments, a, i), e.trailingComments != null && Nt(t, e.trailingComments, a, i), t.write(n + "}")) : e.trailingComments != null ? (t.write(i), Nt(t, e.trailingComments, a, i), t.write(n + "}")) : t.write("}") : t.write("}");
    t.indentLevel--;
  },
  Property(e, t) {
    e.method || e.kind[0] !== "i" ? this.MethodDefinition(e, t) : (e.shorthand || (e.computed ? (t.write("["), this[e.key.type](e.key, t), t.write("]")) : this[e.key.type](e.key, t), t.write(": ")), this[e.value.type](e.value, t));
  },
  PropertyDefinition(e, t) {
    if (e.static && t.write("static "), e.computed && t.write("["), this[e.key.type](e.key, t), e.computed && t.write("]"), e.value == null) {
      e.key.type[0] !== "F" && t.write(";");
      return;
    }
    t.write(" = "), this[e.value.type](e.value, t), t.write(";");
  },
  ObjectPattern(e, t) {
    if (t.write("{"), e.properties.length > 0) {
      const { properties: n } = e, { length: i } = n;
      for (let r = 0; this[n[r].type](n[r], t), ++r < i; )
        t.write(", ");
    }
    t.write("}");
  },
  SequenceExpression(e, t) {
    Ei(t, e.expressions);
  },
  UnaryExpression(e, t) {
    if (e.prefix) {
      const {
        operator: n,
        argument: i,
        argument: { type: r }
      } = e;
      t.write(n);
      const a = Bc(t, i, e);
      !a && (n.length > 1 || r[0] === "U" && (r[1] === "n" || r[1] === "p") && i.prefix && i.operator[0] === n && (n === "+" || n === "-")) && t.write(" "), a ? (t.write(n.length > 1 ? " (" : "("), this[r](i, t), t.write(")")) : this[r](i, t);
    } else
      this[e.argument.type](e.argument, t), t.write(e.operator);
  },
  UpdateExpression(e, t) {
    e.prefix ? (t.write(e.operator), this[e.argument.type](e.argument, t)) : (this[e.argument.type](e.argument, t), t.write(e.operator));
  },
  AssignmentExpression(e, t) {
    this[e.left.type](e.left, t), t.write(" " + e.operator + " "), this[e.right.type](e.right, t);
  },
  AssignmentPattern(e, t) {
    this[e.left.type](e.left, t), t.write(" = "), this[e.right.type](e.right, t);
  },
  BinaryExpression: ql = function(e, t) {
    const n = e.operator === "in";
    n && t.write("("), qr(t, e.left, e, !1), t.write(" " + e.operator + " "), qr(t, e.right, e, !0), n && t.write(")");
  },
  LogicalExpression: ql,
  ConditionalExpression(e, t) {
    const { test: n } = e, i = t.expressionsPrecedence[n.type];
    i === on || i <= t.expressionsPrecedence.ConditionalExpression ? (t.write("("), this[n.type](n, t), t.write(")")) : this[n.type](n, t), t.write(" ? "), this[e.consequent.type](e.consequent, t), t.write(" : "), this[e.alternate.type](e.alternate, t);
  },
  NewExpression(e, t) {
    t.write("new ");
    const n = t.expressionsPrecedence[e.callee.type];
    n === on || n < t.expressionsPrecedence.CallExpression || F1(e.callee) ? (t.write("("), this[e.callee.type](e.callee, t), t.write(")")) : this[e.callee.type](e.callee, t), Ei(t, e.arguments);
  },
  CallExpression(e, t) {
    const n = t.expressionsPrecedence[e.callee.type];
    n === on || n < t.expressionsPrecedence.CallExpression ? (t.write("("), this[e.callee.type](e.callee, t), t.write(")")) : this[e.callee.type](e.callee, t), e.optional && t.write("?."), Ei(t, e.arguments);
  },
  ChainExpression(e, t) {
    this[e.expression.type](e.expression, t);
  },
  MemberExpression(e, t) {
    const n = t.expressionsPrecedence[e.object.type];
    n === on || n < t.expressionsPrecedence.MemberExpression ? (t.write("("), this[e.object.type](e.object, t), t.write(")")) : this[e.object.type](e.object, t), e.computed ? (e.optional && t.write("?."), t.write("["), this[e.property.type](e.property, t), t.write("]")) : (e.optional ? t.write("?.") : t.write("."), this[e.property.type](e.property, t));
  },
  MetaProperty(e, t) {
    t.write(e.meta.name + "." + e.property.name, e);
  },
  Identifier(e, t) {
    t.write(e.name, e);
  },
  PrivateIdentifier(e, t) {
    t.write(`#${e.name}`, e);
  },
  Literal(e, t) {
    e.raw != null ? t.write(e.raw, e) : e.regex != null ? this.RegExpLiteral(e, t) : e.bigint != null ? t.write(e.bigint + "n", e) : t.write(D1(e.value), e);
  },
  RegExpLiteral(e, t) {
    const { regex: n } = e;
    t.write(`/${n.pattern}/${n.flags}`, e);
  }
}, R1 = {};
class O1 {
  constructor(t) {
    const n = t ?? R1;
    this.output = "", n.output != null ? (this.output = n.output, this.write = this.writeToStream) : this.output = "", this.generator = n.generator != null ? n.generator : zc, this.expressionsPrecedence = n.expressionsPrecedence != null ? n.expressionsPrecedence : V1, this.indent = n.indent != null ? n.indent : "  ", this.lineEnd = n.lineEnd != null ? n.lineEnd : `
`, this.indentLevel = n.startingIndentLevel != null ? n.startingIndentLevel : 0, this.writeComments = n.comments ? n.comments : !1, n.sourceMap != null && (this.write = n.output == null ? this.writeAndMap : this.writeToStreamAndMap, this.sourceMap = n.sourceMap, this.line = 1, this.column = 0, this.lineEndSize = this.lineEnd.split(`
`).length - 1, this.mapping = {
      original: null,
      // Uses the entire state to avoid generating ephemeral objects
      generated: this,
      name: void 0,
      source: n.sourceMap.file || n.sourceMap._file
    });
  }
  write(t) {
    this.output += t;
  }
  writeToStream(t) {
    this.output.write(t);
  }
  writeAndMap(t, n) {
    this.output += t, this.map(t, n);
  }
  writeToStreamAndMap(t, n) {
    this.output.write(t), this.map(t, n);
  }
  map(t, n) {
    if (n != null) {
      const { type: a } = n;
      if (a[0] === "L" && a[2] === "n") {
        this.column = 0, this.line++;
        return;
      }
      if (n.loc != null) {
        const { mapping: o } = this;
        o.original = n.loc.start, o.name = n.name, this.sourceMap.addMapping(o);
      }
      if (a[0] === "T" && a[8] === "E" || a[0] === "L" && a[1] === "i" && typeof n.value == "string") {
        const { length: o } = t;
        let { column: l, line: u } = this;
        for (let c = 0; c < o; c++)
          t[c] === `
` ? (l = 0, u++) : l++;
        this.column = l, this.line = u;
        return;
      }
    }
    const { length: i } = t, { lineEnd: r } = this;
    i > 0 && (this.lineEndSize > 0 && (r.length === 1 ? t[i - 1] === r : t.endsWith(r)) ? (this.line += this.lineEndSize, this.column = 0) : this.column += i);
  }
  toString() {
    return this.output;
  }
}
function B1(e, t) {
  const n = new O1(t);
  return n.generator[e.type](e, n), n.output;
}
const z1 = {};
function j1(e, t) {
  const { SourceMapGenerator: n, filePath: i, handlers: r } = t || z1, a = n ? new n({ file: i || "<unknown>.js" }) : void 0, o = B1(
    e,
    // @ts-expect-error: `sourceMap` can be undefined, `astring` types are buggy.
    {
      comments: !0,
      generator: { ...zc, ...r },
      sourceMap: a || void 0
    }
  ), l = a ? a.toJSON() : void 0;
  return { value: o, map: l };
}
const H1 = {
  JSXAttribute: $1,
  JSXClosingElement: q1,
  JSXClosingFragment: U1,
  JSXElement: J1,
  JSXEmptyExpression: W1,
  JSXExpressionContainer: X1,
  JSXFragment: Z1,
  JSXIdentifier: G1,
  JSXMemberExpression: K1,
  JSXNamespacedName: Y1,
  JSXOpeningElement: Q1,
  JSXOpeningFragment: em,
  JSXSpreadAttribute: tm,
  JSXText: nm
};
function $1(e, t) {
  this[e.name.type](e.name, t), e.value !== null && e.value !== void 0 && (t.write("="), e.value.type === "Literal" ? t.write(
    '"' + jc(String(e.value.value)).replace(/"/g, "&quot;") + '"',
    e
  ) : this[e.value.type](e.value, t));
}
function q1(e, t) {
  t.write("</"), this[e.name.type](e.name, t), t.write(">");
}
function U1(e, t) {
  t.write("</>", e);
}
function J1(e, t) {
  let n = -1;
  if (this[e.openingElement.type](e.openingElement, t), e.children)
    for (; ++n < e.children.length; ) {
      const i = e.children[n];
      if (i.type === "JSXSpreadChild")
        throw new Error("JSX spread children are not supported");
      this[i.type](i, t);
    }
  e.closingElement && this[e.closingElement.type](e.closingElement, t);
}
function W1() {
}
function X1(e, t) {
  t.write("{"), this[e.expression.type](e.expression, t), t.write("}");
}
function Z1(e, t) {
  let n = -1;
  if (this[e.openingFragment.type](e.openingFragment, t), e.children)
    for (; ++n < e.children.length; ) {
      const i = e.children[n];
      if (i.type === "JSXSpreadChild")
        throw new Error("JSX spread children are not supported");
      this[i.type](i, t);
    }
  this[e.closingFragment.type](e.closingFragment, t);
}
function G1(e, t) {
  t.write(e.name, e);
}
function K1(e, t) {
  this[e.object.type](e.object, t), t.write("."), this[e.property.type](e.property, t);
}
function Y1(e, t) {
  this[e.namespace.type](e.namespace, t), t.write(":"), this[e.name.type](e.name, t);
}
function Q1(e, t) {
  let n = -1;
  if (t.write("<"), this[e.name.type](e.name, t), e.attributes)
    for (; ++n < e.attributes.length; )
      t.write(" "), this[e.attributes[n].type](e.attributes[n], t);
  t.write(e.selfClosing ? " />" : ">");
}
function em(e, t) {
  t.write("<>", e);
}
function tm(e, t) {
  t.write("{"), this.SpreadElement(e, t), t.write("}");
}
function nm(e, t) {
  t.write(jc(e.value).replace(/[<>{}]/g, im), e);
}
function jc(e) {
  return e.replace(/&(?=[#a-z])/gi, "&amp;");
}
function im(e) {
  return e === "<" ? "&lt;" : e === ">" ? "&gt;" : e === "{" ? "&#123;" : "&#125;";
}
function rm() {
  const e = this.data(), t = e.settings || (e.settings = {}), n = t.handlers || (t.handlers = {});
  (t.plugins || (t.plugins = [])).push(Oc()), Object.assign(n, H1);
}
function sm(e) {
  const t = this;
  this.compiler = n;
  function n(i, r) {
    const a = { ...t.data("settings"), ...e }, o = j1(i, {
      SourceMapGenerator: a.SourceMapGenerator,
      filePath: r.path || "unknown.js",
      handlers: a.handlers
    });
    return r.map = o.map, o.value;
  }
}
function am(e, t) {
  const n = { type: "Block", value: e.value };
  t.inherit(e, n), t.comments.push(n);
  const i = {
    type: "JSXEmptyExpression",
    // @ts-expect-error: `comments` is custom.
    comments: [Object.assign({}, n, { leading: !1, trailing: !0 })]
  };
  t.patch(e, i);
  const r = { type: "JSXExpressionContainer", expression: i };
  return t.patch(e, r), r;
}
function om(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
class Pr {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, i) {
    this.normal = n, this.property = t, i && (this.space = i);
  }
}
Pr.prototype.normal = {};
Pr.prototype.property = {};
Pr.prototype.space = void 0;
function Hc(e, t) {
  const n = {}, i = {};
  for (const r of e)
    Object.assign(n, r.property), Object.assign(i, r.normal);
  return new Pr(n, i, t);
}
function Ra(e) {
  return e.toLowerCase();
}
class $t {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
}
$t.prototype.attribute = "";
$t.prototype.booleanish = !1;
$t.prototype.boolean = !1;
$t.prototype.commaOrSpaceSeparated = !1;
$t.prototype.commaSeparated = !1;
$t.prototype.defined = !1;
$t.prototype.mustUseProperty = !1;
$t.prototype.number = !1;
$t.prototype.overloadedBoolean = !1;
$t.prototype.property = "";
$t.prototype.spaceSeparated = !1;
$t.prototype.space = void 0;
let lm = 0;
const Me = mi(), dt = mi(), Oa = mi(), oe = mi(), Qe = mi(), Mi = mi(), Jt = mi();
function mi() {
  return 2 ** ++lm;
}
const Ba = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Me,
  booleanish: dt,
  commaOrSpaceSeparated: Jt,
  commaSeparated: Mi,
  number: oe,
  overloadedBoolean: Oa,
  spaceSeparated: Qe
}, Symbol.toStringTag, { value: "Module" })), Gs = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(Ba)
);
class go extends $t {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, i, r) {
    let a = -1;
    if (super(t, n), Wl(this, "space", r), typeof i == "number")
      for (; ++a < Gs.length; ) {
        const o = Gs[a];
        Wl(this, Gs[a], (i & Ba[o]) === Ba[o]);
      }
  }
}
go.prototype.defined = !0;
function Wl(e, t, n) {
  n && (e[t] = n);
}
function qi(e) {
  const t = {}, n = {};
  for (const [i, r] of Object.entries(e.properties)) {
    const a = new go(
      i,
      e.transform(e.attributes || {}, i),
      r,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(i) && (a.mustUseProperty = !0), t[i] = a, n[Ra(i)] = i, n[Ra(a.attribute)] = i;
  }
  return new Pr(t, n, e.space);
}
const $c = qi({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: dt,
    ariaAutoComplete: null,
    ariaBusy: dt,
    ariaChecked: dt,
    ariaColCount: oe,
    ariaColIndex: oe,
    ariaColSpan: oe,
    ariaControls: Qe,
    ariaCurrent: null,
    ariaDescribedBy: Qe,
    ariaDetails: null,
    ariaDisabled: dt,
    ariaDropEffect: Qe,
    ariaErrorMessage: null,
    ariaExpanded: dt,
    ariaFlowTo: Qe,
    ariaGrabbed: dt,
    ariaHasPopup: null,
    ariaHidden: dt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Qe,
    ariaLevel: oe,
    ariaLive: null,
    ariaModal: dt,
    ariaMultiLine: dt,
    ariaMultiSelectable: dt,
    ariaOrientation: null,
    ariaOwns: Qe,
    ariaPlaceholder: null,
    ariaPosInSet: oe,
    ariaPressed: dt,
    ariaReadOnly: dt,
    ariaRelevant: null,
    ariaRequired: dt,
    ariaRoleDescription: Qe,
    ariaRowCount: oe,
    ariaRowIndex: oe,
    ariaRowSpan: oe,
    ariaSelected: dt,
    ariaSetSize: oe,
    ariaSort: null,
    ariaValueMax: oe,
    ariaValueMin: oe,
    ariaValueNow: oe,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function qc(e, t) {
  return t in e ? e[t] : t;
}
function Uc(e, t) {
  return qc(e, t.toLowerCase());
}
const um = qi({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Mi,
    acceptCharset: Qe,
    accessKey: Qe,
    action: null,
    allow: null,
    allowFullScreen: Me,
    allowPaymentRequest: Me,
    allowUserMedia: Me,
    alt: null,
    as: null,
    async: Me,
    autoCapitalize: null,
    autoComplete: Qe,
    autoFocus: Me,
    autoPlay: Me,
    blocking: Qe,
    capture: null,
    charSet: null,
    checked: Me,
    cite: null,
    className: Qe,
    cols: oe,
    colSpan: null,
    content: null,
    contentEditable: dt,
    controls: Me,
    controlsList: Qe,
    coords: oe | Mi,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Me,
    defer: Me,
    dir: null,
    dirName: null,
    disabled: Me,
    download: Oa,
    draggable: dt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Me,
    formTarget: null,
    headers: Qe,
    height: oe,
    hidden: Oa,
    high: oe,
    href: null,
    hrefLang: null,
    htmlFor: Qe,
    httpEquiv: Qe,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Me,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Me,
    itemId: null,
    itemProp: Qe,
    itemRef: Qe,
    itemScope: Me,
    itemType: Qe,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Me,
    low: oe,
    manifest: null,
    max: null,
    maxLength: oe,
    media: null,
    method: null,
    min: null,
    minLength: oe,
    multiple: Me,
    muted: Me,
    name: null,
    nonce: null,
    noModule: Me,
    noValidate: Me,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Me,
    optimum: oe,
    pattern: null,
    ping: Qe,
    placeholder: null,
    playsInline: Me,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Me,
    referrerPolicy: null,
    rel: Qe,
    required: Me,
    reversed: Me,
    rows: oe,
    rowSpan: oe,
    sandbox: Qe,
    scope: null,
    scoped: Me,
    seamless: Me,
    selected: Me,
    shadowRootClonable: Me,
    shadowRootDelegatesFocus: Me,
    shadowRootMode: null,
    shape: null,
    size: oe,
    sizes: null,
    slot: null,
    span: oe,
    spellCheck: dt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: oe,
    step: null,
    style: null,
    tabIndex: oe,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Me,
    useMap: null,
    value: dt,
    width: oe,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Qe,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: oe,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: oe,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Me,
    // Lists. Use CSS to reduce space between items instead
    declare: Me,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: oe,
    // `<img>` and `<object>`
    leftMargin: oe,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: oe,
    // `<body>`
    marginWidth: oe,
    // `<body>`
    noResize: Me,
    // `<frame>`
    noHref: Me,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Me,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Me,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: oe,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: dt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: oe,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: oe,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Me,
    disableRemotePlayback: Me,
    prefix: null,
    property: null,
    results: oe,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: Uc
}), cm = qi({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: Jt,
    accentHeight: oe,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: oe,
    amplitude: oe,
    arabicForm: null,
    ascent: oe,
    attributeName: null,
    attributeType: null,
    azimuth: oe,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: oe,
    by: null,
    calcMode: null,
    capHeight: oe,
    className: Qe,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: oe,
    diffuseConstant: oe,
    direction: null,
    display: null,
    dur: null,
    divisor: oe,
    dominantBaseline: null,
    download: Me,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: oe,
    enableBackground: null,
    end: null,
    event: null,
    exponent: oe,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: oe,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Mi,
    g2: Mi,
    glyphName: Mi,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: oe,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: oe,
    horizOriginX: oe,
    horizOriginY: oe,
    id: null,
    ideographic: oe,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: oe,
    k: oe,
    k1: oe,
    k2: oe,
    k3: oe,
    k4: oe,
    kernelMatrix: Jt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: oe,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: oe,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: oe,
    overlineThickness: oe,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: oe,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Qe,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: oe,
    pointsAtY: oe,
    pointsAtZ: oe,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Jt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Jt,
    rev: Jt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Jt,
    requiredFeatures: Jt,
    requiredFonts: Jt,
    requiredFormats: Jt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: oe,
    specularExponent: oe,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: oe,
    strikethroughThickness: oe,
    string: null,
    stroke: null,
    strokeDashArray: Jt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: oe,
    strokeOpacity: oe,
    strokeWidth: null,
    style: null,
    surfaceScale: oe,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Jt,
    tabIndex: oe,
    tableValues: null,
    target: null,
    targetX: oe,
    targetY: oe,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Jt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: oe,
    underlineThickness: oe,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: oe,
    values: null,
    vAlphabetic: oe,
    vMathematical: oe,
    vectorEffect: null,
    vHanging: oe,
    vIdeographic: oe,
    version: null,
    vertAdvY: oe,
    vertOriginX: oe,
    vertOriginY: oe,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: oe,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: qc
}), Jc = qi({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), Wc = qi({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: Uc
}), Xc = qi({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), hm = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, pm = /[A-Z]/g, Xl = /-[a-z]/g, dm = /^data[-\w.:]+$/i;
function fm(e, t) {
  const n = Ra(t);
  let i = t, r = $t;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && dm.test(t)) {
    if (t.charAt(4) === "-") {
      const a = t.slice(5).replace(Xl, gm);
      i = "data" + a.charAt(0).toUpperCase() + a.slice(1);
    } else {
      const a = t.slice(4);
      if (!Xl.test(a)) {
        let o = a.replace(pm, mm);
        o.charAt(0) !== "-" && (o = "-" + o), t = "data" + o;
      }
    }
    r = go;
  }
  return new r(i, t);
}
function mm(e) {
  return "-" + e.toLowerCase();
}
function gm(e) {
  return e.charAt(1).toUpperCase();
}
const _m = Hc([$c, um, Jc, Wc, Xc], "html"), _o = Hc([$c, cm, Jc, Wc, Xc], "svg");
function xm(e) {
  return e.join(" ").trim();
}
var Ai = {}, Ks, Zl;
function ym() {
  if (Zl) return Ks;
  Zl = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, t = /\n/g, n = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, r = /^:\s*/, a = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, o = /^[;\s]*/, l = /^\s+|\s+$/g, u = `
`, c = "/", h = "*", p = "", m = "comment", g = "declaration";
  function b(w, y) {
    if (typeof w != "string")
      throw new TypeError("First argument must be a string");
    if (!w) return [];
    y = y || {};
    var I = 1, E = 1;
    function P(H) {
      var O = H.match(t);
      O && (I += O.length);
      var X = H.lastIndexOf(u);
      E = ~X ? H.length - X : E + H.length;
    }
    function S() {
      var H = { line: I, column: E };
      return function(O) {
        return O.position = new f(H), F(), O;
      };
    }
    function f(H) {
      this.start = H, this.end = { line: I, column: E }, this.source = y.source;
    }
    f.prototype.content = w;
    function C(H) {
      var O = new Error(
        y.source + ":" + I + ":" + E + ": " + H
      );
      if (O.reason = H, O.filename = y.source, O.line = I, O.column = E, O.source = w, !y.silent) throw O;
    }
    function L(H) {
      var O = H.exec(w);
      if (O) {
        var X = O[0];
        return P(X), w = w.slice(X.length), O;
      }
    }
    function F() {
      L(n);
    }
    function M(H) {
      var O;
      for (H = H || []; O = z(); )
        O !== !1 && H.push(O);
      return H;
    }
    function z() {
      var H = S();
      if (!(c != w.charAt(0) || h != w.charAt(1))) {
        for (var O = 2; p != w.charAt(O) && (h != w.charAt(O) || c != w.charAt(O + 1)); )
          ++O;
        if (O += 2, p === w.charAt(O - 1))
          return C("End of comment missing");
        var X = w.slice(2, O - 2);
        return E += 2, P(X), w = w.slice(O), E += 2, H({
          type: m,
          comment: X
        });
      }
    }
    function R() {
      var H = S(), O = L(i);
      if (O) {
        if (z(), !L(r)) return C("property missing ':'");
        var X = L(a), K = H({
          type: g,
          property: v(O[0].replace(e, p)),
          value: X ? v(X[0].replace(e, p)) : p
        });
        return L(o), K;
      }
    }
    function j() {
      var H = [];
      M(H);
      for (var O; O = R(); )
        O !== !1 && (H.push(O), M(H));
      return H;
    }
    return F(), j();
  }
  function v(w) {
    return w ? w.replace(l, p) : p;
  }
  return Ks = b, Ks;
}
var Gl;
function bm() {
  if (Gl) return Ai;
  Gl = 1;
  var e = Ai && Ai.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Ai, "__esModule", { value: !0 }), Ai.default = n;
  const t = e(ym());
  function n(i, r) {
    let a = null;
    if (!i || typeof i != "string")
      return a;
    const o = (0, t.default)(i), l = typeof r == "function";
    return o.forEach((u) => {
      if (u.type !== "declaration")
        return;
      const { property: c, value: h } = u;
      l ? r(c, h, u) : h && (a = a || {}, a[c] = h);
    }), a;
  }
  return Ai;
}
var sr = {}, Kl;
function vm() {
  if (Kl) return sr;
  Kl = 1, Object.defineProperty(sr, "__esModule", { value: !0 }), sr.camelCase = void 0;
  var e = /^--[a-zA-Z0-9_-]+$/, t = /-([a-z])/g, n = /^[^-]+$/, i = /^-(webkit|moz|ms|o|khtml)-/, r = /^-(ms)-/, a = function(c) {
    return !c || n.test(c) || e.test(c);
  }, o = function(c, h) {
    return h.toUpperCase();
  }, l = function(c, h) {
    return "".concat(h, "-");
  }, u = function(c, h) {
    return h === void 0 && (h = {}), a(c) ? c : (c = c.toLowerCase(), h.reactCompat ? c = c.replace(r, l) : c = c.replace(i, l), c.replace(t, o));
  };
  return sr.camelCase = u, sr;
}
var ar, Yl;
function wm() {
  if (Yl) return ar;
  Yl = 1;
  var e = ar && ar.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  }, t = e(bm()), n = vm();
  function i(r, a) {
    var o = {};
    return !r || typeof r != "string" || (0, t.default)(r, function(l, u) {
      l && u && (o[(0, n.camelCase)(l, a)] = u);
    }), o;
  }
  return i.default = i, ar = i, ar;
}
var km = wm();
const Cm = /* @__PURE__ */ Sr(km), za = {}.hasOwnProperty, Sm = /[A-Z]/g, Em = /* @__PURE__ */ new Set(["td", "th"]);
function Am(e, t) {
  const n = t.schema;
  let i = n;
  const r = e.properties || {};
  n.space === "html" && e.tagName.toLowerCase() === "svg" && (i = _o, t.schema = i);
  const a = t.all(e), o = [];
  let l, u, c;
  for (l in r)
    if (za.call(r, l)) {
      let p = r[l];
      const m = fm(i, l);
      let g;
      if (p == null || p === !1 || typeof p == "number" && Number.isNaN(p) || !p && m.boolean)
        continue;
      if (l = t.elementAttributeNameCase === "react" && m.space ? hm[m.property] || m.property : m.attribute, Array.isArray(p) && (p = m.commaSeparated ? om(p) : xm(p)), l === "style") {
        let b = typeof p == "object" ? p : Im(String(p), e.tagName);
        t.stylePropertyNameCase === "css" && (b = Lm(b));
        const v = [];
        let w;
        for (w in b)
          za.call(b, w) && v.push({
            type: "Property",
            method: !1,
            shorthand: !1,
            computed: !1,
            key: vn(w) ? { type: "Identifier", name: w } : { type: "Literal", value: w },
            value: { type: "Literal", value: String(b[w]) },
            kind: "init"
          });
        c = v, g = {
          type: "JSXExpressionContainer",
          expression: { type: "ObjectExpression", properties: v }
        };
      } else if (p === !0)
        g = null;
      else if (t.tableCellAlignToStyle && Em.has(e.tagName) && l === "align") {
        u = String(p);
        continue;
      } else
        g = { type: "Literal", value: String(p) };
      vn(l, { jsx: !0 }) ? o.push({
        type: "JSXAttribute",
        name: { type: "JSXIdentifier", name: l },
        value: g
      }) : o.push({
        type: "JSXSpreadAttribute",
        argument: {
          type: "ObjectExpression",
          properties: [
            {
              type: "Property",
              method: !1,
              shorthand: !1,
              computed: !1,
              key: { type: "Literal", value: String(l) },
              // @ts-expect-error No need to worry about `style` (which has a
              // `JSXExpressionContainer` value) because that’s a valid identifier.
              value: g || { type: "Literal", value: !0 },
              kind: "init"
            }
          ]
        }
      });
    }
  if (u !== void 0) {
    c || (c = [], o.push({
      type: "JSXAttribute",
      name: { type: "JSXIdentifier", name: "style" },
      value: {
        type: "JSXExpressionContainer",
        expression: { type: "ObjectExpression", properties: c }
      }
    }));
    const p = t.stylePropertyNameCase === "css" ? Zc("textAlign") : "textAlign";
    c.push({
      type: "Property",
      method: !1,
      shorthand: !1,
      computed: !1,
      key: vn(p) ? { type: "Identifier", name: p } : { type: "Literal", value: p },
      value: { type: "Literal", value: u },
      kind: "init"
    });
  }
  t.schema = n;
  const h = {
    type: "JSXElement",
    openingElement: {
      type: "JSXOpeningElement",
      attributes: o,
      name: t.createJsxElementName(e.tagName),
      selfClosing: a.length === 0
    },
    closingElement: a.length > 0 ? {
      type: "JSXClosingElement",
      name: t.createJsxElementName(e.tagName)
    } : null,
    children: a
  };
  return t.inherit(e, h), h;
}
function Im(e, t) {
  try {
    return Cm(e, { reactCompat: !0 });
  } catch (n) {
    const i = (
      /** @type {Error} */
      n
    );
    throw new Error(
      "Could not parse `style` attribute on `" + t + "`",
      { cause: i }
    );
  }
}
function Lm(e) {
  const t = {};
  let n;
  for (n in e)
    za.call(e, n) && (t[Zc(n)] = e[n]);
  return t;
}
function Zc(e) {
  let t = e.replace(Sm, Pm);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function Pm(e) {
  return "-" + e.toLowerCase();
}
const Tm = {}.hasOwnProperty, Nm = [];
function os(e, t) {
  const n = t ? [...t].sort(xo) : Nm;
  n.length > 0 && Gc(e, { comments: n, index: 0 });
}
function Gc(e, t) {
  if (t.index === t.comments.length)
    return;
  const n = [], i = [];
  let r;
  for (r in e)
    if (Tm.call(e, r)) {
      const o = e[r];
      if (o && typeof o == "object" && r !== "comments")
        if (Array.isArray(o)) {
          let l = -1;
          for (; ++l < o.length; )
            o[l] && typeof o[l].type == "string" && n.push(o[l]);
        } else typeof o.type == "string" && n.push(o);
    }
  n.sort(xo), i.push(...Ql(t, e, !1, { leading: !0, trailing: !1 }));
  let a = -1;
  for (; ++a < n.length; )
    Gc(n[a], t);
  i.push(
    ...Ql(t, e, !0, {
      leading: !1,
      trailing: n.length > 0
    })
  ), i.length > 0 && (e.comments = i);
}
function Ql(e, t, n, i) {
  const r = [];
  for (; e.comments[e.index] && xo(e.comments[e.index], t, n) < 1; )
    r.push(Object.assign({}, e.comments[e.index++], i));
  return r;
}
function xo(e, t, n) {
  const i = n ? "end" : "start";
  return e.range && t.range ? e.range[0] - t.range[n ? 1 : 0] : e.loc && e.loc.start && t.loc && t.loc[i] ? e.loc.start.line - t.loc[i].line || e.loc.start.column - t.loc[i].column : "start" in e && i in t ? e.start - t[i] : Number.NaN;
}
function eu(e, t) {
  const n = e.data && e.data.estree, i = n && n.comments || [];
  let r;
  n && (t.comments.push(...i), os(n, n.comments), r = n.body[0] && n.body[0].type === "ExpressionStatement" && n.body[0].expression || void 0), r || (r = { type: "JSXEmptyExpression" }, t.patch(e, r));
  const a = { type: "JSXExpressionContainer", expression: r };
  return t.inherit(e, a), a;
}
function tu(e, t) {
  const n = t.schema;
  let i = n;
  const r = e.attributes || [];
  let a = -1;
  e.name && n.space === "html" && e.name.toLowerCase() === "svg" && (i = _o, t.schema = i);
  const o = t.all(e), l = [];
  for (; ++a < r.length; ) {
    const c = r[a], h = c.value;
    let p;
    if (c.type === "mdxJsxAttribute") {
      if (h == null)
        p = null;
      else if (typeof h == "object") {
        const g = h.data && h.data.estree, b = g && g.comments || [];
        let v;
        g && (t.comments.push(...b), os(g, g.comments), v = g.body[0] && g.body[0].type === "ExpressionStatement" && g.body[0].expression || void 0), p = {
          type: "JSXExpressionContainer",
          expression: v || { type: "JSXEmptyExpression" }
        }, t.inherit(h, p);
      } else
        p = { type: "Literal", value: String(h) };
      const m = {
        type: "JSXAttribute",
        name: t.createJsxAttributeName(c.name),
        value: p
      };
      t.inherit(c, m), l.push(m);
    } else {
      const m = c.data && c.data.estree, g = m && m.comments || [];
      let b;
      m && (t.comments.push(...g), os(m, m.comments), b = m.body[0] && m.body[0].type === "ExpressionStatement" && m.body[0].expression && m.body[0].expression.type === "ObjectExpression" && m.body[0].expression.properties && m.body[0].expression.properties[0] && m.body[0].expression.properties[0].type === "SpreadElement" && m.body[0].expression.properties[0].argument || void 0);
      const v = {
        type: "JSXSpreadAttribute",
        argument: b || { type: "ObjectExpression", properties: [] }
      };
      t.inherit(c, v), l.push(v);
    }
  }
  t.schema = n;
  const u = e.name ? {
    type: "JSXElement",
    openingElement: {
      type: "JSXOpeningElement",
      attributes: l,
      name: t.createJsxElementName(e.name),
      selfClosing: o.length === 0
    },
    closingElement: o.length > 0 ? {
      type: "JSXClosingElement",
      name: t.createJsxElementName(e.name)
    } : null,
    children: o
  } : {
    type: "JSXFragment",
    openingFragment: { type: "JSXOpeningFragment" },
    closingFragment: { type: "JSXClosingFragment" },
    children: o
  };
  return t.inherit(e, u), u;
}
function Dm(e, t) {
  const n = e.data && e.data.estree, i = n && n.comments || [];
  n && (t.comments.push(...i), os(n, i), t.esm.push(...n.body));
}
const Vm = /[ \t\n\f\r]/g;
function Mm(e) {
  return typeof e == "object" ? e.type === "text" ? nu(e.value) : !1 : nu(e);
}
function nu(e) {
  return e.replace(Vm, "") === "";
}
function Fm(e, t) {
  const n = t.all(e), i = [];
  let r = -1, a;
  for (; ++r < n.length; ) {
    const l = n[r];
    l.type === "JSXExpressionContainer" && l.expression.type === "Literal" && Mm(String(l.expression.value)) ? a && a.push(l) : (a && i.push(...a), i.push(l), a = []);
  }
  const o = {
    type: "JSXFragment",
    openingFragment: { type: "JSXOpeningFragment" },
    closingFragment: { type: "JSXClosingFragment" },
    children: i
  };
  return t.inherit(e, o), o;
}
function Rm(e, t) {
  const n = String(e.value || "");
  if (n) {
    const i = { type: "Literal", value: n };
    t.inherit(e, i);
    const r = { type: "JSXExpressionContainer", expression: i };
    return t.patch(e, r), r;
  }
}
const Om = {
  comment: am,
  doctype: Bm,
  element: Am,
  mdxFlowExpression: eu,
  mdxJsxFlowElement: tu,
  mdxJsxTextElement: tu,
  mdxTextExpression: eu,
  mdxjsEsm: Dm,
  root: Fm,
  text: Rm
};
function Bm() {
}
const Kc = Qc("end"), Yc = Qc("start");
function Qc(e) {
  return t;
  function t(n) {
    const i = n && n.position && n.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function eh(e) {
  const t = Yc(e), n = Kc(e);
  if (t && n)
    return { start: t, end: n };
}
const iu = {}.hasOwnProperty;
function zm(e, t) {
  const n = t || {};
  function i(r, ...a) {
    let o = i.invalid;
    const l = i.handlers;
    if (r && iu.call(r, e)) {
      const u = String(r[e]);
      o = iu.call(l, u) ? l[u] : i.unknown;
    }
    if (o)
      return o.call(this, r, ...a);
  }
  return i.handlers = n.handlers || {}, i.invalid = n.invalid, i.unknown = n.unknown, i;
}
const jm = {}.hasOwnProperty, Hm = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]);
function $m(e) {
  const t = zm("type", {
    invalid: qm,
    unknown: Um,
    handlers: { ...Om, ...e.handlers }
  });
  return {
    // Current space.
    elementAttributeNameCase: e.elementAttributeNameCase || "react",
    schema: e.space === "svg" ? _o : _m,
    stylePropertyNameCase: e.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: e.tableCellAlignToStyle !== !1,
    // Results.
    comments: [],
    esm: [],
    // Useful functions.
    all: Jm,
    createJsxAttributeName: Xm,
    createJsxElementName: Zm,
    handle: n,
    inherit: Wm,
    patch: th
  };
  function n(i) {
    return t(i, this);
  }
}
function qm(e) {
  throw new Error("Cannot handle value `" + e + "`, expected node");
}
function Um(e) {
  throw new Error("Cannot handle unknown node `" + e.type + "`");
}
function Jm(e) {
  const t = e.children || [];
  let n = -1;
  const i = [], r = this.schema.space === "html" && e.type === "element" && Hm.has(e.tagName.toLowerCase());
  for (; ++n < t.length; ) {
    const a = t[n];
    if (r && a.type === "text" && a.value === `
`)
      continue;
    const o = this.handle(a);
    Array.isArray(o) ? i.push(...o) : o && i.push(o);
  }
  return i;
}
function Wm(e, t) {
  const n = (
    /** @type {Record<string, unknown> | undefined} */
    e.data
  );
  let i, r;
  if (th(e, t), n) {
    for (r in n)
      jm.call(n, r) && r !== "estree" && (i || (i = {}), i[r] = n[r]);
    i && (t.data = i);
  }
}
function th(e, t) {
  const n = eh(e);
  n && n.start.offset !== void 0 && n.end.offset !== void 0 && (t.start = n.start.offset, t.end = n.end.offset, t.loc = {
    start: { line: n.start.line, column: n.start.column - 1 },
    end: { line: n.end.line, column: n.end.column - 1 }
  }, t.range = [n.start.offset, n.end.offset]);
}
function Xm(e) {
  const t = nh(e);
  if (t.type === "JSXMemberExpression")
    throw new Error("Member expressions in attribute names are not supported");
  return t;
}
function Zm(e) {
  return nh(e);
}
function nh(e) {
  if (e.includes(".")) {
    const t = e.split(".");
    let n = t.shift(), i = { type: "JSXIdentifier", name: n };
    for (; n = t.shift(); )
      i = {
        type: "JSXMemberExpression",
        object: i,
        property: { type: "JSXIdentifier", name: n }
      };
    return i;
  }
  if (e.includes(":")) {
    const t = e.split(":");
    return {
      type: "JSXNamespacedName",
      namespace: { type: "JSXIdentifier", name: t[0] },
      name: { type: "JSXIdentifier", name: t[1] }
    };
  }
  return { type: "JSXIdentifier", name: e };
}
function Gm(e, t) {
  const n = $m(t || {});
  let i = n.handle(e);
  const r = n.esm;
  if (i) {
    i.type !== "JSXFragment" && i.type !== "JSXElement" && (i = {
      type: "JSXFragment",
      openingFragment: { type: "JSXOpeningFragment" },
      closingFragment: { type: "JSXClosingFragment" },
      children: [i]
    }, n.patch(e, i));
    const o = { type: "ExpressionStatement", expression: i };
    n.patch(e, o), r.push(o);
  }
  const a = {
    type: "Program",
    body: r,
    sourceType: "module",
    comments: n.comments
  };
  return n.patch(e, a), a;
}
function Km(e) {
  return function(t) {
    return Gm(t, e);
  };
}
function Ym() {
  return {
    enter: {
      mdxFlowExpression: e2,
      mdxTextExpression: t2
    },
    exit: {
      mdxFlowExpression: ru,
      mdxFlowExpressionChunk: su,
      mdxTextExpression: ru,
      mdxTextExpressionChunk: su
    }
  };
}
function Qm() {
  return {
    handlers: {
      mdxFlowExpression: au,
      mdxTextExpression: au
    },
    unsafe: [
      { character: "{", inConstruct: ["phrasing"] },
      { atBreak: !0, character: "{" }
    ]
  };
}
function e2(e) {
  this.enter({ type: "mdxFlowExpression", value: "" }, e), this.buffer();
}
function t2(e) {
  this.enter({ type: "mdxTextExpression", value: "" }, e), this.buffer();
}
function ru(e) {
  const t = this.resume(), n = e.estree, i = this.stack[this.stack.length - 1];
  i.type === "mdxFlowExpression" || i.type, this.exit(e), i.value = t, n && (i.data = { estree: n });
}
function su(e) {
  this.config.enter.data.call(this, e), this.config.exit.data.call(this, e);
}
function au(e, t, n) {
  const i = e.value || "";
  return "{" + n.indentLines(i, function(a, o, l) {
    return (o === 0 || l ? "" : "  ") + a;
  }) + "}";
}
function ls(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let i = 0, r = n.indexOf(t);
  for (; r !== -1; )
    i++, r = n.indexOf(t, r + t.length);
  return i;
}
const n2 = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], ou = {
  0: "�",
  128: "€",
  130: "‚",
  131: "ƒ",
  132: "„",
  133: "…",
  134: "†",
  135: "‡",
  136: "ˆ",
  137: "‰",
  138: "Š",
  139: "‹",
  140: "Œ",
  142: "Ž",
  145: "‘",
  146: "’",
  147: "“",
  148: "”",
  149: "•",
  150: "–",
  151: "—",
  152: "˜",
  153: "™",
  154: "š",
  155: "›",
  156: "œ",
  158: "ž",
  159: "Ÿ"
};
function ih(e) {
  const t = typeof e == "string" ? e.charCodeAt(0) : e;
  return t >= 48 && t <= 57;
}
function i2(e) {
  const t = typeof e == "string" ? e.charCodeAt(0) : e;
  return t >= 97 && t <= 102 || t >= 65 && t <= 70 || t >= 48 && t <= 57;
}
function r2(e) {
  const t = typeof e == "string" ? e.charCodeAt(0) : e;
  return t >= 97 && t <= 122 || t >= 65 && t <= 90;
}
function lu(e) {
  return r2(e) || ih(e);
}
const uu = document.createElement("i");
function br(e) {
  const t = "&" + e + ";";
  uu.innerHTML = t;
  const n = uu.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
const s2 = [
  "",
  /* 1: Non terminated (named) */
  "Named character references must be terminated by a semicolon",
  /* 2: Non terminated (numeric) */
  "Numeric character references must be terminated by a semicolon",
  /* 3: Empty (named) */
  "Named character references cannot be empty",
  /* 4: Empty (numeric) */
  "Numeric character references cannot be empty",
  /* 5: Unknown (named) */
  "Named character references must be known",
  /* 6: Disallowed (numeric) */
  "Numeric character references cannot be disallowed",
  /* 7: Prohibited (numeric) */
  "Numeric character references cannot be outside the permissible Unicode range"
];
function a2(e, t) {
  const n = t || {}, i = typeof n.additional == "string" ? n.additional.charCodeAt(0) : n.additional, r = [];
  let a = 0, o = -1, l = "", u, c;
  n.position && ("start" in n.position || "indent" in n.position ? (c = n.position.indent, u = n.position.start) : u = n.position);
  let h = (u ? u.line : 0) || 1, p = (u ? u.column : 0) || 1, m = b(), g;
  for (a--; ++a <= e.length; )
    if (g === 10 && (p = (c ? c[o] : 0) || 1), g = e.charCodeAt(a), g === 38) {
      const y = e.charCodeAt(a + 1);
      if (y === 9 || y === 10 || y === 12 || y === 32 || y === 38 || y === 60 || Number.isNaN(y) || i && y === i) {
        l += String.fromCharCode(g), p++;
        continue;
      }
      const I = a + 1;
      let E = I, P = I, S;
      if (y === 35) {
        P = ++E;
        const j = e.charCodeAt(P);
        j === 88 || j === 120 ? (S = "hexadecimal", P = ++E) : S = "decimal";
      } else
        S = "named";
      let f = "", C = "", L = "";
      const F = S === "named" ? lu : S === "decimal" ? ih : i2;
      for (P--; ++P <= e.length; ) {
        const j = e.charCodeAt(P);
        if (!F(j))
          break;
        L += String.fromCharCode(j), S === "named" && n2.includes(L) && (f = L, C = br(L));
      }
      let M = e.charCodeAt(P) === 59;
      if (M) {
        P++;
        const j = S === "named" ? br(L) : !1;
        j && (f = L, C = j);
      }
      let z = 1 + P - I, R = "";
      if (!(!M && n.nonTerminated === !1)) if (!L)
        S !== "named" && v(4, z);
      else if (S === "named") {
        if (M && !C)
          v(5, 1);
        else if (f !== L && (P = E + f.length, z = 1 + P - E, M = !1), !M) {
          const j = f ? 1 : 3;
          if (n.attribute) {
            const H = e.charCodeAt(P);
            H === 61 ? (v(j, z), C = "") : lu(H) ? C = "" : v(j, z);
          } else
            v(j, z);
        }
        R = C;
      } else {
        M || v(2, z);
        let j = Number.parseInt(
          L,
          S === "hexadecimal" ? 16 : 10
        );
        if (o2(j))
          v(7, z), R = "�";
        else if (j in ou)
          v(6, z), R = ou[j];
        else {
          let H = "";
          l2(j) && v(6, z), j > 65535 && (j -= 65536, H += String.fromCharCode(
            j >>> 10 | 55296
          ), j = 56320 | j & 1023), R = H + String.fromCharCode(j);
        }
      }
      if (R) {
        w(), m = b(), a = P - 1, p += P - I + 1, r.push(R);
        const j = b();
        j.offset++, n.reference && n.reference.call(
          n.referenceContext || void 0,
          R,
          { start: m, end: j },
          e.slice(I - 1, P)
        ), m = j;
      } else
        L = e.slice(I - 1, P), l += L, p += L.length, a = P - 1;
    } else
      g === 10 && (h++, o++, p = 0), Number.isNaN(g) ? w() : (l += String.fromCharCode(g), p++);
  return r.join("");
  function b() {
    return {
      line: h,
      column: p,
      offset: a + ((u ? u.offset : 0) || 0)
    };
  }
  function v(y, I) {
    let E;
    n.warning && (E = b(), E.column += I, E.offset += I, n.warning.call(
      n.warningContext || void 0,
      s2[y],
      E,
      y
    ));
  }
  function w() {
    l && (r.push(l), n.text && n.text.call(n.textContext || void 0, l, {
      start: m,
      end: b()
    }), l = "");
  }
}
function o2(e) {
  return e >= 55296 && e <= 57343 || e > 1114111;
}
function l2(e) {
  return e >= 1 && e <= 8 || e === 11 || e >= 13 && e <= 31 || e >= 127 && e <= 159 || e >= 64976 && e <= 65007 || (e & 65535) === 65535 || (e & 65535) === 65534;
}
const u2 = /["&'<>`]/g, c2 = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, h2 = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
), p2 = /[|\\{}()[\]^$+*?.]/g, cu = /* @__PURE__ */ new WeakMap();
function d2(e, t) {
  if (e = e.replace(
    t.subset ? f2(t.subset) : u2,
    i
  ), t.subset || t.escapeOnly)
    return e;
  return e.replace(c2, n).replace(h2, i);
  function n(r, a, o) {
    return t.format(
      (r.charCodeAt(0) - 55296) * 1024 + r.charCodeAt(1) - 56320 + 65536,
      o.charCodeAt(a + 2),
      t
    );
  }
  function i(r, a, o) {
    return t.format(
      r.charCodeAt(0),
      o.charCodeAt(a + 1),
      t
    );
  }
}
function f2(e) {
  let t = cu.get(e);
  return t || (t = m2(e), cu.set(e, t)), t;
}
function m2(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t.push(e[n].replace(p2, "\\$&"));
  return new RegExp("(?:" + t.join("|") + ")", "g");
}
function g2(e) {
  return "&#x" + e.toString(16).toUpperCase() + ";";
}
function _2(e, t) {
  return d2(e, Object.assign({ format: g2 }, t));
}
const rh = "  ";
function x2() {
  return {
    canContainEols: ["mdxJsxTextElement"],
    enter: {
      mdxJsxFlowTag: i,
      mdxJsxFlowTagClosingMarker: r,
      mdxJsxFlowTagAttribute: p,
      mdxJsxFlowTagExpressionAttribute: m,
      mdxJsxFlowTagAttributeValueLiteral: e,
      mdxJsxFlowTagAttributeValueExpression: e,
      mdxJsxFlowTagSelfClosingMarker: o,
      mdxJsxTextTag: i,
      mdxJsxTextTagClosingMarker: r,
      mdxJsxTextTagAttribute: p,
      mdxJsxTextTagExpressionAttribute: m,
      mdxJsxTextTagAttributeValueLiteral: e,
      mdxJsxTextTagAttributeValueExpression: e,
      mdxJsxTextTagSelfClosingMarker: o
    },
    exit: {
      mdxJsxFlowTagClosingMarker: l,
      mdxJsxFlowTagNamePrimary: u,
      mdxJsxFlowTagNameMember: c,
      mdxJsxFlowTagNameLocal: h,
      mdxJsxFlowTagExpressionAttribute: g,
      mdxJsxFlowTagExpressionAttributeValue: n,
      mdxJsxFlowTagAttributeNamePrimary: b,
      mdxJsxFlowTagAttributeNameLocal: v,
      mdxJsxFlowTagAttributeValueLiteral: w,
      mdxJsxFlowTagAttributeValueLiteralValue: n,
      mdxJsxFlowTagAttributeValueExpression: y,
      mdxJsxFlowTagAttributeValueExpressionValue: n,
      mdxJsxFlowTagSelfClosingMarker: I,
      mdxJsxFlowTag: E,
      mdxJsxTextTagClosingMarker: l,
      mdxJsxTextTagNamePrimary: u,
      mdxJsxTextTagNameMember: c,
      mdxJsxTextTagNameLocal: h,
      mdxJsxTextTagExpressionAttribute: g,
      mdxJsxTextTagExpressionAttributeValue: n,
      mdxJsxTextTagAttributeNamePrimary: b,
      mdxJsxTextTagAttributeNameLocal: v,
      mdxJsxTextTagAttributeValueLiteral: w,
      mdxJsxTextTagAttributeValueLiteralValue: n,
      mdxJsxTextTagAttributeValueExpression: y,
      mdxJsxTextTagAttributeValueExpressionValue: n,
      mdxJsxTextTagSelfClosingMarker: I,
      mdxJsxTextTag: E
    }
  };
  function e() {
    this.buffer();
  }
  function t(C) {
    return { line: C.line, column: C.column, offset: C.offset };
  }
  function n(C) {
    this.config.enter.data.call(this, C), this.config.exit.data.call(this, C);
  }
  function i(C) {
    const L = {
      name: void 0,
      attributes: [],
      close: !1,
      selfClosing: !1,
      start: C.start,
      end: C.end
    };
    this.data.mdxJsxTagStack || (this.data.mdxJsxTagStack = []), this.data.mdxJsxTag = L, this.buffer();
  }
  function r(C) {
    if (this.data.mdxJsxTagStack.length === 0)
      throw new Xe(
        "Unexpected closing slash `/` in tag, expected an open tag first",
        { start: C.start, end: C.end },
        "mdast-util-mdx-jsx:unexpected-closing-slash"
      );
  }
  function a(C) {
    if (this.data.mdxJsxTag.close)
      throw new Xe(
        "Unexpected attribute in closing tag, expected the end of the tag",
        { start: C.start, end: C.end },
        "mdast-util-mdx-jsx:unexpected-attribute"
      );
  }
  function o(C) {
    if (this.data.mdxJsxTag.close)
      throw new Xe(
        "Unexpected self-closing slash `/` in closing tag, expected the end of the tag",
        { start: C.start, end: C.end },
        "mdast-util-mdx-jsx:unexpected-self-closing-slash"
      );
  }
  function l() {
    const C = this.data.mdxJsxTag;
    C.close = !0;
  }
  function u(C) {
    const L = this.data.mdxJsxTag;
    L.name = this.sliceSerialize(C);
  }
  function c(C) {
    const L = this.data.mdxJsxTag;
    L.name += "." + this.sliceSerialize(C);
  }
  function h(C) {
    const L = this.data.mdxJsxTag;
    L.name += ":" + this.sliceSerialize(C);
  }
  function p(C) {
    const L = this.data.mdxJsxTag;
    a.call(this, C), L.attributes.push({
      type: "mdxJsxAttribute",
      name: "",
      value: null,
      position: {
        start: t(C.start),
        // @ts-expect-error: `end` will be patched later.
        end: void 0
      }
    });
  }
  function m(C) {
    const L = this.data.mdxJsxTag;
    a.call(this, C), L.attributes.push({
      type: "mdxJsxExpressionAttribute",
      value: "",
      position: {
        start: t(C.start),
        // @ts-expect-error: `end` will be patched later.
        end: void 0
      }
    }), this.buffer();
  }
  function g(C) {
    const L = this.data.mdxJsxTag, F = L.attributes[L.attributes.length - 1];
    F.type;
    const M = C.estree;
    F.value = this.resume(), F.position, F.position.end = t(C.end), M && (F.data = { estree: M });
  }
  function b(C) {
    const L = this.data.mdxJsxTag, F = L.attributes[L.attributes.length - 1];
    F.type, F.name = this.sliceSerialize(C), F.position, F.position.end = t(C.end);
  }
  function v(C) {
    const L = this.data.mdxJsxTag, F = L.attributes[L.attributes.length - 1];
    F.type, F.name += ":" + this.sliceSerialize(C), F.position, F.position.end = t(C.end);
  }
  function w(C) {
    const L = this.data.mdxJsxTag, F = L.attributes[L.attributes.length - 1];
    F.value = a2(this.resume(), { nonTerminated: !1 }), F.position, F.position.end = t(C.end);
  }
  function y(C) {
    const L = this.data.mdxJsxTag, F = L.attributes[L.attributes.length - 1];
    F.type;
    const M = { type: "mdxJsxAttributeValueExpression", value: this.resume() }, z = C.estree;
    z && (M.data = { estree: z }), F.value = M, F.position, F.position.end = t(C.end);
  }
  function I() {
    const C = this.data.mdxJsxTag;
    C.selfClosing = !0;
  }
  function E(C) {
    const L = this.data.mdxJsxTag, F = this.data.mdxJsxTagStack, M = F[F.length - 1];
    if (L.close && M.name !== L.name)
      throw new Xe(
        "Unexpected closing tag `" + f(L) + "`, expected corresponding closing tag for `" + f(M) + "` (" + nn(M) + ")",
        { start: C.start, end: C.end },
        "mdast-util-mdx-jsx:end-tag-mismatch"
      );
    this.resume(), L.close ? F.pop() : this.enter(
      {
        type: C.type === "mdxJsxTextTag" ? "mdxJsxTextElement" : "mdxJsxFlowElement",
        name: L.name || null,
        attributes: L.attributes,
        children: []
      },
      C,
      P
    ), L.selfClosing || L.close ? this.exit(C, S) : F.push(L);
  }
  function P(C, L) {
    const F = this.data.mdxJsxTagStack, M = F[F.length - 1], z = C ? " before the end of `" + C.type + "`" : "", R = C ? { start: C.start, end: C.end } : void 0;
    throw new Xe(
      "Expected a closing tag for `" + f(M) + "` (" + nn({ start: L.start, end: L.end }) + ")" + z,
      R,
      "mdast-util-mdx-jsx:end-tag-mismatch"
    );
  }
  function S(C, L) {
    const F = this.data.mdxJsxTag;
    throw new Xe(
      "Expected the closing tag `" + f(F) + "` either after the end of `" + L.type + "` (" + nn(L.end) + ") or another opening tag after the start of `" + L.type + "` (" + nn(L.start) + ")",
      { start: C.start, end: C.end },
      "mdast-util-mdx-jsx:end-tag-mismatch"
    );
  }
  function f(C) {
    return "<" + (C.close ? "/" : "") + (C.name || "") + ">";
  }
}
function y2(e) {
  const t = e || {}, n = t.quote || '"', i = t.quoteSmart || !1, r = t.tightSelfClosing || !1, a = t.printWidth || Number.POSITIVE_INFINITY, o = n === '"' ? "'" : '"';
  if (n !== '"' && n !== "'")
    throw new Error(
      "Cannot serialize attribute values with `" + n + "` for `options.quote`, expected `\"`, or `'`"
    );
  return l.peek = v2, {
    handlers: {
      mdxJsxFlowElement: l,
      mdxJsxTextElement: l
    },
    unsafe: [
      { character: "<", inConstruct: ["phrasing"] },
      { atBreak: !0, character: "<" }
    ],
    // Always generate fenced code (never indented code).
    fences: !0,
    // Always generate links with resources (never autolinks).
    resourceLink: !0
  };
  function l(u, c, h, p) {
    const m = u.type === "mdxJsxFlowElement", g = u.name ? !u.children || u.children.length === 0 : !1, b = sh(h), v = ah(b), w = h.createTracker(p), y = h.createTracker(p), I = [], E = (m ? v : "") + "<" + (u.name || ""), P = h.enter(u.type);
    if (w.move(E), y.move(E), u.attributes && u.attributes.length > 0) {
      if (!u.name)
        throw new Error("Cannot serialize fragment w/ attributes");
      let F = -1;
      for (; ++F < u.attributes.length; ) {
        const M = u.attributes[F];
        let z;
        if (M.type === "mdxJsxExpressionAttribute")
          z = "{" + (M.value || "") + "}";
        else {
          if (!M.name)
            throw new Error("Cannot serialize attribute w/o name");
          const R = M.value, j = M.name;
          let H = "";
          if (R != null) if (typeof R == "object")
            H = "{" + (R.value || "") + "}";
          else {
            const O = i && ls(R, n) > ls(R, o) ? o : n;
            H = O + _2(R, { subset: [O] }) + O;
          }
          z = j + (H ? "=" : "") + H;
        }
        I.push(z);
      }
    }
    let S = !1;
    const f = I.join(" ");
    // Block:
    m && // Including a line ending (expressions).
    (/\r?\n|\r/.test(f) || // Current position (including `<tag`).
    w.current().now.column + // -1 because columns, +1 for ` ` before attributes.
    // Attributes joined by spaces.
    f.length + // ` />`.
    (g ? r ? 2 : 3 : 1) > a) && (S = !0);
    let C = w, L = E;
    if (S) {
      C = y;
      let F = -1;
      for (; ++F < I.length; )
        I[F] = v + rh + I[F];
      L += C.move(
        `
` + I.join(`
`) + `
` + v
      );
    } else f && (L += C.move(" " + f));
    return g && (L += C.move(
      (r || S ? "" : " ") + "/"
    )), L += C.move(">"), u.children && u.children.length > 0 && (u.type === "mdxJsxTextElement" ? L += C.move(
      h.containerPhrasing(u, {
        ...C.current(),
        before: ">",
        after: "<"
      })
    ) : (C.shift(2), L += C.move(`
`), L += C.move(b2(u, h, C.current())), L += C.move(`
`))), g || (L += C.move(
      (m ? v : "") + "</" + (u.name || "") + ">"
    )), P(), L;
  }
}
function b2(e, t, n) {
  const i = t.indexStack, r = e.children, a = t.createTracker(n), o = ah(sh(t)), l = [];
  let u = -1;
  for (i.push(-1); ++u < r.length; ) {
    const c = r[u];
    i[i.length - 1] = u;
    const h = { before: `
`, after: `
`, ...a.current() }, p = t.handle(c, e, t, h), m = c.type === "mdxJsxFlowElement" ? p : t.indentLines(p, function(g, b, v) {
      return (v ? "" : o) + g;
    });
    l.push(a.move(m)), c.type !== "list" && (t.bulletLastUsed = void 0), u < r.length - 1 && l.push(a.move(`

`));
  }
  return i.pop(), l.join("");
}
function sh(e) {
  let t = 0, n = e.stack.length;
  for (; --n > -1; ) {
    const i = e.stack[n];
    if (i === "blockquote" || i === "listItem") break;
    i === "mdxJsxFlowElement" && t++;
  }
  return t;
}
function ah(e) {
  return rh.repeat(e);
}
function v2() {
  return "<";
}
function w2() {
  return {
    enter: { mdxjsEsm: C2 },
    exit: { mdxjsEsm: S2, mdxjsEsmData: E2 }
  };
}
function k2() {
  return { handlers: { mdxjsEsm: A2 } };
}
function C2(e) {
  this.enter({ type: "mdxjsEsm", value: "" }, e), this.buffer();
}
function S2(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, this.exit(e);
  const i = e.estree;
  n.value = t, i && (n.data = { estree: i });
}
function E2(e) {
  this.config.enter.data.call(this, e), this.config.exit.data.call(this, e);
}
function A2(e) {
  return e.value || "";
}
function I2() {
  return [
    Ym(),
    x2(),
    w2()
  ];
}
function L2(e) {
  return {
    extensions: [
      Qm(),
      y2(e),
      k2()
    ]
  };
}
var P2 = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 7, 9, 32, 4, 318, 1, 80, 3, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 68, 8, 2, 0, 3, 0, 2, 3, 2, 4, 2, 0, 15, 1, 83, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 7, 19, 58, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 343, 9, 54, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 10, 5350, 0, 7, 14, 11465, 27, 2343, 9, 87, 9, 39, 4, 60, 6, 26, 9, 535, 9, 470, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4178, 9, 519, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 245, 1, 2, 9, 726, 6, 110, 6, 6, 9, 4759, 9, 787719, 239], oh = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 4, 51, 13, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 39, 27, 10, 22, 251, 41, 7, 1, 17, 2, 60, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 31, 9, 2, 0, 3, 0, 2, 37, 2, 0, 26, 0, 2, 0, 45, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 200, 32, 32, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 26, 3994, 6, 582, 6842, 29, 1763, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 433, 44, 212, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 42, 9, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 229, 29, 3, 0, 496, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 16, 621, 2467, 541, 1507, 4938, 6, 4191], T2 = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛ࢗ-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ೳഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ඁ-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-໎໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠏-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᪿ-ᫎᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿‌‍‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯・꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿･", lh = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲊᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꟍꟐꟑꟓꟕ-Ƛꟲ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", Ys = {
  3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
  5: "class enum extends super const export import",
  6: "enum",
  strict: "implements interface let package private protected public static yield",
  strictBind: "eval arguments"
}, Qs = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", N2 = {
  5: Qs,
  "5module": Qs + " export import",
  6: Qs + " const class extends export import super"
}, D2 = /^in(stanceof)?$/, V2 = new RegExp("[" + lh + "]"), M2 = new RegExp("[" + lh + T2 + "]");
function ja(e, t) {
  for (var n = 65536, i = 0; i < t.length; i += 2) {
    if (n += t[i], n > e)
      return !1;
    if (n += t[i + 1], n >= e)
      return !0;
  }
  return !1;
}
function wn(e, t) {
  return e < 65 ? e === 36 : e < 91 ? !0 : e < 97 ? e === 95 : e < 123 ? !0 : e <= 65535 ? e >= 170 && V2.test(String.fromCharCode(e)) : t === !1 ? !1 : ja(e, oh);
}
function Yn(e, t) {
  return e < 48 ? e === 36 : e < 58 ? !0 : e < 65 ? !1 : e < 91 ? !0 : e < 97 ? e === 95 : e < 123 ? !0 : e <= 65535 ? e >= 170 && M2.test(String.fromCharCode(e)) : t === !1 ? !1 : ja(e, oh) || ja(e, P2);
}
var We = function(t, n) {
  n === void 0 && (n = {}), this.label = t, this.keyword = n.keyword, this.beforeExpr = !!n.beforeExpr, this.startsExpr = !!n.startsExpr, this.isLoop = !!n.isLoop, this.isAssign = !!n.isAssign, this.prefix = !!n.prefix, this.postfix = !!n.postfix, this.binop = n.binop || null, this.updateContext = null;
};
function Yt(e, t) {
  return new We(e, { beforeExpr: !0, binop: t });
}
var Qt = { beforeExpr: !0 }, Ot = { startsExpr: !0 }, yo = {};
function He(e, t) {
  return t === void 0 && (t = {}), t.keyword = e, yo[e] = new We(e, t);
}
var A = {
  num: new We("num", Ot),
  regexp: new We("regexp", Ot),
  string: new We("string", Ot),
  name: new We("name", Ot),
  privateId: new We("privateId", Ot),
  eof: new We("eof"),
  // Punctuation token types.
  bracketL: new We("[", { beforeExpr: !0, startsExpr: !0 }),
  bracketR: new We("]"),
  braceL: new We("{", { beforeExpr: !0, startsExpr: !0 }),
  braceR: new We("}"),
  parenL: new We("(", { beforeExpr: !0, startsExpr: !0 }),
  parenR: new We(")"),
  comma: new We(",", Qt),
  semi: new We(";", Qt),
  colon: new We(":", Qt),
  dot: new We("."),
  question: new We("?", Qt),
  questionDot: new We("?."),
  arrow: new We("=>", Qt),
  template: new We("template"),
  invalidTemplate: new We("invalidTemplate"),
  ellipsis: new We("...", Qt),
  backQuote: new We("`", Ot),
  dollarBraceL: new We("${", { beforeExpr: !0, startsExpr: !0 }),
  // Operators. These carry several kinds of properties to help the
  // parser use them properly (the presence of these properties is
  // what categorizes them as operators).
  //
  // `binop`, when present, specifies that this operator is a binary
  // operator, and will refer to its precedence.
  //
  // `prefix` and `postfix` mark the operator as a prefix or postfix
  // unary operator.
  //
  // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
  // binary operators with a very low precedence, that should result
  // in AssignmentExpression nodes.
  eq: new We("=", { beforeExpr: !0, isAssign: !0 }),
  assign: new We("_=", { beforeExpr: !0, isAssign: !0 }),
  incDec: new We("++/--", { prefix: !0, postfix: !0, startsExpr: !0 }),
  prefix: new We("!/~", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
  logicalOR: Yt("||", 1),
  logicalAND: Yt("&&", 2),
  bitwiseOR: Yt("|", 3),
  bitwiseXOR: Yt("^", 4),
  bitwiseAND: Yt("&", 5),
  equality: Yt("==/!=/===/!==", 6),
  relational: Yt("</>/<=/>=", 7),
  bitShift: Yt("<</>>/>>>", 8),
  plusMin: new We("+/-", { beforeExpr: !0, binop: 9, prefix: !0, startsExpr: !0 }),
  modulo: Yt("%", 10),
  star: Yt("*", 10),
  slash: Yt("/", 10),
  starstar: new We("**", { beforeExpr: !0 }),
  coalesce: Yt("??", 1),
  // Keyword token types.
  _break: He("break"),
  _case: He("case", Qt),
  _catch: He("catch"),
  _continue: He("continue"),
  _debugger: He("debugger"),
  _default: He("default", Qt),
  _do: He("do", { isLoop: !0, beforeExpr: !0 }),
  _else: He("else", Qt),
  _finally: He("finally"),
  _for: He("for", { isLoop: !0 }),
  _function: He("function", Ot),
  _if: He("if"),
  _return: He("return", Qt),
  _switch: He("switch"),
  _throw: He("throw", Qt),
  _try: He("try"),
  _var: He("var"),
  _const: He("const"),
  _while: He("while", { isLoop: !0 }),
  _with: He("with"),
  _new: He("new", { beforeExpr: !0, startsExpr: !0 }),
  _this: He("this", Ot),
  _super: He("super", Ot),
  _class: He("class", Ot),
  _extends: He("extends", Qt),
  _export: He("export"),
  _import: He("import", Ot),
  _null: He("null", Ot),
  _true: He("true", Ot),
  _false: He("false", Ot),
  _in: He("in", { beforeExpr: !0, binop: 7 }),
  _instanceof: He("instanceof", { beforeExpr: !0, binop: 7 }),
  _typeof: He("typeof", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
  _void: He("void", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
  _delete: He("delete", { beforeExpr: !0, prefix: !0, startsExpr: !0 })
}, Ht = /\r\n?|\n|\u2028|\u2029/, F2 = new RegExp(Ht.source, "g");
function Ui(e) {
  return e === 10 || e === 13 || e === 8232 || e === 8233;
}
function uh(e, t, n) {
  n === void 0 && (n = e.length);
  for (var i = t; i < n; i++) {
    var r = e.charCodeAt(i);
    if (Ui(r))
      return i < n - 1 && r === 13 && e.charCodeAt(i + 1) === 10 ? i + 2 : i + 1;
  }
  return -1;
}
var ch = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, It = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, hh = Object.prototype, R2 = hh.hasOwnProperty, O2 = hh.toString, Ji = Object.hasOwn || (function(e, t) {
  return R2.call(e, t);
}), hu = Array.isArray || (function(e) {
  return O2.call(e) === "[object Array]";
}), pu = /* @__PURE__ */ Object.create(null);
function Zn(e) {
  return pu[e] || (pu[e] = new RegExp("^(?:" + e.replace(/ /g, "|") + ")$"));
}
function Rn(e) {
  return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode((e >> 10) + 55296, (e & 1023) + 56320));
}
var B2 = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, vr = function(t, n) {
  this.line = t, this.column = n;
};
vr.prototype.offset = function(t) {
  return new vr(this.line, this.column + t);
};
var ys = function(t, n, i) {
  this.start = n, this.end = i, t.sourceFile !== null && (this.source = t.sourceFile);
};
function ph(e, t) {
  for (var n = 1, i = 0; ; ) {
    var r = uh(e, i, t);
    if (r < 0)
      return new vr(n, t - i);
    ++n, i = r;
  }
}
var Ha = {
  // `ecmaVersion` indicates the ECMAScript version to parse. Must be
  // either 3, 5, 6 (or 2015), 7 (2016), 8 (2017), 9 (2018), 10
  // (2019), 11 (2020), 12 (2021), 13 (2022), 14 (2023), or `"latest"`
  // (the latest version the library supports). This influences
  // support for strict mode, the set of reserved words, and support
  // for new syntax features.
  ecmaVersion: null,
  // `sourceType` indicates the mode the code should be parsed in.
  // Can be either `"script"` or `"module"`. This influences global
  // strict mode and parsing of `import` and `export` declarations.
  sourceType: "script",
  // `onInsertedSemicolon` can be a callback that will be called when
  // a semicolon is automatically inserted. It will be passed the
  // position of the inserted semicolon as an offset, and if
  // `locations` is enabled, it is given the location as a `{line,
  // column}` object as second argument.
  onInsertedSemicolon: null,
  // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
  // trailing commas.
  onTrailingComma: null,
  // By default, reserved words are only enforced if ecmaVersion >= 5.
  // Set `allowReserved` to a boolean value to explicitly turn this on
  // an off. When this option has the value "never", reserved words
  // and keywords can also not be used as property names.
  allowReserved: null,
  // When enabled, a return at the top level is not considered an
  // error.
  allowReturnOutsideFunction: !1,
  // When enabled, import/export statements are not constrained to
  // appearing at the top of the program, and an import.meta expression
  // in a script isn't considered an error.
  allowImportExportEverywhere: !1,
  // By default, await identifiers are allowed to appear at the top-level scope only if ecmaVersion >= 2022.
  // When enabled, await identifiers are allowed to appear at the top-level scope,
  // but they are still not allowed in non-async functions.
  allowAwaitOutsideFunction: null,
  // When enabled, super identifiers are not constrained to
  // appearing in methods and do not raise an error when they appear elsewhere.
  allowSuperOutsideMethod: null,
  // When enabled, hashbang directive in the beginning of file is
  // allowed and treated as a line comment. Enabled by default when
  // `ecmaVersion` >= 2023.
  allowHashBang: !1,
  // By default, the parser will verify that private properties are
  // only used in places where they are valid and have been declared.
  // Set this to false to turn such checks off.
  checkPrivateFields: !0,
  // When `locations` is on, `loc` properties holding objects with
  // `start` and `end` properties in `{line, column}` form (with
  // line being 1-based and column 0-based) will be attached to the
  // nodes.
  locations: !1,
  // A function can be passed as `onToken` option, which will
  // cause Acorn to call that function with object in the same
  // format as tokens returned from `tokenizer().getToken()`. Note
  // that you are not allowed to call the parser from the
  // callback—that will corrupt its internal state.
  onToken: null,
  // A function can be passed as `onComment` option, which will
  // cause Acorn to call that function with `(block, text, start,
  // end)` parameters whenever a comment is skipped. `block` is a
  // boolean indicating whether this is a block (`/* */`) comment,
  // `text` is the content of the comment, and `start` and `end` are
  // character offsets that denote the start and end of the comment.
  // When the `locations` option is on, two more parameters are
  // passed, the full `{line, column}` locations of the start and
  // end of the comments. Note that you are not allowed to call the
  // parser from the callback—that will corrupt its internal state.
  // When this option has an array as value, objects representing the
  // comments are pushed to it.
  onComment: null,
  // Nodes have their start and end characters offsets recorded in
  // `start` and `end` properties (directly on the node, rather than
  // the `loc` object, which holds line/column data. To also add a
  // [semi-standardized][range] `range` property holding a `[start,
  // end]` array with the same numbers, set the `ranges` option to
  // `true`.
  //
  // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
  ranges: !1,
  // It is possible to parse multiple files into a single AST by
  // passing the tree produced by parsing the first file as
  // `program` option in subsequent parses. This will add the
  // toplevel forms of the parsed file to the `Program` (top) node
  // of an existing parse tree.
  program: null,
  // When `locations` is on, you can pass this to record the source
  // file in every node's `loc` object.
  sourceFile: null,
  // This value, if given, is stored in every node, whether
  // `locations` is on or off.
  directSourceFile: null,
  // When enabled, parenthesized expressions are represented by
  // (non-standard) ParenthesizedExpression nodes
  preserveParens: !1
}, du = !1;
function z2(e) {
  var t = {};
  for (var n in Ha)
    t[n] = e && Ji(e, n) ? e[n] : Ha[n];
  if (t.ecmaVersion === "latest" ? t.ecmaVersion = 1e8 : t.ecmaVersion == null ? (!du && typeof console == "object" && console.warn && (du = !0, console.warn(`Since Acorn 8.0.0, options.ecmaVersion is required.
Defaulting to 2020, but this will stop working in the future.`)), t.ecmaVersion = 11) : t.ecmaVersion >= 2015 && (t.ecmaVersion -= 2009), t.allowReserved == null && (t.allowReserved = t.ecmaVersion < 5), (!e || e.allowHashBang == null) && (t.allowHashBang = t.ecmaVersion >= 14), hu(t.onToken)) {
    var i = t.onToken;
    t.onToken = function(r) {
      return i.push(r);
    };
  }
  return hu(t.onComment) && (t.onComment = j2(t, t.onComment)), t;
}
function j2(e, t) {
  return function(n, i, r, a, o, l) {
    var u = {
      type: n ? "Block" : "Line",
      value: i,
      start: r,
      end: a
    };
    e.locations && (u.loc = new ys(this, o, l)), e.ranges && (u.range = [r, a]), t.push(u);
  };
}
var wr = 1, Wi = 2, bo = 4, dh = 8, vo = 16, fh = 32, bs = 64, mh = 128, gi = 256, Tr = 512, vs = wr | Wi | gi;
function wo(e, t) {
  return Wi | (e ? bo : 0) | (t ? dh : 0);
}
var us = 0, ko = 1, jn = 2, gh = 3, _h = 4, xh = 5, xt = function(t, n, i) {
  this.options = t = z2(t), this.sourceFile = t.sourceFile, this.keywords = Zn(N2[t.ecmaVersion >= 6 ? 6 : t.sourceType === "module" ? "5module" : 5]);
  var r = "";
  t.allowReserved !== !0 && (r = Ys[t.ecmaVersion >= 6 ? 6 : t.ecmaVersion === 5 ? 5 : 3], t.sourceType === "module" && (r += " await")), this.reservedWords = Zn(r);
  var a = (r ? r + " " : "") + Ys.strict;
  this.reservedWordsStrict = Zn(a), this.reservedWordsStrictBind = Zn(a + " " + Ys.strictBind), this.input = String(n), this.containsEsc = !1, i ? (this.pos = i, this.lineStart = this.input.lastIndexOf(`
`, i - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(Ht).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = A.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = t.sourceType === "module", this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.potentialArrowInForAwait = !1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = /* @__PURE__ */ Object.create(null), this.pos === 0 && t.allowHashBang && this.input.slice(0, 2) === "#!" && this.skipLineComment(2), this.scopeStack = [], this.enterScope(wr), this.regexpState = null, this.privateNameStack = [];
}, kn = { inFunction: { configurable: !0 }, inGenerator: { configurable: !0 }, inAsync: { configurable: !0 }, canAwait: { configurable: !0 }, allowSuper: { configurable: !0 }, allowDirectSuper: { configurable: !0 }, treatFunctionsAsVar: { configurable: !0 }, allowNewDotTarget: { configurable: !0 }, inClassStaticBlock: { configurable: !0 } };
xt.prototype.parse = function() {
  var t = this.options.program || this.startNode();
  return this.nextToken(), this.parseTopLevel(t);
};
kn.inFunction.get = function() {
  return (this.currentVarScope().flags & Wi) > 0;
};
kn.inGenerator.get = function() {
  return (this.currentVarScope().flags & dh) > 0;
};
kn.inAsync.get = function() {
  return (this.currentVarScope().flags & bo) > 0;
};
kn.canAwait.get = function() {
  for (var e = this.scopeStack.length - 1; e >= 0; e--) {
    var t = this.scopeStack[e], n = t.flags;
    if (n & (gi | Tr))
      return !1;
    if (n & Wi)
      return (n & bo) > 0;
  }
  return this.inModule && this.options.ecmaVersion >= 13 || this.options.allowAwaitOutsideFunction;
};
kn.allowSuper.get = function() {
  var e = this.currentThisScope(), t = e.flags;
  return (t & bs) > 0 || this.options.allowSuperOutsideMethod;
};
kn.allowDirectSuper.get = function() {
  return (this.currentThisScope().flags & mh) > 0;
};
kn.treatFunctionsAsVar.get = function() {
  return this.treatFunctionsAsVarInScope(this.currentScope());
};
kn.allowNewDotTarget.get = function() {
  for (var e = this.scopeStack.length - 1; e >= 0; e--) {
    var t = this.scopeStack[e], n = t.flags;
    if (n & (gi | Tr) || n & Wi && !(n & vo))
      return !0;
  }
  return !1;
};
kn.inClassStaticBlock.get = function() {
  return (this.currentVarScope().flags & gi) > 0;
};
xt.extend = function() {
  for (var t = [], n = arguments.length; n--; ) t[n] = arguments[n];
  for (var i = this, r = 0; r < t.length; r++)
    i = t[r](i);
  return i;
};
xt.parse = function(t, n) {
  return new this(n, t).parse();
};
xt.parseExpressionAt = function(t, n, i) {
  var r = new this(i, t, n);
  return r.nextToken(), r.parseExpression();
};
xt.tokenizer = function(t, n) {
  return new this(n, t);
};
Object.defineProperties(xt.prototype, kn);
var Ft = xt.prototype, H2 = /^(?:'((?:\\[^]|[^'\\])*?)'|"((?:\\[^]|[^"\\])*?)")/;
Ft.strictDirective = function(e) {
  if (this.options.ecmaVersion < 5)
    return !1;
  for (; ; ) {
    It.lastIndex = e, e += It.exec(this.input)[0].length;
    var t = H2.exec(this.input.slice(e));
    if (!t)
      return !1;
    if ((t[1] || t[2]) === "use strict") {
      It.lastIndex = e + t[0].length;
      var n = It.exec(this.input), i = n.index + n[0].length, r = this.input.charAt(i);
      return r === ";" || r === "}" || Ht.test(n[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(r) || r === "!" && this.input.charAt(i + 1) === "=");
    }
    e += t[0].length, It.lastIndex = e, e += It.exec(this.input)[0].length, this.input[e] === ";" && e++;
  }
};
Ft.eat = function(e) {
  return this.type === e ? (this.next(), !0) : !1;
};
Ft.isContextual = function(e) {
  return this.type === A.name && this.value === e && !this.containsEsc;
};
Ft.eatContextual = function(e) {
  return this.isContextual(e) ? (this.next(), !0) : !1;
};
Ft.expectContextual = function(e) {
  this.eatContextual(e) || this.unexpected();
};
Ft.canInsertSemicolon = function() {
  return this.type === A.eof || this.type === A.braceR || Ht.test(this.input.slice(this.lastTokEnd, this.start));
};
Ft.insertSemicolon = function() {
  if (this.canInsertSemicolon())
    return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
};
Ft.semicolon = function() {
  !this.eat(A.semi) && !this.insertSemicolon() && this.unexpected();
};
Ft.afterTrailingComma = function(e, t) {
  if (this.type === e)
    return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), t || this.next(), !0;
};
Ft.expect = function(e) {
  this.eat(e) || this.unexpected();
};
Ft.unexpected = function(e) {
  this.raise(e ?? this.start, "Unexpected token");
};
var ws = function() {
  this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
};
Ft.checkPatternErrors = function(e, t) {
  if (e) {
    e.trailingComma > -1 && this.raiseRecoverable(e.trailingComma, "Comma is not permitted after the rest element");
    var n = t ? e.parenthesizedAssign : e.parenthesizedBind;
    n > -1 && this.raiseRecoverable(n, t ? "Assigning to rvalue" : "Parenthesized pattern");
  }
};
Ft.checkExpressionErrors = function(e, t) {
  if (!e)
    return !1;
  var n = e.shorthandAssign, i = e.doubleProto;
  if (!t)
    return n >= 0 || i >= 0;
  n >= 0 && this.raise(n, "Shorthand property assignments are valid only in destructuring patterns"), i >= 0 && this.raiseRecoverable(i, "Redefinition of __proto__ property");
};
Ft.checkYieldAwaitInDefaultParams = function() {
  this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
};
Ft.isSimpleAssignTarget = function(e) {
  return e.type === "ParenthesizedExpression" ? this.isSimpleAssignTarget(e.expression) : e.type === "Identifier" || e.type === "MemberExpression";
};
var be = xt.prototype;
be.parseTopLevel = function(e) {
  var t = /* @__PURE__ */ Object.create(null);
  for (e.body || (e.body = []); this.type !== A.eof; ) {
    var n = this.parseStatement(null, !0, t);
    e.body.push(n);
  }
  if (this.inModule)
    for (var i = 0, r = Object.keys(this.undefinedExports); i < r.length; i += 1) {
      var a = r[i];
      this.raiseRecoverable(this.undefinedExports[a].start, "Export '" + a + "' is not defined");
    }
  return this.adaptDirectivePrologue(e.body), this.next(), e.sourceType = this.options.sourceType, this.finishNode(e, "Program");
};
var Co = { kind: "loop" }, $2 = { kind: "switch" };
be.isLet = function(e) {
  if (this.options.ecmaVersion < 6 || !this.isContextual("let"))
    return !1;
  It.lastIndex = this.pos;
  var t = It.exec(this.input), n = this.pos + t[0].length, i = this.input.charCodeAt(n);
  if (i === 91 || i === 92)
    return !0;
  if (e)
    return !1;
  if (i === 123 || i > 55295 && i < 56320)
    return !0;
  if (wn(i, !0)) {
    for (var r = n + 1; Yn(i = this.input.charCodeAt(r), !0); )
      ++r;
    if (i === 92 || i > 55295 && i < 56320)
      return !0;
    var a = this.input.slice(n, r);
    if (!D2.test(a))
      return !0;
  }
  return !1;
};
be.isAsyncFunction = function() {
  if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
    return !1;
  It.lastIndex = this.pos;
  var e = It.exec(this.input), t = this.pos + e[0].length, n;
  return !Ht.test(this.input.slice(this.pos, t)) && this.input.slice(t, t + 8) === "function" && (t + 8 === this.input.length || !(Yn(n = this.input.charCodeAt(t + 8)) || n > 55295 && n < 56320));
};
be.isUsingKeyword = function(e, t) {
  if (this.options.ecmaVersion < 17 || !this.isContextual(e ? "await" : "using"))
    return !1;
  It.lastIndex = this.pos;
  var n = It.exec(this.input), i = this.pos + n[0].length;
  if (Ht.test(this.input.slice(this.pos, i)))
    return !1;
  if (e) {
    var r = i + 5, a;
    if (this.input.slice(i, r) !== "using" || r === this.input.length || Yn(a = this.input.charCodeAt(r)) || a > 55295 && a < 56320)
      return !1;
    It.lastIndex = r;
    var o = It.exec(this.input);
    if (o && Ht.test(this.input.slice(r, r + o[0].length)))
      return !1;
  }
  if (t) {
    var l = i + 2, u;
    if (this.input.slice(i, l) === "of" && (l === this.input.length || !Yn(u = this.input.charCodeAt(l)) && !(u > 55295 && u < 56320)))
      return !1;
  }
  var c = this.input.charCodeAt(i);
  return wn(c, !0) || c === 92;
};
be.isAwaitUsing = function(e) {
  return this.isUsingKeyword(!0, e);
};
be.isUsing = function(e) {
  return this.isUsingKeyword(!1, e);
};
be.parseStatement = function(e, t, n) {
  var i = this.type, r = this.startNode(), a;
  switch (this.isLet(e) && (i = A._var, a = "let"), i) {
    case A._break:
    case A._continue:
      return this.parseBreakContinueStatement(r, i.keyword);
    case A._debugger:
      return this.parseDebuggerStatement(r);
    case A._do:
      return this.parseDoStatement(r);
    case A._for:
      return this.parseForStatement(r);
    case A._function:
      return e && (this.strict || e !== "if" && e !== "label") && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(r, !1, !e);
    case A._class:
      return e && this.unexpected(), this.parseClass(r, !0);
    case A._if:
      return this.parseIfStatement(r);
    case A._return:
      return this.parseReturnStatement(r);
    case A._switch:
      return this.parseSwitchStatement(r);
    case A._throw:
      return this.parseThrowStatement(r);
    case A._try:
      return this.parseTryStatement(r);
    case A._const:
    case A._var:
      return a = a || this.value, e && a !== "var" && this.unexpected(), this.parseVarStatement(r, a);
    case A._while:
      return this.parseWhileStatement(r);
    case A._with:
      return this.parseWithStatement(r);
    case A.braceL:
      return this.parseBlock(!0, r);
    case A.semi:
      return this.parseEmptyStatement(r);
    case A._export:
    case A._import:
      if (this.options.ecmaVersion > 10 && i === A._import) {
        It.lastIndex = this.pos;
        var o = It.exec(this.input), l = this.pos + o[0].length, u = this.input.charCodeAt(l);
        if (u === 40 || u === 46)
          return this.parseExpressionStatement(r, this.parseExpression());
      }
      return this.options.allowImportExportEverywhere || (t || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), i === A._import ? this.parseImport(r) : this.parseExport(r, n);
    // If the statement does not start with a statement keyword or a
    // brace, it's an ExpressionStatement or LabeledStatement. We
    // simply start parsing an expression, and afterwards, if the
    // next token is a colon and the expression was a simple
    // Identifier node, we switch to interpreting it as a label.
    default:
      if (this.isAsyncFunction())
        return e && this.unexpected(), this.next(), this.parseFunctionStatement(r, !0, !e);
      var c = this.isAwaitUsing(!1) ? "await using" : this.isUsing(!1) ? "using" : null;
      if (c)
        return t && this.options.sourceType === "script" && this.raise(this.start, "Using declaration cannot appear in the top level when source type is `script`"), c === "await using" && (this.canAwait || this.raise(this.start, "Await using cannot appear outside of async function"), this.next()), this.next(), this.parseVar(r, !1, c), this.semicolon(), this.finishNode(r, "VariableDeclaration");
      var h = this.value, p = this.parseExpression();
      return i === A.name && p.type === "Identifier" && this.eat(A.colon) ? this.parseLabeledStatement(r, h, p, e) : this.parseExpressionStatement(r, p);
  }
};
be.parseBreakContinueStatement = function(e, t) {
  var n = t === "break";
  this.next(), this.eat(A.semi) || this.insertSemicolon() ? e.label = null : this.type !== A.name ? this.unexpected() : (e.label = this.parseIdent(), this.semicolon());
  for (var i = 0; i < this.labels.length; ++i) {
    var r = this.labels[i];
    if ((e.label == null || r.name === e.label.name) && (r.kind != null && (n || r.kind === "loop") || e.label && n))
      break;
  }
  return i === this.labels.length && this.raise(e.start, "Unsyntactic " + t), this.finishNode(e, n ? "BreakStatement" : "ContinueStatement");
};
be.parseDebuggerStatement = function(e) {
  return this.next(), this.semicolon(), this.finishNode(e, "DebuggerStatement");
};
be.parseDoStatement = function(e) {
  return this.next(), this.labels.push(Co), e.body = this.parseStatement("do"), this.labels.pop(), this.expect(A._while), e.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(A.semi) : this.semicolon(), this.finishNode(e, "DoWhileStatement");
};
be.parseForStatement = function(e) {
  this.next();
  var t = this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual("await") ? this.lastTokStart : -1;
  if (this.labels.push(Co), this.enterScope(0), this.expect(A.parenL), this.type === A.semi)
    return t > -1 && this.unexpected(t), this.parseFor(e, null);
  var n = this.isLet();
  if (this.type === A._var || this.type === A._const || n) {
    var i = this.startNode(), r = n ? "let" : this.value;
    return this.next(), this.parseVar(i, !0, r), this.finishNode(i, "VariableDeclaration"), this.parseForAfterInit(e, i, t);
  }
  var a = this.isContextual("let"), o = !1, l = this.isUsing(!0) ? "using" : this.isAwaitUsing(!0) ? "await using" : null;
  if (l) {
    var u = this.startNode();
    return this.next(), l === "await using" && this.next(), this.parseVar(u, !0, l), this.finishNode(u, "VariableDeclaration"), this.parseForAfterInit(e, u, t);
  }
  var c = this.containsEsc, h = new ws(), p = this.start, m = t > -1 ? this.parseExprSubscripts(h, "await") : this.parseExpression(!0, h);
  return this.type === A._in || (o = this.options.ecmaVersion >= 6 && this.isContextual("of")) ? (t > -1 ? (this.type === A._in && this.unexpected(t), e.await = !0) : o && this.options.ecmaVersion >= 8 && (m.start === p && !c && m.type === "Identifier" && m.name === "async" ? this.unexpected() : this.options.ecmaVersion >= 9 && (e.await = !1)), a && o && this.raise(m.start, "The left-hand side of a for-of loop may not start with 'let'."), this.toAssignable(m, !1, h), this.checkLValPattern(m), this.parseForIn(e, m)) : (this.checkExpressionErrors(h, !0), t > -1 && this.unexpected(t), this.parseFor(e, m));
};
be.parseForAfterInit = function(e, t, n) {
  return (this.type === A._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && t.declarations.length === 1 ? (this.options.ecmaVersion >= 9 && (this.type === A._in ? n > -1 && this.unexpected(n) : e.await = n > -1), this.parseForIn(e, t)) : (n > -1 && this.unexpected(n), this.parseFor(e, t));
};
be.parseFunctionStatement = function(e, t, n) {
  return this.next(), this.parseFunction(e, mr | (n ? 0 : $a), !1, t);
};
be.parseIfStatement = function(e) {
  return this.next(), e.test = this.parseParenExpression(), e.consequent = this.parseStatement("if"), e.alternate = this.eat(A._else) ? this.parseStatement("if") : null, this.finishNode(e, "IfStatement");
};
be.parseReturnStatement = function(e) {
  return !this.inFunction && !this.options.allowReturnOutsideFunction && this.raise(this.start, "'return' outside of function"), this.next(), this.eat(A.semi) || this.insertSemicolon() ? e.argument = null : (e.argument = this.parseExpression(), this.semicolon()), this.finishNode(e, "ReturnStatement");
};
be.parseSwitchStatement = function(e) {
  this.next(), e.discriminant = this.parseParenExpression(), e.cases = [], this.expect(A.braceL), this.labels.push($2), this.enterScope(0);
  for (var t, n = !1; this.type !== A.braceR; )
    if (this.type === A._case || this.type === A._default) {
      var i = this.type === A._case;
      t && this.finishNode(t, "SwitchCase"), e.cases.push(t = this.startNode()), t.consequent = [], this.next(), i ? t.test = this.parseExpression() : (n && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), n = !0, t.test = null), this.expect(A.colon);
    } else
      t || this.unexpected(), t.consequent.push(this.parseStatement(null));
  return this.exitScope(), t && this.finishNode(t, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(e, "SwitchStatement");
};
be.parseThrowStatement = function(e) {
  return this.next(), Ht.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), e.argument = this.parseExpression(), this.semicolon(), this.finishNode(e, "ThrowStatement");
};
var q2 = [];
be.parseCatchClauseParam = function() {
  var e = this.parseBindingAtom(), t = e.type === "Identifier";
  return this.enterScope(t ? fh : 0), this.checkLValPattern(e, t ? _h : jn), this.expect(A.parenR), e;
};
be.parseTryStatement = function(e) {
  if (this.next(), e.block = this.parseBlock(), e.handler = null, this.type === A._catch) {
    var t = this.startNode();
    this.next(), this.eat(A.parenL) ? t.param = this.parseCatchClauseParam() : (this.options.ecmaVersion < 10 && this.unexpected(), t.param = null, this.enterScope(0)), t.body = this.parseBlock(!1), this.exitScope(), e.handler = this.finishNode(t, "CatchClause");
  }
  return e.finalizer = this.eat(A._finally) ? this.parseBlock() : null, !e.handler && !e.finalizer && this.raise(e.start, "Missing catch or finally clause"), this.finishNode(e, "TryStatement");
};
be.parseVarStatement = function(e, t, n) {
  return this.next(), this.parseVar(e, !1, t, n), this.semicolon(), this.finishNode(e, "VariableDeclaration");
};
be.parseWhileStatement = function(e) {
  return this.next(), e.test = this.parseParenExpression(), this.labels.push(Co), e.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(e, "WhileStatement");
};
be.parseWithStatement = function(e) {
  return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), e.object = this.parseParenExpression(), e.body = this.parseStatement("with"), this.finishNode(e, "WithStatement");
};
be.parseEmptyStatement = function(e) {
  return this.next(), this.finishNode(e, "EmptyStatement");
};
be.parseLabeledStatement = function(e, t, n, i) {
  for (var r = 0, a = this.labels; r < a.length; r += 1) {
    var o = a[r];
    o.name === t && this.raise(n.start, "Label '" + t + "' is already declared");
  }
  for (var l = this.type.isLoop ? "loop" : this.type === A._switch ? "switch" : null, u = this.labels.length - 1; u >= 0; u--) {
    var c = this.labels[u];
    if (c.statementStart === e.start)
      c.statementStart = this.start, c.kind = l;
    else
      break;
  }
  return this.labels.push({ name: t, kind: l, statementStart: this.start }), e.body = this.parseStatement(i ? i.indexOf("label") === -1 ? i + "label" : i : "label"), this.labels.pop(), e.label = n, this.finishNode(e, "LabeledStatement");
};
be.parseExpressionStatement = function(e, t) {
  return e.expression = t, this.semicolon(), this.finishNode(e, "ExpressionStatement");
};
be.parseBlock = function(e, t, n) {
  for (e === void 0 && (e = !0), t === void 0 && (t = this.startNode()), t.body = [], this.expect(A.braceL), e && this.enterScope(0); this.type !== A.braceR; ) {
    var i = this.parseStatement(null);
    t.body.push(i);
  }
  return n && (this.strict = !1), this.next(), e && this.exitScope(), this.finishNode(t, "BlockStatement");
};
be.parseFor = function(e, t) {
  return e.init = t, this.expect(A.semi), e.test = this.type === A.semi ? null : this.parseExpression(), this.expect(A.semi), e.update = this.type === A.parenR ? null : this.parseExpression(), this.expect(A.parenR), e.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e, "ForStatement");
};
be.parseForIn = function(e, t) {
  var n = this.type === A._in;
  return this.next(), t.type === "VariableDeclaration" && t.declarations[0].init != null && (!n || this.options.ecmaVersion < 8 || this.strict || t.kind !== "var" || t.declarations[0].id.type !== "Identifier") && this.raise(
    t.start,
    (n ? "for-in" : "for-of") + " loop variable declaration may not have an initializer"
  ), e.left = t, e.right = n ? this.parseExpression() : this.parseMaybeAssign(), this.expect(A.parenR), e.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e, n ? "ForInStatement" : "ForOfStatement");
};
be.parseVar = function(e, t, n, i) {
  for (e.declarations = [], e.kind = n; ; ) {
    var r = this.startNode();
    if (this.parseVarId(r, n), this.eat(A.eq) ? r.init = this.parseMaybeAssign(t) : !i && n === "const" && !(this.type === A._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) ? this.unexpected() : !i && (n === "using" || n === "await using") && this.options.ecmaVersion >= 17 && this.type !== A._in && !this.isContextual("of") ? this.raise(this.lastTokEnd, "Missing initializer in " + n + " declaration") : !i && r.id.type !== "Identifier" && !(t && (this.type === A._in || this.isContextual("of"))) ? this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : r.init = null, e.declarations.push(this.finishNode(r, "VariableDeclarator")), !this.eat(A.comma))
      break;
  }
  return e;
};
be.parseVarId = function(e, t) {
  e.id = t === "using" || t === "await using" ? this.parseIdent() : this.parseBindingAtom(), this.checkLValPattern(e.id, t === "var" ? ko : jn, !1);
};
var mr = 1, $a = 2, yh = 4;
be.parseFunction = function(e, t, n, i, r) {
  this.initFunction(e), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !i) && (this.type === A.star && t & $a && this.unexpected(), e.generator = this.eat(A.star)), this.options.ecmaVersion >= 8 && (e.async = !!i), t & mr && (e.id = t & yh && this.type !== A.name ? null : this.parseIdent(), e.id && !(t & $a) && this.checkLValSimple(e.id, this.strict || e.generator || e.async ? this.treatFunctionsAsVar ? ko : jn : gh));
  var a = this.yieldPos, o = this.awaitPos, l = this.awaitIdentPos;
  return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(wo(e.async, e.generator)), t & mr || (e.id = this.type === A.name ? this.parseIdent() : null), this.parseFunctionParams(e), this.parseFunctionBody(e, n, !1, r), this.yieldPos = a, this.awaitPos = o, this.awaitIdentPos = l, this.finishNode(e, t & mr ? "FunctionDeclaration" : "FunctionExpression");
};
be.parseFunctionParams = function(e) {
  this.expect(A.parenL), e.params = this.parseBindingList(A.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
};
be.parseClass = function(e, t) {
  this.next();
  var n = this.strict;
  this.strict = !0, this.parseClassId(e, t), this.parseClassSuper(e);
  var i = this.enterClassBody(), r = this.startNode(), a = !1;
  for (r.body = [], this.expect(A.braceL); this.type !== A.braceR; ) {
    var o = this.parseClassElement(e.superClass !== null);
    o && (r.body.push(o), o.type === "MethodDefinition" && o.kind === "constructor" ? (a && this.raiseRecoverable(o.start, "Duplicate constructor in the same class"), a = !0) : o.key && o.key.type === "PrivateIdentifier" && U2(i, o) && this.raiseRecoverable(o.key.start, "Identifier '#" + o.key.name + "' has already been declared"));
  }
  return this.strict = n, this.next(), e.body = this.finishNode(r, "ClassBody"), this.exitClassBody(), this.finishNode(e, t ? "ClassDeclaration" : "ClassExpression");
};
be.parseClassElement = function(e) {
  if (this.eat(A.semi))
    return null;
  var t = this.options.ecmaVersion, n = this.startNode(), i = "", r = !1, a = !1, o = "method", l = !1;
  if (this.eatContextual("static")) {
    if (t >= 13 && this.eat(A.braceL))
      return this.parseClassStaticBlock(n), n;
    this.isClassElementNameStart() || this.type === A.star ? l = !0 : i = "static";
  }
  if (n.static = l, !i && t >= 8 && this.eatContextual("async") && ((this.isClassElementNameStart() || this.type === A.star) && !this.canInsertSemicolon() ? a = !0 : i = "async"), !i && (t >= 9 || !a) && this.eat(A.star) && (r = !0), !i && !a && !r) {
    var u = this.value;
    (this.eatContextual("get") || this.eatContextual("set")) && (this.isClassElementNameStart() ? o = u : i = u);
  }
  if (i ? (n.computed = !1, n.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc), n.key.name = i, this.finishNode(n.key, "Identifier")) : this.parseClassElementName(n), t < 13 || this.type === A.parenL || o !== "method" || r || a) {
    var c = !n.static && cs(n, "constructor"), h = c && e;
    c && o !== "method" && this.raise(n.key.start, "Constructor can't have get/set modifier"), n.kind = c ? "constructor" : o, this.parseClassMethod(n, r, a, h);
  } else
    this.parseClassField(n);
  return n;
};
be.isClassElementNameStart = function() {
  return this.type === A.name || this.type === A.privateId || this.type === A.num || this.type === A.string || this.type === A.bracketL || this.type.keyword;
};
be.parseClassElementName = function(e) {
  this.type === A.privateId ? (this.value === "constructor" && this.raise(this.start, "Classes can't have an element named '#constructor'"), e.computed = !1, e.key = this.parsePrivateIdent()) : this.parsePropertyName(e);
};
be.parseClassMethod = function(e, t, n, i) {
  var r = e.key;
  e.kind === "constructor" ? (t && this.raise(r.start, "Constructor can't be a generator"), n && this.raise(r.start, "Constructor can't be an async method")) : e.static && cs(e, "prototype") && this.raise(r.start, "Classes may not have a static property named prototype");
  var a = e.value = this.parseMethod(t, n, i);
  return e.kind === "get" && a.params.length !== 0 && this.raiseRecoverable(a.start, "getter should have no params"), e.kind === "set" && a.params.length !== 1 && this.raiseRecoverable(a.start, "setter should have exactly one param"), e.kind === "set" && a.params[0].type === "RestElement" && this.raiseRecoverable(a.params[0].start, "Setter cannot use rest params"), this.finishNode(e, "MethodDefinition");
};
be.parseClassField = function(e) {
  return cs(e, "constructor") ? this.raise(e.key.start, "Classes can't have a field named 'constructor'") : e.static && cs(e, "prototype") && this.raise(e.key.start, "Classes can't have a static field named 'prototype'"), this.eat(A.eq) ? (this.enterScope(Tr | bs), e.value = this.parseMaybeAssign(), this.exitScope()) : e.value = null, this.semicolon(), this.finishNode(e, "PropertyDefinition");
};
be.parseClassStaticBlock = function(e) {
  e.body = [];
  var t = this.labels;
  for (this.labels = [], this.enterScope(gi | bs); this.type !== A.braceR; ) {
    var n = this.parseStatement(null);
    e.body.push(n);
  }
  return this.next(), this.exitScope(), this.labels = t, this.finishNode(e, "StaticBlock");
};
be.parseClassId = function(e, t) {
  this.type === A.name ? (e.id = this.parseIdent(), t && this.checkLValSimple(e.id, jn, !1)) : (t === !0 && this.unexpected(), e.id = null);
};
be.parseClassSuper = function(e) {
  e.superClass = this.eat(A._extends) ? this.parseExprSubscripts(null, !1) : null;
};
be.enterClassBody = function() {
  var e = { declared: /* @__PURE__ */ Object.create(null), used: [] };
  return this.privateNameStack.push(e), e.declared;
};
be.exitClassBody = function() {
  var e = this.privateNameStack.pop(), t = e.declared, n = e.used;
  if (this.options.checkPrivateFields)
    for (var i = this.privateNameStack.length, r = i === 0 ? null : this.privateNameStack[i - 1], a = 0; a < n.length; ++a) {
      var o = n[a];
      Ji(t, o.name) || (r ? r.used.push(o) : this.raiseRecoverable(o.start, "Private field '#" + o.name + "' must be declared in an enclosing class"));
    }
};
function U2(e, t) {
  var n = t.key.name, i = e[n], r = "true";
  return t.type === "MethodDefinition" && (t.kind === "get" || t.kind === "set") && (r = (t.static ? "s" : "i") + t.kind), i === "iget" && r === "iset" || i === "iset" && r === "iget" || i === "sget" && r === "sset" || i === "sset" && r === "sget" ? (e[n] = "true", !1) : i ? !0 : (e[n] = r, !1);
}
function cs(e, t) {
  var n = e.computed, i = e.key;
  return !n && (i.type === "Identifier" && i.name === t || i.type === "Literal" && i.value === t);
}
be.parseExportAllDeclaration = function(e, t) {
  return this.options.ecmaVersion >= 11 && (this.eatContextual("as") ? (e.exported = this.parseModuleExportName(), this.checkExport(t, e.exported, this.lastTokStart)) : e.exported = null), this.expectContextual("from"), this.type !== A.string && this.unexpected(), e.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (e.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(e, "ExportAllDeclaration");
};
be.parseExport = function(e, t) {
  if (this.next(), this.eat(A.star))
    return this.parseExportAllDeclaration(e, t);
  if (this.eat(A._default))
    return this.checkExport(t, "default", this.lastTokStart), e.declaration = this.parseExportDefaultDeclaration(), this.finishNode(e, "ExportDefaultDeclaration");
  if (this.shouldParseExportStatement())
    e.declaration = this.parseExportDeclaration(e), e.declaration.type === "VariableDeclaration" ? this.checkVariableExport(t, e.declaration.declarations) : this.checkExport(t, e.declaration.id, e.declaration.id.start), e.specifiers = [], e.source = null, this.options.ecmaVersion >= 16 && (e.attributes = []);
  else {
    if (e.declaration = null, e.specifiers = this.parseExportSpecifiers(t), this.eatContextual("from"))
      this.type !== A.string && this.unexpected(), e.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (e.attributes = this.parseWithClause());
    else {
      for (var n = 0, i = e.specifiers; n < i.length; n += 1) {
        var r = i[n];
        this.checkUnreserved(r.local), this.checkLocalExport(r.local), r.local.type === "Literal" && this.raise(r.local.start, "A string literal cannot be used as an exported binding without `from`.");
      }
      e.source = null, this.options.ecmaVersion >= 16 && (e.attributes = []);
    }
    this.semicolon();
  }
  return this.finishNode(e, "ExportNamedDeclaration");
};
be.parseExportDeclaration = function(e) {
  return this.parseStatement(null);
};
be.parseExportDefaultDeclaration = function() {
  var e;
  if (this.type === A._function || (e = this.isAsyncFunction())) {
    var t = this.startNode();
    return this.next(), e && this.next(), this.parseFunction(t, mr | yh, !1, e);
  } else if (this.type === A._class) {
    var n = this.startNode();
    return this.parseClass(n, "nullableID");
  } else {
    var i = this.parseMaybeAssign();
    return this.semicolon(), i;
  }
};
be.checkExport = function(e, t, n) {
  e && (typeof t != "string" && (t = t.type === "Identifier" ? t.name : t.value), Ji(e, t) && this.raiseRecoverable(n, "Duplicate export '" + t + "'"), e[t] = !0);
};
be.checkPatternExport = function(e, t) {
  var n = t.type;
  if (n === "Identifier")
    this.checkExport(e, t, t.start);
  else if (n === "ObjectPattern")
    for (var i = 0, r = t.properties; i < r.length; i += 1) {
      var a = r[i];
      this.checkPatternExport(e, a);
    }
  else if (n === "ArrayPattern")
    for (var o = 0, l = t.elements; o < l.length; o += 1) {
      var u = l[o];
      u && this.checkPatternExport(e, u);
    }
  else n === "Property" ? this.checkPatternExport(e, t.value) : n === "AssignmentPattern" ? this.checkPatternExport(e, t.left) : n === "RestElement" && this.checkPatternExport(e, t.argument);
};
be.checkVariableExport = function(e, t) {
  if (e)
    for (var n = 0, i = t; n < i.length; n += 1) {
      var r = i[n];
      this.checkPatternExport(e, r.id);
    }
};
be.shouldParseExportStatement = function() {
  return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
};
be.parseExportSpecifier = function(e) {
  var t = this.startNode();
  return t.local = this.parseModuleExportName(), t.exported = this.eatContextual("as") ? this.parseModuleExportName() : t.local, this.checkExport(
    e,
    t.exported,
    t.exported.start
  ), this.finishNode(t, "ExportSpecifier");
};
be.parseExportSpecifiers = function(e) {
  var t = [], n = !0;
  for (this.expect(A.braceL); !this.eat(A.braceR); ) {
    if (n)
      n = !1;
    else if (this.expect(A.comma), this.afterTrailingComma(A.braceR))
      break;
    t.push(this.parseExportSpecifier(e));
  }
  return t;
};
be.parseImport = function(e) {
  return this.next(), this.type === A.string ? (e.specifiers = q2, e.source = this.parseExprAtom()) : (e.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), e.source = this.type === A.string ? this.parseExprAtom() : this.unexpected()), this.options.ecmaVersion >= 16 && (e.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(e, "ImportDeclaration");
};
be.parseImportSpecifier = function() {
  var e = this.startNode();
  return e.imported = this.parseModuleExportName(), this.eatContextual("as") ? e.local = this.parseIdent() : (this.checkUnreserved(e.imported), e.local = e.imported), this.checkLValSimple(e.local, jn), this.finishNode(e, "ImportSpecifier");
};
be.parseImportDefaultSpecifier = function() {
  var e = this.startNode();
  return e.local = this.parseIdent(), this.checkLValSimple(e.local, jn), this.finishNode(e, "ImportDefaultSpecifier");
};
be.parseImportNamespaceSpecifier = function() {
  var e = this.startNode();
  return this.next(), this.expectContextual("as"), e.local = this.parseIdent(), this.checkLValSimple(e.local, jn), this.finishNode(e, "ImportNamespaceSpecifier");
};
be.parseImportSpecifiers = function() {
  var e = [], t = !0;
  if (this.type === A.name && (e.push(this.parseImportDefaultSpecifier()), !this.eat(A.comma)))
    return e;
  if (this.type === A.star)
    return e.push(this.parseImportNamespaceSpecifier()), e;
  for (this.expect(A.braceL); !this.eat(A.braceR); ) {
    if (t)
      t = !1;
    else if (this.expect(A.comma), this.afterTrailingComma(A.braceR))
      break;
    e.push(this.parseImportSpecifier());
  }
  return e;
};
be.parseWithClause = function() {
  var e = [];
  if (!this.eat(A._with))
    return e;
  this.expect(A.braceL);
  for (var t = {}, n = !0; !this.eat(A.braceR); ) {
    if (n)
      n = !1;
    else if (this.expect(A.comma), this.afterTrailingComma(A.braceR))
      break;
    var i = this.parseImportAttribute(), r = i.key.type === "Identifier" ? i.key.name : i.key.value;
    Ji(t, r) && this.raiseRecoverable(i.key.start, "Duplicate attribute key '" + r + "'"), t[r] = !0, e.push(i);
  }
  return e;
};
be.parseImportAttribute = function() {
  var e = this.startNode();
  return e.key = this.type === A.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never"), this.expect(A.colon), this.type !== A.string && this.unexpected(), e.value = this.parseExprAtom(), this.finishNode(e, "ImportAttribute");
};
be.parseModuleExportName = function() {
  if (this.options.ecmaVersion >= 13 && this.type === A.string) {
    var e = this.parseLiteral(this.value);
    return B2.test(e.value) && this.raise(e.start, "An export name cannot include a lone surrogate."), e;
  }
  return this.parseIdent(!0);
};
be.adaptDirectivePrologue = function(e) {
  for (var t = 0; t < e.length && this.isDirectiveCandidate(e[t]); ++t)
    e[t].directive = e[t].expression.raw.slice(1, -1);
};
be.isDirectiveCandidate = function(e) {
  return this.options.ecmaVersion >= 5 && e.type === "ExpressionStatement" && e.expression.type === "Literal" && typeof e.expression.value == "string" && // Reject parenthesized strings.
  (this.input[e.start] === '"' || this.input[e.start] === "'");
};
var rn = xt.prototype;
rn.toAssignable = function(e, t, n) {
  if (this.options.ecmaVersion >= 6 && e)
    switch (e.type) {
      case "Identifier":
        this.inAsync && e.name === "await" && this.raise(e.start, "Cannot use 'await' as identifier inside an async function");
        break;
      case "ObjectPattern":
      case "ArrayPattern":
      case "AssignmentPattern":
      case "RestElement":
        break;
      case "ObjectExpression":
        e.type = "ObjectPattern", n && this.checkPatternErrors(n, !0);
        for (var i = 0, r = e.properties; i < r.length; i += 1) {
          var a = r[i];
          this.toAssignable(a, t), a.type === "RestElement" && (a.argument.type === "ArrayPattern" || a.argument.type === "ObjectPattern") && this.raise(a.argument.start, "Unexpected token");
        }
        break;
      case "Property":
        e.kind !== "init" && this.raise(e.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(e.value, t);
        break;
      case "ArrayExpression":
        e.type = "ArrayPattern", n && this.checkPatternErrors(n, !0), this.toAssignableList(e.elements, t);
        break;
      case "SpreadElement":
        e.type = "RestElement", this.toAssignable(e.argument, t), e.argument.type === "AssignmentPattern" && this.raise(e.argument.start, "Rest elements cannot have a default value");
        break;
      case "AssignmentExpression":
        e.operator !== "=" && this.raise(e.left.end, "Only '=' operator can be used for specifying default value."), e.type = "AssignmentPattern", delete e.operator, this.toAssignable(e.left, t);
        break;
      case "ParenthesizedExpression":
        this.toAssignable(e.expression, t, n);
        break;
      case "ChainExpression":
        this.raiseRecoverable(e.start, "Optional chaining cannot appear in left-hand side");
        break;
      case "MemberExpression":
        if (!t)
          break;
      default:
        this.raise(e.start, "Assigning to rvalue");
    }
  else n && this.checkPatternErrors(n, !0);
  return e;
};
rn.toAssignableList = function(e, t) {
  for (var n = e.length, i = 0; i < n; i++) {
    var r = e[i];
    r && this.toAssignable(r, t);
  }
  if (n) {
    var a = e[n - 1];
    this.options.ecmaVersion === 6 && t && a && a.type === "RestElement" && a.argument.type !== "Identifier" && this.unexpected(a.argument.start);
  }
  return e;
};
rn.parseSpread = function(e) {
  var t = this.startNode();
  return this.next(), t.argument = this.parseMaybeAssign(!1, e), this.finishNode(t, "SpreadElement");
};
rn.parseRestBinding = function() {
  var e = this.startNode();
  return this.next(), this.options.ecmaVersion === 6 && this.type !== A.name && this.unexpected(), e.argument = this.parseBindingAtom(), this.finishNode(e, "RestElement");
};
rn.parseBindingAtom = function() {
  if (this.options.ecmaVersion >= 6)
    switch (this.type) {
      case A.bracketL:
        var e = this.startNode();
        return this.next(), e.elements = this.parseBindingList(A.bracketR, !0, !0), this.finishNode(e, "ArrayPattern");
      case A.braceL:
        return this.parseObj(!0);
    }
  return this.parseIdent();
};
rn.parseBindingList = function(e, t, n, i) {
  for (var r = [], a = !0; !this.eat(e); )
    if (a ? a = !1 : this.expect(A.comma), t && this.type === A.comma)
      r.push(null);
    else {
      if (n && this.afterTrailingComma(e))
        break;
      if (this.type === A.ellipsis) {
        var o = this.parseRestBinding();
        this.parseBindingListItem(o), r.push(o), this.type === A.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.expect(e);
        break;
      } else
        r.push(this.parseAssignableListItem(i));
    }
  return r;
};
rn.parseAssignableListItem = function(e) {
  var t = this.parseMaybeDefault(this.start, this.startLoc);
  return this.parseBindingListItem(t), t;
};
rn.parseBindingListItem = function(e) {
  return e;
};
rn.parseMaybeDefault = function(e, t, n) {
  if (n = n || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(A.eq))
    return n;
  var i = this.startNodeAt(e, t);
  return i.left = n, i.right = this.parseMaybeAssign(), this.finishNode(i, "AssignmentPattern");
};
rn.checkLValSimple = function(e, t, n) {
  t === void 0 && (t = us);
  var i = t !== us;
  switch (e.type) {
    case "Identifier":
      this.strict && this.reservedWordsStrictBind.test(e.name) && this.raiseRecoverable(e.start, (i ? "Binding " : "Assigning to ") + e.name + " in strict mode"), i && (t === jn && e.name === "let" && this.raiseRecoverable(e.start, "let is disallowed as a lexically bound name"), n && (Ji(n, e.name) && this.raiseRecoverable(e.start, "Argument name clash"), n[e.name] = !0), t !== xh && this.declareName(e.name, t, e.start));
      break;
    case "ChainExpression":
      this.raiseRecoverable(e.start, "Optional chaining cannot appear in left-hand side");
      break;
    case "MemberExpression":
      i && this.raiseRecoverable(e.start, "Binding member expression");
      break;
    case "ParenthesizedExpression":
      return i && this.raiseRecoverable(e.start, "Binding parenthesized expression"), this.checkLValSimple(e.expression, t, n);
    default:
      this.raise(e.start, (i ? "Binding" : "Assigning to") + " rvalue");
  }
};
rn.checkLValPattern = function(e, t, n) {
  switch (t === void 0 && (t = us), e.type) {
    case "ObjectPattern":
      for (var i = 0, r = e.properties; i < r.length; i += 1) {
        var a = r[i];
        this.checkLValInnerPattern(a, t, n);
      }
      break;
    case "ArrayPattern":
      for (var o = 0, l = e.elements; o < l.length; o += 1) {
        var u = l[o];
        u && this.checkLValInnerPattern(u, t, n);
      }
      break;
    default:
      this.checkLValSimple(e, t, n);
  }
};
rn.checkLValInnerPattern = function(e, t, n) {
  switch (t === void 0 && (t = us), e.type) {
    case "Property":
      this.checkLValInnerPattern(e.value, t, n);
      break;
    case "AssignmentPattern":
      this.checkLValPattern(e.left, t, n);
      break;
    case "RestElement":
      this.checkLValPattern(e.argument, t, n);
      break;
    default:
      this.checkLValPattern(e, t, n);
  }
};
var an = function(t, n, i, r, a) {
  this.token = t, this.isExpr = !!n, this.preserveSpace = !!i, this.override = r, this.generator = !!a;
}, rt = {
  b_stat: new an("{", !1),
  b_expr: new an("{", !0),
  b_tmpl: new an("${", !1),
  p_stat: new an("(", !1),
  p_expr: new an("(", !0),
  q_tmpl: new an("`", !0, !0, function(e) {
    return e.tryReadTemplateToken();
  }),
  f_stat: new an("function", !1),
  f_expr: new an("function", !0),
  f_expr_gen: new an("function", !0, !1, null, !0),
  f_gen: new an("function", !1, !1, null, !0)
}, Xi = xt.prototype;
Xi.initialContext = function() {
  return [rt.b_stat];
};
Xi.curContext = function() {
  return this.context[this.context.length - 1];
};
Xi.braceIsBlock = function(e) {
  var t = this.curContext();
  return t === rt.f_expr || t === rt.f_stat ? !0 : e === A.colon && (t === rt.b_stat || t === rt.b_expr) ? !t.isExpr : e === A._return || e === A.name && this.exprAllowed ? Ht.test(this.input.slice(this.lastTokEnd, this.start)) : e === A._else || e === A.semi || e === A.eof || e === A.parenR || e === A.arrow ? !0 : e === A.braceL ? t === rt.b_stat : e === A._var || e === A._const || e === A.name ? !1 : !this.exprAllowed;
};
Xi.inGeneratorContext = function() {
  for (var e = this.context.length - 1; e >= 1; e--) {
    var t = this.context[e];
    if (t.token === "function")
      return t.generator;
  }
  return !1;
};
Xi.updateContext = function(e) {
  var t, n = this.type;
  n.keyword && e === A.dot ? this.exprAllowed = !1 : (t = n.updateContext) ? t.call(this, e) : this.exprAllowed = n.beforeExpr;
};
Xi.overrideContext = function(e) {
  this.curContext() !== e && (this.context[this.context.length - 1] = e);
};
A.parenR.updateContext = A.braceR.updateContext = function() {
  if (this.context.length === 1) {
    this.exprAllowed = !0;
    return;
  }
  var e = this.context.pop();
  e === rt.b_stat && this.curContext().token === "function" && (e = this.context.pop()), this.exprAllowed = !e.isExpr;
};
A.braceL.updateContext = function(e) {
  this.context.push(this.braceIsBlock(e) ? rt.b_stat : rt.b_expr), this.exprAllowed = !0;
};
A.dollarBraceL.updateContext = function() {
  this.context.push(rt.b_tmpl), this.exprAllowed = !0;
};
A.parenL.updateContext = function(e) {
  var t = e === A._if || e === A._for || e === A._with || e === A._while;
  this.context.push(t ? rt.p_stat : rt.p_expr), this.exprAllowed = !0;
};
A.incDec.updateContext = function() {
};
A._function.updateContext = A._class.updateContext = function(e) {
  e.beforeExpr && e !== A._else && !(e === A.semi && this.curContext() !== rt.p_stat) && !(e === A._return && Ht.test(this.input.slice(this.lastTokEnd, this.start))) && !((e === A.colon || e === A.braceL) && this.curContext() === rt.b_stat) ? this.context.push(rt.f_expr) : this.context.push(rt.f_stat), this.exprAllowed = !1;
};
A.colon.updateContext = function() {
  this.curContext().token === "function" && this.context.pop(), this.exprAllowed = !0;
};
A.backQuote.updateContext = function() {
  this.curContext() === rt.q_tmpl ? this.context.pop() : this.context.push(rt.q_tmpl), this.exprAllowed = !1;
};
A.star.updateContext = function(e) {
  if (e === A._function) {
    var t = this.context.length - 1;
    this.context[t] === rt.f_expr ? this.context[t] = rt.f_expr_gen : this.context[t] = rt.f_gen;
  }
  this.exprAllowed = !0;
};
A.name.updateContext = function(e) {
  var t = !1;
  this.options.ecmaVersion >= 6 && e !== A.dot && (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) && (t = !0), this.exprAllowed = t;
};
var Pe = xt.prototype;
Pe.checkPropClash = function(e, t, n) {
  if (!(this.options.ecmaVersion >= 9 && e.type === "SpreadElement") && !(this.options.ecmaVersion >= 6 && (e.computed || e.method || e.shorthand))) {
    var i = e.key, r;
    switch (i.type) {
      case "Identifier":
        r = i.name;
        break;
      case "Literal":
        r = String(i.value);
        break;
      default:
        return;
    }
    var a = e.kind;
    if (this.options.ecmaVersion >= 6) {
      r === "__proto__" && a === "init" && (t.proto && (n ? n.doubleProto < 0 && (n.doubleProto = i.start) : this.raiseRecoverable(i.start, "Redefinition of __proto__ property")), t.proto = !0);
      return;
    }
    r = "$" + r;
    var o = t[r];
    if (o) {
      var l;
      a === "init" ? l = this.strict && o.init || o.get || o.set : l = o.init || o[a], l && this.raiseRecoverable(i.start, "Redefinition of property");
    } else
      o = t[r] = {
        init: !1,
        get: !1,
        set: !1
      };
    o[a] = !0;
  }
};
Pe.parseExpression = function(e, t) {
  var n = this.start, i = this.startLoc, r = this.parseMaybeAssign(e, t);
  if (this.type === A.comma) {
    var a = this.startNodeAt(n, i);
    for (a.expressions = [r]; this.eat(A.comma); )
      a.expressions.push(this.parseMaybeAssign(e, t));
    return this.finishNode(a, "SequenceExpression");
  }
  return r;
};
Pe.parseMaybeAssign = function(e, t, n) {
  if (this.isContextual("yield")) {
    if (this.inGenerator)
      return this.parseYield(e);
    this.exprAllowed = !1;
  }
  var i = !1, r = -1, a = -1, o = -1;
  t ? (r = t.parenthesizedAssign, a = t.trailingComma, o = t.doubleProto, t.parenthesizedAssign = t.trailingComma = -1) : (t = new ws(), i = !0);
  var l = this.start, u = this.startLoc;
  (this.type === A.parenL || this.type === A.name) && (this.potentialArrowAt = this.start, this.potentialArrowInForAwait = e === "await");
  var c = this.parseMaybeConditional(e, t);
  if (n && (c = n.call(this, c, l, u)), this.type.isAssign) {
    var h = this.startNodeAt(l, u);
    return h.operator = this.value, this.type === A.eq && (c = this.toAssignable(c, !1, t)), i || (t.parenthesizedAssign = t.trailingComma = t.doubleProto = -1), t.shorthandAssign >= c.start && (t.shorthandAssign = -1), this.type === A.eq ? this.checkLValPattern(c) : this.checkLValSimple(c), h.left = c, this.next(), h.right = this.parseMaybeAssign(e), o > -1 && (t.doubleProto = o), this.finishNode(h, "AssignmentExpression");
  } else
    i && this.checkExpressionErrors(t, !0);
  return r > -1 && (t.parenthesizedAssign = r), a > -1 && (t.trailingComma = a), c;
};
Pe.parseMaybeConditional = function(e, t) {
  var n = this.start, i = this.startLoc, r = this.parseExprOps(e, t);
  if (this.checkExpressionErrors(t))
    return r;
  if (this.eat(A.question)) {
    var a = this.startNodeAt(n, i);
    return a.test = r, a.consequent = this.parseMaybeAssign(), this.expect(A.colon), a.alternate = this.parseMaybeAssign(e), this.finishNode(a, "ConditionalExpression");
  }
  return r;
};
Pe.parseExprOps = function(e, t) {
  var n = this.start, i = this.startLoc, r = this.parseMaybeUnary(t, !1, !1, e);
  return this.checkExpressionErrors(t) || r.start === n && r.type === "ArrowFunctionExpression" ? r : this.parseExprOp(r, n, i, -1, e);
};
Pe.parseExprOp = function(e, t, n, i, r) {
  var a = this.type.binop;
  if (a != null && (!r || this.type !== A._in) && a > i) {
    var o = this.type === A.logicalOR || this.type === A.logicalAND, l = this.type === A.coalesce;
    l && (a = A.logicalAND.binop);
    var u = this.value;
    this.next();
    var c = this.start, h = this.startLoc, p = this.parseExprOp(this.parseMaybeUnary(null, !1, !1, r), c, h, a, r), m = this.buildBinary(t, n, e, p, u, o || l);
    return (o && this.type === A.coalesce || l && (this.type === A.logicalOR || this.type === A.logicalAND)) && this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses"), this.parseExprOp(m, t, n, i, r);
  }
  return e;
};
Pe.buildBinary = function(e, t, n, i, r, a) {
  i.type === "PrivateIdentifier" && this.raise(i.start, "Private identifier can only be left side of binary expression");
  var o = this.startNodeAt(e, t);
  return o.left = n, o.operator = r, o.right = i, this.finishNode(o, a ? "LogicalExpression" : "BinaryExpression");
};
Pe.parseMaybeUnary = function(e, t, n, i) {
  var r = this.start, a = this.startLoc, o;
  if (this.isContextual("await") && this.canAwait)
    o = this.parseAwait(i), t = !0;
  else if (this.type.prefix) {
    var l = this.startNode(), u = this.type === A.incDec;
    l.operator = this.value, l.prefix = !0, this.next(), l.argument = this.parseMaybeUnary(null, !0, u, i), this.checkExpressionErrors(e, !0), u ? this.checkLValSimple(l.argument) : this.strict && l.operator === "delete" && bh(l.argument) ? this.raiseRecoverable(l.start, "Deleting local variable in strict mode") : l.operator === "delete" && qa(l.argument) ? this.raiseRecoverable(l.start, "Private fields can not be deleted") : t = !0, o = this.finishNode(l, u ? "UpdateExpression" : "UnaryExpression");
  } else if (!t && this.type === A.privateId)
    (i || this.privateNameStack.length === 0) && this.options.checkPrivateFields && this.unexpected(), o = this.parsePrivateIdent(), this.type !== A._in && this.unexpected();
  else {
    if (o = this.parseExprSubscripts(e, i), this.checkExpressionErrors(e))
      return o;
    for (; this.type.postfix && !this.canInsertSemicolon(); ) {
      var c = this.startNodeAt(r, a);
      c.operator = this.value, c.prefix = !1, c.argument = o, this.checkLValSimple(o), this.next(), o = this.finishNode(c, "UpdateExpression");
    }
  }
  if (!n && this.eat(A.starstar))
    if (t)
      this.unexpected(this.lastTokStart);
    else
      return this.buildBinary(r, a, o, this.parseMaybeUnary(null, !1, !1, i), "**", !1);
  else
    return o;
};
function bh(e) {
  return e.type === "Identifier" || e.type === "ParenthesizedExpression" && bh(e.expression);
}
function qa(e) {
  return e.type === "MemberExpression" && e.property.type === "PrivateIdentifier" || e.type === "ChainExpression" && qa(e.expression) || e.type === "ParenthesizedExpression" && qa(e.expression);
}
Pe.parseExprSubscripts = function(e, t) {
  var n = this.start, i = this.startLoc, r = this.parseExprAtom(e, t);
  if (r.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")")
    return r;
  var a = this.parseSubscripts(r, n, i, !1, t);
  return e && a.type === "MemberExpression" && (e.parenthesizedAssign >= a.start && (e.parenthesizedAssign = -1), e.parenthesizedBind >= a.start && (e.parenthesizedBind = -1), e.trailingComma >= a.start && (e.trailingComma = -1)), a;
};
Pe.parseSubscripts = function(e, t, n, i, r) {
  for (var a = this.options.ecmaVersion >= 8 && e.type === "Identifier" && e.name === "async" && this.lastTokEnd === e.end && !this.canInsertSemicolon() && e.end - e.start === 5 && this.potentialArrowAt === e.start, o = !1; ; ) {
    var l = this.parseSubscript(e, t, n, i, a, o, r);
    if (l.optional && (o = !0), l === e || l.type === "ArrowFunctionExpression") {
      if (o) {
        var u = this.startNodeAt(t, n);
        u.expression = l, l = this.finishNode(u, "ChainExpression");
      }
      return l;
    }
    e = l;
  }
};
Pe.shouldParseAsyncArrow = function() {
  return !this.canInsertSemicolon() && this.eat(A.arrow);
};
Pe.parseSubscriptAsyncArrow = function(e, t, n, i) {
  return this.parseArrowExpression(this.startNodeAt(e, t), n, !0, i);
};
Pe.parseSubscript = function(e, t, n, i, r, a, o) {
  var l = this.options.ecmaVersion >= 11, u = l && this.eat(A.questionDot);
  i && u && this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
  var c = this.eat(A.bracketL);
  if (c || u && this.type !== A.parenL && this.type !== A.backQuote || this.eat(A.dot)) {
    var h = this.startNodeAt(t, n);
    h.object = e, c ? (h.property = this.parseExpression(), this.expect(A.bracketR)) : this.type === A.privateId && e.type !== "Super" ? h.property = this.parsePrivateIdent() : h.property = this.parseIdent(this.options.allowReserved !== "never"), h.computed = !!c, l && (h.optional = u), e = this.finishNode(h, "MemberExpression");
  } else if (!i && this.eat(A.parenL)) {
    var p = new ws(), m = this.yieldPos, g = this.awaitPos, b = this.awaitIdentPos;
    this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
    var v = this.parseExprList(A.parenR, this.options.ecmaVersion >= 8, !1, p);
    if (r && !u && this.shouldParseAsyncArrow())
      return this.checkPatternErrors(p, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = m, this.awaitPos = g, this.awaitIdentPos = b, this.parseSubscriptAsyncArrow(t, n, v, o);
    this.checkExpressionErrors(p, !0), this.yieldPos = m || this.yieldPos, this.awaitPos = g || this.awaitPos, this.awaitIdentPos = b || this.awaitIdentPos;
    var w = this.startNodeAt(t, n);
    w.callee = e, w.arguments = v, l && (w.optional = u), e = this.finishNode(w, "CallExpression");
  } else if (this.type === A.backQuote) {
    (u || a) && this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
    var y = this.startNodeAt(t, n);
    y.tag = e, y.quasi = this.parseTemplate({ isTagged: !0 }), e = this.finishNode(y, "TaggedTemplateExpression");
  }
  return e;
};
Pe.parseExprAtom = function(e, t, n) {
  this.type === A.slash && this.readRegexp();
  var i, r = this.potentialArrowAt === this.start;
  switch (this.type) {
    case A._super:
      return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), i = this.startNode(), this.next(), this.type === A.parenL && !this.allowDirectSuper && this.raise(i.start, "super() call outside constructor of a subclass"), this.type !== A.dot && this.type !== A.bracketL && this.type !== A.parenL && this.unexpected(), this.finishNode(i, "Super");
    case A._this:
      return i = this.startNode(), this.next(), this.finishNode(i, "ThisExpression");
    case A.name:
      var a = this.start, o = this.startLoc, l = this.containsEsc, u = this.parseIdent(!1);
      if (this.options.ecmaVersion >= 8 && !l && u.name === "async" && !this.canInsertSemicolon() && this.eat(A._function))
        return this.overrideContext(rt.f_expr), this.parseFunction(this.startNodeAt(a, o), 0, !1, !0, t);
      if (r && !this.canInsertSemicolon()) {
        if (this.eat(A.arrow))
          return this.parseArrowExpression(this.startNodeAt(a, o), [u], !1, t);
        if (this.options.ecmaVersion >= 8 && u.name === "async" && this.type === A.name && !l && (!this.potentialArrowInForAwait || this.value !== "of" || this.containsEsc))
          return u = this.parseIdent(!1), (this.canInsertSemicolon() || !this.eat(A.arrow)) && this.unexpected(), this.parseArrowExpression(this.startNodeAt(a, o), [u], !0, t);
      }
      return u;
    case A.regexp:
      var c = this.value;
      return i = this.parseLiteral(c.value), i.regex = { pattern: c.pattern, flags: c.flags }, i;
    case A.num:
    case A.string:
      return this.parseLiteral(this.value);
    case A._null:
    case A._true:
    case A._false:
      return i = this.startNode(), i.value = this.type === A._null ? null : this.type === A._true, i.raw = this.type.keyword, this.next(), this.finishNode(i, "Literal");
    case A.parenL:
      var h = this.start, p = this.parseParenAndDistinguishExpression(r, t);
      return e && (e.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(p) && (e.parenthesizedAssign = h), e.parenthesizedBind < 0 && (e.parenthesizedBind = h)), p;
    case A.bracketL:
      return i = this.startNode(), this.next(), i.elements = this.parseExprList(A.bracketR, !0, !0, e), this.finishNode(i, "ArrayExpression");
    case A.braceL:
      return this.overrideContext(rt.b_expr), this.parseObj(!1, e);
    case A._function:
      return i = this.startNode(), this.next(), this.parseFunction(i, 0);
    case A._class:
      return this.parseClass(this.startNode(), !1);
    case A._new:
      return this.parseNew();
    case A.backQuote:
      return this.parseTemplate();
    case A._import:
      return this.options.ecmaVersion >= 11 ? this.parseExprImport(n) : this.unexpected();
    default:
      return this.parseExprAtomDefault();
  }
};
Pe.parseExprAtomDefault = function() {
  this.unexpected();
};
Pe.parseExprImport = function(e) {
  var t = this.startNode();
  if (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword import"), this.next(), this.type === A.parenL && !e)
    return this.parseDynamicImport(t);
  if (this.type === A.dot) {
    var n = this.startNodeAt(t.start, t.loc && t.loc.start);
    return n.name = "import", t.meta = this.finishNode(n, "Identifier"), this.parseImportMeta(t);
  } else
    this.unexpected();
};
Pe.parseDynamicImport = function(e) {
  if (this.next(), e.source = this.parseMaybeAssign(), this.options.ecmaVersion >= 16)
    this.eat(A.parenR) ? e.options = null : (this.expect(A.comma), this.afterTrailingComma(A.parenR) ? e.options = null : (e.options = this.parseMaybeAssign(), this.eat(A.parenR) || (this.expect(A.comma), this.afterTrailingComma(A.parenR) || this.unexpected())));
  else if (!this.eat(A.parenR)) {
    var t = this.start;
    this.eat(A.comma) && this.eat(A.parenR) ? this.raiseRecoverable(t, "Trailing comma is not allowed in import()") : this.unexpected(t);
  }
  return this.finishNode(e, "ImportExpression");
};
Pe.parseImportMeta = function(e) {
  this.next();
  var t = this.containsEsc;
  return e.property = this.parseIdent(!0), e.property.name !== "meta" && this.raiseRecoverable(e.property.start, "The only valid meta property for import is 'import.meta'"), t && this.raiseRecoverable(e.start, "'import.meta' must not contain escaped characters"), this.options.sourceType !== "module" && !this.options.allowImportExportEverywhere && this.raiseRecoverable(e.start, "Cannot use 'import.meta' outside a module"), this.finishNode(e, "MetaProperty");
};
Pe.parseLiteral = function(e) {
  var t = this.startNode();
  return t.value = e, t.raw = this.input.slice(this.start, this.end), t.raw.charCodeAt(t.raw.length - 1) === 110 && (t.bigint = t.value != null ? t.value.toString() : t.raw.slice(0, -1).replace(/_/g, "")), this.next(), this.finishNode(t, "Literal");
};
Pe.parseParenExpression = function() {
  this.expect(A.parenL);
  var e = this.parseExpression();
  return this.expect(A.parenR), e;
};
Pe.shouldParseArrow = function(e) {
  return !this.canInsertSemicolon();
};
Pe.parseParenAndDistinguishExpression = function(e, t) {
  var n = this.start, i = this.startLoc, r, a = this.options.ecmaVersion >= 8;
  if (this.options.ecmaVersion >= 6) {
    this.next();
    var o = this.start, l = this.startLoc, u = [], c = !0, h = !1, p = new ws(), m = this.yieldPos, g = this.awaitPos, b;
    for (this.yieldPos = 0, this.awaitPos = 0; this.type !== A.parenR; )
      if (c ? c = !1 : this.expect(A.comma), a && this.afterTrailingComma(A.parenR, !0)) {
        h = !0;
        break;
      } else if (this.type === A.ellipsis) {
        b = this.start, u.push(this.parseParenItem(this.parseRestBinding())), this.type === A.comma && this.raiseRecoverable(
          this.start,
          "Comma is not permitted after the rest element"
        );
        break;
      } else
        u.push(this.parseMaybeAssign(!1, p, this.parseParenItem));
    var v = this.lastTokEnd, w = this.lastTokEndLoc;
    if (this.expect(A.parenR), e && this.shouldParseArrow(u) && this.eat(A.arrow))
      return this.checkPatternErrors(p, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = m, this.awaitPos = g, this.parseParenArrowList(n, i, u, t);
    (!u.length || h) && this.unexpected(this.lastTokStart), b && this.unexpected(b), this.checkExpressionErrors(p, !0), this.yieldPos = m || this.yieldPos, this.awaitPos = g || this.awaitPos, u.length > 1 ? (r = this.startNodeAt(o, l), r.expressions = u, this.finishNodeAt(r, "SequenceExpression", v, w)) : r = u[0];
  } else
    r = this.parseParenExpression();
  if (this.options.preserveParens) {
    var y = this.startNodeAt(n, i);
    return y.expression = r, this.finishNode(y, "ParenthesizedExpression");
  } else
    return r;
};
Pe.parseParenItem = function(e) {
  return e;
};
Pe.parseParenArrowList = function(e, t, n, i) {
  return this.parseArrowExpression(this.startNodeAt(e, t), n, !1, i);
};
var J2 = [];
Pe.parseNew = function() {
  this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword new");
  var e = this.startNode();
  if (this.next(), this.options.ecmaVersion >= 6 && this.type === A.dot) {
    var t = this.startNodeAt(e.start, e.loc && e.loc.start);
    t.name = "new", e.meta = this.finishNode(t, "Identifier"), this.next();
    var n = this.containsEsc;
    return e.property = this.parseIdent(!0), e.property.name !== "target" && this.raiseRecoverable(e.property.start, "The only valid meta property for new is 'new.target'"), n && this.raiseRecoverable(e.start, "'new.target' must not contain escaped characters"), this.allowNewDotTarget || this.raiseRecoverable(e.start, "'new.target' can only be used in functions and class static block"), this.finishNode(e, "MetaProperty");
  }
  var i = this.start, r = this.startLoc;
  return e.callee = this.parseSubscripts(this.parseExprAtom(null, !1, !0), i, r, !0, !1), this.eat(A.parenL) ? e.arguments = this.parseExprList(A.parenR, this.options.ecmaVersion >= 8, !1) : e.arguments = J2, this.finishNode(e, "NewExpression");
};
Pe.parseTemplateElement = function(e) {
  var t = e.isTagged, n = this.startNode();
  return this.type === A.invalidTemplate ? (t || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), n.value = {
    raw: this.value.replace(/\r\n?/g, `
`),
    cooked: null
  }) : n.value = {
    raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, `
`),
    cooked: this.value
  }, this.next(), n.tail = this.type === A.backQuote, this.finishNode(n, "TemplateElement");
};
Pe.parseTemplate = function(e) {
  e === void 0 && (e = {});
  var t = e.isTagged;
  t === void 0 && (t = !1);
  var n = this.startNode();
  this.next(), n.expressions = [];
  var i = this.parseTemplateElement({ isTagged: t });
  for (n.quasis = [i]; !i.tail; )
    this.type === A.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(A.dollarBraceL), n.expressions.push(this.parseExpression()), this.expect(A.braceR), n.quasis.push(i = this.parseTemplateElement({ isTagged: t }));
  return this.next(), this.finishNode(n, "TemplateLiteral");
};
Pe.isAsyncProp = function(e) {
  return !e.computed && e.key.type === "Identifier" && e.key.name === "async" && (this.type === A.name || this.type === A.num || this.type === A.string || this.type === A.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === A.star) && !Ht.test(this.input.slice(this.lastTokEnd, this.start));
};
Pe.parseObj = function(e, t) {
  var n = this.startNode(), i = !0, r = {};
  for (n.properties = [], this.next(); !this.eat(A.braceR); ) {
    if (i)
      i = !1;
    else if (this.expect(A.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma(A.braceR))
      break;
    var a = this.parseProperty(e, t);
    e || this.checkPropClash(a, r, t), n.properties.push(a);
  }
  return this.finishNode(n, e ? "ObjectPattern" : "ObjectExpression");
};
Pe.parseProperty = function(e, t) {
  var n = this.startNode(), i, r, a, o;
  if (this.options.ecmaVersion >= 9 && this.eat(A.ellipsis))
    return e ? (n.argument = this.parseIdent(!1), this.type === A.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.finishNode(n, "RestElement")) : (n.argument = this.parseMaybeAssign(!1, t), this.type === A.comma && t && t.trailingComma < 0 && (t.trailingComma = this.start), this.finishNode(n, "SpreadElement"));
  this.options.ecmaVersion >= 6 && (n.method = !1, n.shorthand = !1, (e || t) && (a = this.start, o = this.startLoc), e || (i = this.eat(A.star)));
  var l = this.containsEsc;
  return this.parsePropertyName(n), !e && !l && this.options.ecmaVersion >= 8 && !i && this.isAsyncProp(n) ? (r = !0, i = this.options.ecmaVersion >= 9 && this.eat(A.star), this.parsePropertyName(n)) : r = !1, this.parsePropertyValue(n, e, i, r, a, o, t, l), this.finishNode(n, "Property");
};
Pe.parseGetterSetter = function(e) {
  var t = e.key.name;
  this.parsePropertyName(e), e.value = this.parseMethod(!1), e.kind = t;
  var n = e.kind === "get" ? 0 : 1;
  if (e.value.params.length !== n) {
    var i = e.value.start;
    e.kind === "get" ? this.raiseRecoverable(i, "getter should have no params") : this.raiseRecoverable(i, "setter should have exactly one param");
  } else
    e.kind === "set" && e.value.params[0].type === "RestElement" && this.raiseRecoverable(e.value.params[0].start, "Setter cannot use rest params");
};
Pe.parsePropertyValue = function(e, t, n, i, r, a, o, l) {
  (n || i) && this.type === A.colon && this.unexpected(), this.eat(A.colon) ? (e.value = t ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, o), e.kind = "init") : this.options.ecmaVersion >= 6 && this.type === A.parenL ? (t && this.unexpected(), e.method = !0, e.value = this.parseMethod(n, i), e.kind = "init") : !t && !l && this.options.ecmaVersion >= 5 && !e.computed && e.key.type === "Identifier" && (e.key.name === "get" || e.key.name === "set") && this.type !== A.comma && this.type !== A.braceR && this.type !== A.eq ? ((n || i) && this.unexpected(), this.parseGetterSetter(e)) : this.options.ecmaVersion >= 6 && !e.computed && e.key.type === "Identifier" ? ((n || i) && this.unexpected(), this.checkUnreserved(e.key), e.key.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = r), t ? e.value = this.parseMaybeDefault(r, a, this.copyNode(e.key)) : this.type === A.eq && o ? (o.shorthandAssign < 0 && (o.shorthandAssign = this.start), e.value = this.parseMaybeDefault(r, a, this.copyNode(e.key))) : e.value = this.copyNode(e.key), e.kind = "init", e.shorthand = !0) : this.unexpected();
};
Pe.parsePropertyName = function(e) {
  if (this.options.ecmaVersion >= 6) {
    if (this.eat(A.bracketL))
      return e.computed = !0, e.key = this.parseMaybeAssign(), this.expect(A.bracketR), e.key;
    e.computed = !1;
  }
  return e.key = this.type === A.num || this.type === A.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
};
Pe.initFunction = function(e) {
  e.id = null, this.options.ecmaVersion >= 6 && (e.generator = e.expression = !1), this.options.ecmaVersion >= 8 && (e.async = !1);
};
Pe.parseMethod = function(e, t, n) {
  var i = this.startNode(), r = this.yieldPos, a = this.awaitPos, o = this.awaitIdentPos;
  return this.initFunction(i), this.options.ecmaVersion >= 6 && (i.generator = e), this.options.ecmaVersion >= 8 && (i.async = !!t), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(wo(t, i.generator) | bs | (n ? mh : 0)), this.expect(A.parenL), i.params = this.parseBindingList(A.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(i, !1, !0, !1), this.yieldPos = r, this.awaitPos = a, this.awaitIdentPos = o, this.finishNode(i, "FunctionExpression");
};
Pe.parseArrowExpression = function(e, t, n, i) {
  var r = this.yieldPos, a = this.awaitPos, o = this.awaitIdentPos;
  return this.enterScope(wo(n, !1) | vo), this.initFunction(e), this.options.ecmaVersion >= 8 && (e.async = !!n), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, e.params = this.toAssignableList(t, !0), this.parseFunctionBody(e, !0, !1, i), this.yieldPos = r, this.awaitPos = a, this.awaitIdentPos = o, this.finishNode(e, "ArrowFunctionExpression");
};
Pe.parseFunctionBody = function(e, t, n, i) {
  var r = t && this.type !== A.braceL, a = this.strict, o = !1;
  if (r)
    e.body = this.parseMaybeAssign(i), e.expression = !0, this.checkParams(e, !1);
  else {
    var l = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(e.params);
    (!a || l) && (o = this.strictDirective(this.end), o && l && this.raiseRecoverable(e.start, "Illegal 'use strict' directive in function with non-simple parameter list"));
    var u = this.labels;
    this.labels = [], o && (this.strict = !0), this.checkParams(e, !a && !o && !t && !n && this.isSimpleParamList(e.params)), this.strict && e.id && this.checkLValSimple(e.id, xh), e.body = this.parseBlock(!1, void 0, o && !a), e.expression = !1, this.adaptDirectivePrologue(e.body.body), this.labels = u;
  }
  this.exitScope();
};
Pe.isSimpleParamList = function(e) {
  for (var t = 0, n = e; t < n.length; t += 1) {
    var i = n[t];
    if (i.type !== "Identifier")
      return !1;
  }
  return !0;
};
Pe.checkParams = function(e, t) {
  for (var n = /* @__PURE__ */ Object.create(null), i = 0, r = e.params; i < r.length; i += 1) {
    var a = r[i];
    this.checkLValInnerPattern(a, ko, t ? null : n);
  }
};
Pe.parseExprList = function(e, t, n, i) {
  for (var r = [], a = !0; !this.eat(e); ) {
    if (a)
      a = !1;
    else if (this.expect(A.comma), t && this.afterTrailingComma(e))
      break;
    var o = void 0;
    n && this.type === A.comma ? o = null : this.type === A.ellipsis ? (o = this.parseSpread(i), i && this.type === A.comma && i.trailingComma < 0 && (i.trailingComma = this.start)) : o = this.parseMaybeAssign(!1, i), r.push(o);
  }
  return r;
};
Pe.checkUnreserved = function(e) {
  var t = e.start, n = e.end, i = e.name;
  if (this.inGenerator && i === "yield" && this.raiseRecoverable(t, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && i === "await" && this.raiseRecoverable(t, "Cannot use 'await' as identifier inside an async function"), !(this.currentThisScope().flags & vs) && i === "arguments" && this.raiseRecoverable(t, "Cannot use 'arguments' in class field initializer"), this.inClassStaticBlock && (i === "arguments" || i === "await") && this.raise(t, "Cannot use " + i + " in class static initialization block"), this.keywords.test(i) && this.raise(t, "Unexpected keyword '" + i + "'"), !(this.options.ecmaVersion < 6 && this.input.slice(t, n).indexOf("\\") !== -1)) {
    var r = this.strict ? this.reservedWordsStrict : this.reservedWords;
    r.test(i) && (!this.inAsync && i === "await" && this.raiseRecoverable(t, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(t, "The keyword '" + i + "' is reserved"));
  }
};
Pe.parseIdent = function(e) {
  var t = this.parseIdentNode();
  return this.next(!!e), this.finishNode(t, "Identifier"), e || (this.checkUnreserved(t), t.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = t.start)), t;
};
Pe.parseIdentNode = function() {
  var e = this.startNode();
  return this.type === A.name ? e.name = this.value : this.type.keyword ? (e.name = this.type.keyword, (e.name === "class" || e.name === "function") && (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46) && this.context.pop(), this.type = A.name) : this.unexpected(), e;
};
Pe.parsePrivateIdent = function() {
  var e = this.startNode();
  return this.type === A.privateId ? e.name = this.value : this.unexpected(), this.next(), this.finishNode(e, "PrivateIdentifier"), this.options.checkPrivateFields && (this.privateNameStack.length === 0 ? this.raise(e.start, "Private field '#" + e.name + "' must be declared in an enclosing class") : this.privateNameStack[this.privateNameStack.length - 1].used.push(e)), e;
};
Pe.parseYield = function(e) {
  this.yieldPos || (this.yieldPos = this.start);
  var t = this.startNode();
  return this.next(), this.type === A.semi || this.canInsertSemicolon() || this.type !== A.star && !this.type.startsExpr ? (t.delegate = !1, t.argument = null) : (t.delegate = this.eat(A.star), t.argument = this.parseMaybeAssign(e)), this.finishNode(t, "YieldExpression");
};
Pe.parseAwait = function(e) {
  this.awaitPos || (this.awaitPos = this.start);
  var t = this.startNode();
  return this.next(), t.argument = this.parseMaybeUnary(null, !0, !1, e), this.finishNode(t, "AwaitExpression");
};
var hs = xt.prototype;
hs.raise = function(e, t) {
  var n = ph(this.input, e);
  t += " (" + n.line + ":" + n.column + ")", this.sourceFile && (t += " in " + this.sourceFile);
  var i = new SyntaxError(t);
  throw i.pos = e, i.loc = n, i.raisedAt = this.pos, i;
};
hs.raiseRecoverable = hs.raise;
hs.curPosition = function() {
  if (this.options.locations)
    return new vr(this.curLine, this.pos - this.lineStart);
};
var ei = xt.prototype, W2 = function(t) {
  this.flags = t, this.var = [], this.lexical = [], this.functions = [];
};
ei.enterScope = function(e) {
  this.scopeStack.push(new W2(e));
};
ei.exitScope = function() {
  this.scopeStack.pop();
};
ei.treatFunctionsAsVarInScope = function(e) {
  return e.flags & Wi || !this.inModule && e.flags & wr;
};
ei.declareName = function(e, t, n) {
  var i = !1;
  if (t === jn) {
    var r = this.currentScope();
    i = r.lexical.indexOf(e) > -1 || r.functions.indexOf(e) > -1 || r.var.indexOf(e) > -1, r.lexical.push(e), this.inModule && r.flags & wr && delete this.undefinedExports[e];
  } else if (t === _h) {
    var a = this.currentScope();
    a.lexical.push(e);
  } else if (t === gh) {
    var o = this.currentScope();
    this.treatFunctionsAsVar ? i = o.lexical.indexOf(e) > -1 : i = o.lexical.indexOf(e) > -1 || o.var.indexOf(e) > -1, o.functions.push(e);
  } else
    for (var l = this.scopeStack.length - 1; l >= 0; --l) {
      var u = this.scopeStack[l];
      if (u.lexical.indexOf(e) > -1 && !(u.flags & fh && u.lexical[0] === e) || !this.treatFunctionsAsVarInScope(u) && u.functions.indexOf(e) > -1) {
        i = !0;
        break;
      }
      if (u.var.push(e), this.inModule && u.flags & wr && delete this.undefinedExports[e], u.flags & vs)
        break;
    }
  i && this.raiseRecoverable(n, "Identifier '" + e + "' has already been declared");
};
ei.checkLocalExport = function(e) {
  this.scopeStack[0].lexical.indexOf(e.name) === -1 && this.scopeStack[0].var.indexOf(e.name) === -1 && (this.undefinedExports[e.name] = e);
};
ei.currentScope = function() {
  return this.scopeStack[this.scopeStack.length - 1];
};
ei.currentVarScope = function() {
  for (var e = this.scopeStack.length - 1; ; e--) {
    var t = this.scopeStack[e];
    if (t.flags & (vs | Tr | gi))
      return t;
  }
};
ei.currentThisScope = function() {
  for (var e = this.scopeStack.length - 1; ; e--) {
    var t = this.scopeStack[e];
    if (t.flags & (vs | Tr | gi) && !(t.flags & vo))
      return t;
  }
};
var ks = function(t, n, i) {
  this.type = "", this.start = n, this.end = 0, t.options.locations && (this.loc = new ys(t, i)), t.options.directSourceFile && (this.sourceFile = t.options.directSourceFile), t.options.ranges && (this.range = [n, 0]);
}, Nr = xt.prototype;
Nr.startNode = function() {
  return new ks(this, this.start, this.startLoc);
};
Nr.startNodeAt = function(e, t) {
  return new ks(this, e, t);
};
function vh(e, t, n, i) {
  return e.type = t, e.end = n, this.options.locations && (e.loc.end = i), this.options.ranges && (e.range[1] = n), e;
}
Nr.finishNode = function(e, t) {
  return vh.call(this, e, t, this.lastTokEnd, this.lastTokEndLoc);
};
Nr.finishNodeAt = function(e, t, n, i) {
  return vh.call(this, e, t, n, i);
};
Nr.copyNode = function(e) {
  var t = new ks(this, e.start, this.startLoc);
  for (var n in e)
    t[n] = e[n];
  return t;
};
var X2 = "Gara Garay Gukh Gurung_Khema Hrkt Katakana_Or_Hiragana Kawi Kirat_Rai Krai Nag_Mundari Nagm Ol_Onal Onao Sunu Sunuwar Todhri Todr Tulu_Tigalari Tutg Unknown Zzzz", wh = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", kh = wh + " Extended_Pictographic", Ch = kh, Sh = Ch + " EBase EComp EMod EPres ExtPict", Eh = Sh, Z2 = Eh, G2 = {
  9: wh,
  10: kh,
  11: Ch,
  12: Sh,
  13: Eh,
  14: Z2
}, K2 = "Basic_Emoji Emoji_Keycap_Sequence RGI_Emoji_Modifier_Sequence RGI_Emoji_Flag_Sequence RGI_Emoji_Tag_Sequence RGI_Emoji_ZWJ_Sequence RGI_Emoji", Y2 = {
  9: "",
  10: "",
  11: "",
  12: "",
  13: "",
  14: K2
}, fu = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", Ah = "Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", Ih = Ah + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", Lh = Ih + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho", Ph = Lh + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi", Th = Ph + " Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith", Q2 = Th + " " + X2, eg = {
  9: Ah,
  10: Ih,
  11: Lh,
  12: Ph,
  13: Th,
  14: Q2
}, Nh = {};
function tg(e) {
  var t = Nh[e] = {
    binary: Zn(G2[e] + " " + fu),
    binaryOfStrings: Zn(Y2[e]),
    nonBinary: {
      General_Category: Zn(fu),
      Script: Zn(eg[e])
    }
  };
  t.nonBinary.Script_Extensions = t.nonBinary.Script, t.nonBinary.gc = t.nonBinary.General_Category, t.nonBinary.sc = t.nonBinary.Script, t.nonBinary.scx = t.nonBinary.Script_Extensions;
}
for (var ea = 0, mu = [9, 10, 11, 12, 13, 14]; ea < mu.length; ea += 1) {
  var ng = mu[ea];
  tg(ng);
}
var ye = xt.prototype, ps = function(t, n) {
  this.parent = t, this.base = n || this;
};
ps.prototype.separatedFrom = function(t) {
  for (var n = this; n; n = n.parent)
    for (var i = t; i; i = i.parent)
      if (n.base === i.base && n !== i)
        return !0;
  return !1;
};
ps.prototype.sibling = function() {
  return new ps(this.parent, this.base);
};
var Cn = function(t) {
  this.parser = t, this.validFlags = "gim" + (t.options.ecmaVersion >= 6 ? "uy" : "") + (t.options.ecmaVersion >= 9 ? "s" : "") + (t.options.ecmaVersion >= 13 ? "d" : "") + (t.options.ecmaVersion >= 15 ? "v" : ""), this.unicodeProperties = Nh[t.options.ecmaVersion >= 14 ? 14 : t.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = !1, this.switchV = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = /* @__PURE__ */ Object.create(null), this.backReferenceNames = [], this.branchID = null;
};
Cn.prototype.reset = function(t, n, i) {
  var r = i.indexOf("v") !== -1, a = i.indexOf("u") !== -1;
  this.start = t | 0, this.source = n + "", this.flags = i, r && this.parser.options.ecmaVersion >= 15 ? (this.switchU = !0, this.switchV = !0, this.switchN = !0) : (this.switchU = a && this.parser.options.ecmaVersion >= 6, this.switchV = !1, this.switchN = a && this.parser.options.ecmaVersion >= 9);
};
Cn.prototype.raise = function(t) {
  this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + t);
};
Cn.prototype.at = function(t, n) {
  n === void 0 && (n = !1);
  var i = this.source, r = i.length;
  if (t >= r)
    return -1;
  var a = i.charCodeAt(t);
  if (!(n || this.switchU) || a <= 55295 || a >= 57344 || t + 1 >= r)
    return a;
  var o = i.charCodeAt(t + 1);
  return o >= 56320 && o <= 57343 ? (a << 10) + o - 56613888 : a;
};
Cn.prototype.nextIndex = function(t, n) {
  n === void 0 && (n = !1);
  var i = this.source, r = i.length;
  if (t >= r)
    return r;
  var a = i.charCodeAt(t), o;
  return !(n || this.switchU) || a <= 55295 || a >= 57344 || t + 1 >= r || (o = i.charCodeAt(t + 1)) < 56320 || o > 57343 ? t + 1 : t + 2;
};
Cn.prototype.current = function(t) {
  return t === void 0 && (t = !1), this.at(this.pos, t);
};
Cn.prototype.lookahead = function(t) {
  return t === void 0 && (t = !1), this.at(this.nextIndex(this.pos, t), t);
};
Cn.prototype.advance = function(t) {
  t === void 0 && (t = !1), this.pos = this.nextIndex(this.pos, t);
};
Cn.prototype.eat = function(t, n) {
  return n === void 0 && (n = !1), this.current(n) === t ? (this.advance(n), !0) : !1;
};
Cn.prototype.eatChars = function(t, n) {
  n === void 0 && (n = !1);
  for (var i = this.pos, r = 0, a = t; r < a.length; r += 1) {
    var o = a[r], l = this.at(i, n);
    if (l === -1 || l !== o)
      return !1;
    i = this.nextIndex(i, n);
  }
  return this.pos = i, !0;
};
ye.validateRegExpFlags = function(e) {
  for (var t = e.validFlags, n = e.flags, i = !1, r = !1, a = 0; a < n.length; a++) {
    var o = n.charAt(a);
    t.indexOf(o) === -1 && this.raise(e.start, "Invalid regular expression flag"), n.indexOf(o, a + 1) > -1 && this.raise(e.start, "Duplicate regular expression flag"), o === "u" && (i = !0), o === "v" && (r = !0);
  }
  this.options.ecmaVersion >= 15 && i && r && this.raise(e.start, "Invalid regular expression flag");
};
function ig(e) {
  for (var t in e)
    return !0;
  return !1;
}
ye.validateRegExpPattern = function(e) {
  this.regexp_pattern(e), !e.switchN && this.options.ecmaVersion >= 9 && ig(e.groupNames) && (e.switchN = !0, this.regexp_pattern(e));
};
ye.regexp_pattern = function(e) {
  e.pos = 0, e.lastIntValue = 0, e.lastStringValue = "", e.lastAssertionIsQuantifiable = !1, e.numCapturingParens = 0, e.maxBackReference = 0, e.groupNames = /* @__PURE__ */ Object.create(null), e.backReferenceNames.length = 0, e.branchID = null, this.regexp_disjunction(e), e.pos !== e.source.length && (e.eat(
    41
    /* ) */
  ) && e.raise("Unmatched ')'"), (e.eat(
    93
    /* ] */
  ) || e.eat(
    125
    /* } */
  )) && e.raise("Lone quantifier brackets")), e.maxBackReference > e.numCapturingParens && e.raise("Invalid escape");
  for (var t = 0, n = e.backReferenceNames; t < n.length; t += 1) {
    var i = n[t];
    e.groupNames[i] || e.raise("Invalid named capture referenced");
  }
};
ye.regexp_disjunction = function(e) {
  var t = this.options.ecmaVersion >= 16;
  for (t && (e.branchID = new ps(e.branchID, null)), this.regexp_alternative(e); e.eat(
    124
    /* | */
  ); )
    t && (e.branchID = e.branchID.sibling()), this.regexp_alternative(e);
  t && (e.branchID = e.branchID.parent), this.regexp_eatQuantifier(e, !0) && e.raise("Nothing to repeat"), e.eat(
    123
    /* { */
  ) && e.raise("Lone quantifier brackets");
};
ye.regexp_alternative = function(e) {
  for (; e.pos < e.source.length && this.regexp_eatTerm(e); )
    ;
};
ye.regexp_eatTerm = function(e) {
  return this.regexp_eatAssertion(e) ? (e.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(e) && e.switchU && e.raise("Invalid quantifier"), !0) : (e.switchU ? this.regexp_eatAtom(e) : this.regexp_eatExtendedAtom(e)) ? (this.regexp_eatQuantifier(e), !0) : !1;
};
ye.regexp_eatAssertion = function(e) {
  var t = e.pos;
  if (e.lastAssertionIsQuantifiable = !1, e.eat(
    94
    /* ^ */
  ) || e.eat(
    36
    /* $ */
  ))
    return !0;
  if (e.eat(
    92
    /* \ */
  )) {
    if (e.eat(
      66
      /* B */
    ) || e.eat(
      98
      /* b */
    ))
      return !0;
    e.pos = t;
  }
  if (e.eat(
    40
    /* ( */
  ) && e.eat(
    63
    /* ? */
  )) {
    var n = !1;
    if (this.options.ecmaVersion >= 9 && (n = e.eat(
      60
      /* < */
    )), e.eat(
      61
      /* = */
    ) || e.eat(
      33
      /* ! */
    ))
      return this.regexp_disjunction(e), e.eat(
        41
        /* ) */
      ) || e.raise("Unterminated group"), e.lastAssertionIsQuantifiable = !n, !0;
  }
  return e.pos = t, !1;
};
ye.regexp_eatQuantifier = function(e, t) {
  return t === void 0 && (t = !1), this.regexp_eatQuantifierPrefix(e, t) ? (e.eat(
    63
    /* ? */
  ), !0) : !1;
};
ye.regexp_eatQuantifierPrefix = function(e, t) {
  return e.eat(
    42
    /* * */
  ) || e.eat(
    43
    /* + */
  ) || e.eat(
    63
    /* ? */
  ) || this.regexp_eatBracedQuantifier(e, t);
};
ye.regexp_eatBracedQuantifier = function(e, t) {
  var n = e.pos;
  if (e.eat(
    123
    /* { */
  )) {
    var i = 0, r = -1;
    if (this.regexp_eatDecimalDigits(e) && (i = e.lastIntValue, e.eat(
      44
      /* , */
    ) && this.regexp_eatDecimalDigits(e) && (r = e.lastIntValue), e.eat(
      125
      /* } */
    )))
      return r !== -1 && r < i && !t && e.raise("numbers out of order in {} quantifier"), !0;
    e.switchU && !t && e.raise("Incomplete quantifier"), e.pos = n;
  }
  return !1;
};
ye.regexp_eatAtom = function(e) {
  return this.regexp_eatPatternCharacters(e) || e.eat(
    46
    /* . */
  ) || this.regexp_eatReverseSolidusAtomEscape(e) || this.regexp_eatCharacterClass(e) || this.regexp_eatUncapturingGroup(e) || this.regexp_eatCapturingGroup(e);
};
ye.regexp_eatReverseSolidusAtomEscape = function(e) {
  var t = e.pos;
  if (e.eat(
    92
    /* \ */
  )) {
    if (this.regexp_eatAtomEscape(e))
      return !0;
    e.pos = t;
  }
  return !1;
};
ye.regexp_eatUncapturingGroup = function(e) {
  var t = e.pos;
  if (e.eat(
    40
    /* ( */
  )) {
    if (e.eat(
      63
      /* ? */
    )) {
      if (this.options.ecmaVersion >= 16) {
        var n = this.regexp_eatModifiers(e), i = e.eat(
          45
          /* - */
        );
        if (n || i) {
          for (var r = 0; r < n.length; r++) {
            var a = n.charAt(r);
            n.indexOf(a, r + 1) > -1 && e.raise("Duplicate regular expression modifiers");
          }
          if (i) {
            var o = this.regexp_eatModifiers(e);
            !n && !o && e.current() === 58 && e.raise("Invalid regular expression modifiers");
            for (var l = 0; l < o.length; l++) {
              var u = o.charAt(l);
              (o.indexOf(u, l + 1) > -1 || n.indexOf(u) > -1) && e.raise("Duplicate regular expression modifiers");
            }
          }
        }
      }
      if (e.eat(
        58
        /* : */
      )) {
        if (this.regexp_disjunction(e), e.eat(
          41
          /* ) */
        ))
          return !0;
        e.raise("Unterminated group");
      }
    }
    e.pos = t;
  }
  return !1;
};
ye.regexp_eatCapturingGroup = function(e) {
  if (e.eat(
    40
    /* ( */
  )) {
    if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(e) : e.current() === 63 && e.raise("Invalid group"), this.regexp_disjunction(e), e.eat(
      41
      /* ) */
    ))
      return e.numCapturingParens += 1, !0;
    e.raise("Unterminated group");
  }
  return !1;
};
ye.regexp_eatModifiers = function(e) {
  for (var t = "", n = 0; (n = e.current()) !== -1 && rg(n); )
    t += Rn(n), e.advance();
  return t;
};
function rg(e) {
  return e === 105 || e === 109 || e === 115;
}
ye.regexp_eatExtendedAtom = function(e) {
  return e.eat(
    46
    /* . */
  ) || this.regexp_eatReverseSolidusAtomEscape(e) || this.regexp_eatCharacterClass(e) || this.regexp_eatUncapturingGroup(e) || this.regexp_eatCapturingGroup(e) || this.regexp_eatInvalidBracedQuantifier(e) || this.regexp_eatExtendedPatternCharacter(e);
};
ye.regexp_eatInvalidBracedQuantifier = function(e) {
  return this.regexp_eatBracedQuantifier(e, !0) && e.raise("Nothing to repeat"), !1;
};
ye.regexp_eatSyntaxCharacter = function(e) {
  var t = e.current();
  return Dh(t) ? (e.lastIntValue = t, e.advance(), !0) : !1;
};
function Dh(e) {
  return e === 36 || e >= 40 && e <= 43 || e === 46 || e === 63 || e >= 91 && e <= 94 || e >= 123 && e <= 125;
}
ye.regexp_eatPatternCharacters = function(e) {
  for (var t = e.pos, n = 0; (n = e.current()) !== -1 && !Dh(n); )
    e.advance();
  return e.pos !== t;
};
ye.regexp_eatExtendedPatternCharacter = function(e) {
  var t = e.current();
  return t !== -1 && t !== 36 && !(t >= 40 && t <= 43) && t !== 46 && t !== 63 && t !== 91 && t !== 94 && t !== 124 ? (e.advance(), !0) : !1;
};
ye.regexp_groupSpecifier = function(e) {
  if (e.eat(
    63
    /* ? */
  )) {
    this.regexp_eatGroupName(e) || e.raise("Invalid group");
    var t = this.options.ecmaVersion >= 16, n = e.groupNames[e.lastStringValue];
    if (n)
      if (t)
        for (var i = 0, r = n; i < r.length; i += 1) {
          var a = r[i];
          a.separatedFrom(e.branchID) || e.raise("Duplicate capture group name");
        }
      else
        e.raise("Duplicate capture group name");
    t ? (n || (e.groupNames[e.lastStringValue] = [])).push(e.branchID) : e.groupNames[e.lastStringValue] = !0;
  }
};
ye.regexp_eatGroupName = function(e) {
  if (e.lastStringValue = "", e.eat(
    60
    /* < */
  )) {
    if (this.regexp_eatRegExpIdentifierName(e) && e.eat(
      62
      /* > */
    ))
      return !0;
    e.raise("Invalid capture group name");
  }
  return !1;
};
ye.regexp_eatRegExpIdentifierName = function(e) {
  if (e.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(e)) {
    for (e.lastStringValue += Rn(e.lastIntValue); this.regexp_eatRegExpIdentifierPart(e); )
      e.lastStringValue += Rn(e.lastIntValue);
    return !0;
  }
  return !1;
};
ye.regexp_eatRegExpIdentifierStart = function(e) {
  var t = e.pos, n = this.options.ecmaVersion >= 11, i = e.current(n);
  return e.advance(n), i === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(e, n) && (i = e.lastIntValue), sg(i) ? (e.lastIntValue = i, !0) : (e.pos = t, !1);
};
function sg(e) {
  return wn(e, !0) || e === 36 || e === 95;
}
ye.regexp_eatRegExpIdentifierPart = function(e) {
  var t = e.pos, n = this.options.ecmaVersion >= 11, i = e.current(n);
  return e.advance(n), i === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(e, n) && (i = e.lastIntValue), ag(i) ? (e.lastIntValue = i, !0) : (e.pos = t, !1);
};
function ag(e) {
  return Yn(e, !0) || e === 36 || e === 95 || e === 8204 || e === 8205;
}
ye.regexp_eatAtomEscape = function(e) {
  return this.regexp_eatBackReference(e) || this.regexp_eatCharacterClassEscape(e) || this.regexp_eatCharacterEscape(e) || e.switchN && this.regexp_eatKGroupName(e) ? !0 : (e.switchU && (e.current() === 99 && e.raise("Invalid unicode escape"), e.raise("Invalid escape")), !1);
};
ye.regexp_eatBackReference = function(e) {
  var t = e.pos;
  if (this.regexp_eatDecimalEscape(e)) {
    var n = e.lastIntValue;
    if (e.switchU)
      return n > e.maxBackReference && (e.maxBackReference = n), !0;
    if (n <= e.numCapturingParens)
      return !0;
    e.pos = t;
  }
  return !1;
};
ye.regexp_eatKGroupName = function(e) {
  if (e.eat(
    107
    /* k */
  )) {
    if (this.regexp_eatGroupName(e))
      return e.backReferenceNames.push(e.lastStringValue), !0;
    e.raise("Invalid named reference");
  }
  return !1;
};
ye.regexp_eatCharacterEscape = function(e) {
  return this.regexp_eatControlEscape(e) || this.regexp_eatCControlLetter(e) || this.regexp_eatZero(e) || this.regexp_eatHexEscapeSequence(e) || this.regexp_eatRegExpUnicodeEscapeSequence(e, !1) || !e.switchU && this.regexp_eatLegacyOctalEscapeSequence(e) || this.regexp_eatIdentityEscape(e);
};
ye.regexp_eatCControlLetter = function(e) {
  var t = e.pos;
  if (e.eat(
    99
    /* c */
  )) {
    if (this.regexp_eatControlLetter(e))
      return !0;
    e.pos = t;
  }
  return !1;
};
ye.regexp_eatZero = function(e) {
  return e.current() === 48 && !Cs(e.lookahead()) ? (e.lastIntValue = 0, e.advance(), !0) : !1;
};
ye.regexp_eatControlEscape = function(e) {
  var t = e.current();
  return t === 116 ? (e.lastIntValue = 9, e.advance(), !0) : t === 110 ? (e.lastIntValue = 10, e.advance(), !0) : t === 118 ? (e.lastIntValue = 11, e.advance(), !0) : t === 102 ? (e.lastIntValue = 12, e.advance(), !0) : t === 114 ? (e.lastIntValue = 13, e.advance(), !0) : !1;
};
ye.regexp_eatControlLetter = function(e) {
  var t = e.current();
  return Vh(t) ? (e.lastIntValue = t % 32, e.advance(), !0) : !1;
};
function Vh(e) {
  return e >= 65 && e <= 90 || e >= 97 && e <= 122;
}
ye.regexp_eatRegExpUnicodeEscapeSequence = function(e, t) {
  t === void 0 && (t = !1);
  var n = e.pos, i = t || e.switchU;
  if (e.eat(
    117
    /* u */
  )) {
    if (this.regexp_eatFixedHexDigits(e, 4)) {
      var r = e.lastIntValue;
      if (i && r >= 55296 && r <= 56319) {
        var a = e.pos;
        if (e.eat(
          92
          /* \ */
        ) && e.eat(
          117
          /* u */
        ) && this.regexp_eatFixedHexDigits(e, 4)) {
          var o = e.lastIntValue;
          if (o >= 56320 && o <= 57343)
            return e.lastIntValue = (r - 55296) * 1024 + (o - 56320) + 65536, !0;
        }
        e.pos = a, e.lastIntValue = r;
      }
      return !0;
    }
    if (i && e.eat(
      123
      /* { */
    ) && this.regexp_eatHexDigits(e) && e.eat(
      125
      /* } */
    ) && og(e.lastIntValue))
      return !0;
    i && e.raise("Invalid unicode escape"), e.pos = n;
  }
  return !1;
};
function og(e) {
  return e >= 0 && e <= 1114111;
}
ye.regexp_eatIdentityEscape = function(e) {
  if (e.switchU)
    return this.regexp_eatSyntaxCharacter(e) ? !0 : e.eat(
      47
      /* / */
    ) ? (e.lastIntValue = 47, !0) : !1;
  var t = e.current();
  return t !== 99 && (!e.switchN || t !== 107) ? (e.lastIntValue = t, e.advance(), !0) : !1;
};
ye.regexp_eatDecimalEscape = function(e) {
  e.lastIntValue = 0;
  var t = e.current();
  if (t >= 49 && t <= 57) {
    do
      e.lastIntValue = 10 * e.lastIntValue + (t - 48), e.advance();
    while ((t = e.current()) >= 48 && t <= 57);
    return !0;
  }
  return !1;
};
var Mh = 0, On = 1, tn = 2;
ye.regexp_eatCharacterClassEscape = function(e) {
  var t = e.current();
  if (lg(t))
    return e.lastIntValue = -1, e.advance(), On;
  var n = !1;
  if (e.switchU && this.options.ecmaVersion >= 9 && ((n = t === 80) || t === 112)) {
    e.lastIntValue = -1, e.advance();
    var i;
    if (e.eat(
      123
      /* { */
    ) && (i = this.regexp_eatUnicodePropertyValueExpression(e)) && e.eat(
      125
      /* } */
    ))
      return n && i === tn && e.raise("Invalid property name"), i;
    e.raise("Invalid property name");
  }
  return Mh;
};
function lg(e) {
  return e === 100 || e === 68 || e === 115 || e === 83 || e === 119 || e === 87;
}
ye.regexp_eatUnicodePropertyValueExpression = function(e) {
  var t = e.pos;
  if (this.regexp_eatUnicodePropertyName(e) && e.eat(
    61
    /* = */
  )) {
    var n = e.lastStringValue;
    if (this.regexp_eatUnicodePropertyValue(e)) {
      var i = e.lastStringValue;
      return this.regexp_validateUnicodePropertyNameAndValue(e, n, i), On;
    }
  }
  if (e.pos = t, this.regexp_eatLoneUnicodePropertyNameOrValue(e)) {
    var r = e.lastStringValue;
    return this.regexp_validateUnicodePropertyNameOrValue(e, r);
  }
  return Mh;
};
ye.regexp_validateUnicodePropertyNameAndValue = function(e, t, n) {
  Ji(e.unicodeProperties.nonBinary, t) || e.raise("Invalid property name"), e.unicodeProperties.nonBinary[t].test(n) || e.raise("Invalid property value");
};
ye.regexp_validateUnicodePropertyNameOrValue = function(e, t) {
  if (e.unicodeProperties.binary.test(t))
    return On;
  if (e.switchV && e.unicodeProperties.binaryOfStrings.test(t))
    return tn;
  e.raise("Invalid property name");
};
ye.regexp_eatUnicodePropertyName = function(e) {
  var t = 0;
  for (e.lastStringValue = ""; Fh(t = e.current()); )
    e.lastStringValue += Rn(t), e.advance();
  return e.lastStringValue !== "";
};
function Fh(e) {
  return Vh(e) || e === 95;
}
ye.regexp_eatUnicodePropertyValue = function(e) {
  var t = 0;
  for (e.lastStringValue = ""; ug(t = e.current()); )
    e.lastStringValue += Rn(t), e.advance();
  return e.lastStringValue !== "";
};
function ug(e) {
  return Fh(e) || Cs(e);
}
ye.regexp_eatLoneUnicodePropertyNameOrValue = function(e) {
  return this.regexp_eatUnicodePropertyValue(e);
};
ye.regexp_eatCharacterClass = function(e) {
  if (e.eat(
    91
    /* [ */
  )) {
    var t = e.eat(
      94
      /* ^ */
    ), n = this.regexp_classContents(e);
    return e.eat(
      93
      /* ] */
    ) || e.raise("Unterminated character class"), t && n === tn && e.raise("Negated character class may contain strings"), !0;
  }
  return !1;
};
ye.regexp_classContents = function(e) {
  return e.current() === 93 ? On : e.switchV ? this.regexp_classSetExpression(e) : (this.regexp_nonEmptyClassRanges(e), On);
};
ye.regexp_nonEmptyClassRanges = function(e) {
  for (; this.regexp_eatClassAtom(e); ) {
    var t = e.lastIntValue;
    if (e.eat(
      45
      /* - */
    ) && this.regexp_eatClassAtom(e)) {
      var n = e.lastIntValue;
      e.switchU && (t === -1 || n === -1) && e.raise("Invalid character class"), t !== -1 && n !== -1 && t > n && e.raise("Range out of order in character class");
    }
  }
};
ye.regexp_eatClassAtom = function(e) {
  var t = e.pos;
  if (e.eat(
    92
    /* \ */
  )) {
    if (this.regexp_eatClassEscape(e))
      return !0;
    if (e.switchU) {
      var n = e.current();
      (n === 99 || Bh(n)) && e.raise("Invalid class escape"), e.raise("Invalid escape");
    }
    e.pos = t;
  }
  var i = e.current();
  return i !== 93 ? (e.lastIntValue = i, e.advance(), !0) : !1;
};
ye.regexp_eatClassEscape = function(e) {
  var t = e.pos;
  if (e.eat(
    98
    /* b */
  ))
    return e.lastIntValue = 8, !0;
  if (e.switchU && e.eat(
    45
    /* - */
  ))
    return e.lastIntValue = 45, !0;
  if (!e.switchU && e.eat(
    99
    /* c */
  )) {
    if (this.regexp_eatClassControlLetter(e))
      return !0;
    e.pos = t;
  }
  return this.regexp_eatCharacterClassEscape(e) || this.regexp_eatCharacterEscape(e);
};
ye.regexp_classSetExpression = function(e) {
  var t = On, n;
  if (!this.regexp_eatClassSetRange(e)) if (n = this.regexp_eatClassSetOperand(e)) {
    n === tn && (t = tn);
    for (var i = e.pos; e.eatChars(
      [38, 38]
      /* && */
    ); ) {
      if (e.current() !== 38 && (n = this.regexp_eatClassSetOperand(e))) {
        n !== tn && (t = On);
        continue;
      }
      e.raise("Invalid character in character class");
    }
    if (i !== e.pos)
      return t;
    for (; e.eatChars(
      [45, 45]
      /* -- */
    ); )
      this.regexp_eatClassSetOperand(e) || e.raise("Invalid character in character class");
    if (i !== e.pos)
      return t;
  } else
    e.raise("Invalid character in character class");
  for (; ; )
    if (!this.regexp_eatClassSetRange(e)) {
      if (n = this.regexp_eatClassSetOperand(e), !n)
        return t;
      n === tn && (t = tn);
    }
};
ye.regexp_eatClassSetRange = function(e) {
  var t = e.pos;
  if (this.regexp_eatClassSetCharacter(e)) {
    var n = e.lastIntValue;
    if (e.eat(
      45
      /* - */
    ) && this.regexp_eatClassSetCharacter(e)) {
      var i = e.lastIntValue;
      return n !== -1 && i !== -1 && n > i && e.raise("Range out of order in character class"), !0;
    }
    e.pos = t;
  }
  return !1;
};
ye.regexp_eatClassSetOperand = function(e) {
  return this.regexp_eatClassSetCharacter(e) ? On : this.regexp_eatClassStringDisjunction(e) || this.regexp_eatNestedClass(e);
};
ye.regexp_eatNestedClass = function(e) {
  var t = e.pos;
  if (e.eat(
    91
    /* [ */
  )) {
    var n = e.eat(
      94
      /* ^ */
    ), i = this.regexp_classContents(e);
    if (e.eat(
      93
      /* ] */
    ))
      return n && i === tn && e.raise("Negated character class may contain strings"), i;
    e.pos = t;
  }
  if (e.eat(
    92
    /* \ */
  )) {
    var r = this.regexp_eatCharacterClassEscape(e);
    if (r)
      return r;
    e.pos = t;
  }
  return null;
};
ye.regexp_eatClassStringDisjunction = function(e) {
  var t = e.pos;
  if (e.eatChars(
    [92, 113]
    /* \q */
  )) {
    if (e.eat(
      123
      /* { */
    )) {
      var n = this.regexp_classStringDisjunctionContents(e);
      if (e.eat(
        125
        /* } */
      ))
        return n;
    } else
      e.raise("Invalid escape");
    e.pos = t;
  }
  return null;
};
ye.regexp_classStringDisjunctionContents = function(e) {
  for (var t = this.regexp_classString(e); e.eat(
    124
    /* | */
  ); )
    this.regexp_classString(e) === tn && (t = tn);
  return t;
};
ye.regexp_classString = function(e) {
  for (var t = 0; this.regexp_eatClassSetCharacter(e); )
    t++;
  return t === 1 ? On : tn;
};
ye.regexp_eatClassSetCharacter = function(e) {
  var t = e.pos;
  if (e.eat(
    92
    /* \ */
  ))
    return this.regexp_eatCharacterEscape(e) || this.regexp_eatClassSetReservedPunctuator(e) ? !0 : e.eat(
      98
      /* b */
    ) ? (e.lastIntValue = 8, !0) : (e.pos = t, !1);
  var n = e.current();
  return n < 0 || n === e.lookahead() && cg(n) || hg(n) ? !1 : (e.advance(), e.lastIntValue = n, !0);
};
function cg(e) {
  return e === 33 || e >= 35 && e <= 38 || e >= 42 && e <= 44 || e === 46 || e >= 58 && e <= 64 || e === 94 || e === 96 || e === 126;
}
function hg(e) {
  return e === 40 || e === 41 || e === 45 || e === 47 || e >= 91 && e <= 93 || e >= 123 && e <= 125;
}
ye.regexp_eatClassSetReservedPunctuator = function(e) {
  var t = e.current();
  return pg(t) ? (e.lastIntValue = t, e.advance(), !0) : !1;
};
function pg(e) {
  return e === 33 || e === 35 || e === 37 || e === 38 || e === 44 || e === 45 || e >= 58 && e <= 62 || e === 64 || e === 96 || e === 126;
}
ye.regexp_eatClassControlLetter = function(e) {
  var t = e.current();
  return Cs(t) || t === 95 ? (e.lastIntValue = t % 32, e.advance(), !0) : !1;
};
ye.regexp_eatHexEscapeSequence = function(e) {
  var t = e.pos;
  if (e.eat(
    120
    /* x */
  )) {
    if (this.regexp_eatFixedHexDigits(e, 2))
      return !0;
    e.switchU && e.raise("Invalid escape"), e.pos = t;
  }
  return !1;
};
ye.regexp_eatDecimalDigits = function(e) {
  var t = e.pos, n = 0;
  for (e.lastIntValue = 0; Cs(n = e.current()); )
    e.lastIntValue = 10 * e.lastIntValue + (n - 48), e.advance();
  return e.pos !== t;
};
function Cs(e) {
  return e >= 48 && e <= 57;
}
ye.regexp_eatHexDigits = function(e) {
  var t = e.pos, n = 0;
  for (e.lastIntValue = 0; Rh(n = e.current()); )
    e.lastIntValue = 16 * e.lastIntValue + Oh(n), e.advance();
  return e.pos !== t;
};
function Rh(e) {
  return e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102;
}
function Oh(e) {
  return e >= 65 && e <= 70 ? 10 + (e - 65) : e >= 97 && e <= 102 ? 10 + (e - 97) : e - 48;
}
ye.regexp_eatLegacyOctalEscapeSequence = function(e) {
  if (this.regexp_eatOctalDigit(e)) {
    var t = e.lastIntValue;
    if (this.regexp_eatOctalDigit(e)) {
      var n = e.lastIntValue;
      t <= 3 && this.regexp_eatOctalDigit(e) ? e.lastIntValue = t * 64 + n * 8 + e.lastIntValue : e.lastIntValue = t * 8 + n;
    } else
      e.lastIntValue = t;
    return !0;
  }
  return !1;
};
ye.regexp_eatOctalDigit = function(e) {
  var t = e.current();
  return Bh(t) ? (e.lastIntValue = t - 48, e.advance(), !0) : (e.lastIntValue = 0, !1);
};
function Bh(e) {
  return e >= 48 && e <= 55;
}
ye.regexp_eatFixedHexDigits = function(e, t) {
  var n = e.pos;
  e.lastIntValue = 0;
  for (var i = 0; i < t; ++i) {
    var r = e.current();
    if (!Rh(r))
      return e.pos = n, !1;
    e.lastIntValue = 16 * e.lastIntValue + Oh(r), e.advance();
  }
  return !0;
};
var So = function(t) {
  this.type = t.type, this.value = t.value, this.start = t.start, this.end = t.end, t.options.locations && (this.loc = new ys(t, t.startLoc, t.endLoc)), t.options.ranges && (this.range = [t.start, t.end]);
}, je = xt.prototype;
je.next = function(e) {
  !e && this.type.keyword && this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword), this.options.onToken && this.options.onToken(new So(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
};
je.getToken = function() {
  return this.next(), new So(this);
};
typeof Symbol < "u" && (je[Symbol.iterator] = function() {
  var e = this;
  return {
    next: function() {
      var t = e.getToken();
      return {
        done: t.type === A.eof,
        value: t
      };
    }
  };
});
je.nextToken = function() {
  var e = this.curContext();
  if ((!e || !e.preserveSpace) && this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length)
    return this.finishToken(A.eof);
  if (e.override)
    return e.override(this);
  this.readToken(this.fullCharCodeAtPos());
};
je.readToken = function(e) {
  return wn(e, this.options.ecmaVersion >= 6) || e === 92 ? this.readWord() : this.getTokenFromCode(e);
};
je.fullCharCodeAtPos = function() {
  var e = this.input.charCodeAt(this.pos);
  if (e <= 55295 || e >= 56320)
    return e;
  var t = this.input.charCodeAt(this.pos + 1);
  return t <= 56319 || t >= 57344 ? e : (e << 10) + t - 56613888;
};
je.skipBlockComment = function() {
  var e = this.options.onComment && this.curPosition(), t = this.pos, n = this.input.indexOf("*/", this.pos += 2);
  if (n === -1 && this.raise(this.pos - 2, "Unterminated comment"), this.pos = n + 2, this.options.locations)
    for (var i = void 0, r = t; (i = uh(this.input, r, this.pos)) > -1; )
      ++this.curLine, r = this.lineStart = i;
  this.options.onComment && this.options.onComment(
    !0,
    this.input.slice(t + 2, n),
    t,
    this.pos,
    e,
    this.curPosition()
  );
};
je.skipLineComment = function(e) {
  for (var t = this.pos, n = this.options.onComment && this.curPosition(), i = this.input.charCodeAt(this.pos += e); this.pos < this.input.length && !Ui(i); )
    i = this.input.charCodeAt(++this.pos);
  this.options.onComment && this.options.onComment(
    !1,
    this.input.slice(t + e, this.pos),
    t,
    this.pos,
    n,
    this.curPosition()
  );
};
je.skipSpace = function() {
  e: for (; this.pos < this.input.length; ) {
    var e = this.input.charCodeAt(this.pos);
    switch (e) {
      case 32:
      case 160:
        ++this.pos;
        break;
      case 13:
        this.input.charCodeAt(this.pos + 1) === 10 && ++this.pos;
      case 10:
      case 8232:
      case 8233:
        ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
        break;
      case 47:
        switch (this.input.charCodeAt(this.pos + 1)) {
          case 42:
            this.skipBlockComment();
            break;
          case 47:
            this.skipLineComment(2);
            break;
          default:
            break e;
        }
        break;
      default:
        if (e > 8 && e < 14 || e >= 5760 && ch.test(String.fromCharCode(e)))
          ++this.pos;
        else
          break e;
    }
  }
};
je.finishToken = function(e, t) {
  this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
  var n = this.type;
  this.type = e, this.value = t, this.updateContext(n);
};
je.readToken_dot = function() {
  var e = this.input.charCodeAt(this.pos + 1);
  if (e >= 48 && e <= 57)
    return this.readNumber(!0);
  var t = this.input.charCodeAt(this.pos + 2);
  return this.options.ecmaVersion >= 6 && e === 46 && t === 46 ? (this.pos += 3, this.finishToken(A.ellipsis)) : (++this.pos, this.finishToken(A.dot));
};
je.readToken_slash = function() {
  var e = this.input.charCodeAt(this.pos + 1);
  return this.exprAllowed ? (++this.pos, this.readRegexp()) : e === 61 ? this.finishOp(A.assign, 2) : this.finishOp(A.slash, 1);
};
je.readToken_mult_modulo_exp = function(e) {
  var t = this.input.charCodeAt(this.pos + 1), n = 1, i = e === 42 ? A.star : A.modulo;
  return this.options.ecmaVersion >= 7 && e === 42 && t === 42 && (++n, i = A.starstar, t = this.input.charCodeAt(this.pos + 2)), t === 61 ? this.finishOp(A.assign, n + 1) : this.finishOp(i, n);
};
je.readToken_pipe_amp = function(e) {
  var t = this.input.charCodeAt(this.pos + 1);
  if (t === e) {
    if (this.options.ecmaVersion >= 12) {
      var n = this.input.charCodeAt(this.pos + 2);
      if (n === 61)
        return this.finishOp(A.assign, 3);
    }
    return this.finishOp(e === 124 ? A.logicalOR : A.logicalAND, 2);
  }
  return t === 61 ? this.finishOp(A.assign, 2) : this.finishOp(e === 124 ? A.bitwiseOR : A.bitwiseAND, 1);
};
je.readToken_caret = function() {
  var e = this.input.charCodeAt(this.pos + 1);
  return e === 61 ? this.finishOp(A.assign, 2) : this.finishOp(A.bitwiseXOR, 1);
};
je.readToken_plus_min = function(e) {
  var t = this.input.charCodeAt(this.pos + 1);
  return t === e ? t === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 && (this.lastTokEnd === 0 || Ht.test(this.input.slice(this.lastTokEnd, this.pos))) ? (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : this.finishOp(A.incDec, 2) : t === 61 ? this.finishOp(A.assign, 2) : this.finishOp(A.plusMin, 1);
};
je.readToken_lt_gt = function(e) {
  var t = this.input.charCodeAt(this.pos + 1), n = 1;
  return t === e ? (n = e === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2, this.input.charCodeAt(this.pos + n) === 61 ? this.finishOp(A.assign, n + 1) : this.finishOp(A.bitShift, n)) : t === 33 && e === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 && this.input.charCodeAt(this.pos + 3) === 45 ? (this.skipLineComment(4), this.skipSpace(), this.nextToken()) : (t === 61 && (n = 2), this.finishOp(A.relational, n));
};
je.readToken_eq_excl = function(e) {
  var t = this.input.charCodeAt(this.pos + 1);
  return t === 61 ? this.finishOp(A.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) : e === 61 && t === 62 && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(A.arrow)) : this.finishOp(e === 61 ? A.eq : A.prefix, 1);
};
je.readToken_question = function() {
  var e = this.options.ecmaVersion;
  if (e >= 11) {
    var t = this.input.charCodeAt(this.pos + 1);
    if (t === 46) {
      var n = this.input.charCodeAt(this.pos + 2);
      if (n < 48 || n > 57)
        return this.finishOp(A.questionDot, 2);
    }
    if (t === 63) {
      if (e >= 12) {
        var i = this.input.charCodeAt(this.pos + 2);
        if (i === 61)
          return this.finishOp(A.assign, 3);
      }
      return this.finishOp(A.coalesce, 2);
    }
  }
  return this.finishOp(A.question, 1);
};
je.readToken_numberSign = function() {
  var e = this.options.ecmaVersion, t = 35;
  if (e >= 13 && (++this.pos, t = this.fullCharCodeAtPos(), wn(t, !0) || t === 92))
    return this.finishToken(A.privateId, this.readWord1());
  this.raise(this.pos, "Unexpected character '" + Rn(t) + "'");
};
je.getTokenFromCode = function(e) {
  switch (e) {
    // The interpretation of a dot depends on whether it is followed
    // by a digit or another two dots.
    case 46:
      return this.readToken_dot();
    // Punctuation tokens.
    case 40:
      return ++this.pos, this.finishToken(A.parenL);
    case 41:
      return ++this.pos, this.finishToken(A.parenR);
    case 59:
      return ++this.pos, this.finishToken(A.semi);
    case 44:
      return ++this.pos, this.finishToken(A.comma);
    case 91:
      return ++this.pos, this.finishToken(A.bracketL);
    case 93:
      return ++this.pos, this.finishToken(A.bracketR);
    case 123:
      return ++this.pos, this.finishToken(A.braceL);
    case 125:
      return ++this.pos, this.finishToken(A.braceR);
    case 58:
      return ++this.pos, this.finishToken(A.colon);
    case 96:
      if (this.options.ecmaVersion < 6)
        break;
      return ++this.pos, this.finishToken(A.backQuote);
    case 48:
      var t = this.input.charCodeAt(this.pos + 1);
      if (t === 120 || t === 88)
        return this.readRadixNumber(16);
      if (this.options.ecmaVersion >= 6) {
        if (t === 111 || t === 79)
          return this.readRadixNumber(8);
        if (t === 98 || t === 66)
          return this.readRadixNumber(2);
      }
    // Anything else beginning with a digit is an integer, octal
    // number, or float.
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return this.readNumber(!1);
    // Quotes produce strings.
    case 34:
    case 39:
      return this.readString(e);
    // Operators are parsed inline in tiny state machines. '=' (61) is
    // often referred to. `finishOp` simply skips the amount of
    // characters it is given as second argument, and returns a token
    // of the type given by its first argument.
    case 47:
      return this.readToken_slash();
    case 37:
    case 42:
      return this.readToken_mult_modulo_exp(e);
    case 124:
    case 38:
      return this.readToken_pipe_amp(e);
    case 94:
      return this.readToken_caret();
    case 43:
    case 45:
      return this.readToken_plus_min(e);
    case 60:
    case 62:
      return this.readToken_lt_gt(e);
    case 61:
    case 33:
      return this.readToken_eq_excl(e);
    case 63:
      return this.readToken_question();
    case 126:
      return this.finishOp(A.prefix, 1);
    case 35:
      return this.readToken_numberSign();
  }
  this.raise(this.pos, "Unexpected character '" + Rn(e) + "'");
};
je.finishOp = function(e, t) {
  var n = this.input.slice(this.pos, this.pos + t);
  return this.pos += t, this.finishToken(e, n);
};
je.readRegexp = function() {
  for (var e, t, n = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(n, "Unterminated regular expression");
    var i = this.input.charAt(this.pos);
    if (Ht.test(i) && this.raise(n, "Unterminated regular expression"), e)
      e = !1;
    else {
      if (i === "[")
        t = !0;
      else if (i === "]" && t)
        t = !1;
      else if (i === "/" && !t)
        break;
      e = i === "\\";
    }
    ++this.pos;
  }
  var r = this.input.slice(n, this.pos);
  ++this.pos;
  var a = this.pos, o = this.readWord1();
  this.containsEsc && this.unexpected(a);
  var l = this.regexpState || (this.regexpState = new Cn(this));
  l.reset(n, r, o), this.validateRegExpFlags(l), this.validateRegExpPattern(l);
  var u = null;
  try {
    u = new RegExp(r, o);
  } catch {
  }
  return this.finishToken(A.regexp, { pattern: r, flags: o, value: u });
};
je.readInt = function(e, t, n) {
  for (var i = this.options.ecmaVersion >= 12 && t === void 0, r = n && this.input.charCodeAt(this.pos) === 48, a = this.pos, o = 0, l = 0, u = 0, c = t ?? 1 / 0; u < c; ++u, ++this.pos) {
    var h = this.input.charCodeAt(this.pos), p = void 0;
    if (i && h === 95) {
      r && this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals"), l === 95 && this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore"), u === 0 && this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits"), l = h;
      continue;
    }
    if (h >= 97 ? p = h - 97 + 10 : h >= 65 ? p = h - 65 + 10 : h >= 48 && h <= 57 ? p = h - 48 : p = 1 / 0, p >= e)
      break;
    l = h, o = o * e + p;
  }
  return i && l === 95 && this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits"), this.pos === a || t != null && this.pos - a !== t ? null : o;
};
function dg(e, t) {
  return t ? parseInt(e, 8) : parseFloat(e.replace(/_/g, ""));
}
function zh(e) {
  return typeof BigInt != "function" ? null : BigInt(e.replace(/_/g, ""));
}
je.readRadixNumber = function(e) {
  var t = this.pos;
  this.pos += 2;
  var n = this.readInt(e);
  return n == null && this.raise(this.start + 2, "Expected number in radix " + e), this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110 ? (n = zh(this.input.slice(t, this.pos)), ++this.pos) : wn(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(A.num, n);
};
je.readNumber = function(e) {
  var t = this.pos;
  !e && this.readInt(10, void 0, !0) === null && this.raise(t, "Invalid number");
  var n = this.pos - t >= 2 && this.input.charCodeAt(t) === 48;
  n && this.strict && this.raise(t, "Invalid number");
  var i = this.input.charCodeAt(this.pos);
  if (!n && !e && this.options.ecmaVersion >= 11 && i === 110) {
    var r = zh(this.input.slice(t, this.pos));
    return ++this.pos, wn(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(A.num, r);
  }
  n && /[89]/.test(this.input.slice(t, this.pos)) && (n = !1), i === 46 && !n && (++this.pos, this.readInt(10), i = this.input.charCodeAt(this.pos)), (i === 69 || i === 101) && !n && (i = this.input.charCodeAt(++this.pos), (i === 43 || i === 45) && ++this.pos, this.readInt(10) === null && this.raise(t, "Invalid number")), wn(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
  var a = dg(this.input.slice(t, this.pos), n);
  return this.finishToken(A.num, a);
};
je.readCodePoint = function() {
  var e = this.input.charCodeAt(this.pos), t;
  if (e === 123) {
    this.options.ecmaVersion < 6 && this.unexpected();
    var n = ++this.pos;
    t = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, t > 1114111 && this.invalidStringToken(n, "Code point out of bounds");
  } else
    t = this.readHexChar(4);
  return t;
};
je.readString = function(e) {
  for (var t = "", n = ++this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
    var i = this.input.charCodeAt(this.pos);
    if (i === e)
      break;
    i === 92 ? (t += this.input.slice(n, this.pos), t += this.readEscapedChar(!1), n = this.pos) : i === 8232 || i === 8233 ? (this.options.ecmaVersion < 10 && this.raise(this.start, "Unterminated string constant"), ++this.pos, this.options.locations && (this.curLine++, this.lineStart = this.pos)) : (Ui(i) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
  }
  return t += this.input.slice(n, this.pos++), this.finishToken(A.string, t);
};
var jh = {};
je.tryReadTemplateToken = function() {
  this.inTemplateElement = !0;
  try {
    this.readTmplToken();
  } catch (e) {
    if (e === jh)
      this.readInvalidTemplateToken();
    else
      throw e;
  }
  this.inTemplateElement = !1;
};
je.invalidStringToken = function(e, t) {
  if (this.inTemplateElement && this.options.ecmaVersion >= 9)
    throw jh;
  this.raise(e, t);
};
je.readTmplToken = function() {
  for (var e = "", t = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
    var n = this.input.charCodeAt(this.pos);
    if (n === 96 || n === 36 && this.input.charCodeAt(this.pos + 1) === 123)
      return this.pos === this.start && (this.type === A.template || this.type === A.invalidTemplate) ? n === 36 ? (this.pos += 2, this.finishToken(A.dollarBraceL)) : (++this.pos, this.finishToken(A.backQuote)) : (e += this.input.slice(t, this.pos), this.finishToken(A.template, e));
    if (n === 92)
      e += this.input.slice(t, this.pos), e += this.readEscapedChar(!0), t = this.pos;
    else if (Ui(n)) {
      switch (e += this.input.slice(t, this.pos), ++this.pos, n) {
        case 13:
          this.input.charCodeAt(this.pos) === 10 && ++this.pos;
        case 10:
          e += `
`;
          break;
        default:
          e += String.fromCharCode(n);
          break;
      }
      this.options.locations && (++this.curLine, this.lineStart = this.pos), t = this.pos;
    } else
      ++this.pos;
  }
};
je.readInvalidTemplateToken = function() {
  for (; this.pos < this.input.length; this.pos++)
    switch (this.input[this.pos]) {
      case "\\":
        ++this.pos;
        break;
      case "$":
        if (this.input[this.pos + 1] !== "{")
          break;
      // fall through
      case "`":
        return this.finishToken(A.invalidTemplate, this.input.slice(this.start, this.pos));
      case "\r":
        this.input[this.pos + 1] === `
` && ++this.pos;
      // fall through
      case `
`:
      case "\u2028":
      case "\u2029":
        ++this.curLine, this.lineStart = this.pos + 1;
        break;
    }
  this.raise(this.start, "Unterminated template");
};
je.readEscapedChar = function(e) {
  var t = this.input.charCodeAt(++this.pos);
  switch (++this.pos, t) {
    case 110:
      return `
`;
    // 'n' -> '\n'
    case 114:
      return "\r";
    // 'r' -> '\r'
    case 120:
      return String.fromCharCode(this.readHexChar(2));
    // 'x'
    case 117:
      return Rn(this.readCodePoint());
    // 'u'
    case 116:
      return "	";
    // 't' -> '\t'
    case 98:
      return "\b";
    // 'b' -> '\b'
    case 118:
      return "\v";
    // 'v' -> '\u000b'
    case 102:
      return "\f";
    // 'f' -> '\f'
    case 13:
      this.input.charCodeAt(this.pos) === 10 && ++this.pos;
    // '\r\n'
    case 10:
      return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
    case 56:
    case 57:
      if (this.strict && this.invalidStringToken(
        this.pos - 1,
        "Invalid escape sequence"
      ), e) {
        var n = this.pos - 1;
        this.invalidStringToken(
          n,
          "Invalid escape sequence in template string"
        );
      }
    default:
      if (t >= 48 && t <= 55) {
        var i = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], r = parseInt(i, 8);
        return r > 255 && (i = i.slice(0, -1), r = parseInt(i, 8)), this.pos += i.length - 1, t = this.input.charCodeAt(this.pos), (i !== "0" || t === 56 || t === 57) && (this.strict || e) && this.invalidStringToken(
          this.pos - 1 - i.length,
          e ? "Octal literal in template string" : "Octal literal in strict mode"
        ), String.fromCharCode(r);
      }
      return Ui(t) ? (this.options.locations && (this.lineStart = this.pos, ++this.curLine), "") : String.fromCharCode(t);
  }
};
je.readHexChar = function(e) {
  var t = this.pos, n = this.readInt(16, e);
  return n === null && this.invalidStringToken(t, "Bad character escape sequence"), n;
};
je.readWord1 = function() {
  this.containsEsc = !1;
  for (var e = "", t = !0, n = this.pos, i = this.options.ecmaVersion >= 6; this.pos < this.input.length; ) {
    var r = this.fullCharCodeAtPos();
    if (Yn(r, i))
      this.pos += r <= 65535 ? 1 : 2;
    else if (r === 92) {
      this.containsEsc = !0, e += this.input.slice(n, this.pos);
      var a = this.pos;
      this.input.charCodeAt(++this.pos) !== 117 && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
      var o = this.readCodePoint();
      (t ? wn : Yn)(o, i) || this.invalidStringToken(a, "Invalid Unicode escape"), e += Rn(o), n = this.pos;
    } else
      break;
    t = !1;
  }
  return e + this.input.slice(n, this.pos);
};
je.readWord = function() {
  var e = this.readWord1(), t = A.name;
  return this.keywords.test(e) && (t = yo[e]), this.finishToken(t, e);
};
var fg = "8.15.0";
xt.acorn = {
  Parser: xt,
  version: fg,
  defaultOptions: Ha,
  Position: vr,
  SourceLocation: ys,
  getLineInfo: ph,
  Node: ks,
  TokenType: We,
  tokTypes: A,
  keywordTypes: yo,
  TokContext: an,
  tokContexts: rt,
  isIdentifierChar: Yn,
  isIdentifierStart: wn,
  Token: So,
  isNewLine: Ui,
  lineBreak: Ht,
  lineBreakG: F2,
  nonASCIIwhitespace: ch
};
const Lt = ti(/[A-Za-z]/), Pt = ti(/[\dA-Za-z]/), mg = ti(/[#-'*+\--9=?A-Z^-~]/);
function ds(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Ua = ti(/\d/), gg = ti(/[\dA-Fa-f]/), _g = ti(/[!-/:-@[-`{-~]/);
function me(e) {
  return e !== null && e < -2;
}
function Ue(e) {
  return e !== null && (e < 0 || e === 32);
}
function Le(e) {
  return e === -2 || e === -1 || e === 32;
}
const Ss = ti(/\p{P}|\p{S}/u), Vt = ti(/\s/);
function ti(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function Be(e, t, n, i) {
  const r = i ? i - 1 : Number.POSITIVE_INFINITY;
  let a = 0;
  return o;
  function o(u) {
    return Le(u) ? (e.enter(n), l(u)) : t(u);
  }
  function l(u) {
    return Le(u) && a++ < r ? (e.consume(u), l) : (e.exit(n), t(u));
  }
}
const xg = {}.hasOwnProperty, yg = Symbol("continue"), ta = Symbol("exit"), bg = Symbol("skip");
function vg(e, t) {
  let n, i;
  typeof t == "function" ? n = t : t && typeof t == "object" && (t.enter && (n = t.enter), t.leave && (i = t.leave)), r(e, void 0, void 0, [])();
  function r(a, o, l, u) {
    return na(a) && (c.displayName = "node (" + a.type + ")"), c;
    function c() {
      const h = n ? gu(n(a, o, l, u)) : [];
      if (h[0] === ta)
        return h;
      if (h[0] !== bg) {
        let p;
        for (p in a)
          if (xg.call(a, p) && a[p] && typeof a[p] == "object" && // @ts-expect-error: custom esast extension.
          p !== "data" && // @ts-expect-error: custom esast extension.
          p !== "position") {
            const m = u.concat(a), g = a[p];
            if (Array.isArray(g)) {
              const b = (
                /** @type {Array<unknown>} */
                g
              );
              let v = 0;
              for (; v > -1 && v < b.length; ) {
                const w = b[v];
                if (na(w)) {
                  const y = r(
                    w,
                    p,
                    v,
                    m
                  )();
                  if (y[0] === ta) return y;
                  v = typeof y[1] == "number" ? y[1] : v + 1;
                } else
                  v++;
              }
            } else if (na(g)) {
              const b = r(g, p, void 0, m)();
              if (b[0] === ta) return b;
            }
          }
      }
      return i ? gu(i(a, o, l, u)) : h;
    }
  }
}
function gu(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [yg, e] : [e];
}
function na(e) {
  return !!(e && typeof e == "object" && "type" in e && typeof e.type == "string" && e.type.length > 0);
}
function Hh(e, t) {
  const n = t.prefix || "", i = t.suffix || "", r = Object.assign({}, t.acornOptions), a = [], o = [], l = r.onComment, u = r.onToken;
  let c = !1, h, p;
  const m = Object.assign({}, r, {
    onComment: a,
    preserveParens: !0
  });
  u && (m.onToken = o);
  const g = wg(e, t.tokenTypes), b = g.value, v = n + b + i, w = t.expression && _u(b);
  if (w && !t.allowEmpty)
    throw new Xe("Unexpected empty expression", {
      place: I(0),
      ruleId: "unexpected-empty-expression",
      source: "micromark-extension-mdx-expression"
    });
  try {
    h = t.expression && !w ? t.acorn.parseExpressionAt(v, 0, m) : t.acorn.parse(v, m);
  } catch (E) {
    const P = (
      /** @type {AcornError} */
      E
    ), S = I(P.pos);
    P.message = String(P.message).replace(/ \(\d+:\d+\)$/, ""), P.pos = S.offset, P.loc = {
      line: S.line,
      column: S.column - 1
    }, p = P, c = P.raisedAt >= n.length + b.length || // Broken comments are raised at their start, not their end.
    P.message === "Unterminated comment";
  }
  if (h && t.expression && !w)
    if (_u(v.slice(h.end, v.length - i.length)))
      h = {
        type: "Program",
        start: 0,
        end: n.length + b.length,
        // @ts-expect-error: It’s good.
        body: [{
          type: "ExpressionStatement",
          expression: h,
          start: 0,
          end: n.length + b.length
        }],
        sourceType: "module",
        comments: []
      };
    else {
      const E = I(h.end), P = (
        /** @type {AcornError} */
        new Error("Unexpected content after expression")
      );
      P.pos = E.offset, P.loc = {
        line: E.line,
        column: E.column - 1
      }, p = P, h = void 0;
    }
  if (h) {
    if (h.comments = a, vg(h, function(E, P, S, f) {
      let C = (
        /** @type {AcornNode | Array<AcornNode>} */
        f[f.length - 1]
      ), L = P;
      E.type === "ParenthesizedExpression" && C && L && (typeof S == "number" && (C = C[L], L = S), C[L] = E.expression), y(E);
    }), Array.isArray(l))
      l.push(...a);
    else if (typeof l == "function")
      for (const E of a)
        l(E.type === "Block", E.value, E.start, E.end, E.loc.start, E.loc.end);
    for (const E of o)
      E.end <= n.length || E.start - n.length >= b.length || (y(E), Array.isArray(u) ? u.push(E) : u(E));
  }
  return {
    estree: h,
    error: p,
    swallow: c
  };
  function y(E) {
    const P = I(E.start), S = I(E.end);
    E.start = P.offset, E.end = S.offset, E.loc = {
      start: {
        line: P.line,
        column: P.column - 1,
        // @ts-expect-error: not allowed by acorn types.
        offset: P.offset
      },
      end: {
        line: S.line,
        column: S.column - 1,
        // @ts-expect-error: not allowed by acorn types.
        offset: S.offset
      }
    }, E.range = [E.start, E.end];
  }
  function I(E) {
    let P = E - n.length;
    P < 0 ? P = 0 : P > b.length && (P = b.length);
    let S = kg(g.stops, P);
    return S || (S = {
      line: t.start.line,
      column: t.start.column,
      offset: t.start.offset
    }), S;
  }
}
function _u(e) {
  return /^\s*$/.test(e.replace(/\/\*[\s\S]*?\*\//g, "").replace(/\/\/[^\r\n]*(\r\n|\n|\r)/g, ""));
}
function wg(e, t) {
  const n = {
    value: "",
    stops: []
  };
  let i = -1;
  for (; ++i < e.length; ) {
    const r = e[i];
    if (r[0] === "enter") {
      const a = r[1].type;
      if (a === "lineEnding" || t.includes(a)) {
        const o = r[2].sliceStream(r[1]);
        for (; o.length > 0 && o[0] === -1; )
          o.shift();
        const l = Cg(o);
        n.stops.push([n.value.length, r[1].start]), n.value += l, n.stops.push([n.value.length, r[1].end]);
      }
    }
  }
  return n;
}
function kg(e, t) {
  let n = 0;
  for (; n < e.length && e[n][0] <= t; )
    n += 1;
  if (n === 0)
    return;
  const [i, r] = e[n - 1], a = t - i;
  return {
    line: r.line,
    column: r.column + a,
    offset: r.offset + a
  };
}
function Cg(e) {
  let t = -1;
  const n = [];
  let i;
  for (; ++t < e.length; ) {
    const r = e[t];
    let a;
    if (typeof r == "string")
      a = r;
    else switch (r) {
      case -5: {
        a = "\r";
        break;
      }
      case -4: {
        a = `
`;
        break;
      }
      case -3: {
        a = `\r
`;
        break;
      }
      case -2: {
        a = "	";
        break;
      }
      /* c8 ignore next 6 */
      case -1: {
        if (i) continue;
        a = " ";
        break;
      }
      default:
        a = String.fromCharCode(r);
    }
    i = r === -2, n.push(a);
  }
  return n.join("");
}
function Vn(e) {
  const t = e || {}, n = t.loc || {}, i = t.range || [void 0, void 0], r = xu(n.start, i[0] || t.start), a = xu(n.end, i[1] || t.end);
  if (r && a)
    return { start: r, end: a };
}
function xu(e, t) {
  if (e && typeof e == "object") {
    const n = "line" in e ? ia(e.line) : void 0, i = "column" in e ? ia(e.column) : void 0;
    if (n && i !== void 0)
      return {
        line: n,
        column: i + 1,
        offset: ia(t)
      };
  }
}
function ia(e) {
  return typeof e == "number" && e > -1 ? e : void 0;
}
const Sg = 2, Di = "https://github.com/micromark/micromark-extension-mdx-expression/tree/main/packages/micromark-extension-mdx-expression", Eg = "#unexpected-end-of-file-in-expression-expected-a-corresponding-closing-brace-for-", Ag = "#unexpected-lazy-line-in-expression-in-container-expected-line-to-be-prefixed", yu = "#unexpected-type-in-code-expected-an-object-spread-spread", Ig = "#unexpected-extra-content-in-spread-only-a-single-spread-is-supported", Lg = "#could-not-parse-expression-with-acorn";
function fs(e, t, n, i, r, a, o, l, u, c, h) {
  const p = this, m = this.events.length + 3;
  let g = 0, b, v;
  return w;
  function w(P) {
    return e.enter(n), e.enter(i), e.consume(P), e.exit(i), b = p.now(), y;
  }
  function y(P) {
    if (P === null) {
      if (v) throw v;
      const S = new Xe("Unexpected end of file in expression, expected a corresponding closing brace for `{`", {
        place: p.now(),
        ruleId: "unexpected-eof",
        source: "micromark-extension-mdx-expression"
      });
      throw S.url = Di + Eg, S;
    }
    if (me(P))
      return e.enter("lineEnding"), e.consume(P), e.exit("lineEnding"), E;
    if (P === 125 && g === 0) {
      const S = a ? Pg.call(p, a, o, r, m, b, c || !1, u || !1) : {
        type: "ok",
        estree: void 0
      };
      if (S.type === "ok") {
        e.enter(i), e.consume(P), e.exit(i);
        const f = e.exit(n);
        return l && S.estree && Object.assign(f, {
          estree: S.estree
        }), t;
      }
      return v = S.message, e.enter(r), e.consume(P), I;
    }
    return e.enter(r), I(P);
  }
  function I(P) {
    return P === 125 && g === 0 || P === null || me(P) ? (e.exit(r), y(P)) : (P === 123 && !a ? g += 1 : P === 125 && (g -= 1), e.consume(P), I);
  }
  function E(P) {
    const S = p.now();
    if (S.line !== b.line && !h && p.parser.lazy[S.line]) {
      const f = new Xe("Unexpected lazy line in expression in container, expected line to be prefixed with `>` when in a block quote, whitespace when in a list, etc", {
        place: p.now(),
        ruleId: "unexpected-lazy",
        source: "micromark-extension-mdx-expression"
      });
      throw f.url = Di + Ag, f;
    }
    return Le(P) ? Be(e, y, "linePrefix", Sg + 1)(P) : y(P);
  }
}
function Pg(e, t, n, i, r, a, o) {
  const l = Hh(this.events.slice(i), {
    acorn: e,
    tokenTypes: [n],
    acornOptions: t,
    start: r,
    expression: !0,
    allowEmpty: a,
    prefix: o ? "({" : "",
    suffix: o ? "})" : ""
  }), u = l.estree;
  if (o && u) {
    const c = u.body[0];
    if (c.type !== "ExpressionStatement" || c.expression.type !== "ObjectExpression") {
      const h = Vn(c), p = new Xe("Unexpected `" + c.type + "` in code: expected an object spread (`{...spread}`)", {
        place: h.start,
        ruleId: "non-spread",
        source: "micromark-extension-mdx-expression"
      });
      throw p.url = Di + yu, p;
    }
    if (c.expression.properties[1]) {
      const h = Vn(c.expression.properties[1]), p = new Xe("Unexpected extra content in spread: only a single spread is supported", {
        place: h.start,
        ruleId: "spread-extra",
        source: "micromark-extension-mdx-expression"
      });
      throw p.url = Di + Ig, p;
    }
    if (c.expression.properties[0] && c.expression.properties[0].type !== "SpreadElement") {
      const h = Vn(c.expression.properties[0]), p = new Xe("Unexpected `" + c.expression.properties[0].type + "` in code: only spread elements are supported", {
        place: h.start,
        ruleId: "non-spread",
        source: "micromark-extension-mdx-expression"
      });
      throw p.url = Di + yu, p;
    }
  }
  if (l.error) {
    const c = new Xe("Could not parse expression with acorn", {
      cause: l.error,
      place: {
        line: l.error.loc.line,
        column: l.error.loc.column + 1,
        offset: l.error.pos
      },
      ruleId: "acorn",
      source: "micromark-extension-mdx-expression"
    });
    return c.url = Di + Lg, {
      type: "nok",
      message: c
    };
  }
  return {
    type: "ok",
    estree: u
  };
}
function Tg(e) {
  const t = e || {}, n = t.addResult, i = t.acorn, r = t.spread;
  let a = t.allowEmpty, o;
  if (a == null && (a = !0), i) {
    if (!i.parseExpressionAt)
      throw new Error("Expected a proper `acorn` instance passed in as `options.acorn`");
    o = Object.assign({
      ecmaVersion: 2024,
      sourceType: "module"
    }, t.acornOptions);
  } else if (t.acornOptions || t.addResult)
    throw new Error("Expected an `acorn` instance passed in as `options.acorn`");
  return {
    flow: {
      123: {
        name: "mdxFlowExpression",
        tokenize: l,
        concrete: !0
      }
    },
    text: {
      123: {
        name: "mdxTextExpression",
        tokenize: u
      }
    }
  };
  function l(c, h, p) {
    const m = this;
    return g;
    function g(y) {
      return b(y);
    }
    function b(y) {
      return fs.call(m, c, v, "mdxFlowExpression", "mdxFlowExpressionMarker", "mdxFlowExpressionChunk", i, o, n, r, a)(y);
    }
    function v(y) {
      return Le(y) ? Be(c, w, "whitespace")(y) : w(y);
    }
    function w(y) {
      const I = m.parser.constructs.flow[60], P = (Array.isArray(I) ? I : (
        /* c8 ignore next 3 -- always a list when normalized. */
        I ? [I] : []
      )).find(function(S) {
        return S.name === "mdxJsxFlowTag";
      });
      return y === 60 && P ? c.attempt(P, w, p)(y) : y === null || me(y) ? h(y) : p(y);
    }
  }
  function u(c, h) {
    const p = this;
    return m;
    function m(g) {
      return fs.call(p, c, h, "mdxTextExpression", "mdxTextExpressionMarker", "mdxTextExpressionChunk", i, o, n, r, a, !0)(g);
    }
  }
}
const bu = "https://github.com/micromark/micromark-extension-mdx-jsx";
function $h(e, t, n, i, r, a, o, l, u, c, h, p, m, g, b, v, w, y, I, E, P, S, f, C, L, F, M, z, R, j, H, O) {
  const X = this;
  let K, se;
  return Y;
  function Y(T) {
    return e.enter(l), e.enter(u), e.consume(T), e.exit(u), N;
  }
  function N(T) {
    return Ue(T) ? n(T) : (K = ue, De(T));
  }
  function ue(T) {
    if (T === 47)
      return e.enter(c), e.consume(T), e.exit(c), K = ie, De;
    if (T === 62)
      return qe(T);
    if (T !== null && T >= 0 && sn(T))
      return e.enter(p), e.enter(m), e.consume(T), V;
    G(T, "before name", "a character that can start a name, such as a letter, `$`, or `_`" + (T === 33 ? " (note: to create a comment in MDX, use `{/* text */}`)" : ""));
  }
  function ie(T) {
    if (T === 62)
      return qe(T);
    if (T !== null && T >= 0 && sn(T))
      return e.enter(p), e.enter(m), e.consume(T), V;
    G(T, "before name", "a character that can start a name, such as a letter, `$`, or `_`" + (T === 42 || T === 47 ? " (note: JS comments in JSX tags are not supported in MDX)" : ""));
  }
  function V(T) {
    if (T !== null && T >= 0 && rr(T, {
      jsx: !0
    }))
      return e.consume(T), V;
    if (T === 46 || T === 47 || T === 58 || T === 62 || T === 123 || Ue(T) || Vt(T))
      return e.exit(m), K = de, De(T);
    G(T, "in name", "a name character such as letters, digits, `$`, or `_`; whitespace before attributes; or the end of the tag" + (T === 64 ? " (note: to create a link in MDX, use `[text](url)`)" : ""));
  }
  function de(T) {
    if (T === 46)
      return e.enter(g), e.consume(T), e.exit(g), K = Se, De;
    if (T === 58)
      return e.enter(v), e.consume(T), e.exit(v), K = ne, De;
    if (T === 47 || T === 62 || T === 123 || T !== null && T >= 0 && sn(T))
      return e.exit(p), te(T);
    G(T, "after name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function Se(T) {
    if (T !== null && T >= 0 && sn(T))
      return e.enter(b), e.consume(T), W;
    G(T, "before member name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function W(T) {
    if (T !== null && T >= 0 && rr(T, {
      jsx: !0
    }))
      return e.consume(T), W;
    if (T === 46 || T === 47 || T === 62 || T === 123 || Ue(T) || Vt(T))
      return e.exit(b), K = q, De(T);
    G(T, "in member name", "a name character such as letters, digits, `$`, or `_`; whitespace before attributes; or the end of the tag" + (T === 64 ? " (note: to create a link in MDX, use `[text](url)`)" : ""));
  }
  function q(T) {
    if (T === 46)
      return e.enter(g), e.consume(T), e.exit(g), K = Se, De;
    if (T === 47 || T === 62 || T === 123 || T !== null && T >= 0 && sn(T))
      return e.exit(p), te(T);
    G(T, "after member name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function ne(T) {
    if (T !== null && T >= 0 && sn(T))
      return e.enter(w), e.consume(T), ee;
    G(T, "before local name", "a character that can start a name, such as a letter, `$`, or `_`" + (T === 43 || T !== null && T > 46 && T < 58 ? " (note: to create a link in MDX, use `[text](url)`)" : ""));
  }
  function ee(T) {
    if (T !== null && T >= 0 && rr(T, {
      jsx: !0
    }))
      return e.consume(T), ee;
    if (T === 47 || T === 62 || T === 123 || Ue(T) || Vt(T))
      return e.exit(w), K = ge, De(T);
    G(T, "in local name", "a name character such as letters, digits, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function ge(T) {
    if (T === 47 || T === 62 || T === 123 || T !== null && T >= 0 && sn(T))
      return e.exit(p), te(T);
    G(T, "after local name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function te(T) {
    if (T === 47)
      return e.enter(h), e.consume(T), e.exit(h), K = Ve, De;
    if (T === 62)
      return qe(T);
    if (T === 123)
      return fs.call(X, e, _e, y, I, E, i, r, a, !0, !1, o)(T);
    if (T !== null && T >= 0 && sn(T))
      return e.enter(P), e.enter(S), e.enter(f), e.consume(T), Te;
    G(T, "before attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function _e(T) {
    return K = te, De(T);
  }
  function Te(T) {
    if (T !== null && T >= 0 && rr(T, {
      jsx: !0
    }))
      return e.consume(T), Te;
    if (T === 47 || T === 58 || T === 61 || T === 62 || T === 123 || Ue(T) || Vt(T))
      return e.exit(f), K = Ye, De(T);
    G(T, "in attribute name", "an attribute name character such as letters, digits, `$`, or `_`; `=` to initialize a value; whitespace before attributes; or the end of the tag");
  }
  function Ye(T) {
    if (T === 58)
      return e.enter(C), e.consume(T), e.exit(C), K = ot, De;
    if (T === 61)
      return e.exit(S), e.enter(F), e.consume(T), e.exit(F), K = Oe, De;
    if (T === 47 || T === 62 || T === 123 || Ue(T) || Vt(T) || T !== null && T >= 0 && sn(T))
      return e.exit(S), e.exit(P), K = te, De(T);
    G(T, "after attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; `=` to initialize a value; or the end of the tag");
  }
  function ot(T) {
    if (T !== null && T >= 0 && sn(T))
      return e.enter(L), e.consume(T), Ze;
    G(T, "before local attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; `=` to initialize a value; or the end of the tag");
  }
  function Ze(T) {
    if (T !== null && T >= 0 && rr(T, {
      jsx: !0
    }))
      return e.consume(T), Ze;
    if (T === 47 || T === 61 || T === 62 || T === 123 || Ue(T) || Vt(T))
      return e.exit(L), e.exit(S), K = ht, De(T);
    G(T, "in local attribute name", "an attribute name character such as letters, digits, `$`, or `_`; `=` to initialize a value; whitespace before attributes; or the end of the tag");
  }
  function ht(T) {
    if (T === 61)
      return e.enter(F), e.consume(T), e.exit(F), K = Oe, De;
    if (T === 47 || T === 62 || T === 123 || T !== null && T >= 0 && sn(T))
      return e.exit(P), te(T);
    G(T, "after local attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; `=` to initialize a value; or the end of the tag");
  }
  function Oe(T) {
    if (T === 34 || T === 39)
      return e.enter(M), e.enter(z), e.consume(T), e.exit(z), se = T, Ct;
    if (T === 123)
      return fs.call(X, e, ft, j, H, O, i, r, a, !1, !1, o)(T);
    G(T, "before attribute value", "a character that can start an attribute value, such as `\"`, `'`, or `{`" + (T === 60 ? " (note: to use an element or fragment as a prop value in MDX, use `{<element />}`)" : ""));
  }
  function ft(T) {
    return e.exit(P), K = te, De(T);
  }
  function Ct(T) {
    return T === null && G(T, "in attribute value", "a corresponding closing quote `" + String.fromCodePoint(se) + "`"), T === se ? (e.enter(z), e.consume(T), e.exit(z), e.exit(M), e.exit(P), se = void 0, K = te, De) : me(T) ? (K = Ct, De(T)) : (e.enter(R), St(T));
  }
  function St(T) {
    return T === null || T === se || me(T) ? (e.exit(R), Ct(T)) : (e.consume(T), St);
  }
  function Ve(T) {
    if (T === 62)
      return qe(T);
    G(T, "after self-closing slash", "`>` to end the tag" + (T === 42 || T === 47 ? " (note: JS comments in JSX tags are not supported in MDX)" : ""));
  }
  function qe(T) {
    return e.enter(u), e.consume(T), e.exit(u), e.exit(l), t;
  }
  function De(T) {
    return me(T) ? (e.enter("lineEnding"), e.consume(T), e.exit("lineEnding"), Z) : Le(T) || Vt(T) ? (e.enter("esWhitespace"), An(T)) : K(T);
  }
  function An(T) {
    return me(T) ? (e.exit("esWhitespace"), De(T)) : Le(T) || Vt(T) ? (e.consume(T), An) : (e.exit("esWhitespace"), K(T));
  }
  function Z(T) {
    if (!o && X.parser.lazy[X.now().line]) {
      const Ce = new Xe("Unexpected lazy line in container, expected line to be prefixed with `>` when in a block quote, whitespace when in a list, etc", X.now(), "micromark-extension-mdx-jsx:unexpected-lazy");
      throw Ce.url = bu + "#unexpected-lazy-line-in-container-expected-line-to-be", Ce;
    }
    return De(T);
  }
  function G(T, Ce, Je) {
    const ut = new Xe("Unexpected " + (T === null ? "end of file" : "character `" + (T === 96 ? "` ` `" : String.fromCodePoint(T)) + "` (" + Ng(T) + ")") + " " + Ce + ", expected " + Je, X.now(), "micromark-extension-mdx-jsx:unexpected-" + (T === null ? "eof" : "character"));
    throw ut.url = bu + (T === null ? "#unexpected-end-of-file-at-expected-expect" : "#unexpected-character-at-expected-expect"), ut;
  }
}
function Ng(e) {
  return "U+" + e.toString(16).toUpperCase().padStart(4, "0");
}
function Dg(e, t) {
  return {
    name: "mdxJsxTextTag",
    tokenize: n
  };
  function n(i, r, a) {
    return $h.call(this, i, r, a, e, t.acornOptions, t.addResult, !0, "mdxJsxTextTag", "mdxJsxTextTagMarker", "mdxJsxTextTagClosingMarker", "mdxJsxTextTagSelfClosingMarker", "mdxJsxTextTagName", "mdxJsxTextTagNamePrimary", "mdxJsxTextTagNameMemberMarker", "mdxJsxTextTagNameMember", "mdxJsxTextTagNamePrefixMarker", "mdxJsxTextTagNameLocal", "mdxJsxTextTagExpressionAttribute", "mdxJsxTextTagExpressionAttributeMarker", "mdxJsxTextTagExpressionAttributeValue", "mdxJsxTextTagAttribute", "mdxJsxTextTagAttributeName", "mdxJsxTextTagAttributeNamePrimary", "mdxJsxTextTagAttributeNamePrefixMarker", "mdxJsxTextTagAttributeNameLocal", "mdxJsxTextTagAttributeInitializerMarker", "mdxJsxTextTagAttributeValueLiteral", "mdxJsxTextTagAttributeValueLiteralMarker", "mdxJsxTextTagAttributeValueLiteralValue", "mdxJsxTextTagAttributeValueExpression", "mdxJsxTextTagAttributeValueExpressionMarker", "mdxJsxTextTagAttributeValueExpressionValue");
  }
}
function Vg(e, t) {
  return {
    concrete: !0,
    name: "mdxJsxFlowTag",
    tokenize: n
  };
  function n(i, r, a) {
    const o = this;
    return l;
    function l(p) {
      return u(p);
    }
    function u(p) {
      return $h.call(o, i, c, a, e, t.acornOptions, t.addResult, !1, "mdxJsxFlowTag", "mdxJsxFlowTagMarker", "mdxJsxFlowTagClosingMarker", "mdxJsxFlowTagSelfClosingMarker", "mdxJsxFlowTagName", "mdxJsxFlowTagNamePrimary", "mdxJsxFlowTagNameMemberMarker", "mdxJsxFlowTagNameMember", "mdxJsxFlowTagNamePrefixMarker", "mdxJsxFlowTagNameLocal", "mdxJsxFlowTagExpressionAttribute", "mdxJsxFlowTagExpressionAttributeMarker", "mdxJsxFlowTagExpressionAttributeValue", "mdxJsxFlowTagAttribute", "mdxJsxFlowTagAttributeName", "mdxJsxFlowTagAttributeNamePrimary", "mdxJsxFlowTagAttributeNamePrefixMarker", "mdxJsxFlowTagAttributeNameLocal", "mdxJsxFlowTagAttributeInitializerMarker", "mdxJsxFlowTagAttributeValueLiteral", "mdxJsxFlowTagAttributeValueLiteralMarker", "mdxJsxFlowTagAttributeValueLiteralValue", "mdxJsxFlowTagAttributeValueExpression", "mdxJsxFlowTagAttributeValueExpressionMarker", "mdxJsxFlowTagAttributeValueExpressionValue")(p);
    }
    function c(p) {
      return Le(p) ? Be(i, h, "whitespace")(p) : h(p);
    }
    function h(p) {
      const m = o.parser.constructs.flow[123], g = Array.isArray(m) ? m : m ? [m] : [];
      let b;
      for (const v of g)
        if (v.name === "mdxFlowExpression") {
          b = v;
          break;
        }
      return p === 60 ? (
        // We can’t just say: fine. Lines of blocks have to be parsed until an eol/eof.
        l(p)
      ) : p === 123 && b ? i.attempt(b, h, a)(p) : p === null || me(p) ? r(p) : a(p);
    }
  }
}
function Mg(e) {
  const t = e || {}, n = t.acorn;
  let i;
  if (n) {
    if (!n.parse || !n.parseExpressionAt)
      throw new Error("Expected a proper `acorn` instance passed in as `options.acorn`");
    i = Object.assign({
      ecmaVersion: 2024,
      sourceType: "module"
    }, t.acornOptions, {
      locations: !0
    });
  } else if (t.acornOptions || t.addResult)
    throw new Error("Expected an `acorn` instance passed in as `options.acorn`");
  return {
    flow: {
      60: Vg(n || void 0, {
        acornOptions: i,
        addResult: t.addResult || void 0
      })
    },
    text: {
      60: Dg(n || void 0, {
        acornOptions: i,
        addResult: t.addResult || void 0
      })
    }
  };
}
function Fg() {
  return {
    disable: { null: ["autolink", "codeIndented", "htmlFlow", "htmlText"] }
  };
}
function Wt(e, t, n, i) {
  const r = e.length;
  let a = 0, o;
  if (t < 0 ? t = -t > r ? 0 : r + t : t = t > r ? r : t, n = n > 0 ? n : 0, i.length < 1e4)
    o = Array.from(i), o.unshift(t, n), e.splice(...o);
  else
    for (n && e.splice(t, n); a < i.length; )
      o = i.slice(a, a + 1e4), o.unshift(t, 0), e.splice(...o), a += 1e4, t += 1e4;
}
function en(e, t) {
  return e.length > 0 ? (Wt(e, e.length, 0, t), e) : t;
}
function Ri(e) {
  if (e === null || Ue(e) || Vt(e))
    return 1;
  if (Ss(e))
    return 2;
}
function Es(e, t, n) {
  const i = [];
  let r = -1;
  for (; ++r < e.length; ) {
    const a = e[r].resolveAll;
    a && !i.includes(a) && (t = a(t, n), i.push(a));
  }
  return t;
}
const Ja = {
  name: "attention",
  resolveAll: Rg,
  tokenize: Og
};
function Rg(e, t) {
  let n = -1, i, r, a, o, l, u, c, h;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (i = n; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        t.sliceSerialize(e[i][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          u = e[i][1].end.offset - e[i][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const p = {
            ...e[i][1].end
          }, m = {
            ...e[n][1].start
          };
          vu(p, -u), vu(m, u), o = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: p,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[n][1].start
            },
            end: m
          }, a = {
            type: u > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[n][1].start
            }
          }, r = {
            type: u > 1 ? "strong" : "emphasis",
            start: {
              ...o.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...o.start
          }, e[n][1].start = {
            ...l.end
          }, c = [], e[i][1].end.offset - e[i][1].start.offset && (c = en(c, [["enter", e[i][1], t], ["exit", e[i][1], t]])), c = en(c, [["enter", r, t], ["enter", o, t], ["exit", o, t], ["enter", a, t]]), c = en(c, Es(t.parser.constructs.insideSpan.null, e.slice(i + 1, n), t)), c = en(c, [["exit", a, t], ["enter", l, t], ["exit", l, t], ["exit", r, t]]), e[n][1].end.offset - e[n][1].start.offset ? (h = 2, c = en(c, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : h = 0, Wt(e, i - 1, n - i + 3, c), n = i + c.length - h - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function Og(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, i = this.previous, r = Ri(i);
  let a;
  return o;
  function o(u) {
    return a = u, e.enter("attentionSequence"), l(u);
  }
  function l(u) {
    if (u === a)
      return e.consume(u), l;
    const c = e.exit("attentionSequence"), h = Ri(u), p = !h || h === 2 && r || n.includes(u), m = !r || r === 2 && h || n.includes(i);
    return c._open = !!(a === 42 ? p : p && (r || !m)), c._close = !!(a === 42 ? m : m && (h || !p)), t(u);
  }
}
function vu(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const Bg = {
  name: "autolink",
  tokenize: zg
};
function zg(e, t, n) {
  let i = 0;
  return r;
  function r(g) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), a;
  }
  function a(g) {
    return Lt(g) ? (e.consume(g), o) : g === 64 ? n(g) : c(g);
  }
  function o(g) {
    return g === 43 || g === 45 || g === 46 || Pt(g) ? (i = 1, l(g)) : c(g);
  }
  function l(g) {
    return g === 58 ? (e.consume(g), i = 0, u) : (g === 43 || g === 45 || g === 46 || Pt(g)) && i++ < 32 ? (e.consume(g), l) : (i = 0, c(g));
  }
  function u(g) {
    return g === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.exit("autolink"), t) : g === null || g === 32 || g === 60 || ds(g) ? n(g) : (e.consume(g), u);
  }
  function c(g) {
    return g === 64 ? (e.consume(g), h) : mg(g) ? (e.consume(g), c) : n(g);
  }
  function h(g) {
    return Pt(g) ? p(g) : n(g);
  }
  function p(g) {
    return g === 46 ? (e.consume(g), i = 0, h) : g === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.exit("autolink"), t) : m(g);
  }
  function m(g) {
    if ((g === 45 || Pt(g)) && i++ < 63) {
      const b = g === 45 ? m : p;
      return e.consume(g), b;
    }
    return n(g);
  }
}
const Zi = {
  partial: !0,
  tokenize: jg
};
function jg(e, t, n) {
  return i;
  function i(a) {
    return Le(a) ? Be(e, r, "linePrefix")(a) : r(a);
  }
  function r(a) {
    return a === null || me(a) ? t(a) : n(a);
  }
}
const qh = {
  continuation: {
    tokenize: $g
  },
  exit: qg,
  name: "blockQuote",
  tokenize: Hg
};
function Hg(e, t, n) {
  const i = this;
  return r;
  function r(o) {
    if (o === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), a;
    }
    return n(o);
  }
  function a(o) {
    return Le(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(o));
  }
}
function $g(e, t, n) {
  const i = this;
  return r;
  function r(o) {
    return Le(o) ? Be(e, a, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o) : a(o);
  }
  function a(o) {
    return e.attempt(qh, t, n)(o);
  }
}
function qg(e) {
  e.exit("blockQuote");
}
const Uh = {
  name: "characterEscape",
  tokenize: Ug
};
function Ug(e, t, n) {
  return i;
  function i(a) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(a), e.exit("escapeMarker"), r;
  }
  function r(a) {
    return _g(a) ? (e.enter("characterEscapeValue"), e.consume(a), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(a);
  }
}
const Jh = {
  name: "characterReference",
  tokenize: Jg
};
function Jg(e, t, n) {
  const i = this;
  let r = 0, a, o;
  return l;
  function l(p) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(p), e.exit("characterReferenceMarker"), u;
  }
  function u(p) {
    return p === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(p), e.exit("characterReferenceMarkerNumeric"), c) : (e.enter("characterReferenceValue"), a = 31, o = Pt, h(p));
  }
  function c(p) {
    return p === 88 || p === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(p), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), a = 6, o = gg, h) : (e.enter("characterReferenceValue"), a = 7, o = Ua, h(p));
  }
  function h(p) {
    if (p === 59 && r) {
      const m = e.exit("characterReferenceValue");
      return o === Pt && !br(i.sliceSerialize(m)) ? n(p) : (e.enter("characterReferenceMarker"), e.consume(p), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return o(p) && r++ < a ? (e.consume(p), h) : n(p);
  }
}
const wu = {
  partial: !0,
  tokenize: Xg
}, ku = {
  concrete: !0,
  name: "codeFenced",
  tokenize: Wg
};
function Wg(e, t, n) {
  const i = this, r = {
    partial: !0,
    tokenize: S
  };
  let a = 0, o = 0, l;
  return u;
  function u(f) {
    return c(f);
  }
  function c(f) {
    const C = i.events[i.events.length - 1];
    return a = C && C[1].type === "linePrefix" ? C[2].sliceSerialize(C[1], !0).length : 0, l = f, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), h(f);
  }
  function h(f) {
    return f === l ? (o++, e.consume(f), h) : o < 3 ? n(f) : (e.exit("codeFencedFenceSequence"), Le(f) ? Be(e, p, "whitespace")(f) : p(f));
  }
  function p(f) {
    return f === null || me(f) ? (e.exit("codeFencedFence"), i.interrupt ? t(f) : e.check(wu, v, P)(f)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), m(f));
  }
  function m(f) {
    return f === null || me(f) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), p(f)) : Le(f) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), Be(e, g, "whitespace")(f)) : f === 96 && f === l ? n(f) : (e.consume(f), m);
  }
  function g(f) {
    return f === null || me(f) ? p(f) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), b(f));
  }
  function b(f) {
    return f === null || me(f) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), p(f)) : f === 96 && f === l ? n(f) : (e.consume(f), b);
  }
  function v(f) {
    return e.attempt(r, P, w)(f);
  }
  function w(f) {
    return e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), y;
  }
  function y(f) {
    return a > 0 && Le(f) ? Be(e, I, "linePrefix", a + 1)(f) : I(f);
  }
  function I(f) {
    return f === null || me(f) ? e.check(wu, v, P)(f) : (e.enter("codeFlowValue"), E(f));
  }
  function E(f) {
    return f === null || me(f) ? (e.exit("codeFlowValue"), I(f)) : (e.consume(f), E);
  }
  function P(f) {
    return e.exit("codeFenced"), t(f);
  }
  function S(f, C, L) {
    let F = 0;
    return M;
    function M(O) {
      return f.enter("lineEnding"), f.consume(O), f.exit("lineEnding"), z;
    }
    function z(O) {
      return f.enter("codeFencedFence"), Le(O) ? Be(f, R, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(O) : R(O);
    }
    function R(O) {
      return O === l ? (f.enter("codeFencedFenceSequence"), j(O)) : L(O);
    }
    function j(O) {
      return O === l ? (F++, f.consume(O), j) : F >= o ? (f.exit("codeFencedFenceSequence"), Le(O) ? Be(f, H, "whitespace")(O) : H(O)) : L(O);
    }
    function H(O) {
      return O === null || me(O) ? (f.exit("codeFencedFence"), C(O)) : L(O);
    }
  }
}
function Xg(e, t, n) {
  const i = this;
  return r;
  function r(o) {
    return o === null ? n(o) : (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a);
  }
  function a(o) {
    return i.parser.lazy[i.now().line] ? n(o) : t(o);
  }
}
const ra = {
  name: "codeIndented",
  tokenize: Gg
}, Zg = {
  partial: !0,
  tokenize: Kg
};
function Gg(e, t, n) {
  const i = this;
  return r;
  function r(c) {
    return e.enter("codeIndented"), Be(e, a, "linePrefix", 5)(c);
  }
  function a(c) {
    const h = i.events[i.events.length - 1];
    return h && h[1].type === "linePrefix" && h[2].sliceSerialize(h[1], !0).length >= 4 ? o(c) : n(c);
  }
  function o(c) {
    return c === null ? u(c) : me(c) ? e.attempt(Zg, o, u)(c) : (e.enter("codeFlowValue"), l(c));
  }
  function l(c) {
    return c === null || me(c) ? (e.exit("codeFlowValue"), o(c)) : (e.consume(c), l);
  }
  function u(c) {
    return e.exit("codeIndented"), t(c);
  }
}
function Kg(e, t, n) {
  const i = this;
  return r;
  function r(o) {
    return i.parser.lazy[i.now().line] ? n(o) : me(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), r) : Be(e, a, "linePrefix", 5)(o);
  }
  function a(o) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(o) : me(o) ? r(o) : n(o);
  }
}
const Yg = {
  name: "codeText",
  previous: e_,
  resolve: Qg,
  tokenize: t_
};
function Qg(e) {
  let t = e.length - 4, n = 3, i, r;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (i = n; ++i < t; )
      if (e[i][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (i = n - 1, t++; ++i <= t; )
    r === void 0 ? i !== t && e[i][1].type !== "lineEnding" && (r = i) : (i === t || e[i][1].type === "lineEnding") && (e[r][1].type = "codeTextData", i !== r + 2 && (e[r][1].end = e[i - 1][1].end, e.splice(r + 2, i - r - 2), t -= i - r - 2, i = r + 2), r = void 0);
  return e;
}
function e_(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function t_(e, t, n) {
  let i = 0, r, a;
  return o;
  function o(p) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(p);
  }
  function l(p) {
    return p === 96 ? (e.consume(p), i++, l) : (e.exit("codeTextSequence"), u(p));
  }
  function u(p) {
    return p === null ? n(p) : p === 32 ? (e.enter("space"), e.consume(p), e.exit("space"), u) : p === 96 ? (a = e.enter("codeTextSequence"), r = 0, h(p)) : me(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), u) : (e.enter("codeTextData"), c(p));
  }
  function c(p) {
    return p === null || p === 32 || p === 96 || me(p) ? (e.exit("codeTextData"), u(p)) : (e.consume(p), c);
  }
  function h(p) {
    return p === 96 ? (e.consume(p), r++, h) : r === i ? (e.exit("codeTextSequence"), e.exit("codeText"), t(p)) : (a.type = "codeTextData", c(p));
  }
}
class n_ {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const i = n ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(t, i) : t > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, i) {
    const r = n || 0;
    this.setCursor(Math.trunc(t));
    const a = this.right.splice(this.right.length - r, Number.POSITIVE_INFINITY);
    return i && or(this.left, i), a.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), or(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), or(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        or(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        or(this.left, n.reverse());
      }
  }
}
function or(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function Wh(e) {
  const t = {};
  let n = -1, i, r, a, o, l, u, c;
  const h = new n_(e);
  for (; ++n < h.length; ) {
    for (; n in t; )
      n = t[n];
    if (i = h.get(n), n && i[1].type === "chunkFlow" && h.get(n - 1)[1].type === "listItemPrefix" && (u = i[1]._tokenizer.events, a = 0, a < u.length && u[a][1].type === "lineEndingBlank" && (a += 2), a < u.length && u[a][1].type === "content"))
      for (; ++a < u.length && u[a][1].type !== "content"; )
        u[a][1].type === "chunkText" && (u[a][1]._isInFirstContentOfListItem = !0, a++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(t, i_(h, n)), n = t[n], c = !0);
    else if (i[1]._container) {
      for (a = n, r = void 0; a--; )
        if (o = h.get(a), o[1].type === "lineEnding" || o[1].type === "lineEndingBlank")
          o[0] === "enter" && (r && (h.get(r)[1].type = "lineEndingBlank"), o[1].type = "lineEnding", r = a);
        else if (!(o[1].type === "linePrefix" || o[1].type === "listItemIndent")) break;
      r && (i[1].end = {
        ...h.get(r)[1].start
      }, l = h.slice(r, n), l.unshift(i), h.splice(r, n - r + 1, l));
    }
  }
  return Wt(e, 0, Number.POSITIVE_INFINITY, h.slice(0)), !c;
}
function i_(e, t) {
  const n = e.get(t)[1], i = e.get(t)[2];
  let r = t - 1;
  const a = [];
  let o = n._tokenizer;
  o || (o = i.parser[n.contentType](n.start), n._contentTypeTextTrailing && (o._contentTypeTextTrailing = !0));
  const l = o.events, u = [], c = {};
  let h, p, m = -1, g = n, b = 0, v = 0;
  const w = [v];
  for (; g; ) {
    for (; e.get(++r)[1] !== g; )
      ;
    a.push(r), g._tokenizer || (h = i.sliceStream(g), g.next || h.push(null), p && o.defineSkip(g.start), g._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(h), g._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), p = g, g = g.next;
  }
  for (g = n; ++m < l.length; )
    // Find a void token that includes a break.
    l[m][0] === "exit" && l[m - 1][0] === "enter" && l[m][1].type === l[m - 1][1].type && l[m][1].start.line !== l[m][1].end.line && (v = m + 1, w.push(v), g._tokenizer = void 0, g.previous = void 0, g = g.next);
  for (o.events = [], g ? (g._tokenizer = void 0, g.previous = void 0) : w.pop(), m = w.length; m--; ) {
    const y = l.slice(w[m], w[m + 1]), I = a.pop();
    u.push([I, I + y.length - 1]), e.splice(I, 2, y);
  }
  for (u.reverse(), m = -1; ++m < u.length; )
    c[b + u[m][0]] = b + u[m][1], b += u[m][1] - u[m][0] - 1;
  return c;
}
const r_ = {
  resolve: a_,
  tokenize: o_
}, s_ = {
  partial: !0,
  tokenize: l_
};
function a_(e) {
  return Wh(e), e;
}
function o_(e, t) {
  let n;
  return i;
  function i(l) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), r(l);
  }
  function r(l) {
    return l === null ? a(l) : me(l) ? e.check(s_, o, a)(l) : (e.consume(l), r);
  }
  function a(l) {
    return e.exit("chunkContent"), e.exit("content"), t(l);
  }
  function o(l) {
    return e.consume(l), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, r;
  }
}
function l_(e, t, n) {
  const i = this;
  return r;
  function r(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), Be(e, a, "linePrefix");
  }
  function a(o) {
    if (o === null || me(o))
      return n(o);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(o) : e.interrupt(i.parser.constructs.flow, n, t)(o);
  }
}
function Xh(e, t, n, i, r, a, o, l, u) {
  const c = u || Number.POSITIVE_INFINITY;
  let h = 0;
  return p;
  function p(y) {
    return y === 60 ? (e.enter(i), e.enter(r), e.enter(a), e.consume(y), e.exit(a), m) : y === null || y === 32 || y === 41 || ds(y) ? n(y) : (e.enter(i), e.enter(o), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), v(y));
  }
  function m(y) {
    return y === 62 ? (e.enter(a), e.consume(y), e.exit(a), e.exit(r), e.exit(i), t) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), g(y));
  }
  function g(y) {
    return y === 62 ? (e.exit("chunkString"), e.exit(l), m(y)) : y === null || y === 60 || me(y) ? n(y) : (e.consume(y), y === 92 ? b : g);
  }
  function b(y) {
    return y === 60 || y === 62 || y === 92 ? (e.consume(y), g) : g(y);
  }
  function v(y) {
    return !h && (y === null || y === 41 || Ue(y)) ? (e.exit("chunkString"), e.exit(l), e.exit(o), e.exit(i), t(y)) : h < c && y === 40 ? (e.consume(y), h++, v) : y === 41 ? (e.consume(y), h--, v) : y === null || y === 32 || y === 40 || ds(y) ? n(y) : (e.consume(y), y === 92 ? w : v);
  }
  function w(y) {
    return y === 40 || y === 41 || y === 92 ? (e.consume(y), v) : v(y);
  }
}
function Zh(e, t, n, i, r, a) {
  const o = this;
  let l = 0, u;
  return c;
  function c(g) {
    return e.enter(i), e.enter(r), e.consume(g), e.exit(r), e.enter(a), h;
  }
  function h(g) {
    return l > 999 || g === null || g === 91 || g === 93 && !u || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    g === 94 && !l && "_hiddenFootnoteSupport" in o.parser.constructs ? n(g) : g === 93 ? (e.exit(a), e.enter(r), e.consume(g), e.exit(r), e.exit(i), t) : me(g) ? (e.enter("lineEnding"), e.consume(g), e.exit("lineEnding"), h) : (e.enter("chunkString", {
      contentType: "string"
    }), p(g));
  }
  function p(g) {
    return g === null || g === 91 || g === 93 || me(g) || l++ > 999 ? (e.exit("chunkString"), h(g)) : (e.consume(g), u || (u = !Le(g)), g === 92 ? m : p);
  }
  function m(g) {
    return g === 91 || g === 92 || g === 93 ? (e.consume(g), l++, p) : p(g);
  }
}
function Gh(e, t, n, i, r, a) {
  let o;
  return l;
  function l(m) {
    return m === 34 || m === 39 || m === 40 ? (e.enter(i), e.enter(r), e.consume(m), e.exit(r), o = m === 40 ? 41 : m, u) : n(m);
  }
  function u(m) {
    return m === o ? (e.enter(r), e.consume(m), e.exit(r), e.exit(i), t) : (e.enter(a), c(m));
  }
  function c(m) {
    return m === o ? (e.exit(a), u(o)) : m === null ? n(m) : me(m) ? (e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), Be(e, c, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), h(m));
  }
  function h(m) {
    return m === o || m === null || me(m) ? (e.exit("chunkString"), c(m)) : (e.consume(m), m === 92 ? p : h);
  }
  function p(m) {
    return m === o || m === 92 ? (e.consume(m), h) : h(m);
  }
}
function gr(e, t) {
  let n;
  return i;
  function i(r) {
    return me(r) ? (e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), n = !0, i) : Le(r) ? Be(e, i, n ? "linePrefix" : "lineSuffix")(r) : t(r);
  }
}
function un(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const u_ = {
  name: "definition",
  tokenize: h_
}, c_ = {
  partial: !0,
  tokenize: p_
};
function h_(e, t, n) {
  const i = this;
  let r;
  return a;
  function a(g) {
    return e.enter("definition"), o(g);
  }
  function o(g) {
    return Zh.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(g);
  }
  function l(g) {
    return r = un(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), g === 58 ? (e.enter("definitionMarker"), e.consume(g), e.exit("definitionMarker"), u) : n(g);
  }
  function u(g) {
    return Ue(g) ? gr(e, c)(g) : c(g);
  }
  function c(g) {
    return Xh(
      e,
      h,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(g);
  }
  function h(g) {
    return e.attempt(c_, p, p)(g);
  }
  function p(g) {
    return Le(g) ? Be(e, m, "whitespace")(g) : m(g);
  }
  function m(g) {
    return g === null || me(g) ? (e.exit("definition"), i.parser.defined.push(r), t(g)) : n(g);
  }
}
function p_(e, t, n) {
  return i;
  function i(l) {
    return Ue(l) ? gr(e, r)(l) : n(l);
  }
  function r(l) {
    return Gh(e, a, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function a(l) {
    return Le(l) ? Be(e, o, "whitespace")(l) : o(l);
  }
  function o(l) {
    return l === null || me(l) ? t(l) : n(l);
  }
}
const d_ = {
  name: "hardBreakEscape",
  tokenize: f_
};
function f_(e, t, n) {
  return i;
  function i(a) {
    return e.enter("hardBreakEscape"), e.consume(a), r;
  }
  function r(a) {
    return me(a) ? (e.exit("hardBreakEscape"), t(a)) : n(a);
  }
}
const m_ = {
  name: "headingAtx",
  resolve: g_,
  tokenize: __
};
function g_(e, t) {
  let n = e.length - 2, i = 3, r, a;
  return e[i][1].type === "whitespace" && (i += 2), n - 2 > i && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (i === n - 1 || n - 4 > i && e[n - 2][1].type === "whitespace") && (n -= i + 1 === n ? 2 : 4), n > i && (r = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[n][1].end
  }, a = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, Wt(e, i, n - i + 1, [["enter", r, t], ["enter", a, t], ["exit", a, t], ["exit", r, t]])), e;
}
function __(e, t, n) {
  let i = 0;
  return r;
  function r(h) {
    return e.enter("atxHeading"), a(h);
  }
  function a(h) {
    return e.enter("atxHeadingSequence"), o(h);
  }
  function o(h) {
    return h === 35 && i++ < 6 ? (e.consume(h), o) : h === null || Ue(h) ? (e.exit("atxHeadingSequence"), l(h)) : n(h);
  }
  function l(h) {
    return h === 35 ? (e.enter("atxHeadingSequence"), u(h)) : h === null || me(h) ? (e.exit("atxHeading"), t(h)) : Le(h) ? Be(e, l, "whitespace")(h) : (e.enter("atxHeadingText"), c(h));
  }
  function u(h) {
    return h === 35 ? (e.consume(h), u) : (e.exit("atxHeadingSequence"), l(h));
  }
  function c(h) {
    return h === null || h === 35 || Ue(h) ? (e.exit("atxHeadingText"), l(h)) : (e.consume(h), c);
  }
}
const x_ = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Cu = ["pre", "script", "style", "textarea"], y_ = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: w_,
  tokenize: k_
}, b_ = {
  partial: !0,
  tokenize: S_
}, v_ = {
  partial: !0,
  tokenize: C_
};
function w_(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function k_(e, t, n) {
  const i = this;
  let r, a, o, l, u;
  return c;
  function c(V) {
    return h(V);
  }
  function h(V) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(V), p;
  }
  function p(V) {
    return V === 33 ? (e.consume(V), m) : V === 47 ? (e.consume(V), a = !0, v) : V === 63 ? (e.consume(V), r = 3, i.interrupt ? t : N) : Lt(V) ? (e.consume(V), o = String.fromCharCode(V), w) : n(V);
  }
  function m(V) {
    return V === 45 ? (e.consume(V), r = 2, g) : V === 91 ? (e.consume(V), r = 5, l = 0, b) : Lt(V) ? (e.consume(V), r = 4, i.interrupt ? t : N) : n(V);
  }
  function g(V) {
    return V === 45 ? (e.consume(V), i.interrupt ? t : N) : n(V);
  }
  function b(V) {
    const de = "CDATA[";
    return V === de.charCodeAt(l++) ? (e.consume(V), l === de.length ? i.interrupt ? t : R : b) : n(V);
  }
  function v(V) {
    return Lt(V) ? (e.consume(V), o = String.fromCharCode(V), w) : n(V);
  }
  function w(V) {
    if (V === null || V === 47 || V === 62 || Ue(V)) {
      const de = V === 47, Se = o.toLowerCase();
      return !de && !a && Cu.includes(Se) ? (r = 1, i.interrupt ? t(V) : R(V)) : x_.includes(o.toLowerCase()) ? (r = 6, de ? (e.consume(V), y) : i.interrupt ? t(V) : R(V)) : (r = 7, i.interrupt && !i.parser.lazy[i.now().line] ? n(V) : a ? I(V) : E(V));
    }
    return V === 45 || Pt(V) ? (e.consume(V), o += String.fromCharCode(V), w) : n(V);
  }
  function y(V) {
    return V === 62 ? (e.consume(V), i.interrupt ? t : R) : n(V);
  }
  function I(V) {
    return Le(V) ? (e.consume(V), I) : M(V);
  }
  function E(V) {
    return V === 47 ? (e.consume(V), M) : V === 58 || V === 95 || Lt(V) ? (e.consume(V), P) : Le(V) ? (e.consume(V), E) : M(V);
  }
  function P(V) {
    return V === 45 || V === 46 || V === 58 || V === 95 || Pt(V) ? (e.consume(V), P) : S(V);
  }
  function S(V) {
    return V === 61 ? (e.consume(V), f) : Le(V) ? (e.consume(V), S) : E(V);
  }
  function f(V) {
    return V === null || V === 60 || V === 61 || V === 62 || V === 96 ? n(V) : V === 34 || V === 39 ? (e.consume(V), u = V, C) : Le(V) ? (e.consume(V), f) : L(V);
  }
  function C(V) {
    return V === u ? (e.consume(V), u = null, F) : V === null || me(V) ? n(V) : (e.consume(V), C);
  }
  function L(V) {
    return V === null || V === 34 || V === 39 || V === 47 || V === 60 || V === 61 || V === 62 || V === 96 || Ue(V) ? S(V) : (e.consume(V), L);
  }
  function F(V) {
    return V === 47 || V === 62 || Le(V) ? E(V) : n(V);
  }
  function M(V) {
    return V === 62 ? (e.consume(V), z) : n(V);
  }
  function z(V) {
    return V === null || me(V) ? R(V) : Le(V) ? (e.consume(V), z) : n(V);
  }
  function R(V) {
    return V === 45 && r === 2 ? (e.consume(V), X) : V === 60 && r === 1 ? (e.consume(V), K) : V === 62 && r === 4 ? (e.consume(V), ue) : V === 63 && r === 3 ? (e.consume(V), N) : V === 93 && r === 5 ? (e.consume(V), Y) : me(V) && (r === 6 || r === 7) ? (e.exit("htmlFlowData"), e.check(b_, ie, j)(V)) : V === null || me(V) ? (e.exit("htmlFlowData"), j(V)) : (e.consume(V), R);
  }
  function j(V) {
    return e.check(v_, H, ie)(V);
  }
  function H(V) {
    return e.enter("lineEnding"), e.consume(V), e.exit("lineEnding"), O;
  }
  function O(V) {
    return V === null || me(V) ? j(V) : (e.enter("htmlFlowData"), R(V));
  }
  function X(V) {
    return V === 45 ? (e.consume(V), N) : R(V);
  }
  function K(V) {
    return V === 47 ? (e.consume(V), o = "", se) : R(V);
  }
  function se(V) {
    if (V === 62) {
      const de = o.toLowerCase();
      return Cu.includes(de) ? (e.consume(V), ue) : R(V);
    }
    return Lt(V) && o.length < 8 ? (e.consume(V), o += String.fromCharCode(V), se) : R(V);
  }
  function Y(V) {
    return V === 93 ? (e.consume(V), N) : R(V);
  }
  function N(V) {
    return V === 62 ? (e.consume(V), ue) : V === 45 && r === 2 ? (e.consume(V), N) : R(V);
  }
  function ue(V) {
    return V === null || me(V) ? (e.exit("htmlFlowData"), ie(V)) : (e.consume(V), ue);
  }
  function ie(V) {
    return e.exit("htmlFlow"), t(V);
  }
}
function C_(e, t, n) {
  const i = this;
  return r;
  function r(o) {
    return me(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a) : n(o);
  }
  function a(o) {
    return i.parser.lazy[i.now().line] ? n(o) : t(o);
  }
}
function S_(e, t, n) {
  return i;
  function i(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), e.attempt(Zi, t, n);
  }
}
const E_ = {
  name: "htmlText",
  tokenize: A_
};
function A_(e, t, n) {
  const i = this;
  let r, a, o;
  return l;
  function l(N) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(N), u;
  }
  function u(N) {
    return N === 33 ? (e.consume(N), c) : N === 47 ? (e.consume(N), S) : N === 63 ? (e.consume(N), E) : Lt(N) ? (e.consume(N), L) : n(N);
  }
  function c(N) {
    return N === 45 ? (e.consume(N), h) : N === 91 ? (e.consume(N), a = 0, b) : Lt(N) ? (e.consume(N), I) : n(N);
  }
  function h(N) {
    return N === 45 ? (e.consume(N), g) : n(N);
  }
  function p(N) {
    return N === null ? n(N) : N === 45 ? (e.consume(N), m) : me(N) ? (o = p, K(N)) : (e.consume(N), p);
  }
  function m(N) {
    return N === 45 ? (e.consume(N), g) : p(N);
  }
  function g(N) {
    return N === 62 ? X(N) : N === 45 ? m(N) : p(N);
  }
  function b(N) {
    const ue = "CDATA[";
    return N === ue.charCodeAt(a++) ? (e.consume(N), a === ue.length ? v : b) : n(N);
  }
  function v(N) {
    return N === null ? n(N) : N === 93 ? (e.consume(N), w) : me(N) ? (o = v, K(N)) : (e.consume(N), v);
  }
  function w(N) {
    return N === 93 ? (e.consume(N), y) : v(N);
  }
  function y(N) {
    return N === 62 ? X(N) : N === 93 ? (e.consume(N), y) : v(N);
  }
  function I(N) {
    return N === null || N === 62 ? X(N) : me(N) ? (o = I, K(N)) : (e.consume(N), I);
  }
  function E(N) {
    return N === null ? n(N) : N === 63 ? (e.consume(N), P) : me(N) ? (o = E, K(N)) : (e.consume(N), E);
  }
  function P(N) {
    return N === 62 ? X(N) : E(N);
  }
  function S(N) {
    return Lt(N) ? (e.consume(N), f) : n(N);
  }
  function f(N) {
    return N === 45 || Pt(N) ? (e.consume(N), f) : C(N);
  }
  function C(N) {
    return me(N) ? (o = C, K(N)) : Le(N) ? (e.consume(N), C) : X(N);
  }
  function L(N) {
    return N === 45 || Pt(N) ? (e.consume(N), L) : N === 47 || N === 62 || Ue(N) ? F(N) : n(N);
  }
  function F(N) {
    return N === 47 ? (e.consume(N), X) : N === 58 || N === 95 || Lt(N) ? (e.consume(N), M) : me(N) ? (o = F, K(N)) : Le(N) ? (e.consume(N), F) : X(N);
  }
  function M(N) {
    return N === 45 || N === 46 || N === 58 || N === 95 || Pt(N) ? (e.consume(N), M) : z(N);
  }
  function z(N) {
    return N === 61 ? (e.consume(N), R) : me(N) ? (o = z, K(N)) : Le(N) ? (e.consume(N), z) : F(N);
  }
  function R(N) {
    return N === null || N === 60 || N === 61 || N === 62 || N === 96 ? n(N) : N === 34 || N === 39 ? (e.consume(N), r = N, j) : me(N) ? (o = R, K(N)) : Le(N) ? (e.consume(N), R) : (e.consume(N), H);
  }
  function j(N) {
    return N === r ? (e.consume(N), r = void 0, O) : N === null ? n(N) : me(N) ? (o = j, K(N)) : (e.consume(N), j);
  }
  function H(N) {
    return N === null || N === 34 || N === 39 || N === 60 || N === 61 || N === 96 ? n(N) : N === 47 || N === 62 || Ue(N) ? F(N) : (e.consume(N), H);
  }
  function O(N) {
    return N === 47 || N === 62 || Ue(N) ? F(N) : n(N);
  }
  function X(N) {
    return N === 62 ? (e.consume(N), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(N);
  }
  function K(N) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(N), e.exit("lineEnding"), se;
  }
  function se(N) {
    return Le(N) ? Be(e, Y, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(N) : Y(N);
  }
  function Y(N) {
    return e.enter("htmlTextData"), o(N);
  }
}
const Eo = {
  name: "labelEnd",
  resolveAll: T_,
  resolveTo: N_,
  tokenize: D_
}, I_ = {
  tokenize: V_
}, L_ = {
  tokenize: M_
}, P_ = {
  tokenize: F_
};
function T_(e) {
  let t = -1;
  const n = [];
  for (; ++t < e.length; ) {
    const i = e[t][1];
    if (n.push(e[t]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const r = i.type === "labelImage" ? 4 : 2;
      i.type = "data", t += r;
    }
  }
  return e.length !== n.length && Wt(e, 0, e.length, n), e;
}
function N_(e, t) {
  let n = e.length, i = 0, r, a, o, l;
  for (; n--; )
    if (r = e[n][1], a) {
      if (r.type === "link" || r.type === "labelLink" && r._inactive)
        break;
      e[n][0] === "enter" && r.type === "labelLink" && (r._inactive = !0);
    } else if (o) {
      if (e[n][0] === "enter" && (r.type === "labelImage" || r.type === "labelLink") && !r._balanced && (a = n, r.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else r.type === "labelEnd" && (o = n);
  const u = {
    type: e[a][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, c = {
    type: "label",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[o][1].end
    }
  }, h = {
    type: "labelText",
    start: {
      ...e[a + i + 2][1].end
    },
    end: {
      ...e[o - 2][1].start
    }
  };
  return l = [["enter", u, t], ["enter", c, t]], l = en(l, e.slice(a + 1, a + i + 3)), l = en(l, [["enter", h, t]]), l = en(l, Es(t.parser.constructs.insideSpan.null, e.slice(a + i + 4, o - 3), t)), l = en(l, [["exit", h, t], e[o - 2], e[o - 1], ["exit", c, t]]), l = en(l, e.slice(o + 1)), l = en(l, [["exit", u, t]]), Wt(e, a, e.length, l), e;
}
function D_(e, t, n) {
  const i = this;
  let r = i.events.length, a, o;
  for (; r--; )
    if ((i.events[r][1].type === "labelImage" || i.events[r][1].type === "labelLink") && !i.events[r][1]._balanced) {
      a = i.events[r][1];
      break;
    }
  return l;
  function l(m) {
    return a ? a._inactive ? p(m) : (o = i.parser.defined.includes(un(i.sliceSerialize({
      start: a.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(m), e.exit("labelMarker"), e.exit("labelEnd"), u) : n(m);
  }
  function u(m) {
    return m === 40 ? e.attempt(I_, h, o ? h : p)(m) : m === 91 ? e.attempt(L_, h, o ? c : p)(m) : o ? h(m) : p(m);
  }
  function c(m) {
    return e.attempt(P_, h, p)(m);
  }
  function h(m) {
    return t(m);
  }
  function p(m) {
    return a._balanced = !0, n(m);
  }
}
function V_(e, t, n) {
  return i;
  function i(p) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(p), e.exit("resourceMarker"), r;
  }
  function r(p) {
    return Ue(p) ? gr(e, a)(p) : a(p);
  }
  function a(p) {
    return p === 41 ? h(p) : Xh(e, o, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(p);
  }
  function o(p) {
    return Ue(p) ? gr(e, u)(p) : h(p);
  }
  function l(p) {
    return n(p);
  }
  function u(p) {
    return p === 34 || p === 39 || p === 40 ? Gh(e, c, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(p) : h(p);
  }
  function c(p) {
    return Ue(p) ? gr(e, h)(p) : h(p);
  }
  function h(p) {
    return p === 41 ? (e.enter("resourceMarker"), e.consume(p), e.exit("resourceMarker"), e.exit("resource"), t) : n(p);
  }
}
function M_(e, t, n) {
  const i = this;
  return r;
  function r(l) {
    return Zh.call(i, e, a, o, "reference", "referenceMarker", "referenceString")(l);
  }
  function a(l) {
    return i.parser.defined.includes(un(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? t(l) : n(l);
  }
  function o(l) {
    return n(l);
  }
}
function F_(e, t, n) {
  return i;
  function i(a) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), r;
  }
  function r(a) {
    return a === 93 ? (e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), e.exit("reference"), t) : n(a);
  }
}
const R_ = {
  name: "labelStartImage",
  resolveAll: Eo.resolveAll,
  tokenize: O_
};
function O_(e, t, n) {
  const i = this;
  return r;
  function r(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), a;
  }
  function a(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), o) : n(l);
  }
  function o(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? n(l) : t(l);
  }
}
const B_ = {
  name: "labelStartLink",
  resolveAll: Eo.resolveAll,
  tokenize: z_
};
function z_(e, t, n) {
  const i = this;
  return r;
  function r(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), a;
  }
  function a(o) {
    return o === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? n(o) : t(o);
  }
}
const sa = {
  name: "lineEnding",
  tokenize: j_
};
function j_(e, t) {
  return n;
  function n(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), Be(e, t, "linePrefix");
  }
}
const is = {
  name: "thematicBreak",
  tokenize: H_
};
function H_(e, t, n) {
  let i = 0, r;
  return a;
  function a(c) {
    return e.enter("thematicBreak"), o(c);
  }
  function o(c) {
    return r = c, l(c);
  }
  function l(c) {
    return c === r ? (e.enter("thematicBreakSequence"), u(c)) : i >= 3 && (c === null || me(c)) ? (e.exit("thematicBreak"), t(c)) : n(c);
  }
  function u(c) {
    return c === r ? (e.consume(c), i++, u) : (e.exit("thematicBreakSequence"), Le(c) ? Be(e, l, "whitespace")(c) : l(c));
  }
}
const Bt = {
  continuation: {
    tokenize: J_
  },
  exit: X_,
  name: "list",
  tokenize: U_
}, $_ = {
  partial: !0,
  tokenize: Z_
}, q_ = {
  partial: !0,
  tokenize: W_
};
function U_(e, t, n) {
  const i = this, r = i.events[i.events.length - 1];
  let a = r && r[1].type === "linePrefix" ? r[2].sliceSerialize(r[1], !0).length : 0, o = 0;
  return l;
  function l(g) {
    const b = i.containerState.type || (g === 42 || g === 43 || g === 45 ? "listUnordered" : "listOrdered");
    if (b === "listUnordered" ? !i.containerState.marker || g === i.containerState.marker : Ua(g)) {
      if (i.containerState.type || (i.containerState.type = b, e.enter(b, {
        _container: !0
      })), b === "listUnordered")
        return e.enter("listItemPrefix"), g === 42 || g === 45 ? e.check(is, n, c)(g) : c(g);
      if (!i.interrupt || g === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), u(g);
    }
    return n(g);
  }
  function u(g) {
    return Ua(g) && ++o < 10 ? (e.consume(g), u) : (!i.interrupt || o < 2) && (i.containerState.marker ? g === i.containerState.marker : g === 41 || g === 46) ? (e.exit("listItemValue"), c(g)) : n(g);
  }
  function c(g) {
    return e.enter("listItemMarker"), e.consume(g), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || g, e.check(
      Zi,
      // Can’t be empty when interrupting.
      i.interrupt ? n : h,
      e.attempt($_, m, p)
    );
  }
  function h(g) {
    return i.containerState.initialBlankLine = !0, a++, m(g);
  }
  function p(g) {
    return Le(g) ? (e.enter("listItemPrefixWhitespace"), e.consume(g), e.exit("listItemPrefixWhitespace"), m) : n(g);
  }
  function m(g) {
    return i.containerState.size = a + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(g);
  }
}
function J_(e, t, n) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(Zi, r, a);
  function r(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, Be(e, t, "listItemIndent", i.containerState.size + 1)(l);
  }
  function a(l) {
    return i.containerState.furtherBlankLines || !Le(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, o(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(q_, t, o)(l));
  }
  function o(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, Be(e, e.attempt(Bt, t, n), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function W_(e, t, n) {
  const i = this;
  return Be(e, r, "listItemIndent", i.containerState.size + 1);
  function r(a) {
    const o = i.events[i.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === i.containerState.size ? t(a) : n(a);
  }
}
function X_(e) {
  e.exit(this.containerState.type);
}
function Z_(e, t, n) {
  const i = this;
  return Be(e, r, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function r(a) {
    const o = i.events[i.events.length - 1];
    return !Le(a) && o && o[1].type === "listItemPrefixWhitespace" ? t(a) : n(a);
  }
}
const Su = {
  name: "setextUnderline",
  resolveTo: G_,
  tokenize: K_
};
function G_(e, t) {
  let n = e.length, i, r, a;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        i = n;
        break;
      }
      e[n][1].type === "paragraph" && (r = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !a && e[n][1].type === "definition" && (a = n);
  const o = {
    type: "setextHeading",
    start: {
      ...e[i][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[r][1].type = "setextHeadingText", a ? (e.splice(r, 0, ["enter", o, t]), e.splice(a + 1, 0, ["exit", e[i][1], t]), e[i][1].end = {
    ...e[a][1].end
  }) : e[i][1] = o, e.push(["exit", o, t]), e;
}
function K_(e, t, n) {
  const i = this;
  let r;
  return a;
  function a(c) {
    let h = i.events.length, p;
    for (; h--; )
      if (i.events[h][1].type !== "lineEnding" && i.events[h][1].type !== "linePrefix" && i.events[h][1].type !== "content") {
        p = i.events[h][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || p) ? (e.enter("setextHeadingLine"), r = c, o(c)) : n(c);
  }
  function o(c) {
    return e.enter("setextHeadingLineSequence"), l(c);
  }
  function l(c) {
    return c === r ? (e.consume(c), l) : (e.exit("setextHeadingLineSequence"), Le(c) ? Be(e, u, "lineSuffix")(c) : u(c));
  }
  function u(c) {
    return c === null || me(c) ? (e.exit("setextHeadingLine"), t(c)) : n(c);
  }
}
const Y_ = {
  tokenize: tx,
  partial: !0
}, Eu = "https://github.com/micromark/micromark-extension-mdxjs-esm", Q_ = /* @__PURE__ */ new Set(["ExportAllDeclaration", "ExportDefaultDeclaration", "ExportNamedDeclaration", "ImportDeclaration"]);
function ex(e) {
  const t = {
    tokenize: r,
    concrete: !0
  };
  if (!e || !e.acorn || !e.acorn.parse)
    throw new Error("Expected an `acorn` instance passed in as `options.acorn`");
  const n = e.acorn, i = Object.assign({
    ecmaVersion: 2024,
    sourceType: "module"
  }, e.acornOptions, {
    locations: !0
  });
  return {
    flow: {
      101: t,
      105: t
    }
  };
  function r(a, o, l) {
    const u = this, c = u.parser.definedModuleSpecifiers || (u.parser.definedModuleSpecifiers = []), h = this.events.length + 1;
    let p = "";
    return u.interrupt ? l : m;
    function m(I) {
      return u.now().column > 1 ? l(I) : (a.enter("mdxjsEsm"), a.enter("mdxjsEsmData"), a.consume(I), p += String.fromCharCode(I), g);
    }
    function g(I) {
      return Lt(I) ? (a.consume(I), p += String.fromCharCode(I), g) : (p === "import" || p === "export") && I === 32 ? (a.consume(I), b) : l(I);
    }
    function b(I) {
      return I === null || me(I) ? (a.exit("mdxjsEsmData"), v(I)) : (a.consume(I), b);
    }
    function v(I) {
      return I === null ? y(I) : me(I) ? a.check(Y_, y, w)(I) : (a.enter("mdxjsEsmData"), b(I));
    }
    function w(I) {
      return a.enter("lineEnding"), a.consume(I), a.exit("lineEnding"), v;
    }
    function y(I) {
      const E = Hh(u.events.slice(h), {
        acorn: n,
        acornOptions: i,
        tokenTypes: ["mdxjsEsmData"],
        prefix: c.length > 0 ? "var " + c.join(",") + `
` : ""
      });
      if (E.error) {
        if (I !== null && E.swallow)
          return w(I);
        const S = new Xe("Could not parse import/exports with acorn", {
          cause: E.error,
          place: {
            line: E.error.loc.line,
            column: E.error.loc.column + 1,
            offset: E.error.pos
          },
          ruleId: "acorn",
          source: "micromark-extension-mdxjs-esm"
        });
        throw S.url = Eu + "#could-not-parse-importexports-with-acorn", S;
      }
      c.length > 0 && E.estree.body.shift();
      let P = -1;
      for (; ++P < E.estree.body.length; ) {
        const S = E.estree.body[P];
        if (!Q_.has(S.type)) {
          const f = new Xe("Unexpected `" + S.type + "` in code: only import/exports are supported", {
            place: Vn(S),
            ruleId: "non-esm",
            source: "micromark-extension-mdxjs-esm"
          });
          throw f.url = Eu + "#unexpected-type-in-code-only-importexports-are-supported", f;
        }
        if (S.type === "ImportDeclaration" && !u.interrupt) {
          let f = -1;
          for (; ++f < S.specifiers.length; ) {
            const C = S.specifiers[f];
            c.push(C.local.name);
          }
        }
      }
      return Object.assign(a.exit("mdxjsEsm"), e.addResult ? {
        estree: E.estree
      } : void 0), o(I);
    }
  }
}
function tx(e, t, n) {
  return i;
  function i(r) {
    return e.enter("lineEndingBlank"), e.consume(r), e.exit("lineEndingBlank"), e.attempt(Zi, t, n);
  }
}
const Au = {}.hasOwnProperty;
function Ao(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    nx(t, e[n]);
  return t;
}
function nx(e, t) {
  let n;
  for (n in t) {
    const r = (Au.call(e, n) ? e[n] : void 0) || (e[n] = {}), a = t[n];
    let o;
    if (a)
      for (o in a) {
        Au.call(r, o) || (r[o] = []);
        const l = a[o];
        ix(
          // @ts-expect-error Looks like a list.
          r[o],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function ix(e, t) {
  let n = -1;
  const i = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : i).push(t[n]);
  Wt(e, 0, 0, i);
}
function rx(e) {
  const t = Object.assign(
    {
      acorn: xt.extend(Oc()),
      acornOptions: { ecmaVersion: 2024, sourceType: "module" },
      addResult: !0
    },
    e
  );
  return Ao([
    ex(t),
    Tg(t),
    Mg(t),
    Fg()
  ]);
}
const sx = {};
function ax(e) {
  const t = this, n = e || sx, i = t.data(), r = i.micromarkExtensions || (i.micromarkExtensions = []), a = i.fromMarkdownExtensions || (i.fromMarkdownExtensions = []), o = i.toMarkdownExtensions || (i.toMarkdownExtensions = []);
  r.push(rx(n)), a.push(I2()), o.push(L2(n));
}
const ox = {};
function Io(e, t) {
  const n = ox, i = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, r = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return Kh(e, i, r);
}
function Kh(e, t, n) {
  if (lx(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Iu(e.children, t, n);
  }
  return Array.isArray(e) ? Iu(e, t, n) : "";
}
function Iu(e, t, n) {
  const i = [];
  let r = -1;
  for (; ++r < e.length; )
    i[r] = Kh(e[r], t, n);
  return i.join("");
}
function lx(e) {
  return !!(e && typeof e == "object");
}
function Yh(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function Gi(e) {
  const t = [];
  let n = -1, i = 0, r = 0;
  for (; ++n < e.length; ) {
    const a = e.charCodeAt(n);
    let o = "";
    if (a === 37 && Pt(e.charCodeAt(n + 1)) && Pt(e.charCodeAt(n + 2)))
      r = 2;
    else if (a < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(a)) || (o = String.fromCharCode(a));
    else if (a > 55295 && a < 57344) {
      const l = e.charCodeAt(n + 1);
      a < 56320 && l > 56319 && l < 57344 ? (o = String.fromCharCode(a, l), r = 1) : o = "�";
    } else
      o = String.fromCharCode(a);
    o && (t.push(e.slice(i, n), encodeURIComponent(o)), i = n + r + 1, o = ""), r && (n += r, r = 0);
  }
  return t.join("") + e.slice(i);
}
const ux = {
  tokenize: cx
};
function cx(e) {
  const t = e.attempt(this.parser.constructs.contentInitial, i, r);
  let n;
  return t;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), Be(e, t, "linePrefix");
  }
  function r(l) {
    return e.enter("paragraph"), a(l);
  }
  function a(l) {
    const u = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = u), n = u, o(l);
  }
  function o(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return me(l) ? (e.consume(l), e.exit("chunkText"), a) : (e.consume(l), o);
  }
}
const hx = {
  tokenize: px
}, Lu = {
  tokenize: dx
};
function px(e) {
  const t = this, n = [];
  let i = 0, r, a, o;
  return l;
  function l(E) {
    if (i < n.length) {
      const P = n[i];
      return t.containerState = P[1], e.attempt(P[0].continuation, u, c)(E);
    }
    return c(E);
  }
  function u(E) {
    if (i++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, r && I();
      const P = t.events.length;
      let S = P, f;
      for (; S--; )
        if (t.events[S][0] === "exit" && t.events[S][1].type === "chunkFlow") {
          f = t.events[S][1].end;
          break;
        }
      y(i);
      let C = P;
      for (; C < t.events.length; )
        t.events[C][1].end = {
          ...f
        }, C++;
      return Wt(t.events, S + 1, 0, t.events.slice(P)), t.events.length = C, c(E);
    }
    return l(E);
  }
  function c(E) {
    if (i === n.length) {
      if (!r)
        return m(E);
      if (r.currentConstruct && r.currentConstruct.concrete)
        return b(E);
      t.interrupt = !!(r.currentConstruct && !r._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(Lu, h, p)(E);
  }
  function h(E) {
    return r && I(), y(i), m(E);
  }
  function p(E) {
    return t.parser.lazy[t.now().line] = i !== n.length, o = t.now().offset, b(E);
  }
  function m(E) {
    return t.containerState = {}, e.attempt(Lu, g, b)(E);
  }
  function g(E) {
    return i++, n.push([t.currentConstruct, t.containerState]), m(E);
  }
  function b(E) {
    if (E === null) {
      r && I(), y(0), e.consume(E);
      return;
    }
    return r = r || t.parser.flow(t.now()), e.enter("chunkFlow", {
      _tokenizer: r,
      contentType: "flow",
      previous: a
    }), v(E);
  }
  function v(E) {
    if (E === null) {
      w(e.exit("chunkFlow"), !0), y(0), e.consume(E);
      return;
    }
    return me(E) ? (e.consume(E), w(e.exit("chunkFlow")), i = 0, t.interrupt = void 0, l) : (e.consume(E), v);
  }
  function w(E, P) {
    const S = t.sliceStream(E);
    if (P && S.push(null), E.previous = a, a && (a.next = E), a = E, r.defineSkip(E.start), r.write(S), t.parser.lazy[E.start.line]) {
      let f = r.events.length;
      for (; f--; )
        if (
          // The token starts before the line ending…
          r.events[f][1].start.offset < o && // …and either is not ended yet…
          (!r.events[f][1].end || // …or ends after it.
          r.events[f][1].end.offset > o)
        )
          return;
      const C = t.events.length;
      let L = C, F, M;
      for (; L--; )
        if (t.events[L][0] === "exit" && t.events[L][1].type === "chunkFlow") {
          if (F) {
            M = t.events[L][1].end;
            break;
          }
          F = !0;
        }
      for (y(i), f = C; f < t.events.length; )
        t.events[f][1].end = {
          ...M
        }, f++;
      Wt(t.events, L + 1, 0, t.events.slice(C)), t.events.length = f;
    }
  }
  function y(E) {
    let P = n.length;
    for (; P-- > E; ) {
      const S = n[P];
      t.containerState = S[1], S[0].exit.call(t, e);
    }
    n.length = E;
  }
  function I() {
    r.write([null]), a = void 0, r = void 0, t.containerState._closeFlow = void 0;
  }
}
function dx(e, t, n) {
  return Be(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
const fx = {
  tokenize: mx
};
function mx(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    Zi,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, r, Be(e, e.attempt(this.parser.constructs.flow, r, e.attempt(r_, r)), "linePrefix"))
  );
  return n;
  function i(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(a), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const gx = {
  resolveAll: ep()
}, _x = Qh("string"), xx = Qh("text");
function Qh(e) {
  return {
    resolveAll: ep(e === "text" ? yx : void 0),
    tokenize: t
  };
  function t(n) {
    const i = this, r = this.parser.constructs[e], a = n.attempt(r, o, l);
    return o;
    function o(h) {
      return c(h) ? a(h) : l(h);
    }
    function l(h) {
      if (h === null) {
        n.consume(h);
        return;
      }
      return n.enter("data"), n.consume(h), u;
    }
    function u(h) {
      return c(h) ? (n.exit("data"), a(h)) : (n.consume(h), u);
    }
    function c(h) {
      if (h === null)
        return !0;
      const p = r[h];
      let m = -1;
      if (p)
        for (; ++m < p.length; ) {
          const g = p[m];
          if (!g.previous || g.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function ep(e) {
  return t;
  function t(n, i) {
    let r = -1, a;
    for (; ++r <= n.length; )
      a === void 0 ? n[r] && n[r][1].type === "data" && (a = r, r++) : (!n[r] || n[r][1].type !== "data") && (r !== a + 2 && (n[a][1].end = n[r - 1][1].end, n.splice(a + 2, r - a - 2), r = a + 2), a = void 0);
    return e ? e(n, i) : n;
  }
}
function yx(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const i = e[n - 1][1], r = t.sliceStream(i);
      let a = r.length, o = -1, l = 0, u;
      for (; a--; ) {
        const c = r[a];
        if (typeof c == "string") {
          for (o = c.length; c.charCodeAt(o - 1) === 32; )
            l++, o--;
          if (o) break;
          o = -1;
        } else if (c === -2)
          u = !0, l++;
        else if (c !== -1) {
          a++;
          break;
        }
      }
      if (t._contentTypeTextTrailing && n === e.length && (l = 0), l) {
        const c = {
          type: n === e.length || u || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: a ? o : i.start._bufferIndex + o,
            _index: i.start._index + a,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...c.start
        }, i.start.offset === i.end.offset ? Object.assign(i, c) : (e.splice(n, 0, ["enter", c, t], ["exit", c, t]), n += 2);
      }
      n++;
    }
  return e;
}
const bx = {
  42: Bt,
  43: Bt,
  45: Bt,
  48: Bt,
  49: Bt,
  50: Bt,
  51: Bt,
  52: Bt,
  53: Bt,
  54: Bt,
  55: Bt,
  56: Bt,
  57: Bt,
  62: qh
}, vx = {
  91: u_
}, wx = {
  [-2]: ra,
  [-1]: ra,
  32: ra
}, kx = {
  35: m_,
  42: is,
  45: [Su, is],
  60: y_,
  61: Su,
  95: is,
  96: ku,
  126: ku
}, Cx = {
  38: Jh,
  92: Uh
}, Sx = {
  [-5]: sa,
  [-4]: sa,
  [-3]: sa,
  33: R_,
  38: Jh,
  42: Ja,
  60: [Bg, E_],
  91: B_,
  92: [d_, Uh],
  93: Eo,
  95: Ja,
  96: Yg
}, Ex = {
  null: [Ja, gx]
}, Ax = {
  null: [42, 95]
}, Ix = {
  null: []
}, Lx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: Ax,
  contentInitial: vx,
  disable: Ix,
  document: bx,
  flow: kx,
  flowInitial: wx,
  insideSpan: Ex,
  string: Cx,
  text: Sx
}, Symbol.toStringTag, { value: "Module" }));
function Px(e, t, n) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: n && n.line || 1,
    column: n && n.column || 1,
    offset: n && n.offset || 0
  };
  const r = {}, a = [];
  let o = [], l = [];
  const u = {
    attempt: C(S),
    check: C(f),
    consume: I,
    enter: E,
    exit: P,
    interrupt: C(f, {
      interrupt: !0
    })
  }, c = {
    code: null,
    containerState: {},
    defineSkip: v,
    events: [],
    now: b,
    parser: e,
    previous: null,
    sliceSerialize: m,
    sliceStream: g,
    write: p
  };
  let h = t.tokenize.call(c, u);
  return t.resolveAll && a.push(t), c;
  function p(z) {
    return o = en(o, z), w(), o[o.length - 1] !== null ? [] : (L(t, 0), c.events = Es(a, c.events, c), c.events);
  }
  function m(z, R) {
    return Nx(g(z), R);
  }
  function g(z) {
    return Tx(o, z);
  }
  function b() {
    const {
      _bufferIndex: z,
      _index: R,
      line: j,
      column: H,
      offset: O
    } = i;
    return {
      _bufferIndex: z,
      _index: R,
      line: j,
      column: H,
      offset: O
    };
  }
  function v(z) {
    r[z.line] = z.column, M();
  }
  function w() {
    let z;
    for (; i._index < o.length; ) {
      const R = o[i._index];
      if (typeof R == "string")
        for (z = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === z && i._bufferIndex < R.length; )
          y(R.charCodeAt(i._bufferIndex));
      else
        y(R);
    }
  }
  function y(z) {
    h = h(z);
  }
  function I(z) {
    me(z) ? (i.line++, i.column = 1, i.offset += z === -3 ? 2 : 1, M()) : z !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    o[i._index].length && (i._bufferIndex = -1, i._index++)), c.previous = z;
  }
  function E(z, R) {
    const j = R || {};
    return j.type = z, j.start = b(), c.events.push(["enter", j, c]), l.push(j), j;
  }
  function P(z) {
    const R = l.pop();
    return R.end = b(), c.events.push(["exit", R, c]), R;
  }
  function S(z, R) {
    L(z, R.from);
  }
  function f(z, R) {
    R.restore();
  }
  function C(z, R) {
    return j;
    function j(H, O, X) {
      let K, se, Y, N;
      return Array.isArray(H) ? (
        /* c8 ignore next 1 */
        ie(H)
      ) : "tokenize" in H ? (
        // Looks like a construct.
        ie([
          /** @type {Construct} */
          H
        ])
      ) : ue(H);
      function ue(W) {
        return q;
        function q(ne) {
          const ee = ne !== null && W[ne], ge = ne !== null && W.null, te = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(ee) ? ee : ee ? [ee] : [],
            ...Array.isArray(ge) ? ge : ge ? [ge] : []
          ];
          return ie(te)(ne);
        }
      }
      function ie(W) {
        return K = W, se = 0, W.length === 0 ? X : V(W[se]);
      }
      function V(W) {
        return q;
        function q(ne) {
          return N = F(), Y = W, W.partial || (c.currentConstruct = W), W.name && c.parser.constructs.disable.null.includes(W.name) ? Se() : W.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            R ? Object.assign(Object.create(c), R) : c,
            u,
            de,
            Se
          )(ne);
        }
      }
      function de(W) {
        return z(Y, N), O;
      }
      function Se(W) {
        return N.restore(), ++se < K.length ? V(K[se]) : X;
      }
    }
  }
  function L(z, R) {
    z.resolveAll && !a.includes(z) && a.push(z), z.resolve && Wt(c.events, R, c.events.length - R, z.resolve(c.events.slice(R), c)), z.resolveTo && (c.events = z.resolveTo(c.events, c));
  }
  function F() {
    const z = b(), R = c.previous, j = c.currentConstruct, H = c.events.length, O = Array.from(l);
    return {
      from: H,
      restore: X
    };
    function X() {
      i = z, c.previous = R, c.currentConstruct = j, c.events.length = H, l = O, M();
    }
  }
  function M() {
    i.line in r && i.column < 2 && (i.column = r[i.line], i.offset += r[i.line] - 1);
  }
}
function Tx(e, t) {
  const n = t.start._index, i = t.start._bufferIndex, r = t.end._index, a = t.end._bufferIndex;
  let o;
  if (n === r)
    o = [e[n].slice(i, a)];
  else {
    if (o = e.slice(n, r), i > -1) {
      const l = o[0];
      typeof l == "string" ? o[0] = l.slice(i) : o.shift();
    }
    a > 0 && o.push(e[r].slice(0, a));
  }
  return o;
}
function Nx(e, t) {
  let n = -1;
  const i = [];
  let r;
  for (; ++n < e.length; ) {
    const a = e[n];
    let o;
    if (typeof a == "string")
      o = a;
    else switch (a) {
      case -5: {
        o = "\r";
        break;
      }
      case -4: {
        o = `
`;
        break;
      }
      case -3: {
        o = `\r
`;
        break;
      }
      case -2: {
        o = t ? " " : "	";
        break;
      }
      case -1: {
        if (!t && r) continue;
        o = " ";
        break;
      }
      default:
        o = String.fromCharCode(a);
    }
    r = a === -2, i.push(o);
  }
  return i.join("");
}
function Dx(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      Ao([Lx, ...(e || {}).extensions || []])
    ),
    content: r(ux),
    defined: [],
    document: r(hx),
    flow: r(fx),
    lazy: {},
    string: r(_x),
    text: r(xx)
  };
  return i;
  function r(a) {
    return o;
    function o(l) {
      return Px(i, a, l);
    }
  }
}
function Vx(e) {
  for (; !Wh(e); )
    ;
  return e;
}
const Pu = /[\0\t\n\r]/g;
function Mx() {
  let e = 1, t = "", n = !0, i;
  return r;
  function r(a, o, l) {
    const u = [];
    let c, h, p, m, g;
    for (a = t + (typeof a == "string" ? a.toString() : new TextDecoder(o || void 0).decode(a)), p = 0, t = "", n && (a.charCodeAt(0) === 65279 && p++, n = void 0); p < a.length; ) {
      if (Pu.lastIndex = p, c = Pu.exec(a), m = c && c.index !== void 0 ? c.index : a.length, g = a.charCodeAt(m), !c) {
        t = a.slice(p);
        break;
      }
      if (g === 10 && p === m && i)
        u.push(-3), i = void 0;
      else
        switch (i && (u.push(-5), i = void 0), p < m && (u.push(a.slice(p, m)), e += m - p), g) {
          case 0: {
            u.push(65533), e++;
            break;
          }
          case 9: {
            for (h = Math.ceil(e / 4) * 4, u.push(-2); e++ < h; ) u.push(-1);
            break;
          }
          case 10: {
            u.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      p = m + 1;
    }
    return l && (i && u.push(-5), t && u.push(t), u.push(null)), u;
  }
}
const Fx = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function Rx(e) {
  return e.replace(Fx, Ox);
}
function Ox(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const r = n.charCodeAt(1), a = r === 120 || r === 88;
    return Yh(n.slice(a ? 2 : 1), a ? 16 : 10);
  }
  return br(n) || e;
}
const tp = {}.hasOwnProperty;
function Bx(e, t, n) {
  return t && typeof t == "object" && (n = t, t = void 0), zx(n)(Vx(Dx(n).document().write(Mx()(e, t, !0))));
}
function zx(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: a(ft),
      autolinkProtocol: F,
      autolinkEmail: F,
      atxHeading: a(ot),
      blockQuote: a(ge),
      characterEscape: F,
      characterReference: F,
      codeFenced: a(te),
      codeFencedFenceInfo: o,
      codeFencedFenceMeta: o,
      codeIndented: a(te, o),
      codeText: a(_e, o),
      codeTextData: F,
      data: F,
      codeFlowValue: F,
      definition: a(Te),
      definitionDestinationString: o,
      definitionLabelString: o,
      definitionTitleString: o,
      emphasis: a(Ye),
      hardBreakEscape: a(Ze),
      hardBreakTrailing: a(Ze),
      htmlFlow: a(ht, o),
      htmlFlowData: F,
      htmlText: a(ht, o),
      htmlTextData: F,
      image: a(Oe),
      label: o,
      link: a(ft),
      listItem: a(St),
      listItemValue: m,
      listOrdered: a(Ct, p),
      listUnordered: a(Ct),
      paragraph: a(Ve),
      reference: V,
      referenceString: o,
      resourceDestinationString: o,
      resourceTitleString: o,
      setextHeading: a(ot),
      strong: a(qe),
      thematicBreak: a(An)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: S,
      autolink: u(),
      autolinkEmail: ee,
      autolinkProtocol: ne,
      blockQuote: u(),
      characterEscapeValue: M,
      characterReferenceMarkerHexadecimal: Se,
      characterReferenceMarkerNumeric: Se,
      characterReferenceValue: W,
      characterReference: q,
      codeFenced: u(w),
      codeFencedFence: v,
      codeFencedFenceInfo: g,
      codeFencedFenceMeta: b,
      codeFlowValue: M,
      codeIndented: u(y),
      codeText: u(O),
      codeTextData: M,
      data: M,
      definition: u(),
      definitionDestinationString: P,
      definitionLabelString: I,
      definitionTitleString: E,
      emphasis: u(),
      hardBreakEscape: u(R),
      hardBreakTrailing: u(R),
      htmlFlow: u(j),
      htmlFlowData: M,
      htmlText: u(H),
      htmlTextData: M,
      image: u(K),
      label: Y,
      labelText: se,
      lineEnding: z,
      link: u(X),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: de,
      resourceDestinationString: N,
      resourceTitleString: ue,
      resource: ie,
      setextHeading: u(L),
      setextHeadingLineSequence: C,
      setextHeadingText: f,
      strong: u(),
      thematicBreak: u()
    }
  };
  np(t, (e || {}).mdastExtensions || []);
  const n = {};
  return i;
  function i(Z) {
    let G = {
      type: "root",
      children: []
    };
    const T = {
      stack: [G],
      tokenStack: [],
      config: t,
      enter: l,
      exit: c,
      buffer: o,
      resume: h,
      data: n
    }, Ce = [];
    let Je = -1;
    for (; ++Je < Z.length; )
      if (Z[Je][1].type === "listOrdered" || Z[Je][1].type === "listUnordered")
        if (Z[Je][0] === "enter")
          Ce.push(Je);
        else {
          const ut = Ce.pop();
          Je = r(Z, ut, Je);
        }
    for (Je = -1; ++Je < Z.length; ) {
      const ut = t[Z[Je][0]];
      tp.call(ut, Z[Je][1].type) && ut[Z[Je][1].type].call(Object.assign({
        sliceSerialize: Z[Je][2].sliceSerialize
      }, T), Z[Je][1]);
    }
    if (T.tokenStack.length > 0) {
      const ut = T.tokenStack[T.tokenStack.length - 1];
      (ut[1] || Tu).call(T, void 0, ut[0]);
    }
    for (G.position = {
      start: Un(Z.length > 0 ? Z[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Un(Z.length > 0 ? Z[Z.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Je = -1; ++Je < t.transforms.length; )
      G = t.transforms[Je](G) || G;
    return G;
  }
  function r(Z, G, T) {
    let Ce = G - 1, Je = -1, ut = !1, le, yt, qt, In;
    for (; ++Ce <= T; ) {
      const mt = Z[Ce];
      switch (mt[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          mt[0] === "enter" ? Je++ : Je--, In = void 0;
          break;
        }
        case "lineEndingBlank": {
          mt[0] === "enter" && (le && !In && !Je && !qt && (qt = Ce), In = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          In = void 0;
      }
      if (!Je && mt[0] === "enter" && mt[1].type === "listItemPrefix" || Je === -1 && mt[0] === "exit" && (mt[1].type === "listUnordered" || mt[1].type === "listOrdered")) {
        if (le) {
          let pn = Ce;
          for (yt = void 0; pn--; ) {
            const Xt = Z[pn];
            if (Xt[1].type === "lineEnding" || Xt[1].type === "lineEndingBlank") {
              if (Xt[0] === "exit") continue;
              yt && (Z[yt][1].type = "lineEndingBlank", ut = !0), Xt[1].type = "lineEnding", yt = pn;
            } else if (!(Xt[1].type === "linePrefix" || Xt[1].type === "blockQuotePrefix" || Xt[1].type === "blockQuotePrefixWhitespace" || Xt[1].type === "blockQuoteMarker" || Xt[1].type === "listItemIndent")) break;
          }
          qt && (!yt || qt < yt) && (le._spread = !0), le.end = Object.assign({}, yt ? Z[yt][1].start : mt[1].end), Z.splice(yt || Ce, 0, ["exit", le, mt[2]]), Ce++, T++;
        }
        if (mt[1].type === "listItemPrefix") {
          const pn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, mt[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          le = pn, Z.splice(Ce, 0, ["enter", pn, mt[2]]), Ce++, T++, qt = void 0, In = !0;
        }
      }
    }
    return Z[G][1]._spread = ut, T;
  }
  function a(Z, G) {
    return T;
    function T(Ce) {
      l.call(this, Z(Ce), Ce), G && G.call(this, Ce);
    }
  }
  function o() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(Z, G, T) {
    this.stack[this.stack.length - 1].children.push(Z), this.stack.push(Z), this.tokenStack.push([G, T || void 0]), Z.position = {
      start: Un(G.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function u(Z) {
    return G;
    function G(T) {
      Z && Z.call(this, T), c.call(this, T);
    }
  }
  function c(Z, G) {
    const T = this.stack.pop(), Ce = this.tokenStack.pop();
    if (Ce)
      Ce[0].type !== Z.type && (G ? G.call(this, Z, Ce[0]) : (Ce[1] || Tu).call(this, Z, Ce[0]));
    else throw new Error("Cannot close `" + Z.type + "` (" + nn({
      start: Z.start,
      end: Z.end
    }) + "): it’s not open");
    T.position.end = Un(Z.end);
  }
  function h() {
    return Io(this.stack.pop());
  }
  function p() {
    this.data.expectingFirstListItemValue = !0;
  }
  function m(Z) {
    if (this.data.expectingFirstListItemValue) {
      const G = this.stack[this.stack.length - 2];
      G.start = Number.parseInt(this.sliceSerialize(Z), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function g() {
    const Z = this.resume(), G = this.stack[this.stack.length - 1];
    G.lang = Z;
  }
  function b() {
    const Z = this.resume(), G = this.stack[this.stack.length - 1];
    G.meta = Z;
  }
  function v() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function w() {
    const Z = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = Z.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function y() {
    const Z = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = Z.replace(/(\r?\n|\r)$/g, "");
  }
  function I(Z) {
    const G = this.resume(), T = this.stack[this.stack.length - 1];
    T.label = G, T.identifier = un(this.sliceSerialize(Z)).toLowerCase();
  }
  function E() {
    const Z = this.resume(), G = this.stack[this.stack.length - 1];
    G.title = Z;
  }
  function P() {
    const Z = this.resume(), G = this.stack[this.stack.length - 1];
    G.url = Z;
  }
  function S(Z) {
    const G = this.stack[this.stack.length - 1];
    if (!G.depth) {
      const T = this.sliceSerialize(Z).length;
      G.depth = T;
    }
  }
  function f() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function C(Z) {
    const G = this.stack[this.stack.length - 1];
    G.depth = this.sliceSerialize(Z).codePointAt(0) === 61 ? 1 : 2;
  }
  function L() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function F(Z) {
    const T = this.stack[this.stack.length - 1].children;
    let Ce = T[T.length - 1];
    (!Ce || Ce.type !== "text") && (Ce = De(), Ce.position = {
      start: Un(Z.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, T.push(Ce)), this.stack.push(Ce);
  }
  function M(Z) {
    const G = this.stack.pop();
    G.value += this.sliceSerialize(Z), G.position.end = Un(Z.end);
  }
  function z(Z) {
    const G = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const T = G.children[G.children.length - 1];
      T.position.end = Un(Z.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(G.type) && (F.call(this, Z), M.call(this, Z));
  }
  function R() {
    this.data.atHardBreak = !0;
  }
  function j() {
    const Z = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = Z;
  }
  function H() {
    const Z = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = Z;
  }
  function O() {
    const Z = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = Z;
  }
  function X() {
    const Z = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const G = this.data.referenceType || "shortcut";
      Z.type += "Reference", Z.referenceType = G, delete Z.url, delete Z.title;
    } else
      delete Z.identifier, delete Z.label;
    this.data.referenceType = void 0;
  }
  function K() {
    const Z = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const G = this.data.referenceType || "shortcut";
      Z.type += "Reference", Z.referenceType = G, delete Z.url, delete Z.title;
    } else
      delete Z.identifier, delete Z.label;
    this.data.referenceType = void 0;
  }
  function se(Z) {
    const G = this.sliceSerialize(Z), T = this.stack[this.stack.length - 2];
    T.label = Rx(G), T.identifier = un(G).toLowerCase();
  }
  function Y() {
    const Z = this.stack[this.stack.length - 1], G = this.resume(), T = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, T.type === "link") {
      const Ce = Z.children;
      T.children = Ce;
    } else
      T.alt = G;
  }
  function N() {
    const Z = this.resume(), G = this.stack[this.stack.length - 1];
    G.url = Z;
  }
  function ue() {
    const Z = this.resume(), G = this.stack[this.stack.length - 1];
    G.title = Z;
  }
  function ie() {
    this.data.inReference = void 0;
  }
  function V() {
    this.data.referenceType = "collapsed";
  }
  function de(Z) {
    const G = this.resume(), T = this.stack[this.stack.length - 1];
    T.label = G, T.identifier = un(this.sliceSerialize(Z)).toLowerCase(), this.data.referenceType = "full";
  }
  function Se(Z) {
    this.data.characterReferenceType = Z.type;
  }
  function W(Z) {
    const G = this.sliceSerialize(Z), T = this.data.characterReferenceType;
    let Ce;
    T ? (Ce = Yh(G, T === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : Ce = br(G);
    const Je = this.stack[this.stack.length - 1];
    Je.value += Ce;
  }
  function q(Z) {
    const G = this.stack.pop();
    G.position.end = Un(Z.end);
  }
  function ne(Z) {
    M.call(this, Z);
    const G = this.stack[this.stack.length - 1];
    G.url = this.sliceSerialize(Z);
  }
  function ee(Z) {
    M.call(this, Z);
    const G = this.stack[this.stack.length - 1];
    G.url = "mailto:" + this.sliceSerialize(Z);
  }
  function ge() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function te() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function _e() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Te() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Ye() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function ot() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Ze() {
    return {
      type: "break"
    };
  }
  function ht() {
    return {
      type: "html",
      value: ""
    };
  }
  function Oe() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function ft() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Ct(Z) {
    return {
      type: "list",
      ordered: Z.type === "listOrdered",
      start: null,
      spread: Z._spread,
      children: []
    };
  }
  function St(Z) {
    return {
      type: "listItem",
      spread: Z._spread,
      checked: null,
      children: []
    };
  }
  function Ve() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function qe() {
    return {
      type: "strong",
      children: []
    };
  }
  function De() {
    return {
      type: "text",
      value: ""
    };
  }
  function An() {
    return {
      type: "thematicBreak"
    };
  }
}
function Un(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function np(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const i = t[n];
    Array.isArray(i) ? np(e, i) : jx(e, i);
  }
}
function jx(e, t) {
  let n;
  for (n in t)
    if (tp.call(t, n))
      switch (n) {
        case "canContainEols": {
          const i = t[n];
          i && e[n].push(...i);
          break;
        }
        case "transforms": {
          const i = t[n];
          i && e[n].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = t[n];
          i && Object.assign(e[n], i);
          break;
        }
      }
}
function Tu(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + nn({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + nn({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + nn({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function Hx(e) {
  const t = this;
  t.parser = n;
  function n(i) {
    return Bx(i, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function $x(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function qx(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function Ux(e, t) {
  const n = t.value ? t.value + `
` : "", i = {}, r = t.lang ? t.lang.split(/\s+/) : [];
  r.length > 0 && (i.className = ["language-" + r[0]]);
  let a = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (a.data = { meta: t.meta }), e.patch(t, a), a = e.applyData(t, a), a = { type: "element", tagName: "pre", properties: {}, children: [a] }, e.patch(t, a), a;
}
function Jx(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Wx(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Xx(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(t.identifier).toUpperCase(), r = Gi(i.toLowerCase()), a = e.footnoteOrder.indexOf(i);
  let o, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), o = e.footnoteOrder.length) : o = a + 1, l += 1, e.footnoteCounts.set(i, l);
  const u = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + r,
      id: n + "fnref-" + r + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  e.patch(t, u);
  const c = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [u]
  };
  return e.patch(t, c), e.applyData(t, c);
}
function Zx(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Gx(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function ip(e, t) {
  const n = t.referenceType;
  let i = "]";
  if (n === "collapsed" ? i += "[]" : n === "full" && (i += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + i }];
  const r = e.all(t), a = r[0];
  a && a.type === "text" ? a.value = "[" + a.value : r.unshift({ type: "text", value: "[" });
  const o = r[r.length - 1];
  return o && o.type === "text" ? o.value += i : r.push({ type: "text", value: i }), r;
}
function Kx(e, t) {
  const n = String(t.identifier).toUpperCase(), i = e.definitionById.get(n);
  if (!i)
    return ip(e, t);
  const r = { src: Gi(i.url || ""), alt: t.alt };
  i.title !== null && i.title !== void 0 && (r.title = i.title);
  const a = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(t, a), e.applyData(t, a);
}
function Yx(e, t) {
  const n = { src: Gi(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const i = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, i), e.applyData(t, i);
}
function Qx(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, i), e.applyData(t, i);
}
function ey(e, t) {
  const n = String(t.identifier).toUpperCase(), i = e.definitionById.get(n);
  if (!i)
    return ip(e, t);
  const r = { href: Gi(i.url || "") };
  i.title !== null && i.title !== void 0 && (r.title = i.title);
  const a = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(t)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function ty(e, t) {
  const n = { href: Gi(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function ny(e, t, n) {
  const i = e.all(t), r = n ? iy(n) : rp(t), a = {}, o = [];
  if (typeof t.checked == "boolean") {
    const h = i[0];
    let p;
    h && h.type === "element" && h.tagName === "p" ? p = h : (p = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(p)), p.children.length > 0 && p.children.unshift({ type: "text", value: " " }), p.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), a.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const h = i[l];
    (r || l !== 0 || h.type !== "element" || h.tagName !== "p") && o.push({ type: "text", value: `
` }), h.type === "element" && h.tagName === "p" && !r ? o.push(...h.children) : o.push(h);
  }
  const u = i[i.length - 1];
  u && (r || u.type !== "element" || u.tagName !== "p") && o.push({ type: "text", value: `
` });
  const c = { type: "element", tagName: "li", properties: a, children: o };
  return e.patch(t, c), e.applyData(t, c);
}
function iy(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let i = -1;
    for (; !t && ++i < n.length; )
      t = rp(n[i]);
  }
  return t;
}
function rp(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function ry(e, t) {
  const n = {}, i = e.all(t);
  let r = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++r < i.length; ) {
    const o = i[r];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const a = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(i, !0)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function sy(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function ay(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function oy(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function ly(e, t) {
  const n = e.all(t), i = n.shift(), r = [];
  if (i) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(t.children[0], o), r.push(o);
  }
  if (n.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, l = Yc(t.children[1]), u = Kc(t.children[t.children.length - 1]);
    l && u && (o.position = { start: l, end: u }), r.push(o);
  }
  const a = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(r, !0)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function uy(e, t, n) {
  const i = n ? n.children : void 0, a = (i ? i.indexOf(t) : 1) === 0 ? "th" : "td", o = n && n.type === "table" ? n.align : void 0, l = o ? o.length : t.children.length;
  let u = -1;
  const c = [];
  for (; ++u < l; ) {
    const p = t.children[u], m = {}, g = o ? o[u] : void 0;
    g && (m.align = g);
    let b = { type: "element", tagName: a, properties: m, children: [] };
    p && (b.children = e.all(p), e.patch(p, b), b = e.applyData(p, b)), c.push(b);
  }
  const h = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(c, !0)
  };
  return e.patch(t, h), e.applyData(t, h);
}
function cy(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Nu = 9, Du = 32;
function hy(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let i = n.exec(t), r = 0;
  const a = [];
  for (; i; )
    a.push(
      Vu(t.slice(r, i.index), r > 0, !0),
      i[0]
    ), r = i.index + i[0].length, i = n.exec(t);
  return a.push(Vu(t.slice(r), r > 0, !1)), a.join("");
}
function Vu(e, t, n) {
  let i = 0, r = e.length;
  if (t) {
    let a = e.codePointAt(i);
    for (; a === Nu || a === Du; )
      i++, a = e.codePointAt(i);
  }
  if (n) {
    let a = e.codePointAt(r - 1);
    for (; a === Nu || a === Du; )
      r--, a = e.codePointAt(r - 1);
  }
  return r > i ? e.slice(i, r) : "";
}
function py(e, t) {
  const n = { type: "text", value: hy(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function dy(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const fy = {
  blockquote: $x,
  break: qx,
  code: Ux,
  delete: Jx,
  emphasis: Wx,
  footnoteReference: Xx,
  heading: Zx,
  html: Gx,
  imageReference: Kx,
  image: Yx,
  inlineCode: Qx,
  linkReference: ey,
  link: ty,
  listItem: ny,
  list: ry,
  paragraph: sy,
  // @ts-expect-error: root is different, but hard to type.
  root: ay,
  strong: oy,
  table: ly,
  tableCell: cy,
  tableRow: uy,
  text: py,
  thematicBreak: dy,
  toml: Ur,
  yaml: Ur,
  definition: Ur,
  footnoteDefinition: Ur
};
function Ur() {
}
const sp = -1, As = 0, _r = 1, ms = 2, Lo = 3, Po = 4, To = 5, No = 6, ap = 7, op = 8, Mu = typeof self == "object" ? self : globalThis, my = (e, t) => {
  const n = (r, a) => (e.set(a, r), r), i = (r) => {
    if (e.has(r))
      return e.get(r);
    const [a, o] = t[r];
    switch (a) {
      case As:
      case sp:
        return n(o, r);
      case _r: {
        const l = n([], r);
        for (const u of o)
          l.push(i(u));
        return l;
      }
      case ms: {
        const l = n({}, r);
        for (const [u, c] of o)
          l[i(u)] = i(c);
        return l;
      }
      case Lo:
        return n(new Date(o), r);
      case Po: {
        const { source: l, flags: u } = o;
        return n(new RegExp(l, u), r);
      }
      case To: {
        const l = n(/* @__PURE__ */ new Map(), r);
        for (const [u, c] of o)
          l.set(i(u), i(c));
        return l;
      }
      case No: {
        const l = n(/* @__PURE__ */ new Set(), r);
        for (const u of o)
          l.add(i(u));
        return l;
      }
      case ap: {
        const { name: l, message: u } = o;
        return n(new Mu[l](u), r);
      }
      case op:
        return n(BigInt(o), r);
      case "BigInt":
        return n(Object(BigInt(o)), r);
      case "ArrayBuffer":
        return n(new Uint8Array(o).buffer, o);
      case "DataView": {
        const { buffer: l } = new Uint8Array(o);
        return n(new DataView(l), o);
      }
    }
    return n(new Mu[a](o), r);
  };
  return i;
}, Fu = (e) => my(/* @__PURE__ */ new Map(), e)(0), Ii = "", { toString: gy } = {}, { keys: _y } = Object, lr = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [As, t];
  const n = gy.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [_r, Ii];
    case "Object":
      return [ms, Ii];
    case "Date":
      return [Lo, Ii];
    case "RegExp":
      return [Po, Ii];
    case "Map":
      return [To, Ii];
    case "Set":
      return [No, Ii];
    case "DataView":
      return [_r, n];
  }
  return n.includes("Array") ? [_r, n] : n.includes("Error") ? [ap, n] : [ms, n];
}, Jr = ([e, t]) => e === As && (t === "function" || t === "symbol"), xy = (e, t, n, i) => {
  const r = (o, l) => {
    const u = i.push(o) - 1;
    return n.set(l, u), u;
  }, a = (o) => {
    if (n.has(o))
      return n.get(o);
    let [l, u] = lr(o);
    switch (l) {
      case As: {
        let h = o;
        switch (u) {
          case "bigint":
            l = op, h = o.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + u);
            h = null;
            break;
          case "undefined":
            return r([sp], o);
        }
        return r([l, h], o);
      }
      case _r: {
        if (u) {
          let m = o;
          return u === "DataView" ? m = new Uint8Array(o.buffer) : u === "ArrayBuffer" && (m = new Uint8Array(o)), r([u, [...m]], o);
        }
        const h = [], p = r([l, h], o);
        for (const m of o)
          h.push(a(m));
        return p;
      }
      case ms: {
        if (u)
          switch (u) {
            case "BigInt":
              return r([u, o.toString()], o);
            case "Boolean":
            case "Number":
            case "String":
              return r([u, o.valueOf()], o);
          }
        if (t && "toJSON" in o)
          return a(o.toJSON());
        const h = [], p = r([l, h], o);
        for (const m of _y(o))
          (e || !Jr(lr(o[m]))) && h.push([a(m), a(o[m])]);
        return p;
      }
      case Lo:
        return r([l, o.toISOString()], o);
      case Po: {
        const { source: h, flags: p } = o;
        return r([l, { source: h, flags: p }], o);
      }
      case To: {
        const h = [], p = r([l, h], o);
        for (const [m, g] of o)
          (e || !(Jr(lr(m)) || Jr(lr(g)))) && h.push([a(m), a(g)]);
        return p;
      }
      case No: {
        const h = [], p = r([l, h], o);
        for (const m of o)
          (e || !Jr(lr(m))) && h.push(a(m));
        return p;
      }
    }
    const { message: c } = o;
    return r([l, { name: u, message: c }], o);
  };
  return a;
}, Ru = (e, { json: t, lossy: n } = {}) => {
  const i = [];
  return xy(!(t || n), !!t, /* @__PURE__ */ new Map(), i)(e), i;
}, gs = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? Fu(Ru(e, t)) : structuredClone(e)
) : (e, t) => Fu(Ru(e, t));
function yy(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function by(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function vy(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || yy, i = e.options.footnoteBackLabel || by, r = e.options.footnoteLabel || "Footnotes", a = e.options.footnoteLabelTagName || "h2", o = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let u = -1;
  for (; ++u < e.footnoteOrder.length; ) {
    const c = e.footnoteById.get(
      e.footnoteOrder[u]
    );
    if (!c)
      continue;
    const h = e.all(c), p = String(c.identifier).toUpperCase(), m = Gi(p.toLowerCase());
    let g = 0;
    const b = [], v = e.footnoteCounts.get(p);
    for (; v !== void 0 && ++g <= v; ) {
      b.length > 0 && b.push({ type: "text", value: " " });
      let I = typeof n == "string" ? n : n(u, g);
      typeof I == "string" && (I = { type: "text", value: I }), b.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + m + (g > 1 ? "-" + g : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(u, g),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(I) ? I : [I]
      });
    }
    const w = h[h.length - 1];
    if (w && w.type === "element" && w.tagName === "p") {
      const I = w.children[w.children.length - 1];
      I && I.type === "text" ? I.value += " " : w.children.push({ type: "text", value: " " }), w.children.push(...b);
    } else
      h.push(...b);
    const y = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + m },
      children: e.wrap(h, !0)
    };
    e.patch(c, y), l.push(y);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: a,
          properties: {
            ...gs(o),
            id: "footnote-label"
          },
          children: [{ type: "text", value: r }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const Is = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return Sy;
    if (typeof e == "function")
      return Ls(e);
    if (typeof e == "object")
      return Array.isArray(e) ? wy(e) : (
        // Cast because `ReadonlyArray` goes into the above but `isArray`
        // narrows to `Array`.
        ky(
          /** @type {Props} */
          e
        )
      );
    if (typeof e == "string")
      return Cy(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function wy(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = Is(e[n]);
  return Ls(i);
  function i(...r) {
    let a = -1;
    for (; ++a < t.length; )
      if (t[a].apply(this, r)) return !0;
    return !1;
  }
}
function ky(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Ls(n);
  function n(i) {
    const r = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let a;
    for (a in e)
      if (r[a] !== t[a]) return !1;
    return !0;
  }
}
function Cy(e) {
  return Ls(t);
  function t(n) {
    return n && n.type === e;
  }
}
function Ls(e) {
  return t;
  function t(n, i, r) {
    return !!(Ey(n) && e.call(
      this,
      n,
      typeof i == "number" ? i : void 0,
      r || void 0
    ));
  }
}
function Sy() {
  return !0;
}
function Ey(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const lp = [], Ay = !0, Wa = !1, Iy = "skip";
function up(e, t, n, i) {
  let r;
  typeof t == "function" && typeof n != "function" ? (i = n, n = t) : r = t;
  const a = Is(r), o = i ? -1 : 1;
  l(e, void 0, [])();
  function l(u, c, h) {
    const p = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof p.type == "string") {
      const g = (
        // `hast`
        typeof p.tagName == "string" ? p.tagName : (
          // `xast`
          typeof p.name == "string" ? p.name : void 0
        )
      );
      Object.defineProperty(m, "name", {
        value: "node (" + (u.type + (g ? "<" + g + ">" : "")) + ")"
      });
    }
    return m;
    function m() {
      let g = lp, b, v, w;
      if ((!t || a(u, c, h[h.length - 1] || void 0)) && (g = Ly(n(u, h)), g[0] === Wa))
        return g;
      if ("children" in u && u.children) {
        const y = (
          /** @type {UnistParent} */
          u
        );
        if (y.children && g[0] !== Iy)
          for (v = (i ? y.children.length : -1) + o, w = h.concat(y); v > -1 && v < y.children.length; ) {
            const I = y.children[v];
            if (b = l(I, v, w)(), b[0] === Wa)
              return b;
            v = typeof b[1] == "number" ? b[1] : v + o;
          }
      }
      return g;
    }
  }
}
function Ly(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [Ay, e] : e == null ? lp : [e];
}
function Ps(e, t, n, i) {
  let r, a, o;
  typeof t == "function" && typeof n != "function" ? (a = void 0, o = t, r = n) : (a = t, o = n, r = i), up(e, a, l, r);
  function l(u, c) {
    const h = c[c.length - 1], p = h ? h.children.indexOf(u) : void 0;
    return o(u, p, h);
  }
}
const Xa = {}.hasOwnProperty, Py = {};
function Ty(e, t) {
  const n = t || Py, i = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = { ...fy, ...n.handlers }, l = {
    all: c,
    applyData: Dy,
    definitionById: i,
    footnoteById: r,
    footnoteCounts: a,
    footnoteOrder: [],
    handlers: o,
    one: u,
    options: n,
    patch: Ny,
    wrap: My
  };
  return Ps(e, function(h) {
    if (h.type === "definition" || h.type === "footnoteDefinition") {
      const p = h.type === "definition" ? i : r, m = String(h.identifier).toUpperCase();
      p.has(m) || p.set(m, h);
    }
  }), l;
  function u(h, p) {
    const m = h.type, g = l.handlers[m];
    if (Xa.call(l.handlers, m) && g)
      return g(l, h, p);
    if (l.options.passThrough && l.options.passThrough.includes(m)) {
      if ("children" in h) {
        const { children: v, ...w } = h, y = gs(w);
        return y.children = l.all(h), y;
      }
      return gs(h);
    }
    return (l.options.unknownHandler || Vy)(l, h, p);
  }
  function c(h) {
    const p = [];
    if ("children" in h) {
      const m = h.children;
      let g = -1;
      for (; ++g < m.length; ) {
        const b = l.one(m[g], h);
        if (b) {
          if (g && m[g - 1].type === "break" && (!Array.isArray(b) && b.type === "text" && (b.value = Ou(b.value)), !Array.isArray(b) && b.type === "element")) {
            const v = b.children[0];
            v && v.type === "text" && (v.value = Ou(v.value));
          }
          Array.isArray(b) ? p.push(...b) : p.push(b);
        }
      }
    }
    return p;
  }
}
function Ny(e, t) {
  e.position && (t.position = eh(e));
}
function Dy(e, t) {
  let n = t;
  if (e && e.data) {
    const i = e.data.hName, r = e.data.hChildren, a = e.data.hProperties;
    if (typeof i == "string")
      if (n.type === "element")
        n.tagName = i;
      else {
        const o = "children" in n ? n.children : [n];
        n = { type: "element", tagName: i, properties: {}, children: o };
      }
    n.type === "element" && a && Object.assign(n.properties, gs(a)), "children" in n && n.children && r !== null && r !== void 0 && (n.children = r);
  }
  return n;
}
function Vy(e, t) {
  const n = t.data || {}, i = "value" in t && !(Xa.call(n, "hProperties") || Xa.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function My(e, t) {
  const n = [];
  let i = -1;
  for (t && n.push({ type: "text", value: `
` }); ++i < e.length; )
    i && n.push({ type: "text", value: `
` }), n.push(e[i]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function Ou(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function Bu(e, t) {
  const n = Ty(e, t), i = n.one(e, void 0), r = vy(n), a = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return r && a.children.push({ type: "text", value: `
` }, r), a;
}
function Fy(e, t) {
  return e && "run" in e ? async function(n, i) {
    const r = (
      /** @type {HastRoot} */
      Bu(n, { file: i, ...t })
    );
    await e.run(r, i);
  } : function(n, i) {
    return (
      /** @type {HastRoot} */
      Bu(n, { file: i, ...e || t })
    );
  };
}
function zu(e) {
  if (e)
    throw e;
}
var aa, ju;
function Ry() {
  if (ju) return aa;
  ju = 1;
  var e = Object.prototype.hasOwnProperty, t = Object.prototype.toString, n = Object.defineProperty, i = Object.getOwnPropertyDescriptor, r = function(c) {
    return typeof Array.isArray == "function" ? Array.isArray(c) : t.call(c) === "[object Array]";
  }, a = function(c) {
    if (!c || t.call(c) !== "[object Object]")
      return !1;
    var h = e.call(c, "constructor"), p = c.constructor && c.constructor.prototype && e.call(c.constructor.prototype, "isPrototypeOf");
    if (c.constructor && !h && !p)
      return !1;
    var m;
    for (m in c)
      ;
    return typeof m > "u" || e.call(c, m);
  }, o = function(c, h) {
    n && h.name === "__proto__" ? n(c, h.name, {
      enumerable: !0,
      configurable: !0,
      value: h.newValue,
      writable: !0
    }) : c[h.name] = h.newValue;
  }, l = function(c, h) {
    if (h === "__proto__")
      if (e.call(c, h)) {
        if (i)
          return i(c, h).value;
      } else return;
    return c[h];
  };
  return aa = function u() {
    var c, h, p, m, g, b, v = arguments[0], w = 1, y = arguments.length, I = !1;
    for (typeof v == "boolean" && (I = v, v = arguments[1] || {}, w = 2), (v == null || typeof v != "object" && typeof v != "function") && (v = {}); w < y; ++w)
      if (c = arguments[w], c != null)
        for (h in c)
          p = l(v, h), m = l(c, h), v !== m && (I && m && (a(m) || (g = r(m))) ? (g ? (g = !1, b = p && r(p) ? p : []) : b = p && a(p) ? p : {}, o(v, { name: h, newValue: u(I, b, m) })) : typeof m < "u" && o(v, { name: h, newValue: m }));
    return v;
  }, aa;
}
var Oy = Ry();
const oa = /* @__PURE__ */ Sr(Oy);
function Za(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function By() {
  const e = [], t = { run: n, use: i };
  return t;
  function n(...r) {
    let a = -1;
    const o = r.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    l(null, ...r);
    function l(u, ...c) {
      const h = e[++a];
      let p = -1;
      if (u) {
        o(u);
        return;
      }
      for (; ++p < r.length; )
        (c[p] === null || c[p] === void 0) && (c[p] = r[p]);
      r = c, h ? zy(h, l)(...c) : o(null, ...c);
    }
  }
  function i(r) {
    if (typeof r != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + r
      );
    return e.push(r), t;
  }
}
function zy(e, t) {
  let n;
  return i;
  function i(...o) {
    const l = e.length > o.length;
    let u;
    l && o.push(r);
    try {
      u = e.apply(this, o);
    } catch (c) {
      const h = (
        /** @type {Error} */
        c
      );
      if (l && n)
        throw h;
      return r(h);
    }
    l || (u && u.then && typeof u.then == "function" ? u.then(a, r) : u instanceof Error ? r(u) : a(u));
  }
  function r(o, ...l) {
    n || (n = !0, t(o, ...l));
  }
  function a(o) {
    r(null, o);
  }
}
const jy = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), r = i[e], a = function() {
      return r.apply(a, arguments);
    };
    return Object.setPrototypeOf(a, i), a;
  })
), Hy = {}.hasOwnProperty;
class Do extends jy {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = By();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Do()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const i = this.attachers[n];
      t.use(...i);
    }
    return t.data(oa(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (ca("data", this.frozen), this.namespace[t] = n, this) : Hy.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (ca("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const r = n.call(t, ...i);
      typeof r == "function" && this.transformers.use(r);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = Wr(t), i = this.parser || this.Parser;
    return la("parse", i), i(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const i = this;
    return this.freeze(), la("process", this.parser || this.Parser), ua("process", this.compiler || this.Compiler), n ? r(void 0, n) : new Promise(r);
    function r(a, o) {
      const l = Wr(t), u = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(u, l, function(h, p, m) {
        if (h || !p || !m)
          return c(h);
        const g = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          p
        ), b = i.stringify(g, m);
        Uy(b) ? m.value = b : m.result = b, c(
          h,
          /** @type {VFileWithOutput<CompileResult>} */
          m
        );
      });
      function c(h, p) {
        h || !p ? o(h) : a ? a(p) : n(void 0, p);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, i;
    return this.freeze(), la("processSync", this.parser || this.Parser), ua("processSync", this.compiler || this.Compiler), this.process(t, r), $u("processSync", "process", n), i;
    function r(a, o) {
      n = !0, zu(a), i = o;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, i) {
    Hu(t), this.freeze();
    const r = this.transformers;
    return !i && typeof n == "function" && (i = n, n = void 0), i ? a(void 0, i) : new Promise(a);
    function a(o, l) {
      const u = Wr(n);
      r.run(t, u, c);
      function c(h, p, m) {
        const g = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          p || t
        );
        h ? l(h) : o ? o(g) : i(void 0, g, m);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let i = !1, r;
    return this.run(t, n, a), $u("runSync", "run", i), r;
    function a(o, l) {
      zu(o), r = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const i = Wr(n), r = this.compiler || this.Compiler;
    return ua("stringify", r), Hu(t), r(t, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const i = this.attachers, r = this.namespace;
    if (ca("use", this.frozen), t != null) if (typeof t == "function")
      u(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? l(t) : o(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function a(c) {
      if (typeof c == "function")
        u(c, []);
      else if (typeof c == "object")
        if (Array.isArray(c)) {
          const [h, ...p] = (
            /** @type {PluginTuple<Array<unknown>>} */
            c
          );
          u(h, p);
        } else
          o(c);
      else
        throw new TypeError("Expected usable value, not `" + c + "`");
    }
    function o(c) {
      if (!("plugins" in c) && !("settings" in c))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(c.plugins), c.settings && (r.settings = oa(!0, r.settings, c.settings));
    }
    function l(c) {
      let h = -1;
      if (c != null) if (Array.isArray(c))
        for (; ++h < c.length; ) {
          const p = c[h];
          a(p);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + c + "`");
    }
    function u(c, h) {
      let p = -1, m = -1;
      for (; ++p < i.length; )
        if (i[p][0] === c) {
          m = p;
          break;
        }
      if (m === -1)
        i.push([c, ...h]);
      else if (h.length > 0) {
        let [g, ...b] = h;
        const v = i[m][1];
        Za(v) && Za(g) && (g = oa(!0, v, g)), i[m] = [c, g, ...b];
      }
    }
  }
}
const $y = new Do().freeze();
function la(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function ua(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function ca(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Hu(e) {
  if (!Za(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function $u(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function Wr(e) {
  return qy(e) ? e : new Fc(e);
}
function qy(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function Uy(e) {
  return typeof e == "string" || Jy(e);
}
function Jy(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
function Wn(e, t) {
  const n = ["start", "end", "loc", "range"];
  let i = -1;
  for (; ++i < n.length; ) {
    const r = n[i];
    r in e && (t[r] = e[r]);
  }
}
function Vo(e, t) {
  let n = -1;
  const i = [], r = [];
  let a;
  for (; ++n < e.length; ) {
    const o = e[n];
    o.type === "ImportNamespaceSpecifier" ? a = o : r.push(o);
  }
  if (a) {
    const o = {
      type: "VariableDeclarator",
      id: a.local,
      init: t
    };
    Wn(a, o), i.push(o);
  }
  return i.push({
    type: "VariableDeclarator",
    id: {
      type: "ObjectPattern",
      properties: r.map(function(o) {
        let l = o.type === "ImportSpecifier" ? o.imported : o.type === "ExportSpecifier" ? o.exported : { type: "Identifier", name: "default" }, u = o.local;
        o.type === "ExportSpecifier" && (u = l, l = o.local), u.type;
        const c = {
          type: "Property",
          kind: "init",
          shorthand: l.type === "Identifier" && u.type === "Identifier" && l.name === u.name,
          method: !1,
          computed: !1,
          key: l,
          value: u
        };
        return Wn(o, c), c;
      })
    },
    init: a ? { type: "Identifier", name: a.local.name } : t
  }), i;
}
function Gn(e) {
  let t = -1, n;
  for (; ++t < e.length; ) {
    const i = e[t], r = typeof i == "string" && vn(i) ? { type: "Identifier", name: i } : { type: "Literal", value: i };
    n = n ? {
      type: "MemberExpression",
      object: n,
      property: r,
      computed: r.type === "Literal",
      optional: !1
    } : r;
  }
  return n.type, n;
}
function qu(e) {
  let t = -1, n;
  for (; ++t < e.length; ) {
    const i = e[t];
    typeof i == "string" && vn(i, { jsx: !0 });
    const r = { type: "JSXIdentifier", name: i };
    n = n ? { type: "JSXMemberExpression", object: n, property: r } : r;
  }
  return n;
}
function Wy(e) {
  const { outputFormat: t } = e || {};
  return function(n) {
    if (n.comments && (n.comments = n.comments.filter(function(i) {
      return !i.data?._mdxIsPragmaComment;
    })), t === "function-body") {
      let i = 0;
      for (; i < n.body.length; ) {
        const a = n.body[i];
        if ("directive" in a && a.directive)
          i++;
        else
          break;
      }
      const r = n.body[i];
      r && r.type === "ImportDeclaration" && typeof r.source.value == "string" && /\/jsx-(dev-)?runtime$/.test(r.source.value) && (n.body[i] = {
        type: "VariableDeclaration",
        kind: "const",
        declarations: Vo(
          r.specifiers,
          Gn(["arguments", 0])
        )
      });
    }
  };
}
function cp() {
  const e = [{ block: !1, defined: [] }];
  return { enter: t, exit: n, scopes: e };
  function t(a) {
    if (a.type === "ArrowFunctionExpression") {
      e.push({ block: !1, defined: [] });
      for (const o of a.params)
        r(o, !1);
    } else if (a.type === "BlockStatement" || a.type === "DoWhileStatement" || a.type === "ForInStatement" || a.type === "ForOfStatement" || a.type === "ForStatement" || a.type === "WhileStatement")
      e.push({ block: !0, defined: [] });
    else if (a.type === "CatchClause")
      e.push({ block: !0, defined: [] }), a.param && r(a.param, !0);
    else if (a.type === "ClassDeclaration")
      i(a.id.name, !1);
    else if (a.type === "FunctionDeclaration") {
      i(a.id.name, !1), e.push({ block: !1, defined: [] });
      for (const o of a.params)
        r(o, !1);
    } else if (a.type === "FunctionExpression") {
      a.id && i(a.id.name, !1), e.push({ block: !1, defined: [] });
      for (const o of a.params)
        r(o, !1);
    } else if (a.type === "ImportDeclaration")
      for (const o of a.specifiers)
        i(o.local.name, !1);
    else if (a.type === "VariableDeclaration")
      for (const o of a.declarations)
        r(o.id, a.kind !== "var");
  }
  function n(a) {
    if (a.type === "ArrowFunctionExpression" || a.type === "FunctionDeclaration" || a.type === "FunctionExpression") {
      const o = e.pop();
      o.block;
    } else if (a.type === "BlockStatement" || a.type === "CatchClause" || a.type === "DoWhileStatement" || a.type === "ForInStatement" || a.type === "ForOfStatement" || a.type === "ForStatement" || a.type === "WhileStatement") {
      const o = e.pop();
      o.block;
    }
  }
  function i(a, o) {
    let l = e.length, u;
    for (; l-- && (u = e[l], !(o || !u.block)); )
      ;
    u.defined.push(a);
  }
  function r(a, o) {
    if (a.type === "ArrayPattern")
      for (const l of a.elements)
        l && r(l, o);
    else if (a.type === "AssignmentPattern")
      r(a.left, o);
    else if (a.type === "Identifier")
      i(a.name, o);
    else if (a.type === "ObjectPattern")
      for (const l of a.properties)
        l.type === "Property" ? r(l.value, o) : (l.type, r(l, o));
    else
      a.type, r(a.argument, o);
  }
}
function Xy(e) {
  return e.type === "FunctionDeclaration" ? { ...e, type: "FunctionExpression" } : (e.type, { ...e, type: "ClassExpression" });
}
function Zy(e) {
  return e.type === "FunctionDeclaration" || e.type === "ClassDeclaration" || e.type === "VariableDeclaration";
}
function Gy(e) {
  const t = e.baseUrl || void 0, n = typeof t == "object" ? t.href : t, i = e.outputFormat || "program", r = e.pragma === void 0 ? "React.createElement" : e.pragma, a = e.pragmaFrag === void 0 ? "React.Fragment" : e.pragmaFrag, o = e.pragmaImportSource || "react", l = e.jsxImportSource || "react", u = e.jsxRuntime || "automatic";
  return function(h, p) {
    const m = [], g = [];
    let b = 0, v, w, y;
    if (u === "classic" && a && Xr(h, "@jsxFrag", a), u === "classic" && r && Xr(h, "@jsx", r), u === "automatic" && l && Xr(h, "@jsxImportSource", l), Xr(h, "@jsxRuntime", u), u === "classic" && o) {
      if (!r)
        throw new Error(
          "Missing `pragma` in classic runtime with `pragmaImportSource`"
        );
      S({
        type: "ImportDeclaration",
        specifiers: [
          {
            type: "ImportDefaultSpecifier",
            local: { type: "Identifier", name: r.split(".")[0] }
          }
        ],
        attributes: [],
        source: { type: "Literal", value: o }
      });
    }
    for (y of h.body)
      if (y.type === "ExportDefaultDeclaration")
        v && p.fail(
          "Unexpected duplicate layout, expected a single layout (previous: " + nn(Vn(v)) + ")",
          {
            ancestors: [h, y],
            place: Vn(y),
            ruleId: "duplicate-layout",
            source: "recma-document"
          }
        ), v = y, g.push({
          type: "VariableDeclaration",
          kind: "const",
          declarations: [
            {
              type: "VariableDeclarator",
              id: { type: "Identifier", name: "MDXLayout" },
              init: Zy(y.declaration) ? Xy(y.declaration) : y.declaration
            }
          ]
        });
      else if (y.type === "ExportNamedDeclaration" && y.source) {
        const f = (
          /** @type {SimpleLiteral} */
          y.source
        );
        y.specifiers = y.specifiers.filter(function(C) {
          if (C.exported.type === "Identifier" && C.exported.name === "default") {
            v && p.fail(
              "Unexpected duplicate layout, expected a single layout (previous: " + nn(Vn(v)) + ")",
              {
                ancestors: [h, y, C],
                place: Vn(y),
                ruleId: "duplicate-layout",
                source: "recma-document"
              }
            ), v = C;
            const L = [];
            if (C.local.type === "Identifier" && C.local.name === "default")
              L.push({
                type: "ImportDefaultSpecifier",
                local: { type: "Identifier", name: "MDXLayout" }
              });
            else {
              const z = {
                type: "ImportSpecifier",
                imported: C.local,
                local: { type: "Identifier", name: "MDXLayout" }
              };
              Wn(C.local, z), L.push(z);
            }
            const F = { type: "Literal", value: f.value };
            Wn(f, F);
            const M = {
              type: "ImportDeclaration",
              specifiers: L,
              attributes: [],
              source: F
            };
            return Wn(C, M), S(M), !1;
          }
          return !0;
        }), y.specifiers.length > 0 && P(y);
      } else y.type === "ExportNamedDeclaration" || y.type === "ExportAllDeclaration" ? P(y) : y.type === "ImportDeclaration" ? S(y) : y.type === "ExpressionStatement" && (y.expression.type === "JSXElement" || y.expression.type === "JSXFragment") ? (w = !0, g.push(
        ...c(y.expression, i, !!v)
      )) : g.push(y);
    w || g.push(
      ...c(void 0, i, !!v)
    ), m.push(["MDXContent", "default"]), i === "function-body" && g.push({
      type: "ReturnStatement",
      argument: {
        type: "ObjectExpression",
        properties: [
          ...Array.from({ length: b }).map(
            /**
             * @param {undefined} _
             *   Nothing.
             * @param {number} index
             *   Index.
             * @returns {SpreadElement}
             *   Node.
             */
            function(f, C) {
              return {
                type: "SpreadElement",
                argument: {
                  type: "Identifier",
                  name: "_exportAll" + (C + 1)
                }
              };
            }
          ),
          ...m.map(function(f) {
            return {
              type: "Property",
              kind: "init",
              method: !1,
              computed: !1,
              shorthand: typeof f == "string",
              key: {
                type: "Identifier",
                name: typeof f == "string" ? f : f[1]
              },
              value: {
                type: "Identifier",
                name: typeof f == "string" ? f : f[0]
              }
            };
          })
        ]
      }
    }), h.body = g;
    let I = !1, E = !1;
    (n || i === "function-body") && Vi(h, {
      enter(f) {
        if ((f.type === "ExportAllDeclaration" || f.type === "ExportNamedDeclaration" || f.type === "ImportDeclaration") && f.source) {
          let C = f.source.value;
          try {
            new URL(C);
          } catch {
            (C.startsWith("/") || C.startsWith("./") || C.startsWith("../")) && (C = new URL(C, n).href);
          }
          const L = { type: "Literal", value: C };
          Wn(f.source, L), f.source = L;
          return;
        }
        if (f.type === "ImportExpression") {
          E = !0;
          const C = {
            type: "CallExpression",
            callee: { type: "Identifier", name: "_resolveDynamicMdxSpecifier" },
            arguments: [f.source],
            optional: !1
          };
          f.source = C;
          return;
        }
        if (f.type === "MemberExpression" && "object" in f && f.object.type === "MetaProperty" && f.property.type === "Identifier" && f.object.meta.name === "import" && f.object.property.name === "meta" && f.property.name === "url") {
          I = !0;
          const C = { type: "Identifier", name: "_importMetaUrl" };
          Wn(f, C), this.replace(C);
        }
      }
    }), E && (n || (I = !0), h.body.push(
      Ky(
        n ? { type: "Literal", value: n } : { type: "Identifier", name: "_importMetaUrl" }
      )
    )), I && h.body.unshift(...Yy());
    function P(f) {
      if (f.type === "ExportNamedDeclaration") {
        if (f.declaration) {
          const C = cp();
          Vi(f, {
            enter(L) {
              C.enter(L), (L.type === "ArrowFunctionExpression" || L.type === "FunctionDeclaration" || L.type === "FunctionExpression") && (this.skip(), C.exit(L));
            },
            leave: C.exit
          }), m.push(...C.scopes[0].defined);
        }
        for (y of f.specifiers)
          y.exported.type === "Identifier" ? m.push(y.exported.name) : (y.exported.value, m.push(y.exported.value));
      }
      S(f);
    }
    function S(f) {
      let C, L;
      if (i === "function-body")
        if (
          // Always have a source:
          f.type === "ImportDeclaration" || f.type === "ExportAllDeclaration" || // Source optional:
          f.type === "ExportNamedDeclaration" && f.source
        ) {
          f.source;
          const F = { type: "ImportExpression", source: f.source };
          Wn(f, F), L = { type: "AwaitExpression", argument: F }, (f.type === "ImportDeclaration" || f.type === "ExportNamedDeclaration") && f.specifiers.length === 0 ? C = { type: "ExpressionStatement", expression: L } : C = {
            type: "VariableDeclaration",
            kind: "const",
            declarations: f.type === "ExportAllDeclaration" ? [
              {
                type: "VariableDeclarator",
                id: {
                  type: "Identifier",
                  name: "_exportAll" + ++b
                },
                init: L
              }
            ] : Vo(f.specifiers, L)
          };
        } else if (f.declaration)
          C = f.declaration;
        else {
          const F = [];
          for (const M of f.specifiers)
            M.exported.type === "Identifier" && M.local.type === "Identifier" && M.local.name !== M.exported.name && F.push({
              type: "VariableDeclarator",
              id: M.exported,
              init: M.local
            });
          F.length > 0 && (C = {
            type: "VariableDeclaration",
            kind: "const",
            declarations: F
          });
        }
      else
        C = f;
      C && g.push(C);
    }
  };
  function c(h, p, m) {
    let b = {
      type: "JSXElement",
      openingElement: {
        type: "JSXOpeningElement",
        name: { type: "JSXIdentifier", name: "MDXLayout" },
        attributes: [
          {
            type: "JSXSpreadAttribute",
            argument: { type: "Identifier", name: "props" }
          }
        ],
        selfClosing: !1
      },
      closingElement: {
        type: "JSXClosingElement",
        name: { type: "JSXIdentifier", name: "MDXLayout" }
      },
      children: [
        {
          type: "JSXElement",
          openingElement: {
            type: "JSXOpeningElement",
            name: { type: "JSXIdentifier", name: "_createMdxContent" },
            attributes: [
              {
                type: "JSXSpreadAttribute",
                argument: { type: "Identifier", name: "props" }
              }
            ],
            selfClosing: !0
          },
          closingElement: null,
          children: []
        }
      ]
    };
    m || (b = {
      type: "ConditionalExpression",
      test: { type: "Identifier", name: "MDXLayout" },
      consequent: b,
      alternate: {
        type: "CallExpression",
        callee: { type: "Identifier", name: "_createMdxContent" },
        arguments: [{ type: "Identifier", name: "props" }],
        optional: !1
      }
    });
    let v = (
      // Cast because TS otherwise does not think `JSXFragment`s are expressions.
      /** @type {Readonly<Expression> | Readonly<JSXFragment>} */
      h || { type: "Identifier", name: "undefined" }
    );
    v.type === "JSXFragment" && v.children.length === 1 && v.children[0].type === "JSXElement" && (v = v.children[0]);
    let w = !1;
    Vi(v, {
      enter(I) {
        if (I.type === "ArrowFunctionExpression" || I.type === "FunctionDeclaration" || I.type === "FunctionExpression")
          return this.skip();
        (I.type === "AwaitExpression" || /* c8 ignore next 2 -- can only occur in a function (which then can
         * only be async, so skipped it) */
        I.type === "ForOfStatement" && I.await) && (w = !0);
      }
    });
    const y = {
      type: "FunctionDeclaration",
      id: { type: "Identifier", name: "MDXContent" },
      params: [
        {
          type: "AssignmentPattern",
          left: { type: "Identifier", name: "props" },
          right: { type: "ObjectExpression", properties: [] }
        }
      ],
      body: {
        type: "BlockStatement",
        body: [{ type: "ReturnStatement", argument: b }]
      }
    };
    return [
      {
        type: "FunctionDeclaration",
        async: w,
        id: { type: "Identifier", name: "_createMdxContent" },
        params: [{ type: "Identifier", name: "props" }],
        body: {
          type: "BlockStatement",
          body: [
            {
              type: "ReturnStatement",
              // Cast because TS doesn’t think `JSXFragment` is an expression.
              // eslint-disable-next-line object-shorthand
              argument: (
                /** @type {Expression} */
                v
              )
            }
          ]
        }
      },
      p === "program" ? { type: "ExportDefaultDeclaration", declaration: y } : y
    ];
  }
}
function Xr(e, t, n) {
  e.comments?.unshift({
    type: "Block",
    value: t + " " + n,
    data: { _mdxIsPragmaComment: !0 }
  });
}
function Ky(e) {
  return {
    type: "FunctionDeclaration",
    id: { type: "Identifier", name: "_resolveDynamicMdxSpecifier" },
    generator: !1,
    async: !1,
    params: [{ type: "Identifier", name: "d" }],
    body: {
      type: "BlockStatement",
      body: [
        {
          type: "IfStatement",
          test: {
            type: "BinaryExpression",
            left: {
              type: "UnaryExpression",
              operator: "typeof",
              prefix: !0,
              argument: { type: "Identifier", name: "d" }
            },
            operator: "!==",
            right: { type: "Literal", value: "string" }
          },
          consequent: {
            type: "ReturnStatement",
            argument: { type: "Identifier", name: "d" }
          },
          alternate: null
        },
        // To do: use `URL.canParse` when widely supported (see commented
        // out code below).
        {
          type: "TryStatement",
          block: {
            type: "BlockStatement",
            body: [
              {
                type: "ExpressionStatement",
                expression: {
                  type: "NewExpression",
                  callee: { type: "Identifier", name: "URL" },
                  arguments: [{ type: "Identifier", name: "d" }]
                }
              },
              {
                type: "ReturnStatement",
                argument: { type: "Identifier", name: "d" }
              }
            ]
          },
          handler: {
            type: "CatchClause",
            param: null,
            body: { type: "BlockStatement", body: [] }
          },
          finalizer: null
        },
        // To do: use `URL.canParse` when widely supported.
        // {
        //   type: 'IfStatement',
        //   test: {
        //     type: 'CallExpression',
        //     callee: toIdOrMemberExpression(['URL', 'canParse']),
        //     arguments: [{type: 'Identifier', name: 'd'}],
        //     optional: false
        //   },
        //   consequent: {
        //     type: 'ReturnStatement',
        //     argument: {type: 'Identifier', name: 'd'}
        //   },
        //   alternate: null
        // },
        {
          type: "IfStatement",
          test: {
            type: "LogicalExpression",
            left: {
              type: "LogicalExpression",
              left: {
                type: "CallExpression",
                callee: Gn(["d", "startsWith"]),
                arguments: [{ type: "Literal", value: "/" }],
                optional: !1
              },
              operator: "||",
              right: {
                type: "CallExpression",
                callee: Gn(["d", "startsWith"]),
                arguments: [{ type: "Literal", value: "./" }],
                optional: !1
              }
            },
            operator: "||",
            right: {
              type: "CallExpression",
              callee: Gn(["d", "startsWith"]),
              arguments: [{ type: "Literal", value: "../" }],
              optional: !1
            }
          },
          consequent: {
            type: "ReturnStatement",
            argument: {
              type: "MemberExpression",
              object: {
                type: "NewExpression",
                callee: { type: "Identifier", name: "URL" },
                arguments: [{ type: "Identifier", name: "d" }, e]
              },
              property: { type: "Identifier", name: "href" },
              computed: !1,
              optional: !1
            }
          },
          alternate: null
        },
        {
          type: "ReturnStatement",
          argument: { type: "Identifier", name: "d" }
        }
      ]
    }
  };
}
function Yy() {
  return [
    {
      type: "VariableDeclaration",
      declarations: [
        {
          type: "VariableDeclarator",
          id: { type: "Identifier", name: "_importMetaUrl" },
          init: Gn(["arguments", 0, "baseUrl"])
        }
      ],
      kind: "const"
    },
    {
      type: "IfStatement",
      test: {
        type: "UnaryExpression",
        operator: "!",
        prefix: !0,
        argument: { type: "Identifier", name: "_importMetaUrl" }
      },
      consequent: {
        type: "ThrowStatement",
        argument: {
          type: "NewExpression",
          callee: { type: "Identifier", name: "Error" },
          arguments: [
            {
              type: "Literal",
              value: "Unexpected missing `options.baseUrl` needed to support `export … from`, `import`, or `import.meta.url` when generating `function-body`"
            }
          ]
        }
      },
      alternate: null
    }
  ];
}
function Uu(e) {
  let t = -1, n;
  for (; ++t < e.length; ) {
    const i = e[t];
    n = n ? { type: "BinaryExpression", left: n, operator: "+", right: i } : i;
  }
  return n;
}
function Qy(e) {
  const { development: t, outputFormat: n, providerImportSource: i } = e;
  return function(r, a) {
    const o = cp(), l = [];
    let u = !1, c = !1;
    if (Vi(r, {
      enter(h) {
        o.enter(h), (h.type === "FunctionDeclaration" || h.type === "FunctionExpression" || h.type === "ArrowFunctionExpression") && (l.push({
          components: [],
          idToInvalidComponentName: /* @__PURE__ */ new Map(),
          node: h,
          objects: [],
          references: {},
          tags: []
        }), Li(h, "MDXContent") && !ha(o.scopes, "MDXLayout") && l[0].components.push("MDXLayout"));
        const p = l[0];
        if (!(!p || !Li(p.node, "_createMdxContent") && !i) && h.type === "JSXElement") {
          let m = h.openingElement.name;
          if (m.type === "JSXMemberExpression") {
            const g = [];
            for (; m.type === "JSXMemberExpression"; )
              g.unshift(m.property.name), m = m.object;
            g.unshift(m.name);
            const b = g.join("."), v = m.name, w = ha(o.scopes, v);
            !Object.hasOwn(p.references, b) && (!w || // If the parent scope is `_createMdxContent`, then this
            // references a component we can add a check statement for.
            l.length === 1 && l[0].node.type === "FunctionDeclaration" && Li(l[0].node, "_createMdxContent")) && (p.references[b] = { component: !0, node: h }), !p.objects.includes(v) && !w && p.objects.push(v);
          } else if (m.type !== "JSXNamespacedName") {
            if (vn(m.name) && !/^[a-z]/.test(m.name)) {
              const g = m.name;
              ha(o.scopes, g) || (g !== "MDXLayout" && !Object.hasOwn(p.references, g) && (p.references[g] = { component: !0, node: h }), p.components.includes(g) || p.components.push(g));
            } else if (!(h.data && h.data._mdxExplicitJsx)) {
              const g = m.name;
              p.tags.includes(g) || p.tags.push(g);
              let b = ["_components", g];
              if (vn(g) === !1) {
                let v = p.idToInvalidComponentName.get(g);
                v === void 0 && (v = `_component${p.idToInvalidComponentName.size}`, p.idToInvalidComponentName.set(
                  g,
                  v
                )), b = [v];
              }
              h.openingElement.name = qu(b), h.closingElement && (h.closingElement.name = qu(b));
            }
          }
        }
      },
      leave(h) {
        o.exit(h);
        const p = [], m = [], g = [], b = [];
        if (h.type === "FunctionDeclaration" || h.type === "FunctionExpression" || h.type === "ArrowFunctionExpression") {
          const v = l[l.length - 1];
          let w;
          for (w of v.tags.sort())
            p.push({
              type: "Property",
              kind: "init",
              key: vn(w) ? { type: "Identifier", name: w } : { type: "Literal", value: w },
              value: { type: "Literal", value: w },
              method: !1,
              shorthand: !1,
              computed: !1
            });
          m.push(...v.components);
          for (w of v.objects)
            m.includes(w) || m.push(w);
          m.sort();
          const y = [];
          if (p.length > 0 || m.length > 0 || v.idToInvalidComponentName.size > 0) {
            if (i && (u = !0, g.push({
              type: "CallExpression",
              callee: { type: "Identifier", name: "_provideComponents" },
              arguments: [],
              optional: !1
            })), (Li(v.node, "MDXContent") || Li(v.node, "_createMdxContent")) && g.push(Gn(["props", "components"])), p.length > 0 || g.length > 1)
              for (const C of g)
                p.push({ type: "SpreadElement", argument: C });
            let S = p.length > 0 ? { type: "ObjectExpression", properties: p } : (
              // If we’re only getting components from `props.components`,
              // make sure it’s defined.
              {
                type: "LogicalExpression",
                operator: "||",
                left: g[0],
                right: { type: "ObjectExpression", properties: [] }
              }
            ), f;
            if (m.length > 0 && (f = {
              type: "ObjectPattern",
              properties: m.map(function(C) {
                return {
                  type: "Property",
                  kind: "init",
                  key: {
                    type: "Identifier",
                    name: C === "MDXLayout" ? "wrapper" : C
                  },
                  value: { type: "Identifier", name: C },
                  method: !1,
                  shorthand: C !== "MDXLayout",
                  computed: !1
                };
              })
            }), v.tags.length > 0 && (b.push({
              type: "VariableDeclarator",
              id: { type: "Identifier", name: "_components" },
              init: S
            }), S = { type: "Identifier", name: "_components" }), Li(v.node, "_createMdxContent"))
              for (const [C, L] of [
                ...v.idToInvalidComponentName
              ].sort(function([F], [M]) {
                return F.localeCompare(M);
              }))
                b.push({
                  type: "VariableDeclarator",
                  id: {
                    type: "Identifier",
                    name: L
                  },
                  init: {
                    type: "MemberExpression",
                    object: { type: "Identifier", name: "_components" },
                    property: { type: "Literal", value: C },
                    computed: !0,
                    optional: !1
                  }
                });
            f && b.push({
              type: "VariableDeclarator",
              id: f,
              init: S
            }), b.length > 0 && y.push({
              type: "VariableDeclaration",
              kind: "const",
              declarations: b
            });
          }
          let I;
          for (I in v.references)
            if (Object.hasOwn(v.references, I)) {
              const S = I.split(".");
              let f = 0;
              for (; ++f < S.length; ) {
                const C = S.slice(0, f).join(".");
                Object.hasOwn(v.references, C) || (v.references[C] = {
                  component: !1,
                  node: v.references[I].node
                });
              }
            }
          const E = Object.keys(v.references).sort();
          let P = -1;
          for (; ++P < E.length; ) {
            const S = E[P], f = v.references[S], C = nn(Vn(f.node)), L = [
              { type: "Literal", value: S },
              { type: "Literal", value: f.component }
            ];
            c = !0, t && C && L.push({ type: "Literal", value: C }), y.push({
              type: "IfStatement",
              test: {
                type: "UnaryExpression",
                operator: "!",
                prefix: !0,
                argument: Gn(S.split("."))
              },
              consequent: {
                type: "ExpressionStatement",
                expression: {
                  type: "CallExpression",
                  callee: { type: "Identifier", name: "_missingMdxReference" },
                  arguments: L,
                  optional: !1
                }
              },
              alternate: void 0
            });
          }
          y.length > 0 && (h.body.type !== "BlockStatement" && (h.body = {
            type: "BlockStatement",
            body: [{ type: "ReturnStatement", argument: h.body }]
          }), h.body.body.unshift(...y)), l.pop();
        }
      }
    }), u && i && r.body.unshift(
      eb(i, n)
    ), c) {
      const h = [
        { type: "Literal", value: "Expected " },
        {
          type: "ConditionalExpression",
          test: { type: "Identifier", name: "component" },
          consequent: { type: "Literal", value: "component" },
          alternate: { type: "Literal", value: "object" }
        },
        { type: "Literal", value: " `" },
        { type: "Identifier", name: "id" },
        {
          type: "Literal",
          value: "` to be defined: you likely forgot to import, pass, or provide it."
        }
      ], p = [
        { type: "Identifier", name: "id" },
        { type: "Identifier", name: "component" }
      ];
      t && (h.push({
        type: "ConditionalExpression",
        test: { type: "Identifier", name: "place" },
        consequent: Uu([
          { type: "Literal", value: "\nIt’s referenced in your code at `" },
          { type: "Identifier", name: "place" },
          {
            type: "Literal",
            value: (a.path ? "` in `" + a.path : "") + "`"
          }
        ]),
        alternate: { type: "Literal", value: "" }
      }), p.push({ type: "Identifier", name: "place" })), r.body.push({
        type: "FunctionDeclaration",
        id: { type: "Identifier", name: "_missingMdxReference" },
        generator: !1,
        async: !1,
        params: p,
        body: {
          type: "BlockStatement",
          body: [
            {
              type: "ThrowStatement",
              argument: {
                type: "NewExpression",
                callee: { type: "Identifier", name: "Error" },
                arguments: [Uu(h)]
              }
            }
          ]
        }
      });
    }
    n === "function-body" && r.body.unshift({
      type: "ExpressionStatement",
      expression: { type: "Literal", value: "use strict" },
      directive: "use strict"
    });
  };
}
function eb(e, t) {
  const n = [
    {
      type: "ImportSpecifier",
      imported: { type: "Identifier", name: "useMDXComponents" },
      local: { type: "Identifier", name: "_provideComponents" }
    }
  ];
  return t === "function-body" ? {
    type: "VariableDeclaration",
    kind: "const",
    declarations: Vo(
      n,
      Gn(["arguments", 0])
    )
  } : {
    type: "ImportDeclaration",
    specifiers: n,
    attributes: [],
    source: { type: "Literal", value: e }
  };
}
function Li(e, t) {
  return !!(e && "id" in e && e.id && e.id.name === t);
}
function ha(e, t) {
  let n = e.length;
  for (; n--; )
    if (e[n].defined.includes(t))
      return !0;
  return !1;
}
function tb() {
  return function(e) {
    Ps(e, "raw", function(t, n, i) {
      if (i && typeof n == "number")
        return i.children.splice(n, 1), n;
    });
  };
}
const nb = /\s+/g, ib = /[\t\n\v\f\r ]+/g;
function rb(e, t) {
  t ? typeof t == "string" && (t = { style: t }) : t = {};
  const n = t.preserveLineEndings ? sb : ab;
  return String(e).replace(
    t.style === "html" ? ib : nb,
    t.trim ? ob(n) : n
  );
}
function sb(e) {
  const t = /\r?\n|\r/.exec(e);
  return t ? t[0] : " ";
}
function ab() {
  return " ";
}
function ob(e) {
  return t;
  function t(n, i, r) {
    return i === 0 || i + n.length === r.length ? "" : e(n);
  }
}
function lb() {
  return function(e) {
    Ps(e, function(t, n, i) {
      let r = -1, a = !0, o = !1;
      if (i && typeof n == "number" && t.type === "paragraph") {
        const l = t.children;
        for (; ++r < l.length; ) {
          const u = l[r];
          if (u.type === "mdxJsxTextElement" || u.type === "mdxTextExpression")
            o = !0;
          else if (!(u.type === "text" && rb(u.value, { style: "html", trim: !0 }) === "")) {
            a = !1;
            break;
          }
        }
        if (a && o) {
          r = -1;
          const u = [];
          for (; ++r < l.length; ) {
            const c = l[r];
            c.type === "mdxJsxTextElement" && (c.type = "mdxJsxFlowElement"), c.type === "mdxTextExpression" && (c.type = "mdxFlowExpression"), c.type === "text" && /^[\t\r\n ]+$/.test(String(c.value)) || u.push(c);
          }
          return i.children.splice(n, 1, ...u), n;
        }
      }
      if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement") {
        const l = t.data || (t.data = {});
        l._mdxExplicitJsx = !0;
      }
      (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression" || t.type === "mdxjsEsm") && t.data && t.data.estree && Vi(t.data.estree, {
        enter(l) {
          if (l.type === "JSXElement") {
            const u = l.data || (l.data = {});
            u._mdxExplicitJsx = !0;
          }
        }
      });
    });
  };
}
const ub = (
  /** @type {const} */
  [
    "mdxFlowExpression",
    "mdxJsxFlowElement",
    "mdxJsxTextElement",
    "mdxTextExpression",
    "mdxjsEsm"
  ]
);
let Ju = !1;
function cb(e) {
  const t = e || {};
  t.format, (t.jsxRuntime === "classic" || t.pragma || t.pragmaFrag || t.pragmaImportSource) && !Ju && (Ju = !0, console.warn(
    "Unexpected deprecated option `jsxRuntime: 'classic'`, `pragma`, `pragmaFrag`, or `pragmaImportSource`; see <https://mdxjs.com/migrating/v3/> on how to migrate"
  ));
  const n = $y().use(Hx);
  t.format !== "md" && n.use(ax);
  const i = t.remarkRehypeOptions || {};
  return n.use(lb).use(t.remarkPlugins || []).use(Fy, {
    ...i,
    allowDangerousHtml: !0,
    passThrough: [...i.passThrough || [], ...ub]
  }).use(t.rehypePlugins || []), t.format === "md" && n.use(tb), n.use(Km, t).use(Gy, t).use(Qy, t), t.jsx || n.use(I1, t).use(Wy, t), n.use(rm).use(sm, t).use(t.recmaPlugins || []), n;
}
function hb(e, t) {
  const { file: n, options: i } = _1(e, t);
  return cb(i).process(n);
}
function pb(e) {
  const {
    Fragment: t,
    baseUrl: n,
    development: i,
    jsx: r,
    jsxDEV: a,
    jsxs: o,
    useMDXComponents: l,
    ...u
  } = e || {};
  if (!t) throw new Error("Expected `Fragment` given to `evaluate`");
  if (i) {
    if (!a) throw new Error("Expected `jsxDEV` given to `evaluate`");
  } else {
    if (!r) throw new Error("Expected `jsx` given to `evaluate`");
    if (!o) throw new Error("Expected `jsxs` given to `evaluate`");
  }
  return {
    compiletime: {
      ...u,
      development: i,
      outputFormat: "function-body",
      providerImportSource: l ? "#" : void 0
    },
    runtime: { Fragment: t, baseUrl: n, jsx: r, jsxDEV: a, jsxs: o, useMDXComponents: l }
  };
}
const db = Object.getPrototypeOf(hp).constructor;
async function hp(e, t) {
  return new db(String(e))(t);
}
async function fb(e, t) {
  const { compiletime: n, runtime: i } = pb(t);
  return hp(await hb(e, n), i);
}
var pa = { exports: {} }, Wu;
function mb() {
  return Wu || (Wu = 1, (function(e) {
    (function() {
      var t;
      t = e.exports = r, t.format = r, t.vsprintf = i, typeof console < "u" && typeof console.log == "function" && (t.printf = n);
      function n() {
        console.log(r.apply(null, arguments));
      }
      function i(a, o) {
        return r.apply(null, [a].concat(o));
      }
      function r(a) {
        for (var o = 1, l = [].slice.call(arguments), u = 0, c = a.length, h = "", p, m = !1, g, b, v = !1, w, y = function() {
          return l[o++];
        }, I = function() {
          for (var E = ""; /\d/.test(a[u]); )
            E += a[u++], p = a[u];
          return E.length > 0 ? parseInt(E) : null;
        }; u < c; ++u)
          if (p = a[u], m)
            switch (m = !1, p == "." ? (v = !1, p = a[++u]) : p == "0" && a[u + 1] == "." ? (v = !0, u += 2, p = a[u]) : v = !0, w = I(), p) {
              case "b":
                h += parseInt(y(), 10).toString(2);
                break;
              case "c":
                g = y(), typeof g == "string" || g instanceof String ? h += g : h += String.fromCharCode(parseInt(g, 10));
                break;
              case "d":
                h += parseInt(y(), 10);
                break;
              case "f":
                b = String(parseFloat(y()).toFixed(w || 6)), h += v ? b : b.replace(/^0/, "");
                break;
              case "j":
                h += JSON.stringify(y());
                break;
              case "o":
                h += "0" + parseInt(y(), 10).toString(8);
                break;
              case "s":
                h += y();
                break;
              case "x":
                h += "0x" + parseInt(y(), 10).toString(16);
                break;
              case "X":
                h += "0x" + parseInt(y(), 10).toString(16).toUpperCase();
                break;
              default:
                h += p;
                break;
            }
          else p === "%" ? m = !0 : h += p;
        return h;
      }
    })();
  })(pa)), pa.exports;
}
var gb = mb();
const _b = /* @__PURE__ */ Sr(gb), Zr = Object.assign(ii(Error), {
  eval: ii(EvalError),
  range: ii(RangeError),
  reference: ii(ReferenceError),
  syntax: ii(SyntaxError),
  type: ii(TypeError),
  uri: ii(URIError)
});
function ii(e) {
  return t.displayName = e.displayName || e.name, t;
  function t(n, ...i) {
    const r = n && _b(n, ...i);
    return new e(r);
  }
}
const Gr = {}.hasOwnProperty, Xu = {
  yaml: "-",
  toml: "+"
};
function Mo(e) {
  const t = [];
  let n = -1;
  const i = Array.isArray(e) ? e : e ? [e] : ["yaml"];
  for (; ++n < i.length; )
    t[n] = xb(i[n]);
  return t;
}
function xb(e) {
  let t = e;
  if (typeof t == "string") {
    if (!Gr.call(Xu, t))
      throw Zr("Missing matter definition for `%s`", t);
    t = {
      type: t,
      marker: Xu[t]
    };
  } else if (typeof t != "object")
    throw Zr("Expected matter to be an object, not `%j`", t);
  if (!Gr.call(t, "type"))
    throw Zr("Missing `type` in matter `%j`", t);
  if (!Gr.call(t, "fence") && !Gr.call(t, "marker"))
    throw Zr("Missing `marker` or `fence` in matter `%j`", t);
  return t;
}
function yb(e) {
  const t = Mo(e), n = {};
  let i = -1;
  for (; ++i < t.length; ) {
    const r = t[i], a = Ga(r, "open").charCodeAt(0), o = bb(r), l = n[a];
    Array.isArray(l) ? l.push(o) : n[a] = [o];
  }
  return {
    flow: n
  };
}
function bb(e) {
  const t = e.anywhere, n = (
    /** @type {TokenType} */
    e.type
  ), i = (
    /** @type {TokenType} */
    n + "Fence"
  ), r = (
    /** @type {TokenType} */
    i + "Sequence"
  ), a = (
    /** @type {TokenType} */
    n + "Value"
  ), o = {
    tokenize: h,
    partial: !0
  };
  let l, u = 0;
  return {
    tokenize: c,
    concrete: !0
  };
  function c(p, m, g) {
    const b = this;
    return v;
    function v(C) {
      const L = b.now();
      return (
        // Indent not allowed.
        L.column === 1 && // Normally, only allowed in first line.
        (L.line === 1 || t) && (l = Ga(e, "open"), u = 0, C === l.charCodeAt(u)) ? (p.enter(n), p.enter(i), p.enter(r), w(C)) : g(C)
      );
    }
    function w(C) {
      return u === l.length ? (p.exit(r), Le(C) ? (p.enter("whitespace"), y(C)) : I(C)) : C === l.charCodeAt(u++) ? (p.consume(C), w) : g(C);
    }
    function y(C) {
      return Le(C) ? (p.consume(C), y) : (p.exit("whitespace"), I(C));
    }
    function I(C) {
      return me(C) ? (p.exit(i), p.enter("lineEnding"), p.consume(C), p.exit("lineEnding"), l = Ga(e, "close"), u = 0, p.attempt(o, f, E)) : g(C);
    }
    function E(C) {
      return C === null || me(C) ? S(C) : (p.enter(a), P(C));
    }
    function P(C) {
      return C === null || me(C) ? (p.exit(a), S(C)) : (p.consume(C), P);
    }
    function S(C) {
      return C === null ? g(C) : (p.enter("lineEnding"), p.consume(C), p.exit("lineEnding"), p.attempt(o, f, E));
    }
    function f(C) {
      return p.exit(n), m(C);
    }
  }
  function h(p, m, g) {
    let b = 0;
    return v;
    function v(E) {
      return E === l.charCodeAt(b) ? (p.enter(i), p.enter(r), w(E)) : g(E);
    }
    function w(E) {
      return b === l.length ? (p.exit(r), Le(E) ? (p.enter("whitespace"), y(E)) : I(E)) : E === l.charCodeAt(b++) ? (p.consume(E), w) : g(E);
    }
    function y(E) {
      return Le(E) ? (p.consume(E), y) : (p.exit("whitespace"), I(E));
    }
    function I(E) {
      return E === null || me(E) ? (p.exit(i), m(E)) : g(E);
    }
  }
}
function Ga(e, t) {
  return e.marker ? Zu(e.marker, t).repeat(3) : (
    // @ts-expect-error: They’re mutually exclusive.
    Zu(e.fence, t)
  );
}
function Zu(e, t) {
  return typeof e == "string" ? e : e[t];
}
function pp(e) {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function vb(e) {
  const t = Mo(e), n = {}, i = {};
  let r = -1;
  for (; ++r < t.length; ) {
    const a = t[r];
    n[a.type] = wb(a), i[a.type] = kb, i[a.type + "Value"] = Cb;
  }
  return { enter: n, exit: i };
}
function wb(e) {
  return t;
  function t(n) {
    this.enter({ type: e.type, value: "" }, n), this.buffer();
  }
}
function kb(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  this.exit(e), n.value = t.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
}
function Cb(e) {
  this.config.enter.data.call(this, e), this.config.exit.data.call(this, e);
}
function Sb(e) {
  const t = [], n = {}, i = Mo(e);
  let r = -1;
  for (; ++r < i.length; ) {
    const a = i[r];
    n[a.type] = Eb(a);
    const o = Ka(a, "open");
    t.push({
      atBreak: !0,
      character: o.charAt(0),
      after: pp(o.charAt(1))
    });
  }
  return { unsafe: t, handlers: n };
}
function Eb(e) {
  const t = Ka(e, "open"), n = Ka(e, "close");
  return i;
  function i(r) {
    return t + (r.value ? `
` + r.value : "") + `
` + n;
  }
}
function Ka(e, t) {
  return e.marker ? Gu(e.marker, t).repeat(3) : (
    // @ts-expect-error: They’re mutually exclusive.
    Gu(e.fence, t)
  );
}
function Gu(e, t) {
  return typeof e == "string" ? e : e[t];
}
const Ab = "yaml";
function Ib(e) {
  const t = (
    /** @type {Processor} */
    this
  ), n = e || Ab, i = t.data(), r = i.micromarkExtensions || (i.micromarkExtensions = []), a = i.fromMarkdownExtensions || (i.fromMarkdownExtensions = []), o = i.toMarkdownExtensions || (i.toMarkdownExtensions = []);
  r.push(yb(n)), a.push(vb(n)), o.push(Sb(n));
}
function Lb(e, t, n) {
  const r = Is((n || {}).ignore || []), a = Pb(t);
  let o = -1;
  for (; ++o < a.length; )
    up(e, "text", l);
  function l(c, h) {
    let p = -1, m;
    for (; ++p < h.length; ) {
      const g = h[p], b = m ? m.children : void 0;
      if (r(
        g,
        b ? b.indexOf(g) : void 0,
        m
      ))
        return;
      m = g;
    }
    if (m)
      return u(c, h);
  }
  function u(c, h) {
    const p = h[h.length - 1], m = a[o][0], g = a[o][1];
    let b = 0;
    const w = p.children.indexOf(c);
    let y = !1, I = [];
    m.lastIndex = 0;
    let E = m.exec(c.value);
    for (; E; ) {
      const P = E.index, S = {
        index: E.index,
        input: E.input,
        stack: [...h, c]
      };
      let f = g(...E, S);
      if (typeof f == "string" && (f = f.length > 0 ? { type: "text", value: f } : void 0), f === !1 ? m.lastIndex = P + 1 : (b !== P && I.push({
        type: "text",
        value: c.value.slice(b, P)
      }), Array.isArray(f) ? I.push(...f) : f && I.push(f), b = P + E[0].length, y = !0), !m.global)
        break;
      E = m.exec(c.value);
    }
    return y ? (b < c.value.length && I.push({ type: "text", value: c.value.slice(b) }), p.children.splice(w, 1, ...I)) : I = [c], w + I.length;
  }
}
function Pb(e) {
  const t = [];
  if (!Array.isArray(e))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const n = !e[0] || Array.isArray(e[0]) ? e : [e];
  let i = -1;
  for (; ++i < n.length; ) {
    const r = n[i];
    t.push([Tb(r[0]), Nb(r[1])]);
  }
  return t;
}
function Tb(e) {
  return typeof e == "string" ? new RegExp(pp(e), "g") : e;
}
function Nb(e) {
  return typeof e == "function" ? e : function() {
    return e;
  };
}
const da = "phrasing", fa = ["autolink", "link", "image", "label"];
function Db() {
  return {
    transforms: [zb],
    enter: {
      literalAutolink: Mb,
      literalAutolinkEmail: ma,
      literalAutolinkHttp: ma,
      literalAutolinkWww: ma
    },
    exit: {
      literalAutolink: Bb,
      literalAutolinkEmail: Ob,
      literalAutolinkHttp: Fb,
      literalAutolinkWww: Rb
    }
  };
}
function Vb() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct: da,
        notInConstruct: fa
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct: da,
        notInConstruct: fa
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct: da,
        notInConstruct: fa
      }
    ]
  };
}
function Mb(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function ma(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function Fb(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function Rb(e) {
  this.config.exit.data.call(this, e);
  const t = this.stack[this.stack.length - 1];
  t.type, t.url = "http://" + this.sliceSerialize(e);
}
function Ob(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function Bb(e) {
  this.exit(e);
}
function zb(e) {
  Lb(
    e,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, jb],
      [/(?<=^|\s|\p{P}|\p{S})([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/gu, Hb]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function jb(e, t, n, i, r) {
  let a = "";
  if (!dp(r) || (/^w/i.test(t) && (n = t + n, t = "", a = "http://"), !$b(n)))
    return !1;
  const o = qb(n + i);
  if (!o[0]) return !1;
  const l = {
    type: "link",
    title: null,
    url: a + t + o[0],
    children: [{ type: "text", value: t + o[0] }]
  };
  return o[1] ? [l, { type: "text", value: o[1] }] : l;
}
function Hb(e, t, n, i) {
  return (
    // Not an expected previous character.
    !dp(i, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(n) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + t + "@" + n,
      children: [{ type: "text", value: t + "@" + n }]
    }
  );
}
function $b(e) {
  const t = e.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function qb(e) {
  const t = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!t)
    return [e, void 0];
  e = e.slice(0, t.index);
  let n = t[0], i = n.indexOf(")");
  const r = ls(e, "(");
  let a = ls(e, ")");
  for (; i !== -1 && r > a; )
    e += n.slice(0, i + 1), n = n.slice(i + 1), i = n.indexOf(")"), a++;
  return [e, n];
}
function dp(e, t) {
  const n = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || Vt(n) || Ss(n)) && // If it’s an email, the previous character should not be a slash.
  (!t || n !== 47);
}
fp.peek = Qb;
function Ub() {
  this.buffer();
}
function Jb(e) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, e);
}
function Wb() {
  this.buffer();
}
function Xb(e) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    e
  );
}
function Zb(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.identifier = un(
    this.sliceSerialize(e)
  ).toLowerCase(), n.label = t;
}
function Gb(e) {
  this.exit(e);
}
function Kb(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.identifier = un(
    this.sliceSerialize(e)
  ).toLowerCase(), n.label = t;
}
function Yb(e) {
  this.exit(e);
}
function Qb() {
  return "[";
}
function fp(e, t, n, i) {
  const r = n.createTracker(i);
  let a = r.move("[^");
  const o = n.enter("footnoteReference"), l = n.enter("reference");
  return a += r.move(
    n.safe(n.associationId(e), { after: "]", before: a })
  ), l(), o(), a += r.move("]"), a;
}
function e3() {
  return {
    enter: {
      gfmFootnoteCallString: Ub,
      gfmFootnoteCall: Jb,
      gfmFootnoteDefinitionLabelString: Wb,
      gfmFootnoteDefinition: Xb
    },
    exit: {
      gfmFootnoteCallString: Zb,
      gfmFootnoteCall: Gb,
      gfmFootnoteDefinitionLabelString: Kb,
      gfmFootnoteDefinition: Yb
    }
  };
}
function t3(e) {
  let t = !1;
  return e && e.firstLineBlank && (t = !0), {
    handlers: { footnoteDefinition: n, footnoteReference: fp },
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["label", "phrasing", "reference"] }]
  };
  function n(i, r, a, o) {
    const l = a.createTracker(o);
    let u = l.move("[^");
    const c = a.enter("footnoteDefinition"), h = a.enter("label");
    return u += l.move(
      a.safe(a.associationId(i), { before: u, after: "]" })
    ), h(), u += l.move("]:"), i.children && i.children.length > 0 && (l.shift(4), u += l.move(
      (t ? `
` : " ") + a.indentLines(
        a.containerFlow(i, l.current()),
        t ? mp : n3
      )
    )), c(), u;
  }
}
function n3(e, t, n) {
  return t === 0 ? e : mp(e, t, n);
}
function mp(e, t, n) {
  return (n ? "" : "    ") + e;
}
const i3 = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
gp.peek = l3;
function r3() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: a3 },
    exit: { strikethrough: o3 }
  };
}
function s3() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: i3
      }
    ],
    handlers: { delete: gp }
  };
}
function a3(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function o3(e) {
  this.exit(e);
}
function gp(e, t, n, i) {
  const r = n.createTracker(i), a = n.enter("strikethrough");
  let o = r.move("~~");
  return o += n.containerPhrasing(e, {
    ...r.current(),
    before: o,
    after: "~"
  }), o += r.move("~~"), a(), o;
}
function l3() {
  return "~";
}
function u3(e) {
  return e.length;
}
function c3(e, t) {
  const n = t || {}, i = (n.align || []).concat(), r = n.stringLength || u3, a = [], o = [], l = [], u = [];
  let c = 0, h = -1;
  for (; ++h < e.length; ) {
    const v = [], w = [];
    let y = -1;
    for (e[h].length > c && (c = e[h].length); ++y < e[h].length; ) {
      const I = h3(e[h][y]);
      if (n.alignDelimiters !== !1) {
        const E = r(I);
        w[y] = E, (u[y] === void 0 || E > u[y]) && (u[y] = E);
      }
      v.push(I);
    }
    o[h] = v, l[h] = w;
  }
  let p = -1;
  if (typeof i == "object" && "length" in i)
    for (; ++p < c; )
      a[p] = Ku(i[p]);
  else {
    const v = Ku(i);
    for (; ++p < c; )
      a[p] = v;
  }
  p = -1;
  const m = [], g = [];
  for (; ++p < c; ) {
    const v = a[p];
    let w = "", y = "";
    v === 99 ? (w = ":", y = ":") : v === 108 ? w = ":" : v === 114 && (y = ":");
    let I = n.alignDelimiters === !1 ? 1 : Math.max(
      1,
      u[p] - w.length - y.length
    );
    const E = w + "-".repeat(I) + y;
    n.alignDelimiters !== !1 && (I = w.length + I + y.length, I > u[p] && (u[p] = I), g[p] = I), m[p] = E;
  }
  o.splice(1, 0, m), l.splice(1, 0, g), h = -1;
  const b = [];
  for (; ++h < o.length; ) {
    const v = o[h], w = l[h];
    p = -1;
    const y = [];
    for (; ++p < c; ) {
      const I = v[p] || "";
      let E = "", P = "";
      if (n.alignDelimiters !== !1) {
        const S = u[p] - (w[p] || 0), f = a[p];
        f === 114 ? E = " ".repeat(S) : f === 99 ? S % 2 ? (E = " ".repeat(S / 2 + 0.5), P = " ".repeat(S / 2 - 0.5)) : (E = " ".repeat(S / 2), P = E) : P = " ".repeat(S);
      }
      n.delimiterStart !== !1 && !p && y.push("|"), n.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(n.alignDelimiters === !1 && I === "") && (n.delimiterStart !== !1 || p) && y.push(" "), n.alignDelimiters !== !1 && y.push(E), y.push(I), n.alignDelimiters !== !1 && y.push(P), n.padding !== !1 && y.push(" "), (n.delimiterEnd !== !1 || p !== c - 1) && y.push("|");
    }
    b.push(
      n.delimiterEnd === !1 ? y.join("").replace(/ +$/, "") : y.join("")
    );
  }
  return b.join(`
`);
}
function h3(e) {
  return e == null ? "" : String(e);
}
function Ku(e) {
  const t = typeof e == "string" ? e.codePointAt(0) : 0;
  return t === 67 || t === 99 ? 99 : t === 76 || t === 108 ? 108 : t === 82 || t === 114 ? 114 : 0;
}
function p3(e, t, n, i) {
  const r = n.enter("blockquote"), a = n.createTracker(i);
  a.move("> "), a.shift(2);
  const o = n.indentLines(
    n.containerFlow(e, a.current()),
    d3
  );
  return r(), o;
}
function d3(e, t, n) {
  return ">" + (n ? "" : " ") + e;
}
function f3(e, t) {
  return Yu(e, t.inConstruct, !0) && !Yu(e, t.notInConstruct, !1);
}
function Yu(e, t, n) {
  if (typeof t == "string" && (t = [t]), !t || t.length === 0)
    return n;
  let i = -1;
  for (; ++i < t.length; )
    if (e.includes(t[i]))
      return !0;
  return !1;
}
function Qu(e, t, n, i) {
  let r = -1;
  for (; ++r < n.unsafe.length; )
    if (n.unsafe[r].character === `
` && f3(n.stack, n.unsafe[r]))
      return /[ \t]/.test(i.before) ? "" : " ";
  return `\\
`;
}
function m3(e, t) {
  const n = String(e);
  let i = n.indexOf(t), r = i, a = 0, o = 0;
  if (typeof t != "string")
    throw new TypeError("Expected substring");
  for (; i !== -1; )
    i === r ? ++a > o && (o = a) : a = 1, r = i + t.length, i = n.indexOf(t, r);
  return o;
}
function g3(e, t) {
  return !!(t.options.fences === !1 && e.value && // If there’s no info…
  !e.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(e.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(e.value));
}
function _3(e) {
  const t = e.options.fence || "`";
  if (t !== "`" && t !== "~")
    throw new Error(
      "Cannot serialize code with `" + t + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return t;
}
function x3(e, t, n, i) {
  const r = _3(n), a = e.value || "", o = r === "`" ? "GraveAccent" : "Tilde";
  if (g3(e, n)) {
    const p = n.enter("codeIndented"), m = n.indentLines(a, y3);
    return p(), m;
  }
  const l = n.createTracker(i), u = r.repeat(Math.max(m3(a, r) + 1, 3)), c = n.enter("codeFenced");
  let h = l.move(u);
  if (e.lang) {
    const p = n.enter(`codeFencedLang${o}`);
    h += l.move(
      n.safe(e.lang, {
        before: h,
        after: " ",
        encode: ["`"],
        ...l.current()
      })
    ), p();
  }
  if (e.lang && e.meta) {
    const p = n.enter(`codeFencedMeta${o}`);
    h += l.move(" "), h += l.move(
      n.safe(e.meta, {
        before: h,
        after: `
`,
        encode: ["`"],
        ...l.current()
      })
    ), p();
  }
  return h += l.move(`
`), a && (h += l.move(a + `
`)), h += l.move(u), c(), h;
}
function y3(e, t, n) {
  return (n ? "" : "    ") + e;
}
function Fo(e) {
  const t = e.options.quote || '"';
  if (t !== '"' && t !== "'")
    throw new Error(
      "Cannot serialize title with `" + t + "` for `options.quote`, expected `\"`, or `'`"
    );
  return t;
}
function b3(e, t, n, i) {
  const r = Fo(n), a = r === '"' ? "Quote" : "Apostrophe", o = n.enter("definition");
  let l = n.enter("label");
  const u = n.createTracker(i);
  let c = u.move("[");
  return c += u.move(
    n.safe(n.associationId(e), {
      before: c,
      after: "]",
      ...u.current()
    })
  ), c += u.move("]: "), l(), // If there’s no url, or…
  !e.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (l = n.enter("destinationLiteral"), c += u.move("<"), c += u.move(
    n.safe(e.url, { before: c, after: ">", ...u.current() })
  ), c += u.move(">")) : (l = n.enter("destinationRaw"), c += u.move(
    n.safe(e.url, {
      before: c,
      after: e.title ? " " : `
`,
      ...u.current()
    })
  )), l(), e.title && (l = n.enter(`title${a}`), c += u.move(" " + r), c += u.move(
    n.safe(e.title, {
      before: c,
      after: r,
      ...u.current()
    })
  ), c += u.move(r), l()), o(), c;
}
function v3(e) {
  const t = e.options.emphasis || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + t + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return t;
}
function kr(e) {
  return "&#x" + e.toString(16).toUpperCase() + ";";
}
function _s(e, t, n) {
  const i = Ri(e), r = Ri(t);
  return i === void 0 ? r === void 0 ? (
    // Letter inside:
    // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    n === "_" ? { inside: !0, outside: !0 } : { inside: !1, outside: !1 }
  ) : r === 1 ? (
    // Whitespace inside: encode both (letter, whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: encode outer (letter)
    { inside: !1, outside: !0 }
  ) : i === 1 ? r === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : r === 1 ? (
    // Whitespace inside: encode both (whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  ) : r === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : r === 1 ? (
    // Whitespace inside: encode inner (whitespace).
    { inside: !0, outside: !1 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  );
}
_p.peek = w3;
function _p(e, t, n, i) {
  const r = v3(n), a = n.enter("emphasis"), o = n.createTracker(i), l = o.move(r);
  let u = o.move(
    n.containerPhrasing(e, {
      after: r,
      before: l,
      ...o.current()
    })
  );
  const c = u.charCodeAt(0), h = _s(
    i.before.charCodeAt(i.before.length - 1),
    c,
    r
  );
  h.inside && (u = kr(c) + u.slice(1));
  const p = u.charCodeAt(u.length - 1), m = _s(i.after.charCodeAt(0), p, r);
  m.inside && (u = u.slice(0, -1) + kr(p));
  const g = o.move(r);
  return a(), n.attentionEncodeSurroundingInfo = {
    after: m.outside,
    before: h.outside
  }, l + u + g;
}
function w3(e, t, n) {
  return n.options.emphasis || "*";
}
function k3(e, t) {
  let n = !1;
  return Ps(e, function(i) {
    if ("value" in i && /\r?\n|\r/.test(i.value) || i.type === "break")
      return n = !0, Wa;
  }), !!((!e.depth || e.depth < 3) && Io(e) && (t.options.setext || n));
}
function C3(e, t, n, i) {
  const r = Math.max(Math.min(6, e.depth || 1), 1), a = n.createTracker(i);
  if (k3(e, n)) {
    const h = n.enter("headingSetext"), p = n.enter("phrasing"), m = n.containerPhrasing(e, {
      ...a.current(),
      before: `
`,
      after: `
`
    });
    return p(), h(), m + `
` + (r === 1 ? "=" : "-").repeat(
      // The whole size…
      m.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(m.lastIndexOf("\r"), m.lastIndexOf(`
`)) + 1)
    );
  }
  const o = "#".repeat(r), l = n.enter("headingAtx"), u = n.enter("phrasing");
  a.move(o + " ");
  let c = n.containerPhrasing(e, {
    before: "# ",
    after: `
`,
    ...a.current()
  });
  return /^[\t ]/.test(c) && (c = kr(c.charCodeAt(0)) + c.slice(1)), c = c ? o + " " + c : o, n.options.closeAtx && (c += " " + o), u(), l(), c;
}
xp.peek = S3;
function xp(e) {
  return e.value || "";
}
function S3() {
  return "<";
}
yp.peek = E3;
function yp(e, t, n, i) {
  const r = Fo(n), a = r === '"' ? "Quote" : "Apostrophe", o = n.enter("image");
  let l = n.enter("label");
  const u = n.createTracker(i);
  let c = u.move("![");
  return c += u.move(
    n.safe(e.alt, { before: c, after: "]", ...u.current() })
  ), c += u.move("]("), l(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (l = n.enter("destinationLiteral"), c += u.move("<"), c += u.move(
    n.safe(e.url, { before: c, after: ">", ...u.current() })
  ), c += u.move(">")) : (l = n.enter("destinationRaw"), c += u.move(
    n.safe(e.url, {
      before: c,
      after: e.title ? " " : ")",
      ...u.current()
    })
  )), l(), e.title && (l = n.enter(`title${a}`), c += u.move(" " + r), c += u.move(
    n.safe(e.title, {
      before: c,
      after: r,
      ...u.current()
    })
  ), c += u.move(r), l()), c += u.move(")"), o(), c;
}
function E3() {
  return "!";
}
bp.peek = A3;
function bp(e, t, n, i) {
  const r = e.referenceType, a = n.enter("imageReference");
  let o = n.enter("label");
  const l = n.createTracker(i);
  let u = l.move("![");
  const c = n.safe(e.alt, {
    before: u,
    after: "]",
    ...l.current()
  });
  u += l.move(c + "]["), o();
  const h = n.stack;
  n.stack = [], o = n.enter("reference");
  const p = n.safe(n.associationId(e), {
    before: u,
    after: "]",
    ...l.current()
  });
  return o(), n.stack = h, a(), r === "full" || !c || c !== p ? u += l.move(p + "]") : r === "shortcut" ? u = u.slice(0, -1) : u += l.move("]"), u;
}
function A3() {
  return "!";
}
vp.peek = I3;
function vp(e, t, n) {
  let i = e.value || "", r = "`", a = -1;
  for (; new RegExp("(^|[^`])" + r + "([^`]|$)").test(i); )
    r += "`";
  for (/[^ \r\n]/.test(i) && (/^[ \r\n]/.test(i) && /[ \r\n]$/.test(i) || /^`|`$/.test(i)) && (i = " " + i + " "); ++a < n.unsafe.length; ) {
    const o = n.unsafe[a], l = n.compilePattern(o);
    let u;
    if (o.atBreak)
      for (; u = l.exec(i); ) {
        let c = u.index;
        i.charCodeAt(c) === 10 && i.charCodeAt(c - 1) === 13 && c--, i = i.slice(0, c) + " " + i.slice(u.index + 1);
      }
  }
  return r + i + r;
}
function I3() {
  return "`";
}
function wp(e, t) {
  const n = Io(e);
  return !!(!t.options.resourceLink && // If there’s a url…
  e.url && // And there’s a no title…
  !e.title && // And the content of `node` is a single text node…
  e.children && e.children.length === 1 && e.children[0].type === "text" && // And if the url is the same as the content…
  (n === e.url || "mailto:" + n === e.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(e.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(e.url));
}
kp.peek = L3;
function kp(e, t, n, i) {
  const r = Fo(n), a = r === '"' ? "Quote" : "Apostrophe", o = n.createTracker(i);
  let l, u;
  if (wp(e, n)) {
    const h = n.stack;
    n.stack = [], l = n.enter("autolink");
    let p = o.move("<");
    return p += o.move(
      n.containerPhrasing(e, {
        before: p,
        after: ">",
        ...o.current()
      })
    ), p += o.move(">"), l(), n.stack = h, p;
  }
  l = n.enter("link"), u = n.enter("label");
  let c = o.move("[");
  return c += o.move(
    n.containerPhrasing(e, {
      before: c,
      after: "](",
      ...o.current()
    })
  ), c += o.move("]("), u(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (u = n.enter("destinationLiteral"), c += o.move("<"), c += o.move(
    n.safe(e.url, { before: c, after: ">", ...o.current() })
  ), c += o.move(">")) : (u = n.enter("destinationRaw"), c += o.move(
    n.safe(e.url, {
      before: c,
      after: e.title ? " " : ")",
      ...o.current()
    })
  )), u(), e.title && (u = n.enter(`title${a}`), c += o.move(" " + r), c += o.move(
    n.safe(e.title, {
      before: c,
      after: r,
      ...o.current()
    })
  ), c += o.move(r), u()), c += o.move(")"), l(), c;
}
function L3(e, t, n) {
  return wp(e, n) ? "<" : "[";
}
Cp.peek = P3;
function Cp(e, t, n, i) {
  const r = e.referenceType, a = n.enter("linkReference");
  let o = n.enter("label");
  const l = n.createTracker(i);
  let u = l.move("[");
  const c = n.containerPhrasing(e, {
    before: u,
    after: "]",
    ...l.current()
  });
  u += l.move(c + "]["), o();
  const h = n.stack;
  n.stack = [], o = n.enter("reference");
  const p = n.safe(n.associationId(e), {
    before: u,
    after: "]",
    ...l.current()
  });
  return o(), n.stack = h, a(), r === "full" || !c || c !== p ? u += l.move(p + "]") : r === "shortcut" ? u = u.slice(0, -1) : u += l.move("]"), u;
}
function P3() {
  return "[";
}
function Ro(e) {
  const t = e.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return t;
}
function T3(e) {
  const t = Ro(e), n = e.options.bulletOther;
  if (!n)
    return t === "*" ? "-" : "*";
  if (n !== "*" && n !== "+" && n !== "-")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (n === t)
    throw new Error(
      "Expected `bullet` (`" + t + "`) and `bulletOther` (`" + n + "`) to be different"
    );
  return n;
}
function N3(e) {
  const t = e.options.bulletOrdered || ".";
  if (t !== "." && t !== ")")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return t;
}
function Sp(e) {
  const t = e.options.rule || "*";
  if (t !== "*" && t !== "-" && t !== "_")
    throw new Error(
      "Cannot serialize rules with `" + t + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return t;
}
function D3(e, t, n, i) {
  const r = n.enter("list"), a = n.bulletCurrent;
  let o = e.ordered ? N3(n) : Ro(n);
  const l = e.ordered ? o === "." ? ")" : "." : T3(n);
  let u = t && n.bulletLastUsed ? o === n.bulletLastUsed : !1;
  if (!e.ordered) {
    const h = e.children ? e.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (o === "*" || o === "-") && // Empty first list item:
      h && (!h.children || !h.children[0]) && // Directly in two other list items:
      n.stack[n.stack.length - 1] === "list" && n.stack[n.stack.length - 2] === "listItem" && n.stack[n.stack.length - 3] === "list" && n.stack[n.stack.length - 4] === "listItem" && // That are each the first child.
      n.indexStack[n.indexStack.length - 1] === 0 && n.indexStack[n.indexStack.length - 2] === 0 && n.indexStack[n.indexStack.length - 3] === 0 && (u = !0), Sp(n) === o && h
    ) {
      let p = -1;
      for (; ++p < e.children.length; ) {
        const m = e.children[p];
        if (m && m.type === "listItem" && m.children && m.children[0] && m.children[0].type === "thematicBreak") {
          u = !0;
          break;
        }
      }
    }
  }
  u && (o = l), n.bulletCurrent = o;
  const c = n.containerFlow(e, i);
  return n.bulletLastUsed = o, n.bulletCurrent = a, r(), c;
}
function V3(e) {
  const t = e.options.listItemIndent || "one";
  if (t !== "tab" && t !== "one" && t !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return t;
}
function M3(e, t, n, i) {
  const r = V3(n);
  let a = n.bulletCurrent || Ro(n);
  t && t.type === "list" && t.ordered && (a = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (n.options.incrementListMarker === !1 ? 0 : t.children.indexOf(e)) + a);
  let o = a.length + 1;
  (r === "tab" || r === "mixed" && (t && t.type === "list" && t.spread || e.spread)) && (o = Math.ceil(o / 4) * 4);
  const l = n.createTracker(i);
  l.move(a + " ".repeat(o - a.length)), l.shift(o);
  const u = n.enter("listItem"), c = n.indentLines(
    n.containerFlow(e, l.current()),
    h
  );
  return u(), c;
  function h(p, m, g) {
    return m ? (g ? "" : " ".repeat(o)) + p : (g ? a : a + " ".repeat(o - a.length)) + p;
  }
}
function F3(e, t, n, i) {
  const r = n.enter("paragraph"), a = n.enter("phrasing"), o = n.containerPhrasing(e, i);
  return a(), r(), o;
}
const R3 = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  Is([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function O3(e, t, n, i) {
  return (e.children.some(function(o) {
    return R3(o);
  }) ? n.containerPhrasing : n.containerFlow).call(n, e, i);
}
function B3(e) {
  const t = e.options.strong || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize strong with `" + t + "` for `options.strong`, expected `*`, or `_`"
    );
  return t;
}
Ep.peek = z3;
function Ep(e, t, n, i) {
  const r = B3(n), a = n.enter("strong"), o = n.createTracker(i), l = o.move(r + r);
  let u = o.move(
    n.containerPhrasing(e, {
      after: r,
      before: l,
      ...o.current()
    })
  );
  const c = u.charCodeAt(0), h = _s(
    i.before.charCodeAt(i.before.length - 1),
    c,
    r
  );
  h.inside && (u = kr(c) + u.slice(1));
  const p = u.charCodeAt(u.length - 1), m = _s(i.after.charCodeAt(0), p, r);
  m.inside && (u = u.slice(0, -1) + kr(p));
  const g = o.move(r + r);
  return a(), n.attentionEncodeSurroundingInfo = {
    after: m.outside,
    before: h.outside
  }, l + u + g;
}
function z3(e, t, n) {
  return n.options.strong || "*";
}
function j3(e, t, n, i) {
  return n.safe(e.value, i);
}
function H3(e) {
  const t = e.options.ruleRepetition || 3;
  if (t < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + t + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return t;
}
function $3(e, t, n) {
  const i = (Sp(n) + (n.options.ruleSpaces ? " " : "")).repeat(H3(n));
  return n.options.ruleSpaces ? i.slice(0, -1) : i;
}
const Ap = {
  blockquote: p3,
  break: Qu,
  code: x3,
  definition: b3,
  emphasis: _p,
  hardBreak: Qu,
  heading: C3,
  html: xp,
  image: yp,
  imageReference: bp,
  inlineCode: vp,
  link: kp,
  linkReference: Cp,
  list: D3,
  listItem: M3,
  paragraph: F3,
  root: O3,
  strong: Ep,
  text: j3,
  thematicBreak: $3
};
function q3() {
  return {
    enter: {
      table: U3,
      tableData: ec,
      tableHeader: ec,
      tableRow: W3
    },
    exit: {
      codeText: X3,
      table: J3,
      tableData: ga,
      tableHeader: ga,
      tableRow: ga
    }
  };
}
function U3(e) {
  const t = e._align;
  this.enter(
    {
      type: "table",
      align: t.map(function(n) {
        return n === "none" ? null : n;
      }),
      children: []
    },
    e
  ), this.data.inTable = !0;
}
function J3(e) {
  this.exit(e), this.data.inTable = void 0;
}
function W3(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function ga(e) {
  this.exit(e);
}
function ec(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function X3(e) {
  let t = this.resume();
  this.data.inTable && (t = t.replace(/\\([\\|])/g, Z3));
  const n = this.stack[this.stack.length - 1];
  n.type, n.value = t, this.exit(e);
}
function Z3(e, t) {
  return t === "|" ? t : e;
}
function G3(e) {
  const t = e || {}, n = t.tableCellPadding, i = t.tablePipeAlign, r = t.stringLength, a = n ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: m,
      table: o,
      tableCell: u,
      tableRow: l
    }
  };
  function o(g, b, v, w) {
    return c(h(g, v, w), g.align);
  }
  function l(g, b, v, w) {
    const y = p(g, v, w), I = c([y]);
    return I.slice(0, I.indexOf(`
`));
  }
  function u(g, b, v, w) {
    const y = v.enter("tableCell"), I = v.enter("phrasing"), E = v.containerPhrasing(g, {
      ...w,
      before: a,
      after: a
    });
    return I(), y(), E;
  }
  function c(g, b) {
    return c3(g, {
      align: b,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: i,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: n,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: r
    });
  }
  function h(g, b, v) {
    const w = g.children;
    let y = -1;
    const I = [], E = b.enter("table");
    for (; ++y < w.length; )
      I[y] = p(w[y], b, v);
    return E(), I;
  }
  function p(g, b, v) {
    const w = g.children;
    let y = -1;
    const I = [], E = b.enter("tableRow");
    for (; ++y < w.length; )
      I[y] = u(w[y], g, b, v);
    return E(), I;
  }
  function m(g, b, v) {
    let w = Ap.inlineCode(g, b, v);
    return v.stack.includes("tableCell") && (w = w.replace(/\|/g, "\\$&")), w;
  }
}
function K3() {
  return {
    exit: {
      taskListCheckValueChecked: tc,
      taskListCheckValueUnchecked: tc,
      paragraph: Q3
    }
  };
}
function Y3() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: ev }
  };
}
function tc(e) {
  const t = this.stack[this.stack.length - 2];
  t.type, t.checked = e.type === "taskListCheckValueChecked";
}
function Q3(e) {
  const t = this.stack[this.stack.length - 2];
  if (t && t.type === "listItem" && typeof t.checked == "boolean") {
    const n = this.stack[this.stack.length - 1];
    n.type;
    const i = n.children[0];
    if (i && i.type === "text") {
      const r = t.children;
      let a = -1, o;
      for (; ++a < r.length; ) {
        const l = r[a];
        if (l.type === "paragraph") {
          o = l;
          break;
        }
      }
      o === n && (i.value = i.value.slice(1), i.value.length === 0 ? n.children.shift() : n.position && i.position && typeof i.position.start.offset == "number" && (i.position.start.column++, i.position.start.offset++, n.position.start = Object.assign({}, i.position.start)));
    }
  }
  this.exit(e);
}
function ev(e, t, n, i) {
  const r = e.children[0], a = typeof e.checked == "boolean" && r && r.type === "paragraph", o = "[" + (e.checked ? "x" : " ") + "] ", l = n.createTracker(i);
  a && l.move(o);
  let u = Ap.listItem(e, t, n, {
    ...i,
    ...l.current()
  });
  return a && (u = u.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, c)), u;
  function c(h) {
    return h + o;
  }
}
function tv() {
  return [
    Db(),
    e3(),
    r3(),
    q3(),
    K3()
  ];
}
function nv(e) {
  return {
    extensions: [
      Vb(),
      t3(e),
      s3(),
      G3(e),
      Y3()
    ]
  };
}
const iv = {
  tokenize: uv,
  partial: !0
}, Ip = {
  tokenize: cv,
  partial: !0
}, Lp = {
  tokenize: hv,
  partial: !0
}, Pp = {
  tokenize: pv,
  partial: !0
}, rv = {
  tokenize: dv,
  partial: !0
}, Tp = {
  name: "wwwAutolink",
  tokenize: ov,
  previous: Dp
}, Np = {
  name: "protocolAutolink",
  tokenize: lv,
  previous: Vp
}, Hn = {
  name: "emailAutolink",
  tokenize: av,
  previous: Mp
}, Sn = {};
function sv() {
  return {
    text: Sn
  };
}
let ri = 48;
for (; ri < 123; )
  Sn[ri] = Hn, ri++, ri === 58 ? ri = 65 : ri === 91 && (ri = 97);
Sn[43] = Hn;
Sn[45] = Hn;
Sn[46] = Hn;
Sn[95] = Hn;
Sn[72] = [Hn, Np];
Sn[104] = [Hn, Np];
Sn[87] = [Hn, Tp];
Sn[119] = [Hn, Tp];
function av(e, t, n) {
  const i = this;
  let r, a;
  return o;
  function o(p) {
    return !Ya(p) || !Mp.call(i, i.previous) || Oo(i.events) ? n(p) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), l(p));
  }
  function l(p) {
    return Ya(p) ? (e.consume(p), l) : p === 64 ? (e.consume(p), u) : n(p);
  }
  function u(p) {
    return p === 46 ? e.check(rv, h, c)(p) : p === 45 || p === 95 || Pt(p) ? (a = !0, e.consume(p), u) : h(p);
  }
  function c(p) {
    return e.consume(p), r = !0, u;
  }
  function h(p) {
    return a && r && Lt(i.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), t(p)) : n(p);
  }
}
function ov(e, t, n) {
  const i = this;
  return r;
  function r(o) {
    return o !== 87 && o !== 119 || !Dp.call(i, i.previous) || Oo(i.events) ? n(o) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(iv, e.attempt(Ip, e.attempt(Lp, a), n), n)(o));
  }
  function a(o) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), t(o);
  }
}
function lv(e, t, n) {
  const i = this;
  let r = "", a = !1;
  return o;
  function o(p) {
    return (p === 72 || p === 104) && Vp.call(i, i.previous) && !Oo(i.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), r += String.fromCodePoint(p), e.consume(p), l) : n(p);
  }
  function l(p) {
    if (Lt(p) && r.length < 5)
      return r += String.fromCodePoint(p), e.consume(p), l;
    if (p === 58) {
      const m = r.toLowerCase();
      if (m === "http" || m === "https")
        return e.consume(p), u;
    }
    return n(p);
  }
  function u(p) {
    return p === 47 ? (e.consume(p), a ? c : (a = !0, u)) : n(p);
  }
  function c(p) {
    return p === null || ds(p) || Ue(p) || Vt(p) || Ss(p) ? n(p) : e.attempt(Ip, e.attempt(Lp, h), n)(p);
  }
  function h(p) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), t(p);
  }
}
function uv(e, t, n) {
  let i = 0;
  return r;
  function r(o) {
    return (o === 87 || o === 119) && i < 3 ? (i++, e.consume(o), r) : o === 46 && i === 3 ? (e.consume(o), a) : n(o);
  }
  function a(o) {
    return o === null ? n(o) : t(o);
  }
}
function cv(e, t, n) {
  let i, r, a;
  return o;
  function o(c) {
    return c === 46 || c === 95 ? e.check(Pp, u, l)(c) : c === null || Ue(c) || Vt(c) || c !== 45 && Ss(c) ? u(c) : (a = !0, e.consume(c), o);
  }
  function l(c) {
    return c === 95 ? i = !0 : (r = i, i = void 0), e.consume(c), o;
  }
  function u(c) {
    return r || i || !a ? n(c) : t(c);
  }
}
function hv(e, t) {
  let n = 0, i = 0;
  return r;
  function r(o) {
    return o === 40 ? (n++, e.consume(o), r) : o === 41 && i < n ? a(o) : o === 33 || o === 34 || o === 38 || o === 39 || o === 41 || o === 42 || o === 44 || o === 46 || o === 58 || o === 59 || o === 60 || o === 63 || o === 93 || o === 95 || o === 126 ? e.check(Pp, t, a)(o) : o === null || Ue(o) || Vt(o) ? t(o) : (e.consume(o), r);
  }
  function a(o) {
    return o === 41 && i++, e.consume(o), r;
  }
}
function pv(e, t, n) {
  return i;
  function i(l) {
    return l === 33 || l === 34 || l === 39 || l === 41 || l === 42 || l === 44 || l === 46 || l === 58 || l === 59 || l === 63 || l === 95 || l === 126 ? (e.consume(l), i) : l === 38 ? (e.consume(l), a) : l === 93 ? (e.consume(l), r) : (
      // `<` is an end.
      l === 60 || // So is whitespace.
      l === null || Ue(l) || Vt(l) ? t(l) : n(l)
    );
  }
  function r(l) {
    return l === null || l === 40 || l === 91 || Ue(l) || Vt(l) ? t(l) : i(l);
  }
  function a(l) {
    return Lt(l) ? o(l) : n(l);
  }
  function o(l) {
    return l === 59 ? (e.consume(l), i) : Lt(l) ? (e.consume(l), o) : n(l);
  }
}
function dv(e, t, n) {
  return i;
  function i(a) {
    return e.consume(a), r;
  }
  function r(a) {
    return Pt(a) ? n(a) : t(a);
  }
}
function Dp(e) {
  return e === null || e === 40 || e === 42 || e === 95 || e === 91 || e === 93 || e === 126 || Ue(e);
}
function Vp(e) {
  return !Lt(e);
}
function Mp(e) {
  return !(e === 47 || Ya(e));
}
function Ya(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || Pt(e);
}
function Oo(e) {
  let t = e.length, n = !1;
  for (; t--; ) {
    const i = e[t][1];
    if ((i.type === "labelLink" || i.type === "labelImage") && !i._balanced) {
      n = !0;
      break;
    }
    if (i._gfmAutolinkLiteralWalkedInto) {
      n = !1;
      break;
    }
  }
  return e.length > 0 && !n && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), n;
}
const fv = {
  tokenize: wv,
  partial: !0
};
function mv() {
  return {
    document: {
      91: {
        name: "gfmFootnoteDefinition",
        tokenize: yv,
        continuation: {
          tokenize: bv
        },
        exit: vv
      }
    },
    text: {
      91: {
        name: "gfmFootnoteCall",
        tokenize: xv
      },
      93: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: gv,
        resolveTo: _v
      }
    }
  };
}
function gv(e, t, n) {
  const i = this;
  let r = i.events.length;
  const a = i.parser.gfmFootnotes || (i.parser.gfmFootnotes = []);
  let o;
  for (; r--; ) {
    const u = i.events[r][1];
    if (u.type === "labelImage") {
      o = u;
      break;
    }
    if (u.type === "gfmFootnoteCall" || u.type === "labelLink" || u.type === "label" || u.type === "image" || u.type === "link")
      break;
  }
  return l;
  function l(u) {
    if (!o || !o._balanced)
      return n(u);
    const c = un(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }));
    return c.codePointAt(0) !== 94 || !a.includes(c.slice(1)) ? n(u) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(u), e.exit("gfmFootnoteCallLabelMarker"), t(u));
  }
}
function _v(e, t) {
  let n = e.length;
  for (; n--; )
    if (e[n][1].type === "labelImage" && e[n][0] === "enter") {
      e[n][1];
      break;
    }
  e[n + 1][1].type = "data", e[n + 3][1].type = "gfmFootnoteCallLabelMarker";
  const i = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, e[n + 3][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, r = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, e[n + 3][1].end),
    end: Object.assign({}, e[n + 3][1].end)
  };
  r.end.column++, r.end.offset++, r.end._bufferIndex++;
  const a = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, r.end),
    end: Object.assign({}, e[e.length - 1][1].start)
  }, o = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, a.start),
    end: Object.assign({}, a.end)
  }, l = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    e[n + 1],
    e[n + 2],
    ["enter", i, t],
    // The `[`
    e[n + 3],
    e[n + 4],
    // The `^`.
    ["enter", r, t],
    ["exit", r, t],
    // Everything in between.
    ["enter", a, t],
    ["enter", o, t],
    ["exit", o, t],
    ["exit", a, t],
    // The ending (`]`, properly parsed and labelled).
    e[e.length - 2],
    e[e.length - 1],
    ["exit", i, t]
  ];
  return e.splice(n, e.length - n + 1, ...l), e;
}
function xv(e, t, n) {
  const i = this, r = i.parser.gfmFootnotes || (i.parser.gfmFootnotes = []);
  let a = 0, o;
  return l;
  function l(p) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(p), e.exit("gfmFootnoteCallLabelMarker"), u;
  }
  function u(p) {
    return p !== 94 ? n(p) : (e.enter("gfmFootnoteCallMarker"), e.consume(p), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", c);
  }
  function c(p) {
    if (
      // Too long.
      a > 999 || // Closing brace with nothing.
      p === 93 && !o || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      p === null || p === 91 || Ue(p)
    )
      return n(p);
    if (p === 93) {
      e.exit("chunkString");
      const m = e.exit("gfmFootnoteCallString");
      return r.includes(un(i.sliceSerialize(m))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(p), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), t) : n(p);
    }
    return Ue(p) || (o = !0), a++, e.consume(p), p === 92 ? h : c;
  }
  function h(p) {
    return p === 91 || p === 92 || p === 93 ? (e.consume(p), a++, c) : c(p);
  }
}
function yv(e, t, n) {
  const i = this, r = i.parser.gfmFootnotes || (i.parser.gfmFootnotes = []);
  let a, o = 0, l;
  return u;
  function u(b) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(b), e.exit("gfmFootnoteDefinitionLabelMarker"), c;
  }
  function c(b) {
    return b === 94 ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(b), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", h) : n(b);
  }
  function h(b) {
    if (
      // Too long.
      o > 999 || // Closing brace with nothing.
      b === 93 && !l || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      b === null || b === 91 || Ue(b)
    )
      return n(b);
    if (b === 93) {
      e.exit("chunkString");
      const v = e.exit("gfmFootnoteDefinitionLabelString");
      return a = un(i.sliceSerialize(v)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(b), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), m;
    }
    return Ue(b) || (l = !0), o++, e.consume(b), b === 92 ? p : h;
  }
  function p(b) {
    return b === 91 || b === 92 || b === 93 ? (e.consume(b), o++, h) : h(b);
  }
  function m(b) {
    return b === 58 ? (e.enter("definitionMarker"), e.consume(b), e.exit("definitionMarker"), r.includes(a) || r.push(a), Be(e, g, "gfmFootnoteDefinitionWhitespace")) : n(b);
  }
  function g(b) {
    return t(b);
  }
}
function bv(e, t, n) {
  return e.check(Zi, t, e.attempt(fv, t, n));
}
function vv(e) {
  e.exit("gfmFootnoteDefinition");
}
function wv(e, t, n) {
  const i = this;
  return Be(e, r, "gfmFootnoteDefinitionIndent", 5);
  function r(a) {
    const o = i.events[i.events.length - 1];
    return o && o[1].type === "gfmFootnoteDefinitionIndent" && o[2].sliceSerialize(o[1], !0).length === 4 ? t(a) : n(a);
  }
}
function kv(e) {
  let n = (e || {}).singleTilde;
  const i = {
    name: "strikethrough",
    tokenize: a,
    resolveAll: r
  };
  return n == null && (n = !0), {
    text: {
      126: i
    },
    insideSpan: {
      null: [i]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function r(o, l) {
    let u = -1;
    for (; ++u < o.length; )
      if (o[u][0] === "enter" && o[u][1].type === "strikethroughSequenceTemporary" && o[u][1]._close) {
        let c = u;
        for (; c--; )
          if (o[c][0] === "exit" && o[c][1].type === "strikethroughSequenceTemporary" && o[c][1]._open && // If the sizes are the same:
          o[u][1].end.offset - o[u][1].start.offset === o[c][1].end.offset - o[c][1].start.offset) {
            o[u][1].type = "strikethroughSequence", o[c][1].type = "strikethroughSequence";
            const h = {
              type: "strikethrough",
              start: Object.assign({}, o[c][1].start),
              end: Object.assign({}, o[u][1].end)
            }, p = {
              type: "strikethroughText",
              start: Object.assign({}, o[c][1].end),
              end: Object.assign({}, o[u][1].start)
            }, m = [["enter", h, l], ["enter", o[c][1], l], ["exit", o[c][1], l], ["enter", p, l]], g = l.parser.constructs.insideSpan.null;
            g && Wt(m, m.length, 0, Es(g, o.slice(c + 1, u), l)), Wt(m, m.length, 0, [["exit", p, l], ["enter", o[u][1], l], ["exit", o[u][1], l], ["exit", h, l]]), Wt(o, c - 1, u - c + 3, m), u = c + m.length - 2;
            break;
          }
      }
    for (u = -1; ++u < o.length; )
      o[u][1].type === "strikethroughSequenceTemporary" && (o[u][1].type = "data");
    return o;
  }
  function a(o, l, u) {
    const c = this.previous, h = this.events;
    let p = 0;
    return m;
    function m(b) {
      return c === 126 && h[h.length - 1][1].type !== "characterEscape" ? u(b) : (o.enter("strikethroughSequenceTemporary"), g(b));
    }
    function g(b) {
      const v = Ri(c);
      if (b === 126)
        return p > 1 ? u(b) : (o.consume(b), p++, g);
      if (p < 2 && !n) return u(b);
      const w = o.exit("strikethroughSequenceTemporary"), y = Ri(b);
      return w._open = !y || y === 2 && !!v, w._close = !v || v === 2 && !!y, l(b);
    }
  }
}
class Cv {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(t, n, i) {
    Sv(this, t, n, i);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(t) {
    if (this.map.sort(function(a, o) {
      return a[0] - o[0];
    }), this.map.length === 0)
      return;
    let n = this.map.length;
    const i = [];
    for (; n > 0; )
      n -= 1, i.push(t.slice(this.map[n][0] + this.map[n][1]), this.map[n][2]), t.length = this.map[n][0];
    i.push(t.slice()), t.length = 0;
    let r = i.pop();
    for (; r; ) {
      for (const a of r)
        t.push(a);
      r = i.pop();
    }
    this.map.length = 0;
  }
}
function Sv(e, t, n, i) {
  let r = 0;
  if (!(n === 0 && i.length === 0)) {
    for (; r < e.map.length; ) {
      if (e.map[r][0] === t) {
        e.map[r][1] += n, e.map[r][2].push(...i);
        return;
      }
      r += 1;
    }
    e.map.push([t, n, i]);
  }
}
function Ev(e, t) {
  let n = !1;
  const i = [];
  for (; t < e.length; ) {
    const r = e[t];
    if (n) {
      if (r[0] === "enter")
        r[1].type === "tableContent" && i.push(e[t + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (r[1].type === "tableContent") {
        if (e[t - 1][1].type === "tableDelimiterMarker") {
          const a = i.length - 1;
          i[a] = i[a] === "left" ? "center" : "right";
        }
      } else if (r[1].type === "tableDelimiterRow")
        break;
    } else r[0] === "enter" && r[1].type === "tableDelimiterRow" && (n = !0);
    t += 1;
  }
  return i;
}
function Av() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: Iv,
        resolveAll: Lv
      }
    }
  };
}
function Iv(e, t, n) {
  const i = this;
  let r = 0, a = 0, o;
  return l;
  function l(M) {
    let z = i.events.length - 1;
    for (; z > -1; ) {
      const H = i.events[z][1].type;
      if (H === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      H === "linePrefix") z--;
      else break;
    }
    const R = z > -1 ? i.events[z][1].type : null, j = R === "tableHead" || R === "tableRow" ? f : u;
    return j === f && i.parser.lazy[i.now().line] ? n(M) : j(M);
  }
  function u(M) {
    return e.enter("tableHead"), e.enter("tableRow"), c(M);
  }
  function c(M) {
    return M === 124 || (o = !0, a += 1), h(M);
  }
  function h(M) {
    return M === null ? n(M) : me(M) ? a > 1 ? (a = 0, i.interrupt = !0, e.exit("tableRow"), e.enter("lineEnding"), e.consume(M), e.exit("lineEnding"), g) : n(M) : Le(M) ? Be(e, h, "whitespace")(M) : (a += 1, o && (o = !1, r += 1), M === 124 ? (e.enter("tableCellDivider"), e.consume(M), e.exit("tableCellDivider"), o = !0, h) : (e.enter("data"), p(M)));
  }
  function p(M) {
    return M === null || M === 124 || Ue(M) ? (e.exit("data"), h(M)) : (e.consume(M), M === 92 ? m : p);
  }
  function m(M) {
    return M === 92 || M === 124 ? (e.consume(M), p) : p(M);
  }
  function g(M) {
    return i.interrupt = !1, i.parser.lazy[i.now().line] ? n(M) : (e.enter("tableDelimiterRow"), o = !1, Le(M) ? Be(e, b, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(M) : b(M));
  }
  function b(M) {
    return M === 45 || M === 58 ? w(M) : M === 124 ? (o = !0, e.enter("tableCellDivider"), e.consume(M), e.exit("tableCellDivider"), v) : S(M);
  }
  function v(M) {
    return Le(M) ? Be(e, w, "whitespace")(M) : w(M);
  }
  function w(M) {
    return M === 58 ? (a += 1, o = !0, e.enter("tableDelimiterMarker"), e.consume(M), e.exit("tableDelimiterMarker"), y) : M === 45 ? (a += 1, y(M)) : M === null || me(M) ? P(M) : S(M);
  }
  function y(M) {
    return M === 45 ? (e.enter("tableDelimiterFiller"), I(M)) : S(M);
  }
  function I(M) {
    return M === 45 ? (e.consume(M), I) : M === 58 ? (o = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(M), e.exit("tableDelimiterMarker"), E) : (e.exit("tableDelimiterFiller"), E(M));
  }
  function E(M) {
    return Le(M) ? Be(e, P, "whitespace")(M) : P(M);
  }
  function P(M) {
    return M === 124 ? b(M) : M === null || me(M) ? !o || r !== a ? S(M) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), t(M)) : S(M);
  }
  function S(M) {
    return n(M);
  }
  function f(M) {
    return e.enter("tableRow"), C(M);
  }
  function C(M) {
    return M === 124 ? (e.enter("tableCellDivider"), e.consume(M), e.exit("tableCellDivider"), C) : M === null || me(M) ? (e.exit("tableRow"), t(M)) : Le(M) ? Be(e, C, "whitespace")(M) : (e.enter("data"), L(M));
  }
  function L(M) {
    return M === null || M === 124 || Ue(M) ? (e.exit("data"), C(M)) : (e.consume(M), M === 92 ? F : L);
  }
  function F(M) {
    return M === 92 || M === 124 ? (e.consume(M), L) : L(M);
  }
}
function Lv(e, t) {
  let n = -1, i = !0, r = 0, a = [0, 0, 0, 0], o = [0, 0, 0, 0], l = !1, u = 0, c, h, p;
  const m = new Cv();
  for (; ++n < e.length; ) {
    const g = e[n], b = g[1];
    g[0] === "enter" ? b.type === "tableHead" ? (l = !1, u !== 0 && (nc(m, t, u, c, h), h = void 0, u = 0), c = {
      type: "table",
      start: Object.assign({}, b.start),
      // Note: correct end is set later.
      end: Object.assign({}, b.end)
    }, m.add(n, 0, [["enter", c, t]])) : b.type === "tableRow" || b.type === "tableDelimiterRow" ? (i = !0, p = void 0, a = [0, 0, 0, 0], o = [0, n + 1, 0, 0], l && (l = !1, h = {
      type: "tableBody",
      start: Object.assign({}, b.start),
      // Note: correct end is set later.
      end: Object.assign({}, b.end)
    }, m.add(n, 0, [["enter", h, t]])), r = b.type === "tableDelimiterRow" ? 2 : h ? 3 : 1) : r && (b.type === "data" || b.type === "tableDelimiterMarker" || b.type === "tableDelimiterFiller") ? (i = !1, o[2] === 0 && (a[1] !== 0 && (o[0] = o[1], p = Kr(m, t, a, r, void 0, p), a = [0, 0, 0, 0]), o[2] = n)) : b.type === "tableCellDivider" && (i ? i = !1 : (a[1] !== 0 && (o[0] = o[1], p = Kr(m, t, a, r, void 0, p)), a = o, o = [a[1], n, 0, 0])) : b.type === "tableHead" ? (l = !0, u = n) : b.type === "tableRow" || b.type === "tableDelimiterRow" ? (u = n, a[1] !== 0 ? (o[0] = o[1], p = Kr(m, t, a, r, n, p)) : o[1] !== 0 && (p = Kr(m, t, o, r, n, p)), r = 0) : r && (b.type === "data" || b.type === "tableDelimiterMarker" || b.type === "tableDelimiterFiller") && (o[3] = n);
  }
  for (u !== 0 && nc(m, t, u, c, h), m.consume(t.events), n = -1; ++n < t.events.length; ) {
    const g = t.events[n];
    g[0] === "enter" && g[1].type === "table" && (g[1]._align = Ev(t.events, n));
  }
  return e;
}
function Kr(e, t, n, i, r, a) {
  const o = i === 1 ? "tableHeader" : i === 2 ? "tableDelimiter" : "tableData", l = "tableContent";
  n[0] !== 0 && (a.end = Object.assign({}, Ti(t.events, n[0])), e.add(n[0], 0, [["exit", a, t]]));
  const u = Ti(t.events, n[1]);
  if (a = {
    type: o,
    start: Object.assign({}, u),
    // Note: correct end is set later.
    end: Object.assign({}, u)
  }, e.add(n[1], 0, [["enter", a, t]]), n[2] !== 0) {
    const c = Ti(t.events, n[2]), h = Ti(t.events, n[3]), p = {
      type: l,
      start: Object.assign({}, c),
      end: Object.assign({}, h)
    };
    if (e.add(n[2], 0, [["enter", p, t]]), i !== 2) {
      const m = t.events[n[2]], g = t.events[n[3]];
      if (m[1].end = Object.assign({}, g[1].end), m[1].type = "chunkText", m[1].contentType = "text", n[3] > n[2] + 1) {
        const b = n[2] + 1, v = n[3] - n[2] - 1;
        e.add(b, v, []);
      }
    }
    e.add(n[3] + 1, 0, [["exit", p, t]]);
  }
  return r !== void 0 && (a.end = Object.assign({}, Ti(t.events, r)), e.add(r, 0, [["exit", a, t]]), a = void 0), a;
}
function nc(e, t, n, i, r) {
  const a = [], o = Ti(t.events, n);
  r && (r.end = Object.assign({}, o), a.push(["exit", r, t])), i.end = Object.assign({}, o), a.push(["exit", i, t]), e.add(n + 1, 0, a);
}
function Ti(e, t) {
  const n = e[t], i = n[0] === "enter" ? "start" : "end";
  return n[1][i];
}
const Pv = {
  name: "tasklistCheck",
  tokenize: Nv
};
function Tv() {
  return {
    text: {
      91: Pv
    }
  };
}
function Nv(e, t, n) {
  const i = this;
  return r;
  function r(u) {
    return (
      // Exit if there’s stuff before.
      i.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !i._gfmTasklistFirstContentOfListItem ? n(u) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), a)
    );
  }
  function a(u) {
    return Ue(u) ? (e.enter("taskListCheckValueUnchecked"), e.consume(u), e.exit("taskListCheckValueUnchecked"), o) : u === 88 || u === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(u), e.exit("taskListCheckValueChecked"), o) : n(u);
  }
  function o(u) {
    return u === 93 ? (e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), l) : n(u);
  }
  function l(u) {
    return me(u) ? t(u) : Le(u) ? e.check({
      tokenize: Dv
    }, t, n)(u) : n(u);
  }
}
function Dv(e, t, n) {
  return Be(e, i, "whitespace");
  function i(r) {
    return r === null ? n(r) : t(r);
  }
}
function Vv(e) {
  return Ao([
    sv(),
    mv(),
    kv(e),
    Av(),
    Tv()
  ]);
}
const Mv = {};
function Fv(e) {
  const t = (
    /** @type {Processor<Root>} */
    this
  ), n = e || Mv, i = t.data(), r = i.micromarkExtensions || (i.micromarkExtensions = []), a = i.fromMarkdownExtensions || (i.fromMarkdownExtensions = []), o = i.toMarkdownExtensions || (i.toMarkdownExtensions = []);
  r.push(Vv(n)), a.push(tv()), o.push(nv(n));
}
function s5({ content: e, components: t = {} }) {
  const [n, i] = Ee(null), [r, a] = Ee(null);
  return ve(() => {
    let o = !1;
    i(null), a(null);
    const l = {
      // `runtime` supplies jsx/jsxs/Fragment to the compiled MDX module.
      // The cast is required because the types between react/jsx-runtime and
      // EvaluateOptions don't perfectly overlap (known @mdx-js/mdx issue).
      ...Ed,
      remarkPlugins: [Fv, Ib]
    };
    return fb(e, l).then(({ default: u }) => {
      o || i(() => u);
    }).catch((u) => {
      o || a(u instanceof Error ? u : new Error(String(u)));
    }), () => {
      o = !0;
    };
  }, [e]), r ? /* @__PURE__ */ B("div", { className: "ns-mdx-error", role: "alert", children: [
    /* @__PURE__ */ _("strong", { children: "MDX rendering error:" }),
    " ",
    r.message
  ] }) : n ? /* @__PURE__ */ _(n, { components: { ...Mc, ...t } }) : null;
}
const si = {
  "ns-data-card": "_ns-data-card_1xnme_1",
  "ns-data-card__action": "_ns-data-card__action_1xnme_12",
  "ns-data-card__heading": "_ns-data-card__heading_1xnme_17",
  "ns-data-card__list": "_ns-data-card__list_1xnme_25",
  "ns-data-card__property": "_ns-data-card__property_1xnme_31",
  "ns-data-card__term": "_ns-data-card__term_1xnme_36",
  "ns-data-card__value": "_ns-data-card__value_1xnme_45"
};
function Rv(e) {
  return e == null || e === "" ? "—" : String(e);
}
const a5 = ({
  "aria-label": e,
  heading: t,
  data: n,
  fields: i,
  action: r,
  onAction: a
}) => {
  const o = at(), l = Q({ [si["ns-data-card"]]: !0 }), u = !e && typeof t == "string";
  return /* @__PURE__ */ B(
    "section",
    {
      className: l,
      role: "group",
      "aria-label": u ? void 0 : e,
      "aria-labelledby": u ? o : void 0,
      children: [
        r ? /* @__PURE__ */ _("div", { className: si["ns-data-card__action"], children: /* @__PURE__ */ _(st, { ...r, onClick: () => a?.(r) }) }) : null,
        t != null ? /* @__PURE__ */ _("div", { id: u ? o : void 0, className: si["ns-data-card__heading"], children: t }) : null,
        /* @__PURE__ */ _("dl", { className: si["ns-data-card__list"], children: i.map((c) => /* @__PURE__ */ B("div", { className: si["ns-data-card__property"], children: [
          /* @__PURE__ */ _("dt", { className: si["ns-data-card__term"], children: c.label }),
          /* @__PURE__ */ _("dd", { className: si["ns-data-card__value"], children: c.transform ? c.transform(n[c.key]) : Rv(n[c.key]) })
        ] }, c.key)) })
      ]
    }
  );
};
function o5(e) {
  return e;
}
function l5(e) {
  return e;
}
const Fp = Cr(null);
function En() {
  const e = Oi(Fp);
  if (e === null)
    throw new Error("DataTable compound components must be rendered inside <DataTable>.");
  return e;
}
const fe = {
  "ns-datatable": "_ns-datatable_s1tiw_1",
  "ns-datatable__toolbar": "_ns-datatable__toolbar_s1tiw_8",
  "ns-datatable__global-filter": "_ns-datatable__global-filter_s1tiw_12",
  "ns-datatable__global-filter-icon": "_ns-datatable__global-filter-icon_s1tiw_24",
  "ns-datatable__card": "_ns-datatable__card_s1tiw_36",
  "ns-datatable__scroll": "_ns-datatable__scroll_s1tiw_41",
  "ns-datatable__table": "_ns-datatable__table_s1tiw_48",
  "ns-datatable__caption": "_ns-datatable__caption_s1tiw_55",
  "ns-datatable__control-col": "_ns-datatable__control-col_s1tiw_63",
  "ns-datatable__head": "_ns-datatable__head_s1tiw_66",
  "ns-datatable__header-cell--align-center": "_ns-datatable__header-cell--align-center_s1tiw_85",
  "ns-datatable__header-inner": "_ns-datatable__header-inner_s1tiw_85",
  "ns-datatable__header-cell--align-end": "_ns-datatable__header-cell--align-end_s1tiw_88",
  "ns-datatable__header-cell": "_ns-datatable__header-cell_s1tiw_85",
  "ns-datatable__cell": "_ns-datatable__cell_s1tiw_92",
  "ns-datatable__header-text": "_ns-datatable__header-text_s1tiw_103",
  "ns-datatable__header-sub": "_ns-datatable__header-sub_s1tiw_108",
  "ns-datatable__sort-button": "_ns-datatable__sort-button_s1tiw_114",
  "ns-datatable__filter-button": "_ns-datatable__filter-button_s1tiw_115",
  "ns-datatable__kebab": "_ns-datatable__kebab_s1tiw_116",
  "ns-datatable__drag-handle": "_ns-datatable__drag-handle_s1tiw_117",
  "ns-datatable__expand-toggle": "_ns-datatable__expand-toggle_s1tiw_118",
  "ns-datatable__sort-icon": "_ns-datatable__sort-icon_s1tiw_145",
  "ns-datatable__filter-button--active": "_ns-datatable__filter-button--active_s1tiw_151",
  "ns-datatable__filter-field": "_ns-datatable__filter-field_s1tiw_154",
  "ns-datatable__filter-field-label": "_ns-datatable__filter-field-label_s1tiw_160",
  "ns-datatable__resize-handle": "_ns-datatable__resize-handle_s1tiw_175",
  "ns-datatable__control-cell": "_ns-datatable__control-cell_s1tiw_189",
  "ns-datatable__control-group": "_ns-datatable__control-group_s1tiw_195",
  "ns-datatable__row": "_ns-datatable__row_s1tiw_206",
  "ns-datatable__row--odd": "_ns-datatable__row--odd_s1tiw_206",
  "ns-datatable__row--even": "_ns-datatable__row--even_s1tiw_209",
  "ns-datatable__row--selected": "_ns-datatable__row--selected_s1tiw_212",
  "ns-datatable__row--dragging": "_ns-datatable__row--dragging_s1tiw_215",
  "ns-datatable__row--picked": "_ns-datatable__row--picked_s1tiw_218",
  "ns-datatable__row--drop-target": "_ns-datatable__row--drop-target_s1tiw_222",
  "ns-datatable__row--summary": "_ns-datatable__row--summary_s1tiw_225",
  "ns-datatable__cell--align-center": "_ns-datatable__cell--align-center_s1tiw_245",
  "ns-datatable__cell--align-end": "_ns-datatable__cell--align-end_s1tiw_248",
  "ns-datatable__cell-main": "_ns-datatable__cell-main_s1tiw_251",
  "ns-datatable__cell-main--text": "_ns-datatable__cell-main--text_s1tiw_254",
  "ns-datatable__cell-main--number": "_ns-datatable__cell-main--number_s1tiw_259",
  "ns-datatable__cell-sub": "_ns-datatable__cell-sub_s1tiw_264",
  "ns-datatable__link": "_ns-datatable__link_s1tiw_272",
  "ns-datatable__link-icon": "_ns-datatable__link-icon_s1tiw_283",
  "ns-datatable__link-text": "_ns-datatable__link-text_s1tiw_286",
  "ns-datatable__bool": "_ns-datatable__bool_s1tiw_297",
  "ns-datatable__bool-icon": "_ns-datatable__bool-icon_s1tiw_307",
  "ns-datatable__bool-icon--true": "_ns-datatable__bool-icon--true_s1tiw_310",
  "ns-datatable__bool-icon--false": "_ns-datatable__bool-icon--false_s1tiw_313",
  "ns-datatable__list": "_ns-datatable__list_s1tiw_316",
  "ns-datatable__expansion-cell": "_ns-datatable__expansion-cell_s1tiw_323",
  "ns-datatable__expansion-wrapper": "_ns-datatable__expansion-wrapper_s1tiw_328",
  "ns-datatable__expansion-wrapper--open": "_ns-datatable__expansion-wrapper--open_s1tiw_333",
  "ns-datatable__expansion-content": "_ns-datatable__expansion-content_s1tiw_341",
  "ns-datatable__expansion--top": "_ns-datatable__expansion--top_s1tiw_348",
  "ns-datatable__empty": "_ns-datatable__empty_s1tiw_351",
  "ns-datatable__sr-only": "_ns-datatable__sr-only_s1tiw_357",
  "ns-datatable__actions-inline": "_ns-datatable__actions-inline_s1tiw_368",
  "ns-datatable__actions-kebab": "_ns-datatable__actions-kebab_s1tiw_374",
  "ns-datatable__pagination": "_ns-datatable__pagination_s1tiw_385",
  "ns-datatable__pagination-left": "_ns-datatable__pagination-left_s1tiw_395",
  "ns-datatable__pagination-right": "_ns-datatable__pagination-right_s1tiw_396",
  "ns-datatable__page-label": "_ns-datatable__page-label_s1tiw_401",
  "ns-datatable__page-size-select": "_ns-datatable__page-size-select_s1tiw_406",
  "ns-datatable__page-range": "_ns-datatable__page-range_s1tiw_422",
  "ns-datatable__page-btn": "_ns-datatable__page-btn_s1tiw_427"
};
function Rp({ id: e, isOpen: t, children: n, labelledBy: i, label: r, className: a }) {
  const { totalColumnCount: o } = En(), l = Q(fe["ns-datatable__expansion-wrapper"], {
    [fe["ns-datatable__expansion-wrapper--open"]]: t
  });
  return /* @__PURE__ */ _("tr", { className: Q(fe["ns-datatable__expansion"], a), "aria-hidden": !t, children: /* @__PURE__ */ _("td", { colSpan: o, className: fe["ns-datatable__expansion-cell"], children: /* @__PURE__ */ _("div", { className: l, inert: !t, children: /* @__PURE__ */ _(
    "div",
    {
      id: e,
      role: "region",
      "aria-labelledby": i,
      "aria-label": i ? void 0 : r,
      className: fe["ns-datatable__expansion-content"],
      children: n
    }
  ) }) }) });
}
function Ov(e, t) {
  const { dragState: n, keyboardDragId: i, beginDrag: r, dragOver: a, endDrag: o, toggleKeyboardDrag: l, moveKeyboardDrag: u } = En(), c = pe(
    (v) => {
      t && (v.preventDefault(), v.dataTransfer.dropEffect = "move", a(e));
    },
    [t, a, e]
  ), h = pe((v) => {
    v.preventDefault();
  }, []), p = pe(
    (v) => {
      v.dataTransfer.effectAllowed = "move", v.dataTransfer.setData("text/plain", e), r(e);
    },
    [r, e]
  ), m = pe(
    (v) => {
      t && (v.currentTarget.contains(v.relatedTarget) || a(n.draggingId ?? e));
    },
    [t, a, n.draggingId, e]
  ), g = pe(
    (v) => {
      o(v.dataTransfer.dropEffect !== "none");
    },
    [o]
  ), b = pe(
    (v) => {
      switch (v.key) {
        case " ":
        case "Enter":
          v.preventDefault(), l(e);
          break;
        case "ArrowUp":
          i === e && (v.preventDefault(), u(-1));
          break;
        case "ArrowDown":
          i === e && (v.preventDefault(), u(1));
          break;
        case "Escape":
          i === e && (v.preventDefault(), l(e));
          break;
      }
    },
    [i, e, l, u]
  );
  return {
    isDragging: n.draggingId === e,
    isDropTarget: n.draggingId !== null && n.draggingId !== e && n.overId === e,
    isKeyboardPicked: i === e,
    rowProps: t ? { onDragOver: c, onDrop: h, onDragLeave: m } : {},
    handleProps: { draggable: t, onDragStart: p, onDragEnd: g, onKeyDown: b }
  };
}
function Bv({ rowId: e, menu: t, triggerLabel: n }) {
  const i = re(null);
  return /* @__PURE__ */ B(Ke, { children: [
    /* @__PURE__ */ _(
      st,
      {
        ref: i,
        type: "button",
        "aria-label": n,
        variant: lt.Text,
        icon: J.MoreVert,
        size: Mt.Small,
        isIconOnly: !0
      }
    ),
    /* @__PURE__ */ _(
      Kn,
      {
        id: `ns-datatable-menu-${e}`,
        label: t.label ?? "Row actions",
        items: t.items,
        anchorRef: i,
        placement: t.placement,
        onItemClick: t.onItemClick
      }
    )
  ] });
}
function zv(e) {
  switch (e.kind) {
    case "text":
    case "link":
    case "badge":
      return e.text;
    case "boolean":
    case "number":
    case "date":
      return e.value;
    case "list":
      return e.items.join(", ");
    default:
      return "";
  }
}
function jv(e, t) {
  if (!e || !t)
    return;
  let n;
  return e.mode === "boolean" ? n = t.value ? e.whenTrue : e.whenFalse : e.mode === "value" ? n = e.values[String(zv(t))] ?? e.fallback : n = typeof e.content == "function" ? e.content(t) : e.content, n === "" ? void 0 : n;
}
function Hv({ text: e, variant: t, color: n, prefix: i }) {
  return /* @__PURE__ */ _(hi, { id: `badge-${e}`, label: e, text: e, variant: t, color: n, prefix: i });
}
function $v({
  value: e,
  trueLabel: t = "Yes",
  falseLabel: n = "No",
  trueIcon: i = J.Done,
  falseIcon: r = J.Close
}) {
  const a = Q(fe["ns-datatable__bool-icon"], {
    [fe["ns-datatable__bool-icon--true"]]: e,
    [fe["ns-datatable__bool-icon--false"]]: !e
  });
  return /* @__PURE__ */ B("span", { className: fe["ns-datatable__bool"], children: [
    /* @__PURE__ */ _("span", { "aria-hidden": "true", className: a, children: /* @__PURE__ */ _(ke, { name: e ? i : r, size: 16 }) }),
    /* @__PURE__ */ _("span", { children: e ? t : n })
  ] });
}
const ic = /* @__PURE__ */ new Map(), rc = /* @__PURE__ */ new Map();
function qv(e, t) {
  const n = `${e ?? ""}|${JSON.stringify(t)}`;
  let i = ic.get(n);
  return i || (i = new Intl.NumberFormat(e, t), ic.set(n, i)), i;
}
function Uv(e, t) {
  const n = `${e ?? ""}|${JSON.stringify(t)}`;
  let i = rc.get(n);
  return i || (i = new Intl.DateTimeFormat(e, t), rc.set(n, i)), i;
}
function Jv(e) {
  return !e || e.style === "decimal" ? {
    style: "decimal",
    minimumFractionDigits: e?.style === "decimal" ? e.minimumFractionDigits : void 0,
    maximumFractionDigits: e?.style === "decimal" ? e.maximumFractionDigits : void 0
  } : e.style === "currency" ? { style: "currency", currency: e.currency } : { style: "unit", unit: e.unit, unitDisplay: "short" };
}
function Op(e, t, n) {
  return qv(n, Jv(t)).format(e);
}
function xs(e) {
  return typeof e == "number" ? e : new Date(e).getTime();
}
function Bp(e) {
  const t = xs(e.value);
  if (Number.isNaN(t))
    return String(e.value);
  const n = e.options ?? { dateStyle: "medium" };
  return Uv(e.locale, n).format(new Date(t));
}
function Wv({ value: e, options: t, locale: n }) {
  const i = xs(e), r = Number.isNaN(i) ? void 0 : new Date(i).toISOString();
  return /* @__PURE__ */ _("time", { dateTime: r, children: Bp({ value: e, options: t, locale: n }) });
}
function Xv({ text: e, href: t, label: n, target: i = "_self", icon: r }) {
  const a = r ?? (i === "_blank" ? J.Launch : void 0);
  return /* @__PURE__ */ B(
    Ir,
    {
      url: t,
      target: i,
      ariaLabel: n,
      title: n,
      className: fe["ns-datatable__link"],
      children: [
        /* @__PURE__ */ _("span", { className: fe["ns-datatable__link-text"], children: e }),
        a !== void 0 && /* @__PURE__ */ _("span", { "aria-hidden": "true", className: fe["ns-datatable__link-icon"], children: /* @__PURE__ */ _(ke, { name: a, size: 16 }) })
      ]
    }
  );
}
function Zv({ items: e, ordered: t = !1 }) {
  return /* @__PURE__ */ _(t ? "ol" : "ul", { className: fe["ns-datatable__list"], children: e.map((i, r) => /* @__PURE__ */ _("li", { children: i }, `${i}-${r}`)) });
}
function Gv({ value: e, format: t, locale: n }) {
  return /* @__PURE__ */ _(Ke, { children: Op(e, t, n) });
}
function Kv({ text: e }) {
  return /* @__PURE__ */ _(Ke, { children: e });
}
function Yv(e, t) {
  return {
    type: "button",
    id: e.name,
    label: e.text ?? e.title ?? e.name,
    prefix: e.prefix,
    danger: e.color === Re.Error,
    disabled: e.disabled,
    onClick: () => t?.(e)
  };
}
function Qv({ rowId: e, items: t, onAction: n }) {
  const i = re(null), r = `ns-datatable-actions-menu-${e}`, a = t.map((o) => Yv(o, n));
  return /* @__PURE__ */ B(Ke, { children: [
    /* @__PURE__ */ _("div", { className: fe["ns-datatable__actions-inline"], "aria-hidden": !1, children: t.map((o) => /* @__PURE__ */ _(st, { ...o, variant: lt.Text, onClick: () => n?.(o) }, o.name)) }),
    /* @__PURE__ */ B("div", { className: fe["ns-datatable__actions-kebab"], children: [
      /* @__PURE__ */ _(
        "button",
        {
          ref: i,
          type: "button",
          className: fe["ns-datatable__kebab"],
          "aria-label": `Row actions for ${e}`,
          children: /* @__PURE__ */ _(ke, { name: J.MoreVert, size: 20 })
        }
      ),
      /* @__PURE__ */ _(
        Kn,
        {
          id: r,
          label: `Row actions for ${e}`,
          items: a,
          anchorRef: i,
          placement: "bottom-end"
        }
      )
    ] })
  ] });
}
function zp(e) {
  return e.align ? e.align : e.type === "number" || e.type === "date" ? "end" : "start";
}
function ew(e, t) {
  switch (e.kind) {
    case "text":
      return /* @__PURE__ */ _(Kv, { ...e });
    case "link":
      return /* @__PURE__ */ _(Xv, { ...e });
    case "boolean":
      return /* @__PURE__ */ _($v, { ...e });
    case "number":
      return /* @__PURE__ */ _(Gv, { ...e });
    case "list":
      return /* @__PURE__ */ _(Zv, { ...e });
    case "date":
      return /* @__PURE__ */ _(Wv, { ...e });
    case "badge":
      return /* @__PURE__ */ _(Hv, { ...e });
    case "actions": {
      const n = e;
      return /* @__PURE__ */ _(Qv, { rowId: t ?? "row", items: n.items, onAction: n.onAction });
    }
    default:
      return null;
  }
}
function jp({ column: e, cell: t, rowId: n }) {
  const i = re(null), r = at(), a = zp(e), o = Q(fe["ns-datatable__cell"], fe[`ns-datatable__cell--align-${a}`]);
  if (!t)
    return /* @__PURE__ */ _("td", { className: o });
  const l = t.tooltip ?? jv(e.tooltip, t), u = Q(fe["ns-datatable__cell-main"], fe[`ns-datatable__cell-main--${t.kind}`]);
  return /* @__PURE__ */ B("td", { ref: i, className: o, children: [
    /* @__PURE__ */ _("span", { className: u, children: ew(t, n) }),
    t.sub !== void 0 && t.sub !== "" && /* @__PURE__ */ _("span", { className: fe["ns-datatable__cell-sub"], children: t.sub }),
    l && /* @__PURE__ */ _(cn, { id: `ns-datatable-tooltip-${r}`, content: l, anchorRef: i, placement: e.tooltip?.placement })
  ] });
}
function tw(e, t) {
  for (const n of t)
    if (n.type === "text" || n.type === "link") {
      const i = e[n.key];
      if (i && (i.kind === "text" || i.kind === "link"))
        return i.text;
    }
  return e.id;
}
function nw({ row: e, displayIndex: t }) {
  const {
    columns: n,
    selectable: i,
    draggable: r,
    hasRowMenus: a,
    showRowExpandToggle: o,
    leadingColumnCount: l,
    selectedIds: u,
    expandedIds: c,
    toggleSelected: h,
    toggleExpanded: p
  } = En(), m = i && e.isSelectable !== !1, g = r && e.isDraggable !== !1, b = e.expandedContent !== void 0 && e.expandedContent !== null, v = u.has(e.id), w = c.has(e.id), y = tw(e, n), I = Ov(e.id, g), E = Q(fe["ns-datatable__row"], {
    [fe["ns-datatable__row--even"]]: t % 2 === 0,
    [fe["ns-datatable__row--odd"]]: t % 2 === 1,
    [fe["ns-datatable__row--selected"]]: v,
    [fe["ns-datatable__row--dragging"]]: I.isDragging,
    [fe["ns-datatable__row--drop-target"]]: I.isDropTarget,
    [fe["ns-datatable__row--picked"]]: I.isKeyboardPicked
  }), P = g || m || a || l > 0;
  return /* @__PURE__ */ B(Ke, { children: [
    /* @__PURE__ */ B("tr", { className: E, "aria-selected": m ? v : void 0, ...I.rowProps, children: [
      P && /* @__PURE__ */ _("td", { className: fe["ns-datatable__control-cell"], children: /* @__PURE__ */ B("div", { className: fe["ns-datatable__control-group"], children: [
        g && /* @__PURE__ */ _(
          "button",
          {
            type: "button",
            className: fe["ns-datatable__drag-handle"],
            "aria-label": `Reorder ${y}`,
            "aria-pressed": I.isKeyboardPicked,
            ...I.handleProps,
            children: /* @__PURE__ */ _(ke, { name: J.SwapHoriz, size: 18 })
          }
        ),
        m && /* @__PURE__ */ B(Ke, { children: [
          /* @__PURE__ */ B("label", { htmlFor: `ns-datatable-select-${e.id}`, className: fe["ns-datatable__sr-only"], children: [
            "Select ",
            y
          ] }),
          /* @__PURE__ */ _(
            $i,
            {
              id: `ns-datatable-select-${e.id}`,
              label: "",
              checked: v,
              size: Hi.Small,
              onChange: () => h(e.id),
              className: fe["ns-datatable__select"]
            }
          )
        ] }),
        e.contextualMenu && /* @__PURE__ */ _(Bv, { rowId: e.id, menu: e.contextualMenu, triggerLabel: `Actions for ${y}` }),
        b && o && /* @__PURE__ */ _(
          "button",
          {
            id: `ns-datatable-expand-${e.id}`,
            type: "button",
            className: fe["ns-datatable__expand-toggle"],
            "aria-expanded": w,
            "aria-controls": `ns-datatable-expansion-${e.id}`,
            "aria-label": w ? `Collapse ${y}` : `Expand ${y}`,
            onClick: () => p(e.id),
            children: /* @__PURE__ */ _(ke, { name: w ? J.KeyboardArrowUp : J.KeyboardArrowDown, size: 20 })
          }
        )
      ] }) }),
      n.map((S) => {
        const f = e[S.key];
        return /* @__PURE__ */ _(jp, { column: S, cell: f, rowId: e.id }, S.key);
      })
    ] }),
    b && /* @__PURE__ */ _(
      Rp,
      {
        id: `ns-datatable-expansion-${e.id}`,
        labelledBy: o ? `ns-datatable-expand-${e.id}` : void 0,
        label: o ? void 0 : y,
        isOpen: w,
        children: e.expandedContent
      }
    )
  ] });
}
function iw() {
  const { columns: e, leadingColumnCount: t, summaryRow: n } = En();
  return n ? /* @__PURE__ */ B("tr", { className: Q(fe["ns-datatable__row"], fe["ns-datatable__row--summary"]), children: [
    t > 0 && /* @__PURE__ */ _("td", {}),
    e.map((i) => /* @__PURE__ */ _(jp, { column: i, cell: n[i.key] }, i.key))
  ] }) : null;
}
function rw({
  rows: e,
  totalColumnCount: t,
  topExpansion: n,
  topExpansionOpen: i = !1,
  topExpansionId: r = "ns-datatable-top-expansion",
  topExpansionLabel: a = "Create record"
}) {
  const { summaryRow: o } = En(), l = n != null;
  return /* @__PURE__ */ B(Ke, { children: [
    /* @__PURE__ */ B("tbody", { children: [
      l && /* @__PURE__ */ _(
        Rp,
        {
          id: r,
          isOpen: i,
          label: a,
          className: fe["ns-datatable__expansion--top"],
          children: n
        }
      ),
      e.length === 0 ? /* @__PURE__ */ _("tr", { children: /* @__PURE__ */ _("td", { colSpan: t, className: fe["ns-datatable__empty"], children: "No results." }) }) : e.map((u, c) => /* @__PURE__ */ _(nw, { row: u, displayIndex: c }, u.id))
    ] }),
    o && /* @__PURE__ */ _("tfoot", { children: /* @__PURE__ */ _(iw, {}) })
  ] });
}
const sw = 64, sc = 8;
function ac(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function aw() {
  const { setColumnWidth: e } = En(), t = re(null), n = re(e);
  n.current = e;
  const i = re((u) => {
    const c = t.current;
    if (!c)
      return;
    const h = ac(c.startWidth + (u.clientX - c.startX), c.min, c.max);
    n.current(c.columnKey, h);
  }).current, r = re(() => {
    t.current = null, window.removeEventListener("pointermove", i), window.removeEventListener("pointerup", a), document.body.style.removeProperty("cursor"), document.body.style.removeProperty("user-select");
  }).current, a = re(() => r()).current, o = pe(
    (u, c, h, p) => {
      u.preventDefault(), u.stopPropagation();
      const m = u.currentTarget.closest("th"), g = m ? m.getBoundingClientRect().width : h;
      t.current = { columnKey: c, startX: u.clientX, startWidth: g, min: h, max: p }, window.addEventListener("pointermove", i), window.addEventListener("pointerup", a), document.body.style.cursor = "col-resize", document.body.style.userSelect = "none";
    },
    [i, a]
  ), l = pe(
    (u, c, h, p, m) => {
      let g = 0;
      if (u.key === "ArrowLeft")
        g = -sc;
      else if (u.key === "ArrowRight")
        g = sc;
      else
        return;
      u.preventDefault(), n.current(c, ac(h + g, p, m));
    },
    []
  );
  return ve(() => r, [r]), { onPointerDown: o, onKeyboardResize: l };
}
function ow({ column: e }) {
  const { sort: t, cycleSort: n, filters: i, setColumnFilter: r, columnWidths: a } = En(), o = aw(), l = re(null), u = t?.columnKey === e.key, c = e.isSortable ? u ? t?.direction === "asc" ? "ascending" : "descending" : "none" : void 0, h = u ? t?.direction === "asc" ? J.KeyboardArrowUp : J.KeyboardArrowDown : J.Sort, p = e.header ?? e.key, m = zp(e), g = i[e.key] ?? "", b = g !== "", v = e.minWidth ?? sw, w = e.maxWidth ?? Number.MAX_SAFE_INTEGER, y = typeof e.width == "number" ? e.width : void 0, I = a[e.key] ?? y ?? v, E = /* @__PURE__ */ B("span", { className: fe["ns-datatable__header-text"], children: [
    /* @__PURE__ */ _("span", { className: fe["ns-datatable__header-title"], children: p }),
    e.subheader && /* @__PURE__ */ _("span", { className: fe["ns-datatable__header-sub"], children: e.subheader })
  ] }), P = e.filterType === "select" ? [
    { type: "button", id: "__all__", label: "All", onClick: () => r(e.key, "") },
    ...(e.filterOptions ?? []).map((S) => ({
      type: "button",
      id: S,
      label: S,
      suffix: g === S ? J.Done : void 0,
      onClick: () => r(e.key, S)
    }))
  ] : void 0;
  return /* @__PURE__ */ B(
    "th",
    {
      scope: "col",
      "aria-sort": c,
      className: Q(fe["ns-datatable__header-cell"], fe[`ns-datatable__header-cell--align-${m}`]),
      children: [
        /* @__PURE__ */ B("div", { className: fe["ns-datatable__header-inner"], children: [
          E,
          e.isSortable && /* @__PURE__ */ _(st, { type: "button", variant: lt.Text, icon: h, isIconOnly: !0, "aria-label": p, onClick: () => n(e.key) }),
          e.isFilterable && /* @__PURE__ */ B(Ke, { children: [
            /* @__PURE__ */ _(
              "button",
              {
                ref: l,
                type: "button",
                className: Q(fe["ns-datatable__filter-button"], {
                  [fe["ns-datatable__filter-button--active"]]: b
                }),
                "aria-label": `Filter ${p}`,
                children: /* @__PURE__ */ _(ke, { name: J.FilterList, size: 16 })
              }
            ),
            P ? /* @__PURE__ */ _(
              Kn,
              {
                id: `ns-datatable-filter-${e.key}`,
                label: `Filter ${p}`,
                items: P,
                anchorRef: l,
                placement: "bottom-end"
              }
            ) : /* @__PURE__ */ _(
              Kn,
              {
                id: `ns-datatable-filter-${e.key}`,
                label: `Filter ${p}`,
                anchorRef: l,
                placement: "bottom-end",
                content: /* @__PURE__ */ B("label", { className: fe["ns-datatable__filter-field"], children: [
                  /* @__PURE__ */ B("span", { className: fe["ns-datatable__filter-field-label"], children: [
                    "Filter ",
                    p
                  ] }),
                  /* @__PURE__ */ _(
                    "input",
                    {
                      type: "text",
                      value: g,
                      placeholder: "Type to filter…",
                      onChange: (S) => r(e.key, S.target.value)
                    }
                  )
                ] })
              }
            )
          ] })
        ] }),
        e.isResizable && /* @__PURE__ */ _(
          "span",
          {
            role: "separator",
            "aria-orientation": "vertical",
            "aria-label": `Resize ${p}`,
            "aria-valuenow": Math.round(I),
            "aria-valuemin": v,
            "aria-valuemax": Number.isFinite(w) ? w : void 0,
            tabIndex: 0,
            className: fe["ns-datatable__resize-handle"],
            onPointerDown: (S) => o.onPointerDown(S, e.key, v, w),
            onKeyDown: (S) => o.onKeyboardResize(S, e.key, I, v, w)
          }
        )
      ]
    }
  );
}
function lw() {
  const { columns: e, selectable: t, leadingColumnCount: n, selectAllState: i, toggleSelectAll: r } = En();
  return /* @__PURE__ */ _("thead", { className: fe["ns-datatable__head"], children: /* @__PURE__ */ B("tr", { children: [
    n > 0 && /* @__PURE__ */ _("th", { scope: "col", className: fe["ns-datatable__control-cell"], children: t ? /* @__PURE__ */ B(Ke, { children: [
      /* @__PURE__ */ _("label", { htmlFor: "ns-datatable-select-all", className: fe["ns-datatable__sr-only"], children: "Select all rows" }),
      /* @__PURE__ */ _(
        $i,
        {
          id: "ns-datatable-select-all",
          label: "",
          checked: i === "all",
          indeterminate: i === "some",
          size: Hi.Small,
          onChange: r,
          className: fe["ns-datatable__select"]
        }
      )
    ] }) : /* @__PURE__ */ _("span", { className: fe["ns-datatable__sr-only"], children: "Row controls" }) }),
    e.map((a) => /* @__PURE__ */ _(ow, { column: a }, a.key))
  ] }) });
}
function uw() {
  const { page: e, pageSize: t, totalRows: n, setPage: i, setPageSize: r, pageSizeOptions: a } = En(), o = n === 0 ? 0 : e * t + 1, l = Math.min((e + 1) * t, n), u = t > 0 ? Math.max(0, Math.ceil(n / t) - 1) : 0;
  return /* @__PURE__ */ B("div", { className: fe["ns-datatable__pagination"], children: [
    /* @__PURE__ */ B("div", { className: fe["ns-datatable__pagination-left"], children: [
      /* @__PURE__ */ _("span", { className: fe["ns-datatable__page-label"], children: "Rows per page:" }),
      /* @__PURE__ */ _(
        "select",
        {
          className: fe["ns-datatable__page-size-select"],
          value: t,
          onChange: (c) => r(Number(c.target.value)),
          "aria-label": "Rows per page",
          children: a.map((c) => /* @__PURE__ */ _("option", { value: c, children: c }, c))
        }
      )
    ] }),
    /* @__PURE__ */ B("div", { className: fe["ns-datatable__pagination-right"], children: [
      /* @__PURE__ */ B("span", { className: fe["ns-datatable__page-range"], children: [
        o,
        "–",
        l,
        " of ",
        n
      ] }),
      /* @__PURE__ */ _(
        "button",
        {
          type: "button",
          className: fe["ns-datatable__page-btn"],
          "aria-label": "Previous page",
          disabled: e === 0,
          onClick: () => i(e - 1),
          children: /* @__PURE__ */ _(ke, { name: J.ChevronLeft, size: 20 })
        }
      ),
      /* @__PURE__ */ _(
        "button",
        {
          type: "button",
          className: fe["ns-datatable__page-btn"],
          "aria-label": "Next page",
          disabled: e >= u,
          onClick: () => i(e + 1),
          children: /* @__PURE__ */ _(ke, { name: J.ChevronRight, size: 20 })
        }
      )
    ] })
  ] });
}
function cw() {
  const { tableId: e, globalFilter: t, setGlobalFilter: n } = En(), i = `${e}-global-filter`;
  return /* @__PURE__ */ B("div", { className: fe["ns-datatable__toolbar"], children: [
    /* @__PURE__ */ _("label", { htmlFor: i, className: fe["ns-datatable__sr-only"], children: "Filter all columns" }),
    /* @__PURE__ */ B("div", { className: fe["ns-datatable__global-filter"], children: [
      /* @__PURE__ */ _("span", { "aria-hidden": "true", className: fe["ns-datatable__global-filter-icon"], children: /* @__PURE__ */ _(ke, { name: J.FilterList, size: 18 }) }),
      /* @__PURE__ */ _(
        "input",
        {
          id: i,
          type: "search",
          value: t,
          placeholder: "Filter…",
          onChange: (r) => n(r.target.value)
        }
      )
    ] })
  ] });
}
function Jn(e, t) {
  const [n, i] = Ee(t), r = e !== void 0, a = r ? e : n, o = pe(
    (l, u) => {
      u?.(l), r || i(l);
    },
    [r]
  );
  return [a, o];
}
function hw(e, t, n) {
  const i = e.filter((o) => o !== t), r = i.indexOf(n);
  if (r === -1)
    return [...e];
  const a = e.indexOf(t) < e.indexOf(n) ? r + 1 : r;
  return i.splice(a, 0, t), i;
}
function pw(e) {
  const t = $e(() => e.data.map((te) => te.id), [e.data]), [n, i] = Jn(e.selectedIds, e.defaultSelectedIds ?? []), r = $e(() => new Set(n), [n]), [a, o] = Jn(e.expandedIds, e.defaultExpandedIds ?? []), l = $e(() => new Set(a), [a]), [u, c] = Jn(e.sort, e.defaultSort ?? null), [h, p] = Jn(e.filters, e.defaultFilters ?? {}), [m, g] = Jn(e.globalFilter, e.defaultGlobalFilter ?? ""), [b, v] = Jn(e.columnWidths, e.defaultColumnWidths ?? {}), [w, y] = Jn(e.page, e.defaultPage ?? 0), [I, E] = Jn(e.pageSize, e.defaultPageSize ?? 10), P = pe(
    (te) => y(te, e.onPageChange),
    [y, e.onPageChange]
  ), S = pe(
    (te) => {
      E(te, e.onPageSizeChange), y(0, e.onPageChange);
    },
    [E, y, e.onPageSizeChange, e.onPageChange]
  ), [f, C] = Ee(t), L = $e(() => {
    const te = e.order ?? f, _e = new Set(t), Te = te.filter((Ze) => _e.has(Ze)), Ye = new Set(Te), ot = t.filter((Ze) => !Ye.has(Ze));
    return [...Te, ...ot];
  }, [e.order, f, t]), F = e.order !== void 0, M = pe(
    (te) => {
      e.onRowReorder?.(te), F || C(te);
    },
    [e, F]
  ), [z, R] = Ee({ draggingId: null, overId: null }), [j, H] = Ee(null), [O, X] = Ee(""), K = pe((te) => R({ draggingId: te, overId: te }), []), se = pe((te) => R((_e) => _e.overId === te ? _e : { ..._e, overId: te }), []), Y = pe(
    (te) => {
      R((_e) => (te && _e.draggingId && _e.overId && _e.draggingId !== _e.overId && M(hw(L, _e.draggingId, _e.overId)), { draggingId: null, overId: null }));
    },
    [L, M]
  ), N = pe(
    (te) => {
      H((_e) => _e === te ? (X(`Dropped row at position ${L.indexOf(te) + 1} of ${L.length}.`), null) : (X("Picked up row. Use arrow keys to move, space to drop, escape to cancel."), te));
    },
    [L]
  ), ue = pe(
    (te) => {
      if (j === null)
        return;
      const _e = L.indexOf(j), Te = _e + te;
      if (Te < 0 || Te >= L.length)
        return;
      const Ye = [...L];
      Ye.splice(_e, 1), Ye.splice(Te, 0, j), M(Ye), X(`Moved row to position ${Te + 1} of ${L.length}.`);
    },
    [j, L, M]
  ), ie = pe(
    (te) => {
      const _e = new Set(r);
      _e.has(te) ? _e.delete(te) : _e.add(te), i([..._e], e.onSelectionChange);
    },
    [r, i, e.onSelectionChange]
  ), V = pe(
    (te) => {
      if (te.length === 0)
        return "none";
      const _e = te.filter((Te) => r.has(Te)).length;
      return _e === 0 ? "none" : _e === te.length ? "all" : "some";
    },
    [r]
  ), de = pe(
    (te) => {
      const _e = V(te) === "all", Te = new Set(r);
      _e ? te.forEach((Ye) => Te.delete(Ye)) : te.forEach((Ye) => Te.add(Ye)), i([...Te], e.onSelectionChange);
    },
    [V, r, i, e.onSelectionChange]
  ), Se = pe(
    (te, _e) => {
      const Te = new Set(l);
      _e ? Te.add(te) : Te.delete(te), o([...Te], e.onExpandedChange);
    },
    [l, o, e.onExpandedChange]
  ), W = pe(
    (te) => Se(te, !l.has(te)),
    [Se, l]
  ), q = pe(
    (te) => {
      let _e;
      u?.columnKey !== te ? _e = { columnKey: te, direction: "asc" } : u.direction === "asc" ? _e = { columnKey: te, direction: "desc" } : _e = null, c(_e, e.onSortChange);
    },
    [u, c, e.onSortChange]
  ), ne = pe(
    (te, _e) => {
      const Te = { ...h };
      _e === "" ? delete Te[te] : Te[te] = _e, p(Te, e.onFilterChange);
    },
    [h, p, e.onFilterChange]
  ), ee = pe(
    (te) => g(te, e.onGlobalFilterChange),
    [g, e.onGlobalFilterChange]
  ), ge = pe(
    (te, _e) => {
      v({ ...b, [te]: _e }, e.onColumnWidthsChange);
    },
    [b, v, e.onColumnWidthsChange]
  );
  return {
    selectedIds: r,
    expandedIds: l,
    sort: u,
    filters: h,
    globalFilter: m,
    columnWidths: b,
    order: L,
    dragState: z,
    keyboardDragId: j,
    liveMessage: O,
    page: w,
    pageSize: I,
    setPage: P,
    setPageSize: S,
    selectAllStateFor: V,
    toggleSelected: ie,
    toggleSelectAllFor: de,
    toggleExpanded: W,
    setExpanded: Se,
    cycleSort: q,
    setColumnFilter: ne,
    setGlobalFilter: ee,
    setColumnWidth: ge,
    beginDrag: K,
    dragOver: se,
    endDrag: Y,
    toggleKeyboardDrag: N,
    moveKeyboardDrag: ue
  };
}
function Yr(e, t) {
  return e.localeCompare(t, void 0, { sensitivity: "base", numeric: !0 });
}
function oc(e, t) {
  const n = Number.isNaN(e), i = Number.isNaN(t);
  return n && i ? 0 : n ? 1 : i ? -1 : e - t;
}
function dw(e) {
  switch (e) {
    case "text":
      return (t, n) => Yr(t.text, n.text);
    case "link":
      return (t, n) => Yr(t.text, n.text);
    case "number":
      return (t, n) => oc(t.value, n.value);
    case "boolean":
      return (t, n) => Number(t.value) - Number(n.value);
    case "date":
      return (t, n) => oc(xs(t.value), xs(n.value));
    case "badge":
      return (t, n) => Yr(t.text, n.text);
    case "list":
      return (t, n) => {
        const i = t.items, r = n.items, a = Yr(i[0] ?? "", r[0] ?? "");
        return a !== 0 ? a : i.length - r.length;
      };
    default:
      return () => 0;
  }
}
function Qa(e, t) {
  switch (e) {
    case "text":
      return ai(t.text, t.sub);
    case "link":
      return ai(t.text, t.label, t.sub);
    case "boolean": {
      const n = t;
      return ai(n.value ? n.trueLabel ?? "Yes" : n.falseLabel ?? "No", t.sub);
    }
    case "number": {
      const n = t;
      return ai(Op(n.value, n.format, n.locale), String(n.value), t.sub);
    }
    case "date":
      return ai(Bp(t), t.sub);
    case "badge":
      return ai(t.text, t.sub);
    case "list":
      return ai(t.items.join(" "), t.sub);
    default:
      return "";
  }
}
function ai(...e) {
  return e.filter((t) => t !== void 0 && t !== "").join(" ").toLowerCase();
}
function fw(e, t) {
  return t === "select" ? (n, i) => i === "" ? !0 : Qa(e, n) === i.toLowerCase() : (n, i) => i === "" ? !0 : Qa(e, n).includes(i.toLowerCase());
}
const mw = [5, 10, 25, 50];
function u5(e) {
  const {
    caption: t,
    columns: n,
    data: i,
    selectable: r = !1,
    // `sortable` is deliberately NOT destructured: DataTableProps documents it
    // as "Enable sorting globally", but no code path reads it — per-column
    // `isSortable` is the only switch that has any effect. Binding it here
    // just asserted otherwise. Wiring up the global gate is a behaviour
    // change, so it is left to the DataTable owners.
    draggable: a = !1,
    showGlobalFilter: o = !1,
    manualSort: l = !1,
    manualFilter: u = !1,
    manualPagination: c = !1,
    showRowExpandToggle: h = !0,
    topExpansion: p,
    topExpansionOpen: m = !1,
    topExpansionLabel: g,
    pagination: b = !1,
    pageSizeOptions: v = mw,
    summaryRow: w,
    minWidth: y,
    className: I
  } = e, E = at(), P = pw(e), S = $e(() => {
    if (y !== void 0)
      return {
        "--ns-datatable-min-width": typeof y == "number" ? `${y}px` : y
      };
  }, [y]), f = $e(() => i.some((O) => O.contextualMenu !== void 0), [i]), C = $e(() => i.some((O) => O.expandedContent !== void 0 && O.expandedContent !== null), [i]), L = r || a || f || C ? 1 : 0, F = L + n.length, M = $e(() => {
    const O = /* @__PURE__ */ new Map();
    for (const K of i)
      O.set(K.id, K);
    let X = P.order.map((K) => O.get(K)).filter((K) => K !== void 0);
    if (!u) {
      const K = P.globalFilter.trim().toLowerCase();
      X = X.filter((se) => {
        const Y = se;
        return n.every((ue) => {
          const ie = P.filters[ue.key];
          if (!ie)
            return !0;
          const V = Y[ue.key];
          return V ? (ue.filterPredicate ?? fw(ue.type, ue.filterType))(V, ie) : !1;
        }) ? K === "" ? !0 : n.some((ue) => {
          const ie = Y[ue.key];
          return ie ? Qa(ue.type, ie).includes(K) : !1;
        }) : !1;
      });
    }
    if (!l && P.sort) {
      const K = n.find((se) => se.key === P.sort.columnKey);
      if (K) {
        const se = K.sortComparator ?? dw(K.type), Y = P.sort.direction === "asc" ? 1 : -1;
        X = [...X].sort((N, ue) => {
          const ie = N[K.key], V = ue[K.key];
          return !ie || !V ? 0 : Y * se(ie, V);
        });
      }
    }
    return X;
  }, [i, n, P.order, P.filters, P.globalFilter, P.sort, u, l]), z = c ? e.totalRows ?? 0 : M.length, R = $e(() => {
    if (!b || c)
      return M;
    const O = P.page * P.pageSize;
    return M.slice(O, O + P.pageSize);
  }, [M, b, c, P.page, P.pageSize]), j = $e(() => R.map((O) => O.id), [R]), H = $e(
    () => ({
      selectedIds: P.selectedIds,
      expandedIds: P.expandedIds,
      sort: P.sort,
      filters: P.filters,
      globalFilter: P.globalFilter,
      columnWidths: P.columnWidths,
      dragState: P.dragState,
      keyboardDragId: P.keyboardDragId,
      selectAllState: P.selectAllStateFor(j),
      toggleSelected: P.toggleSelected,
      toggleSelectAll: () => P.toggleSelectAllFor(j),
      toggleExpanded: P.toggleExpanded,
      setExpanded: P.setExpanded,
      cycleSort: P.cycleSort,
      setColumnFilter: P.setColumnFilter,
      setGlobalFilter: P.setGlobalFilter,
      setColumnWidth: P.setColumnWidth,
      beginDrag: P.beginDrag,
      dragOver: P.dragOver,
      endDrag: P.endDrag,
      toggleKeyboardDrag: P.toggleKeyboardDrag,
      moveKeyboardDrag: P.moveKeyboardDrag,
      page: P.page,
      pageSize: P.pageSize,
      totalRows: z,
      setPage: P.setPage,
      setPageSize: P.setPageSize,
      pageSizeOptions: v,
      columns: n,
      selectable: r,
      draggable: a,
      hasRowMenus: f,
      showRowExpandToggle: h,
      leadingColumnCount: L,
      totalColumnCount: F,
      tableId: E,
      liveMessage: P.liveMessage,
      summaryRow: w
    }),
    [P, j, z, v, n, r, a, f, L, F, E, w]
  );
  return /* @__PURE__ */ _(Fp.Provider, { value: H, children: /* @__PURE__ */ B("div", { className: Q(fe["ns-datatable"], I), children: [
    o && /* @__PURE__ */ _(cw, {}),
    /* @__PURE__ */ B("div", { className: fe["ns-datatable__card"], children: [
      /* @__PURE__ */ _(
        "div",
        {
          className: fe["ns-datatable__scroll"],
          tabIndex: y === void 0 ? void 0 : 0,
          children: /* @__PURE__ */ B("table", { className: fe["ns-datatable__table"], style: S, children: [
            t && /* @__PURE__ */ _("caption", { className: fe["ns-datatable__caption"], children: t }),
            /* @__PURE__ */ B("colgroup", { children: [
              L > 0 && /* @__PURE__ */ _("col", { className: fe["ns-datatable__control-col"] }),
              n.map((O) => {
                const X = P.columnWidths[O.key], K = X !== void 0 ? `${X}px` : typeof O.width == "string" ? O.width : O.width !== void 0 ? `${O.width}px` : void 0;
                return /* @__PURE__ */ _("col", { style: K !== void 0 ? { width: K } : void 0 }, O.key);
              })
            ] }),
            /* @__PURE__ */ _(lw, {}),
            /* @__PURE__ */ _(
              rw,
              {
                rows: R,
                totalColumnCount: F,
                topExpansion: p,
                topExpansionOpen: m,
                topExpansionId: `${E}-top-expansion`,
                topExpansionLabel: g
              }
            )
          ] })
        }
      ),
      b && /* @__PURE__ */ _(uw, {})
    ] }),
    /* @__PURE__ */ _("div", { role: "status", "aria-live": "polite", className: fe["ns-datatable__sr-only"], children: P.liveMessage })
  ] }) });
}
const Hp = "__answer_later__";
function Bo(e) {
  return e === Hp;
}
function oi(e) {
  try {
    return decodeURIComponent(e);
  } catch {
    return console.warn("[ISM] Malformed percent-encoding in slot segment, showing raw text"), e;
  }
}
function gw(e, t) {
  const n = {};
  for (const [i, r] of Object.entries(e)) {
    const a = t.get(r.param);
    if (a === null) {
      "default" in r && (n[i] = r.default);
      continue;
    }
    switch (r.type) {
      case "string":
        n[i] = a;
        break;
      case "boolean":
        n[i] = a === "1";
        break;
      case "number":
        n[i] = parseFloat(a);
        break;
      case "options":
        n[i] = a.split("|").filter(Boolean).map((o) => {
          const l = o.indexOf(":");
          if (l === -1)
            return { id: o, label: o, value: o };
          const u = o.slice(0, l), c = o.slice(l + 1);
          return { id: u, label: u, value: c };
        });
        break;
      // EntityPicker-only variant of "options": "Label:value" parsing,
      // plus an optional third ":job_title" segment, for a BE-supplied
      // candidate list that needs to carry secondary info (see
      // ISMPropType's "entityOptions" doc). Kept separate from "options"
      // (shared with Select) so a legitimate value containing its own `:`
      // is never misparsed there.
      //
      // The backend percent-encodes every field (label/value/job_title)
      // before joining, precisely so none of them can contain a raw ":"
      // or "|" — that's what makes splitting on the first two literal
      // colons here unambiguous, not an assumption about the field
      // contents. `safeDecode` never throws: decodeURIComponent throws
      // on a malformed sequence (e.g. a stray "%"), which must not
      // escape parseISMParams' documented never-throws contract — fall
      // back to the raw (still-encoded) segment rather than crashing.
      case "entityOptions":
        n[i] = a.split("|").filter(Boolean).map((o) => {
          const l = o.indexOf(":");
          if (l === -1) {
            const g = oi(o);
            return { id: g, label: g, value: g };
          }
          const u = oi(o.slice(0, l)), c = o.slice(l + 1), h = c.indexOf(":");
          if (h === -1) {
            const g = oi(c);
            return { id: u, label: u, value: g };
          }
          const p = oi(c.slice(0, h)), m = oi(c.slice(h + 1));
          return {
            id: u,
            label: u,
            value: p,
            attributes: m ? { job_title: m } : void 0
          };
        });
        break;
      // "value:description" pairs → Record<string, string>, keyed by option
      // value (see ISMPropType's "descriptionMap" doc). Both halves are
      // percent-encoded by the producer, so the first literal ":" is an
      // unambiguous split point; `safeDecode` keeps the never-throws
      // contract for a malformed sequence. Entries without ":" are dropped.
      case "descriptionMap":
        n[i] = Object.fromEntries(
          a.split("|").filter(Boolean).flatMap((o) => {
            const l = o.indexOf(":");
            return l === -1 ? [] : [[oi(o.slice(0, l)), oi(o.slice(l + 1))]];
          })
        );
        break;
      case "fields":
        n[i] = a.split("|").filter(Boolean).map((o) => {
          const l = o.indexOf(":");
          if (l === -1)
            return { key: o, label: o };
          const u = o.slice(0, l), c = o.slice(l + 1);
          return { key: u, label: c };
        });
        break;
      // A set of scalar codes (e.g. MultiSelect's selected values), not a
      // single value — split on "," rather than "|" since these entries are
      // never themselves "Label:value" pairs (see ISMPropType's "stringList"
      // doc). Deduped here so a slot's seeded `value` and its ContextToken
      // open-time baseline are identical by construction.
      case "stringList":
        n[i] = Array.from(
          new Set(
            a.split(",").map((o) => o.trim()).filter(Boolean)
          )
        );
        break;
    }
  }
  return n;
}
const _w = "⟪LEN:", $p = "⟪/⟫", _a = [...$p].length;
function xa(e) {
  return [...e];
}
function Ts(e, t) {
  const n = xa(e), i = n.length, r = [], a = [];
  let o = "", l = 0;
  const u = () => {
    o && (r.push({ type: "text", content: o }), o = "");
  }, c = xa(_w), h = c.length;
  for (; l < i; ) {
    let p = l + h <= i;
    if (p) {
      for (let H = 0; H < h; H++)
        if (n[l + H] !== c[H]) {
          p = !1;
          break;
        }
    }
    if (!p) {
      o += n[l], l++;
      continue;
    }
    u();
    const m = l;
    l += h;
    let g = "";
    for (; l < i && n[l] !== "⟫"; ) {
      const H = n[l];
      if (H < "0" || H > "9") {
        a.push({
          position: m,
          message: `Non-digit character '${H}' inside LEN fence at position ${l}.`,
          raw: n.slice(m, l + 1).join("")
        }), l = m + h, g = "";
        break;
      }
      g += H, l++;
    }
    if (!g) {
      l < i && n[l] === "⟫" && l++;
      continue;
    }
    if (l >= i || n[l] !== "⟫") {
      a.push({
        position: m,
        message: `Opening fence at position ${m} has no closing ⟫.`,
        raw: n.slice(m, l).join("")
      });
      continue;
    }
    l++;
    const b = parseInt(g, 10);
    if (l + b > i) {
      a.push({
        position: m,
        message: `Payload at position ${m} is shorter than declared length ${b}.`,
        raw: n.slice(m, i).join("")
      });
      continue;
    }
    const w = n.slice(l, l + b).join("");
    if (l += b, w.includes("⟪") || w.includes("⟫")) {
      a.push({
        position: m,
        message: `Payload at position ${m} contains illegal fence characters.`,
        raw: w
      });
      continue;
    }
    const y = xa($p);
    let I = l + _a <= i;
    if (I) {
      for (let H = 0; H < _a; H++)
        if (n[l + H] !== y[H]) {
          I = !1;
          break;
        }
    }
    if (!I) {
      a.push({
        position: m,
        message: `Expected closing fence ⟪/⟫ at position ${l} but found something else.`,
        raw: w
      }), l = m + h;
      continue;
    }
    l += _a;
    const E = w.indexOf("?"), P = E === -1 ? w : w.slice(0, E), S = E === -1 ? "" : w.slice(E + 1);
    if (!(P in t)) {
      console.warn(`[ISM] Unknown component "${P}" — slot ignored.`);
      continue;
    }
    const f = t[P], C = new URLSearchParams(S), L = C.get("source") ?? void 0, F = C.get("status"), M = F === "clear" || F === "unclear" || F === "invalid" ? F : void 0, z = C.get("interactive"), R = z === null ? void 0 : z !== "0", j = gw(f.spec, C);
    r.push({ type: "slot", componentName: P, props: j, source: L, status: M, interactive: R, rawQuery: S });
  }
  return u(), { nodes: r, errors: a };
}
function c5(e, t) {
  const { errors: n } = Ts(e, t);
  return { valid: n.length === 0, errors: n };
}
function xw(e, t) {
  const n = new URLSearchParams();
  for (const [o, l] of Object.entries(t))
    typeof l == "boolean" ? n.set(o, l ? "1" : "0") : n.set(o, String(l));
  const i = n.toString(), r = i ? `${e}?${i}` : e;
  return `⟪LEN:${[...r].length}⟫${r}⟪/⟫`;
}
function ya(e) {
  return typeof e == "boolean" ? e ? "1" : "0" : Array.isArray(e) ? e.map((t) => String(t)).join(",") : String(e);
}
function yw(e) {
  return !!e && typeof e == "object" && "value" in e;
}
function h5(e, t, n) {
  const { nodes: i } = Ts(e, t);
  return i.map((r) => {
    if (r.type === "text")
      return r.content;
    const a = r.props.name, o = typeof a == "string" ? a : "", l = Object.fromEntries(new URLSearchParams(r.rawQuery ?? ""));
    if (o in n) {
      const u = n[o];
      yw(u) ? (l.value = ya(u.value), "label" in u && (l.selectedLabel = ya(u.label))) : l.value = ya(u), l.status = "clear";
    }
    return xw(r.componentName, l);
  }).join("");
}
function bw(e) {
  return e.length === 0 ? "" : e.length === 1 ? e[0] ?? "" : e.length === 2 ? `${e[0]} and ${e[1]}` : `${e.slice(0, -1).join(", ")}, and ${e[e.length - 1]}`;
}
const qp = Cr(null);
function hn() {
  const e = Oi(qp);
  if (!e)
    throw new Error(
      "[ISM] useISMForm() must be used inside an <ISMFormProvider>. Wrap your ISMR or slot components in an ISMFormProvider."
    );
  return e;
}
function vw({ children: e, onSubmit: t, onSearch: n, validate: i }) {
  const [r, a] = Ee({}), [o, l] = Ee({}), [u, c] = Ee({}), h = re(/* @__PURE__ */ new Map()), p = re({}), m = pe((y, I, E) => {
    p.current = { ...p.current, [y]: I }, a((f) => ({ ...f, [y]: I })), E?.seed || c((f) => f[y] ? f : { ...f, [y]: !0 });
    const P = h.current.get(y);
    let S = P ? P(I) : null;
    !S && i && (S = i(y, I, p.current)), l((f) => ({ ...f, [y]: S }));
  }, [i]), g = pe((y, I) => (h.current.set(y, I), () => {
    h.current.delete(y);
  }), []), b = pe(() => {
    const y = p.current, I = {};
    let E = !1;
    for (const [P, S] of h.current) {
      let f = S(y[P] ?? null);
      !f && i && (f = i(P, y[P] ?? null, y)), I[P] = f, f !== null && (E = !0);
    }
    l(I), E || t(y);
  }, [t, i]), v = pe(
    async (y, I, E) => n ? n(y, I, E) : (console.warn(`[ISM] EntityPicker (kind="${y}") called onSearch but none was provided to ISMFormProvider.`), []),
    [n]
  ), w = {
    values: r,
    errors: o,
    touched: u,
    setValue: m,
    registerValidator: g,
    submit: b,
    onSearch: v
  };
  return /* @__PURE__ */ _(qp.Provider, { value: w, children: e });
}
const ww = {
  contained: lt.Contained,
  outlined: lt.Outlined,
  text: lt.Text
}, kw = {
  primary: Re.Primary,
  secondary: Re.Secondary
};
function Cw({
  name: e,
  label: t,
  value: n,
  variant: i = "outlined",
  color: r = "primary",
  disabled: a = !1
}) {
  const { setValue: o, submit: l } = hn();
  return /* @__PURE__ */ _(
    st,
    {
      text: t,
      variant: ww[i] ?? lt.Outlined,
      color: kw[r] ?? Re.Primary,
      size: Mt.Small,
      onClick: () => {
        o(e, n ?? t), l();
      },
      disabled: a
    }
  );
}
const lc = {
  "ns-button-group-slot": "_ns-button-group-slot_ygfxr_1",
  "ns-button-group-slot__error": "_ns-button-group-slot__error_ygfxr_46"
};
function Sw(e) {
  return e.split("|").filter(Boolean).map((t) => {
    const n = t.indexOf(":");
    return n === -1 ? { label: t, value: t } : { label: t.slice(0, n), value: t.slice(n + 1) };
  });
}
function Ew({
  name: e,
  options: t,
  required: n = !1,
  autoSubmit: i = !0,
  label: r = "",
  disabled: a = !1
}) {
  const { values: o, errors: l, setValue: u, registerValidator: c, submit: h } = hn(), p = `${at()}-error`, m = l[e];
  ve(() => c(e, (b) => n && !b ? "Please select an option." : null), [e, n, c]);
  const g = Sw(t);
  return /* @__PURE__ */ B(Ke, { children: [
    /* @__PURE__ */ _(
      "div",
      {
        className: lc["ns-button-group-slot"],
        role: "group",
        "aria-label": r === "" ? e : r,
        "aria-describedby": m ? p : void 0,
        children: g.map((b) => {
          const v = !i && o[e] === b.value;
          return /* @__PURE__ */ _(
            st,
            {
              variant: v ? lt.Contained : lt.Outlined,
              "aria-pressed": i ? void 0 : v,
              size: Mt.Small,
              onClick: () => {
                u(e, b.value), i && h();
              },
              text: b.label,
              disabled: a
            },
            b.value
          );
        })
      }
    ),
    m ? /* @__PURE__ */ _("p", { id: p, role: "alert", className: lc["ns-button-group-slot__error"], children: m }) : null
  ] });
}
const Aw = {
  auto: we.Auto,
  full: we.Full,
  sm: we.Small,
  md: we.Medium,
  lg: we.Large
};
function Iw({
  name: e,
  label: t,
  required: n = !1,
  disabled: i = !1,
  width: r = "auto"
}) {
  const { values: a, setValue: o, registerValidator: l } = hn();
  ve(() => l(e, (c) => n && !c ? `${t} must be checked.` : null), [e, t, n, l]);
  const u = !!a[e];
  return /* @__PURE__ */ _(
    $i,
    {
      id: `ism-field-${e}`,
      label: t,
      checked: u,
      size: Hi.Medium,
      onChange: (c) => o(e, c),
      disabled: i,
      width: Aw[r] ?? we.Auto
    }
  );
}
const uc = {
  "ns-date-picker-calendar-slot--width-full": "_ns-date-picker-calendar-slot--width-full_wyc3y_1",
  "ns-date-picker-calendar-slot--width-sm": "_ns-date-picker-calendar-slot--width-sm_wyc3y_4",
  "ns-date-picker-calendar-slot--width-md": "_ns-date-picker-calendar-slot--width-md_wyc3y_7",
  "ns-date-picker-calendar-slot--width-lg": "_ns-date-picker-calendar-slot--width-lg_wyc3y_10"
}, Lw = {
  contained: lt.Contained,
  outlined: lt.Outlined,
  text: lt.Text
}, Pw = {
  primary: Re.Primary,
  secondary: Re.Secondary
};
function cc(e) {
  if (e) {
    const n = e.split("-").map(Number);
    if (n[0] && n[1])
      return { year: n[0], month: n[1] - 1 };
  }
  const t = /* @__PURE__ */ new Date();
  return { year: t.getFullYear(), month: t.getMonth() };
}
function Up({
  name: e,
  label: t,
  required: n = !1,
  minDate: i,
  maxDate: r,
  disabled: a,
  autoSubmit: o = !0,
  answerLater: l = !1,
  answerLaterLabel: u = "Answer later",
  answerLaterPrefix: c,
  answerLaterSuffix: h,
  answerLaterVariant: p = "text",
  answerLaterColor: m = "primary",
  value: g,
  width: b = "auto"
}) {
  const { values: v, errors: w, setValue: y, registerValidator: I, submit: E } = hn();
  ve(() => I(e, (R) => n && !R ? `${t} is required.` : null), [e, t, n, I]), ve(() => {
    v[e] === void 0 && g !== void 0 && y(e, g, { seed: !0 });
  }, [e, g, v, y]);
  const P = v[e] ?? null, S = Bo(P) ? null : P, f = w[e], [C, L] = Ee(() => cc(S));
  ve(() => {
    S && L(cc(S));
  }, [S]);
  const F = () => L((R) => R.month === 0 ? { year: R.year - 1, month: 11 } : { year: R.year, month: R.month - 1 }), M = () => L((R) => R.month === 11 ? { year: R.year + 1, month: 0 } : { year: R.year, month: R.month + 1 }), z = (R) => L((j) => ({ ...j, year: R }));
  return /* @__PURE__ */ B(
    "div",
    {
      className: Q(
        uc["ns-date-picker-calendar-slot"],
        b !== "auto" && uc[`ns-date-picker-calendar-slot--width-${b}`]
      ),
      children: [
        /* @__PURE__ */ _(
          Sc,
          {
            id: `ism-calendar-${e}`,
            selectedIso: S,
            calState: C,
            minDate: i,
            maxDate: r,
            onSelectDay: (R) => {
              y(e, R), o && E();
            },
            onPrevMonth: F,
            onNextMonth: M,
            onSelectYear: z,
            disabled: a
          }
        ),
        l && /* @__PURE__ */ _(
          st,
          {
            text: u,
            prefix: c,
            suffix: h,
            variant: Lw[p] ?? lt.Text,
            color: Pw[m] ?? Re.Primary,
            size: Mt.Small,
            disabled: a,
            onClick: () => {
              y(e, Hp), o && E();
            }
          }
        ),
        f && /* @__PURE__ */ _("p", { role: "alert", style: { margin: "4px 0 0", fontSize: "12px", color: "var(--ns-color-red-500, #ef4444)" }, children: f })
      ]
    }
  );
}
const Tw = {
  auto: we.Auto,
  full: we.Full,
  sm: we.Small,
  md: we.Medium,
  lg: we.Large
};
function p5({
  disabled: e,
  name: t,
  label: n,
  required: i = !1,
  minDate: r,
  maxDate: a,
  width: o = "auto"
}) {
  const { values: l, errors: u, setValue: c, registerValidator: h } = hn();
  ve(() => h(t, (b) => i && !b ? `${n} is required.` : null), [t, n, i, h]);
  const p = l[t] ?? null, m = u[t], g = m ? Ne.Error : Ne.Default;
  return /* @__PURE__ */ _(
    co,
    {
      id: `ism-field-${t}`,
      name: t,
      label: n,
      required: i,
      value: p,
      onChange: (b) => c(t, b),
      state: g,
      hint: m ?? void 0,
      size: kt.Small,
      minDate: r,
      maxDate: a,
      disabled: e,
      width: Tw[o] ?? we.Auto
    }
  );
}
const Nw = {
  auto: we.Auto,
  full: we.Full,
  sm: we.Small,
  md: we.Medium,
  lg: we.Large
};
function hc(e, t) {
  const n = t.map((i) => e.attributes?.[i.key]).filter((i) => typeof i == "string" && i.length > 0).join(", ");
  return {
    id: e.id,
    label: e.label,
    value: e,
    description: n || void 0
  };
}
function Dw({
  name: e,
  label: t,
  kind: n,
  endpoint: i,
  required: r = !1,
  placeholder: a,
  disabled: o,
  autoSubmit: l = !0,
  infoFields: u = [],
  value: c,
  selectedLabel: h,
  options: p = [],
  width: m = "auto"
}) {
  const { values: g, errors: b, setValue: v, registerValidator: w, submit: y, onSearch: I } = hn();
  ve(() => w(e, (L) => r && !L ? `${t} is required.` : null), [e, t, r, w]), ve(() => {
    g[e] === void 0 && c !== void 0 && v(
      e,
      {
        id: c,
        label: h ?? c,
        value: c
      },
      { seed: !0 }
    );
  }, [e, c, h, g, v]);
  const E = pe(
    async (L) => (await I(n ?? e, L, i)).map((M) => hc(M, u)),
    [n, e, i, I, u]
  ), P = g[e] ?? null, S = b[e], f = S ? Ne.Error : Ne.Default, C = $e(
    () => p.map(
      (L) => hc(
        {
          id: L.value,
          label: L.label,
          value: L.value,
          attributes: L.attributes
        },
        u
      )
    ),
    [p, u]
  );
  return /* @__PURE__ */ _(
    po,
    {
      disabled: o,
      id: `ism-field-${e}`,
      name: e,
      label: t,
      required: r,
      placeholder: a,
      value: P,
      onChange: (L) => {
        v(e, L), l && y();
      },
      onSearch: E,
      getOptionLabel: (L) => L.label,
      initialOptions: C,
      state: f,
      hint: S ?? void 0,
      size: kt.Small,
      width: Nw[m] ?? we.Auto
    }
  );
}
const Qr = {
  "ns-multi-select-slot": "_ns-multi-select-slot_ds7w4_1",
  "ns-multi-select-slot--width-full": "_ns-multi-select-slot--width-full_ds7w4_6",
  "ns-multi-select-slot--width-sm": "_ns-multi-select-slot--width-sm_ds7w4_9",
  "ns-multi-select-slot--width-md": "_ns-multi-select-slot--width-md_ds7w4_12",
  "ns-multi-select-slot--width-lg": "_ns-multi-select-slot--width-lg_ds7w4_15",
  "ns-multi-select-slot__list": "_ns-multi-select-slot__list_ds7w4_18",
  "ns-multi-select-slot__error": "_ns-multi-select-slot__error_ds7w4_23"
};
function Jp(e, t) {
  return t ? e.map((n) => {
    const i = Object.prototype.hasOwnProperty.call(t, n.value) ? t[n.value] : void 0;
    return n.description !== void 0 || !i ? n : { ...n, description: i };
  }) : e;
}
const Vw = [];
function Mw({
  name: e,
  label: t,
  options: n,
  optionDescriptions: i,
  required: r = !1,
  placeholder: a,
  disabled: o,
  value: l,
  minSelections: u,
  minSelectionsHint: c,
  width: h = "auto"
}) {
  const { values: p, errors: m, setValue: g, registerValidator: b } = hn(), [v, w] = Ee(""), [y, I] = Ee(!1), E = re(null), P = at();
  ve(() => b(e, (Y) => {
    const N = Array.isArray(Y) ? Y : [], ue = n.filter((ie) => N.includes(ie.value)).length;
    return r && ue === 0 ? `${t} is required.` : u && ue < u ? c ?? `Select at least ${u}.` : null;
  }), [e, t, r, u, c, n, b]), ve(() => {
    p[e] === void 0 && l !== void 0 && g(e, l, { seed: !0 });
  }, [e, l, p, g]);
  const S = Array.isArray(p[e]) ? p[e] : Vw, f = m[e], C = $e(
    () => n.filter((Y) => S.includes(Y.value)).map((Y) => Y.id),
    [n, S]
  ), L = $e(() => o || !u || u <= 0 || C.length > u ? /* @__PURE__ */ new Set() : new Set(C), [o, u, C]), F = $e(
    () => Jp(n, i),
    [n, i]
  ), M = oo(F, v, !0), z = c ?? `Select at least ${u}.`, R = $e(
    () => M.map((Y) => o ? { ...Y, disabled: !0 } : L.has(Y.id) ? {
      ...Y,
      disabled: !0,
      description: Y.description ? `${Y.description} — ${z}` : z
    } : Y),
    [M, o, L, z]
  ), j = (Y) => {
    if (Y.disabled)
      return;
    const N = S.includes(Y.value) ? S.filter((ue) => ue !== Y.value) : [...S, Y.value];
    g(
      e,
      n.filter((ue) => N.includes(ue.value)).map((ue) => ue.value)
    );
  }, { activeId: H, clearActiveId: O, handleInputKeyDown: X, onOptionRef: K } = Er({
    options: R,
    // The list has no separate open/closed state of its own — it's always
    // visible inside the token's popover panel, which is the thing that
    // opens/closes. onOpen/onClose are effectively unreachable no-ops.
    isOpen: !0,
    onOpen: () => {
    },
    onClose: () => {
    },
    onSelect: j
  }), se = t.length > 0 ? t : a ?? "Filter options";
  return /* @__PURE__ */ B(
    "div",
    {
      className: Q(
        Qr["ns-multi-select-slot"],
        h !== "auto" && Qr[`ns-multi-select-slot--width-${h}`]
      ),
      children: [
        /* @__PURE__ */ _(
          Bn,
          {
            isFocused: y,
            disabled: o,
            state: f ? Ne.Error : Ne.Default,
            size: kt.Small,
            prefix: J.Search,
            inputRef: E,
            children: /* @__PURE__ */ _(
              zn,
              {
                ref: E,
                id: `ism-field-${e}`,
                value: v,
                placeholder: a ?? "Search…",
                type: ct.Search,
                disabled: o,
                role: "combobox",
                ariaLabel: se,
                ariaExpanded: !0,
                ariaControls: P,
                ariaActivedescendant: H ?? void 0,
                ariaInvalid: !!f,
                autoComplete: "off",
                onChange: w,
                onFocus: () => I(!0),
                onBlur: () => I(!1),
                onKeyDown: X
              }
            )
          }
        ),
        /* @__PURE__ */ _("div", { className: Qr["ns-multi-select-slot__list"], children: /* @__PURE__ */ _(
          Ar,
          {
            id: P,
            options: R,
            selectedIds: C,
            activeId: H,
            mode: "multi",
            ariaLabel: se,
            emptyText: "No matching options",
            onActivate: (Y) => {
              j(Y), O();
            },
            onOptionRef: K
          }
        ) }),
        f && /* @__PURE__ */ _("p", { role: "alert", className: Qr["ns-multi-select-slot__error"], children: f })
      ]
    }
  );
}
const Fw = {
  auto: we.Auto,
  full: we.Full,
  sm: we.Small,
  md: we.Medium,
  lg: we.Large
};
function Rw({
  name: e,
  label: t,
  options: n,
  optionDescriptions: i,
  required: r = !1,
  placeholder: a,
  disabled: o,
  autoSubmit: l = !0,
  value: u,
  width: c = "auto"
}) {
  const { values: h, errors: p, setValue: m, registerValidator: g, submit: b } = hn(), v = $e(
    () => Jp(n, i),
    [n, i]
  );
  ve(() => g(e, (E) => r && !E ? `${t} is required.` : null), [e, t, r, g]), ve(() => {
    h[e] === void 0 && u !== void 0 && m(e, u, { seed: !0 });
  }, [e, u, h, m]);
  const w = h[e] ?? null, y = p[e], I = y ? Ne.Error : Ne.Default;
  return /* @__PURE__ */ _(
    ao,
    {
      disabled: o,
      id: `ism-field-${e}`,
      name: e,
      label: t,
      options: v,
      required: r,
      placeholder: a,
      value: w,
      onChange: (E) => {
        m(e, E), l && b();
      },
      state: I,
      hint: y ?? void 0,
      size: kt.Small,
      width: Fw[c] ?? we.Auto
    }
  );
}
const Ow = {
  "ns-animated-aries-icon": "_ns-animated-aries-icon_6az0b_11"
};
function Wp({ size: e = 20, className: t }) {
  return /* @__PURE__ */ _(ke, { name: J.ARIES, size: e, className: Q(Ow["ns-animated-aries-icon"], t) });
}
const pc = {
  "spinner-slot": "_spinner-slot_tpxx7_1",
  "spinner-slot__text": "_spinner-slot__text_tpxx7_11"
};
function Xp({ text: e = "Thinking…", minHeight: t }) {
  return /* @__PURE__ */ B(
    "div",
    {
      className: pc["spinner-slot"],
      style: t ? { minHeight: t } : void 0,
      role: "status",
      "aria-live": "polite",
      children: [
        /* @__PURE__ */ _(Wp, { size: 40 }),
        /* @__PURE__ */ _("span", { className: pc["spinner-slot__text"], children: e })
      ]
    }
  );
}
const Bw = {
  text: ct.Text,
  email: ct.Email,
  number: ct.Number
}, zw = {
  auto: we.Auto,
  full: we.Full,
  sm: we.Small,
  md: we.Medium,
  lg: we.Large
};
function jw({
  name: e,
  label: t,
  placeholder: n,
  required: i = !1,
  inputType: r = "text",
  disabled: a,
  width: o = "auto"
}) {
  const { values: l, errors: u, setValue: c, registerValidator: h, submit: p } = hn();
  ve(() => h(e, (w) => i && (!w || String(w).trim() === "") ? `${t} is required.` : null), [e, t, i, h]);
  const m = l[e] ?? "", g = u[e], b = g ? Ne.Error : Ne.Default, v = (w) => {
    w.key === "Enter" && !a && (w.preventDefault(), p());
  };
  return /* @__PURE__ */ _(
    Ni,
    {
      disabled: a,
      id: `ism-field-${e}`,
      name: e,
      label: t,
      placeholder: n,
      required: i,
      value: m,
      onChange: (w) => c(e, w),
      onKeyDown: v,
      state: b,
      hint: g ?? void 0,
      size: kt.Small,
      inputType: Bw[r] ?? ct.Text,
      width: zw[o] ?? we.Auto
    }
  );
}
const Hw = {
  auto: we.Auto,
  full: we.Full,
  sm: we.Small,
  md: we.Medium,
  lg: we.Large
};
function $w({
  name: e,
  label: t,
  required: n = !1,
  minTime: i,
  maxTime: r,
  disabled: a,
  width: o = "auto"
}) {
  const { values: l, errors: u, setValue: c, registerValidator: h } = hn();
  ve(() => h(e, (b) => n && !b ? `${t} is required.` : null), [e, t, n, h]);
  const p = l[e] ?? null, m = u[e], g = m ? Ne.Error : Ne.Default;
  return /* @__PURE__ */ _(
    ho,
    {
      id: `ism-field-${e}`,
      disabled: a,
      name: e,
      label: t,
      required: n,
      value: p,
      onChange: (b) => c(e, b),
      state: g,
      hint: m ?? void 0,
      size: kt.Small,
      minTime: i,
      maxTime: r,
      width: Hw[o] ?? we.Auto
    }
  );
}
const qw = {
  TextField: {
    Component: jw,
    spec: {
      name: { param: "name", type: "string", default: "" },
      label: { param: "label", type: "string", default: "" },
      placeholder: { param: "placeholder", type: "string" },
      required: { param: "required", type: "boolean", default: !1 },
      // The ISM param is "type" but the React prop is "inputType" to avoid
      // collision with the HTML `type` attribute forwarded by the input component.
      inputType: { param: "type", type: "string", default: "text" },
      disabled: { param: "disabled", type: "boolean", default: !1 },
      width: { param: "width", type: "string", default: "auto" }
    }
  },
  Checkbox: {
    Component: Iw,
    spec: {
      name: { param: "name", type: "string", default: "" },
      label: { param: "label", type: "string", default: "" },
      required: { param: "required", type: "boolean", default: !1 },
      disabled: { param: "disabled", type: "boolean", default: !1 },
      width: { param: "width", type: "string", default: "auto" }
    }
  },
  DatePicker: {
    Component: Up,
    spec: {
      name: { param: "name", type: "string", default: "" },
      label: { param: "label", type: "string", default: "" },
      required: { param: "required", type: "boolean", default: !1 },
      minDate: { param: "minDate", type: "string" },
      maxDate: { param: "maxDate", type: "string" },
      disabled: { param: "disabled", type: "boolean", default: !1 },
      // answerLater: renders an extra button under the calendar that submits
      // the ANSWER_LATER_VALUE sentinel instead of a date (see answerLater.ts).
      // autoSubmit is deliberately still absent from this spec — decoded
      // instances always auto-submit.
      answerLater: { param: "answerLater", type: "boolean", default: !1 },
      answerLaterLabel: { param: "answerLaterLabel", type: "string", default: "Answer later" },
      // Styling for the answer-later button, fully ISM-controllable (same
      // conventions as the Button slot). Prefix/suffix take IconName string
      // values (e.g. "calendar-today").
      answerLaterPrefix: { param: "answerLaterPrefix", type: "string" },
      answerLaterSuffix: { param: "answerLaterSuffix", type: "string" },
      answerLaterVariant: { param: "answerLaterVariant", type: "string", default: "text" },
      answerLaterColor: { param: "answerLaterColor", type: "string", default: "primary" },
      // value: pre-selected ISO date. Seeds ISMFormContext on mount so the
      // calendar renders with a day already selected.
      value: { param: "value", type: "string" },
      // width only constrains the slot's outer wrapper — the calendar grid
      // keeps its intrinsic ~240-280px sizing regardless of this value.
      width: { param: "width", type: "string", default: "auto" }
    }
  },
  // we need to keep this as a way to quickly-toggle these two types...
  // {
  //   Component: DatePickerSlot,
  //   spec: {
  //     name:     { param: "name",     type: "string",  default: "" },
  //     label:    { param: "label",    type: "string",  default: "" },
  //     required: { param: "required", type: "boolean", default: false },
  //     minDate:  { param: "minDate",  type: "string" },
  //     maxDate:  { param: "maxDate",  type: "string" },
  //     disabled: { param: "disabled", type: "boolean", default: false },
  //   },
  // },
  Select: {
    Component: Rw,
    spec: {
      name: { param: "name", type: "string", default: "" },
      label: { param: "label", type: "string", default: "" },
      required: { param: "required", type: "boolean", default: !1 },
      // "options" is a pipe-separated list: "Label|Label:value|..."
      // Parsed into { id, label, value }[] by the "options" type parser.
      options: { param: "options", type: "options", default: [] },
      // optionDescriptions: "value:description|..." — an optional secondary
      // line per option value, rendered under the option's label.
      optionDescriptions: { param: "optionDescriptions", type: "descriptionMap", default: {} },
      placeholder: { param: "placeholder", type: "string" },
      disabled: { param: "disabled", type: "boolean", default: !1 },
      // value: pre-selected option value, matched against `options[].value`.
      // Seeds ISMFormContext on mount so the Select renders pre-filled.
      value: { param: "value", type: "string" },
      width: { param: "width", type: "string", default: "auto" }
    }
  },
  // A set of option values rather than one — checked/unchecked via a
  // searchable checkbox list, no chips (LOA-1332). Unlike every other slot
  // here, this one never submits itself; it's only ever used inside a
  // ContextToken with `submitOnClose`, which submits once when the popover
  // closes rather than on every checkbox toggle. See MultiSelectSlot's
  // docstring for why, and ContextPrompt's SUBMIT_ON_CLOSE_COMPONENTS.
  MultiSelect: {
    Component: Mw,
    spec: {
      name: { param: "name", type: "string", default: "" },
      label: { param: "label", type: "string", default: "" },
      required: { param: "required", type: "boolean", default: !1 },
      // "options" is the same pipe-separated "Label:value" list Select
      // uses — one option per entry, not the selection.
      options: { param: "options", type: "options", default: [] },
      // optionDescriptions: same "value:description|..." map Select uses —
      // the always-visible secondary line under each option.
      optionDescriptions: { param: "optionDescriptions", type: "descriptionMap", default: {} },
      placeholder: { param: "placeholder", type: "string" },
      disabled: { param: "disabled", type: "boolean", default: !1 },
      // value: comma-separated selected option values. Seeds
      // ISMFormContext on mount as a string[] via the "stringList" type —
      // see ISMPropType's doc for why "," rather than Select's "|".
      value: { param: "value", type: "stringList" },
      // minSelections: floor below which a selected option can't be
      // unchecked. No maximum counterpart exists yet — add one the same
      // way if a future ticket needs it.
      minSelections: { param: "minSelections", type: "number" },
      minSelectionsHint: { param: "minSelectionsHint", type: "string" },
      width: { param: "width", type: "string", default: "auto" }
    }
  },
  TimePicker: {
    Component: $w,
    spec: {
      name: { param: "name", type: "string", default: "" },
      label: { param: "label", type: "string", default: "" },
      required: { param: "required", type: "boolean", default: !1 },
      minTime: { param: "minTime", type: "string" },
      maxTime: { param: "maxTime", type: "string" },
      disabled: { param: "disabled", type: "boolean", default: !1 },
      width: { param: "width", type: "string", default: "auto" }
    }
  },
  EntityPicker: {
    Component: Dw,
    spec: {
      name: { param: "name", type: "string", default: "" },
      label: { param: "label", type: "string", default: "" },
      // kind: semantic entity type, e.g. "employee", "department".
      // Passed to ISMFormProvider.onSearch so the host can route to the
      // correct data source. Falls back to `name` inside EntityPickerSlot
      // when not provided.
      kind: { param: "kind", type: "string" },
      // endpoint: optional REST endpoint override. When present, the host
      // may use this URL directly instead of resolving from `kind`.
      endpoint: { param: "endpoint", type: "string" },
      required: { param: "required", type: "boolean", default: !1 },
      placeholder: { param: "placeholder", type: "string" },
      disabled: { param: "disabled", type: "boolean", default: !1 },
      // options: pipe-separated "Label:value[:job_title]" entries — a
      // BE-supplied candidate list shown immediately, with no search needed
      // (e.g. resolving an ambiguous employee-name match to a handful of
      // candidates). Uses the EntityPicker-only "entityOptions" type (NOT
      // the "options" type shared with Select) so its optional third
      // job_title segment can never be misparsed against a Select/
      // ButtonGroup value that legitimately contains its own ":". Parsed
      // into { id, label, value, attributes? }[]; EntityPickerSlot remaps
      // each into the ISMEntityOption shape below.
      options: { param: "options", type: "entityOptions", default: [] },
      // fields: pipe-separated "key:Label" entries declaring which entity
      // attributes to surface as secondary info under each search result
      // (e.g. "employee_id:Employee ID|job_title:Job Title"). Mirrors how
      // EntityViewer/EntityEditor declare columns/fields, just carried over
      // the ISM string. Parsed into { key, label }[] by the "fields" type.
      infoFields: { param: "fields", type: "fields", default: [] },
      // value: pre-selected entity's value (e.g. an Employee ID). Paired
      // with `selectedLabel` to seed ISMFormContext on mount so the picker
      // renders with an entity already selected, without a live search.
      value: { param: "value", type: "string" },
      // selectedLabel: display label for the pre-selected entity above.
      selectedLabel: { param: "selectedLabel", type: "string" },
      width: { param: "width", type: "string", default: "auto" }
    }
  },
  Button: {
    Component: Cw,
    spec: {
      name: { param: "name", type: "string", default: "" },
      label: { param: "label", type: "string", default: "" },
      value: { param: "value", type: "string" },
      variant: { param: "variant", type: "string" },
      color: { param: "color", type: "string" },
      disabled: { param: "disabled", type: "boolean", default: !1 }
    }
  },
  ButtonGroup: {
    Component: Ew,
    // Renders directly below the prose in ContextPrompt (never behind a
    // ContextToken popover) — its options must be immediately visible.
    inline: !0,
    spec: {
      name: { param: "name", type: "string", default: "" },
      // options is kept as a raw string; ButtonGroupSlot parses label:value
      // pairs internally (same format as Select, but deferred to the component
      // so the component can maintain its own selected-state rendering).
      options: { param: "options", type: "string", default: "" },
      required: { param: "required", type: "boolean", default: !1 },
      // autoSubmit defaults to true — set autoSubmit=0 in ISM to disable.
      autoSubmit: { param: "autoSubmit", type: "boolean", default: !0 },
      // The group's accessible name (the question it answers). Without it the
      // group is named by `name`, which is an identifier, not words.
      label: { param: "label", type: "string", default: "" },
      disabled: { param: "disabled", type: "boolean", default: !1 }
    }
  },
  Spinner: {
    Component: Xp,
    spec: {
      text: { param: "text", type: "string", default: "Thinking…" }
    },
    // Renders alone, centered — never as an inline token. See
    // ISMComponentDefinition.standalone.
    standalone: !0
  }
}, d5 = {
  ...qw,
  DatePicker: {
    Component: Up,
    spec: {
      name: { param: "name", type: "string", default: "" },
      label: { param: "label", type: "string", default: "" },
      required: { param: "required", type: "boolean", default: !1 },
      minDate: { param: "minDate", type: "string" },
      maxDate: { param: "maxDate", type: "string" },
      disabled: { param: "disabled", type: "boolean", default: !1 },
      answerLater: { param: "answerLater", type: "boolean", default: !1 },
      answerLaterLabel: { param: "answerLaterLabel", type: "string", default: "Answer later" },
      answerLaterPrefix: { param: "answerLaterPrefix", type: "string" },
      answerLaterSuffix: { param: "answerLaterSuffix", type: "string" },
      answerLaterVariant: { param: "answerLaterVariant", type: "string", default: "text" },
      answerLaterColor: { param: "answerLaterColor", type: "string", default: "primary" },
      value: { param: "value", type: "string" },
      width: { param: "width", type: "string", default: "auto" }
    }
  }
}, ba = {
  "ns-formatted-text": "_ns-formatted-text_agcni_1",
  "ns-formatted-text__list": "_ns-formatted-text__list_agcni_16"
}, Uw = /\[([^\]\n]+)\]\((https?:\/\/[^\s<>"')]+)\)|https?:\/\/[^\s<>"']+/gi, Jw = ".,;:!?", Ww = { ")": "(", "]": "[", "}": "{" };
function dc(e, t) {
  return e.split(t).length - 1;
}
function fc(e) {
  const t = e.charAt(e.length - 1), n = Ww[t];
  return t !== "" && Jw.includes(t) || n !== void 0 && dc(e, t) > dc(e, n) ? e.slice(0, -1) : null;
}
function Xw(e) {
  let t = e, n = fc(t);
  for (; n !== null; )
    t = n, n = fc(t);
  return t;
}
function Zw(e) {
  try {
    const { protocol: t } = new URL(e);
    return t === "https:" || t === "http:";
  } catch {
    return !1;
  }
}
function Gw(e) {
  const t = [];
  let n = 0;
  for (const i of e.matchAll(Uw)) {
    const r = i.index ?? 0, a = i[1], o = a === void 0 ? Xw(i[0]) : i[2] ?? "";
    Zw(o) && (r > n && t.push({ kind: "text", value: e.slice(n, r) }), t.push(a === void 0 ? { kind: "link", value: o } : { kind: "link", value: o, label: a }), n = r + (a === void 0 ? o.length : i[0].length));
  }
  return n < e.length && t.push({ kind: "text", value: e.slice(n) }), t;
}
function eo({ text: e }) {
  return /* @__PURE__ */ _(Ke, { children: Gw(e).map(
    (t, n) => t.kind === "link" ? (
      // Children, not `text`: the Link's trailing launch icon is a block
      // element, which would drop onto a line of its own inside a sentence.
      /* @__PURE__ */ _(
        Ir,
        {
          url: t.value,
          target: Mn.Blank,
          title: t.label === void 0 ? void 0 : t.value,
          ariaLabel: `${t.label ?? t.value} (opens in a new tab)`,
          children: t.label ?? t.value
        },
        n
      )
    ) : /* @__PURE__ */ _(io, { children: t.value }, n)
  ) });
}
const Kw = /^\s*[-*•]\s+(.*)$/, Yw = /\*\*([^*\n]+)\*\*/g;
function Qw(e) {
  const t = [];
  let n = [], i = [];
  const r = () => {
    n.length > 0 && t.push({ kind: "paragraph", lines: n }), i.length > 0 && t.push({ kind: "list", items: i }), n = [], i = [];
  };
  for (const a of e.split(`
`)) {
    const o = Kw.exec(a);
    a.trim() === "" ? r() : o ? (n.length > 0 && r(), i.push(o[1] ?? "")) : (i.length > 0 && r(), n.push(a));
  }
  return r(), t;
}
function mc({ text: e }) {
  const t = [];
  let n = 0;
  for (const i of e.matchAll(Yw)) {
    const r = i.index ?? 0;
    r > n && t.push(/* @__PURE__ */ _(eo, { text: e.slice(n, r) }, `t${n}`)), t.push(/* @__PURE__ */ _("strong", { children: i[1] }, `b${r}`)), n = r + i[0].length;
  }
  return n < e.length && t.push(/* @__PURE__ */ _(eo, { text: e.slice(n) }, `t${n}`)), /* @__PURE__ */ _(Ke, { children: t });
}
function e4({ text: e }) {
  return /* @__PURE__ */ _("div", { className: ba["ns-formatted-text"], children: Qw(e).map(
    (t, n) => t.kind === "list" ? /* @__PURE__ */ _("ul", { className: ba["ns-formatted-text__list"], children: t.items.map((i, r) => /* @__PURE__ */ _("li", { children: /* @__PURE__ */ _(mc, { text: i }) }, r)) }, n) : /* @__PURE__ */ _("p", { className: ba["ns-formatted-text__paragraph"], children: t.lines.map((i, r) => /* @__PURE__ */ B(io, { children: [
      r > 0 && /* @__PURE__ */ _("br", {}),
      /* @__PURE__ */ _(mc, { text: i })
    ] }, r)) }, n)
  ) });
}
function zo({ ism: e, registry: t, onParseError: n, filter: i, isActiveISM: r }) {
  const { nodes: a, errors: o } = $e(() => Ts(e, t), [e, t]);
  return ve(() => {
    o.length > 0 && n?.(o);
  }, [o, n]), /* @__PURE__ */ _(Ke, { children: a.map((l, u) => {
    if (l.type === "text")
      return i === "slots" ? null : /* @__PURE__ */ _(e4, { text: l.content }, u);
    if (i === "text")
      return null;
    const c = t[l.componentName];
    if (!c)
      return null;
    const h = c.Component;
    return /* @__PURE__ */ _(
      h,
      {
        ...l.props,
        disabled: !r || l.interactive === !1
      },
      `${l.componentName}-${u}`
    );
  }) });
}
function f5({
  ism: e,
  registry: t,
  "aria-label": n = "AI message",
  isActiveISM: i = !1,
  onParseError: r
}) {
  return /* @__PURE__ */ _(zo, { ism: e, registry: t, onParseError: r, isActiveISM: i });
}
const va = {
  "context-prompt": "_context-prompt_15dzo_1",
  "context-prompt__prose": "_context-prompt__prose_15dzo_14",
  "context-prompt__inline-slots": "_context-prompt__inline-slots_15dzo_20"
}, t4 = {
  "ds-context-token-panel": "_ds-context-token-panel_1s031_9"
}, n4 = {
  clear: Re.Success,
  unclear: Re.Warning,
  invalid: Re.Error
};
function i4(e, t, n, i) {
  return e ? Re.Error : t ? Re.Warning : n ? Re.Success : n4[i];
}
function to(e) {
  return e == null || Array.isArray(e) && e.length === 0;
}
function r4(e, t) {
  if (to(e) && to(t))
    return !0;
  if (Array.isArray(e) && Array.isArray(t)) {
    const n = e, i = t;
    if (n.length !== i.length)
      return !1;
    const r = [...n].sort(), a = [...i].sort();
    return r.every((o, l) => o === a[l]);
  }
  return e === t;
}
const s4 = "ds-context-token-panel-layer";
function a4({
  componentName: e,
  source: t,
  fieldName: n,
  status: i,
  icon: r,
  slotContent: a,
  formatValue: o,
  disabled: l = !1,
  closeOnChange: u = !1,
  submitOnClose: c = !1,
  initialValue: h
}) {
  const { values: p, errors: m, touched: g, submit: b } = hn(), v = re(null), [w, y] = Ee(!1), [I, E] = Ee({ top: 0, left: 0 }), P = re(void 0), S = () => {
    y(!1), c && !r4(p[n], P.current) && b();
  }, f = re(S);
  f.current = S;
  const { panelRef: C } = uo({ isOpen: w, onClose: S }), L = p[n], M = g[n] === !0 && L !== "" && !to(L), z = e === "DatePicker" && Bo(L), R = m[n], j = M ? o ? o(L) : String(L) : t, H = i4(R, z, M, i), O = () => {
    const se = v.current?.getBoundingClientRect();
    se && E({ top: se.bottom + 2, left: se.left });
  }, X = () => {
    O(), P.current = L === void 0 ? h : L, y(!0);
  }, K = () => {
    l || (w ? S() : X());
  };
  return ve(() => {
    if (!w)
      return;
    const se = { current: 0 }, Y = () => {
      cancelAnimationFrame(se.current), se.current = requestAnimationFrame(O);
    };
    return window.addEventListener("scroll", Y, { capture: !0, passive: !0 }), window.addEventListener("resize", Y, { passive: !0 }), () => {
      window.removeEventListener("scroll", Y, { capture: !0 }), window.removeEventListener("resize", Y), cancelAnimationFrame(se.current);
    };
  }, [w]), ve(() => {
    !u || !w || L !== void 0 && L !== P.current && f.current();
  }, [u, w, L]), ve(() => {
    if (!w)
      return;
    const se = (Y) => {
      const N = Y.target;
      C.current?.contains(N) || v.current?.contains(N) || N?.closest?.("[data-ds-layer]") || f.current();
    };
    return document.addEventListener("pointerdown", se), () => document.removeEventListener("pointerdown", se);
  }, [w, C]), /* @__PURE__ */ B(Ke, { children: [
    /* @__PURE__ */ _(
      st,
      {
        ref: v,
        text: j,
        prefix: r,
        variant: lt.Outlined,
        color: H,
        size: Mt.Medium,
        disabled: l,
        "aria-label": M ? `${t}: ${j}` : `Clarify: ${t}`,
        tooltip: R ?? void 0,
        onClick: K
      }
    ),
    w && di(
      /* @__PURE__ */ _("div", { ref: C, className: t4["ds-context-token-panel"], style: { top: I.top, left: I.left }, children: a }),
      fi(s4)
    )
  ] });
}
const o4 = {
  DatePicker: J.CalendarToday
}, l4 = /* @__PURE__ */ new Set(["Select", "DatePicker", "EntityPicker"]), u4 = /* @__PURE__ */ new Set(["MultiSelect"]);
function c4(e) {
  return Array.isArray(e) ? e : typeof e == "string" ? e.split("|").filter(Boolean).map((t) => {
    const n = t.indexOf(":");
    return n === -1 ? { label: t, value: t } : { label: t.slice(0, n), value: t.slice(n + 1) };
  }) : [];
}
function gc(e, t) {
  const n = c4(e).find((i) => i.value === t);
  return n ? String(n.label) : void 0;
}
function h4(e) {
  const [t, n, i] = e.split("-").map(Number);
  return !t || !n || !i ? e : new Date(t, n - 1, i).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
}
function p4(e, t, n, i) {
  if (e === "DatePicker" && Bo(n))
    return i ?? "Answer later";
  if (typeof n == "boolean")
    return n ? "Yes" : "No";
  if (Array.isArray(n)) {
    const a = Array.from(
      new Set(n.map((o) => gc(t, o) ?? String(o)))
    ).sort((o, l) => o.localeCompare(l));
    return bw(a);
  }
  if (n && typeof n == "object" && "label" in n)
    return String(n.label);
  const r = gc(t, n);
  return r !== void 0 ? r : e === "DatePicker" && typeof n == "string" ? h4(n) : String(n);
}
function m5({
  text: e,
  registry: t,
  onSubmit: n,
  onSearch: i,
  validate: r,
  loading: a = !1,
  loadingText: o,
  disabled: l,
  inlineSlots: u = !1,
  autoFocus: c = !1
}) {
  const { nodes: h } = $e(
    () => e ? Ts(e, t) : { nodes: [], errors: [] },
    [e, t]
  ), p = $e(
    () => h.filter(
      (w) => w.type === "slot" && (u || !!t[w.componentName]?.inline)
    ),
    [h, u, t]
  ), m = Cc(e, { enabled: c }), g = Q({
    [va["context-prompt"]]: !0
  });
  if (a)
    return /* @__PURE__ */ _("div", { className: g, children: /* @__PURE__ */ _(Xp, { text: o }) });
  if (!e || h.length === 0)
    return null;
  const b = h.length === 1 ? h[0] : void 0, v = b?.type === "slot" ? t[b.componentName] : void 0;
  if (b?.type === "slot" && v?.standalone) {
    const w = v.Component;
    return /* @__PURE__ */ _("div", { className: g, children: /* @__PURE__ */ _(w, { ...b.props }) });
  }
  return /* @__PURE__ */ _(vw, { onSubmit: n, onSearch: i, validate: r, children: /* @__PURE__ */ B("div", { className: g, children: [
    /* @__PURE__ */ _("p", { className: va["context-prompt__prose"], children: h.map((w, y) => {
      if (w.type === "text")
        return /* @__PURE__ */ _("span", { children: w.content }, y);
      const I = t[w.componentName];
      if (!I || u || I.inline)
        return null;
      const E = w.source ?? w.componentName, P = w.status ?? "unclear", S = w.interactive === !1 || !!w.props.disabled || !!l, f = I.Component;
      return /* @__PURE__ */ _(
        a4,
        {
          componentName: w.componentName,
          source: E,
          fieldName: String(w.props.name ?? w.componentName),
          status: P,
          icon: o4[w.componentName],
          disabled: S,
          closeOnChange: l4.has(w.componentName),
          submitOnClose: u4.has(w.componentName),
          initialValue: w.props.value,
          formatValue: (C) => {
            const L = w.props.answerLaterLabel;
            return p4(
              w.componentName,
              w.props.options,
              C,
              typeof L == "string" ? L : void 0
            );
          },
          slotContent: /* @__PURE__ */ _(f, { ...w.props, disabled: l, label: "" })
        },
        `${w.componentName}-${y}`
      );
    }) }),
    p.length > 0 && /* @__PURE__ */ _("div", { ref: m, className: va["context-prompt__inline-slots"], children: p.map((w, y) => {
      const I = t[w.componentName];
      if (!I)
        return null;
      const E = w.interactive === !1 || !!w.props.disabled || !!l, P = I.Component;
      return /* @__PURE__ */ _(
        P,
        {
          ...w.props,
          disabled: E
        },
        `${w.componentName}-${y}`
      );
    }) })
  ] }) });
}
const wa = {
  "ns-aries-status-row": "_ns-aries-status-row_1mx9l_1",
  "ns-aries-status-row__icon-wrap": "_ns-aries-status-row__icon-wrap_1mx9l_8",
  "ns-aries-status-row__label": "_ns-aries-status-row__label_1mx9l_14"
}, d4 = [
  "Thinking…",
  "Working on it…",
  "Analyzing your request…",
  "Gathering the details…",
  "Reviewing your answer…",
  "Putting it together…",
  "One moment…"
], f4 = ["Scrubbing PHI…", "Removing personal details…", "Securing your message…"];
function m4(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function g4({ item: e }) {
  const t = e.status === "sanitizing" ? "sanitizing" : "working", n = $e(
    () => m4(t === "sanitizing" ? f4 : d4),
    [t]
  ), i = e.label ?? n;
  return /* @__PURE__ */ B("div", { className: wa["ns-aries-status-row"], "aria-label": i, children: [
    /* @__PURE__ */ _("span", { className: wa["ns-aries-status-row__icon-wrap"], "aria-hidden": "true", children: /* @__PURE__ */ _(Wp, { size: 20 }) }),
    /* @__PURE__ */ _("span", { className: wa["ns-aries-status-row__label"], children: i })
  ] });
}
const jt = {
  "ns-chat-message-row": "_ns-chat-message-row_14rb4_9",
  "ns-chat-message-row--end": "_ns-chat-message-row--end_14rb4_14",
  "ns-chat-message-row--start": "_ns-chat-message-row--start_14rb4_18",
  "ns-chat-message-row__content": "_ns-chat-message-row__content_14rb4_22",
  "ns-chat-message-row__ism-panel": "_ns-chat-message-row__ism-panel_14rb4_37",
  "ns-chat-message-row__meta": "_ns-chat-message-row__meta_14rb4_46",
  "ns-chat-message-row__timestamp": "_ns-chat-message-row__timestamp_14rb4_58",
  "ns-chat-message-row__delivery": "_ns-chat-message-row__delivery_14rb4_64",
  "ns-chat-message-row__delivery--sent": "_ns-chat-message-row__delivery--sent_14rb4_71",
  "ns-chat-message-row__delivery--failed": "_ns-chat-message-row__delivery--failed_14rb4_75",
  "ns-chat-message-row__delivery--sending": "_ns-chat-message-row__delivery--sending_14rb4_79",
  "ns-chat-message-row__sending-dot": "_ns-chat-message-row__sending-dot_14rb4_83"
};
function _4({ delivery: e }) {
  return e === "sent" || e === "complete" ? /* @__PURE__ */ _("span", { className: Q(jt["ns-chat-message-row__delivery"], jt["ns-chat-message-row__delivery--sent"]), children: /* @__PURE__ */ _(ke, { name: J.Done, "aria-label": "Sent" }) }) : e === "failed" ? /* @__PURE__ */ _("span", { className: Q(jt["ns-chat-message-row__delivery"], jt["ns-chat-message-row__delivery--failed"]), children: /* @__PURE__ */ _(ke, { name: J.Close, "aria-label": "Failed to send" }) }) : e === "sending" ? /* @__PURE__ */ _(
    "span",
    {
      className: Q(jt["ns-chat-message-row__delivery"], jt["ns-chat-message-row__delivery--sending"]),
      "aria-label": "Sending",
      children: /* @__PURE__ */ _("span", { className: jt["ns-chat-message-row__sending-dot"], "aria-hidden": "true" })
    }
  ) : null;
}
const ka = {
  "ns-message-feedback-row": "_ns-message-feedback-row_1b813_1",
  "ns-message-feedback-row__btn": "_ns-message-feedback-row__btn_1b813_9"
};
function g5({ onFeedback: e }) {
  return /* @__PURE__ */ B("div", { className: ka["ns-message-feedback-row"], "aria-label": "Was this response helpful?", children: [
    /* @__PURE__ */ _(
      st,
      {
        type: "button",
        className: ka["ns-message-feedback-row__btn"],
        "aria-label": "Helpful",
        onClick: () => e("up"),
        icon: J.ThumbUp,
        variant: lt.Outlined,
        size: Mt.Small,
        isIconOnly: !0
      }
    ),
    /* @__PURE__ */ _(
      st,
      {
        type: "button",
        className: ka["ns-message-feedback-row__btn"],
        "aria-label": "Not helpful",
        onClick: () => e("down"),
        icon: J.ThumbDown,
        variant: lt.Outlined,
        size: Mt.Small,
        isIconOnly: !0
      }
    )
  ] });
}
const li = {
  "ns-chat-bubble": "_ns-chat-bubble_1cn1u_1",
  "ns-chat-bubble--end": "_ns-chat-bubble--end_1cn1u_7",
  "ns-chat-bubble--start": "_ns-chat-bubble--start_1cn1u_11",
  "ns-chat-bubble__pill": "_ns-chat-bubble__pill_1cn1u_15",
  "ns-chat-bubble__pill--human": "_ns-chat-bubble__pill--human_1cn1u_20",
  "ns-chat-bubble__text": "_ns-chat-bubble__text_1cn1u_28",
  "ns-chat-bubble__pill--assistant": "_ns-chat-bubble__pill--assistant_1cn1u_32"
};
function x4({
  content: e,
  alignment: t,
  participant: n,
  registry: i,
  "aria-label": r,
  isActiveISM: a = !1
}) {
  const o = t === "end", l = o ? li["ns-chat-bubble--end"] : li["ns-chat-bubble--start"], u = o ? li["ns-chat-bubble__pill--human"] : li["ns-chat-bubble__pill--assistant"], c = e.kind === "ism" ? /* @__PURE__ */ _(zo, { ism: e.ism, registry: i, filter: "text", isActiveISM: a }) : /* @__PURE__ */ _("p", { className: li["ns-chat-bubble__text"], children: o ? e.text : /* @__PURE__ */ _(eo, { text: e.text }) });
  return /* @__PURE__ */ _("div", { className: Q(li["ns-chat-bubble"], l), "aria-label": r, children: /* @__PURE__ */ B("div", { className: Q(li["ns-chat-bubble__pill"], u), children: [
    /* @__PURE__ */ _(
      xf,
      {
        imageUrl: n.avatarUrl,
        iconName: n.iconName,
        name: n.name,
        size: 32,
        isAries: !o
      }
    ),
    c
  ] }) });
}
const _c = {
  "ns-chat-date-divider": "_ns-chat-date-divider_23x9d_1",
  "ns-chat-date-divider__label": "_ns-chat-date-divider__label_23x9d_14"
};
function y4({ item: e }) {
  const t = new Intl.DateTimeFormat(void 0, {
    weekday: "long",
    month: "long",
    day: "numeric"
  }).format(e.date);
  return /* @__PURE__ */ _("div", { className: _c["ns-chat-date-divider"], role: "separator", "aria-label": t, children: /* @__PURE__ */ _("span", { className: _c["ns-chat-date-divider__label"], "aria-hidden": "true", children: t }) });
}
const Ca = {
  "ns-chat-error-row": "_ns-chat-error-row_16809_1",
  "ns-chat-error-row__icon": "_ns-chat-error-row__icon_16809_12",
  "ns-chat-error-row__message": "_ns-chat-error-row__message_16809_18"
};
function b4({ item: e }) {
  return /* @__PURE__ */ B("div", { className: Ca["ns-chat-error-row"], role: "alert", children: [
    /* @__PURE__ */ _(ke, { name: J.Close, className: Ca["ns-chat-error-row__icon"], "aria-hidden": "true" }),
    /* @__PURE__ */ _("span", { className: Ca["ns-chat-error-row__message"], children: e.message })
  ] });
}
function v4({
  item: e,
  registry: t,
  onMessageFeedback: n,
  showTimestamp: i = !1,
  showDeliveryBadge: r = !1,
  isActiveISM: a = !1,
  autoFocus: o = !1
}) {
  const l = Cc(e.id, {
    enabled: o && a
  }), u = e.alignment === "end", c = e.timestamp.toISOString(), h = new Intl.DateTimeFormat(void 0, {
    hour: "numeric",
    minute: "2-digit"
  }).format(e.timestamp), m = !1, g = i || r && u;
  return /* @__PURE__ */ _(
    "div",
    {
      className: Q(
        jt["ns-chat-message-row"],
        u ? jt["ns-chat-message-row--end"] : jt["ns-chat-message-row--start"]
      ),
      children: /* @__PURE__ */ B("div", { className: jt["ns-chat-message-row__content"], children: [
        /* @__PURE__ */ _(
          x4,
          {
            content: e.content,
            alignment: e.alignment,
            participant: e.participant,
            registry: t,
            isActiveISM: a
          }
        ),
        e.content.kind === "ism" && a && /* @__PURE__ */ _("div", { ref: l, className: jt["ns-chat-message-row__ism-panel"], children: /* @__PURE__ */ _(zo, { ism: e.content.ism, registry: t, isActiveISM: !0, filter: "slots" }) }),
        m,
        g && /* @__PURE__ */ B("div", { className: jt["ns-chat-message-row__meta"], children: [
          i && /* @__PURE__ */ _("time", { className: jt["ns-chat-message-row__timestamp"], dateTime: c, children: h }),
          r && u && /* @__PURE__ */ _(_4, { delivery: e.delivery })
        ] })
      ] })
    }
  );
}
const xc = {
  "ns-chat-system-row": "_ns-chat-system-row_v9ntr_1",
  "ns-chat-system-row__text": "_ns-chat-system-row__text_v9ntr_7"
};
function w4({ item: e }) {
  return /* @__PURE__ */ _("div", { className: xc["ns-chat-system-row"], "aria-live": "polite", children: /* @__PURE__ */ _("span", { className: xc["ns-chat-system-row__text"], children: e.text }) });
}
const Sa = {
  "ns-chat-timeline": "_ns-chat-timeline_1xzg7_1",
  "ns-chat-timeline__list": "_ns-chat-timeline__list_1xzg7_8",
  "ns-chat-timeline__item": "_ns-chat-timeline__item_1xzg7_18"
}, Pi = {
  "ns-chat-typing-row": "_ns-chat-typing-row_z906l_9",
  "ns-chat-typing-row__avatar": "_ns-chat-typing-row__avatar_z906l_16",
  "ns-chat-typing-row__bubble": "_ns-chat-typing-row__bubble_z906l_39",
  "ns-chat-typing-row__dot": "_ns-chat-typing-row__dot_z906l_50"
};
function k4({ item: e }) {
  const t = e.participant.name.split(" ").slice(0, 2).map((n) => n[0]?.toUpperCase() ?? "").join("");
  return /* @__PURE__ */ B(
    "div",
    {
      className: Pi["ns-chat-typing-row"],
      role: "status",
      "aria-label": `${e.participant.name} is typing`,
      children: [
        /* @__PURE__ */ _("div", { className: Pi["ns-chat-typing-row__avatar"], "aria-hidden": "true", children: e.participant.avatarUrl ? /* @__PURE__ */ _("img", { src: e.participant.avatarUrl, alt: "" }) : /* @__PURE__ */ _("span", { children: t }) }),
        /* @__PURE__ */ B("div", { className: Pi["ns-chat-typing-row__bubble"], "aria-hidden": "true", children: [
          /* @__PURE__ */ _("span", { className: Pi["ns-chat-typing-row__dot"] }),
          /* @__PURE__ */ _("span", { className: Pi["ns-chat-typing-row__dot"] }),
          /* @__PURE__ */ _("span", { className: Pi["ns-chat-typing-row__dot"] })
        ] })
      ]
    }
  );
}
const C4 = 96;
function _5({
  items: e,
  registry: t,
  className: n,
  header: i,
  onMessageFeedback: r,
  showTimestamp: a = !1,
  showDeliveryBadge: o = !1,
  autoFocusActiveISM: l = !1
}) {
  const u = re(null), c = re(null), h = re(null), p = re(!0), m = re(0), g = pe(() => {
    u.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, []), b = pe(() => {
    const w = c.current;
    if (!w)
      return;
    const y = w.scrollTop;
    w.scrollHeight - y - w.clientHeight <= C4 ? p.current = !0 : y < m.current && (p.current = !1), m.current = y;
  }, []), v = $e(() => {
    let w;
    for (let y = e.length - 1; y >= 0; y--)
      if (e[y].kind === "message") {
        w = e[y];
        break;
      }
    return w?.kind === "message" && w.content.kind === "ism" && w.delivery !== "complete" ? w : void 0;
  }, [e]);
  return ve(() => {
    p.current = !0, g();
  }, [e.length, g]), ve(() => {
    const w = h.current;
    if (!w || typeof ResizeObserver > "u")
      return;
    const y = new ResizeObserver(() => {
      p.current && g();
    });
    return y.observe(w), () => y.disconnect();
  }, [g]), /* @__PURE__ */ B(
    "div",
    {
      ref: c,
      onScroll: b,
      className: Q(Sa["ns-chat-timeline"], n),
      role: "log",
      "aria-live": "polite",
      "aria-label": "Conversation",
      "aria-relevant": "additions",
      children: [
        i,
        /* @__PURE__ */ _("ul", { ref: h, className: Sa["ns-chat-timeline__list"], children: e.map((w) => /* @__PURE__ */ B("li", { className: Sa["ns-chat-timeline__item"], children: [
          w.kind === "message" && /* @__PURE__ */ _(
            v4,
            {
              item: w,
              registry: t,
              onMessageFeedback: r,
              showTimestamp: a,
              showDeliveryBadge: o,
              isActiveISM: v ? w.id === v.id : !1,
              autoFocus: l
            }
          ),
          w.kind === "typing" && /* @__PURE__ */ _(k4, { item: w }),
          w.kind === "system" && /* @__PURE__ */ _(w4, { item: w }),
          w.kind === "date-divider" && /* @__PURE__ */ _(y4, { item: w }),
          w.kind === "error" && /* @__PURE__ */ _(b4, { item: w }),
          w.kind === "aries-status" && /* @__PURE__ */ _(g4, { item: w })
        ] }, w.id)) }),
        /* @__PURE__ */ _("div", { ref: u, "aria-hidden": "true" })
      ]
    }
  );
}
const ui = {
  "ds-alert": "_ds-alert_lip8q_1",
  "ds-alert--filled-primary": "_ds-alert--filled-primary_lip8q_24",
  "ds-alert--filled-secondary": "_ds-alert--filled-secondary_lip8q_28",
  "ds-alert--filled-error": "_ds-alert--filled-error_lip8q_32",
  "ds-alert--filled-warning": "_ds-alert--filled-warning_lip8q_36",
  "ds-alert--filled-info": "_ds-alert--filled-info_lip8q_44",
  "ds-alert--filled-success": "_ds-alert--filled-success_lip8q_48",
  "ds-alert--outlined-primary": "_ds-alert--outlined-primary_lip8q_52",
  "ds-alert--outlined-secondary": "_ds-alert--outlined-secondary_lip8q_60",
  "ds-alert--outlined-error": "_ds-alert--outlined-error_lip8q_68",
  "ds-alert--outlined-warning": "_ds-alert--outlined-warning_lip8q_76",
  "ds-alert--outlined-info": "_ds-alert--outlined-info_lip8q_84",
  "ds-alert--outlined-success": "_ds-alert--outlined-success_lip8q_92",
  "ds-alert__icon": "_ds-alert__icon_lip8q_127",
  "ds-alert__body": "_ds-alert__body_lip8q_137",
  "ds-alert__title": "_ds-alert__title_lip8q_144",
  "ds-alert__description": "_ds-alert__description_lip8q_150",
  "ds-alert__dismiss": "_ds-alert__dismiss_lip8q_155"
};
var jo = /* @__PURE__ */ ((e) => (e.Filled = "filled", e.Outlined = "outlined", e))(jo || {}), ln = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Secondary = "secondary", e.Error = "error", e.Warning = "warning", e.Info = "info", e.Success = "success", e))(ln || {}), Ho = /* @__PURE__ */ ((e) => (e.TopLeft = "top-left", e.TopCenter = "top-center", e.TopRight = "top-right", e.CenterLeft = "center-left", e.Center = "center", e.CenterRight = "center-right", e.BottomLeft = "bottom-left", e.BottomCenter = "bottom-center", e.BottomRight = "bottom-right", e))(Ho || {}), Zp = /* @__PURE__ */ ((e) => (e.FadeIn = "fade-in", e.SlideIn = "slide-in", e.None = "none", e))(Zp || {}), Gp = /* @__PURE__ */ ((e) => (e.FadeOut = "fade-out", e.SlideOut = "slide-out", e.None = "none", e))(Gp || {});
const S4 = {
  [ln.Primary]: J.AlertCircle,
  [ln.Secondary]: J.AlertCircle,
  [ln.Error]: J.AlertCircle,
  [ln.Warning]: J.Warning,
  [ln.Info]: J.Info,
  [ln.Success]: J.CheckCircle
}, E4 = [ln.Error, ln.Warning], A4 = ({
  title: e,
  description: t,
  severity: n = ln.Info,
  variant: i = jo.Filled,
  dismissible: r = !0,
  onDismiss: a,
  className: o,
  phase: l = "visible",
  enterEffect: u,
  exitEffect: c
}) => {
  const h = E4.includes(n);
  return /* @__PURE__ */ B(
    "div",
    {
      role: h ? "alert" : "status",
      "aria-atomic": "true",
      "aria-live": h ? "assertive" : "polite",
      "data-state": l,
      "data-enter": u,
      "data-exit": c,
      className: Q(
        ui["ds-alert"],
        ui[`ds-alert--${i}-${n}`],
        o
      ),
      children: [
        /* @__PURE__ */ _("span", { className: ui["ds-alert__icon"], "aria-hidden": "true", children: /* @__PURE__ */ _(ke, { name: S4[n], size: 20 }) }),
        /* @__PURE__ */ B("div", { className: ui["ds-alert__body"], children: [
          /* @__PURE__ */ _("span", { className: ui["ds-alert__title"], children: e }),
          t && /* @__PURE__ */ _("span", { className: ui["ds-alert__description"], children: t })
        ] }),
        r && /* @__PURE__ */ _(
          "button",
          {
            type: "button",
            "aria-label": "Dismiss notification",
            className: ui["ds-alert__dismiss"],
            onClick: a,
            children: /* @__PURE__ */ _(ke, { name: J.Close, size: 16 })
          }
        )
      ]
    }
  );
}, yc = {
  "ds-alert-container": "_ds-alert-container_19hve_1",
  "ds-alert-container--top-left": "_ds-alert-container--top-left_19hve_9",
  "ds-alert-container--top-center": "_ds-alert-container--top-center_19hve_13",
  "ds-alert-container--top-right": "_ds-alert-container--top-right_19hve_19",
  "ds-alert-container--center-left": "_ds-alert-container--center-left_19hve_24",
  "ds-alert-container--center": "_ds-alert-container--center_19hve_24",
  "ds-alert-container--center-right": "_ds-alert-container--center-right_19hve_35",
  "ds-alert-container--bottom-left": "_ds-alert-container--bottom-left_19hve_41",
  "ds-alert-container--bottom-center": "_ds-alert-container--bottom-center_19hve_45",
  "ds-alert-container--bottom-right": "_ds-alert-container--bottom-right_19hve_51"
}, I4 = "ds-alert-layer", L4 = 4e3, P4 = 150, T4 = Ho.BottomRight, N4 = Zp.SlideIn, D4 = Gp.SlideOut, $o = Cr(null), Kp = Object.values(Ho);
function V4(e) {
  const t = /* @__PURE__ */ new Map();
  for (const n of Kp)
    t.set(n, []);
  for (const n of e)
    t.get(n.position).push(n);
  return t;
}
const M4 = ({ item: e, onSetPhase: t, onRemove: n }) => {
  const i = re(null), r = re(null), a = re(null);
  ve(() => (e.phase === "entering" && (i.current = requestAnimationFrame(() => {
    t(e.id, "visible");
  })), () => {
    i.current !== null && cancelAnimationFrame(i.current);
  }), []);
  const o = pe(() => {
    r.current !== null && (clearTimeout(r.current), r.current = null), t(e.id, "exiting"), a.current = setTimeout(() => {
      n(e.id);
    }, P4);
  }, [e.id, t, n]);
  return ve(() => {
    if (!(e.phase !== "visible" || e.duration === 0))
      return r.current = setTimeout(o, e.duration), () => {
        r.current !== null && clearTimeout(r.current);
      };
  }, [e.phase, e.duration, o]), ve(() => () => {
    i.current !== null && cancelAnimationFrame(i.current), r.current !== null && clearTimeout(r.current), a.current !== null && clearTimeout(a.current);
  }, []), /* @__PURE__ */ _(
    A4,
    {
      ...e.alertProps,
      phase: e.phase,
      enterEffect: e.enterEffect,
      exitEffect: e.exitEffect,
      onDismiss: o
    }
  );
}, F4 = () => {
  const e = Oi($o);
  if (!e)
    return null;
  const { alerts: t, setPhase: n, removeAlert: i } = e, r = V4(t), a = fi(I4);
  return di(
    /* @__PURE__ */ _(Ke, { children: Kp.map((o) => {
      const l = r.get(o) ?? [];
      return l.length === 0 ? null : /* @__PURE__ */ _(
        "div",
        {
          className: `${yc["ds-alert-container"]} ${yc[`ds-alert-container--${o}`]}`,
          children: l.map((u) => /* @__PURE__ */ _(
            M4,
            {
              item: u,
              onSetPhase: n,
              onRemove: i
            },
            u.id
          ))
        },
        o
      );
    }) }),
    a
  );
};
function R4(e, t) {
  switch (t.type) {
    case "ADD_ALERT":
      return [...e, t.payload];
    case "SET_PHASE":
      return e.map(
        (n) => n.id === t.id ? { ...n, phase: t.phase } : n
      );
    case "REMOVE_ALERT":
      return e.filter((n) => n.id !== t.id);
    default:
      return e;
  }
}
const x5 = ({ children: e }) => {
  const [t, n] = Id(R4, []), i = pe((u) => {
    const c = crypto.randomUUID(), h = {
      id: c,
      alertProps: {
        title: u.title,
        description: u.description,
        severity: u.severity ?? ln.Info,
        variant: u.variant ?? jo.Filled,
        dismissible: u.dismissible ?? !0,
        className: u.className
      },
      duration: u.duration ?? L4,
      position: u.position ?? T4,
      enterEffect: u.enterEffect ?? N4,
      exitEffect: u.exitEffect ?? D4,
      phase: "entering"
    };
    return n({ type: "ADD_ALERT", payload: h }), c;
  }, []), r = pe((u) => {
    n({ type: "SET_PHASE", id: u, phase: "exiting" });
  }, []), a = pe((u, c) => {
    n({ type: "SET_PHASE", id: u, phase: c });
  }, []), o = pe((u) => {
    n({ type: "REMOVE_ALERT", id: u });
  }, []), l = { alerts: t, show: i, dismiss: r, setPhase: a, removeAlert: o };
  return /* @__PURE__ */ B($o.Provider, { value: l, children: [
    e,
    /* @__PURE__ */ _(F4, {})
  ] });
};
function y5() {
  const e = Oi($o);
  if (!e)
    throw new Error("useAlert must be used within an <AlertProvider>");
  return { show: e.show, dismiss: e.dismiss };
}
const O4 = {
  radius: {
    1: "4px",
    2: "6px",
    3: "8px",
    4: "12px",
    5: "16px",
    100: "100px"
  }
}, B4 = {
  desktop: {
    "min-width": "1025px"
  },
  tablet: {
    landscape: {
      from: {
        "max-width": "1024px"
      },
      to: {
        "min-width": "992px"
      }
    },
    portrait: {
      from: {
        "max-width": "991px"
      },
      to: {
        "min-width": "576px"
      }
    }
  },
  mobile: {
    "max-width": "575px"
  }
}, z4 = {
  neutral: {
    black: "#000000",
    white: "#FFFFFF"
  },
  "mitra-blue": {
    100: "#F2F7FD",
    200: "#BFD9F4",
    300: "#80B3E8",
    400: "#408DDE",
    500: "#0067D2",
    600: "#004D9E",
    700: "#003368",
    800: "#001A35",
    900: "#001A35"
  },
  "cool-gray": {
    100: "#F9FAFC",
    200: "#E3E9EF",
    300: "#C7D3DF",
    400: "#ABBDCF",
    500: "#8FA7BF",
    600: "#6B7D8F",
    700: "#47535F",
    800: "#242A30",
    900: "#07080A"
  },
  blue: {
    100: "#F2FAFD",
    200: "#BFE5F4",
    300: "#80CCE8",
    400: "#40B3DE",
    500: "#0099D2",
    600: "#00739E",
    700: "#004C68",
    800: "#002635",
    900: "#000F15"
  },
  green: {
    100: "#F2F8F6",
    200: "#BFDDD3",
    300: "#80BBA7",
    400: "#40997B",
    500: "#00774E",
    600: "#00593B",
    700: "#003B27",
    800: "#001E14",
    900: "#000C08"
  },
  red: {
    100: "#FCF4F4",
    200: "#F2C7C9",
    300: "#E69093",
    400: "#DA585D",
    500: "#CD2026",
    600: "#9A181D",
    700: "#661013",
    800: "#33080A",
    900: "#140304"
  },
  yellow: {
    100: "#FFFAF4",
    200: "#FFE5C7",
    300: "#FFCC8F",
    400: "#FFB357",
    500: "#FF991F",
    600: "#BF7317",
    700: "#7F4C0F",
    800: "#402608",
    900: "#190F03"
  }
}, j4 = {}, H4 = {
  1: {
    x: "1px",
    y: "2px",
    blur: "3px",
    spread: "1px",
    color: "#00000017",
    opacity: "9%"
  },
  2: {
    x: "2px",
    y: "4px",
    blur: "6px",
    spread: "2px",
    color: "#00000017",
    opacity: "9%"
  },
  3: {
    x: "3px",
    y: "6px",
    blur: "9px",
    spread: "4px",
    color: "#00000017",
    opacity: "9%"
  },
  4: {
    x: "4pxß",
    y: "8pxß",
    blur: "12pxß",
    spread: "8pxß",
    color: "#00000017",
    opacity: "9%"
  }
}, $4 = {}, q4 = {}, U4 = {}, J4 = {
  "space-1": "4px",
  "space-1-5": "6px",
  "space-2": "8px",
  "space-3": "12px",
  "space-4": "16px",
  "space-5": "20px",
  "space-6": "24px",
  "space-7": "32px",
  "space-8": "40px",
  "space-9": "48px",
  "space-10": "56px",
  "space-11": "64px",
  "space-12": "80px",
  "space-13": "96px"
}, W4 = {
  "font-family": {
    primary: "Poppins"
  },
  header: {
    1: {
      "font-name": "var(--ns-typography-font-family-primary)",
      "font-weight": 600,
      "font-size": "48px",
      "font-kerning": "-0.5px",
      "line-height": "114.99999999999999%"
    },
    2: {
      "font-name": "var(--ns-typography-font-family-primary)",
      "font-weight": 600,
      "font-size": "40px",
      "font-kerning": "0.4px",
      "line-height": "114.99999999999999%"
    },
    3: {
      "font-name": "var(--ns-typography-font-family-primary)",
      "font-weight": 500,
      "font-size": "32px",
      "font-kerning": "-0.2px",
      "line-height": "120%"
    },
    4: {
      "font-name": "var(--ns-typography-font-family-primary)",
      "font-weight": 500,
      "font-size": "28px",
      "font-kerning": "0px",
      "line-height": "120%"
    },
    5: {
      "font-name": "var(--ns-typography-font-family-primary)",
      "font-weight": 500,
      "font-size": "24px",
      "font-kerning": "0px",
      "line-height": "120%"
    },
    6: {
      "font-name": "var(--ns-typography-font-family-primary)",
      "font-weight": 500,
      "font-size": "20px",
      "font-kerning": "0px",
      "line-height": "120%"
    }
  },
  title: {
    page: {
      title: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 600,
        "font-size": "32px",
        "font-kerning": "-0.2px",
        "line-height": "120%",
        "text-transform": "capitalize"
      }
    },
    section: {
      title: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 600,
        "font-size": "20px",
        "font-kerning": "0px",
        "line-height": "120%"
      }
    }
  },
  body: {
    1: {
      400: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 400,
        "font-size": "16px",
        "font-kerning": "0px",
        "line-height": "150%"
      },
      500: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "16px",
        "font-kerning": "0px",
        "line-height": "150%"
      },
      600: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 600,
        "font-size": "16px",
        "font-kerning": "0px",
        "line-height": "150%"
      }
    },
    2: {
      400: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 400,
        "font-size": "14px",
        "font-kerning": "0px",
        "line-height": "150%"
      },
      500: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "14px",
        "font-kerning": "0px",
        "line-height": "150%"
      },
      600: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 600,
        "font-size": "14px",
        "font-kerning": "0px",
        "line-height": "150%"
      }
    },
    caption: {
      400: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 400,
        "font-size": "12px",
        "font-kerning": "0.2px",
        "line-height": "140%"
      },
      500: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "12px",
        "font-kerning": "0.2px",
        "line-height": "140%"
      },
      600: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 600,
        "font-size": "12px",
        "font-kerning": "0.2px",
        "line-height": "140%"
      }
    },
    overline: {
      400: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 400,
        "font-size": "10px",
        "font-kerning": "0.3px",
        "line-height": "130%",
        "text-transform": "uppercase"
      },
      500: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "10px",
        "font-kerning": "0.3px",
        "line-height": "130%",
        "text-transform": "uppercase"
      },
      600: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 600,
        "font-size": "10px",
        "font-kerning": "0.3px",
        "line-height": "130%",
        "text-transform": "uppercase"
      }
    },
    tooltip: {
      400: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 400,
        "font-size": "10px",
        "font-kerning": "0px",
        "line-height": "140%"
      },
      500: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "10px",
        "font-kerning": "0px",
        "line-height": "140%"
      },
      600: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 600,
        "font-size": "10px",
        "font-kerning": "0px",
        "line-height": "140%"
      }
    }
  },
  label: {
    accordion: {
      header: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "16px",
        "font-kerning": "0.1px",
        "line-height": "150%"
      }
    },
    button: {
      lg: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "16px",
        "font-kerning": "0.25px",
        "line-height": "120%",
        "text-transform": "capitalize"
      },
      md: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "14px",
        "font-kerning": "0.25px",
        "line-height": "120%",
        "text-transform": "capitalize"
      },
      sm: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "12px",
        "font-kerning": "0.25px",
        "line-height": "120%",
        "text-transform": "capitalize"
      }
    },
    chip: {
      "font-name": "var(--ns-typography-font-family-primary)",
      "font-weight": 500,
      "font-size": "12px",
      "font-kerning": "0.2px",
      "line-height": "114.99999999999999%",
      "text-transform": "capitalize"
    },
    input: {
      field: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 400,
        "font-size": "14px",
        "font-kerning": "0.25px",
        "line-height": "120%",
        "text-transform": "capitalize"
      }
    },
    table: {
      header: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "14px",
        "font-kerning": "0.1px",
        "line-height": "145%",
        "text-transform": "capitalize"
      }
    }
  }
}, X4 = {
  sm: "160px",
  md: "280px",
  lg: "400px"
}, Z4 = {
  primary: {
    100: "var(--ns-color-mitra-blue-100)",
    200: "var(--ns-color-mitra-blue-200)",
    300: "var(--ns-color-mitra-blue-300)",
    400: "var(--ns-color-mitra-blue-400)",
    500: "var(--ns-color-mitra-blue-500)",
    600: "var(--ns-color-mitra-blue-600)",
    700: "var(--ns-color-mitra-blue-700)",
    800: "var(--ns-color-mitra-blue-800)",
    900: "var(--ns-color-mitra-blue-900)"
  },
  secondary: {
    100: "var(--ns-color-cool-gray-100)",
    200: "var(--ns-color-cool-gray-200)",
    300: "var(--ns-color-cool-gray-300)",
    400: "var(--ns-color-cool-gray-400)",
    500: "var(--ns-color-cool-gray-500)",
    600: "var(--ns-color-cool-gray-600)",
    700: "var(--ns-color-cool-gray-700)",
    800: "var(--ns-color-cool-gray-800)",
    900: "var(--ns-color-cool-gray-900)"
  },
  accent: {
    yellow: {
      100: "var(--ns-color-yellow-100)"
    }
  },
  copy: {
    text: {
      primary: "var(--ns-color-neutral-black)",
      secondary: "var(--ns-color-cool-gray-700)",
      tertiary: "var(--ns-color-neutral-white)",
      link: "var(--ns-color-mitra-blue-500)",
      error: "var(--ns-color-red-500)"
    },
    label: {
      button: {
        primary: {
          enabled: "var(--ns-color-neutral-white)",
          hover: "var(--ns-color-neutral-white)",
          focused: "var(--ns-color-neutral-white)",
          disabled: "var(--ns-color-neutral-white)",
          variant: {
            outlined: {
              enabled: "var(--ns-color-primary-500)",
              hover: "var(--ns-color-primary-500)",
              focused: "var(--ns-color-primary-600)",
              disabled: "var(--ns-color-primary-300)"
            },
            text: {
              enabled: "var(--ns-color-primary-500)",
              hover: "var(--ns-color-primary-500)",
              focused: "var(--ns-color-primary-600)",
              disabled: "var(--ns-color-primary-300)"
            }
          }
        },
        secondary: {
          enabled: "var(--ns-color-neutral-white)",
          hover: "var(--ns-color-primary-100)",
          focused: "var(--ns-color-neutral-white)",
          disabled: "var(--ns-color-secondary-300)",
          variant: {
            outlined: {
              enabled: "var(--ns-color-secondary-700)",
              hover: "var(--ns-color-secondary-700)",
              focused: "var(--ns-color-secondary-700)",
              disabled: "var(--ns-color-secondary-300)"
            },
            text: {
              enabled: "var(--ns-color-secondary-700)",
              hover: "var(--ns-color-secondary-700)",
              focused: "var(--ns-color-secondary-700)",
              disabled: "var(--ns-color-secondary-300)"
            }
          }
        },
        info: {
          enabled: "var(--ns-color-neutral-white)",
          hover: "var(--ns-color-neutral-white)",
          focused: "var(--ns-color-neutral-white)",
          disabled: "var(--ns-color-semantic-info-300)",
          variant: {
            outlined: {
              enabled: "var(--ns-color-semantic-info-600)",
              hover: "var(--ns-color-semantic-info-600)",
              focused: "var(--ns-color-semantic-info-700)",
              disabled: "var(--ns-color-semantic-info-300)"
            },
            text: {
              enabled: "var(--ns-color-semantic-info-600)",
              hover: "var(--ns-color-semantic-info-600)",
              focused: "var(--ns-color-semantic-info-700)",
              disabled: "var(--ns-color-semantic-info-300)"
            }
          }
        },
        success: {
          enabled: "var(--ns-color-neutral-white)",
          hover: "var(--ns-color-neutral-white)",
          focused: "var(--ns-color-neutral-white)",
          disabled: "var(--ns-color-semantic-success-300)",
          variant: {
            outlined: {
              enabled: "var(--ns-color-semantic-success-primary)",
              hover: "var(--ns-color-semantic-success-primary)",
              focused: "var(--ns-color-semantic-success-600)",
              disabled: "var(--ns-color-semantic-success-300)"
            },
            text: {
              enabled: "var(--ns-color-semantic-success-primary)",
              hover: "var(--ns-color-semantic-success-primary)",
              focused: "var(--ns-color-semantic-success-600)",
              disabled: "var(--ns-color-semantic-success-300)"
            }
          }
        },
        warning: {
          enabled: "var(--ns-color-neutral-black)",
          hover: "var(--ns-color-neutral-black)",
          focused: "var(--ns-color-neutral-black)",
          disabled: "var(--ns-color-semantic-warning-300)",
          variant: {
            outlined: {
              enabled: "var(--ns-color-semantic-warning-700)",
              hover: "var(--ns-color-semantic-warning-700)",
              focused: "var(--ns-color-semantic-warning-700)",
              disabled: "var(--ns-color-semantic-warning-300)"
            },
            text: {
              enabled: "var(--ns-color-semantic-warning-700)",
              hover: "var(--ns-color-semantic-warning-700)",
              focused: "var(--ns-color-semantic-warning-700)",
              disabled: "var(--ns-color-semantic-warning-300)"
            }
          }
        },
        error: {
          enabled: "var(--ns-color-neutral-white)",
          hover: "var(--ns-color-neutral-white)",
          focused: "var(--ns-color-neutral-white)",
          disabled: "var(--ns-color-semantic-error-300)",
          variant: {
            outlined: {
              enabled: "var(--ns-color-semantic-error-primary)",
              hover: "var(--ns-color-semantic-error-primary)",
              focused: "var(--ns-color-semantic-error-600)",
              disabled: "var(--ns-color-semantic-error-300)"
            },
            text: {
              enabled: "var(--ns-color-semantic-error-primary)",
              hover: "var(--ns-color-semantic-error-primary)",
              focused: "var(--ns-color-semantic-error-600)",
              disabled: "var(--ns-color-semantic-error-300)"
            }
          }
        }
      },
      input: {
        field: {
          default: "var(--ns-color-cool-gray-800)",
          disabled: "var(--ns-color-cool-gray-600)",
          placeholder: "var(--ns-color-cool-gray-700)"
        }
      }
    }
  },
  surface: {
    button: {
      primary: {
        enabled: "var(--ns-color-primary-500)",
        hover: "var(--ns-color-primary-600)",
        focused: "var(--ns-color-primary-700)",
        disabled: "var(--ns-color-primary-300)",
        variant: {
          outlined: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-primary-100)",
            focused: "var(--ns-color-primary-200)",
            disabled: "var(--ns-color-neutral-white)"
          },
          text: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-primary-100)",
            focused: "var(--ns-color-primary-200)",
            disabled: "var(--ns-color-neutral-white)"
          }
        }
      },
      secondary: {
        enabled: "var(--ns-color-secondary-700)",
        hover: "var(--ns-color-secondary-800)",
        focused: "var(--ns-color-secondary-900)",
        disabled: "var(--ns-color-secondary-300)",
        variant: {
          outlined: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-secondary-100)",
            focused: "var(--ns-color-secondary-200)",
            disabled: "var(--ns-color-neutral-white)"
          },
          text: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-secondary-100)",
            focused: "var(--ns-color-secondary-200)",
            disabled: "var(--ns-color-neutral-white)"
          }
        }
      },
      info: {
        enabled: "var(--ns-color-semantic-info-600)",
        hover: "var(--ns-color-semantic-info-700)",
        focused: "var(--ns-color-semantic-info-800)",
        disabled: "var(--ns-color-semantic-info-300)",
        variant: {
          outlined: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-semantic-info-100)",
            focused: "var(--ns-color-semantic-info-200)",
            disabled: "var(--ns-color-neutral-white)"
          },
          text: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-semantic-info-100)",
            focused: "var(--ns-color-semantic-info-200)",
            disabled: "var(--ns-color-neutral-white)"
          }
        }
      },
      success: {
        enabled: "var(--ns-color-semantic-success-500)",
        hover: "var(--ns-color-semantic-success-600)",
        focused: "var(--ns-color-semantic-success-700)",
        disabled: "var(--ns-color-semantic-success-300)",
        variant: {
          outlined: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-semantic-success-100)",
            focused: "var(--ns-color-semantic-success-200)",
            disabled: "var(--ns-color-neutral-white)"
          },
          text: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-semantic-success-100)",
            focused: "var(--ns-color-semantic-success-200)",
            disabled: "var(--ns-color-neutral-white)"
          }
        }
      },
      warning: {
        enabled: "var(--ns-color-semantic-warning-400)",
        hover: "var(--ns-color-semantic-warning-500)",
        focused: "var(--ns-color-semantic-warning-600)",
        disabled: "var(--ns-color-semantic-warning-300)",
        variant: {
          outlined: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-semantic-warning-100)",
            focused: "var(--ns-color-semantic-warning-200)",
            disabled: "var(--ns-color-neutral-white)"
          },
          text: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-semantic-warning-100)",
            focused: "var(--ns-color-semantic-warning-200)",
            disabled: "var(--ns-color-neutral-white)"
          }
        }
      },
      error: {
        enabled: "var(--ns-color-semantic-error-500)",
        hover: "var(--ns-color-semantic-error-600)",
        focused: "var(--ns-color-semantic-error-700)",
        disabled: "var(--ns-color-semantic-error-300)",
        variant: {
          outlined: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-semantic-error-100)",
            focused: "var(--ns-color-semantic-error-200)",
            disabled: "var(--ns-color-neutral-white)"
          },
          text: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-semantic-error-100)",
            focused: "var(--ns-color-semantic-error-200)",
            disabled: "var(--ns-color-neutral-white)"
          }
        }
      }
    }
  },
  background: {
    primary: "var(--ns-color-cool-gray-100)",
    secondary: "var(--ns-color-neutral-white)",
    backdrop: "rgba(0,0,0,0.5)"
  },
  border: {
    normal: "var(--ns-color-cool-gray-300)",
    active: "var(--ns-color-mitra-blue-500)",
    // Underscore-prefixed deliberately: a plain `error` key would collide with
    // the `error: { … }` state object below and be silently dropped, taking
    // `--ns-color-border-_error` with it.
    _error: "var(--ns-color-red-500)",
    primary: {
      enabled: "var(--ns-color-primary-500)",
      hover: "var(--ns-color-primary-600)",
      focused: "var(--ns-color-primary-700)",
      disabled: "var(--ns-color-primary-300)",
      variant: {
        outlined: {
          enabled: "var(--ns-color-primary-500)",
          hover: "var(--ns-color-primary-600)",
          focused: "var(--ns-color-primary-700)"
        }
      }
    },
    secondary: {
      enabled: "var(--ns-color-secondary-500)",
      hover: "var(--ns-color-secondary-600)",
      focused: "var(--ns-color-secondary-700)",
      disabled: "var(--ns-color-secondary-300)",
      variant: {
        outlined: {
          enabled: "var(--ns-color-secondary-500)",
          hover: "var(--ns-color-secondary-600)",
          focused: "var(--ns-color-secondary-700)",
          disabled: "var(--ns-color-secondary-300)"
        }
      }
    },
    info: {
      enabled: "var(--ns-color-semantic-info-primary)",
      hover: "var(--ns-color-semantic-info-600)",
      focused: "var(--ns-color-semantic-info-700)",
      disabled: "var(--ns-color-semantic-info-300)",
      variant: {
        outlined: {
          enabled: "var(--ns-color-semantic-info-primary)",
          hover: "var(--ns-color-semantic-info-600)",
          focused: "var(--ns-color-semantic-info-700)",
          disabled: "var(--ns-color-semantic-info-300)"
        }
      }
    },
    success: {
      enabled: "var(--ns-color-semantic-success-primary)",
      hover: "var(--ns-color-semantic-success-600)",
      focused: "var(--ns-color-semantic-success-700)",
      disabled: "var(--ns-color-semantic-success-300)",
      variant: {
        outlined: {
          enabled: "var(--ns-color-semantic-success-primary)",
          hover: "var(--ns-color-semantic-success-600)",
          focused: "var(--ns-color-semantic-success-700)",
          disabled: "var(--ns-color-semantic-success-300)"
        }
      }
    },
    warning: {
      enabled: "var(--ns-color-semantic-warning-primary)",
      hover: "var(--ns-color-semantic-warning-600)",
      focused: "var(--ns-color-semantic-warning-700)",
      disabled: "var(--ns-color-semantic-warning-300)",
      variant: {
        outlined: {
          enabled: "var(--ns-color-semantic-warning-primary)",
          hover: "var(--ns-color-semantic-warning-600)",
          focused: "var(--ns-color-semantic-warning-700)",
          disabled: "var(--ns-color-semantic-warning-300)"
        }
      }
    },
    error: {
      enabled: "var(--ns-color-semantic-error-primary)",
      hover: "var(--ns-color-semantic-error-600)",
      focused: "var(--ns-color-semantic-error-700)",
      disabled: "var(--ns-color-semantic-error-300)",
      variant: {
        outlined: {
          enabled: "var(--ns-color-semantic-error-primary)",
          hover: "var(--ns-color-semantic-error-600)",
          focused: "var(--ns-color-semantic-error-700)",
          disabled: "var(--ns-color-semantic-error-300)"
        }
      }
    }
  },
  semantic: {
    info: {
      primary: "var(--ns-color-blue-500)",
      100: "var(--ns-color-blue-100)",
      200: "var(--ns-color-blue-200)",
      300: "var(--ns-color-blue-300)",
      400: "var(--ns-color-blue-400)",
      500: "var(--ns-color-blue-500)",
      600: "var(--ns-color-blue-600)",
      700: "var(--ns-color-blue-700)",
      800: "var(--ns-color-blue-800)",
      900: "var(--ns-color-blue-900)"
    },
    success: {
      primary: "var(--ns-color-green-500)",
      100: "var(--ns-color-green-100)",
      200: "var(--ns-color-green-200)",
      300: "var(--ns-color-green-300)",
      400: "var(--ns-color-green-400)",
      500: "var(--ns-color-green-500)",
      600: "var(--ns-color-green-600)",
      700: "var(--ns-color-green-700)",
      800: "var(--ns-color-green-800)",
      900: "var(--ns-color-green-900)"
    },
    error: {
      primary: "var(--ns-color-red-500)",
      100: "var(--ns-color-red-100)",
      200: "var(--ns-color-red-200)",
      300: "var(--ns-color-red-300)",
      400: "var(--ns-color-red-400)",
      500: "var(--ns-color-red-500)",
      600: "var(--ns-color-red-600)",
      700: "var(--ns-color-red-700)",
      800: "var(--ns-color-red-800)",
      900: "var(--ns-color-red-900)"
    },
    warning: {
      primary: "var(--ns-color-yellow-500)",
      100: "var(--ns-color-yellow-100)",
      200: "var(--ns-color-yellow-200)",
      300: "var(--ns-color-yellow-300)",
      400: "var(--ns-color-yellow-400)",
      500: "var(--ns-color-yellow-500)",
      600: "var(--ns-color-yellow-600)",
      700: "var(--ns-color-yellow-700)",
      800: "var(--ns-color-yellow-800)",
      900: "var(--ns-color-yellow-900)"
    }
  }
}, b5 = {
  border: O4,
  breakpoint: B4,
  color: {
    ...z4,
    ...Z4
  },
  depth: j4,
  elevation: H4,
  iconography: $4,
  layout: q4,
  motion: U4,
  spacing: J4,
  typography: W4,
  width: X4
}, Tn = {
  "ds-switch": "_ds-switch_j7kps_1",
  "ds-switch--disabled": "_ds-switch--disabled_j7kps_4",
  "ds-switch--width-full": "_ds-switch--width-full_j7kps_9",
  "ds-switch--width-sm": "_ds-switch--width-sm_j7kps_12",
  "ds-switch--width-md": "_ds-switch--width-md_j7kps_15",
  "ds-switch--width-lg": "_ds-switch--width-lg_j7kps_18",
  "ds-switch__control": "_ds-switch__control_j7kps_21",
  "ds-switch__input": "_ds-switch__input_j7kps_27",
  "ds-switch__track": "_ds-switch__track_j7kps_38",
  "ds-switch__thumb": "_ds-switch__thumb_j7kps_49",
  "ds-switch--size-medium": "_ds-switch--size-medium_j7kps_60",
  "ds-switch--size-small": "_ds-switch--size-small_j7kps_73",
  "ds-switch__label": "_ds-switch__label_j7kps_86"
};
var qo = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(qo || {});
const v5 = ({
  id: e,
  label: t,
  hideLabel: n = !1,
  ariaDescribedBy: i,
  checked: r,
  disabled: a = !1,
  focusableWhenDisabled: o = !1,
  size: l = qo.Medium,
  width: u = we.Auto,
  onChange: c,
  className: h
}) => {
  const p = Q(
    Tn["ds-switch"],
    Tn[`ds-switch--size-${l}`],
    a && Tn["ds-switch--disabled"],
    u !== we.Auto && Tn[`ds-switch--width-${u}`],
    h
  );
  return /* @__PURE__ */ _("span", { className: p, "data-checked": r, children: /* @__PURE__ */ B(
    "label",
    {
      className: Tn["ds-switch__control"],
      onClick: (m) => {
        m.preventDefault(), a || c(!r);
      },
      children: [
        /* @__PURE__ */ _(
          "input",
          {
            id: e,
            type: "checkbox",
            role: "switch",
            className: Tn["ds-switch__input"],
            checked: r,
            disabled: a && !o,
            "aria-disabled": a && o || void 0,
            "aria-describedby": i,
            onChange: (m) => {
              a || c(m.target.checked);
            }
          }
        ),
        /* @__PURE__ */ _("span", { className: Tn["ds-switch__track"], "aria-hidden": "true", children: /* @__PURE__ */ _("span", { className: Tn["ds-switch__thumb"] }) }),
        t && n && /* @__PURE__ */ _(Ic, { children: t }),
        t && !n && /* @__PURE__ */ _("span", { className: Tn["ds-switch__label"], children: t })
      ]
    }
  ) });
}, Nn = {
  "ds-segmented-switch": "_ds-segmented-switch_1m4ih_1",
  "ds-segmented-switch--disabled": "_ds-segmented-switch--disabled_1m4ih_7",
  "ds-segmented-switch__control": "_ds-segmented-switch__control_1m4ih_12",
  "ds-segmented-switch__input": "_ds-segmented-switch__input_1m4ih_17",
  "ds-segmented-switch__track": "_ds-segmented-switch__track_1m4ih_28",
  "ds-segmented-switch__thumb": "_ds-segmented-switch__thumb_1m4ih_39",
  "ds-segmented-switch--size-medium": "_ds-segmented-switch--size-medium_1m4ih_50",
  "ds-segmented-switch--size-small": "_ds-segmented-switch--size-small_1m4ih_63",
  "ds-segmented-switch__option": "_ds-segmented-switch__option_1m4ih_76"
}, w5 = ({
  id: e,
  labelLeft: t,
  labelRight: n,
  checked: i,
  disabled: r = !1,
  size: a = qo.Medium,
  onChange: o,
  className: l
}) => {
  const u = Q(
    Nn["ds-segmented-switch"],
    Nn[`ds-segmented-switch--size-${a}`],
    r && Nn["ds-segmented-switch--disabled"],
    l
  );
  return /* @__PURE__ */ B("span", { className: u, "data-checked": i, children: [
    /* @__PURE__ */ _(
      "span",
      {
        className: Nn["ds-segmented-switch__option"],
        "data-side": "left",
        "aria-hidden": "true",
        onClick: () => o(!1),
        children: t
      }
    ),
    /* @__PURE__ */ B(
      "label",
      {
        className: Nn["ds-segmented-switch__control"],
        onClick: (c) => {
          c.preventDefault(), r || o(!i);
        },
        children: [
          /* @__PURE__ */ _(
            "input",
            {
              id: e,
              type: "checkbox",
              role: "switch",
              "aria-label": `${t} / ${n}`,
              className: Nn["ds-segmented-switch__input"],
              checked: i,
              disabled: r,
              onChange: (c) => o(c.target.checked)
            }
          ),
          /* @__PURE__ */ _("span", { className: Nn["ds-segmented-switch__track"], "aria-hidden": "true", children: /* @__PURE__ */ _("span", { className: Nn["ds-segmented-switch__thumb"] }) })
        ]
      }
    ),
    /* @__PURE__ */ _(
      "span",
      {
        className: Nn["ds-segmented-switch__option"],
        "data-side": "right",
        "aria-hidden": "true",
        onClick: () => o(!0),
        children: n
      }
    )
  ] });
};
export {
  Hp as ANSWER_LATER_VALUE,
  g4 as ARIESStatusRow,
  kc as AUTO_FOCUS_ATTRIBUTE,
  Gf as Accordion,
  Kf as AccordionItem,
  A4 as Alert,
  Zp as AlertEnterEffect,
  Gp as AlertExitEffect,
  Ho as AlertPosition,
  x5 as AlertProvider,
  ln as AlertSeverity,
  jo as AlertVariant,
  Wp as AnimatedAriesIcon,
  t0 as AriesCard,
  s0 as AriesInput,
  xf as Avatar,
  kf as Badge,
  Ea as BadgeVariant,
  st as Button,
  Ew as ButtonGroupSlot,
  Cw as ButtonSlot,
  lt as ButtonVariant,
  Sc as CalendarPanel,
  o0 as Card,
  Na as CardVariant,
  x4 as ChatBubble,
  y4 as ChatDateDivider,
  b4 as ChatErrorRow,
  f5 as ChatMessage,
  v4 as ChatMessageRow,
  w4 as ChatSystemRow,
  _5 as ChatTimeline,
  k4 as ChatTypingRow,
  $i as Checkbox,
  Hi as CheckboxSize,
  Iw as CheckboxSlot,
  hi as Chip,
  yr as ChipVariant,
  Re as ColorVariant,
  bc as ComboBoxField,
  m5 as ContextPrompt,
  a4 as ContextToken,
  Kn as ContextualMenu,
  Ta as CounterMode,
  a5 as DataCard,
  u5 as DataTable,
  Up as DatePickerCalendarSlot,
  co as DatePickerField,
  p5 as DatePickerSlot,
  _4 as DeliveryBadge,
  q0 as Dialog,
  u0 as Drawer,
  v0 as EntityEditor,
  po as EntityPickerField,
  Dw as EntityPickerSlot,
  H0 as EntityViewer,
  a0 as ErrorBoundary,
  rs as FOCUSABLE_SELECTORS,
  it as FieldEditorType,
  Ld as FieldValueType,
  qp as ISMFormContext,
  vw as ISMFormProvider,
  zo as ISMR,
  ke as Icon,
  J as IconName,
  n0 as InfoCard,
  Jd as Input,
  kt as InputSize,
  Ne as InputState,
  Pa as InputStatus,
  i0 as InputType,
  Ir as Link,
  vf as LoABadge,
  r5 as MDXProvider,
  s5 as MDXRenderer,
  g5 as MessageFeedbackRow,
  vc as MultiSelectField,
  Mw as MultiSelectSlot,
  w0 as Navbar,
  n5 as ProjectionCalendar,
  Nf as Radio,
  Df as RadioGroup,
  fo as RadioSize,
  t5 as SegmentedControl,
  Ac as SegmentedControlSize,
  w5 as SegmentedSwitch,
  ao as SelectField,
  Rw as SelectSlot,
  P0 as Sidebar,
  Mt as SizeVariant,
  Xp as SpinnerSlot,
  he as SvgElem,
  v5 as Switch,
  qo as SwitchSize,
  O0 as Table,
  wf as TableDataType,
  _f as TextAreaField,
  Ni as TextField,
  jw as TextFieldSlot,
  ho as TimePickerField,
  $w as TimePickerSlot,
  n1 as Token,
  cn as Tooltip,
  e5 as UserBadge,
  ns as ViewFormat,
  Ic as VisuallyHidden,
  we as WidthVariant,
  d5 as chatISMRegistry,
  Ts as decodeISM,
  qw as defaultISMRegistry,
  o5 as defineEditorColumns,
  l5 as defineEditorRows,
  i5 as defineViewerColumns,
  Mn as eAnchorTarget,
  Da as eAsidePanelType,
  Va as eCTA,
  Td as eDataRawType,
  Pd as eHintType,
  Nd as eInputType,
  ct as eTextEntryType,
  xw as encodeSlot,
  bw as formatConjunctionList,
  Bo as isAnswerLaterValue,
  Bi as mergeRefs,
  Mc as northStarComponents,
  h5 as patchISMValues,
  b5 as tokens,
  y5 as useAlert,
  Cc as useAutoFocusWithin,
  hn as useISMForm,
  c5 as validateISM
};
//# sourceMappingURL=north-star.esm.js.map
